
function $parcel$interopDefault(a) {
  return a && a.__esModule ? a.default : a;
}

function $parcel$defineInteropFlag(a) {
  Object.defineProperty(a, '__esModule', {value: true, configurable: true});
}

function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

      var $parcel$global = globalThis;
    var parcelRequire = $parcel$global["parcelRequire94c2"];
var parcelRegister = parcelRequire.register;
parcelRegister("dDXUI", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

$parcel$export(module.exports, "default", () => $413a2e452f9b80b0$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $7HGHG = parcelRequire("7HGHG");

var $jK1pm = parcelRequire("jK1pm");

var $guZLT = parcelRequire("guZLT");
function $413a2e452f9b80b0$export$2e2bcd8739ae039() {
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $jK1pm.default), {
        name: "queues-issue-view-spa"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $7HGHG.default), {
        pageId: "queues-issue-view"
    }, ({ match: match, pageContext: pageContext, push: push })=>pageContext && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $guZLT.default), {
            pageContext: pageContext,
            // @ts-expect-error - TS2322 - Type 'QueuesPush' is not assignable to type '(url: string) => void'.
            push: push,
            match: match
        })));
}

});
parcelRegister("7HGHG", function(module, exports) {

$parcel$export(module.exports, "default", () => $2488e0530c930d00$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $knPb9 = parcelRequire("knPb9");

var $1ybV0 = parcelRequire("1ybV0");

var $lB25E = parcelRequire("lB25E");

var $kKzsy = parcelRequire("kKzsy");

var $aS6XE = parcelRequire("aS6XE");
var $9GzdM = parcelRequire("9GzdM");

var $1L8BM = parcelRequire("1L8BM");

var $f5prk = parcelRequire("f5prk");
var $2d7Sj = parcelRequire("2d7Sj");
var $dVAlv = parcelRequire("dVAlv");
var $51Ia6 = parcelRequire("51Ia6");

var $fDE9L = parcelRequire("fDE9L");

var $6vrw7 = parcelRequire("6vrw7");

var $6M8Uw = parcelRequire("6M8Uw");

var $75nMA = parcelRequire("75nMA");

var $gatu1 = parcelRequire("gatu1");
const $2488e0530c930d00$var$QueuesAppBase = (props)=>{
    const { QueuesPushProvider: QueuesPushProvider, pageId: pageId } = props;
    const [{ match: match }] = (0, $lB25E.useRouter)();
    const [{ data: pageContextData, error: error }] = (0, $51Ia6.usePageContext)();
    const { tenantContext: tenantContext, projectContext: projectContext, serviceDeskContext: serviceDeskContext } = pageContextData || {};
    const { baseUrl: baseUrl = '' } = tenantContext || {};
    const { projectName: projectName } = projectContext || {};
    const pageContextProps = (0, $eUqFw.useMemo)(()=>({
            ...tenantContext,
            ...projectContext,
            ...serviceDeskContext
        }), [
        projectContext,
        serviceDeskContext,
        tenantContext
    ]);
    const projectKey = (0, $6vrw7.toProjectKey)(match.params.projectKey || '');
    const practice = (0, $fDE9L.toItsmPractice)(match.params.practiceType);
    const [categorizedQueues, categorizedQueuesLoading, categorizedError, methods] = (0, $1L8BM.useCategorizedQueues)(baseUrl, projectKey, practice);
    let selectedQueueName;
    if (categorizedQueues && match.params.queueId) {
        const selectedQueue = categorizedQueues.find((queue)=>queue.id === Number(match.params.queueId));
        selectedQueueName = selectedQueue ? selectedQueue.name : undefined;
    }
    (0, $75nMA.useOnFavoritesChanged)(projectKey, practice, categorizedQueues, methods.editItemFavorite);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $6M8Uw.MarkProductStart), null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $dVAlv.SpaPageWrapper), {
        pageId: pageId,
        baseUrl: baseUrl,
        currentUrl: match.url,
        // @ts-expect-error - TS2322 - Type '{ projectId: number; projectKey: string; projectName: string; projectType: ProjectType; isAdmin: boolean; isProjectSimplified: boolean; } | undefined' is not assignable to type 'ProjectContext | null | undefined'.
        projectContext: projectContext,
        isLoading: !pageContextData && !error || categorizedQueuesLoading,
        error: error
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(QueuesPushProvider, {
        projectKey: projectKey
    }, ({ push: push, replace: providerReplace })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).Fragment, null, (0, $1ybV0.ff)('a11y-fission-queues-related-issues_giuuk') ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $2d7Sj.ServiceDeskDocumentTitle), {
            // @ts-expect-error - TS2322 - Type '{ projectName: string | undefined; section: string; }' is not assignable to type 'IntrinsicAttributes & Diff<(Diff<RefAttributes<any> | (RefAttributes<any> & { children?: ReactNode; }), Partial<RefAttributes<...> | (RefAttributes<...> & { ...; })>> & RefAttributes<...>) | (Diff<...> & ... 1 more ... & { ...; }), InjectIntlVoidProps> & { ...; }'.
            projectName: projectName,
            section: "queues",
            subsection: selectedQueueName
        }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $2d7Sj.ServiceDeskDocumentTitle), {
            // @ts-expect-error - TS2322 - Type '{ projectName: string | undefined; section: string; }' is not assignable to type 'IntrinsicAttributes & Diff<(Diff<RefAttributes<any> | (RefAttributes<any> & { children?: ReactNode; }), Partial<RefAttributes<...> | (RefAttributes<...> & { ...; })>> & RefAttributes<...>) | (Diff<...> & ... 1 more ... & { ...; }), InjectIntlVoidProps> & { ...; }'.
            projectName: projectName,
            section: "queues"
        }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).Fragment, null, props.children({
            push: push,
            match: match,
            replace: providerReplace,
            queuesData: {
                data: (0, $gatu1.pageToQueues)(categorizedQueues || []),
                error: categorizedError ? categorizedError.message : undefined,
                loading: categorizedQueuesLoading
            },
            category: practice,
            // @ts-expect-error - TS2322 - Type '{ portalId?: number | undefined; canSeeNewIssueView?: boolean | undefined; userRole?: string | undefined; serviceDeskId?: number | undefined; projectId?: number | undefined; projectKey?: string | undefined; ... 11 more ...; isSiteAdmin?: boolean | undefined; }' is not assignable to type 'PageProps'.
            pageContext: pageContextProps
        }))))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $kKzsy.JsdGettingStartedPanelShouldRender), null));
};
var $2488e0530c930d00$export$2e2bcd8739ae039 = (0, $knPb9.default)($2488e0530c930d00$var$QueuesAppBase, {
    QueueProvider: (0, $9GzdM.default),
    QueuesApiDataProvider: (0, $aS6XE.default),
    QueuesPushProvider: (0, $f5prk.default)
});

});
parcelRegister("kKzsy", function(module, exports) {

$parcel$export(module.exports, "JsdGettingStartedPanelShouldRender", () => $993d872dc7228c2f$export$46976e0f90edfcfe);
$parcel$export(module.exports, "JsdGettingStartedPanel", () => $993d872dc7228c2f$export$6f9913539cfb4ab6);
$parcel$export(module.exports, "JsdGettingStartedPanelOpenButton", () => $993d872dc7228c2f$export$4cb23b2c31a1b2ad);
$parcel$export(module.exports, "JsdGettingStartedPanelReopenSpotlight", () => $993d872dc7228c2f$export$c7732c55900cf0b9);

var $eUqFw = parcelRequire("eUqFw");

var $7rh0R = parcelRequire("7rh0R");

var $gGtKh = parcelRequire("gGtKh");

// eslint-disable-next-line @typescript-eslint/no-explicit-any
const $993d872dc7228c2f$var$AsyncGettingStartedPanelShouldRender = (0, $7rh0R.lazyAfterPaint)(()=>(parcelRequire("5palF")).then(({ JsdGettingStartedPanelShouldRender: JsdGettingStartedPanelShouldRender })=>JsdGettingStartedPanelShouldRender), {
    moduleId: "./src/packages/servicedesk/getting-started-panel/src/ui/should-render/async.tsx"
});

// eslint-disable-next-line @typescript-eslint/no-explicit-any
const $993d872dc7228c2f$var$AsyncGettingStartedPanel = (0, $7rh0R.lazyAfterPaint)(()=>(parcelRequire("5N7oJ")).then(({ JsdGettingStartedPanel: JsdGettingStartedPanel })=>JsdGettingStartedPanel), {
    moduleId: "./src/packages/servicedesk/getting-started-panel/src/ui/panel/async.tsx"
});

// eslint-disable-next-line @typescript-eslint/no-explicit-any
const $993d872dc7228c2f$var$AsyncGettingStartedPanelOpenButton = (0, $7rh0R.lazyAfterPaint)(()=>(parcelRequire("1U7AI")).then(({ JsdGettingStartedPanelOpenButton: JsdGettingStartedPanelOpenButton })=>JsdGettingStartedPanelOpenButton), {
    moduleId: "./src/packages/servicedesk/getting-started-panel/src/ui/open-button/async.tsx"
});

// eslint-disable-next-line @typescript-eslint/no-explicit-any
const $993d872dc7228c2f$var$AsyncGettingStartedPanelReopenSpotlight = (0, $7rh0R.lazyAfterPaint)(()=>(parcelRequire("1kr4I")).then(({ JsdGettingStartedPanelReopenSpotlight: JsdGettingStartedPanelReopenSpotlight })=>JsdGettingStartedPanelReopenSpotlight), {
    moduleId: "./src/packages/servicedesk/getting-started-panel/src/ui/reopen-spotlight/async.tsx"
});
const $993d872dc7228c2f$export$46976e0f90edfcfe = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $gGtKh.default), {
        name: "jsm-getting-started-panel-async-should-render",
        fallback: null
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($993d872dc7228c2f$var$AsyncGettingStartedPanelShouldRender, null));
$993d872dc7228c2f$export$46976e0f90edfcfe.displayName = 'AsyncJsdGettingStartedPanelShouldRender';
const $993d872dc7228c2f$export$6f9913539cfb4ab6 = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $gGtKh.default), {
        name: "jsm-getting-started-panel-async-panel",
        fallback: null
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($993d872dc7228c2f$var$AsyncGettingStartedPanel, null));
$993d872dc7228c2f$export$6f9913539cfb4ab6.displayName = 'AsyncJsdGettingStartedPanel';
const $993d872dc7228c2f$export$4cb23b2c31a1b2ad = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $gGtKh.default), {
        name: "jsm-getting-started-panel-async-open-button",
        fallback: null
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($993d872dc7228c2f$var$AsyncGettingStartedPanelOpenButton, null));
$993d872dc7228c2f$export$4cb23b2c31a1b2ad.displayName = 'AsyncJsdGettingStartedPanelOpenButton';
const $993d872dc7228c2f$export$c7732c55900cf0b9 = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $gGtKh.default), {
        name: "jsm-getting-started-panel-async-reopen-spotlight",
        fallback: null
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($993d872dc7228c2f$var$AsyncGettingStartedPanelReopenSpotlight, null));
$993d872dc7228c2f$export$c7732c55900cf0b9.displayName = 'AsyncJsdGettingStartedPanelReopenSpotlight';

});
parcelRegister("5palF", function(module, exports) {

var $d1Cng = parcelRequire("d1Cng");
module.exports = $d1Cng("kd6Ju").then(()=>parcelRequire('appSk'));

});

parcelRegister("5N7oJ", function(module, exports) {

var $d1Cng = parcelRequire("d1Cng");
module.exports = Promise.all([
    $d1Cng("2hmUs"),
    $d1Cng("bCeK4"),
    $d1Cng("5eFqM")
]).then(()=>parcelRequire('ddfk6'));

});

parcelRegister("1U7AI", function(module, exports) {

var $d1Cng = parcelRequire("d1Cng");
module.exports = Promise.all([
    $d1Cng("2hmUs"),
    $d1Cng("bCeK4"),
    $d1Cng("ahRif")
]).then(()=>parcelRequire('1HvEW'));

});

parcelRegister("1kr4I", function(module, exports) {

var $d1Cng = parcelRequire("d1Cng");
module.exports = Promise.all([
    $d1Cng("2hmUs"),
    $d1Cng("bCeK4"),
    $d1Cng("cxrYi")
]).then(()=>parcelRequire('f9sDQ'));

});


parcelRegister("aS6XE", function(module, exports) {

$parcel$export(module.exports, "AvailableQueuesConsumer", () => $946c01b4eaf4ef31$export$dfebed0fc9519fcc);
$parcel$export(module.exports, "default", () => $946c01b4eaf4ef31$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $hTLlD = parcelRequire("hTLlD");

var $jG2Eu = parcelRequire("jG2Eu");

var $2bMHt = parcelRequire("2bMHt");

var $aNBkj = parcelRequire("aNBkj");

var $a2MDL = parcelRequire("a2MDL");

var $3RIuY = parcelRequire("3RIuY");

var $9Q5bD = parcelRequire("9Q5bD");
const $946c01b4eaf4ef31$var$LAST_VISITED_QUEUE_KEY_PREFIX = 'last_visited_queue';
// @ts-expect-error - TS2322 - Type 'Context<{ setFavorite: (...args: any[]) => void; deleteNavItem: (...args: any[]) => void; updateIssueCount: (...args: any[]) => void; markNavItemsAsStale: (...args: any[]) => void; getQueueCount: (...args: any[]) => void; setLastVisitedQueueId: (...args: any[]) => void; getLastVisitedQueueId: (...args: any[]) => voi...' is not assignable to type 'Context<QueuesContextType>'.
const $946c01b4eaf4ef31$var$AvailableQueuesContext = /*#__PURE__*/ (0, $eUqFw.createContext)({
    setFavorite: (0, (/*@__PURE__*/$parcel$interopDefault($jG2Eu))),
    deleteNavItem: (0, (/*@__PURE__*/$parcel$interopDefault($jG2Eu))),
    updateIssueCount: (0, (/*@__PURE__*/$parcel$interopDefault($jG2Eu))),
    markNavItemsAsStale: (0, (/*@__PURE__*/$parcel$interopDefault($jG2Eu))),
    getQueueCount: (0, (/*@__PURE__*/$parcel$interopDefault($jG2Eu))),
    setLastVisitedQueueId: (0, (/*@__PURE__*/$parcel$interopDefault($jG2Eu))),
    getLastVisitedQueueId: (0, (/*@__PURE__*/$parcel$interopDefault($jG2Eu)))
});
const { Provider: $946c01b4eaf4ef31$var$Provider, Consumer: $946c01b4eaf4ef31$export$dfebed0fc9519fcc } = $946c01b4eaf4ef31$var$AvailableQueuesContext;
class $946c01b4eaf4ef31$export$2e2bcd8739ae039 extends (0, $eUqFw.Component) {
    static{
        this.defaultProps = {
            FavoriteSubscriber: (0, $3RIuY.default),
            queuesPrefetchData: [],
            push: undefined,
            onDeleteNavItem: undefined
        };
    }
    constructor(props){
        const { onNavUpdated: onNavUpdated, onIssueCountUpdated: onIssueCountUpdated, queuesPrefetchData: queuesPrefetchData, push: push } = props;
        super(props);
        this.getQueueCount = ()=>{
            const { data: data } = this.state;
            return data ? Object.keys(data).filter((queueId)=>!this.deletedQueueIds.has((0, $aNBkj.toQueueIdString)(queueId))).length : 0;
        };
        this.getLastVisitedQueueId = (projectKey)=>{
            const { category: category } = this.props;
            if (!projectKey) return null;
            try {
                if (category) return (0, $a2MDL.getFromLocalStorage)(`${$946c01b4eaf4ef31$var$LAST_VISITED_QUEUE_KEY_PREFIX}_${projectKey}_${category}`);
                return (0, $a2MDL.getFromLocalStorage)(`${$946c01b4eaf4ef31$var$LAST_VISITED_QUEUE_KEY_PREFIX}_${projectKey}`);
            // eslint-disable-next-line @typescript-eslint/no-explicit-any
            } catch (error) {
                return null;
            }
        };
        this.setFavorite = (queueId, newValue)=>{
            const { FavoriteSubscriber: FavoriteSubscriber } = this.props;
            FavoriteSubscriber.setFavorite(queueId, newValue);
        };
        this.setLastVisitedQueueId = (queueId, projectKey)=>{
            const lastVisitedQueueId = this.getLastVisitedQueueId(projectKey);
            const { category: category } = this.props;
            // @ts-expect-error - TS2367 - This condition will always return 'true' since the types 'string | null | undefined' and 'number' have no overlap.
            if (projectKey && lastVisitedQueueId !== queueId) try {
                if (category) (0, $a2MDL.setInLocalStorage)(`${$946c01b4eaf4ef31$var$LAST_VISITED_QUEUE_KEY_PREFIX}_${projectKey}_${category}`, (0, $aNBkj.fromQueueIdString)(queueId));
                else (0, $a2MDL.setInLocalStorage)(`${$946c01b4eaf4ef31$var$LAST_VISITED_QUEUE_KEY_PREFIX}_${projectKey}`, (0, $aNBkj.fromQueueIdString)(queueId));
            // eslint-disable-next-line @typescript-eslint/no-explicit-any
            } catch (error) {
            // Don't care if it fails. Default behavior in QueuesRedirect will take users to first available queue.
            }
        };
        this.queuesContext = {
            deleteNavItem: this.deleteNavItem(push),
            updateIssueCount: onIssueCountUpdated,
            markNavItemsAsStale: ()=>onNavUpdated(false),
            setFavorite: this.setFavorite,
            getQueueCount: this.getQueueCount,
            setLastVisitedQueueId: this.setLastVisitedQueueId,
            getLastVisitedQueueId: this.getLastVisitedQueueId
        };
        this.deletedQueueIds = new Set();
        this.state = {
            loading: false,
            error: undefined,
            data: queuesPrefetchData.length ? (0, $9Q5bD.pageToQueues)(queuesPrefetchData) : undefined
        };
    }
    static getDerivedStateFromProps(props, state) {
        const { queuesPrefetchData: queuesPrefetchData } = props;
        if (!(0, (/*@__PURE__*/$parcel$interopDefault($hTLlD)))((0, $9Q5bD.pageToQueues)(queuesPrefetchData), state.data) && queuesPrefetchData.length) return {
            data: (0, $9Q5bD.pageToQueues)(queuesPrefetchData)
        };
        return null;
    }
    componentWillUnmount() {
        const { fetchSubscription: fetchSubscription, deleteItemSubscription: deleteItemSubscription } = this;
        fetchSubscription && fetchSubscription.unsubscribe();
        deleteItemSubscription && deleteItemSubscription.unsubscribe();
    }
    deleteNavItem(push) {
        return (queueId)=>{
            const { onDeleteNavItem: onDeleteNavItem } = this.props;
            onDeleteNavItem && onDeleteNavItem((0, $aNBkj.fromQueueIdString)(queueId));
            // update queue counts to reflect the deletion
            // note that deleteQueueFromSidebar is called after the delete endpoint returns success
            const updatedQueues = {
                ...this.state.data
            };
            delete updatedQueues[(0, $aNBkj.fromQueueIdString)(queueId)];
            const deletedLastQueue = Object.keys(updatedQueues).length === 0;
            if (deletedLastQueue) push && push(`${(0, $2bMHt.getQueueFragment)()}/custom/new`);
            else push && push((0, $2bMHt.getQueueFragment)());
        };
    }
    render() {
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($946c01b4eaf4ef31$var$Provider, {
            value: this.queuesContext
        }, this.props.children(this.state));
    }
}

});
parcelRegister("2bMHt", function(module, exports) {

$parcel$export(module.exports, "QUEUE_ROUTES", () => $aa4b24cdc7b12949$export$410a6306dae101ca);
$parcel$export(module.exports, "navigate", () => $aa4b24cdc7b12949$export$ff7962acd6052c28);
$parcel$export(module.exports, "getQueueFragment", () => $aa4b24cdc7b12949$export$954f428fa284c7);
$parcel$export(module.exports, "getEditQueueFragment", () => $aa4b24cdc7b12949$export$86f6a6d69e87f843);
$parcel$export(module.exports, "getCloneQueueFragment", () => $aa4b24cdc7b12949$export$7a487d215c9c3f76);
$parcel$export(module.exports, "getQueueIssueFragment", () => $aa4b24cdc7b12949$export$773cefb51b60b161);
$parcel$export(module.exports, "getIssueFragment", () => $aa4b24cdc7b12949$export$a796bfaff67c9fae);
$parcel$export(module.exports, "getQueueUrl", () => $aa4b24cdc7b12949$export$a29b42a005fecf0);
$parcel$export(module.exports, "getEditQueueUrlFromManageQueue", () => $aa4b24cdc7b12949$export$91152835d12ca65f);

var $3JafE = parcelRequire("3JafE");
parcelRequire("8jBvP");
parcelRequire("cpH8E");
parcelRequire("iects");
parcelRequire("1Lcr1");

var $8BwtD = parcelRequire("8BwtD");

var $f1lMr = parcelRequire("f1lMr");

var $1MlrF = parcelRequire("1MlrF");
const $aa4b24cdc7b12949$var$LOCATION = 'servicedesk.common.navigation.queues';
let $aa4b24cdc7b12949$var$navigatorPromise;
const $aa4b24cdc7b12949$var$getPushStateNavigator = ()=>{
    if (!$aa4b24cdc7b12949$var$navigatorPromise) $aa4b24cdc7b12949$var$navigatorPromise = (0, $1MlrF.createPushStateNavigator)();
    return $aa4b24cdc7b12949$var$navigatorPromise;
};
const $aa4b24cdc7b12949$export$410a6306dae101ca = {
    [(0, $f1lMr.INCIDENTS)]: 'section/incidents',
    [(0, $f1lMr.CHANGES)]: 'section/changes',
    [(0, $f1lMr.SERVICE_REQUEST)]: 'section/service-requests',
    [(0, $f1lMr.PROBLEMS)]: 'section/problems',
    [(0, $f1lMr.POST_INCIDENT_REVIEWS)]: 'section/post-incident-reviews',
    [(0, $f1lMr.NO_CATEGORY)]: 'queues'
};
const $aa4b24cdc7b12949$var$fromCategory = (category)=>$aa4b24cdc7b12949$export$410a6306dae101ca[category || (0, $f1lMr.NO_CATEGORY)];
const $aa4b24cdc7b12949$export$ff7962acd6052c28 = (projectKey, fragment)=>{
    (0, $8BwtD.emitSignal)($aa4b24cdc7b12949$var$LOCATION, {
        projectKey: projectKey,
        fragment: fragment
    });
    return (0, $3JafE.Observable).fromPromise($aa4b24cdc7b12949$var$getPushStateNavigator()).mergeMap((pushStateNavigator)=>{
        pushStateNavigator.navigateToFragment(fragment);
        return (0, $3JafE.Observable).empty();
    }).catch(()=>(0, $3JafE.Observable).empty());
};
const $aa4b24cdc7b12949$export$954f428fa284c7 = (queueId, category)=>{
    const categoryString = $aa4b24cdc7b12949$var$fromCategory(category);
    return queueId != null ? `${categoryString}/custom/${queueId}` : `${categoryString}`;
};
const $aa4b24cdc7b12949$export$86f6a6d69e87f843 = (queueId, category)=>`${$aa4b24cdc7b12949$export$954f428fa284c7(queueId, category)}/edit`;
const $aa4b24cdc7b12949$export$7a487d215c9c3f76 = (queueId, category)=>{
    const categoryString = $aa4b24cdc7b12949$var$fromCategory(category);
    return queueId != null ? `${categoryString}/custom/new?parentId=${queueId}` : `${categoryString}/custom/new`;
};
const $aa4b24cdc7b12949$export$773cefb51b60b161 = (queueId, issueKey, category)=>`${$aa4b24cdc7b12949$export$954f428fa284c7(queueId, category)}/${issueKey}`;
const $aa4b24cdc7b12949$export$a796bfaff67c9fae = (issueKey)=>`${$aa4b24cdc7b12949$export$954f428fa284c7()}/issue/${issueKey}`;
const $aa4b24cdc7b12949$export$a29b42a005fecf0 = ({ projectKey: projectKey, category: category, queueId: queueId, queryParams: queryParams })=>{
    const urlSearchParams = new URLSearchParams();
    if (queryParams) Object.entries(queryParams).forEach(([key, value])=>{
        urlSearchParams.set(key, value);
    });
    const formattedQueryParams = urlSearchParams.toString() ? `?${urlSearchParams.toString()}` : '';
    return `/jira/servicedesk/projects/${projectKey}/${$aa4b24cdc7b12949$export$954f428fa284c7(queueId, category)}${formattedQueryParams}`;
};
const $aa4b24cdc7b12949$export$91152835d12ca65f = (queueId, projectKey, category)=>`/jira/servicedesk/projects/${projectKey}/${$aa4b24cdc7b12949$export$86f6a6d69e87f843(queueId, category)}`;

});
parcelRegister("8BwtD", function(module, exports) {

$parcel$export(module.exports, "emitSignal", () => $32b8235f7373c763$export$a8a72bca1918549c);
/**
 * A signalling mechanism for Cypress tests.
 *
 * This acts as a bridge between the storybook application and cypress for
 * checking behaviours which cannot be asserted on via the DOM or are
 * otherwise not reflected in application state.
 *
 * This is the 'emit' side of the story. It should be used by
 * production-facing code to emit a signal.
 */ const $32b8235f7373c763$var$isProduction = ()=>true;
// eslint-disable-next-line @typescript-eslint/no-explicit-any
const $32b8235f7373c763$var$registerSignal = (signal, meta)=>{
    window.cySignals.allSignals.push(signal);
    const signalsByName = window.cySignals.signalsByName;
    if (signalsByName[signal]) signalsByName[signal].push(meta);
    else signalsByName[signal] = [
        meta
    ];
};
const $32b8235f7373c763$var$initCySignals = ()=>{
    window.cySignals = {
        signalsByName: {},
        allSignals: []
    };
};
const $32b8235f7373c763$export$a8a72bca1918549c = (signal, meta = {})=>{
    if ($32b8235f7373c763$var$isProduction()) return;
    if (!window.cySignals) $32b8235f7373c763$var$initCySignals();
    $32b8235f7373c763$var$registerSignal(signal, meta);
};

});

parcelRegister("1MlrF", function(module, exports) {

$parcel$export(module.exports, "createPushStateNavigator", () => $7831c13a1ae73fca$export$d3bf579f8e5cd838);
// eslint-disable-next-line jira/wrm/no-load-bridge

var $2BvS3 = parcelRequire("2BvS3");
const $7831c13a1ae73fca$var$PUSH_STATE_NAVIGATOR_MODULE = 'servicedesk/internal-api/core/util/push-state-navigator/push-state-navigator';
// Try to require push-state-navigator over 500ms, otherwise we'll fallback.
const $7831c13a1ae73fca$var$REQUIRE_TIMEOUT = 100;
const $7831c13a1ae73fca$var$REQUIRE_RETRIES = 5;
const $7831c13a1ae73fca$export$d3bf579f8e5cd838 = ()=>// eslint-disable-next-line jira/wrm/no-load-bridge
    (0, $2BvS3.loadBridge)({
        name: $7831c13a1ae73fca$var$PUSH_STATE_NAVIGATOR_MODULE,
        timeout: $7831c13a1ae73fca$var$REQUIRE_TIMEOUT,
        tentatives: $7831c13a1ae73fca$var$REQUIRE_RETRIES
    });

});


parcelRegister("aNBkj", function(module, exports) {

$parcel$export(module.exports, "toQueueId", () => $bd51b1e2d773d6ee$export$dae52b119ebf2444);
$parcel$export(module.exports, "fromQueueId", () => $bd51b1e2d773d6ee$export$999de35c9ca8105b);
$parcel$export(module.exports, "toQueueIdString", () => $bd51b1e2d773d6ee$export$cda0e35414946580);
$parcel$export(module.exports, "fromQueueIdString", () => $bd51b1e2d773d6ee$export$cde8da12f845d56f);
$parcel$export(module.exports, "LOCAL_STORAGE_SOURCE", () => $bd51b1e2d773d6ee$export$6e21137db7aec966);
$parcel$export(module.exports, "PREFETCHER_SOURCE", () => $bd51b1e2d773d6ee$export$ce13a6c409c4db7d);
$parcel$export(module.exports, "REST_SOURCE", () => $bd51b1e2d773d6ee$export$e85fb1a0846db30f);
const $bd51b1e2d773d6ee$export$dae52b119ebf2444 = (queueId)=>queueId;
const $bd51b1e2d773d6ee$export$999de35c9ca8105b = (queueId)=>queueId;
const $bd51b1e2d773d6ee$export$cda0e35414946580 = (queueId)=>$bd51b1e2d773d6ee$export$dae52b119ebf2444(Number(queueId));
const $bd51b1e2d773d6ee$export$cde8da12f845d56f = (queueId)=>$bd51b1e2d773d6ee$export$999de35c9ca8105b(queueId).toString();
const $bd51b1e2d773d6ee$export$6e21137db7aec966 = 'LOCAL_STORAGE';
const $bd51b1e2d773d6ee$export$ce13a6c409c4db7d = 'PREFETCHER';
const $bd51b1e2d773d6ee$export$e85fb1a0846db30f = 'REST';

});

parcelRegister("a2MDL", function(module, exports) {

$parcel$export(module.exports, "getFromLocalStorage", () => $a7ebc853463bf130$export$602bc7b349337fec);
$parcel$export(module.exports, "setInLocalStorage", () => $a7ebc853463bf130$export$e7b9840f77b6b2a4);

var $aZaPn = parcelRequire("aZaPn");

var $2IspF = parcelRequire("2IspF");
const $a7ebc853463bf130$export$f016358f0af18fa0 = (0, $aZaPn.createLocalExpirableStorageProvider)('servicedesk_queues');
const $a7ebc853463bf130$var$TIME_BEFORE_EXPIRY = 1209600000; // 14 days
const $a7ebc853463bf130$export$602bc7b349337fec = (key)=>{
    try {
        return $a7ebc853463bf130$export$f016358f0af18fa0.get(key);
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    } catch (e) {
        // .get() can trigger an exception due to a bug in 'storejs', where if
        // LS is not able to be read or written, it will not initialise the store.
        (0, $2IspF.default).safeWarnWithoutCustomerData('servicedesk.queues.agent-view.services', 'Local storage failure on read');
        return null;
    }
};
const $a7ebc853463bf130$export$e7b9840f77b6b2a4 = (key, value)=>{
    try {
        const now = Date.now();
        $a7ebc853463bf130$export$f016358f0af18fa0.set(key, value, now + $a7ebc853463bf130$var$TIME_BEFORE_EXPIRY);
        $a7ebc853463bf130$export$f016358f0af18fa0.removeExpiredKeys();
        return true;
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    } catch (_) {
        (0, $2IspF.default).safeWarnWithoutCustomerData('servicedesk.queues.agent-view.services', 'Local storage failure');
        return false;
    }
};

});
parcelRegister("aZaPn", function(module, exports) {

$parcel$export(module.exports, "createLocalStorageProvider", () => $e83d7abe46867842$export$697e65b1658f821b);
$parcel$export(module.exports, "createLocalExpirableStorageProvider", () => $e83d7abe46867842$export$59acef2b3ab1df90);

var $jqvCZ = parcelRequire("jqvCZ");

var $avHyR = parcelRequire("avHyR");

var $kkXA4 = parcelRequire("kkXA4");
const $e83d7abe46867842$export$697e65b1658f821b = (0, (/*@__PURE__*/$parcel$interopDefault($jqvCZ)))((appPrefix)=>(0, $avHyR.createStorageProvider)(appPrefix, (0, $kkXA4.makeLocalStore)()));
const $e83d7abe46867842$export$59acef2b3ab1df90 = (0, (/*@__PURE__*/$parcel$interopDefault($jqvCZ)))((appPrefix)=>{
    if (!appPrefix) throw Error("appPrefix can not be empty. It's used to separate apps");
    const store = (0, $kkXA4.makeLocalExpirableStore)();
    return store.namespace(appPrefix);
});

});
parcelRegister("avHyR", function(module, exports) {

$parcel$export(module.exports, "plugins", () => $e7af9f5944d51b15$export$8b3ca321c77fdea6);
$parcel$export(module.exports, "createStorageProvider", () => $e7af9f5944d51b15$export$8441605555fbd60c);

var $2y3XF = parcelRequire("2y3XF");

var $4b9NC = parcelRequire("4b9NC");
const $e7af9f5944d51b15$export$8b3ca321c77fdea6 = [
    (0, (/*@__PURE__*/$parcel$interopDefault($2y3XF))),
    (0, $4b9NC.default)
];
const $e7af9f5944d51b15$export$8441605555fbd60c = (appPrefix, store)=>store.namespace(appPrefix);

});
parcelRegister("4b9NC", function(module, exports) {

$parcel$export(module.exports, "default", () => $19af1635632d325b$export$2e2bcd8739ae039);

var $guiFP = parcelRequire("guiFP");

var $gjqa4 = parcelRequire("gjqa4");
/**
 * Enhances storage operations with automated cleanup capabilities. This includes tracking
 * item timestamps for age-based cleanup, handling storage limits by removing older items,
 * and providing utility functions for managing storage contents. Designed to ensure
 * efficient use of storage space without manual intervention.
 */ // eslint-disable-next-line @typescript-eslint/no-explicit-any
function $19af1635632d325b$var$cleanUpPlugin() {
    // eslint-disable-next-line @typescript-eslint/no-this-alias
    const self = this;
    const timestamps = self.createStore(self.storage, null, self._namespacePrefix + (0, $gjqa4.NAMESPACE));
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    function set(superFn, key, val) {
        try {
            if (!self.hasNamespace((0, $gjqa4.NAMESPACE))) timestamps.set(key, Date.now());
            superFn();
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        } catch (e) {
            // storage is full. Relevant only for localStorage
            if (e.code === (0, $gjqa4.LOCAL_STORAGE_FULL_ERROR_CODE) || e.code === (0, $gjqa4.LOCAL_STORAGE_FULL_FF_ERROR_CODE)) {
                // 22 - the correct code most browsers use
                // 1014 - Firefox's code
                (0, $guiFP.default)({
                    meta: {
                        id: 'browserLocalStorageFullError',
                        packageName: 'jiraBrowserStorageProviders',
                        teamName: 'magma'
                    },
                    attributes: {
                        namespace: self._namespacePrefix
                    },
                    error: e
                });
                if (self.cleanWhenFull()) self.set(superFn, key, val);
            } else {
                (0, $guiFP.default)({
                    meta: {
                        id: 'storageCleanupPluginError',
                        packageName: 'jiraBrowserStorageProviders',
                        teamName: 'magma'
                    },
                    attributes: {
                        isLegacyFunction: false
                    },
                    error: e
                });
                throw e;
            }
        }
    }
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    function remove(superFn, key) {
        if (!self.hasNamespace((0, $gjqa4.NAMESPACE))) timestamps.remove(key);
        return superFn();
    }
    // quite stupid way of getting totals, but current library supports only this.each()
    function getTotalCount() {
        let count = 0;
        self.each(()=>{
            count += 1;
        });
        return count;
    }
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    function cleanWhenFull(superFn, minAge = (0, $gjqa4.FOUR_WEEKS)) {
        const currTime = Date.now();
        const numKeysBefore = self.getTotalCount();
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        self.each((_value, key)=>{
            // return correct value for current collection
            // and return null for timestamps collection
            const created = !self.hasNamespace((0, $gjqa4.NAMESPACE)) ? timestamps.get(key) : null;
            if (typeof created === 'number' && currTime - created > minAge) self.remove(key);
        });
        const itemsRemovedCount = numKeysBefore - self.getTotalCount();
        if (!itemsRemovedCount && minAge - (0, $gjqa4.ONE_WEEK) >= (0, $gjqa4.ONE_WEEK)) return self.cleanWhenFull(minAge - (0, $gjqa4.ONE_WEEK));
        return itemsRemovedCount === 0;
    }
    return {
        set: set,
        remove: remove,
        cleanWhenFull: cleanWhenFull,
        getTotalCount: getTotalCount
    };
}
var $19af1635632d325b$export$2e2bcd8739ae039 = $19af1635632d325b$var$cleanUpPlugin;

});
parcelRegister("gjqa4", function(module, exports) {

$parcel$export(module.exports, "NAMESPACE", () => $cf4854539b53d7dc$export$6aad947bda0f3f46);
$parcel$export(module.exports, "ONE_WEEK", () => $cf4854539b53d7dc$export$8187f416f1cc43d8);
$parcel$export(module.exports, "FOUR_WEEKS", () => $cf4854539b53d7dc$export$6e952fa7d47190cf);
$parcel$export(module.exports, "LOCAL_STORAGE_FULL_ERROR_CODE", () => $cf4854539b53d7dc$export$da99ebca8f453abd);
$parcel$export(module.exports, "LOCAL_STORAGE_FULL_FF_ERROR_CODE", () => $cf4854539b53d7dc$export$ea28dfd9333cda2d);
const $cf4854539b53d7dc$export$6aad947bda0f3f46 = 'timestamps';
const $cf4854539b53d7dc$export$8187f416f1cc43d8 = 604800000;
const $cf4854539b53d7dc$export$6e952fa7d47190cf = 4 * $cf4854539b53d7dc$export$8187f416f1cc43d8;
const $cf4854539b53d7dc$export$da99ebca8f453abd = 22;
const $cf4854539b53d7dc$export$ea28dfd9333cda2d = 1014;

});



parcelRegister("kkXA4", function(module, exports) {

$parcel$export(module.exports, "makeLocalStore", () => $b4e518dc83f214e8$export$b2631085fe8db7af);
$parcel$export(module.exports, "makeLocalExpirableStore", () => $b4e518dc83f214e8$export$cf816b43e73de947);

var $2y3XF = parcelRequire("2y3XF");

var $gleLd = parcelRequire("gleLd");

var $ZGlKn = parcelRequire("ZGlKn");

var $5rWiD = parcelRequire("5rWiD");

var $gpWeB = parcelRequire("gpWeB");

var $avHyR = parcelRequire("avHyR");
const $b4e518dc83f214e8$export$b2631085fe8db7af = ()=>(0, (/*@__PURE__*/$parcel$interopDefault($ZGlKn))).createStore([
        (0, (/*@__PURE__*/$parcel$interopDefault($5rWiD))),
        (0, (/*@__PURE__*/$parcel$interopDefault($gpWeB)))
    ], (0, $avHyR.plugins));
const $b4e518dc83f214e8$export$cf816b43e73de947 = ()=>(0, (/*@__PURE__*/$parcel$interopDefault($ZGlKn))).createStore([
        (0, (/*@__PURE__*/$parcel$interopDefault($5rWiD))),
        (0, (/*@__PURE__*/$parcel$interopDefault($gpWeB)))
    ], [
        (0, (/*@__PURE__*/$parcel$interopDefault($2y3XF))),
        (0, (/*@__PURE__*/$parcel$interopDefault($gleLd)))
    ]);

});


parcelRegister("2IspF", function(module, exports) {

$parcel$export(module.exports, "default", () => $95e7f2142734ea48$export$2e2bcd8739ae039);

var $gUUjF = parcelRequire("gUUjF");
const $95e7f2142734ea48$var$PREFIX = '[Queues]';
/** This function logs privacy safe error.
 * The content must not include any personally identifiable information (PII) or user generated content (UGC).
 * In Jira, UGC includes issue keys, project keys etc. Please see go/jira-ugc for more information.
 *
 * @param location the lower-case, '.' separated path to the file that you are logging from.
 * @param message the message to be logged.
 * @param event the error that is thrown.
 */ // eslint-disable-next-line @typescript-eslint/no-explicit-any
const $95e7f2142734ea48$var$safeErrorWithoutCustomerData = (location, message, event)=>{
    (0, $gUUjF.default).safeErrorWithoutCustomerData(location, `${$95e7f2142734ea48$var$PREFIX} ${message}`, event);
};
/** This function logs privacy safe warning.
 * The content must not include any personally identifiable information (PII) or user generated content (UGC).
 * In Jira, UGC includes issue keys, project keys etc. Please see go/jira-ugc for more information.
 *
 * @param location the lower-case, '.' separated path to the file that you are logging from.
 * @param message the message to be logged.
 * @param event the error that is thrown.
 */ // eslint-disable-next-line @typescript-eslint/no-explicit-any
const $95e7f2142734ea48$var$safeWarnWithoutCustomerData = (location, message, event)=>{
    (0, $gUUjF.default).safeWarnWithoutCustomerData(location, `${$95e7f2142734ea48$var$PREFIX} ${message}`, event);
};
/** This function logs privacy safe info.
 * The content must not include any personally identifiable information (PII) or user generated content (UGC).
 * In Jira, UGC includes issue keys, project keys etc. Please see go/jira-ugc for more information.
 *
 * @param location the lower-case, '.' separated path to the file that you are logging from.
 * @param message the message to be logged.
 * @param event the error that is thrown.
 */ // eslint-disable-next-line @typescript-eslint/no-explicit-any
const $95e7f2142734ea48$var$safeInfoWithoutCustomerData = (location, message, event)=>{
    (0, $gUUjF.default).safeInfoWithoutCustomerData(location, `${$95e7f2142734ea48$var$PREFIX} ${message}`, event);
};
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$95e7f2142734ea48$export$2e2bcd8739ae039 = {
    safeInfoWithoutCustomerData: $95e7f2142734ea48$var$safeInfoWithoutCustomerData,
    safeWarnWithoutCustomerData: $95e7f2142734ea48$var$safeWarnWithoutCustomerData,
    safeErrorWithoutCustomerData: $95e7f2142734ea48$var$safeErrorWithoutCustomerData
};

});


parcelRegister("3RIuY", function(module, exports) {

$parcel$export(module.exports, "default", () => $6ecad685a6bf6254$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $jrdvV = parcelRequire("jrdvV");

var $aNBkj = parcelRequire("aNBkj");
class $6ecad685a6bf6254$export$2e2bcd8739ae039 extends (0, $eUqFw.Component) {
    // Replace with lodash/noop
    // eslint-disable-next-line @typescript-eslint/no-empty-function
    static setFavorite() {}
    render() {
        return null;
    }
    constructor(...args){
        super(...args);
        this.onFavoritesChanged = (items)=>{
            const queueItemsObj = items[0, $jrdvV.QUEUES_ITEM_TYPE];
            if (!queueItemsObj) return;
            // Object.values gives Array<mixed> according to Flow, which is wrong.
            // https://github.com/facebook/flow/issues/2221
            // eslint-disable-next-line @typescript-eslint/no-explicit-any
            const queueItems = Object.values(queueItemsObj);
            // @ts-expect-error - TS7006 - Parameter 'item' implicitly has an 'any' type.
            queueItems.forEach((item)=>this.props.onFavoriteItemChanged((0, $aNBkj.toQueueIdString)(item.id), item.value));
        };
    }
}

});

parcelRegister("9Q5bD", function(module, exports) {

$parcel$export(module.exports, "pageToQueues", () => $251ab12b126901b1$export$8ada91ce992fa66f);

var $3JafE = parcelRequire("3JafE");
parcelRequire("jyKN9");
parcelRequire("iects");

var $aNBkj = parcelRequire("aNBkj");
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$251ab12b126901b1$export$2e2bcd8739ae039 = (rest, transformFunc)=>rest.mergeMap((payload)=>(0, $3JafE.Observable).of(transformFunc(payload)));
const $251ab12b126901b1$var$transformColumns = (responseColumns)=>responseColumns.map((responseColumn)=>{
        const column = {
            id: responseColumn.fieldId,
            title: responseColumn.title,
            fieldType: responseColumn.fieldType,
            sortable: responseColumn.sortable
        };
        if (responseColumn.sortOrder) return {
            ...column,
            currentSorting: responseColumn.sortOrder
        };
        return column;
    });
const $251ab12b126901b1$export$8ada91ce992fa66f = (page)=>// eslint-disable-next-line @typescript-eslint/no-explicit-any
    page.reduce((acc, queue)=>{
        acc[queue.id] = {
            id: (0, $aNBkj.toQueueId)(queue.id),
            name: queue.name,
            jql: queue.jql,
            completeJql: queue.completeJql,
            order: queue.order,
            columns: $251ab12b126901b1$var$transformColumns(queue.columnsDetails),
            // British spelling from legacy Backend code
            isFavorite: queue.favourite,
            category: queue.category,
            canBeHidden: queue.canBeHidden
        };
        return acc;
    }, {});
const $251ab12b126901b1$export$9fd203f323102996 = (prefetchData, queues)=>{
    if (queues === undefined) return [];
    // @ts-expect-error - TS2322 - Type '{ favourite: boolean; columns: string[]; columnsDetails: { title: string; fieldType: string; sortable: boolean; fieldId: string; sortOrder: SortOrder | undefined; }[]; id: number; name: string; ... 8 more ...; shouldSkipIssueCountRefresh?: boolean | undefined; }[]' is not assignable to type 'Page[]'.
    return Object.keys(queues).map((queueId)=>{
        const updatedQueue = queues[queueId];
        const { isFavorite: isFavorite, columns: columns, isTransient: isTransient, ...queuesData } = updatedQueue;
        const cachedPage = prefetchData.find((q)=>String(q.id) === queueId);
        return {
            ...cachedPage,
            ...queuesData,
            favourite: isFavorite,
            columns: columns.map(({ id: id })=>id),
            columnsDetails: columns.map(({ id: id, currentSorting: currentSorting, ...remaining })=>({
                    fieldId: id,
                    sortOrder: currentSorting,
                    ...remaining
                }))
        };
    });
};
const $251ab12b126901b1$export$4906aa3ec3919ad9 = ()=>window.JSD_QUEUES_PRELOAD_PROMISES && window.JSD_QUEUES_PRELOAD_PROMISES.queues;
const $251ab12b126901b1$export$17bdd949b6a9952 = ()=>{
    if (window.JSD_QUEUES_PRELOAD_PROMISES) window.JSD_QUEUES_PRELOAD_PROMISES.queues = undefined;
};

});


parcelRegister("9GzdM", function(module, exports) {

$parcel$export(module.exports, "default", () => $3af95322b447f872$export$2e2bcd8739ae039);

var $giAhk = parcelRequire("giAhk");

var $jc7VN = parcelRequire("jc7VN");
var $3af95322b447f872$export$2e2bcd8739ae039 = (0, $giAhk.injectIntlV2)((0, $jc7VN.default));

});
parcelRegister("jc7VN", function(module, exports) {

$parcel$export(module.exports, "default", () => $667f4392b1198f8d$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $6HC1D = parcelRequire("6HC1D");

var $3NCZx = parcelRequire("3NCZx");

var $4yH5W = parcelRequire("4yH5W");

var $iyZnb = parcelRequire("iyZnb");

var $i8xmR = parcelRequire("i8xmR");
const $667f4392b1198f8d$var$findQueue = (source, id)=>(0, $6HC1D.getIn)(source, [
        'data',
        id
    ]);
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$667f4392b1198f8d$export$2e2bcd8739ae039 = ({ queueId: queueId, queuesDataSource: queuesDataSource, baseUrl: baseUrl, projectKey: projectKey, children: children, intl: { formatMessage: formatMessage } })=>{
    const lastUnfoundQueue = (0, $eUqFw.useRef)('');
    if (queuesDataSource.loading) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $4yH5W.default), null);
    const queue = $667f4392b1198f8d$var$findQueue(queuesDataSource, queueId);
    if (queue) {
        lastUnfoundQueue.current = '';
        (0, $iyZnb.setLastVisitedQueueIdAndCategory)(queue.id, projectKey, queue.category);
        return children(queue);
    }
    if (lastUnfoundQueue.current === queueId) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $3NCZx.default), {
        header: formatMessage((0, $i8xmR.default).notFoundHeader),
        description: formatMessage((0, $i8xmR.default).notFoundDescription),
        onRetry: ()=>{
            // If data source errors out let user retry the current page they are on.
            // Otherwise queue doesn't exist so go back to /queues
            if (queuesDataSource.error) window.location.reload();
            else window.location.assign(`${baseUrl}/jira/servicedesk/projects/${projectKey}/queues`);
        }
    });
    lastUnfoundQueue.current = queueId;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $4yH5W.default), null);
};

});
parcelRegister("3NCZx", function(module, exports) {

$parcel$export(module.exports, "default", () => $0cbb1e7780288e8f$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $7u4fN = parcelRequire("7u4fN");

var $220ac = parcelRequire("220ac");

var $1ybV0 = parcelRequire("1ybV0");

var $giAhk = parcelRequire("giAhk");

var $4zP5Y = parcelRequire("4zP5Y");

var $80J5A = parcelRequire("80J5A");

var $eQdlC = parcelRequire("eQdlC");
function $0cbb1e7780288e8f$export$edf27be85e5f6da0(props) {
    const { header: header, description: description, size: size, onRetry: onRetry, isLoading: isLoading, intl: { formatMessage: formatMessage }, errorImage: errorImage, isSubtle: isSubtle, imageWidth: imageWidth, maxImageHeight: maxImageHeight, retryMessage: retryMessage, renderErrorImage: renderErrorImage } = props;
    const buttonAppearance = isSubtle ? 'default' : 'primary';
    const defaultImageUrl = isSubtle ? (0, (/*@__PURE__*/$parcel$interopDefault($4zP5Y))) : (0, (/*@__PURE__*/$parcel$interopDefault($80J5A)));
    const isAssetConsolidation = (0, $1ybV0.ff)('jfe-asset-consolidation-itsm-agni_po996');
    const fallbackImage = errorImage || defaultImageUrl;
    let imageUrl;
    if (isAssetConsolidation) {
        if (renderErrorImage) imageUrl = undefined;
        else imageUrl = fallbackImage;
    } else imageUrl = fallbackImage;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $220ac.default), {
        testId: "common-components-error-state.empty-state",
        size: size,
        imageWidth: imageWidth,
        imageUrl: imageUrl,
        header: header,
        description: description,
        isLoading: isLoading,
        maxImageHeight: maxImageHeight,
        primaryAction: !onRetry ? null : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $7u4fN.default), {
            appearance: buttonAppearance,
            isDisabled: isLoading,
            onClick: onRetry
        }, formatMessage(retryMessage)),
        renderImage: renderErrorImage
    });
}
$0cbb1e7780288e8f$export$edf27be85e5f6da0.defaultProps = {
    header: '',
    size: 'wide',
    isLoading: false,
    isSubtle: false,
    retryMessage: (0, $eQdlC.default).retry
};
var $0cbb1e7780288e8f$export$2e2bcd8739ae039 = (0, $giAhk.injectIntlV2)($0cbb1e7780288e8f$export$edf27be85e5f6da0);

});
parcelRegister("4zP5Y", function(module, exports) {
module.exports = new URL("error-subtle.580d9941.svg", import.meta.url).toString();

});

parcelRegister("80J5A", function(module, exports) {
module.exports = new URL("error.4fa1b24b.svg", import.meta.url).toString();

});

parcelRegister("eQdlC", function(module, exports) {

$parcel$export(module.exports, "default", () => $8bc26b353252dab4$export$2e2bcd8739ae039);

var $90IgZ = parcelRequire("90IgZ");
var $8bc26b353252dab4$export$2e2bcd8739ae039 = (0, $90IgZ.defineMessages)({
    retry: {
        "id": "common.components.error-state.retry-action",
        "defaultMessage": "Try again"
    }
});

});


parcelRegister("4yH5W", function(module, exports) {

$parcel$export(module.exports, "default", () => $055eb3d48c7bfa62$export$2e2bcd8739ae039);
/* index.tsx generated by @compiled/babel-plugin v0.29.1 */ 
var $eUqFw = parcelRequire("eUqFw");

var $7JEyt = parcelRequire("7JEyt");

var $4Bees = parcelRequire("4Bees");
// No delay on this spinner; we don't know if the monolith had previously
// provided one. Better to increase risk a very brief display of a spinner
// than have the spinner vanish and return.
const $055eb3d48c7bfa62$var$LoadingSpinner = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($055eb3d48c7bfa62$var$SpinnerContainer, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $4Bees.default), {
        size: "large",
        testId: "servicedesk-common.ui.components.page-spinner.spinner"
    }));
var $055eb3d48c7bfa62$export$2e2bcd8739ae039 = $055eb3d48c7bfa62$var$LoadingSpinner;
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $055eb3d48c7bfa62$var$SpinnerContainer = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_kqswh2mm _154i1jfw _1bsb1osq _y3gn1h6o",
            __cmplp.className
        ])
    });
});

});

parcelRegister("iyZnb", function(module, exports) {

$parcel$export(module.exports, "getLastVisitedQueueIdAndCategory", () => $2202aa85cc588865$export$b5b4407b2529d2c4);
$parcel$export(module.exports, "setLastVisitedQueueIdAndCategory", () => $2202aa85cc588865$export$947aff127337ffa5);

var $8blac = parcelRequire("8blac");

var $aNBkj = parcelRequire("aNBkj");

var $a2MDL = parcelRequire("a2MDL");

var $fDE9L = parcelRequire("fDE9L");
var $f1lMr = parcelRequire("f1lMr");
const $2202aa85cc588865$var$LAST_VISITED_QUEUE_KEY_PREFIX = 'last_visited_queue';
const $2202aa85cc588865$var$LAST_VISITED_CATEGORY_KEY_PREFIX = 'last_visited_category';
const $2202aa85cc588865$export$b5b4407b2529d2c4 = (projectKey, category = (0, $f1lMr.NO_CATEGORY))=>{
    if ((0, (/*@__PURE__*/$parcel$interopDefault($8blac)))(projectKey)) return [
        null,
        null
    ];
    try {
        if (category === (0, $f1lMr.NO_CATEGORY)) {
            // indicates a redirect from /queues endpoint
            const categoryToRedirectTo = (0, $a2MDL.getFromLocalStorage)(`${$2202aa85cc588865$var$LAST_VISITED_CATEGORY_KEY_PREFIX}_${projectKey}`);
            const queueId = (0, $a2MDL.getFromLocalStorage)(`${$2202aa85cc588865$var$LAST_VISITED_QUEUE_KEY_PREFIX}_${projectKey}_${categoryToRedirectTo}`);
            return [
                queueId,
                ...(0, $fDE9L.isValidItsmPractice)(categoryToRedirectTo) ? [
                    categoryToRedirectTo
                ] : [
                    (0, $f1lMr.NO_CATEGORY)
                ]
            ];
        }
        return [
            (0, $a2MDL.getFromLocalStorage)(`${$2202aa85cc588865$var$LAST_VISITED_QUEUE_KEY_PREFIX}_${projectKey}_${category}`),
            category
        ];
    } catch (error) {
        return [
            null,
            null
        ];
    }
};
const $2202aa85cc588865$export$947aff127337ffa5 = (queueId, projectKey, category = (0, $f1lMr.NO_CATEGORY))=>{
    let lastVisitedQueueId;
    try {
        if ((0, (/*@__PURE__*/$parcel$interopDefault($8blac)))(projectKey)) throw new Error('project key is empty');
        lastVisitedQueueId = (0, $a2MDL.getFromLocalStorage)(`${$2202aa85cc588865$var$LAST_VISITED_QUEUE_KEY_PREFIX}_${projectKey}_${category}`);
    } catch (error) {
        lastVisitedQueueId = null;
    }
    if (!(0, (/*@__PURE__*/$parcel$interopDefault($8blac)))(projectKey) && lastVisitedQueueId !== queueId) try {
        (0, $a2MDL.setInLocalStorage)(`${$2202aa85cc588865$var$LAST_VISITED_QUEUE_KEY_PREFIX}_${projectKey}_${category}`, (0, $aNBkj.fromQueueIdString)(queueId));
        (0, $a2MDL.setInLocalStorage)(`${$2202aa85cc588865$var$LAST_VISITED_CATEGORY_KEY_PREFIX}_${projectKey}`, category);
    } catch (error) {
    // Don't care if it fails. Default behavior in QueuesRedirect will take users to first available queue.
    }
};

});
parcelRegister("fDE9L", function(module, exports) {

$parcel$export(module.exports, "toItsmPractice", () => $535b295fef57b491$export$1b27246f3c7494c);
$parcel$export(module.exports, "isValidItsmPractice", () => $535b295fef57b491$export$357b94e419749e3d);

var $f1lMr = parcelRequire("f1lMr");
const $535b295fef57b491$export$1b27246f3c7494c = (practiceString)=>{
    switch(practiceString){
        case 'incidents':
            return 0, $f1lMr.INCIDENTS;
        case 'changes':
            return 0, $f1lMr.CHANGES;
        case 'service-requests':
            return 0, $f1lMr.SERVICE_REQUEST;
        case 'problems':
            return 0, $f1lMr.PROBLEMS;
        case 'post-incident-reviews':
            return 0, $f1lMr.POST_INCIDENT_REVIEWS;
        default:
            return 0, $f1lMr.NO_CATEGORY;
    }
};
const $535b295fef57b491$export$357b94e419749e3d = (practiceString)=>{
    switch(practiceString){
        case 0, $f1lMr.INCIDENTS:
        case 0, $f1lMr.CHANGES:
        case 0, $f1lMr.SERVICE_REQUEST:
        case 0, $f1lMr.PROBLEMS:
        case 0, $f1lMr.POST_INCIDENT_REVIEWS:
        case 0, $f1lMr.NO_CATEGORY:
            return true;
        default:
            return false;
    }
};

});


parcelRegister("i8xmR", function(module, exports) {

$parcel$export(module.exports, "default", () => $e7a1d79592523d6a$export$2e2bcd8739ae039);

var $90IgZ = parcelRequire("90IgZ");
var $e7a1d79592523d6a$export$2e2bcd8739ae039 = (0, $90IgZ.defineMessages)({
    notFoundHeader: {
        "id": "servicedesk-queues-available-queues-api.queue-provider.not-found-header",
        "defaultMessage": "We couldn't find your queue"
    },
    notFoundDescription: {
        "id": "servicedesk-queues-available-queues-api.queue-provider.not-found-description",
        "defaultMessage": "Looks like we\u2019re having trouble connecting, or it may have been removed."
    }
});

});



parcelRegister("1L8BM", function(module, exports) {

$parcel$export(module.exports, "useCategorizedNavItems", () => $93f34f3b432efde9$export$fec6561bcaa1c55b);
$parcel$export(module.exports, "useCurrentCategorizedNavItems", () => $93f34f3b432efde9$export$f9b7a4e20c09f3ce);
$parcel$export(module.exports, "useCategorizedQueues", () => $93f34f3b432efde9$export$c4ca47ba8c81dba6);
$parcel$export(module.exports, "useFavouriteNavItems", () => $93f34f3b432efde9$export$e27d61833d43b175);
$parcel$export(module.exports, "useCanBeHiddenNavItems", () => $93f34f3b432efde9$export$528be43f76fe19f7);
$parcel$export(module.exports, "useAlwaysVisibleNavItems", () => $93f34f3b432efde9$export$4c168500ca36ad18);
$parcel$export(module.exports, "usePracticeMetadata", () => $93f34f3b432efde9$export$f857eeb50ae9b1b2);
$parcel$export(module.exports, "usePracticeList", () => $93f34f3b432efde9$export$216a9245ead6e18a);
$parcel$export(module.exports, "CategorizedQueuesStore", () => $93f34f3b432efde9$export$5577ca8a6b2fed3c);

var $eUqFw = parcelRequire("eUqFw");

var $iZJHG = parcelRequire("iZJHG");

var $hRe6W = parcelRequire("hRe6W");

var $f1lMr = parcelRequire("f1lMr");

var $5OEre = parcelRequire("5OEre");

var $lvy2i = parcelRequire("lvy2i");

var $2htGg = parcelRequire("2htGg");
const $93f34f3b432efde9$var$useCategorizedData = (category, dataSelector, customContext)=>{
    const { data: allData, loading: loading, error: error, refresh: refresh } = (0, $iZJHG.useResourceWithCustomRouterContext)((0, $hRe6W.queuesNavigationItems), customContext);
    const memoizedData = (0, $eUqFw.useMemo)(()=>dataSelector(allData, category), [
        allData,
        category,
        dataSelector
    ]);
    return [
        memoizedData,
        loading,
        error,
        refresh
    ];
};
const $93f34f3b432efde9$export$fec6561bcaa1c55b = (baseUrl, projectKey, category = (0, $f1lMr.NO_CATEGORY), customContext)=>{
    const [methods] = (0, $2htGg.useCategorizedActions)(baseUrl, projectKey, category, customContext);
    const [data, loading, error, refresh] = $93f34f3b432efde9$var$useCategorizedData(category, (0, $lvy2i.navDataSelector), customContext);
    return [
        data,
        loading,
        error,
        methods,
        refresh
    ];
};
const $93f34f3b432efde9$export$f9b7a4e20c09f3ce = ()=>{
    const projectKey = (0, $5OEre.useProjectKey)();
    const category = (0, $5OEre.useCurrentCategory)();
    const [data, loading, error, methods] = $93f34f3b432efde9$export$c4ca47ba8c81dba6('', projectKey, category);
    return [
        data,
        loading,
        error,
        methods
    ];
};
const $93f34f3b432efde9$export$1dc9816387d038aa = (baseUrl, projectKey, category = (0, $f1lMr.NO_CATEGORY))=>{
    const [methods] = (0, $2htGg.useCategorizedActions)(baseUrl, projectKey, category);
    const [data, loading, error] = $93f34f3b432efde9$var$useCategorizedData(category, (0, $lvy2i.notFavouriteDataSelector));
    return [
        data,
        loading,
        error,
        methods
    ];
};
const $93f34f3b432efde9$export$e27d61833d43b175 = (baseUrl, projectKey, category = (0, $f1lMr.NO_CATEGORY), customContext)=>{
    const [methods] = (0, $2htGg.useCategorizedActions)(baseUrl, projectKey, category, customContext);
    const [data, loading, error] = $93f34f3b432efde9$var$useCategorizedData(category, (0, $lvy2i.favouriteDataSelector), customContext);
    return [
        data,
        loading,
        error,
        methods
    ];
};
const $93f34f3b432efde9$export$528be43f76fe19f7 = (baseUrl, projectKey, category = (0, $f1lMr.NO_CATEGORY), customContext)=>{
    const [methods] = (0, $2htGg.useCategorizedActions)(baseUrl, projectKey, category, customContext);
    const [data, loading, error] = $93f34f3b432efde9$var$useCategorizedData(category, (0, $lvy2i.notFavouriteAndCanBeHiddenDataSelector), customContext);
    return [
        data,
        loading,
        error,
        methods
    ];
};
const $93f34f3b432efde9$export$4c168500ca36ad18 = (baseUrl, projectKey, category = (0, $f1lMr.NO_CATEGORY), customContext)=>{
    const [methods] = (0, $2htGg.useCategorizedActions)(baseUrl, projectKey, category, customContext);
    const [data, loading, error] = $93f34f3b432efde9$var$useCategorizedData(category, (0, $lvy2i.cannotBeHiddenAndNotFavouriteDataSelector), customContext);
    return [
        data,
        loading,
        error,
        methods
    ];
};
const $93f34f3b432efde9$export$c4ca47ba8c81dba6 = (baseUrl, projectKey, category = (0, $f1lMr.NO_CATEGORY))=>{
    const [methods] = (0, $2htGg.useCategorizedActions)(baseUrl, projectKey, category);
    const [data, loading, error] = $93f34f3b432efde9$var$useCategorizedData(category, (0, $lvy2i.queuesDataSelector));
    return [
        data,
        loading,
        error,
        methods
    ];
};
const $93f34f3b432efde9$export$f857eeb50ae9b1b2 = (category = (0, $f1lMr.NO_CATEGORY), customContext)=>$93f34f3b432efde9$var$useCategorizedData(category, (0, $lvy2i.practiceMetadataSelector), customContext);
const $93f34f3b432efde9$export$216a9245ead6e18a = (customContext)=>$93f34f3b432efde9$var$useCategorizedData((0, $f1lMr.NO_CATEGORY), (0, $lvy2i.practiceListSelector), customContext);
const $93f34f3b432efde9$export$5577ca8a6b2fed3c = ({ baseUrl: baseUrl, projectKey: projectKey, category: category, children: children })=>{
    const [data, loading, error, methods] = $93f34f3b432efde9$export$c4ca47ba8c81dba6(baseUrl, projectKey, category);
    return children({
        data: data,
        loading: loading,
        error: error,
        methods: methods
    });
};
const $93f34f3b432efde9$export$aea9dc5735ed30c = ({ baseUrl: baseUrl, projectKey: projectKey, category: category, children: children })=>{
    const [data, loading, error, methods] = $93f34f3b432efde9$export$fec6561bcaa1c55b(baseUrl, projectKey, category);
    return children({
        data: data,
        loading: loading,
        error: error,
        methods: methods
    });
};
$93f34f3b432efde9$export$5577ca8a6b2fed3c.defaultProps = {
    category: (0, $f1lMr.NO_CATEGORY)
};
$93f34f3b432efde9$export$aea9dc5735ed30c.defaultProps = {
    category: (0, $f1lMr.NO_CATEGORY)
};

});
parcelRegister("5OEre", function(module, exports) {

$parcel$export(module.exports, "getQueuesForCategory", () => $e80fc5c8437d321b$export$fcf9c653a5f7167a);
$parcel$export(module.exports, "setQueuesForCategory", () => $e80fc5c8437d321b$export$7ca50bfd96f22f76);
$parcel$export(module.exports, "queuesToNavItems", () => $e80fc5c8437d321b$export$e6491f132367997c);
$parcel$export(module.exports, "useProjectKey", () => $e80fc5c8437d321b$export$f87be37f8e8be65);
$parcel$export(module.exports, "useCurrentCategory", () => $e80fc5c8437d321b$export$e42116f2f5c27c35);

var $6HC1D = parcelRequire("6HC1D");

var $lB25E = parcelRequire("lB25E");

var $2bMHt = parcelRequire("2bMHt");

var $fDE9L = parcelRequire("fDE9L");

var $6vrw7 = parcelRequire("6vrw7");
const $e80fc5c8437d321b$export$fcf9c653a5f7167a = (data, category)=>(0, $6HC1D.getIn)(data, [
        category,
        'queues'
    ]);
const $e80fc5c8437d321b$export$7ca50bfd96f22f76 = (data, category, newQueues)=>// @ts-expect-error(PARTIAL_RECORD) TS2740 - Type '{}' is missing the following properties from type 'CategorizedQueueData': "change-management", "incident-management", "problem-management", "service-request", and 2 more.
    (0, $6HC1D.updateIn)(data || {}, [
        category,
        'queues'
    ], (queues)=>{
        // We only want to update queues if they exist in a category already
        if (queues) return newQueues;
        throw new Error(`${category} does not exist in resource`);
    });
const $e80fc5c8437d321b$export$e6491f132367997c = (queues)=>queues.map(({ id: id, name: name, projectKey: projectKey, count: count, category: category, favourite: favourite, canBeHidden: canBeHidden, shouldSkipIssueCountRefresh: shouldSkipIssueCountRefresh, lastRefreshedTime: lastRefreshedTime })=>({
            id: String(id),
            name: name,
            url: `/projects/${projectKey}/${(0, $2bMHt.getQueueFragment)(id, category)}`,
            badgeCount: count,
            starred: favourite,
            canBeHidden: canBeHidden,
            shouldSkipIssueCountRefresh: shouldSkipIssueCountRefresh,
            category: category,
            lastRefreshedTime: lastRefreshedTime
        }));
const $e80fc5c8437d321b$export$f87be37f8e8be65 = ()=>{
    const [{ match: match }] = (0, $lB25E.useRouter)();
    return (0, $6vrw7.toProjectKey)(match.params.projectKey || '');
};
const $e80fc5c8437d321b$export$e42116f2f5c27c35 = ()=>{
    const [{ match: match }] = (0, $lB25E.useRouter)();
    return (0, $fDE9L.toItsmPractice)(match.params.practiceType);
};

});

parcelRegister("lvy2i", function(module, exports) {

$parcel$export(module.exports, "queuesDataSelector", () => $a719d5cd2d3098d5$export$fe10e38dc2f0e4c8);
$parcel$export(module.exports, "navDataSelector", () => $a719d5cd2d3098d5$export$caf8de9cbdbf9102);
$parcel$export(module.exports, "notFavouriteAndCanBeHiddenDataSelector", () => $a719d5cd2d3098d5$export$231e113a2e075013);
$parcel$export(module.exports, "notFavouriteDataSelector", () => $a719d5cd2d3098d5$export$46aa703ec1a01e);
$parcel$export(module.exports, "cannotBeHiddenAndNotFavouriteDataSelector", () => $a719d5cd2d3098d5$export$f28545acfde3f70e);
$parcel$export(module.exports, "favouriteDataSelector", () => $a719d5cd2d3098d5$export$fc3fab89f453b08e);
$parcel$export(module.exports, "practiceMetadataSelector", () => $a719d5cd2d3098d5$export$b0af22bb6bff9c49);
$parcel$export(module.exports, "isCountLoadingSelector", () => $a719d5cd2d3098d5$export$efbcd30acb5e816f);
$parcel$export(module.exports, "hasRequestedCountSelector", () => $a719d5cd2d3098d5$export$54e54a1ac5e7098f);
$parcel$export(module.exports, "practiceListSelector", () => $a719d5cd2d3098d5$export$61d9fd7be029b514);

var $6HC1D = parcelRequire("6HC1D");

var $5OEre = parcelRequire("5OEre");
const $a719d5cd2d3098d5$export$fe10e38dc2f0e4c8 = (data, category)=>(0, $5OEre.getQueuesForCategory)(data, category) || null;
const $a719d5cd2d3098d5$export$caf8de9cbdbf9102 = (data, category)=>{
    const queues = (0, $5OEre.getQueuesForCategory)(data, category);
    return queues ? (0, $5OEre.queuesToNavItems)(queues) : null;
};
const $a719d5cd2d3098d5$export$231e113a2e075013 = (data, category)=>{
    const queues = (0, $5OEre.getQueuesForCategory)(data, category);
    const otherQueuesData = queues ? queues.filter((q)=>q.canBeHidden && !q.favourite) : null;
    return otherQueuesData ? (0, $5OEre.queuesToNavItems)(otherQueuesData) : null;
};
const $a719d5cd2d3098d5$export$46aa703ec1a01e = (data, category)=>{
    const queues = (0, $5OEre.getQueuesForCategory)(data, category);
    // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
    const otherQueuesData = queues ? queues.filter((q)=>!q.favourite) : null;
    return otherQueuesData ? (0, $5OEre.queuesToNavItems)(otherQueuesData) : null;
};
const $a719d5cd2d3098d5$export$f28545acfde3f70e = (data, category)=>{
    const queues = (0, $5OEre.getQueuesForCategory)(data, category);
    const defaultQueuesData = queues ? queues.filter((q)=>!q.canBeHidden && !q.favourite) : null;
    return defaultQueuesData ? (0, $5OEre.queuesToNavItems)(defaultQueuesData) : null;
};
const $a719d5cd2d3098d5$export$fc3fab89f453b08e = (data, category)=>{
    const queues = (0, $5OEre.getQueuesForCategory)(data, category);
    // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
    const starredQueues = queues ? queues.filter((q)=>q.favourite) : null;
    return starredQueues ? (0, $5OEre.queuesToNavItems)(starredQueues) : null;
};
const $a719d5cd2d3098d5$export$b0af22bb6bff9c49 = (data, category)=>{
    const practiceData = (0, $6HC1D.getIn)(data, [
        category
    ]);
    return practiceData ? (0, $6HC1D.dissoc)(practiceData, 'queues') : null;
};
const $a719d5cd2d3098d5$export$efbcd30acb5e816f = (data, category)=>{
    const practiceData = (0, $6HC1D.getIn)(data, [
        category
    ]);
    return practiceData ? practiceData.isCountLoading : false;
};
const $a719d5cd2d3098d5$export$54e54a1ac5e7098f = (data, category)=>{
    const practiceData = (0, $6HC1D.getIn)(data, [
        category
    ]);
    return practiceData ? practiceData.hasRequestedCount : false;
};
const $a719d5cd2d3098d5$export$61d9fd7be029b514 = (data)=>// @ts-expect-error - TS2322 - Type 'string[] | null' is not assignable to type 'Data<ItsmPractice[]>'.
    data ? Object.keys(data) : null;

});

parcelRegister("2htGg", function(module, exports) {

$parcel$export(module.exports, "useCategorizedActions", () => $f77abdc2734c705f$export$8632bfeb0b672958);
$parcel$export(module.exports, "default", () => $f77abdc2734c705f$export$2e2bcd8739ae039);

var $iZJHG = parcelRequire("iZJHG");

var $hRe6W = parcelRequire("hRe6W");

var $g2iRM = parcelRequire("g2iRM");
const $f77abdc2734c705f$export$8632bfeb0b672958 = (baseUrl, projectKey, category, customContext)=>{
    const { update: update } = (0, $iZJHG.useResourceWithCustomRouterContext)((0, $hRe6W.queuesNavigationItems), customContext);
    const cachedActions = (0, $g2iRM.default)(category, update, {
        baseUrl: baseUrl,
        projectKey: projectKey
    });
    return [
        cachedActions
    ];
};
const $f77abdc2734c705f$var$ActionsProvider = ({ baseUrl: baseUrl, projectKey: projectKey, category: category, children: children })=>{
    const [actions] = $f77abdc2734c705f$export$8632bfeb0b672958(baseUrl, projectKey, category);
    return children(actions);
};
var $f77abdc2734c705f$export$2e2bcd8739ae039 = $f77abdc2734c705f$var$ActionsProvider;

});
parcelRegister("g2iRM", function(module, exports) {

$parcel$export(module.exports, "default", () => $29b1c6018b6f5b00$export$2e2bcd8739ae039);

var $jG2Eu = parcelRequire("jG2Eu");

var $1yZQx = parcelRequire("1yZQx");
var $kEDjj = parcelRequire("kEDjj");

var $3uRX3 = parcelRequire("3uRX3");
const $29b1c6018b6f5b00$export$36d128238e6b60f5 = {
    currentCacheKey: '',
    // @ts-expect-error(PARTIAL_RECORD) TS2740 - Type '{}' is missing the following properties from type 'Record<ItsmPractice, ChildrenProps>': "change-management", "incident-management", "problem-management", "service-request", and 2 more.
    actionsByCategory: {}
};
const $29b1c6018b6f5b00$export$8b3bc28eb06c49b6 = {
    // Actions are lazily created for each category of a project.
    // Project key is used as the cache key. Once the cache key has changed
    // the store will be reset
    getActions: (...args)=>({ getState: getState, setState: setState })=>{
            const [category, , { projectKey: projectKey }] = args;
            const { currentCacheKey: currentCacheKey, actionsByCategory: actionsByCategory } = getState();
            const categoryActions = actionsByCategory[category];
            const hasSameKey = projectKey === currentCacheKey;
            if (hasSameKey && Boolean(categoryActions)) return categoryActions;
            const newCategoryActions = (0, $3uRX3.getActions)(...args);
            setState({
                currentCacheKey: projectKey,
                // @ts-expect-error(PARTIAL_RECORD) TS2322 - Type '{ "change-management"?: Actions | undefined; "incident-management"?: Actions | undefined; "problem-management"?: Actions | undefined; "service-request"?: Actions | undefined; "post-incident-review"?: Actions | undefined; "no-category"?: Actions | undefined; }' is not assignable to type 'Record<ItsmPractice, ChildrenProps>'.
                actionsByCategory: {
                    ...hasSameKey ? actionsByCategory : {},
                    [category]: newCategoryActions
                }
            });
            return newCategoryActions;
        }
};
const $29b1c6018b6f5b00$var$Store = (0, $kEDjj.createStore)({
    initialState: $29b1c6018b6f5b00$export$36d128238e6b60f5,
    actions: $29b1c6018b6f5b00$export$8b3bc28eb06c49b6,
    name: 'jira-servicedesk-categorized-queues-actions-store'
});
const $29b1c6018b6f5b00$var$useActionsStore = (0, $1yZQx.createHook)($29b1c6018b6f5b00$var$Store, {
    selector: (0, (/*@__PURE__*/$parcel$interopDefault($jG2Eu)))
});
const $29b1c6018b6f5b00$export$193cb0fec61d3692 = (...args)=>{
    const [, { getActions: getActions }] = $29b1c6018b6f5b00$var$useActionsStore();
    return getActions(...args);
};
var $29b1c6018b6f5b00$export$2e2bcd8739ae039 = $29b1c6018b6f5b00$export$193cb0fec61d3692;

});
parcelRegister("3uRX3", function(module, exports) {

$parcel$export(module.exports, "getActions", () => $b6785e02894533d1$export$fe3955935f564b31);

var $6HC1D = parcelRequire("6HC1D");

var $a576Y = parcelRequire("a576Y");


var $1ybV0 = parcelRequire("1ybV0");

var $JRB5w = parcelRequire("JRB5w");

var $9U7QG = parcelRequire("9U7QG");

var $kzu7k = parcelRequire("kzu7k");
var $4czDf = parcelRequire("4czDf");

var $5OEre = parcelRequire("5OEre");

var $lvy2i = parcelRequire("lvy2i");

var $8tcOM = parcelRequire("8tcOM");

var $kG021 = parcelRequire("kG021");
const $b6785e02894533d1$var$throttleNavItemsRefreshRate = ()=>(0, $1ybV0.getMultivariateFeatureFlag)('jsm.dynamic.queues.issue.count.refresh.interval', '60000', [
        '60000',
        '120000',
        '300000',
        '90000',
        '86400000'
    ]);
const $b6785e02894533d1$var$getThrottledRefresh = ()=>Number($b6785e02894533d1$var$throttleNavItemsRefreshRate());
const $b6785e02894533d1$var$getAnalyticsPayload = (err)=>{
    const wasQueueDeleted = err?.statusCode === (0, $1c3fbb431a173cc6$export$8bca792d963eb0ef);
    const queueConflictOccurred = err?.statusCode === (0, $1c3fbb431a173cc6$export$c09e7ea0fc79f34f);
    const queueActionNotPermitted = err?.statusCode === (0, $1c3fbb431a173cc6$export$a3269a3914b007e3);
    return {
        wasQueueDeleted: wasQueueDeleted,
        queueConflictOccurred: queueConflictOccurred,
        queueActionNotPermitted: queueActionNotPermitted,
        isClientFetchError: (0, $JRB5w.isClientFetchError)(err)
    };
};
const $b6785e02894533d1$export$fe3955935f564b31 = (category, update, restParams)=>{
    const actions = {
        addItem: (item)=>{
            update((data)=>{
                const queues = (0, $5OEre.getQueuesForCategory)(data, category);
                if (queues) return (0, $5OEre.setQueuesForCategory)(data, category, (0, $kG021.addItem)(queues, item));
                throw new Error(`Cannot add item because ${category} does not exist in resource`);
            });
        },
        deleteItem: (id)=>{
            update((data)=>{
                const queues = (0, $5OEre.getQueuesForCategory)(data, category);
                if (queues) return (0, $5OEre.setQueuesForCategory)(data, category, (0, $kG021.deleteItem)(queues, id));
                throw new Error(`Cannot delete item because ${category} does not exist in resource`);
            });
        },
        editItem: (item)=>{
            update((data)=>{
                const queues = (0, $5OEre.getQueuesForCategory)(data, category);
                if (queues) return (0, $5OEre.setQueuesForCategory)(data, category, (0, $kG021.editItem)(queues, item));
                throw new Error(`Cannot edit item because ${category} does not exist in resource`);
            });
        },
        moveItem: (from, to)=>{
            if (from !== to) update((data)=>{
                const queues = (0, $5OEre.getQueuesForCategory)(data, category);
                if (queues) {
                    const { baseUrl: baseUrl, projectKey: projectKey } = restParams;
                    const result = (0, $kG021.moveItem)(queues, from, to);
                    (0, $kzu7k.setQueues)(baseUrl, projectKey, (0, $5OEre.queuesToNavItems)(result), category);
                    return (0, $5OEre.setQueuesForCategory)(data, category, result);
                }
                throw new Error(`Cannot move item because ${category} does not exist in resource`);
            });
        },
        moveItemBelow: (queueId, targetQueueId, onSuccessCallback, onErrorCallback)=>{
            update((data)=>{
                const queues = (0, $5OEre.getQueuesForCategory)(data, category);
                if (queues) {
                    const { baseUrl: baseUrl, projectKey: projectKey } = restParams;
                    const result = (0, $kG021.moveItemBelow)(queues, queueId, targetQueueId);
                    (0, $kzu7k.setQueues)(baseUrl, projectKey, (0, $5OEre.queuesToNavItems)(result), category).then(()=>onSuccessCallback()).catch((err)=>onErrorCallback($b6785e02894533d1$var$getAnalyticsPayload(err)));
                    return (0, $5OEre.setQueuesForCategory)(data, category, result);
                }
                throw new Error(`Cannot move item below because ${category} does not exist in resource`);
            });
        },
        moveItemAbove: (queueId, targetQueueId, onSuccessCallback, onErrorCallback)=>{
            update((data)=>{
                const queues = (0, $5OEre.getQueuesForCategory)(data, category);
                if (queues) {
                    const { baseUrl: baseUrl, projectKey: projectKey } = restParams;
                    const result = (0, $kG021.moveItemAbove)(queues, queueId, targetQueueId);
                    (0, $kzu7k.setQueues)(baseUrl, projectKey, (0, $5OEre.queuesToNavItems)(result), category).then(()=>onSuccessCallback()).catch((err)=>onErrorCallback($b6785e02894533d1$var$getAnalyticsPayload(err)));
                    return (0, $5OEre.setQueuesForCategory)(data, category, result);
                }
                throw new Error(`Cannot move item above because ${category} does not exist in resource`);
            });
        },
        moveToTop: (queueId, onSuccessCallback, onErrorCallback)=>{
            update((data)=>{
                const queues = (0, $5OEre.getQueuesForCategory)(data, category);
                if (queues) {
                    const { baseUrl: baseUrl, projectKey: projectKey } = restParams;
                    const result = (0, $kG021.moveToTop)(queues, queueId);
                    (0, $kzu7k.setQueues)(baseUrl, projectKey, (0, $5OEre.queuesToNavItems)(result), category).then(()=>onSuccessCallback()).catch((err)=>onErrorCallback($b6785e02894533d1$var$getAnalyticsPayload(err)));
                    return (0, $5OEre.setQueuesForCategory)(data, category, result);
                }
                throw new Error(`Cannot move item to top because ${category} does not exist in resource`);
            });
        },
        refreshNavItems: (0, (/*@__PURE__*/$parcel$interopDefault($a576Y)))((analyticsEvent)=>{
            setTimeout(()=>{
                update((data)=>{
                    const isCountLoading = (0, $lvy2i.isCountLoadingSelector)(data, category);
                    if (isCountLoading) return data;
                    if (restParams.projectKey) (0, $8tcOM.refreshIssueCountForVisibleAndStarredQueues)(update, {
                        ...restParams,
                        category: category
                    }, analyticsEvent);
                    const updatedData = data ? (0, $6HC1D.assocIn)(data, [
                        category,
                        'isCountLoading'
                    ], true) : null;
                    return updatedData;
                });
            // Jitter the call randomly between 1 - 5secs in case of multiple tab requests
            }, Math.floor(Math.random() * 5000) + 1000);
        }, $b6785e02894533d1$var$getThrottledRefresh()),
        initialFetchNavItems: (analyticsEvent)=>{
            update((data)=>{
                const isCountLoading = (0, $lvy2i.isCountLoadingSelector)(data, category);
                const hasRequestedCount = (0, $lvy2i.hasRequestedCountSelector)(data, category);
                if (!isCountLoading && !hasRequestedCount) actions.refreshNavItems(analyticsEvent);
                return data;
            });
        },
        refreshIssueCountForItems: (queueIds, analyticsEvent)=>{
            (0, $8tcOM.refreshIssueCountForQueues)(update, {
                ...restParams,
                category: category
            }, queueIds, analyticsEvent);
        },
        editItemIssueCount: (id, count)=>{
            update((data)=>{
                const queues = (0, $5OEre.getQueuesForCategory)(data, category);
                if (queues) return (0, $5OEre.setQueuesForCategory)(data, category, (0, $kG021.editItem)(queues, {
                    id: Number(id),
                    count: count,
                    lastRefreshedTime: Date.now()
                }));
                // There is no point update the issue-counts for default queue as there is no queues.
                // It might throwing exceptions if we cannot fetch queue categories.
                // Being defensive here for the rollout, if this code throw any errors, it's the same behavior as the below line.
                if (Number(id) === (0, $9U7QG.DEFAULT_QUEUE_ID)) return data;
                throw new Error(`Cannot edit item issue count because ${category} does not exist in resource for queue id ${id}`);
            });
        },
        editItemFavorite: (id, favourite)=>{
            update((data)=>{
                const queues = (0, $5OEre.getQueuesForCategory)(data, category);
                if (queues) return (0, $5OEre.setQueuesForCategory)(data, category, (0, $kG021.editItem)(queues, {
                    id: Number(id),
                    favourite: favourite
                }));
                throw new Error(`Cannot edit item favorite because ${category} does not exist in resource`);
            });
        },
        editVisibilityOfItems: (updatedItems, draggableId, onSuccessCallback, onErrorCallback)=>{
            update((data)=>{
                const queues = (0, $5OEre.getQueuesForCategory)(data, category);
                const { baseUrl: baseUrl, projectKey: projectKey } = restParams;
                if (queues) {
                    (0, $4czDf.updateQueuesVisibility)(baseUrl, projectKey, updatedItems).then(()=>onSuccessCallback()).catch((err)=>onErrorCallback($b6785e02894533d1$var$getAnalyticsPayload(err)));
                    return (0, $5OEre.setQueuesForCategory)(data, category, (0, $kG021.editItems)(queues, [
                        ...updatedItems
                    ]));
                }
                throw new Error(`Cannot edit item favorite because ${category} does not exist in resource`);
            });
        },
        enableRefreshForQueues: (queueIds)=>{
            (0, $8tcOM.enableRefreshForQueues)(update, {
                ...restParams,
                category: category
            }, queueIds);
        },
        enableIssueCountForSelectedQueues: (selectedQueueIds)=>{
            update((data)=>{
                const queues = (0, $5OEre.getQueuesForCategory)(data, category);
                if (queues) return (0, $5OEre.setQueuesForCategory)(data, category, (0, $kG021.enableSelectedQueuesVisibility)(selectedQueueIds, queues));
                throw new Error(`Cannot enable issue count for selected queues because ${category} does not exist in resource`);
            });
        }
    };
    return actions;
};

});
const $1c3fbb431a173cc6$export$ff39ebd4bb12b718 = 201;
const $1c3fbb431a173cc6$export$3288b14b6745c572 = 204;
const $1c3fbb431a173cc6$export$9de493bcd9b1d977 = 400;
const $1c3fbb431a173cc6$export$67d19e9a991baa07 = 401;
const $1c3fbb431a173cc6$export$a3269a3914b007e3 = 403;
const $1c3fbb431a173cc6$export$8bca792d963eb0ef = 404;
const $1c3fbb431a173cc6$export$4a3cb39801694eee = 407;
const $1c3fbb431a173cc6$export$fa405bbf47d510e2 = 408;
const $1c3fbb431a173cc6$export$c09e7ea0fc79f34f = 409;
const $1c3fbb431a173cc6$export$5244030134e99 = 412;
const $1c3fbb431a173cc6$export$f90ac1df0b60853d = 413;
const $1c3fbb431a173cc6$export$a447d0a965e16776 = 422;
const $1c3fbb431a173cc6$export$3b48aba8957000cd = 426;
const $1c3fbb431a173cc6$export$6763168a631449a2 = 429;
const $1c3fbb431a173cc6$export$e813cd7045fcc98d = 500;
const $1c3fbb431a173cc6$export$2ce38d41a306034e = 502;
const $1c3fbb431a173cc6$export$974c37534b0191b1 = 503;
const $1c3fbb431a173cc6$export$5400e8dddac3fcf3 = 504;

parcelRegister("9U7QG", function(module, exports) {

$parcel$export(module.exports, "DEFAULT_COLUMNS", () => $cf96a29155ecae50$export$50c19f60b9c144f7);
$parcel$export(module.exports, "DEFAULT_QUEUE_ID", () => $cf96a29155ecae50$export$e78379cc32bff512);
const $cf96a29155ecae50$export$50c19f60b9c144f7 = [
    'issuetype',
    'issuekey',
    'summary',
    'reporter',
    'assignee',
    'status',
    'created'
];
const $cf96a29155ecae50$export$e78379cc32bff512 = Number.MIN_VALUE;

});

parcelRegister("kzu7k", function(module, exports) {

$parcel$export(module.exports, "setQueues", () => $03d5e58aec24405a$export$51b06787b88b2bf2);

var $lRmyA = parcelRequire("lRmyA");

var $7nVUh = parcelRequire("7nVUh");
const $03d5e58aec24405a$var$getQueuesUrl = (baseUrl, projectKey)=>`${baseUrl}/rest/servicedesk/1/servicedesk/${projectKey}/queues`;
const $03d5e58aec24405a$export$51b06787b88b2bf2 = (baseUrl, projectKey, queues, category)=>(0, $lRmyA.performPutRequest)($03d5e58aec24405a$var$getQueuesUrl(baseUrl, projectKey), {
        body: JSON.stringify((0, $7nVUh.transformQueues)(queues, category))
    });

});
parcelRegister("7nVUh", function(module, exports) {

$parcel$export(module.exports, "transformQueues", () => $9f9a0a7b480d38b8$export$66ec85c65393edb4);

var $f1lMr = parcelRequire("f1lMr");
const $9f9a0a7b480d38b8$export$66ec85c65393edb4 = (queues, category)=>({
        order: queues.map((queue)=>queue.id),
        id: 'com.atlassian.servicedesk.project-ui:sd-queues-custom',
        inline: true,
        deleted: [],
        ...category && category !== (0, $f1lMr.NO_CATEGORY) ? {
            category: category
        } : undefined
    });

});


parcelRegister("4czDf", function(module, exports) {

$parcel$export(module.exports, "updateQueuesVisibility", () => $1c8d54edade9a56e$export$c0862f2fb17c23c2);

var $lRmyA = parcelRequire("lRmyA");
const $1c8d54edade9a56e$var$getUpdateQueuesVisibilityUrl = (baseUrl, projectKey)=>`${baseUrl}/rest/servicedesk/1/servicedesk/${projectKey}/queues/update-visibility`;
const $1c8d54edade9a56e$export$c0862f2fb17c23c2 = (baseUrl, projectKey, modified)=>(0, $lRmyA.performPutRequest)($1c8d54edade9a56e$var$getUpdateQueuesVisibilityUrl(baseUrl, projectKey), {
        body: JSON.stringify({
            modified: modified
        })
    });

});

parcelRegister("8tcOM", function(module, exports) {

$parcel$export(module.exports, "refreshIssueCountForVisibleAndStarredQueues", () => $949c92075b18bf2b$export$aaa6aeca5994daee);
$parcel$export(module.exports, "enableRefreshForQueues", () => $949c92075b18bf2b$export$6b0c14cefee3edf5);
$parcel$export(module.exports, "refreshIssueCountForQueues", () => $949c92075b18bf2b$export$b05e3887bfb123a8);

var $6HC1D = parcelRequire("6HC1D");

var $3aUuh = parcelRequire("3aUuh");

var $jG2Eu = parcelRequire("jG2Eu");

var $3G3gn = parcelRequire("3G3gn");

var $guiFP = parcelRequire("guiFP");

var $5OEre = parcelRequire("5OEre");

var $lvy2i = parcelRequire("lvy2i");

var $ddvJX = parcelRequire("ddvJX");
const $949c92075b18bf2b$export$defcbd4ba0fd3734 = 5;
const $949c92075b18bf2b$var$RETRY_DELAY_IN_MS = 1000;
const $949c92075b18bf2b$var$fireErrorAnalyticsForRetryFailure = (error)=>{
    (0, $guiFP.default)({
        meta: {
            id: 'retryQueueIssueCountAction',
            packageName: 'jiraServicedeskCategorizedQueuesStore',
            teamName: 'jsd-shield'
        },
        error: error
    });
};
const $949c92075b18bf2b$export$ef7266a9f6c0de43 = ({ baseUrl: baseUrl, projectKey: projectKey, category: category }, skipHiddenQueues, update, retryCount, analyticsEvent)=>async (queueIds)=>{
        if (queueIds && queueIds.length === 0) return;
        if (retryCount >= $949c92075b18bf2b$export$defcbd4ba0fd3734) {
            (0, $ddvJX.fireManualOperationalAnalytics)({
                source: 'refreshQueueIssueCountAction',
                actionSubject: 'retryIssueCount',
                action: 'limitExceeded',
                attributes: {
                    retryCount: retryCount,
                    maxRetryCount: $949c92075b18bf2b$export$defcbd4ba0fd3734
                }
            });
            return;
        }
        setTimeout(()=>{
            try {
                const newRetryCount = retryCount + 1;
                update((data)=>{
                    const queues = (0, $5OEre.getQueuesForCategory)(data, category)?.filter((queue)=>queueIds.includes(queue.id));
                    if (queues && queues.length > 0) {
                        const retryCallback = $949c92075b18bf2b$export$ef7266a9f6c0de43({
                            baseUrl: baseUrl,
                            projectKey: projectKey,
                            category: category
                        }, true, update, newRetryCount, analyticsEvent);
                        (0, $ddvJX.updateIssueCountForQueues)(baseUrl, projectKey, category, queues, skipHiddenQueues, update, retryCallback, analyticsEvent);
                        (0, $ddvJX.fireManualOperationalAnalytics)({
                            source: 'refreshQueueIssueCountAction',
                            actionSubject: 'retryQueueIssueCount',
                            action: 'triggered',
                            attributes: {
                                retryCount: newRetryCount,
                                maxRetryCount: $949c92075b18bf2b$export$defcbd4ba0fd3734,
                                queuesCount: queues.length
                            }
                        });
                        return data ? (0, $6HC1D.assocIn)(data, [
                            category,
                            'isCountLoading'
                        ], true) : null;
                    }
                    return data;
                });
            // eslint-disable-next-line @typescript-eslint/no-explicit-any
            } catch (error) {
                $949c92075b18bf2b$var$fireErrorAnalyticsForRetryFailure(error);
                throw error;
            }
        }, $949c92075b18bf2b$var$RETRY_DELAY_IN_MS);
    };
const $949c92075b18bf2b$export$aaa6aeca5994daee = async (update, { baseUrl: baseUrl, projectKey: projectKey, category: category }, analyticsEvent)=>{
    try {
        update((data)=>{
            const queues = (0, $5OEre.getQueuesForCategory)(data, category);
            const retryCallback = !(0, $lvy2i.hasRequestedCountSelector)(data, category) ? $949c92075b18bf2b$export$ef7266a9f6c0de43({
                baseUrl: baseUrl,
                projectKey: projectKey,
                category: category
            }, true, update, 0, analyticsEvent) : (0, (/*@__PURE__*/$parcel$interopDefault($jG2Eu)));
            if (queues) {
                (0, $ddvJX.updateIssueCountForQueues)(baseUrl, projectKey, category, queues, true, update, retryCallback, analyticsEvent);
                return data ? (0, $6HC1D.assocIn)(data, [
                    category,
                    'isCountLoading'
                ], true) : null;
            }
            return data;
        });
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    } catch (error) {
        (0, $ddvJX.fireErrorAnalyticsForRefreshCountFailure)(error);
        throw error;
    }
};
const $949c92075b18bf2b$export$6b0c14cefee3edf5 = (update, { projectKey: _, category: category }, queueIds)=>{
    update((data)=>{
        const queues = (0, $5OEre.getQueuesForCategory)(data, category);
        const refreshEnabledQueues = queues?.filter((queue)=>queueIds.includes(queue.id.toString())).map((queue)=>queue.shouldSkipIssueCountRefresh ? {
                ...queue,
                shouldSkipIssueCountRefresh: false,
                count: undefined
            } : queue);
        const queuesMap = (0, (/*@__PURE__*/$parcel$interopDefault($3aUuh)))(queues, 'id');
        refreshEnabledQueues?.forEach((queue)=>{
            queuesMap[queue.id] = queue;
        });
        return (0, $5OEre.setQueuesForCategory)(data, category, (0, (/*@__PURE__*/$parcel$interopDefault($3G3gn)))(Object.values(queuesMap), 'order'));
    });
};
const $949c92075b18bf2b$export$b05e3887bfb123a8 = async (update, { baseUrl: baseUrl, projectKey: projectKey, category: category }, queueIds, analyticsEvent)=>{
    try {
        update((data)=>{
            const queues = (0, $5OEre.getQueuesForCategory)(data, category)?.filter((queue)=>queueIds.includes(queue.id.toString()));
            if (queues && queues.length > 0) {
                (0, $ddvJX.updateIssueCountForQueues)(baseUrl, projectKey, category, queues, false, update, (0, (/*@__PURE__*/$parcel$interopDefault($jG2Eu))), analyticsEvent);
                return data ? (0, $6HC1D.assocIn)(data, [
                    category,
                    'isCountLoading'
                ], true) : null;
            }
            return data;
        });
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    } catch (error) {
        (0, $ddvJX.fireErrorAnalyticsForRefreshCountFailure)(error);
        throw error;
    }
};

});
parcelRegister("3aUuh", function(module, exports) {

var $3pSMu = parcelRequire("3pSMu");

var $f2sQe = parcelRequire("f2sQe");
/**
 * Creates an object composed of keys generated from the results of running
 * each element of `collection` thru `iteratee`. The corresponding value of
 * each key is the last element responsible for generating the key. The
 * iteratee is invoked with one argument: (value).
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Collection
 * @param {Array|Object} collection The collection to iterate over.
 * @param {Function} [iteratee=_.identity] The iteratee to transform keys.
 * @returns {Object} Returns the composed aggregate object.
 * @example
 *
 * var array = [
 *   { 'dir': 'left', 'code': 97 },
 *   { 'dir': 'right', 'code': 100 }
 * ];
 *
 * _.keyBy(array, function(o) {
 *   return String.fromCharCode(o.code);
 * });
 * // => { 'a': { 'dir': 'left', 'code': 97 }, 'd': { 'dir': 'right', 'code': 100 } }
 *
 * _.keyBy(array, 'dir');
 * // => { 'left': { 'dir': 'left', 'code': 97 }, 'right': { 'dir': 'right', 'code': 100 } }
 */ var $24fe1f7ac78dbb37$var$keyBy = $f2sQe(function(result, value, key) {
    $3pSMu(result, key, value);
});
module.exports = $24fe1f7ac78dbb37$var$keyBy;

});

parcelRegister("ddvJX", function(module, exports) {

$parcel$export(module.exports, "fireManualOperationalAnalytics", () => $95f367cfb169c39f$export$a9301d18019c11f9);
$parcel$export(module.exports, "fireErrorAnalyticsForRefreshCountFailure", () => $95f367cfb169c39f$export$b5e2038970f91d6c);
$parcel$export(module.exports, "updateIssueCountForQueues", () => $95f367cfb169c39f$export$d436cbef77099410);

var $6HC1D = parcelRequire("6HC1D");

var $lzTt0 = parcelRequire("lzTt0");

var $3aUuh = parcelRequire("3aUuh");

var $3G3gn = parcelRequire("3G3gn");

var $hvbu2 = parcelRequire("hvbu2");

var $guiFP = parcelRequire("guiFP");

var $lRmyA = parcelRequire("lRmyA");

var $6rW04 = parcelRequire("6rW04");

var $jMP2a = parcelRequire("jMP2a");

var $3DOEL = parcelRequire("3DOEL");

var $53c4R = parcelRequire("53c4R");

var $5OEre = parcelRequire("5OEre");
const $95f367cfb169c39f$var$ERROR_DB_TIMEOUT = 'error.db-timeout';
const $95f367cfb169c39f$var$ERROR_UNKNOWN = 'error.unknown';
const $95f367cfb169c39f$export$cf85cf6a45b00808 = {
    FAILED: 'failed',
    SUCCESS: 'success',
    PENDING: 'pending'
};
const $95f367cfb169c39f$var$MAX_ISSUECOUNT_THRESHOLD = 1000;
const $95f367cfb169c39f$export$a9301d18019c11f9 = (payload)=>(0, $3DOEL.getAnalyticsWebClient)().getInstance().sendOperationalEvent(payload);
const $95f367cfb169c39f$var$filterOutHiddenQueues = (queues)=>queues.filter((q)=>!(q.canBeHidden === undefined ? false : q.canBeHidden) || q.favourite);
const $95f367cfb169c39f$var$filterOutBadQueues = (queues)=>queues.filter((q)=>!q.shouldSkipIssueCountRefresh);
const $95f367cfb169c39f$var$getIssueCountPerGroup = (issueCounts)=>// eslint-disable-next-line @typescript-eslint/no-explicit-any
    Object.keys(issueCounts).reduce((curr, queueId)=>{
        const res = curr;
        if (issueCounts[Number(queueId)]) {
            if (issueCounts[Number(queueId)].issueCount || issueCounts[Number(queueId)].issueCount === 0) res[Number(queueId)] = issueCounts[Number(queueId)].issueCount;
        }
        return res;
    }, {});
const $95f367cfb169c39f$var$getQueuesPerGroup = (queues, skipHiddenQueues)=>{
    const starredQueues = [];
    const defaultQueues = [];
    let toGroupQueues = queues;
    let hasSkippedQueues = false;
    if (skipHiddenQueues === true) toGroupQueues = $95f367cfb169c39f$var$filterOutHiddenQueues(queues);
    toGroupQueues = $95f367cfb169c39f$var$filterOutBadQueues(toGroupQueues);
    let queueByGroups = {};
    toGroupQueues.forEach((queue)=>{
        if ((0, (/*@__PURE__*/$parcel$interopDefault($lzTt0)))(queue.count) && queue.count > $95f367cfb169c39f$var$MAX_ISSUECOUNT_THRESHOLD) {
            hasSkippedQueues = true;
            return;
        }
        if (queue.favourite) starredQueues.push(queue);
        else defaultQueues.push(queue);
    });
    queueByGroups = {
        starredQueues: starredQueues,
        defaultQueues: defaultQueues
    };
    if (hasSkippedQueues) $95f367cfb169c39f$export$a9301d18019c11f9({
        source: 'refreshQueueIssueCountAction',
        actionSubject: 'queueIssueCountRefresh',
        action: 'skipped'
    });
    return queueByGroups;
};
const $95f367cfb169c39f$var$getQueuesSortByLastRefreshedTime = (queuesBeforeSort)=>{
    let queuesSortByLastRefreshedTime = [];
    const queuesSortByGroup = [
        ...queuesBeforeSort.starredQueues,
        ...queuesBeforeSort.defaultQueues
    ];
    queuesSortByLastRefreshedTime = (0, (/*@__PURE__*/$parcel$interopDefault($3G3gn)))(queuesSortByGroup, [
        'lastRefreshedTime'
    ]);
    return queuesSortByLastRefreshedTime;
};
const $95f367cfb169c39f$export$b5e2038970f91d6c = (error)=>{
    (0, $guiFP.default)({
        meta: {
            id: 'refreshQueueIssueCountAction',
            packageName: 'jiraServicedeskCategorizedQueuesStore',
            teamName: 'jsd-shield'
        },
        error: error
    });
};
const $95f367cfb169c39f$var$isIssueCountAlreadyFetched = (queue)=>queue.count !== undefined;
const $95f367cfb169c39f$var$getSkippedQueues = (issueCounts, queuesMap)=>Object.keys(issueCounts).map((id)=>Number(id)).filter((queueId)=>issueCounts[queueId].result === $95f367cfb169c39f$export$cf85cf6a45b00808.PENDING && !$95f367cfb169c39f$var$isIssueCountAlreadyFetched(queuesMap[queueId]));
const $95f367cfb169c39f$var$fetchIssueCountForQueueGroup = async (projectKey, queueIds)=>(0, $lRmyA.performPostRequest)(`/rest/servicedesk/1/servicedesk/${projectKey}/queues/issue-counts/refresh`, {
        body: JSON.stringify(queueIds)
    });
const $95f367cfb169c39f$var$getQueueGroupData = (queueIds, issueCounts, queuesMap, batchStartProcessingTime)=>{
    const queueRefreshData = {
        minLastRefreshTimeFromCurrentBatch: Number.MAX_VALUE,
        queueCountChanges: 0
    };
    return queueIds.reduce((changes, queueId)=>{
        if (issueCounts[queueId]) {
            if (issueCounts[queueId].issueCount !== undefined || issueCounts[queueId].issueCount === 0) {
                const queue = queuesMap[queueId];
                const currentQueueLastRefreshedTime = queue.lastRefreshedTime !== undefined && queue.lastRefreshedTime !== 0 ? queue.lastRefreshedTime : batchStartProcessingTime;
                const minLastRefreshTimeFromCurrentBatch = Math.min(changes.minLastRefreshTimeFromCurrentBatch, currentQueueLastRefreshedTime);
                const queueCountChanges = queue.count !== issueCounts[queueId].issueCount ? changes.queueCountChanges + 1 : changes.queueCountChanges;
                return {
                    minLastRefreshTimeFromCurrentBatch: minLastRefreshTimeFromCurrentBatch,
                    queueCountChanges: queueCountChanges
                };
            }
        }
        return changes;
    }, queueRefreshData);
};
const $95f367cfb169c39f$var$fetchAndUpdateCount = async (baseUrl, projectKey, queueIds, category, analyticsEvent, // @ts-expect-error - TS1016 - A required parameter cannot follow an optional parameter.
update, batchStartProcessingTime, retryCallback)=>{
    if (queueIds.length === 0) return;
    let maxQueuesPerSd = await (0, $53c4R.getLimit)((0, $53c4R.MAX_QUEUES_PER_SD));
    if (maxQueuesPerSd === null) maxQueuesPerSd = queueIds.length;
    const queueIdsToFetch = queueIds.slice(0, maxQueuesPerSd);
    const startTime = Date.now();
    await $95f367cfb169c39f$var$fetchIssueCountForQueueGroup(projectKey, queueIdsToFetch).then(({ issueCounts: issueCounts })=>{
        update((data)=>{
            const queuesMap = (0, (/*@__PURE__*/$parcel$interopDefault($3aUuh)))((0, $5OEre.getQueuesForCategory)(data, category), 'id');
            const skippedQueues = $95f367cfb169c39f$var$getSkippedQueues(issueCounts, queuesMap);
            if (skippedQueues.length > 0) retryCallback(skippedQueues);
            const endTime = Date.now();
            let queueCountChanges = 0;
            let minLastRefreshTimeFromCurrentBatch = 0;
            let numberOfBadQueues = 0;
            const queueRefreshData = $95f367cfb169c39f$var$getQueueGroupData(queueIds, issueCounts, queuesMap, batchStartProcessingTime);
            queueCountChanges = queueRefreshData.queueCountChanges;
            minLastRefreshTimeFromCurrentBatch = queueRefreshData.minLastRefreshTimeFromCurrentBatch;
            queueIds.forEach((queueId)=>{
                const queue = queuesMap[queueId];
                if (issueCounts[queueId]) {
                    if (issueCounts[queueId].issueCount !== undefined || issueCounts[queueId].issueCount === 0) queuesMap[queueId] = {
                        ...queue,
                        count: issueCounts[queueId].issueCount,
                        lastRefreshedTime: endTime,
                        shouldSkipIssueCountRefresh: false
                    };
                    else if (issueCounts[queueId].errorCode === $95f367cfb169c39f$var$ERROR_DB_TIMEOUT) {
                        numberOfBadQueues += 1;
                        queuesMap[queueId] = {
                            ...queue,
                            shouldSkipIssueCountRefresh: true
                        };
                    }
                }
            });
            if (analyticsEvent) {
                const issueCountPerGroup = $95f367cfb169c39f$var$getIssueCountPerGroup(issueCounts);
                const queueIssueCounts = Object.values(issueCountPerGroup).map((queueCount)=>Number(queueCount));
                const jiraShard = (0, $6rW04.default)('ajs-shard') || '';
                if (queueIssueCounts.length === 0) (0, $jMP2a.fireOperationalAnalytics)(analyticsEvent, 'navigationSession poorPerformanceQueuesCountsInfo', {
                    category: category,
                    queuesRequested: queueIdsToFetch.length,
                    maxQueuesPerSd: maxQueuesPerSd,
                    timeToFetchIssueCount: endTime - startTime,
                    timeSinceBatchStart: endTime - batchStartProcessingTime,
                    jiraShard: jiraShard,
                    browserTabVisibilityState: document.visibilityState,
                    numberOfBadQueues: numberOfBadQueues
                });
                else (0, $jMP2a.fireOperationalAnalytics)(analyticsEvent, 'navigationSession queuesCountsInfo', {
                    category: category,
                    queues: queueIssueCounts.length,
                    queuesRequested: queueIdsToFetch.length,
                    maxQueuesPerSd: maxQueuesPerSd,
                    maxIssueCount: Math.max(...queueIssueCounts),
                    timeToFetchIssueCount: endTime - startTime,
                    timeBetweenQueueRefresh: endTime - minLastRefreshTimeFromCurrentBatch,
                    timeSinceBatchStart: endTime - batchStartProcessingTime,
                    noOfQueuesWithUpdatedCount: queueCountChanges,
                    jiraShard: jiraShard,
                    browserTabVisibilityState: document.visibilityState,
                    numberOfBadQueues: numberOfBadQueues
                });
            }
            return (0, $5OEre.setQueuesForCategory)(data, category, // Object.values is typed as Mixed[] and makes flow unhappy
            (0, (/*@__PURE__*/$parcel$interopDefault($3G3gn)))((0, (/*@__PURE__*/$parcel$interopDefault($hvbu2)))(queuesMap), 'order'));
        });
    }).catch((error)=>{
        $95f367cfb169c39f$export$b5e2038970f91d6c(error);
    });
};
const $95f367cfb169c39f$var$updateLoadingState = (category, queues, update)=>{
    update((data)=>data ? (0, $6HC1D.chain)(data).setIn([
            category,
            'hasRequestedCount'
        ], true).setIn([
            category,
            'isCountLoading'
        ], false).value() : null);
};
const $95f367cfb169c39f$export$d436cbef77099410 = async (baseUrl, projectKey, category, queues, skipHiddenQueues, update, retryCallback, analyticsEvent)=>{
    const queuesPerGroup = $95f367cfb169c39f$var$getQueuesPerGroup(queues, skipHiddenQueues);
    const queuesSortByLastRefreshedTime = $95f367cfb169c39f$var$getQueuesSortByLastRefreshedTime(queuesPerGroup);
    const queueIds = queuesSortByLastRefreshedTime.map((x)=>x.id);
    const batchStartProcessingTime = Date.now();
    try {
        // fetching the result in one call
        await $95f367cfb169c39f$var$fetchAndUpdateCount(baseUrl, projectKey, queueIds, category, analyticsEvent, update, batchStartProcessingTime, retryCallback);
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    } catch (error) {
        $95f367cfb169c39f$var$updateLoadingState(category, queues, update);
        $95f367cfb169c39f$export$b5e2038970f91d6c(error);
        throw error;
    }
    $95f367cfb169c39f$var$updateLoadingState(category, queues, update);
};

});
parcelRegister("lzTt0", function(module, exports) {

var $2OY5s = parcelRequire("2OY5s");

var $hYEMs = parcelRequire("hYEMs");
/** `Object#toString` result references. */ var $fb57e46e5749abd1$var$numberTag = '[object Number]';
/**
 * Checks if `value` is classified as a `Number` primitive or object.
 *
 * **Note:** To exclude `Infinity`, `-Infinity`, and `NaN`, which are
 * classified as numbers, use the `_.isFinite` method.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a number, else `false`.
 * @example
 *
 * _.isNumber(3);
 * // => true
 *
 * _.isNumber(Number.MIN_VALUE);
 * // => true
 *
 * _.isNumber(Infinity);
 * // => true
 *
 * _.isNumber('3');
 * // => false
 */ function $fb57e46e5749abd1$var$isNumber(value) {
    return typeof value == 'number' || $hYEMs(value) && $2OY5s(value) == $fb57e46e5749abd1$var$numberTag;
}
module.exports = $fb57e46e5749abd1$var$isNumber;

});

parcelRegister("53c4R", function(module, exports) {

$parcel$export(module.exports, "MAX_AUTOMATION_RULES_PER_SD", () => $d0467ae3b0b1cf99$export$dca2c2105b681490);
$parcel$export(module.exports, "MAX_AUTOMATION_BRANCHES_PER_RULE", () => $d0467ae3b0b1cf99$export$a48ac34d39e0fc22);
$parcel$export(module.exports, "MAX_QUEUES_PER_SD", () => $d0467ae3b0b1cf99$export$2e0ba662d5bb7742);
$parcel$export(module.exports, "MAX_SLA_GOALS_PER_SD", () => $d0467ae3b0b1cf99$export$eb69982aa3a172b4);
$parcel$export(module.exports, "MAX_CMDB_OBJECTS_PER_FIELD", () => $d0467ae3b0b1cf99$export$cb3888a8c43147d2);
$parcel$export(module.exports, "MAX_NUM_TEAM_PRIORITY_QUEUES_PER_SD", () => $d0467ae3b0b1cf99$export$801a603585fb94d8);
$parcel$export(module.exports, "LIMIT_DEFAULTS", () => $d0467ae3b0b1cf99$export$5ed1d2ac050e39d);
$parcel$export(module.exports, "getLimit", () => $d0467ae3b0b1cf99$export$fb8ce379717a383d);
$parcel$export(module.exports, "LimitData", () => $d0467ae3b0b1cf99$export$9989835030ecd317);
$parcel$export(module.exports, "withLimitData", () => $d0467ae3b0b1cf99$export$c5d8aa8a650e690f);

var $eUqFw = parcelRequire("eUqFw");

var $gUUjF = parcelRequire("gUUjF");

var $2OdyW = parcelRequire("2OdyW");
const $d0467ae3b0b1cf99$export$dca2c2105b681490 = 'max_automation_rules_per_sd';
const $d0467ae3b0b1cf99$export$a48ac34d39e0fc22 = 'max_automation_branches_per_rule';
const $d0467ae3b0b1cf99$export$2e0ba662d5bb7742 = 'max_queues_per_sd';
const $d0467ae3b0b1cf99$export$eb69982aa3a172b4 = 'max_sla_goals_per_sd';
const $d0467ae3b0b1cf99$export$cb3888a8c43147d2 = 'max_cmdb_objects_per_field';
const $d0467ae3b0b1cf99$export$801a603585fb94d8 = 'max_num_team_priority_queues_per_sd';
const $d0467ae3b0b1cf99$export$5ed1d2ac050e39d = {
    [$d0467ae3b0b1cf99$export$dca2c2105b681490]: 30,
    [$d0467ae3b0b1cf99$export$a48ac34d39e0fc22]: 30,
    [$d0467ae3b0b1cf99$export$2e0ba662d5bb7742]: 300,
    [$d0467ae3b0b1cf99$export$eb69982aa3a172b4]: 30,
    [$d0467ae3b0b1cf99$export$cb3888a8c43147d2]: 20,
    [$d0467ae3b0b1cf99$export$801a603585fb94d8]: 50
};
// eslint-disable-next-line @typescript-eslint/consistent-type-assertions
const $d0467ae3b0b1cf99$var$limitCache = {};
const $d0467ae3b0b1cf99$export$c419786abd6faaad = (limitProperty)=>{
    delete $d0467ae3b0b1cf99$var$limitCache[limitProperty];
};
const $d0467ae3b0b1cf99$export$fb8ce379717a383d = (limitProperty)=>{
    if (!$d0467ae3b0b1cf99$var$limitCache[limitProperty]) $d0467ae3b0b1cf99$var$limitCache[limitProperty] = (0, $2OdyW.default)(`/rest/servicedesk/latest/limit/${limitProperty}?_=${Date.now()}`).then(({ limit: limit })=>limit, (error)=>{
        // Will allow us to try again to fetch limit
        $d0467ae3b0b1cf99$export$c419786abd6faaad(limitProperty);
        (0, $gUUjF.default).safeWarnWithoutCustomerData('servicedesk.common.view.components.limit-data', `Failed to fetch limit for ${limitProperty}`);
        throw error;
    });
    return $d0467ae3b0b1cf99$var$limitCache[limitProperty];
};
class $d0467ae3b0b1cf99$export$9989835030ecd317 extends (0, $eUqFw.Component) {
    componentDidMount() {
        const { limitProperty: limitProperty } = this.props;
        const defaultLimit = $d0467ae3b0b1cf99$export$5ed1d2ac050e39d[limitProperty];
        $d0467ae3b0b1cf99$export$fb8ce379717a383d(limitProperty).then((limit)=>{
            this.updateLimit(limit || defaultLimit);
        }).catch(()=>{
            this.updateLimit(defaultLimit);
        });
    }
    updateLimit(newLimit) {
        this.setState(({ limit: oldLimit })=>oldLimit !== newLimit ? {
                limit: newLimit
            } : undefined);
    }
    render() {
        return this.props.children(this.state.limit);
    }
    constructor(...args){
        super(...args);
        this.state = {
            // Current consumers of LimitData expect typeof number so this cannot be an empty value.
            // This also voids limit messages showing until we have a reliable limit,
            // instead of showing then changing the value
            limit: Infinity
        };
    }
}
const $d0467ae3b0b1cf99$export$c5d8aa8a650e690f = (limitProperty, WrappedComponent)=>(props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($d0467ae3b0b1cf99$export$9989835030ecd317, {
            limitProperty: limitProperty
        }, (limit)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(WrappedComponent, {
                limit: limit,
                ...props
            }));

});



parcelRegister("kG021", function(module, exports) {

$parcel$export(module.exports, "addItem", () => $6679463effac295c$export$fb9705de59d96855);
$parcel$export(module.exports, "deleteItem", () => $6679463effac295c$export$8d8542dbbc23fe1a);
$parcel$export(module.exports, "editItem", () => $6679463effac295c$export$60832f4899fbf6a1);
$parcel$export(module.exports, "editItems", () => $6679463effac295c$export$8c896bccb18e1db1);
$parcel$export(module.exports, "moveItem", () => $6679463effac295c$export$ec937e64de6c1257);
$parcel$export(module.exports, "moveItemBelow", () => $6679463effac295c$export$17c7ebc966cf5476);
$parcel$export(module.exports, "moveItemAbove", () => $6679463effac295c$export$d54386016cadff45);
$parcel$export(module.exports, "moveToTop", () => $6679463effac295c$export$f2c5cc4c3f787c3e);
$parcel$export(module.exports, "enableSelectedQueuesVisibility", () => $6679463effac295c$export$ce58537552972d29);

var $k61d1 = parcelRequire("k61d1");
const $6679463effac295c$export$fb9705de59d96855 = (source, item)=>[
        ...source,
        item
    ];
const $6679463effac295c$export$8d8542dbbc23fe1a = (source, id)=>{
    const result = source.slice();
    const index = (0, (/*@__PURE__*/$parcel$interopDefault($k61d1)))(result, {
        id: Number(id)
    });
    if (index >= 0) result.splice(index, 1);
    return result;
};
const $6679463effac295c$export$60832f4899fbf6a1 = (source, updatedItem)=>{
    const result = source.slice();
    const index = (0, (/*@__PURE__*/$parcel$interopDefault($k61d1)))(result, {
        id: updatedItem.id
    });
    if (index >= 0) result[index] = {
        ...result[index],
        ...updatedItem
    };
    return result;
};
const $6679463effac295c$export$8c896bccb18e1db1 = (source, updatedItems)=>{
    const result = source.slice();
    updatedItems.forEach((item)=>{
        const index = (0, (/*@__PURE__*/$parcel$interopDefault($k61d1)))(result, {
            id: item.id
        });
        if (index >= 0) result[index] = {
            ...result[index],
            ...item
        };
    });
    return result;
};
const $6679463effac295c$export$ec937e64de6c1257 = (source, from, to)=>{
    const result = source.slice();
    const item = result[from];
    if (from !== to && from >= 0) {
        result.splice(from, 1);
        result.splice(to, 0, item);
    }
    return result.map((page, order)=>({
            ...page,
            order: order
        }));
};
const $6679463effac295c$export$17c7ebc966cf5476 = (source, sourceId, targetId)=>{
    const result = source.slice();
    if (sourceId !== targetId) {
        const sourceIndex = (0, (/*@__PURE__*/$parcel$interopDefault($k61d1)))(result, {
            id: sourceId
        });
        if (sourceIndex >= 0) {
            const sourceQueue = result[sourceIndex];
            result.splice(sourceIndex, 1);
            const targetIndex = (0, (/*@__PURE__*/$parcel$interopDefault($k61d1)))(result, {
                id: targetId
            });
            if (targetIndex >= 0) {
                result.splice(targetIndex + 1, 0, sourceQueue);
                return result.map((page, order)=>({
                        ...page,
                        order: order
                    }));
            }
        }
    }
    return source;
};
const $6679463effac295c$export$d54386016cadff45 = (source, sourceId, targetId)=>{
    const result = source.slice();
    if (sourceId !== targetId) {
        const sourceIndex = (0, (/*@__PURE__*/$parcel$interopDefault($k61d1)))(result, {
            id: sourceId
        });
        if (sourceIndex >= 0) {
            const sourceQueue = result[sourceIndex];
            result.splice(sourceIndex, 1);
            const targetIndex = (0, (/*@__PURE__*/$parcel$interopDefault($k61d1)))(result, {
                id: targetId
            });
            if (targetIndex >= 0) {
                result.splice(targetIndex, 0, sourceQueue);
                return result.map((page, order)=>({
                        ...page,
                        order: order
                    }));
            }
        }
    }
    return source;
};
const $6679463effac295c$export$f2c5cc4c3f787c3e = (source, sourceId)=>{
    const result = source.slice();
    if (result.length === 0) return source;
    const index = (0, (/*@__PURE__*/$parcel$interopDefault($k61d1)))(result, {
        id: sourceId
    });
    if (index > 0) {
        const sourceQueue = result[index];
        result.splice(index, 1);
        result.splice(0, 0, sourceQueue);
        return result.map((page, order)=>({
                ...page,
                order: order
            }));
    }
    return source;
};
const $6679463effac295c$export$ce58537552972d29 = (selectedQueueIds, queues)=>queues.map((queue)=>{
        if (selectedQueueIds.some((selectedQueueId)=>selectedQueueId === queue.id)) {
            if (!queue.canBeHidden) return queue;
            return {
                ...queue,
                canBeHidden: false
            };
        }
        if (queue.canBeHidden) return queue;
        return {
            ...queue,
            canBeHidden: true
        };
    });

});
parcelRegister("k61d1", function(module, exports) {

var $9mB9u = parcelRequire("9mB9u");

var $7qARj = parcelRequire("7qARj");

var $hNahz = parcelRequire("hNahz");
/* Built-in method references for those with the same name as other `lodash` methods. */ var $ea154e499f779271$var$nativeMax = Math.max;
/**
 * This method is like `_.find` except that it returns the index of the first
 * element `predicate` returns truthy for instead of the element itself.
 *
 * @static
 * @memberOf _
 * @since 1.1.0
 * @category Array
 * @param {Array} array The array to inspect.
 * @param {Function} [predicate=_.identity] The function invoked per iteration.
 * @param {number} [fromIndex=0] The index to search from.
 * @returns {number} Returns the index of the found element, else `-1`.
 * @example
 *
 * var users = [
 *   { 'user': 'barney',  'active': false },
 *   { 'user': 'fred',    'active': false },
 *   { 'user': 'pebbles', 'active': true }
 * ];
 *
 * _.findIndex(users, function(o) { return o.user == 'barney'; });
 * // => 0
 *
 * // The `_.matches` iteratee shorthand.
 * _.findIndex(users, { 'user': 'fred', 'active': false });
 * // => 1
 *
 * // The `_.matchesProperty` iteratee shorthand.
 * _.findIndex(users, ['active', false]);
 * // => 0
 *
 * // The `_.property` iteratee shorthand.
 * _.findIndex(users, 'active');
 * // => 2
 */ function $ea154e499f779271$var$findIndex(array, predicate, fromIndex) {
    var length = array == null ? 0 : array.length;
    if (!length) return -1;
    var index = fromIndex == null ? 0 : $hNahz(fromIndex);
    if (index < 0) index = $ea154e499f779271$var$nativeMax(length + index, 0);
    return $9mB9u(array, $7qARj(predicate, 3), index);
}
module.exports = $ea154e499f779271$var$findIndex;

});






parcelRegister("f5prk", function(module, exports) {

$parcel$export(module.exports, "default", () => $92ebb2dbbec2e6e0$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $3JafE = parcelRequire("3JafE");

var $lB25E = parcelRequire("lB25E");
parcelRequire("8jBvP");

var $2bMHt = parcelRequire("2bMHt");
/* Intended usage is to replace direct usage of history.push from react-dom-router with a Jira SPA compatible push history */ const $92ebb2dbbec2e6e0$var$QueuesPushProvider = (props)=>{
    const { projectKey: projectKey, children: children } = props;
    const { push: push, replace: replace } = (0, $lB25E.useRouterActions)();
    const pushWithSpaCompatibleUrl = (0, $eUqFw.useCallback)((path)=>{
        const pathWithLeadingSlash = path.charAt(0) === '/' ? `${path}` : `/${path}`;
        let fullPath = pathWithLeadingSlash;
        // Don't update the url if it is already in the right format
        if (pathWithLeadingSlash.indexOf('/jira/servicedesk/projects') !== 0) fullPath = `/jira/servicedesk/projects/${projectKey}${pathWithLeadingSlash}`;
        push(fullPath);
        // Some existing consumers in queues expect this to return an observable
        return (0, $3JafE.Observable).empty();
    }, [
        projectKey,
        push
    ]);
    const navigateWithProjectKey = (0, $eUqFw.useCallback)((path)=>(0, $2bMHt.navigate)(projectKey, path), [
        projectKey
    ]);
    if (!projectKey) return children({
        push: undefined
    });
    return __SPA__ ? children({
        push: pushWithSpaCompatibleUrl,
        replace: replace
    }) : children({
        push: navigateWithProjectKey
    });
};
var $92ebb2dbbec2e6e0$export$2e2bcd8739ae039 = $92ebb2dbbec2e6e0$var$QueuesPushProvider;

});

parcelRegister("2d7Sj", function(module, exports) {

$parcel$export(module.exports, "PageTitle", () => $0653f34646647329$export$155581e8dc02007a);
$parcel$export(module.exports, "ServiceDeskDocumentTitle", () => $0653f34646647329$export$c7841d2c1c13065e);

var $eUqFw = parcelRequire("eUqFw");

var $knPb9 = parcelRequire("knPb9");

var $1ybV0 = parcelRequire("1ybV0");

var $heNSb = parcelRequire("heNSb");

var $giAhk = parcelRequire("giAhk");

var $f9Osc = parcelRequire("f9Osc");
const $0653f34646647329$export$155581e8dc02007a = (props)=>{
    const { DocumentTitle: DocumentTitle, section: section, intl: { formatMessage: formatMessage }, projectName: projectName, subsection: subsection } = props;
    // @ts-expect-error - TS7053 - Element implicitly has an 'any' type because expression of type 'string' can't be used to index type '{ proformaForms: MessageDescriptorV2; chat: MessageDescriptorV2; incidentManagementSettings: MessageDescriptorV2; ... 32 more ...; serviceProject: MessageDescriptorV2; }'.
    const titleOld = `${projectName} - ${formatMessage((0, $f9Osc.default)[section])} - ${formatMessage((0, $f9Osc.default).serviceProject)}`;
    const titleNew = subsection ? // @ts-expect-error - TS7053 - Element implicitly has an 'any' type because expression of type 'string' can't be used to index type '{ proformaForms: MessageDescriptorV2; chat: MessageDescriptorV2; incidentManagementSettings: MessageDescriptorV2; ... 32 more ...; serviceProject: MessageDescriptorV2; }'.
    `${projectName} - ${formatMessage((0, $f9Osc.default)[section])} - ${subsection} - ${formatMessage((0, $f9Osc.default).serviceProject)}` : // @ts-expect-error - TS7053 - Element implicitly has an 'any' type because expression of type 'string' can't be used to index type '{ proformaForms: MessageDescriptorV2; chat: MessageDescriptorV2; incidentManagementSettings: MessageDescriptorV2; ... 32 more ...; serviceProject: MessageDescriptorV2; }'.
    `${projectName} - ${formatMessage((0, $f9Osc.default)[section])} - ${formatMessage((0, $f9Osc.default).serviceProject)}`;
    const title = (0, $1ybV0.ff)('a11y-fission-queues-related-issues_giuuk') ? titleNew : titleOld;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(DocumentTitle, {
        title: title
    });
};
const $0653f34646647329$var$InjectedPage = (0, $knPb9.default)($0653f34646647329$export$155581e8dc02007a, {
    DocumentTitle: (0, $heNSb.DocumentTitle)
});
const $0653f34646647329$export$c7841d2c1c13065e = (0, $giAhk.injectIntlV2)($0653f34646647329$var$InjectedPage);
var $0653f34646647329$export$2e2bcd8739ae039 = $0653f34646647329$export$c7841d2c1c13065e;

});
parcelRegister("heNSb", function(module, exports) {

$parcel$export(module.exports, "DocumentTitle", () => $44af95caa6ad02db$export$dd5ad0b65cf665da);

var $eUqFw = parcelRequire("eUqFw");

var $1TtYL = parcelRequire("1TtYL");

var $3fq1f = parcelRequire("3fq1f");
class $44af95caa6ad02db$export$dd5ad0b65cf665da extends (0, $eUqFw.Component) {
    static{
        this.defaultProps = {
            TitleSubscriber: (0, $1TtYL.DocumentTitleSubscriber)
        };
    }
    shouldComponentUpdate(nextProps) {
        return nextProps.title !== this.props.title;
    }
    render() {
        const { title: title, TitleSubscriber: TitleSubscriber } = this.props;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(TitleSubscriber, null, ({ contextArray: contextArray }, { setTitle: setTitle, addDocumentTitle: addDocumentTitle, removeDocumentTitle: removeDocumentTitle })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $1TtYL.DocumentTitleHelper), {
                title: title,
                setTitle: setTitle,
                addDocumentTitle: addDocumentTitle,
                contextArray: contextArray,
                removeDocumentTitle: removeDocumentTitle,
                TitleSubscriber: TitleSubscriber
            }));
    }
}

});

parcelRegister("f9Osc", function(module, exports) {

$parcel$export(module.exports, "default", () => $7be746c19c254767$export$2e2bcd8739ae039);

var $90IgZ = parcelRequire("90IgZ");
var $7be746c19c254767$export$2e2bcd8739ae039 = (0, $90IgZ.defineMessages)({
    atlassianAnalytics: {
        "id": "servicedesk-spa-commons.common.utils.document-title.atlassian-analytics",
        "defaultMessage": "Atlassian Analytics"
    },
    serviceProject: {
        "id": "servicedesk-spa-commons.common.utils.document-title.service-project",
        "defaultMessage": "Service project"
    },
    knowledge: {
        "id": "servicedesk-spa-commons.common.utils.document-title.knowledge",
        "defaultMessage": "Knowledge base"
    },
    itsmFeatures: {
        "id": "servicedesk-spa-commons.common.utils.document-title.itsm-features",
        "defaultMessage": "Features"
    },
    queues: {
        "id": "servicedesk-spa-commons.common.utils.document-title.queues",
        "defaultMessage": "Queues"
    },
    customers: {
        "id": "servicedesk-spa-commons.common.utils.document-title.customers",
        "defaultMessage": "Customers"
    },
    organizations: {
        "id": "servicedesk-spa-commons.common.utils.document-title.organizations",
        "defaultMessage": "Organizations"
    },
    customerServiceEscalations: {
        "id": "servicedesk-spa-commons.common.utils.document-title.customer-service-escalations",
        "defaultMessage": "Developer escalations"
    },
    reports: {
        "id": "servicedesk-spa-commons.common.utils.document-title.reports",
        "defaultMessage": "Reports"
    },
    services: {
        "id": "servicedesk-spa-commons.common.utils.document-title.services",
        "defaultMessage": "Services"
    },
    oncall: {
        "id": "servicedesk-spa-commons.common.utils.document-title.oncall",
        "defaultMessage": "On-call"
    },
    email: {
        "id": "servicedesk-spa-commons.common.utils.document-title.email",
        "defaultMessage": "Email request"
    },
    sla: {
        "id": "servicedesk-spa-commons.common.utils.document-title.sla",
        "defaultMessage": "Service level agreements"
    },
    csat: {
        "id": "servicedesk-spa-commons.common.utils.document-title.csat",
        "defaultMessage": "Customer satisfaction"
    },
    details: {
        "id": "servicedesk-spa-commons.common.utils.document-title.details",
        "defaultMessage": "Details"
    },
    portal: {
        "id": "servicedesk-spa-commons.common.utils.document-title.portal",
        "defaultMessage": "Customer portal"
    },
    externalLinks: {
        "id": "servicedesk-spa-commons.common.utils.document-title.external-links",
        "defaultMessage": "Links"
    },
    portalSettings: {
        "id": "servicedesk-spa-commons.common.utils.document-title.portal-settings",
        "defaultMessage": "Portal settings"
    },
    automation: {
        "id": "servicedesk-spa-commons.common.utils.document-title.automation",
        "defaultMessage": "Automation"
    },
    advanced: {
        "id": "servicedesk-spa-commons.common.utils.document-title.advanced",
        "defaultMessage": "Advanced"
    },
    languageSupport: {
        "id": "servicedesk-spa-commons.common.utils.document-title.language-support",
        "defaultMessage": "Language support"
    },
    languageTranslations: {
        "id": "servicedesk-spa-commons.common.utils.document-title.language-translations",
        "defaultMessage": "Language translations"
    },
    notificationEmail: {
        "id": "servicedesk-spa-commons.common.utils.document-title.notification-email",
        "defaultMessage": "Notification email"
    },
    notifications: {
        "id": "servicedesk-spa-commons.common.utils.document-title.notifications",
        "defaultMessage": "Notifications"
    },
    internalNotifications: {
        "id": "servicedesk-spa-commons.common.utils.document-title.internal-notifications",
        "defaultMessage": "Internal notifications"
    },
    customerNotifications: {
        "id": "servicedesk-spa-commons.common.utils.document-title.customer-notifications",
        "defaultMessage": "Customer notifications"
    },
    widget: {
        "id": "servicedesk-spa-commons.common.utils.document-title.widget",
        "defaultMessage": "Widget"
    },
    customerPermissions: {
        "id": "servicedesk-spa-commons.common.utils.document-title.customer-permissions",
        "defaultMessage": "Customer permissions"
    },
    people: {
        "id": "servicedesk-spa-commons.common.utils.document-title.people",
        "defaultMessage": "Internal access"
    },
    issueType: {
        "id": "servicedesk-spa-commons.common.utils.document-title.issue-type",
        "defaultMessage": "Request types"
    },
    connectAppControls: {
        "id": "servicedesk-spa-commons.common.utils.document-title.connect-app-controls",
        "defaultMessage": "Apps"
    },
    features: {
        "id": "servicedesk-spa-commons.common.utils.document-title.features",
        "defaultMessage": "Features"
    },
    calendar: {
        "id": "servicedesk-spa-commons.common.utils.document-title.calendar",
        "defaultMessage": "Calendar"
    },
    changeCalendar: {
        "id": "servicedesk-spa-commons.common.utils.document-title.change-calendar",
        "defaultMessage": "Change calendar"
    },
    changeManagementSettings: {
        "id": "servicedesk-spa-commons.common.utils.document-title.change-management-settings",
        "defaultMessage": "Change management"
    },
    incidentManagementSettings: {
        "id": "servicedesk-spa-commons.common.utils.document-title.incident-management-settings",
        "defaultMessage": "Incident management"
    },
    virtualAgentConversations: {
        "id": "servicedesk-spa-commons.common.utils.document-title.virtual-agent-conversations",
        "defaultMessage": "Conversations"
    },
    virtualAgentIntents: {
        "id": "servicedesk-spa-commons.common.utils.document-title.virtual-agent-intents",
        "defaultMessage": "Intents"
    },
    virtualAgentStandardFlows: {
        "id": "servicedesk-spa-commons.common.utils.document-title.virtual-agent-standard-flows",
        "defaultMessage": "Standard flows"
    },
    virtualAgentSettings: {
        "id": "servicedesk-spa-commons.common.utils.document-title.virtual-agent-settings",
        "defaultMessage": "Settings"
    },
    virtualAgentLanding: {
        "id": "servicedesk-spa-commons.common.utils.document-title.virtual-agent-landing",
        "defaultMessage": "Virtual agent"
    },
    chat: {
        "id": "servicedesk-spa-commons.common.utils.document-title.chat",
        "defaultMessage": "Chat"
    },
    proformaForms: {
        "id": "servicedesk-spa-commons.common.utils.document-title.proforma-forms",
        "defaultMessage": "Forms"
    },
    playbooks: {
        "id": "servicedesk-spa-commons.common.utils.document-title.playbooks-non-final",
        "defaultMessage": "Playbooks"
    },
    dataClassifications: {
        "id": "servicedesk-spa-commons.common.utils.document-title.data-classifications",
        "defaultMessage": "Data classification"
    },
    // EAX-256 - Finalise this string
    fieldsNonFinal: {
        "id": "servicedesk-spa-commons.common.utils.document-title.fields-non-final",
        "defaultMessage": "Fields"
    },
    workflowScheme: {
        "id": "servicedesk-spa-commons.common.utils.document-title.workflow-scheme",
        "defaultMessage": "Workflows"
    }
});

});


parcelRegister("dVAlv", function(module, exports) {

$parcel$export(module.exports, "SpaPageWrapper", () => $33637cae863dc9b4$export$577514961fbf4842);
// eslint-disable-next-line @typescript-eslint/no-unused-vars

var $eUqFw = parcelRequire("eUqFw");

var $ae4LH = parcelRequire("ae4LH");

var $gUUjF = parcelRequire("gUUjF");

var $knPb9 = parcelRequire("knPb9");

var $fO5rB = parcelRequire("fO5rB");

var $bhwgQ = parcelRequire("bhwgQ");

var $1IzB8 = parcelRequire("1IzB8");

var $2Ba2b = parcelRequire("2Ba2b");
const $33637cae863dc9b4$export$91f88695e0d311a5 = (props)=>{
    const { projectContext: projectContext, isLoading: isLoading, error: error, children: children, AccessCheck: AccessCheck, AuthenticationCheck: AuthenticationCheck, ProjectNotFound: ProjectNotFound, GenericError: GenericError, SubProductUpdater: SubProductUpdater } = props;
    if (isLoading) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $ae4LH.default), null);
    if (error) {
        (0, $gUUjF.default).safeErrorWithoutCustomerData('jsdspa-page-wrapper', 'rendering-error-page', error);
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(AuthenticationCheck, null, error.statusCode === 404 ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(ProjectNotFound, null) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(GenericError, null));
    }
    if (projectContext) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(SubProductUpdater, {
        subProduct: "serviceDesk"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(AuthenticationCheck, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(AccessCheck, null, children)));
    return null;
};
const $33637cae863dc9b4$export$577514961fbf4842 = (0, $knPb9.default)($33637cae863dc9b4$export$91f88695e0d311a5, {
    AccessCheck: (0, $1IzB8.default),
    GenericError: (0, $2Ba2b.GenericError),
    ProjectNotFound: (0, $2Ba2b.ProjectNotFound),
    AuthenticationCheck: (0, $bhwgQ.AuthenticationCheck),
    SubProductUpdater: (0, $fO5rB.SubProductUpdater)
});
var $33637cae863dc9b4$export$2e2bcd8739ae039 = $33637cae863dc9b4$export$577514961fbf4842;

});
parcelRegister("fO5rB", function(module, exports) {

$parcel$export(module.exports, "SubProductUpdater", () => $0dcc4693f2e4993e$export$eb40d3df56aa5c53);

var $eUqFw = parcelRequire("eUqFw");

var $3viaK = parcelRequire("3viaK");

var $cOnuN = parcelRequire("cOnuN");

var $6QL9v = parcelRequire("6QL9v");

var $kxBN8 = parcelRequire("kxBN8");

var $2SV7r = parcelRequire("2SV7r");
const $0dcc4693f2e4993e$export$eb40d3df56aa5c53 = ({ allowMonolithDeferral: allowMonolithDeferral = false, ...props })=>{
    const subProduct = (0, $2SV7r.isSubProductProps)(props) ? props.subProduct : (0, $6QL9v.getSubProductFromProjectType)(props.projectType);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $3viaK.default), {
        op: (0, $kxBN8.default),
        args: [
            subProduct,
            allowMonolithDeferral
        ]
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $cOnuN.default), {
        subProduct: subProduct
    }));
};

});
parcelRegister("cOnuN", function(module, exports) {

$parcel$export(module.exports, "default", () => $b3e22c81c3ebeab6$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $lgxha = parcelRequire("lgxha");

var $j5W2t = parcelRequire("j5W2t");
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$b3e22c81c3ebeab6$export$2e2bcd8739ae039 = ({ subProduct: subProduct })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $lgxha.default), {
        op: (0, $j5W2t.default),
        args: [
            subProduct
        ]
    });

});
parcelRegister("j5W2t", function(module, exports) {

$parcel$export(module.exports, "default", () => $8613fa53f568085a$export$2e2bcd8739ae039);

var $gUUjF = parcelRequire("gUUjF");

var $lRmyA = parcelRequire("lRmyA");
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$8613fa53f568085a$export$2e2bcd8739ae039 = (subProduct)=>{
    (0, $lRmyA.performGetRequest)(`/rest/internal/2/mauTag/${subProduct}`).catch((err)=>{
        (0, $gUUjF.default).safeErrorWithoutCustomerData('common.tag-mau.tag-mau-event', 'Error connecting to monolith mau tag endpoint', err);
    });
};

});


parcelRegister("6QL9v", function(module, exports) {

$parcel$export(module.exports, "getSubProductFromProjectType", () => $c2784746c0813b99$export$b1fe420ed15dff7b);

var $1ybV0 = parcelRequire("1ybV0");

var $dWlsy = parcelRequire("dWlsy");
const $c2784746c0813b99$export$b1fe420ed15dff7b = (projectType)=>{
    // for Analytics only 'product_discovery' is mapped to 'polaris'. In other cases it is mapped to 'software'
    if ((0, $1ybV0.ff)('polaris-detect-subproduct-for-jpd-by-project-type_8jxfy', false)) {
        if (projectType === 'product_discovery') return 'polaris';
        return (0, $dWlsy.subProductFromProjectType)(projectType);
    }
    return (0, $dWlsy.subProductFromProjectType)(projectType);
};

});

parcelRegister("kxBN8", function(module, exports) {

$parcel$export(module.exports, "default", () => $95a7ec92a66826ce$export$2e2bcd8739ae039);
// eslint-disable-next-line jira/wrm/no-load-bridge

var $2BvS3 = parcelRequire("2BvS3");
var $ds5Im = parcelRequire("ds5Im");
var $4DtuZ = parcelRequire("4DtuZ");


var $gUUjF = parcelRequire("gUUjF");

var $3FyZ4 = parcelRequire("3FyZ4");
const $95a7ec92a66826ce$var$maybeDelayAndRace = (// @ts-expect-error - TS2304 - Cannot find name 'Deferred'.
maybeWaitPromise, getDefaultPromise, getRacePromise)=>maybeWaitPromise ? Promise.race([
        maybeWaitPromise.then(getDefaultPromise),
        getRacePromise()
    ]) : getDefaultPromise();
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$95a7ec92a66826ce$export$2e2bcd8739ae039 = async (subProduct, allowMonolithDeferral)=>{
    (0, $3FyZ4.getAnalyticsWebClientPromise)().then((client)=>{
        client.setSubProduct(subProduct);
        if (subProduct === 'serviceDesk') client.setUIViewedAttributes({
            solutions: [
                (0, $96da08ab2c7a3243$export$c8b406ad8ee0dab9)
            ]
        });
        else client.removeUIViewedAttribute('solutions');
    });
    // IMPORTANT -
    // Until such time as all pre-TTI WRM loads are removed we find that waitForHeritage() then
    // loadBridgeStrict() is too slow, resulting in `subproduct:unknown` for analytics events.
    // In that same case however, profiling shows us that polling in loadBridgeWeak() somehow
    // resolves the same AMD code faster.
    // This is not well understood, but it does allow us to work around the issue by racing these
    // two techniques.
    // Once there is no pre-TTI WRM loads we the waitForHeritage() then loadBridgeStrict() does seem
    // to be faster such that we can remove the `Promise.race()`.
    /* eslint-disable jira/wrm/no-load-bridge */ $95a7ec92a66826ce$var$maybeDelayAndRace(allowMonolithDeferral ? (0, $4DtuZ.waitForHeritage)() : null, ()=>(0, $2BvS3.loadBridgeStrict)({
            name: 'jira/analytics/sub-product-resolver',
            wrmKeys: [
                'wrc!com.atlassian.jira.jira-client-analytics-plugin:analytics-web-client'
            ]
        }), ()=>(0, $ds5Im.loadBridgeWeak)({
            name: 'jira/analytics/sub-product-resolver'
        })).then((subProductResolver)=>{
        subProductResolver.setSubProduct(subProduct);
    }).catch((e)=>(0, $gUUjF.default).safeErrorWithoutCustomerData('common.analytics-sub-product.sub-product-updater', 'Error connecting to monolith sub product resolver', e));
/* eslint-enable jira/wrm/no-load-bridge */ };

});
const $96da08ab2c7a3243$export$c8b406ad8ee0dab9 = 'jiraServiceManagement';


parcelRegister("2SV7r", function(module, exports) {

$parcel$export(module.exports, "isSubProductProps", () => $5e5ef73a1d4e492a$export$c3063d6d7a8c075f);
const $5e5ef73a1d4e492a$export$c3063d6d7a8c075f = (props)=>'subProduct' in props && typeof props.subProduct === 'string';
const $5e5ef73a1d4e492a$export$81da4a7e1ba1dcee = (props)=>'projectType' in props && typeof props.projectType === 'string';

});


parcelRegister("1IzB8", function(module, exports) {

$parcel$export(module.exports, "default", () => $edeca50de0b85084$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $10fdS = parcelRequire("10fdS");


var $bsgfb = parcelRequire("bsgfb");

var $1fuiA = parcelRequire("1fuiA");
const $edeca50de0b85084$var$AccessCheck = ({ children: children })=>{
    const isSettingsRoute = (0, $10fdS.useCurrentRoute)().path.includes(`${(0, $2df94debed157361$export$967ba7bfb5ce30bd)}/:projectKey/settings/`);
    const Gate = isSettingsRoute ? (0, $1fuiA.default) : (0, $bsgfb.default);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(Gate, null, children);
};
var $edeca50de0b85084$export$2e2bcd8739ae039 = $edeca50de0b85084$var$AccessCheck;

});
const $2df94debed157361$export$967ba7bfb5ce30bd = '/jira/servicedesk/projects';

parcelRegister("bsgfb", function(module, exports) {

$parcel$export(module.exports, "default", () => $a7d02215a42a3332$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $lB25E = parcelRequire("lB25E");

var $fz8wa = parcelRequire("fz8wa");

var $11C4f = parcelRequire("11C4f");
const $a7d02215a42a3332$var$ProductAccessCheck = ({ children: children })=>{
    const { hasServiceDeskAccess: hasServiceDeskAccess } = (0, $fz8wa.useApplicationPermissions)();
    const [projectKey = ''] = (0, $lB25E.usePathParam)('projectKey');
    if (projectKey) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $11C4f.default), null, children);
    return hasServiceDeskAccess ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).Fragment, null, children) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $lB25E.Redirect), {
        to: "/jira"
    });
};
var $a7d02215a42a3332$export$2e2bcd8739ae039 = $a7d02215a42a3332$var$ProductAccessCheck;

});
parcelRegister("fz8wa", function(module, exports) {

$parcel$export(module.exports, "ApplicationPermissionsSubscriber", () => $d53bf78e5b3b7ada$export$d8c76f7e52d0a856);
$parcel$export(module.exports, "useApplicationPermissions", () => $d53bf78e5b3b7ada$export$4d9cadb4042acc1b);

var $df4Sl = parcelRequire("df4Sl");

var $2HpOy = parcelRequire("2HpOy");

var $k4yit = parcelRequire("k4yit");

var $gd0Sp = parcelRequire("gd0Sp");
const $d53bf78e5b3b7ada$var$selector = (0, $df4Sl.createSelector)((state)=>state.tenantContext.appPermissions, (applicationPermissions)=>({
        data: {
            applicationPermissions: applicationPermissions
        }
    }));
const $d53bf78e5b3b7ada$export$d8c76f7e52d0a856 = (0, $2HpOy.createSubscriber)((0, $k4yit.default), {
    displayName: 'ApplicationPermissionsSubscriber',
    selector: $d53bf78e5b3b7ada$var$selector
});
const $d53bf78e5b3b7ada$export$4d9cadb4042acc1b = ()=>{
    const tenantContext = (0, $gd0Sp.useTenantContext)();
    return tenantContext && tenantContext.appPermissions;
};

});

parcelRegister("11C4f", function(module, exports) {

$parcel$export(module.exports, "default", () => $a2544b3bfea70255$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $lB25E = parcelRequire("lB25E");

var $jyTef = parcelRequire("jyTef");


var $6tW8V = parcelRequire("6tW8V");
const $a2544b3bfea70255$var$AgentCheck = ({ children: children })=>{
    const [projectKey = ''] = (0, $lB25E.usePathParam)('projectKey');
    const [{ data: data, error: error }] = (0, $jyTef.useServiceDeskContext)();
    if (data || error) {
        // @ts-expect-error - TS2345 - Argument of type 'Error | Record<string, any> | (Error & Record<string, any>) | (Record<string, any> & Error) | null' is not assignable to parameter of type '{ statusCode?: number | undefined; } | null'.
        if (!(0, $6tW8V.isAccessError)(error)) {
            const { userRole: userRole = '' } = data || {};
            if (userRole === 'agent' || userRole === 'agent-project-admin') return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).Fragment, null, children);
            if (error) throw error;
        }
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $lB25E.Redirect), {
            to: `${(0, $2df94debed157361$export$967ba7bfb5ce30bd)}/${projectKey}/issues`
        });
    }
    return null;
};
var $a2544b3bfea70255$export$2e2bcd8739ae039 = $a2544b3bfea70255$var$AgentCheck;

});
parcelRegister("jyTef", function(module, exports) {

$parcel$export(module.exports, "useServiceDeskContext", () => $3f940b317a874b53$export$712ead87353ac687);

var $eUqFw = parcelRequire("eUqFw");

var $iZJHG = parcelRequire("iZJHG");

var $ct0sQ = parcelRequire("ct0sQ");

var $9V785 = parcelRequire("9V785");
const $3f940b317a874b53$var$getServiceDeskContextResource = ()=>(0, $ct0sQ.serviceDeskContextResource);
const $3f940b317a874b53$export$712ead87353ac687 = (projectKey, customContext)=>{
    const { data: data, loading: loading, error: error, refresh: refreshCache } = (0, $iZJHG.useResourceWithCustomRouterContext)($3f940b317a874b53$var$getServiceDeskContextResource(), customContext);
    (0, $eUqFw.useEffect)(()=>{
        if (!false) refreshCache();
    }, [
        projectKey,
        refreshCache
    ]);
    return [
        {
            data: data,
            loading: loading,
            error: error
        }
    ];
};

});
parcelRegister("9V785", function(module, exports) {

$parcel$export(module.exports, "USER_JSM_PROJECT_ROLE", () => $3cdacd90d2ecef12$export$a9054e41660c4d00);
// use USER_JSM_PROJECT_ROLE instead
const $3cdacd90d2ecef12$var$AGENT_ROLE = 'agent';
const $3cdacd90d2ecef12$var$AGENT_PROJECT_ADMIN_ROLE = 'agent-project-admin';
const $3cdacd90d2ecef12$var$JIRA_ROLE = 'jira-user';
const $3cdacd90d2ecef12$export$a9054e41660c4d00 = {
    AGENT_ROLE: $3cdacd90d2ecef12$var$AGENT_ROLE,
    AGENT_PROJECT_ADMIN_ROLE: $3cdacd90d2ecef12$var$AGENT_PROJECT_ADMIN_ROLE,
    JIRA_ROLE: $3cdacd90d2ecef12$var$JIRA_ROLE
};

});


parcelRegister("6tW8V", function(module, exports) {

$parcel$export(module.exports, "isAccessError", () => $5107715f0b974007$export$ddaebe4928e793cb);

const $5107715f0b974007$var$RESTRICTED_ACCESS_CODES = [
    (0, $1c3fbb431a173cc6$export$a3269a3914b007e3),
    (0, $1c3fbb431a173cc6$export$8bca792d963eb0ef),
    (0, $1c3fbb431a173cc6$export$67d19e9a991baa07)
];
const $5107715f0b974007$export$ddaebe4928e793cb = (error)=>error?.statusCode != null ? $5107715f0b974007$var$RESTRICTED_ACCESS_CODES.includes(error.statusCode) : false;

});



parcelRegister("1fuiA", function(module, exports) {

$parcel$export(module.exports, "default", () => $0788b3e6146363c4$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $2Ba2b = parcelRequire("2Ba2b");

var $jyTef = parcelRequire("jyTef");

var $6tW8V = parcelRequire("6tW8V");
const $0788b3e6146363c4$var$SettingsAccessCheck = ({ children: children })=>{
    const [{ data: serviceDeskContext, error: serviceDeskContextError }] = (0, $jyTef.useServiceDeskContext)();
    const userRole = serviceDeskContext?.userRole;
    // @ts-expect-error - TS2345 - Argument of type 'Error | Record<string, any> | (Error & Record<string, any>) | (Record<string, any> & Error) | null' is not assignable to parameter of type '{ statusCode?: number | undefined; } | null'.
    const hasAccessError = (0, $6tW8V.isAccessError)(serviceDeskContextError);
    // Service desk context is updated on every route change
    // If context fails to give us an indicative result (e.g. fetch failed, 500 error)
    // We will continue to use current value to assess permissions
    if (userRole === 'agent-project-admin' && !hasAccessError) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).Fragment, null, children);
    if (userRole !== undefined || hasAccessError) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $2Ba2b.ProjectNotFound), null);
    if (serviceDeskContextError) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $2Ba2b.GenericError), null);
    return null;
};
var $0788b3e6146363c4$export$2e2bcd8739ae039 = $0788b3e6146363c4$var$SettingsAccessCheck;

});
parcelRegister("2Ba2b", function(module, exports) {

$parcel$export(module.exports, "ProjectNotFound", () => $abcdf98f8a718d25$export$849d319c342682a2);
$parcel$export(module.exports, "GenericError", () => $abcdf98f8a718d25$export$7d465be8efa67280);

var $eUqFw = parcelRequire("eUqFw");

var $220ac = parcelRequire("220ac");

var $heNSb = parcelRequire("heNSb");

var $4Es8k = parcelRequire("4Es8k");

var $lQXqy = parcelRequire("lQXqy");

var $7QuzF = parcelRequire("7QuzF");

var $5JgJ2 = parcelRequire("5JgJ2");

var $lB25E = parcelRequire("lB25E");

var $6Yj0X = parcelRequire("6Yj0X");
const $abcdf98f8a718d25$export$849d319c342682a2 = ()=>{
    const { formatMessage: formatMessage } = (0, $5JgJ2.default)();
    const projectsPath = '/jira/projects';
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $heNSb.DocumentTitle), {
        title: formatMessage((0, $6Yj0X.default).notFoundDocumentTitleJsm)
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $220ac.default), {
        renderImage: (0, $4Es8k.getAkEmptyStateRenderImageFn)((0, $7QuzF.default)),
        maxImageWidth: 120,
        header: formatMessage((0, $6Yj0X.default).notFoundTitle),
        description: formatMessage((0, $6Yj0X.default).notFoundDescription),
        primaryAction: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $lB25E.Link), {
            to: projectsPath
        }, formatMessage((0, $6Yj0X.default).notFoundAction))
    }));
};
const $abcdf98f8a718d25$export$7d465be8efa67280 = ()=>{
    const { formatMessage: formatMessage } = (0, $5JgJ2.default)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $heNSb.DocumentTitle), {
        title: formatMessage((0, $6Yj0X.default).genericDocumentTitleJsm)
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $220ac.default), {
        renderImage: (0, $4Es8k.getAkEmptyStateRenderImageFn)((0, $lQXqy.default)),
        maxImageWidth: 120,
        header: formatMessage((0, $6Yj0X.default).genericErrorTitle),
        description: formatMessage((0, $6Yj0X.default).genericErrorDescription)
    }));
};

});
parcelRegister("lQXqy", function(module, exports) {

$parcel$export(module.exports, "default", () => $30559913302f86cb$export$2e2bcd8739ae039);
$parcel$export(module.exports, "viewBox", () => $30559913302f86cb$export$a179c88182cb9d56);
$parcel$export(module.exports, "srcLight", () => (/*@__PURE__*/$parcel$interopDefault((parcelRequire("1cuWo")))));
$parcel$export(module.exports, "srcDark", () => (/*@__PURE__*/$parcel$interopDefault((parcelRequire("48S62")))));
// THIS FILE WAS AUTO-GENERATED. MODIFY WITH CAUTION. See README.md
// brandfolder asset id = m5v37k2r2scm86wgmrk6
// brandfolder url = https://brandfolder.com/atlassian-brand-creative-library/atlassian-public-asset-library/#!asset/m5v37k2r2scm86wgmrk6

var $9TZf5 = parcelRequire("9TZf5");

var $48S62 = parcelRequire("48S62");

var $1cuWo = parcelRequire("1cuWo");
const $30559913302f86cb$var$Illustration = (0, $9TZf5.createIllustration)({
    srcLight: (/*@__PURE__*/$parcel$interopDefault($1cuWo)),
    srcDark: (/*@__PURE__*/$parcel$interopDefault($48S62))
});
var $30559913302f86cb$export$2e2bcd8739ae039 = $30559913302f86cb$var$Illustration;
// for advanced use only
const $30559913302f86cb$export$a179c88182cb9d56 = [
    0,
    0,
    164,
    218
];

});
parcelRegister("48S62", function(module, exports) {
module.exports = new URL("error-darkmode.9dba78cd.svg", import.meta.url).toString();

});

parcelRegister("1cuWo", function(module, exports) {
module.exports = new URL("error.b7de7f77.svg", import.meta.url).toString();

});


parcelRegister("7QuzF", function(module, exports) {

$parcel$export(module.exports, "default", () => $3ab5059cf2dfabb6$export$2e2bcd8739ae039);
// THIS FILE WAS AUTO-GENERATED. MODIFY WITH CAUTION. See README.md
// brandfolder asset id = 53grvvhrxck68z6q4s7ztq4p
// brandfolder url = https://brandfolder.com/atlassian-brand-creative-library/atlassian-public-asset-library/#!asset/53grvvhrxck68z6q4s7ztq4p

var $9TZf5 = parcelRequire("9TZf5");

var $fCVbE = parcelRequire("fCVbE");
const $3ab5059cf2dfabb6$var$Illustration = (0, $9TZf5.createIllustration)({
    srcLight: (/*@__PURE__*/$parcel$interopDefault($fCVbE)),
    srcDark: (/*@__PURE__*/$parcel$interopDefault($fCVbE))
});
var $3ab5059cf2dfabb6$export$2e2bcd8739ae039 = $3ab5059cf2dfabb6$var$Illustration;
// for advanced use only
const $3ab5059cf2dfabb6$export$a179c88182cb9d56 = [
    0,
    0,
    167,
    226
];

});
parcelRegister("fCVbE", function(module, exports) {
module.exports = new URL("search-error.a6df7c97.svg", import.meta.url).toString();

});


parcelRegister("6Yj0X", function(module, exports) {

$parcel$export(module.exports, "default", () => $6c13e1fbd282caae$export$2e2bcd8739ae039);

var $90IgZ = parcelRequire("90IgZ");
var $6c13e1fbd282caae$export$2e2bcd8739ae039 = (0, $90IgZ.defineMessages)({
    notFoundDocumentTitleJsm: {
        "id": "servicedesk-spa-commons.common.utils.errors.not-found-document-title-jsm",
        "defaultMessage": "Project not found - Service project"
    },
    notFoundTitle: {
        "id": "servicedesk-spa-commons.common.utils.errors.not-found-title",
        "defaultMessage": "This project isn't available"
    },
    notFoundDescription: {
        "id": "servicedesk-spa-commons.common.utils.errors.not-found-description",
        "defaultMessage": "It may have been deleted or your permissions may have changed"
    },
    notFoundAction: {
        "id": "servicedesk-spa-commons.common.utils.errors.not-found-action",
        "defaultMessage": "View a list of all projects"
    },
    genericDocumentTitleJsm: {
        "id": "servicedesk-spa-commons.common.utils.errors.generic-document-title-jsm",
        "defaultMessage": "Error - Service project"
    },
    genericErrorTitle: {
        "id": "servicedesk-spa-commons.common.utils.errors.generic-error-title",
        "defaultMessage": "An error occurred"
    },
    genericErrorDescription: {
        "id": "servicedesk-spa-commons.common.utils.errors.generic-error-description",
        "defaultMessage": "An error occurred while loading this page"
    }
});

});





parcelRegister("51Ia6", function(module, exports) {

$parcel$export(module.exports, "usePageContext", () => $16ae5fc48efca0d6$export$9c25024bdfe755f7);

var $eUqFw = parcelRequire("eUqFw");

var $iZJHG = parcelRequire("iZJHG");

var $ixwgj = parcelRequire("ixwgj");

var $gd0Sp = parcelRequire("gd0Sp");

var $jyTef = parcelRequire("jyTef");
const $16ae5fc48efca0d6$var$getProjectContextResource = ()=>(0, $ixwgj.projectContextResourceWithCache);
const $16ae5fc48efca0d6$export$9c25024bdfe755f7 = (customContext)=>{
    const tenantContext = (0, $gd0Sp.useTenantContext)();
    const { data: projectContext, loading: projectContextLoading, error: projectContextError } = (0, $iZJHG.useResourceWithCustomRouterContext)($16ae5fc48efca0d6$var$getProjectContextResource(), customContext);
    const [{ data: serviceDeskContext, loading: serviceDeskLoading, error: serviceDeskError }] = (0, $jyTef.useServiceDeskContext)(projectContext?.projectKey || undefined, customContext);
    const pageContextData = (0, $eUqFw.useMemo)(()=>({
            data: projectContext && serviceDeskContext ? {
                serviceDeskContext: {
                    portalId: serviceDeskContext.portalId,
                    portalUrl: serviceDeskContext.portalUrl,
                    canSeeNewIssueView: serviceDeskContext.canSeeNewIssueView,
                    userRole: serviceDeskContext.userRole,
                    serviceDeskId: serviceDeskContext.serviceDeskId
                },
                projectContext: {
                    projectId: projectContext.projectId,
                    projectKey: projectContext.projectKey,
                    projectName: projectContext.projectName,
                    projectType: projectContext.projectType,
                    // Refactor this in https://jdog.jira-dev.com/browse/JSK-443 this is a temporary fix to
                    // resolve a regression https://jira.atlassian.com/browse/JSDCLOUD-8751
                    isAdmin: projectContext.isProjectAdmin || tenantContext.isAdmin,
                    isProjectSimplified: projectContext.simplified
                },
                tenantContext: {
                    baseUrl: tenantContext.baseUrl,
                    locale: tenantContext.locale,
                    userFullname: tenantContext.userFullname,
                    cloudId: tenantContext.cloudId,
                    fabricPfDirUrl: tenantContext.fabricPfDirUrl,
                    atlassianAccountId: tenantContext.atlassianAccountId,
                    isJiraAdmin: tenantContext.isAdmin,
                    isSiteAdmin: tenantContext.isSiteAdmin,
                    activationId: tenantContext.activationId
                }
            } : null,
            loading: projectContextLoading || serviceDeskLoading,
            error: serviceDeskError || projectContextError || null
        }), [
        tenantContext,
        projectContext,
        serviceDeskContext,
        projectContextLoading,
        serviceDeskLoading,
        serviceDeskError,
        projectContextError
    ]);
    return [
        pageContextData
    ];
};

});

parcelRegister("6M8Uw", function(module, exports) {

$parcel$export(module.exports, "PRODUCT_START_MARK", () => $e57b25b6033962a3$export$8e54fca0a680fdfd);
$parcel$export(module.exports, "MarkProductStart", () => $e57b25b6033962a3$export$2a999c5f84501025);

var $6iz4v = parcelRequire("6iz4v");
const $e57b25b6033962a3$export$8e54fca0a680fdfd = 'PRODUCT_START';
const $e57b25b6033962a3$export$2a999c5f84501025 = ()=>{
    if (!false) {
        performance.clearMarks($e57b25b6033962a3$export$8e54fca0a680fdfd);
        (0, $6iz4v.setMark)($e57b25b6033962a3$export$8e54fca0a680fdfd);
    }
    return null;
};

});

parcelRegister("75nMA", function(module, exports) {

$parcel$export(module.exports, "useOnFavoritesChanged", () => $787f5fd962a6c1b3$export$ddf44c597e03063d);

var $eUqFw = parcelRequire("eUqFw");

var $8i1R8 = parcelRequire("8i1R8");

var $hvbu2 = parcelRequire("hvbu2");

var $dQZ5c = parcelRequire("dQZ5c");
var $jrdvV = parcelRequire("jrdvV");
const $787f5fd962a6c1b3$export$ddf44c597e03063d = (projectKey, category, queues, callback)=>{
    const { items: items } = (0, $eUqFw.useContext)((0, $dQZ5c.FavoriteChangeContext));
    const queueItemChanges = items[0, $jrdvV.QUEUES_ITEM_TYPE];
    const previousChangesRef = (0, $eUqFw.useRef)({
        projectKey: projectKey,
        category: category,
        changedItems: undefined
    });
    const { current: previousChanges } = previousChangesRef;
    const hasPotentialChanges = previousChanges.projectKey !== projectKey || previousChanges.category !== category || previousChanges.changedItems !== queueItemChanges;
    if (hasPotentialChanges) {
        previousChangesRef.current = {
            projectKey: projectKey,
            category: category,
            changedItems: queueItemChanges
        };
        if (queues) (0, (/*@__PURE__*/$parcel$interopDefault($hvbu2)))(queueItemChanges).forEach(({ id: id, value: value })=>{
            const queue = (0, (/*@__PURE__*/$parcel$interopDefault($8i1R8)))(queues, {
                id: Number(id)
            });
            if (queue && queue.favourite !== value) callback(id, value);
        });
    }
};

});
parcelRegister("8i1R8", function(module, exports) {

var $e5OGm = parcelRequire("e5OGm");

var $k61d1 = parcelRequire("k61d1");
/**
 * Iterates over elements of `collection`, returning the first element
 * `predicate` returns truthy for. The predicate is invoked with three
 * arguments: (value, index|key, collection).
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Collection
 * @param {Array|Object} collection The collection to inspect.
 * @param {Function} [predicate=_.identity] The function invoked per iteration.
 * @param {number} [fromIndex=0] The index to search from.
 * @returns {*} Returns the matched element, else `undefined`.
 * @example
 *
 * var users = [
 *   { 'user': 'barney',  'age': 36, 'active': true },
 *   { 'user': 'fred',    'age': 40, 'active': false },
 *   { 'user': 'pebbles', 'age': 1,  'active': true }
 * ];
 *
 * _.find(users, function(o) { return o.age < 40; });
 * // => object for 'barney'
 *
 * // The `_.matches` iteratee shorthand.
 * _.find(users, { 'age': 1, 'active': true });
 * // => object for 'pebbles'
 *
 * // The `_.matchesProperty` iteratee shorthand.
 * _.find(users, ['active', false]);
 * // => object for 'fred'
 *
 * // The `_.property` iteratee shorthand.
 * _.find(users, 'active');
 * // => object for 'barney'
 */ var $609171b9cff1596d$var$find = $e5OGm($k61d1);
module.exports = $609171b9cff1596d$var$find;

});
parcelRegister("e5OGm", function(module, exports) {

var $7qARj = parcelRequire("7qARj");

var $jxg5X = parcelRequire("jxg5X");

var $8nrDO = parcelRequire("8nrDO");
/**
 * Creates a `_.find` or `_.findLast` function.
 *
 * @private
 * @param {Function} findIndexFunc The function to find the collection index.
 * @returns {Function} Returns the new find function.
 */ function $a428d8bbecbff7a6$var$createFind(findIndexFunc) {
    return function(collection, predicate, fromIndex) {
        var iterable = Object(collection);
        if (!$jxg5X(collection)) {
            var iteratee = $7qARj(predicate, 3);
            collection = $8nrDO(collection);
            predicate = function(key) {
                return iteratee(iterable[key], key, iterable);
            };
        }
        var index = findIndexFunc(collection, predicate, fromIndex);
        return index > -1 ? iterable[iteratee ? collection[index] : index] : undefined;
    };
}
module.exports = $a428d8bbecbff7a6$var$createFind;

});



parcelRegister("gatu1", function(module, exports) {

$parcel$export(module.exports, "pageToQueues", () => $929c5ad2a648b730$export$8ada91ce992fa66f);

var $aNBkj = parcelRequire("aNBkj");
const $929c5ad2a648b730$var$transformColumns = (responseColumns)=>responseColumns.map((responseColumn)=>{
        const column = {
            id: responseColumn.fieldId,
            title: responseColumn.title,
            fieldType: responseColumn.fieldType,
            sortable: responseColumn.sortable
        };
        if (responseColumn.sortOrder) return {
            ...column,
            currentSorting: responseColumn.sortOrder
        };
        return column;
    });
const $929c5ad2a648b730$export$8ada91ce992fa66f = (page)=>// eslint-disable-next-line @typescript-eslint/no-explicit-any
    page.reduce((acc, queue)=>{
        acc[queue.id] = {
            id: (0, $aNBkj.toQueueId)(queue.id),
            name: queue.name,
            jql: queue.jql,
            completeJql: queue.completeJql,
            order: queue.order,
            columns: $929c5ad2a648b730$var$transformColumns(queue.columnsDetails),
            // British spelling from legacy Backend code
            isFavorite: queue.favourite,
            category: queue.category,
            canBeHidden: queue.canBeHidden
        };
        return acc;
    }, {});

});


parcelRegister("jK1pm", function(module, exports) {

$parcel$export(module.exports, "default", () => $f6f009785aaee067$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $7rh0R = parcelRequire("7rh0R");

var $iWLL0 = parcelRequire("iWLL0");

var $3Hphq = parcelRequire("3Hphq");

var $fYqUr = parcelRequire("fYqUr");

var $232mI = parcelRequire("232mI");
/** A portion of the page we apply measurement to */ function $f6f009785aaee067$var$JiraUFOSegmentWrapper({ children: children }) {
    // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
    const interactionContext = (0, $3Hphq.useInteractionContext)();
    const relayProfilerContext = (0, $eUqFw.useMemo)(()=>({
            getInteractionContext: ()=>interactionContext,
            wrapPrepareQueryResource (cb) {
                return cb();
            },
            retainQuery (info) {
                this.getInteractionContext().retainQuery(info);
            }
        }), [
        interactionContext
    ]);
    const reactLooselyLazyContext = (0, $eUqFw.useMemo)(()=>{
        const moduleLoadingRequests = {};
        return {
            current: {
                getInteractionContext () {
                    return interactionContext;
                },
                onPreload (moduleId, _priority) {
                    this.getInteractionContext().addPreload((0, $fYqUr.extractModuleName)(moduleId), performance.now());
                },
                onLoadStart (info) {
                    const timeoutId = setTimeout(()=>{
                        delete moduleLoadingRequests[info.identifier];
                    }, 30000);
                    const request = {
                        start: performance.now(),
                        timeoutId: timeoutId
                    };
                    moduleLoadingRequests[info.identifier] = request;
                },
                onLoadComplete (info) {
                    const request = moduleLoadingRequests[info.identifier];
                    if (request) {
                        clearTimeout(request.timeoutId);
                        delete moduleLoadingRequests[info.identifier];
                        this.getInteractionContext()?.addLoad((0, $fYqUr.extractModuleName)(info.identifier), request.start, performance.now());
                    }
                },
                placeholderFallBackMounted (id, name, lazyWait) {
                    if (lazyWait) return;
                    this.getInteractionContext().addHoldByID(this.getInteractionContext().labelStack, id, name);
                },
                placeholderFallBackUnmounted (id, name, lazyWait) {
                    if (lazyWait) return;
                    this.getInteractionContext().removeHoldByID(this.getInteractionContext().labelStack, id, name);
                }
            }
        };
    }, [
        interactionContext
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $iWLL0.ProfilerContext).Provider, {
        value: relayProfilerContext
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $7rh0R.ProfilerContext).Provider, {
        value: reactLooselyLazyContext
    }, children));
}
function $f6f009785aaee067$export$2e2bcd8739ae039({ name: segmentName, children: children }) {
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $232mI.default), {
        name: segmentName
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($f6f009785aaee067$var$JiraUFOSegmentWrapper, null, children));
}

});

parcelRegister("guZLT", function(module, exports) {

$parcel$export(module.exports, "default", () => $cc41b9ab1a2fec5f$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $ae4LH = parcelRequire("ae4LH");

var $lB25E = parcelRequire("lB25E");

var $g3JCd = parcelRequire("g3JCd");

var $fJAmy = parcelRequire("fJAmy");

var $4YkVK = parcelRequire("4YkVK");
var $cVYSD = parcelRequire("cVYSD");

var $gd0Sp = parcelRequire("gd0Sp");

var $jK1pm = parcelRequire("jK1pm");
const $cc41b9ab1a2fec5f$var$LegacyIssueView = (props)=>{
    const { push: push, match: match } = props;
    const [{ location: location }] = (0, $lB25E.useRouter)();
    const tenantContext = (0, $gd0Sp.useTenantContext)();
    const projectKey = match && match.params && match.params.projectKey ? match.params.projectKey : undefined;
    const [{ data: kbLink, loading: loading }] = (0, $4YkVK.useKbConfluenceContext)(projectKey);
    const { locale: locale } = tenantContext;
    if (loading) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $ae4LH.default), null);
    return match && match.params && match.params.issueKey ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $jK1pm.default), {
        name: "queues-legacy-issue-view"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $fJAmy.Page), {
        entity: match.params.queueId || '',
        issueKey: match.params.issueKey,
        onNavigation: push,
        locale: locale,
        wrmDataForPage: {
            'com.atlassian.servicedesk.core-ui:util-base-url.base-url': `https://${// @ts-expect-error - TS2339 - Property 'host' does not exist on type 'Location'.
            location.host || window.location.host}`,
            moment_user_locale: locale,
            'sd-kb-link': kbLink
        },
        pathname: location.pathname
    })) : null;
};
const $cc41b9ab1a2fec5f$var$QueuesIssueViewContent = (props)=>{
    const { pageContext: pageContext, push: push, match: match, issueNavigatorData: issueNavigatorData } = props;
    const { isProjectSimplified: isProjectSimplified, canSeeNewIssueView: canSeeNewIssueView } = pageContext;
    const [{ location: { search: search } }] = (0, $lB25E.useRouter)();
    const { showLegacyIssueView: showLegacyIssueView } = (0, $cVYSD.useShouldShowLegacyIssueView)(isProjectSimplified, canSeeNewIssueView, search);
    if (showLegacyIssueView) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($cc41b9ab1a2fec5f$var$LegacyIssueView, {
        push: push,
        match: match
    });
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $jK1pm.default), {
        name: "queues-issue-view"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $g3JCd.default), {
        issueNavigatorData: issueNavigatorData
    }));
};
var $cc41b9ab1a2fec5f$export$2e2bcd8739ae039 = $cc41b9ab1a2fec5f$var$QueuesIssueViewContent;

});
parcelRegister("g3JCd", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

$parcel$export(module.exports, "default", () => $6434ce5bd980a8ef$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");


var $jBy23 = parcelRequire("jBy23");

var $iEcUp = parcelRequire("iEcUp");

var $hgiIU = parcelRequire("hgiIU");

var $jc4kK = parcelRequire("jc4kK");

var $2bMHt = parcelRequire("2bMHt");

var $jK1pm = parcelRequire("jK1pm");

var $asM86 = parcelRequire("asM86");
let $6434ce5bd980a8ef$var$dispatchExternalAction;
const $6434ce5bd980a8ef$var$getIssueKey = ()=>(0, $iEcUp.parseIssueKey)(window.location.href);
const $6434ce5bd980a8ef$var$getPreviousUrl = ()=>{
    const urlParts = window.location.href.split('/');
    return urlParts.slice(0, urlParts.length - 1).join('/');
};
const $6434ce5bd980a8ef$var$queueRoutesPattern = Object.values((0, $2bMHt.QUEUE_ROUTES)).join('|').replace(/\//g, '\\/');
const $6434ce5bd980a8ef$var$QUEUES_URL_REGEX = new RegExp(`.*\\/projects\\/[^/]+\\/(${$6434ce5bd980a8ef$var$queueRoutesPattern})\\/custom\\/.*`);
const $6434ce5bd980a8ef$var$isComingFromQueue = ()=>window.location.pathname.match($6434ce5bd980a8ef$var$QUEUES_URL_REGEX);
const $6434ce5bd980a8ef$var$REPORTS_URL_REGEX = /.*\/projects\/[^/]+\/reports\/.*/;
const $6434ce5bd980a8ef$var$isComingFromReport = ()=>window.location.pathname.match($6434ce5bd980a8ef$var$REPORTS_URL_REGEX);
const $6434ce5bd980a8ef$var$isComingFromQueueOrReport = ()=>$6434ce5bd980a8ef$var$isComingFromQueue() || $6434ce5bd980a8ef$var$isComingFromReport();
const $6434ce5bd980a8ef$var$redirectAfterSuccessfulDelete = ()=>()=>{
        const issueKey = $6434ce5bd980a8ef$var$getIssueKey();
        const projectKey = (0, $jBy23.extractProjectKey)(issueKey);
        let url;
        if ($6434ce5bd980a8ef$var$isComingFromQueueOrReport()) url = $6434ce5bd980a8ef$var$getPreviousUrl();
        else url = `/projects/${projectKey}`;
        window.location.assign(url);
    };
(0, $hgiIU.listenToExternalActionFromLegacy)(()=>({
        dispatchExternalAction: $6434ce5bd980a8ef$var$dispatchExternalAction,
        modifiedIssueIssueKey: $6434ce5bd980a8ef$var$getIssueKey()
    }));
const $6434ce5bd980a8ef$var$onDispatchExternalActionRef = (ref)=>{
    if (ref) $6434ce5bd980a8ef$var$dispatchExternalAction = ref;
};
const $6434ce5bd980a8ef$var$getAnalyticsSourceFromUrl = ()=>{
    const { pathname: pathname } = window.location;
    if (pathname.includes('section')) return 0, $0100842672acae20$export$7063ee6d0035a982;
    if (pathname.includes('queues')) return 0, $0100842672acae20$export$7063ee6d0035a982;
    return 0, $0100842672acae20$export$5bd5011b6596a0e7;
};
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$6434ce5bd980a8ef$export$2e2bcd8739ae039 = ({ issueNavigatorData: issueNavigatorData } = {})=>{
    (0, $jc4kK.markFragmentReady)();
    const issueKey = $6434ce5bd980a8ef$var$getIssueKey();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $jK1pm.default), {
        name: "jsm-issue-view"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $asM86.default), {
        backButtonUrl: $6434ce5bd980a8ef$var$isComingFromQueueOrReport() ? $6434ce5bd980a8ef$var$getPreviousUrl() : undefined,
        issueNavigatorData: issueNavigatorData,
        analyticsSource: $6434ce5bd980a8ef$var$getAnalyticsSourceFromUrl(),
        issueKey: issueKey,
        onIssueDeleteSuccess: $6434ce5bd980a8ef$var$redirectAfterSuccessfulDelete(),
        onDispatchExternalActionRef: $6434ce5bd980a8ef$var$onDispatchExternalActionRef
    }));
};

});
const $0100842672acae20$export$53d41ff2666118e1 = 'agility-backlog';
const $0100842672acae20$export$7552fe2669628499 = 'bitbucket-issue';
const $0100842672acae20$export$41a718da0a8636f4 = 'connect-issue';
const $0100842672acae20$export$cebf0bc8b2ccaf57 = 'core-issue';
const $0100842672acae20$export$5e91e17726e54450 = 'jiraCalendar';
const $0100842672acae20$export$82540942fb014b0a = 'business-calendar';
const $0100842672acae20$export$7ca28938a07e0c33 = 'business-list';
const $0100842672acae20$export$f6cf06aaaeb58a54 = 'business-timeline';
const $0100842672acae20$export$b2c0462ff17aa26e = 'business-board';
const $0100842672acae20$export$a607850ebccd28ac = 'business-approvals';
const $0100842672acae20$export$1da6cede3561048f = 'business-files';
const $0100842672acae20$export$b19f949fb9713614 = 'full-issue';
const $0100842672acae20$export$a5132300c5214280 = 'embed-issue';
const $0100842672acae20$export$710114090a811b37 = 'global-issue-navigator-issue';
const $0100842672acae20$export$ce88447986394f2d = 'mobile-issue';
const $0100842672acae20$export$6a90d9196d330040 = 'project-issue-navigator';
const $0100842672acae20$export$2247c9059c171db1 = 'roadmap-issue';
const $0100842672acae20$export$cd16d39c55c569d0 = 'simple-software-board';
const $0100842672acae20$export$f72626bf0d75dfad = 'software-backlog-issue';
const $0100842672acae20$export$778b4609e784cb27 = 'software-deployments-issue';
const $0100842672acae20$export$5b73d694a6048002 = 'version-detail-issue';
const $0100842672acae20$export$accce97178e4e049 = 'software-cycle-time-report-issue';
const $0100842672acae20$export$21b5b7189add7861 = 'software-incidents-issue';
const $0100842672acae20$export$9c5d81b901471b27 = 'software-issue';
const $0100842672acae20$export$1735f6ad917dc411 = 'change-calendar';
const $0100842672acae20$export$7063ee6d0035a982 = 'queues-issue-view';
const $0100842672acae20$export$5bd5011b6596a0e7 = 'reports-issue-view';
const $0100842672acae20$export$9dfa9e993d3e0520 = 'forge-full-page-extension';
const $0100842672acae20$export$14a8072f422804fd = 'issue-navigator-next';

parcelRegister("jBy23", function(module, exports) {

$parcel$export(module.exports, "extractProjectKey", () => $7901038b5997e3c0$export$f1a2e4721b127828);

var $6vrw7 = parcelRequire("6vrw7");
const $7901038b5997e3c0$export$f1a2e4721b127828 = (issueKey)=>(0, $6vrw7.toProjectKey)(issueKey.split('-')[0]);

});

parcelRegister("iEcUp", function(module, exports) {

$parcel$export(module.exports, "parseIssueKey", () => $bfe586d9caaf9342$export$775cba7641fc60e9);

var $6vrw7 = parcelRequire("6vrw7");
const $bfe586d9caaf9342$export$775cba7641fc60e9 = (href)=>{
    const path = href.split('/').pop();
    // @ts-expect-error - TS2532 - Object is possibly 'undefined'.
    return (0, $6vrw7.toIssueKey)(path.split('?')[0].split('#')[0]);
};

});

parcelRegister("hgiIU", function(module, exports) {

$parcel$export(module.exports, "listenToExternalActionFromLegacy", () => $c80637eb06558544$export$60376d8e2c7d8037);
// eslint-disable-next-line jira/wrm/no-load-bridge

var $2BvS3 = parcelRequire("2BvS3");
const $c80637eb06558544$export$60376d8e2c7d8037 = (getDispatcherAndModifiedIssue)=>{
    // eslint-disable-next-line jira/wrm/no-load-bridge
    (0, $2BvS3.loadBridge)({
        name: 'jira/util/events',
        wrmKeys: 'wrc!jira.webresources:jira-events'
    }).then((Events)=>{
        Events.bind('modify-issue-view-via-external-action', (e, payload)=>{
            const { issueKey: issueKey, externalAction: externalAction } = payload;
            const { dispatchExternalAction: dispatchExternalAction, modifiedIssueIssueKey: modifiedIssueIssueKey } = getDispatcherAndModifiedIssue();
            if (issueKey === modifiedIssueIssueKey && externalAction && dispatchExternalAction) dispatchExternalAction(externalAction);
        });
    });
};

});

parcelRegister("jc4kK", function(module, exports) {

$parcel$export(module.exports, "markFragmentReady", () => $3ef0a8a6a82c0ed3$export$f35671de67f03a2b);
$parcel$export(module.exports, "initialiseMetrics", () => $3ef0a8a6a82c0ed3$export$1ac307e078c767d0);
$parcel$export(module.exports, "markIssueStartRendering", () => $3ef0a8a6a82c0ed3$export$c039505b02c87616);
$parcel$export(module.exports, "markIssueRender", () => $3ef0a8a6a82c0ed3$export$c16cf8a32075f588);
$parcel$export(module.exports, "markIssueLegacyInteractive", () => $3ef0a8a6a82c0ed3$export$4d5d547fdbe28097);
$parcel$export(module.exports, "markSPAReadyEndOfCriticalPath", () => $3ef0a8a6a82c0ed3$export$a45a77102d75517f);
$parcel$export(module.exports, "markIssueInteractive", () => $3ef0a8a6a82c0ed3$export$e57956c4b76a36f);
$parcel$export(module.exports, "markIssueOnPageLoadEvent", () => $3ef0a8a6a82c0ed3$export$c30d9392d27ab5a8);
$parcel$export(module.exports, "markStartIssue", () => $3ef0a8a6a82c0ed3$export$71cdf78946f275c);
$parcel$export(module.exports, "markIssuePreviewRendered", () => $3ef0a8a6a82c0ed3$export$7f5545008a1e5a18);
$parcel$export(module.exports, "setIsInitialRender", () => $3ef0a8a6a82c0ed3$export$eedeaa0a5b3bd3d1);
$parcel$export(module.exports, "isFullIssueView", () => $3ef0a8a6a82c0ed3$export$db2ef91f6ace96c7);

var $hompL = parcelRequire("hompL");

var $hknOo = parcelRequire("hknOo");

var $6iz4v = parcelRequire("6iz4v");

var $gUUjF = parcelRequire("gUUjF");

var $6xYPC = parcelRequire("6xYPC");

var $1ybV0 = parcelRequire("1ybV0");

var $eI5EY = parcelRequire("eI5EY");


var $RvFPW = parcelRequire("RvFPW");

var $g0N0Z = parcelRequire("g0N0Z");

var $8Bhia = parcelRequire("8Bhia");

var $782cd = parcelRequire("782cd");

var $lMwBY = parcelRequire("lMwBY");

var $6M8Uw = parcelRequire("6M8Uw");
var $2B87Z = parcelRequire("2B87Z");

var $87isp = parcelRequire("87isp");

var $iTvzN = parcelRequire("iTvzN");

var $3iMaY = parcelRequire("3iMaY");

var $eJ3kO = parcelRequire("eJ3kO");

var $fbE19 = parcelRequire("fbE19");

var $fYqUr = parcelRequire("fYqUr");

var $9OxOE = parcelRequire("9OxOE");

var $7iu2Y = parcelRequire("7iu2Y");

var $gU59E = parcelRequire("gU59E");

var $7YIVI = parcelRequire("7YIVI");
const $3ef0a8a6a82c0ed3$var$LOG_LOCATION = 'issue.metrics';
let $3ef0a8a6a82c0ed3$var$state;
const $3ef0a8a6a82c0ed3$var$getSsrMark = ()=>{
    const ssrMark = (0, $6iz4v.getMark)((0, $hknOo.SPA_SSR_RENDERED_MARK));
    if (ssrMark != null) return Math.floor(ssrMark.startTime);
    return null;
};
const $3ef0a8a6a82c0ed3$var$setMarkWithError = (markName)=>{
    try {
        (0, $6iz4v.setMark)(markName);
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    } catch (error) {
        (0, $gUUjF.default).safeErrorWithoutCustomerData($3ef0a8a6a82c0ed3$var$LOG_LOCATION, 'Setting performance mark failed', error);
    }
};
const $3ef0a8a6a82c0ed3$export$f35671de67f03a2b = ()=>{
    $3ef0a8a6a82c0ed3$var$setMarkWithError($848ef1328a091c81$export$625e4e4c6eb56930);
};
const $3ef0a8a6a82c0ed3$export$1ac307e078c767d0 = (options)=>{
    try {
        const { issueContextActions: issueContextActions, isLoadedWithPage: isLoadedWithPage, isSPA: isSPA, isRecentIssue: isRecentIssue, recentIssuesCount: recentIssuesCount, dataProvider: dataProvider, analyticsSource: analyticsSource, store: store, route: route } = options;
        $3ef0a8a6a82c0ed3$var$state = new (0, $gU59E.default)({
            isLoadedWithPage: isLoadedWithPage,
            isSPA: isSPA,
            isRecentIssue: isRecentIssue,
            analyticsSource: analyticsSource,
            recentIssuesCount: recentIssuesCount,
            correlationId: (0, (/*@__PURE__*/$parcel$interopDefault($hompL))).v4(),
            // @ts-expect-error - TS2322 - Type '{ analyticsKey: ApplicationKey | undefined; viewMode: any; issueId: string | undefined; }' is not assignable to type 'MetricsProps'.
            lazyMetricsProps: ()=>(0, $7YIVI.metricsStateSelector)(store.getState()),
            timingDataReporter: ()=>({
                    ...(0, $782cd.serverTimingSelector)(store.getState()),
                    ...(0, $RvFPW.getFetchIssueNetworkTimes)()
                }),
            issueScaleabilityReporter: (0, $7iu2Y.issueScaleabilityReporterFactory)(store, issueContextActions),
            dataProvider: dataProvider,
            route: route
        });
        // Marking init of bm3
        (0, $g0N0Z.issueViewLoad).mark('metrics_init');
        (0, $g0N0Z.issueViewOnPageLoad).mark('metrics_init');
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    } catch (error) {
        (0, $gUUjF.default).safeErrorWithoutCustomerData($3ef0a8a6a82c0ed3$var$LOG_LOCATION, 'Failed to initialise issue metrics', error);
    }
};
const $3ef0a8a6a82c0ed3$export$c039505b02c87616 = ()=>{
    $3ef0a8a6a82c0ed3$var$setMarkWithError($848ef1328a091c81$export$10082883a7f4ea4d);
    (0, $g0N0Z.issueViewLoad).mark($848ef1328a091c81$export$10082883a7f4ea4d);
};
const $3ef0a8a6a82c0ed3$export$c16cf8a32075f588 = ()=>{
    $3ef0a8a6a82c0ed3$var$setMarkWithError($848ef1328a091c81$export$7f7b606f70e669e6);
    (0, $g0N0Z.issueViewOnPageLoad).mark($848ef1328a091c81$export$7f7b606f70e669e6);
};
const $3ef0a8a6a82c0ed3$export$4d5d547fdbe28097 = ()=>{
    $3ef0a8a6a82c0ed3$var$setMarkWithError($848ef1328a091c81$export$b292c195104c50d3);
    (0, $g0N0Z.issueViewLoad).mark($848ef1328a091c81$export$b292c195104c50d3);
};
const $3ef0a8a6a82c0ed3$export$8bc8bca4478fe6d7 = (markTime)=>{
    (0, $g0N0Z.issueViewOnPageLoad).mark($848ef1328a091c81$export$4d1080224e02ef0b, markTime);
};
const $3ef0a8a6a82c0ed3$export$a45a77102d75517f = ()=>{
    $3ef0a8a6a82c0ed3$var$setMarkWithError($848ef1328a091c81$export$434b58ebadf14df2);
    (0, $g0N0Z.issueViewLoad).mark($848ef1328a091c81$export$434b58ebadf14df2);
};
const $3ef0a8a6a82c0ed3$var$getSharedCustomData = ()=>({
        ...$3ef0a8a6a82c0ed3$var$state.getIssueScaleabilityReporter()(),
        ...(0, $9OxOE.getBackendBlockingTime)({
            // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
            issueViewLoad: (0, $g0N0Z.issueViewLoad)
        }),
        isBentoRecentIssue: $3ef0a8a6a82c0ed3$var$state.getIsRecentIssue(),
        bentoRecentIssuesCount: $3ef0a8a6a82c0ed3$var$state.getRecentIssuesCount(),
        correlationId: $3ef0a8a6a82c0ed3$var$state.getCorrelationId(),
        ...(0, $eI5EY.fg)('enable-metric-full-page-bundle-load-count') ? {
            initialLoadFullPageBundleLoadCount: $3ef0a8a6a82c0ed3$var$state.getIsInitial() ? performance.getEntriesByType('resource').filter((x)=>x.name.includes('async-issue-app--full-page')).length : 0
        } : {}
    });
const $3ef0a8a6a82c0ed3$export$e57956c4b76a36f = ({ lastTransitionTime: // TODO JIV-14563 Fixup or remove embeddedIssueTTI in BM3 metrics due to broken lastTransitionStartTime
// @ts-expect-error - this has never been wired up correctly, I only just discovered it by adding types for the data that is actually passed through.
lastTransitionTime })=>{
    const isFullIssue = $3ef0a8a6a82c0ed3$var$state.getIsFullIssue();
    $3ef0a8a6a82c0ed3$var$state.setInteractiveEnd(performance.now());
    if ($3ef0a8a6a82c0ed3$var$state) {
        const startTime = lastTransitionTime || $3ef0a8a6a82c0ed3$var$state.getStartTime();
        if ($3ef0a8a6a82c0ed3$var$state.getIsFullIssue()) (0, $2B87Z.stopInitialPageLoadTimingFromPerformanceMarkStart)('product', (0, $6M8Uw.PRODUCT_START_MARK), true);
        const embeddedCustomData = !isFullIssue ? {
            embeddedIssueFMP: Math.floor($3ef0a8a6a82c0ed3$var$state.getFMP()),
            embeddedIssueTTI: Math.floor($3ef0a8a6a82c0ed3$var$state.getInteractiveEnd() - startTime),
            analyticsSource: $3ef0a8a6a82c0ed3$var$state.getAnalyticsSource(),
            featureFlags: Object.fromEntries((0, $fbE19.allFeatureFlagsAccessed))
        } : {};
        const perfConfig = {
            stopTime: $3ef0a8a6a82c0ed3$var$state.getInteractiveEnd(),
            customData: {
                ...$3ef0a8a6a82c0ed3$var$getSharedCustomData(),
                ...embeddedCustomData
            }
        };
        // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
        (0, $3iMaY.addUFOCustomData)(perfConfig.customData);
        const ufoMetricKey = isFullIssue ? 'issue-view' : 'issue-embed';
        (0, $fYqUr.addApdexToAll)({
            key: ufoMetricKey,
            startTime: isFullIssue ? undefined : (0, $g0N0Z.embeddedIssueViewLoad).getData()?.start ?? undefined,
            stopTime: perfConfig.stopTime
        });
        if (isFullIssue) (0, $eJ3kO.addBM3TimingsToUFO)((0, $g0N0Z.issueViewLoad).getData()?.marks, (0, $g0N0Z.issueViewLoad).getData()?.config.timings);
        if (isFullIssue && (0, $8Bhia.isBM3EmitOnRafTopExperiencesEnabled)()) (0, $lMwBY.afterPaintEmit)(()=>{
            // @ts-expect-error payload type mismatch with optional values
            (0, $g0N0Z.issueViewLoad).stop(perfConfig);
        }, // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
        (0, $g0N0Z.issueViewLoad));
        else // @ts-expect-error payload type mismatch with optional values
        (0, $g0N0Z.issueViewLoad).stop(perfConfig);
        (0, $iTvzN.markUimTtiIssueViewLoaded)();
        if (!isFullIssue) // See markStartIssue for more information.
        {
            if ((0, $87isp.isAutomaticExposureCollectionEnabled)()) (0, $6xYPC.stopLowPriorityEventDelay)();
        }
    }
};
const $3ef0a8a6a82c0ed3$var$getBrowserNavigationMetrics = ()=>{
    const entries = performance.getEntriesByType('navigation');
    if (entries.length === 0 || !(entries[0] instanceof PerformanceNavigationTiming)) return null;
    const navigation = entries[0];
    return {
        connectEnd: Math.round(navigation.connectEnd),
        connectStart: Math.round(navigation.connectStart),
        domComplete: Math.round(navigation.domComplete),
        domContentLoadedEventEnd: Math.round(navigation.domContentLoadedEventEnd),
        domContentLoadedEventStart: Math.round(navigation.domContentLoadedEventStart),
        domInteractive: Math.round(navigation.domInteractive),
        domainLookupEnd: Math.round(navigation.domainLookupEnd),
        domainLookupStart: Math.round(navigation.domainLookupStart),
        fetchStart: Math.round(navigation.fetchStart),
        loadEventStart: Math.round(navigation.loadEventStart),
        requestStart: Math.round(navigation.requestStart),
        responseEnd: Math.round(navigation.responseEnd),
        responseStart: Math.round(navigation.responseStart),
        unloadEventEnd: Math.round(navigation.unloadEventEnd),
        unloadEventStart: Math.round(navigation.unloadEventStart),
        redirectStart: Math.round(navigation.redirectStart),
        redirectEnd: Math.round(navigation.redirectEnd),
        secureConnectionStart: Math.round(navigation.secureConnectionStart),
        redirectCount: navigation.redirectCount,
        type: navigation.type
    };
};
const $3ef0a8a6a82c0ed3$export$c30d9392d27ab5a8 = ()=>{
    const isFullIssue = $3ef0a8a6a82c0ed3$var$state.getIsFullIssue();
    if (!isFullIssue) return;
    if ($3ef0a8a6a82c0ed3$var$state) {
        try {
            new PerformanceObserver((entryList)=>{
                entryList.getEntries().forEach((entry)=>$3ef0a8a6a82c0ed3$export$8bc8bca4478fe6d7(entry.startTime));
            }).observe({
                type: 'largest-contentful-paint',
                buffered: true
            });
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        } catch (e) {
        // do nothing
        }
        const customData = {
            ...$3ef0a8a6a82c0ed3$var$getSharedCustomData(),
            browserNavigationMetrics: $3ef0a8a6a82c0ed3$var$getBrowserNavigationMetrics()
        };
        // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
        (0, $g0N0Z.issueViewOnPageLoad).stop(customData);
        // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
        (0, $3iMaY.addUFOCustomData)(customData);
    }
};
const $3ef0a8a6a82c0ed3$export$71cdf78946f275c = (isFullPage = false)=>{
    if ((0, $1ybV0.ff)('fix-issueviewload-start-timing-for-new-browser-metric-version_ahdhr')) (0, $g0N0Z.issueViewLoad).start();
    if (!isFullPage) {
        (0, $g0N0Z.embeddedIssueViewLoad).start({
            startTime: performance.now()
        });
        /**
		 * All SPA full page loads already start the event delay through the
		 * usePageLoadedSubscriber hook in @atlassian/jira-event-delay-controller.
		 * The embedded views need to start this critical section explicitly here because
		 * there is no equivalent hook that is generically applicable to all experiences.
		 *
		 * The only events that currently leverage the delay mechanism are the automatic
		 * exposure events, so we can avoid the overhead of starting this critical section
		 * if it won't be necessary.
		 */ if ((0, $87isp.isAutomaticExposureCollectionEnabled)()) (0, $6xYPC.startLowPriorityEventDelay)();
    }
    if (isFullPage) (0, $g0N0Z.issueViewOnPageLoad).start({
        startTime: 0
    });
    if (!(0, $1ybV0.ff)('fix-issueviewload-start-timing-for-new-browser-metric-version_ahdhr')) (0, $g0N0Z.issueViewLoad).start();
    (0, $iTvzN.startUimTti)();
};
const $3ef0a8a6a82c0ed3$export$7f5545008a1e5a18 = ({ isInitialRender: isInitialRender, lastTransitionStartTime: lastTransitionStartTime })=>{
    const ssrMark = $3ef0a8a6a82c0ed3$var$getSsrMark();
    const previewTime = performance.now();
    const startTime = $3ef0a8a6a82c0ed3$var$state.getStartTime();
    let fmp = 0;
    if ($3ef0a8a6a82c0ed3$var$state.getIsFullIssue()) {
        if (isInitialRender) // @ts-expect-error - TS2322 - Type 'number | null' is not assignable to type 'number'.
        fmp = ssrMark;
        else fmp = previewTime - (lastTransitionStartTime || startTime);
    } else fmp = previewTime - startTime;
    (0, $g0N0Z.issueViewLoad).mark($848ef1328a091c81$export$62c04f0e896827e3);
    (0, $g0N0Z.issueViewOnPageLoad).mark($848ef1328a091c81$export$62c04f0e896827e3);
    $3ef0a8a6a82c0ed3$var$state.setFMP(fmp);
    $3ef0a8a6a82c0ed3$var$state.setPreviewEnd(previewTime);
    $3ef0a8a6a82c0ed3$var$setMarkWithError($848ef1328a091c81$export$62c04f0e896827e3);
};
const $3ef0a8a6a82c0ed3$export$eedeaa0a5b3bd3d1 = (isInitialRender)=>{
    if ($3ef0a8a6a82c0ed3$var$state) $3ef0a8a6a82c0ed3$var$state.setIsLoadedWithPage(isInitialRender);
};
const $3ef0a8a6a82c0ed3$export$db2ef91f6ace96c7 = ()=>$3ef0a8a6a82c0ed3$var$state && $3ef0a8a6a82c0ed3$var$state.getIsFullIssue();

});
parcelRegister("6xYPC", function(module, exports) {

$parcel$export(module.exports, "stopLowPriorityEventDelay", () => $4b25e5ad6cfac913$export$a928755af449867);
$parcel$export(module.exports, "startLowPriorityEventDelay", () => $4b25e5ad6cfac913$export$8bb8df5a93e9525);
$parcel$export(module.exports, "default", () => $4b25e5ad6cfac913$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $ICvxP = parcelRequire("ICvxP");
var $6iz4v = parcelRequire("6iz4v");

var $cbwiM = parcelRequire("cbwiM");

var $3FyZ4 = parcelRequire("3FyZ4");

var $epT40 = parcelRequire("epT40");

var $87isp = parcelRequire("87isp");

const $4b25e5ad6cfac913$var$STOP_DELAY_TIMEOUT = 10000;
let $4b25e5ad6cfac913$var$stopDelayTimeout;
let $4b25e5ad6cfac913$var$lastDelayActionPromise = (0, $3FyZ4.getAnalyticsWebClientPromise)().then((clientWrapper)=>clientWrapper.getInstance());
const $4b25e5ad6cfac913$export$a928755af449867 = ()=>{
    $4b25e5ad6cfac913$var$lastDelayActionPromise = $4b25e5ad6cfac913$var$lastDelayActionPromise.then((client)=>{
        if (!(0, $cbwiM.isEventDelayActive)()) return client;
        clearTimeout($4b25e5ad6cfac913$var$stopDelayTimeout);
        // stopLowPriorityEventDelay performs a flush of the delayed events,
        // so the delayed period needs to be marked as ended _before_ calling that method.
        (0, $6iz4v.setMark)((0, $9f18a423c52d71b6$export$2d91d3eed1108e72));
        (0, $cbwiM.setEventDelayActive)(false);
        client.stopLowPriorityEventDelay();
        return client;
    });
};
const $4b25e5ad6cfac913$export$8bb8df5a93e9525 = ()=>{
    $4b25e5ad6cfac913$var$lastDelayActionPromise = $4b25e5ad6cfac913$var$lastDelayActionPromise.then((client)=>{
        // If startLowPriorityEventDelay is called when it's already active, then we are just extending
        // the delay period, so we don't want to reset any metadata we have captured about the original start.
        if (!(0, $cbwiM.isEventDelayActive)()) {
            (0, $ICvxP.default)((0, $9f18a423c52d71b6$export$358721a9d6125914));
            (0, $6iz4v.setMark)((0, $9f18a423c52d71b6$export$b2122dce85a27912));
        }
        client.startLowPriorityEventDelay();
        (0, $cbwiM.setEventDelayActive)(true);
        clearTimeout($4b25e5ad6cfac913$var$stopDelayTimeout);
        $4b25e5ad6cfac913$var$stopDelayTimeout = setTimeout($4b25e5ad6cfac913$export$a928755af449867, $4b25e5ad6cfac913$var$STOP_DELAY_TIMEOUT);
        return client;
    });
};
const $4b25e5ad6cfac913$export$778ebe2a4fab1ba7 = ()=>$4b25e5ad6cfac913$var$lastDelayActionPromise;
const $4b25e5ad6cfac913$var$EventDelayController = ()=>{
    const [loadedState] = (0, $epT40.default)();
    (0, $eUqFw.useEffect)(()=>{
        /**
		 * The delay mechanism is currently locked so that only automatic exposure events
		 * can leverage it.
		 * We can remove the performance overhead of starting and stopping critical sections when
		 * these events won't be getting fired.
		 */ if (!loadedState.hasLoaded && (0, $87isp.isAutomaticExposureCollectionEnabled)()) $4b25e5ad6cfac913$export$8bb8df5a93e9525();
    }, [
        loadedState.hasLoaded
    ]);
    return null;
};
var $4b25e5ad6cfac913$export$2e2bcd8739ae039 = $4b25e5ad6cfac913$var$EventDelayController;

});
parcelRegister("cbwiM", function(module, exports) {

$parcel$export(module.exports, "setEventDelayActive", () => $00304183c2d9ac4d$export$9a4add6d6ddcc1a);
$parcel$export(module.exports, "isEventDelayActive", () => $00304183c2d9ac4d$export$3536b0184fa98d19);
let $00304183c2d9ac4d$var$eventDelayActive = false;
const $00304183c2d9ac4d$export$9a4add6d6ddcc1a = (isEventDelayActive)=>{
    $00304183c2d9ac4d$var$eventDelayActive = isEventDelayActive;
};
const $00304183c2d9ac4d$export$3536b0184fa98d19 = ()=>$00304183c2d9ac4d$var$eventDelayActive;

});

parcelRegister("epT40", function(module, exports) {

$parcel$export(module.exports, "default", () => $c9158c027ae7ce81$export$2e2bcd8739ae039);

var $1yZQx = parcelRequire("1yZQx");


var $cfLkw = parcelRequire("cfLkw");
const $c9158c027ae7ce81$export$4a361c7505f72f5c = ({ currentPage: currentPage })=>{
    const { apps: apps } = currentPage;
    const appIds = Object.keys(apps);
    const determineHasLoaded = ()=>{
        /*
		 * During a transition, the top navigation is the only app loading. Additionally, legacy pages generally
		 * render a LegacyPage component, analytics, or nothing at all.
		 *
		 * This code ensures that the page is considered loaded when the content has finished loading in the
		 * SPA, or when the top navigation has finished loading for legacy pages.
		 *
		 * Ideally the LegacyPage component should include an app for the content, but the usage of route components
		 * in legacy routes is inconsistent and would need thorough testing. This should be good enough for now.
		 */ if (appIds.length === 1 && appIds[0] === (0, $9c22638d2f17f9db$export$3a54edb6ba4daa82)) return !__SPA__;
        return appIds.length ? appIds.filter((id)=>id !== (0, $9c22638d2f17f9db$export$2ee9e5a3556c1e43)).every((id)=>apps[id].endTime != null || apps[id].timeoutTime) : false;
    };
    const hasLoaded = determineHasLoaded();
    return {
        hasLoaded: hasLoaded
    };
};
const $c9158c027ae7ce81$var$usePageLoadedSubscriber = (0, $1yZQx.createHook)((0, $cfLkw.default), {
    selector: $c9158c027ae7ce81$export$4a361c7505f72f5c
});
var $c9158c027ae7ce81$export$2e2bcd8739ae039 = $c9158c027ae7ce81$var$usePageLoadedSubscriber;

});
const $9c22638d2f17f9db$export$3a54edb6ba4daa82 = 'TOP_NAV';
const $9c22638d2f17f9db$export$2ee9e5a3556c1e43 = 'SIDEBAR';


const $9f18a423c52d71b6$export$358721a9d6125914 = 'event-delay-controller.';
const $9f18a423c52d71b6$export$b2122dce85a27912 = `${$9f18a423c52d71b6$export$358721a9d6125914}start`;
const $9f18a423c52d71b6$export$2d91d3eed1108e72 = `${$9f18a423c52d71b6$export$358721a9d6125914}end`;


const $848ef1328a091c81$export$625e4e4c6eb56930 = 'ISSUE_FRAGMENT_READY_MARK';
const $848ef1328a091c81$export$10082883a7f4ea4d = 'ISSUE_START_RENDERING_MARK';
const $848ef1328a091c81$export$62c04f0e896827e3 = 'ISSUE_PREVIEW_RENDERED';
const $848ef1328a091c81$export$5db08809a3f311ed = 'ISSUE_FETCHED_MARK';
const $848ef1328a091c81$export$c21b33196a19ec61 = 'ISSUE_START_FETCHING_DATA';
const $848ef1328a091c81$export$e64e32643802b552 = 'ISSUE_READY_FOR_DATA';
const $848ef1328a091c81$export$e52cc35f872875f7 = 'ISSUE_DATA_AVAILABLE';
const $848ef1328a091c81$export$91b5cb94c32a9b = 'ISSUE_CACHED_CONTENT_LOADED';
const $848ef1328a091c81$export$205779a1d31dbc62 = 'ssr.issue.rendered';
const $848ef1328a091c81$export$bfb91b09e6b87d3c = 'ISSUE_START_GIRA_FETCH';
const $848ef1328a091c81$export$beb8599162403c36 = 'ISSUE_FINISH_GIRA_FETCH';
const $848ef1328a091c81$export$3a9e4a905dec520d = 'ISSUE_MOUNTED';
const $848ef1328a091c81$export$7f7b606f70e669e6 = 'ISSUE_RENDERED';
const $848ef1328a091c81$export$b292c195104c50d3 = 'ISSUE_LEGACY_INTERACTIVE';
const $848ef1328a091c81$export$434b58ebadf14df2 = 'ISSUE_SPA_MARKED_READY_END_OF_CRITICAL_PATH';
const $848ef1328a091c81$export$4d1080224e02ef0b = 'LCP_CANDIDATE';
const $848ef1328a091c81$export$a98a3196940af8fa = 'issueViewCriticalData-agg-suspense';
const $848ef1328a091c81$export$7b35970640b1e1c0 = 'issueViewCriticalData-gira-suspense';
const $848ef1328a091c81$export$1ea0ab50283b82a8 = 'issueViewCriticalData-redux';

parcelRegister("RvFPW", function(module, exports) {

$parcel$export(module.exports, "clearFetchIssueNetworkTimes", () => $65ddff06319f9633$export$8d777cefeb6b914e);
$parcel$export(module.exports, "getFetchIssueNetworkTimes", () => $65ddff06319f9633$export$48cecd0d00931806);

var $8uNQc = parcelRequire("8uNQc");
var $8ITzY = parcelRequire("8ITzY");

var $cUHte = parcelRequire("cUHte");
const $65ddff06319f9633$var$fetchIssueNetworkMarks = [
    (0, $cUHte.fetchUploadPerf),
    (0, $cUHte.fetchCommentsPerf),
    (0, $cUHte.fetchIssuePropertiesPerf),
    (0, $cUHte.fetchIssueLinkPerf),
    (0, $cUHte.fetchViewContextPerf),
    (0, $cUHte.fetchSubtaskTypesPerf),
    (0, $cUHte.fetchFieldDataPerf),
    (0, $cUHte.fetchUserAuthPerf)
];
// Data remains the same once called once (for the same issue), so we cache it
// here for future requests for this data due to the calculation wiping the
//  performance marks required to calculate.  It does however need to be reset
// in cases like subtask click throughs when we load a new issue.
let $65ddff06319f9633$var$fetchIssueNetworkTimes;
const $65ddff06319f9633$var$calculateFetchIssueNetworkTimes = ()=>{
    const issueNetworkTimes = $65ddff06319f9633$var$fetchIssueNetworkMarks.reduce((obj, perf)=>{
        const beginMarkName = `BEGIN_${perf.prefix}_${perf.key}`;
        const endMarkName = `END_${perf.prefix}_${perf.key}`;
        const networkTime = (0, $8ITzY.timeBetweenMarks)(beginMarkName, endMarkName);
        if (networkTime != null && networkTime > 0) {
            // eslint-disable-next-line jira/js/no-reduce-accumulator-spread
            const aggregated = {
                ...obj,
                [`${perf.key}_NETWORK`]: networkTime
            };
            // This is vital to clear mark after use.  Or next call will failed to add the mark of same name.
            if ((0, $8uNQc.default).clearMarks) {
                (0, $8uNQc.default).clearMarks(beginMarkName);
                (0, $8uNQc.default).clearMarks(endMarkName);
            }
            return aggregated;
        }
        return obj;
    }, {});
    return issueNetworkTimes;
};
const $65ddff06319f9633$export$8d777cefeb6b914e = ()=>{
    $65ddff06319f9633$var$fetchIssueNetworkMarks.forEach((perf)=>{
        const beginMarkName = `BEGIN_${perf.prefix}_${perf.key}`;
        const endMarkName = `END_${perf.prefix}_${perf.key}`;
        if ((0, $8uNQc.default).clearMarks) {
            (0, $8uNQc.default).clearMarks(beginMarkName);
            (0, $8uNQc.default).clearMarks(endMarkName);
        }
    });
    $65ddff06319f9633$var$fetchIssueNetworkTimes = null;
    window.ISSUE_DATA_AVAILABLE = null;
};
const $65ddff06319f9633$export$48cecd0d00931806 = ()=>{
    if (!$65ddff06319f9633$var$fetchIssueNetworkTimes) $65ddff06319f9633$var$fetchIssueNetworkTimes = $65ddff06319f9633$var$calculateFetchIssueNetworkTimes();
    return $65ddff06319f9633$var$fetchIssueNetworkTimes;
};

});
parcelRegister("cUHte", function(module, exports) {

$parcel$export(module.exports, "fetchFieldDataPerf", () => $e54dd57964efa8b8$export$b97d963a8496fa2f);
$parcel$export(module.exports, "fetchCommentsPerf", () => $e54dd57964efa8b8$export$179836a99669cbe7);
$parcel$export(module.exports, "fetchIssueLinkPerf", () => $e54dd57964efa8b8$export$8d0984a0f9f31117);
$parcel$export(module.exports, "fetchSubtaskTypesPerf", () => $e54dd57964efa8b8$export$c1324bd586e9a53a);
$parcel$export(module.exports, "fetchUploadPerf", () => $e54dd57964efa8b8$export$72fcc6cb1cdc70e0);
$parcel$export(module.exports, "fetchUserAuthPerf", () => $e54dd57964efa8b8$export$4052b1eae3373c3b);
$parcel$export(module.exports, "fetchViewContextPerf", () => $e54dd57964efa8b8$export$b4e2588a18d8d980);
$parcel$export(module.exports, "fetchIssuePropertiesPerf", () => $e54dd57964efa8b8$export$2ee73dd298bdfe8a);
const $e54dd57964efa8b8$var$ISSUE_DETAILS_ANALYTICS_PREFIX = 'ISSUE_DETAILS';
const $e54dd57964efa8b8$var$FETCH_FIELD_DATA_REQUEST = 'FETCH_FIELD_DATA';
const $e54dd57964efa8b8$var$FETCH_INITIAL_COMMENTS_REQUEST = 'FETCH_INITIAL_COMMENTS';
const $e54dd57964efa8b8$var$FETCH_ISSUE_LINK_TYPES_REQUEST = 'FETCH_ISSUE_LINK_TYPES';
const $e54dd57964efa8b8$var$FETCH_SUBTASK_TYPES_REQUEST = 'FETCH_SUBTASK_TYPES';
const $e54dd57964efa8b8$var$FETCH_UPLOAD_CONTEXT_REQUEST = 'FETCH_LOAD_CONTEXT';
const $e54dd57964efa8b8$var$FETCH_USER_AUTH_REQUEST = 'FETCH_USER_AUTH';
const $e54dd57964efa8b8$var$FETCH_VIEW_CONTEXT_REQUEST = 'FETCH_VIEW_CONTEXT';
const $e54dd57964efa8b8$var$FETCH_ISSUE_PROPERTIES_REQUEST = 'FETCH_ISSUE_PROPERTIES';
const $e54dd57964efa8b8$export$b97d963a8496fa2f = {
    key: $e54dd57964efa8b8$var$FETCH_FIELD_DATA_REQUEST,
    prefix: $e54dd57964efa8b8$var$ISSUE_DETAILS_ANALYTICS_PREFIX
};
const $e54dd57964efa8b8$export$179836a99669cbe7 = {
    key: $e54dd57964efa8b8$var$FETCH_INITIAL_COMMENTS_REQUEST,
    prefix: $e54dd57964efa8b8$var$ISSUE_DETAILS_ANALYTICS_PREFIX
};
const $e54dd57964efa8b8$export$8d0984a0f9f31117 = {
    key: $e54dd57964efa8b8$var$FETCH_ISSUE_LINK_TYPES_REQUEST,
    prefix: $e54dd57964efa8b8$var$ISSUE_DETAILS_ANALYTICS_PREFIX
};
const $e54dd57964efa8b8$export$c1324bd586e9a53a = {
    key: $e54dd57964efa8b8$var$FETCH_SUBTASK_TYPES_REQUEST,
    prefix: $e54dd57964efa8b8$var$ISSUE_DETAILS_ANALYTICS_PREFIX
};
const $e54dd57964efa8b8$export$72fcc6cb1cdc70e0 = {
    key: $e54dd57964efa8b8$var$FETCH_UPLOAD_CONTEXT_REQUEST,
    prefix: $e54dd57964efa8b8$var$ISSUE_DETAILS_ANALYTICS_PREFIX
};
const $e54dd57964efa8b8$export$4052b1eae3373c3b = {
    key: $e54dd57964efa8b8$var$FETCH_USER_AUTH_REQUEST,
    prefix: $e54dd57964efa8b8$var$ISSUE_DETAILS_ANALYTICS_PREFIX
};
const $e54dd57964efa8b8$export$b4e2588a18d8d980 = {
    key: $e54dd57964efa8b8$var$FETCH_VIEW_CONTEXT_REQUEST,
    prefix: $e54dd57964efa8b8$var$ISSUE_DETAILS_ANALYTICS_PREFIX
};
const $e54dd57964efa8b8$export$2ee73dd298bdfe8a = {
    key: $e54dd57964efa8b8$var$FETCH_ISSUE_PROPERTIES_REQUEST,
    prefix: $e54dd57964efa8b8$var$ISSUE_DETAILS_ANALYTICS_PREFIX
};

});


parcelRegister("g0N0Z", function(module, exports) {

$parcel$export(module.exports, "issueViewLoad", () => $95fa1cd4aae1a34f$export$49371c2cc4aaa4f6);
$parcel$export(module.exports, "issueViewOnPageLoad", () => $95fa1cd4aae1a34f$export$2f6837d06b669285);
$parcel$export(module.exports, "embeddedIssueViewLoad", () => $95fa1cd4aae1a34f$export$9d773f01a8da623e);
$parcel$export(module.exports, "epicDropdownOpenInteraction", () => $95fa1cd4aae1a34f$export$8d33579ffe76aa5b);
$parcel$export(module.exports, "epicModalOpenInteraction", () => $95fa1cd4aae1a34f$export$8f0deabe791d5bb9);

var $lNfG4 = parcelRequire("lNfG4");

const $95fa1cd4aae1a34f$export$49371c2cc4aaa4f6 = (0, $lNfG4.metrics).custom({
    key: 'issue-view-load',
    virtual: true,
    timings: [
        {
            key: 'legacy-tti-2021',
            startMark: 'metrics_init',
            endMark: $848ef1328a091c81$export$b292c195104c50d3
        },
        {
            key: 'timeBlockedOnBackend',
            startMark: $848ef1328a091c81$export$e64e32643802b552,
            endMark: $848ef1328a091c81$export$e52cc35f872875f7
        }
    ]
});
const $95fa1cd4aae1a34f$export$2f6837d06b669285 = (0, $lNfG4.metrics).custom({
    key: 'issue-view-on-page-load',
    timings: [
        {
            key: 'issue-mounted',
            endMark: $848ef1328a091c81$export$3a9e4a905dec520d
        },
        {
            key: 'latest-lcp',
            endMark: $848ef1328a091c81$export$4d1080224e02ef0b
        }
    ]
});
const $95fa1cd4aae1a34f$export$9d773f01a8da623e = (0, $lNfG4.metrics).custom({
    key: 'embedded-issue-view-load',
    until: $95fa1cd4aae1a34f$export$49371c2cc4aaa4f6,
    include: [
        $95fa1cd4aae1a34f$export$49371c2cc4aaa4f6
    ]
});
const $95fa1cd4aae1a34f$export$1e32b6c8e1e31a3d = (0, $lNfG4.metrics).pageLoad({
    key: 'service-management.queues.issue'
});
const $95fa1cd4aae1a34f$export$4be279014c4d8d39 = (0, $lNfG4.metrics).pageLoad({
    key: 'service-management.reports.issue'
});
const $95fa1cd4aae1a34f$export$8d33579ffe76aa5b = (0, $lNfG4.metrics).interaction({
    key: 'issue-epic-dropdown-menu-open'
});
const $95fa1cd4aae1a34f$export$8f0deabe791d5bb9 = (0, $lNfG4.metrics).interaction({
    key: 'issue-epic-modal-open'
});

});

parcelRegister("8Bhia", function(module, exports) {

$parcel$export(module.exports, "isIssueFetchEpicPrefetchedAGGQueryLoggingEnabled", () => $706d7ea06981f598$export$7af43b56ceb4b148);
$parcel$export(module.exports, "isGiraAGGConsistencyCheckEnabled", () => $706d7ea06981f598$export$3c97eb4b6ff2fec1);
$parcel$export(module.exports, "isJiraIssueViewEditorAIEnabled", () => $706d7ea06981f598$export$183bff9fcee964a2);
$parcel$export(module.exports, "isSwitcherooRealtimeExposuresTestFlagEnabled", () => $706d7ea06981f598$export$a73c9c09ec24e5e9);
$parcel$export(module.exports, "isJsmTimelineEnabled", () => $706d7ea06981f598$export$575e1bf822db15b5);
$parcel$export(module.exports, "isBM3EmitOnRafTopExperiencesEnabled", () => $706d7ea06981f598$export$ee410f0ba32dc900);
$parcel$export(module.exports, "isIssueViewWhiteboardsStandaloneEnabled", () => $706d7ea06981f598$export$6f64fb042a8db7d9);
$parcel$export(module.exports, "isWhiteboardStandaloneEnabled", () => $706d7ea06981f598$export$18b62f1e8801aa0f);
$parcel$export(module.exports, "isCrossJoinContentPreviewEnabled", () => $706d7ea06981f598$export$ce9fb45735ec88ee);
$parcel$export(module.exports, "isIdeaViewSidebarEnabled", () => $706d7ea06981f598$export$dcf527cccb1a409e);
$parcel$export(module.exports, "isForgeUiModificationsScreenTabsSupportEnabled", () => $706d7ea06981f598$export$1ee1f7892e4153f2);
/**
 * Feature flags convention: go/frontend-feature-flags
 */ 
var $1Iui1 = parcelRequire("1Iui1");

var $79xbN = parcelRequire("79xbN");

var $1ybV0 = parcelRequire("1ybV0");

const $706d7ea06981f598$export$58be025db0b41bcd = ()=>(0, $1ybV0.ff)('issue.remove-viewed-activityfeeddropdown-event_bbdu1');
const $706d7ea06981f598$export$7329e4497cd10299 = ()=>(0, $1ybV0.ff)('issue.details.issue-view-fields-rendering-slo_zycrv');
const $706d7ea06981f598$export$a3c054fb0bd7cd31 = ()=>(0, $1ybV0.ff)('jira-issue-view-activity-feed-temp-metrics_hpdjz');
const $706d7ea06981f598$export$b5be9eaa7fce369 = ()=>(0, $1ybV0.ff)('configurable-child-issues-panel_3ht06', false);
const $706d7ea06981f598$export$d2c19c8f5c517423 = ()=>(0, $1ybV0.ff)('fix-issueviewload-start-timing-for-new-browser-metric-version_ahdhr', false);
const $706d7ea06981f598$export$6e4f76cd76a804da = ()=>(0, $1ybV0.ff)('ecosystem_content_panel_lhs_6eptr');
const $706d7ea06981f598$export$7f7b600c4eafe68f = ()=>(0, $1ybV0.ff)('issue_view_quick_actions_revamp_l8mbx');
const $706d7ea06981f598$export$e1597a137164ba25 = ()=>(0, $1ybV0.ff)('show-new-issue-transition-flags_az3ds');
const $706d7ea06981f598$export$c8aa8a13c42858dd = ()=>(0, $1ybV0.ff)('jira-issue-history-data-classification_mhyjw', false);
const $706d7ea06981f598$export$e1778b5c613f3812 = ()=>(0, $1ybV0.ff)('issue-view-add-issueid-in-key-in-ecosystem-module_mf4a8', false);
const $706d7ea06981f598$export$6942cbfdc0a232ef = ()=>(0, $1ybV0.ff)('ken-767-create-issue-history-slo_iupy2', false);
const $706d7ea06981f598$export$3041d162b6562717 = ()=>(0, $1ybV0.ff)('create-linked-issues-trigger-point-issue-view', false);
const $706d7ea06981f598$export$7af43b56ceb4b148 = ()=>(0, $1ybV0.ff)('issue.details.issue-fetch-epic-prefetched-agg-query-logging', false);
const $706d7ea06981f598$export$91d9e9331bcb489f = ()=>(0, $1ybV0.ff)('issue.details.relay-cascading-select-field-issue-view-layout-integration');
const $706d7ea06981f598$export$4bef98bf98ff2cb = ()=>(0, $1ybV0.ff)('issue.details.migration-migrated-stream', false);
const $706d7ea06981f598$export$3c97eb4b6ff2fec1 = ()=>(0, $1ybV0.getMultivariateFeatureFlag)('issue.details.gira-agg-consistency-check-master-flag', 'OLD', [
        'OLD',
        'NEW',
        'CHECK',
        'CHECK_RETURN_NEW'
    ]) === 'CHECK';
const $706d7ea06981f598$export$183bff9fcee964a2 = ()=>(0, $1ybV0.ff)('issue.details.jira-issue-view-editor-ai_sozy', false);
const $706d7ea06981f598$export$bb7bcfe9ba7992e5 = ()=>(0, $1ybV0.ff)('jira-intelligent-issue-breakdown_18syl', false);
const $706d7ea06981f598$export$be02cc41570f884f = ()=>(0, $1ybV0.ff)('issue.details.jira-smart-summary-platform_0jta9', false);
const $706d7ea06981f598$export$25f1a380ac523ab1 = ()=>(0, $1ybV0.ff)('jira-ai-work-breakdown-onboarding', false);
const $706d7ea06981f598$export$b1c6c927b1de3746 = ()=>(0, $1ybV0.ff)('issue.details.feature-flags-to-slo-analytics', false);
const $706d7ea06981f598$export$4166161ebaa7c45b = ()=>(0, $1ybV0.ff)('issue-view-a11y-for-issue-key-strikethrough_3xavq', false);
const $706d7ea06981f598$export$c3e066f7be7868e8 = ()=>(0, $1ybV0.ff)('issue-view-remove-connect-operations-from-critical-fetch_vtk4w');
const $706d7ea06981f598$export$a3e5d5dfe1ed90ed = ()=>(0, $1ybV0.ff)('issue.details.media-inline', false);
const $706d7ea06981f598$export$d7d142f5ac020394 = ()=>(0, $1ybV0.ff)('jira.teams.enable-new-custom-field-types', false);
const $706d7ea06981f598$export$cdd5c612352d7bf0 = ()=>(0, $1ybV0.getMultivariateFeatureFlag)('invite.from.assign', (0, $1Iui1.NOT_ENROLLED), [
        (0, $1Iui1.CONTROL),
        (0, $1Iui1.NOT_ENROLLED),
        (0, $1Iui1.VARIATION)
    ]) === (0, $1Iui1.VARIATION);
const $706d7ea06981f598$export$5b9220081498abd7 = ()=>(0, $1ybV0.getMultivariateFeatureFlag)('invite.from.assign.modal', 'not-enrolled', [
        'control',
        'not-enrolled',
        'variation'
    ]);
const $706d7ea06981f598$export$89f18660d3a3bb78 = ()=>(0, $1ybV0.ff)('invite.from.assign.modal.fe.event', false);
const $706d7ea06981f598$export$dcc4742bc52ec465 = ()=>(0, $1ybV0.ff)('comment-limit-exceed-warning-flag_3rx53', false);
const $706d7ea06981f598$export$fa2b2d3091ee4acb = ()=>(0, $1ybV0.ff)('worklog-limit-exceed-warning-flag_hh86h', false);
const $706d7ea06981f598$export$8138f2ec6e2b730c = ()=>(0, $1ybV0.ff)('confluence-link-limit-exceed-warning-flag_1ycku', false);
const $706d7ea06981f598$export$d0ed2d8440fb5bbc = ()=>(0, $1ybV0.ff)('issue.details.hard-limits.milestone-1');
const $706d7ea06981f598$export$41470180bace44ba = ()=>(0, $1ybV0.ff)('issue.details.hard-limits.issue-remote-link');
const $706d7ea06981f598$export$9a5cf06e051f6deb = ()=>(0, $1ybV0.ff)('issue.details.hard-limits.issue-attachments-limit');
const $706d7ea06981f598$export$e3bcb7ed6340e909 = ()=>(0, $1ybV0.ff)('issue.details.hard-limits.issue-weblinks-limit');
const $706d7ea06981f598$export$a0e01c32249a7097 = ()=>(0, $1ybV0.ff)('parent-field-changeboarding_4ljdy', false);
const $706d7ea06981f598$export$dbaa92a1f690c8fe = ()=>(0, $1ybV0.ff)('issue.details.display-flag-on-optimistic-weblinks-error');
const $706d7ea06981f598$export$78dd97cfaffb6fb1 = ()=>(0, $1ybV0.getFeatureFlagValue)('issue.details.editor.performance-tracking', {});
const $706d7ea06981f598$export$a801da94b6dd586b = ()=>{
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    const value = (0, $1ybV0.getFeatureFlagValue)('issue.details.editor.valid-transactions-tracking', {});
    // workaround as editor is interpreting an empty object as enabled: https://product-fabric.atlassian.net/browse/ED-12432
    const enabled = typeof value === 'object' && Object.keys(value).length;
    return enabled ? value : undefined;
};
const $706d7ea06981f598$export$fd99e03c299972d3 = ()=>(0, $1ybV0.ff)('issue.details.editor.ufo', false);
const $706d7ea06981f598$export$6fb6e5d98b15585b = ()=>// eslint-disable-next-line @typescript-eslint/no-explicit-any
    (0, $1ybV0.getFeatureFlagValue)('issue.details.renderer.ttr-severity-tracking', {});
const $706d7ea06981f598$export$eccecfefbd48225b = ()=>// eslint-disable-next-line @typescript-eslint/no-explicit-any
    (0, $1ybV0.getFeatureFlagValue)('issue.details.renderer.unsupported-content-levels-tracking', {});
const $706d7ea06981f598$export$ef24e9eecc594777 = ()=>(0, $1ybV0.ff)('issue.details.renderer.spec-based-validator');
const $706d7ea06981f598$export$67305b99ef59566c = ()=>(0, $1ybV0.ff)('project.config.pce.modern.global-issue-create.trigger', false);
const $706d7ea06981f598$export$fa44fb942e45b85d = ()=>(0, $1ybV0.ff)('create-linked-issues-trigger-point-issue-view', false);
const $706d7ea06981f598$export$9ba0da55e7f403e1 = ()=>(0, $1ybV0.ff)('project.config.pce.modern.global-subtask-issue-create-trigger', false);
const $706d7ea06981f598$export$dbaf42ba39b66293 = ()=>$706d7ea06981f598$export$67305b99ef59566c() && $706d7ea06981f598$export$9ba0da55e7f403e1();
const $706d7ea06981f598$export$5dc774c58824d858 = ()=>(0, $1ybV0.ff)('proforma-harmonisation-main_ca6ff', false);
const $706d7ea06981f598$export$73957227bab0d3f7 = ()=>(0, $1ybV0.ff)('hide-epic-link-from-issue-view-for-epic-renaming-beta_r1g77', false);
const $706d7ea06981f598$export$dd5401dbc8bdbdfb = ()=>(0, $1ybV0.ff)('disable-epic-link-and-parent-link-fields-in-issue-view-and-gic_zixrt', false);
const $706d7ea06981f598$export$c197f8974183a4f0 = ()=>(0, $1ybV0.ff)('request-isdone-when-requesting-parent-candidates-and-display-in-parent-field_3becy', false);
const $706d7ea06981f598$export$6e06c78fd874f07f = ()=>(0, $1ybV0.ff)('remove-parent-link-from-issue-view_4t7dy', false);
const $706d7ea06981f598$export$9c7fa56ed1fa2e15 = ()=>(0, $1ybV0.ff)('parent-field-in-issue-view_x4zn4', false);
const $706d7ea06981f598$export$33e603f2e83329f5 = ()=>(0, $1ybV0.ff)('com.atlassian.rm.jpo.jpo3cloud.increment-planning-board-m1', false);
const $706d7ea06981f598$export$a73c9c09ec24e5e9 = ()=>(0, $1ybV0.ff)('switcheroo-realtime-exposures-test-flag_648u4', false);
const $706d7ea06981f598$export$bfc00b5a0f36c863 = ()=>(0, $1ybV0.ff)('issue-view-placeholder-end-user-request-modal_myc7n', false);
const $706d7ea06981f598$export$fff49f3f84d869e5 = ()=>(0, $1ybV0.ff)('confluence-template-placeholder_2bhgf', false);
const $706d7ea06981f598$export$e9544b00b7cb5703 = ()=>(0, $1ybV0.ff)('relay-migration-issue-fields-events-transformer-ld', false);
const $706d7ea06981f598$export$7c0bd221ecbf9b57 = ()=>()=>(0, $1ybV0.ff)('compal-issue-actions-follow-up-improvements_y49xu', false);
const $706d7ea06981f598$export$d5d401f0a31e62ea = ()=>()=>(0, $1ybV0.ff)('compal-issue-actions-very-high-priority_f5w5r', false);
const $706d7ea06981f598$export$6df7a6ecffbd200 = ()=>(0, $1ybV0.ff)('relay-migration-issue-fields-soft-refresh-ld');
const $706d7ea06981f598$export$6c3661f793bf9d1 = ()=>(0, $1ybV0.ff)('relay-migration-issue-fields-priority_ri9vi');
const $706d7ea06981f598$export$7000df6bbe3f5099 = ()=>(0, $1ybV0.ff)('relay-migration-issue-fields-reporter_jfzs2');
const $706d7ea06981f598$export$e253ac70cea0d36b = ()=>(0, $1ybV0.ff)('issue.details.follow-up-relay-multi-select-field-issue-view-integration', false);
const $706d7ea06981f598$export$12afaf05e3ffffed = ()=>(0, $1ybV0.ff)('issue.details.fix-issue-status-transition-loading_6s8n8', false);
const $706d7ea06981f598$export$47d240e96e9bc1b3 = ()=>(0, $1ybV0.ff)('issue.details.fix-incorrect-state-closed-sprint-field_mpzbh', false);
const $706d7ea06981f598$export$5194de77e8750c41 = ()=>(0, $1ybV0.ff)('jira-issue-view-smart-summary-onboarding_jmzm7', false);
const $706d7ea06981f598$export$7e4aef4ae0b914e2 = ()=>(0, $1ybV0.ff)('enable-jsm-smart-request-summary_kva1r', false);
const $706d7ea06981f598$export$9591540fa082da5a = ()=>(0, $1ybV0.ff)('editor.renderer-alt-text-on-images', false);
const $706d7ea06981f598$export$e6ec1a9a62cbf071 = 'issue.details.sorting-pinned-fields';
const $706d7ea06981f598$export$cce5c39a2a1dacf1 = ()=>(0, $1ybV0.ff)('issue.details.sorting-pinned-fields', false);
const $706d7ea06981f598$export$408491224a0c915b = ()=>(0, $1ybV0.ff)('issue.details.editor.enable-flexible-block-card');
const $706d7ea06981f598$export$150e448c819201a7 = ()=>(0, $1ybV0.ff)('jira.frontend.ptc.team-field-in-subtasks', false);
const $706d7ea06981f598$export$369fa0ed6b2504fb = ()=>(0, $1ybV0.ff)('offeringcataloguefeatures-resource-layer-in-frontend_o5pnu', false);
const $706d7ea06981f598$export$b236d4b6aec7c4c3 = ()=>(0, $1ybV0.ff)('issue.details.renderer.tti-tracking', false);
const $706d7ea06981f598$export$a792a3f88a852f06 = ()=>(0, $1ybV0.ff)('sea-2830-improve-accessibility-of-priority-field-in-backlog-card_k53tq', false);
const $706d7ea06981f598$export$575e1bf822db15b5 = ()=>(0, $1ybV0.ff)('jsm-timelines-phase-2_70gja', false);
const $706d7ea06981f598$export$9f71233b08c04922 = ()=>(0, $1ybV0.ff)('jsm-canned-response', false);
const $706d7ea06981f598$export$8521761ebcf26351 = ()=>(0, $1ybV0.ff)('jsm-agent-signature-cr-enabled', false);
const $706d7ea06981f598$export$6f0be57bd65ee8bc = ()=>(0, $1ybV0.ff)('responders-field-in-all-projects-issues-ui', false);
const $706d7ea06981f598$export$e3bafd4acea73c60 = ()=>{
    const experiences = (0, $1ybV0.getFeatureFlagValue)('odin.ec.client.integration.issueview', '');
    return experiences.length > 0;
};
const $706d7ea06981f598$export$317ab03e75769d4f = ()=>(0, $1ybV0.ff)('ken-545-display-hide-when-empty-button-to-user-_fjpw9');
const $706d7ea06981f598$export$6d1f8ae8cf9bbc71 = ()=>(0, $1ybV0.ff)('ken-429-restrict-4xx-error_vi8v7', false);
const $706d7ea06981f598$export$3fa1b10a7b484874 = ()=>(0, $1ybV0.ff)('ken-432-missing-project-key-log_hr7zv', false);
const $706d7ea06981f598$export$6604067817758030 = ()=>{
    const featureFlagValue = (0, $1ybV0.getMultivariateFeatureFlag)('issue.details.gira-agg-migration-isarchived', 'OLD', [
        'OLD',
        'NEW',
        'CHECK',
        'CHECK_RETURN_NEW'
    ]);
    return featureFlagValue === 'NEW' || featureFlagValue === 'CHECK_RETURN_NEW' || featureFlagValue === 'CHECK';
};
const $706d7ea06981f598$export$c108c03095e0e655 = ()=>(0, $1ybV0.ff)('enable-archived-issues-page-link', false);
const $706d7ea06981f598$export$ee410f0ba32dc900 = ()=>(0, $1ybV0.ff)('bm3.emit-on-raf.top-experiences', false);
const $706d7ea06981f598$export$3068bf83bd6f9396 = ()=>(0, $1ybV0.ff)('issue.details.custom-message-for-linking-with-no-permissions_k7qsn', false);
const $706d7ea06981f598$export$da019fa3d31e5c7e = ()=>(0, $1ybV0.ff)('issue-view.enable-search-by-email-in-multiselect-user-picker-field', false);
const $706d7ea06981f598$export$48d407f97269c8fa = ()=>(0, $1ybV0.ff)('issue.details.relay-release-version-field-issue-view-integration', false);
const $706d7ea06981f598$export$8a90e3b075447800 = ()=>(0, $1ybV0.ff)('issue.details.async-field-options-tech-debt', false);
const $706d7ea06981f598$export$bf10032e4a734a65 = {
    CROSS_FLOW: 'jira.issue-view.placeholder-template-cross-flow'
};
const $706d7ea06981f598$export$fb512d5beec30a90 = (experiment)=>experiment ? (0, $1ybV0.getMultivariateFeatureFlag)(experiment, (0, $1Iui1.NOT_ENROLLED), [
        (0, $3401608855dcf8dc$export$fb6fa89d43ed06f7),
        (0, $3401608855dcf8dc$export$c52ae1847ec8c2c),
        (0, $1Iui1.CONTROL),
        (0, $1Iui1.NOT_ENROLLED)
    ]) : (0, $1Iui1.NOT_ENROLLED);
const $706d7ea06981f598$export$6e7dfb06c9e45ae7 = ()=>[
        (0, $1Iui1.CONTROL),
        (0, $3401608855dcf8dc$export$fb6fa89d43ed06f7)
    ].includes($706d7ea06981f598$export$fb512d5beec30a90($706d7ea06981f598$export$bf10032e4a734a65.CROSS_FLOW));
const $706d7ea06981f598$export$ef28379ba310de6e = (experiment)=>$706d7ea06981f598$export$fb512d5beec30a90(experiment) === (0, $3401608855dcf8dc$export$fb6fa89d43ed06f7);
const $706d7ea06981f598$export$98dcb5ffd7beaf00 = ()=>(0, $1ybV0.ff)('jracloud-81255-stop-loading-field-config-twice_jfdek', false);
const $706d7ea06981f598$export$8ea052ed520b62bc = ()=>(0, $1ybV0.ff)('issue.details.non-critical-gira-query-experience-tracking', false);
const $706d7ea06981f598$export$496e94e3da873a49 = ()=>(0, $1ybV0.ff)('arken-1053-jira-forge-extension-changes-for-aegis_aws9x');
const $706d7ea06981f598$export$33008660eb5353ef = ()=>(0, $1ybV0.ff)('compass-components-in-jira-components_xw42u', false);
const $706d7ea06981f598$export$176e4d6701700463 = ()=>(0, $1ybV0.ff)('hide-icc-for-all-users_avyh5', false);
const $706d7ea06981f598$export$c567845e4f18ee11 = ()=>(0, $1ybV0.ff)('issue.details.issue-link-limit-exceed-warning-flag');
const $706d7ea06981f598$export$2b839c758c080224 = ()=>(0, $1ybV0.ff)('platform.embedded-confluence.jira-issue.create-confluence-pages', false);
const $706d7ea06981f598$export$7411486b04537f62 = ()=>(0, $1ybV0.ff)('issue-details-optimise-editor-onchange-calls_bb4fq', false);
const $706d7ea06981f598$export$ae2025957f2940e4 = ()=>(0, $1ybV0.ff)('platform.linking-platform.link-picker_tgrho', false);
const $706d7ea06981f598$export$1c607d9b866655e1 = ()=>(0, $1ybV0.ff)('platform.linking-platform.datasource-jira_issues', false);
const $706d7ea06981f598$export$8c74256e92f57afb = ()=>(0, $1ybV0.ff)('platform.linking-platform.use-new-editor-card-provider', false);
const $706d7ea06981f598$export$882e8ff421f7744c = ()=>(0, $1ybV0.ff)('devops_app_recommendation_on_link_paste', false) && (0, $79xbN.expValEquals)('devops_app_recommendation_on_link_paste', 'cohort', 'variation');
const $706d7ea06981f598$export$c3737cff1b9064df = ()=>(0, $1ybV0.ff)('issue-view-remove-backgroundscripts-from-critical-fetch_6f6on');
const $706d7ea06981f598$export$d4fe7150f9d83fa = ()=>(0, $1ybV0.ff)('jiv-14067-issue.details.gira-agg-migration-comments_pzao9', false);
const $706d7ea06981f598$export$f6bbc5e1c7a75195 = ()=>(0, $1ybV0.ff)('issue-jiv-14530-comments-consistency-check_x716d', false);
const $706d7ea06981f598$export$bc3ae4e1219a64e = ()=>(0, $1ybV0.ff)('jiv-18751-investigate-time-tracking-update-errors_ng38s');
const $706d7ea06981f598$export$5a53bba8e442c4f9 = ()=>(0, $1ybV0.ff)('issue.details.gira-agg-migration-attachments_ecebe', false);
const $706d7ea06981f598$export$6f64fb042a8db7d9 = ()=>(0, $1ybV0.ff)('jira-issue-view-whiteboards-standalone', false);
const $706d7ea06981f598$export$1f76c12fbdafb975 = ()=>(0, $1ybV0.ff)('nin-resizable-columns_8z4eo');
const $706d7ea06981f598$export$667dd70f296d7a79 = ()=>(0, $1ybV0.ff)('platform_embed-conf_jira-issue_create_cross-join', false);
const $706d7ea06981f598$export$8d9e5c2fc560d7fb = ()=>(0, $1ybV0.ff)('platform.embedded-confluence.jira-issue.linked-page-cross-join', false);
const $706d7ea06981f598$export$712b6916406c5e2a = ()=>(0, $1ybV0.ff)('platform_embed-conf_jira-issue_co-use', false);
const $706d7ea06981f598$export$60184d6d974595a9 = ()=>(0, $1ybV0.ff)('use-view-workflow-service-hook_8y6bk', false);
const $706d7ea06981f598$export$602a082cd6009b66 = ()=>(0, $1ybV0.ff)('hrz-716-integrate-goal-picker-into-issue-view', false);
const $706d7ea06981f598$export$590b056868f89976 = ()=>(0, $1ybV0.ff)('im-tokens-and-styled-components-migration_qpsld', false);
const $706d7ea06981f598$export$f67982569b9aab31 = ()=>(0, $1ybV0.ff)('issue-unarchival_wdpb9', false);
const $706d7ea06981f598$export$cd66b30e1a3ad3b0 = ()=>(0, $1ybV0.ff)('jsm-sentiment-analysis_1dage', false);
const $706d7ea06981f598$export$59aedb8bed66fbb5 = ()=>(0, $1ybV0.ff)('sentiment-custom-field', false);
const $706d7ea06981f598$export$e92cc7310d059d3e = ()=>(0, $1ybV0.ff)('dlp-gordian-enabled', false);
const $706d7ea06981f598$export$ab71258032925094 = ()=>(0, $1ybV0.ff)('issue-view-classification-level-editability_88zal', false);
const $706d7ea06981f598$export$5dbdd9e44df66fdb = ()=>(0, $1ybV0.ff)('jsm-restrict-internal-comment-visibility', false);
const $706d7ea06981f598$export$9e983b29015333eb = ()=>(0, $1ybV0.ff)('jiv-17158-agg-use-iseditableinview_8nogh', false);
const $706d7ea06981f598$export$418f24ad76008d74 = ()=>(0, $1ybV0.ff)('uim-cascading-select-field-support-gic_h1cda', false);
const $706d7ea06981f598$export$24744533e9559f1e = ()=>(0, $1ybV0.ff)('sprint-field-long-text-bug_fo95j', false);
const $706d7ea06981f598$export$614b1f6ee38ef8fe = ()=>(0, $1ybV0.ff)('selectable-field-edit-view-replace-select-with-footer_301u0', false);
const $706d7ea06981f598$export$8fa51a766c2ece72 = ()=>(0, $1ybV0.ff)('platform.embedded-confluence.jira-issue.create-confluence-content-crossflow', false);
const $706d7ea06981f598$export$68300000ff0840c3 = ()=>(0, $1ybV0.ff)('platform.linking-platform.smart-card.hover-card-ai-summaries', false);
const $706d7ea06981f598$export$1262b52679049b5e = ()=>(0, $1ybV0.ff)('jiv-18175-usemutation-for-remaining-estimate-field_ar10h', false);
const $706d7ea06981f598$export$d9ce3c80c1cc862d = ()=>(0, $1ybV0.ff)('jsw.xflow.issue-view-nudge-experiment', false);
const $706d7ea06981f598$export$9e54bab54faf7459 = ()=>(0, $1ybV0.ff)('convert-approvals-glance-to-collapsible-context-group_gqbgz', false);
const $706d7ea06981f598$export$4399c72174f6c25d = ()=>(0, $1ybV0.ff)('jsw.xflow.issue-view-nudge-experiment', false);
const $706d7ea06981f598$export$18b62f1e8801aa0f = ()=>(0, $1ybV0.ff)('jira-issue-view-whiteboards-standalone', false);
const $706d7ea06981f598$export$ce9fb45735ec88ee = ()=>(0, $1ybV0.ff)('platform.embedded-confluence.jira-issue.linked-page-cross-join', false);
const $706d7ea06981f598$export$31792eb3d1db9c94 = ()=>(0, $1ybV0.ff)('hide-issue-key-when-linked-issue-has-no-access_8nb8t');
const $706d7ea06981f598$export$e73f54d78d4ddfd8 = ()=>(0, $1ybV0.ff)('select-feedback-type-label_683rg', false);
const $706d7ea06981f598$export$653dc805d400e563 = ()=>(0, $1ybV0.ff)('custom-select-feedback-for-issue-view_y8h7f', false);
const $706d7ea06981f598$export$98975042f993a7b1 = ()=>(0, $1ybV0.ff)('assets-rearch-deprecate-attribute-value-id_ykukg', false);
const $706d7ea06981f598$export$7248d3c792741fe6 = ()=>(0, $1ybV0.ff)('fix-narrow-button-spacing-on-issue-actions_icmq8', false);
const $706d7ea06981f598$export$6ff28b2229a27899 = ()=>(0, $1ybV0.ff)('third_party_app_nudge_on_issues_watch', false) && (0, $79xbN.expValEquals)('third_party_app_nudge_on_issues_watch', 'cohort', 'variation');
const $706d7ea06981f598$export$aff6e532ec3ced01 = ()=>(0, $1ybV0.ff)('linked_mentioned_pages_handle_restricted_page_on_click', false);
const $706d7ea06981f598$export$d365d0b31e3df46e = ()=>(0, $1ybV0.ff)('jira.onboarding.kuro-5895', false);
const $706d7ea06981f598$export$c3c0abcc7a24c315 = ()=>(0, $1ybV0.ff)('polaris.jpd-panel-in-issue-view', false);
const $706d7ea06981f598$export$dcf527cccb1a409e = ()=>(0, $1ybV0.ff)('polaris.show-idea-sidebar-on-card-click_py19i', false);
const $706d7ea06981f598$export$fc627b9c964c8914 = ()=>(0, $1ybV0.ff)('adding-error-analytics-to-child-issue-panel-if-issue-types-array-is-empty_tb0ut', false);
const $706d7ea06981f598$export$757c7dfbd7ddcbdd = ()=>(0, $1ybV0.ff)('reminder-nudge-for-failed-xflow_z8l8q', false);
const $706d7ea06981f598$export$1ee1f7892e4153f2 = ()=>(0, $1ybV0.ff)('forge-ui-modifications-screentabs_qoa33', false);
const $706d7ea06981f598$export$44436302a680c0e0 = ()=>(0, $1ybV0.ff)('jira.issue-view.create-confluence-page.template-browser', false);
const $706d7ea06981f598$export$5696901bc5f2fcb6 = ()=>(0, $1ybV0.ff)('ui-modifications-issue-view-status-custom-field-support_hwx15', false);
const $706d7ea06981f598$export$f3c5e3944e08cc8a = ()=>(0, $1ybV0.ff)('placeholder-template-end-users-cross-flow-via-e2e-flow-killswitch_4bfgx', false);
const $706d7ea06981f598$export$ebdc109f22d5762d = ()=>(0, $1ybV0.ff)('fix-for-jracloud-84181_dm5fg', false);
const $706d7ea06981f598$export$3336aec97cc6ad82 = ()=>(0, $1ybV0.ff)('relay-migration-issue-fields-sprint_jozpu');
const $706d7ea06981f598$export$1ebd956541101430 = ()=>(0, $1ybV0.ff)('relay-migration-issue-fields-metadata_d42b0');
const $706d7ea06981f598$export$2f960bba67ffb99d = ()=>(0, $1ybV0.ff)('issue.details.embedded-confluence.jira-issue.auto-link-pages-on-link-paste', false);
const $706d7ea06981f598$export$f523e13f8d29cd4d = ()=>(0, $1ybV0.ff)('relay-migration-issue-fields-assignee-ld', false);
const $706d7ea06981f598$export$d51d9f0f8bb8e5d5 = ()=>(0, $1ybV0.ff)('relay-migration-issue-fields-number_q0em4', false);
const $706d7ea06981f598$export$d7b1ba16033dcdd4 = ()=>(0, $1ybV0.ff)('loom-issue-view-record-video-button_o1hra', false);
const $706d7ea06981f598$export$b496d047520756aa = ()=>(0, $1ybV0.ff)('uim-orginal-estimate-field-support_ugzqt', false);
const $706d7ea06981f598$export$ae1c98a76fd367f1 = ()=>(0, $1ybV0.ff)('bifrost.playbooks-in-issue-view_lv7b2', false);
const $706d7ea06981f598$export$b15e700f73951a90 = ()=>(0, $1ybV0.ff)('compiled-react-migration-issue-view_zilee', false);
const $706d7ea06981f598$export$3215b3331a7b187a = ()=>(0, $1ybV0.ff)('compiled-react-migration-issue-view_u9myz', false);
const $706d7ea06981f598$export$a465afdb16c2fb1e = ()=>(0, $1ybV0.ff)('enable_jsm_repackaging_changes_vtwk9', false);
const $706d7ea06981f598$export$b8f1556e1f953f8d = ()=>(0, $1ybV0.ff)('compal-sunset-and-remove-dot-menu_66j8q', false);
const $706d7ea06981f598$export$7262f08c93e522ee = ()=>(0, $1ybV0.ff)('compal-dot-menu-shortcut-integration_dvvg2', false);
const $706d7ea06981f598$export$39e338620e4f1561 = ()=>(0, $1ybV0.ff)('relay-migration-issue-fields-single-line-text_in6w6', false);
const $706d7ea06981f598$export$fb62da0fafc1b47b = ()=>(0, $1ybV0.ff)('relay-migration-issue-fields-date_ptj72', false);
const $706d7ea06981f598$export$b41fe6134b9dd04b = ()=>(0, $1ybV0.ff)('relay-migration-issue-fields-project-select_w0xem', false);
const $706d7ea06981f598$export$d705591f59096b16 = ()=>(0, $1ybV0.ff)('add-team-id-analytics-data');
const $706d7ea06981f598$export$386ddedc27abb46a = ()=>(0, $1ybV0.ff)('relay-migration-issue-fields-date-time_eaqd2', false);
const $706d7ea06981f598$export$8fac1563227555f2 = ()=>(0, $1ybV0.ff)('polaris.jpd-panel-filter-by-delivery-link-type', false);
const $706d7ea06981f598$export$b4501966f3d67615 = ()=>(0, $1ybV0.ff)('relay-migration-issue-fields-url_ob8uu', false);
const $706d7ea06981f598$export$51e354a6287b4e6f = ()=>(0, $1ybV0.ff)('relay-migration-issue-fields-summary_eog1v', false); // <relay-code-gen-Summary>

});
parcelRegister("1Iui1", function(module, exports) {

$parcel$export(module.exports, "COHORT", () => $1524157debf2fd00$export$3d370c33621572df);
$parcel$export(module.exports, "NOT_ENROLLED", () => $1524157debf2fd00$export$5b7423264d48ab04);
$parcel$export(module.exports, "CONTROL", () => $1524157debf2fd00$export$43f367b3e957f219);
$parcel$export(module.exports, "EXPERIMENT", () => $1524157debf2fd00$export$9ba2bc3b1bdc1519);
$parcel$export(module.exports, "VARIATION", () => $1524157debf2fd00$export$fa04ad826acc90da);

var $1ybV0 = parcelRequire("1ybV0");
const $1524157debf2fd00$export$3d370c33621572df = 'cohort';
const $1524157debf2fd00$export$5b7423264d48ab04 = 'not-enrolled';
const $1524157debf2fd00$export$43f367b3e957f219 = 'control';
const $1524157debf2fd00$export$9ba2bc3b1bdc1519 = 'experiment';
const $1524157debf2fd00$export$fa04ad826acc90da = 'variation';
const $1524157debf2fd00$export$6486974e39493fa6 = 'variation-1';
const $1524157debf2fd00$export$7d994996134ad562 = 'variation-2';
const $1524157debf2fd00$export$795e7d69b248dcd0 = 'variation-3';
const $1524157debf2fd00$export$c9c947c57470b787 = 'variation-4';
const $1524157debf2fd00$var$DEFAULT_VALID_EXPERIMENT_GROUPS = [
    $1524157debf2fd00$export$5b7423264d48ab04,
    $1524157debf2fd00$export$43f367b3e957f219,
    $1524157debf2fd00$export$9ba2bc3b1bdc1519,
    $1524157debf2fd00$export$fa04ad826acc90da,
    $1524157debf2fd00$export$6486974e39493fa6,
    $1524157debf2fd00$export$7d994996134ad562,
    $1524157debf2fd00$export$795e7d69b248dcd0,
    $1524157debf2fd00$export$c9c947c57470b787
];
var // Use optionalValidExperimentGroups to further restrict the list of cohorts
// eslint-disable-next-line jira/import/no-anonymous-default-export
$1524157debf2fd00$export$2e2bcd8739ae039 = (experimentFeatureFlag, validExperimentGroups = $1524157debf2fd00$var$DEFAULT_VALID_EXPERIMENT_GROUPS)=>(0, $1ybV0.getMultivariateFeatureFlag)(experimentFeatureFlag, $1524157debf2fd00$export$5b7423264d48ab04, validExperimentGroups);

});

const $3401608855dcf8dc$export$fb6fa89d43ed06f7 = 'variant-contextual';
const $3401608855dcf8dc$export$c52ae1847ec8c2c = 'variant-contextual-not-enrolled';


parcelRegister("782cd", function(module, exports) {

$parcel$export(module.exports, "serverTimingSelector", () => $51fba4a554a079cc$export$a0b21c7e17057a47);

var $df4Sl = parcelRequire("df4Sl");

var $jZDJX = parcelRequire("jZDJX");
const $51fba4a554a079cc$export$8ef68fa2b28a6d0f = (state)=>state.timing;
const $51fba4a554a079cc$export$a0b21c7e17057a47 = (0, $df4Sl.createSelector)($51fba4a554a079cc$export$8ef68fa2b28a6d0f, (0, $jZDJX.isLoadingSelector), (timing, isLoading)=>isLoading ? undefined : timing.server);

});
parcelRegister("jZDJX", function(module, exports) {

$parcel$export(module.exports, "entitiesSelector", () => $ea753f2b3db28e48$export$ccebe5cc5854d0fa);
$parcel$export(module.exports, "projectSelector", () => $ea753f2b3db28e48$export$852a6c34ff1a2e77);
$parcel$export(module.exports, "uiSelector", () => $ea753f2b3db28e48$export$185c0864c82372e3);
$parcel$export(module.exports, "entitiesIssueSelector", () => $ea753f2b3db28e48$export$fa3ac1f794979805);
$parcel$export(module.exports, "entitiesRefreshedOnSelector", () => $ea753f2b3db28e48$export$c4ebdc93969b82cc);
$parcel$export(module.exports, "flagsSelector", () => $ea753f2b3db28e48$export$40cfdc5e96db7759);
$parcel$export(module.exports, "projectIdSelector", () => $ea753f2b3db28e48$export$4c9d6034f65d22f4);
$parcel$export(module.exports, "projectIdsSelector", () => $ea753f2b3db28e48$export$9edb3f63d1bd8546);
$parcel$export(module.exports, "projectKeySelector", () => $ea753f2b3db28e48$export$404de5ac601b84bc);
$parcel$export(module.exports, "projectTypeSelector", () => $ea753f2b3db28e48$export$69316f88206ca90b);
$parcel$export(module.exports, "isSimplifiedProjectSelector", () => $ea753f2b3db28e48$export$d94d544d4b2e1310);
$parcel$export(module.exports, "loggedInUserDetailsSelector", () => $ea753f2b3db28e48$export$b5a68452fc64275d);
$parcel$export(module.exports, "loggedInUserAvatarUrlSelector", () => $ea753f2b3db28e48$export$e0efa9c12379be7a);
$parcel$export(module.exports, "loggedInUserDisplayNameSelector", () => $ea753f2b3db28e48$export$4f56a07246719eb0);
$parcel$export(module.exports, "parentIssueEntitySelector", () => $ea753f2b3db28e48$export$e10c57d263d23c49);
$parcel$export(module.exports, "loggedInUserTimeZoneSelector", () => $ea753f2b3db28e48$export$ac6f9fd801c94fff);
$parcel$export(module.exports, "idSelector", () => $ea753f2b3db28e48$export$66c501bed2fcd648);
$parcel$export(module.exports, "isClassicProjectSelector", () => $ea753f2b3db28e48$export$45347d9f8a67561b);
$parcel$export(module.exports, "isLoadingSelector", () => $ea753f2b3db28e48$export$c077f23183070903);
$parcel$export(module.exports, "doNotUseIsLoadingPromiseSelector", () => $ea753f2b3db28e48$export$2ca9575c7da6bf18);
$parcel$export(module.exports, "isPreviewSelector", () => $ea753f2b3db28e48$export$b33a1a8958a8d805);
$parcel$export(module.exports, "isCompletedLoadingSelector", () => $ea753f2b3db28e48$export$9b99fb9e23fc133);
$parcel$export(module.exports, "loadingStageSelector", () => $ea753f2b3db28e48$export$18bc980d36bf93d);
$parcel$export(module.exports, "isDeleteIssueModalOpenSelector", () => $ea753f2b3db28e48$export$7cfd3e0dd7059b87);
$parcel$export(module.exports, "isDeletingIssueSelector", () => $ea753f2b3db28e48$export$d414d8eddcb409e4);
$parcel$export(module.exports, "didIssueDeleteFailSelector", () => $ea753f2b3db28e48$export$834732624d2c73e1);
$parcel$export(module.exports, "errorSelector", () => $ea753f2b3db28e48$export$47aec13333381be0);
$parcel$export(module.exports, "errorMessageSelector", () => $ea753f2b3db28e48$export$9b1097e17c0e6dc2);
$parcel$export(module.exports, "getUserByIdSelector", () => $ea753f2b3db28e48$export$801a2f2bd4059665);
$parcel$export(module.exports, "parentLevelIssuesSelector", () => $ea753f2b3db28e48$export$aa8980c49aba4478);
$parcel$export(module.exports, "baseAriSelector", () => $ea753f2b3db28e48$export$fa12ae06e35ebd67);
$parcel$export(module.exports, "issueAriSelector", () => $ea753f2b3db28e48$export$a2cdbba2136e72d3);
$parcel$export(module.exports, "epicLinkFieldKeySelector", () => $ea753f2b3db28e48$export$27abc48b8d528300);
$parcel$export(module.exports, "isEpicSelector", () => $ea753f2b3db28e48$export$6e8ebe94ad8bb62b);
$parcel$export(module.exports, "isServiceDeskSelector", () => $ea753f2b3db28e48$export$43d733e4b7e8c7d0);

var $df4Sl = parcelRequire("df4Sl");

var $7ZZxN = parcelRequire("7ZZxN");


var $f9RL0 = parcelRequire("f9RL0");

var $6vrw7 = parcelRequire("6vrw7");

var $5JqpU = parcelRequire("5JqpU");

var $fokFV = parcelRequire("fokFV");
const $ea753f2b3db28e48$export$ccebe5cc5854d0fa = (state)=>state.entities;
const $ea753f2b3db28e48$export$852a6c34ff1a2e77 = (0, $df4Sl.createSelector)($ea753f2b3db28e48$export$ccebe5cc5854d0fa, (entities)=>entities ? entities.project : null);
const $ea753f2b3db28e48$export$185c0864c82372e3 = (state)=>state.ui;
const $ea753f2b3db28e48$export$27493ac3d8611290 = (state)=>state.agile;
const $ea753f2b3db28e48$export$fa3ac1f794979805 = (0, $df4Sl.createSelector)($ea753f2b3db28e48$export$ccebe5cc5854d0fa, (entities)=>entities.issue);
const $ea753f2b3db28e48$export$c4ebdc93969b82cc = (0, $df4Sl.createSelector)($ea753f2b3db28e48$export$ccebe5cc5854d0fa, (entities)=>entities.refreshedOn);
const $ea753f2b3db28e48$export$40cfdc5e96db7759 = (0, $df4Sl.createSelector)($ea753f2b3db28e48$export$185c0864c82372e3, (ui)=>ui.flags);
const $ea753f2b3db28e48$export$4c9d6034f65d22f4 = (0, $df4Sl.createSelector)($ea753f2b3db28e48$export$852a6c34ff1a2e77, (project)=>project && project.projectId ? project.projectId : null);
const $ea753f2b3db28e48$export$9edb3f63d1bd8546 = (0, $df4Sl.createSelector)($ea753f2b3db28e48$export$852a6c34ff1a2e77, (project)=>project && project.projectId ? [
        project.projectId
    ] : []);
const $ea753f2b3db28e48$export$404de5ac601b84bc = (0, $df4Sl.createSelector)($ea753f2b3db28e48$export$852a6c34ff1a2e77, (project)=>project ? project.projectKey : null);
const $ea753f2b3db28e48$export$69316f88206ca90b = (0, $df4Sl.createSelector)($ea753f2b3db28e48$export$852a6c34ff1a2e77, (project)=>project && project.projectType ? project.projectType : null);
const $ea753f2b3db28e48$export$d94d544d4b2e1310 = (0, $df4Sl.createSelector)($ea753f2b3db28e48$export$852a6c34ff1a2e77, (project)=>!!project && project.isSimplified);
const $ea753f2b3db28e48$export$b5a68452fc64275d = (0, $df4Sl.createSelector)($ea753f2b3db28e48$export$ccebe5cc5854d0fa, (0, $5JqpU.accountIdloggedInUserSelector), (entities, loggedInAccountId)=>loggedInAccountId ? entities.users[loggedInAccountId] : null);
const $ea753f2b3db28e48$export$e0efa9c12379be7a = (0, $df4Sl.createSelector)($ea753f2b3db28e48$export$ccebe5cc5854d0fa, (0, $5JqpU.accountIdloggedInUserSelector), (entities, loggedInAccountId)=>{
    const loggedInUser = loggedInAccountId ? entities.users[loggedInAccountId] : null;
    return loggedInUser ? loggedInUser.avatarUrl : null;
});
const $ea753f2b3db28e48$export$4f56a07246719eb0 = (0, $df4Sl.createSelector)($ea753f2b3db28e48$export$ccebe5cc5854d0fa, (0, $5JqpU.accountIdloggedInUserSelector), (entities, loggedInAccountId)=>{
    const loggedInUser = loggedInAccountId ? entities.users[loggedInAccountId] : null;
    return loggedInUser ? loggedInUser.displayName : null;
});
const $ea753f2b3db28e48$export$e10c57d263d23c49 = (0, $df4Sl.createSelector)($ea753f2b3db28e48$export$ccebe5cc5854d0fa, (entities)=>entities.parentIssue);
const $ea753f2b3db28e48$export$ac6f9fd801c94fff = (0, $df4Sl.createSelector)($ea753f2b3db28e48$export$b5a68452fc64275d, (loggedInUser)=>loggedInUser ? loggedInUser.timeZone : undefined);
const $ea753f2b3db28e48$export$66c501bed2fcd648 = (0, $df4Sl.createSelector)($ea753f2b3db28e48$export$fa3ac1f794979805, (issue)=>issue && (0, $6vrw7.toIssueId)(issue.id));
const $ea753f2b3db28e48$export$45347d9f8a67561b = (0, $df4Sl.createSelector)($ea753f2b3db28e48$export$d94d544d4b2e1310, (isSimplified)=>!isSimplified);
const $ea753f2b3db28e48$export$c077f23183070903 = (0, $df4Sl.createSelector)($ea753f2b3db28e48$export$185c0864c82372e3, (ui)=>ui.loadingStage === (0, $d6ff0428d6ad71a2$export$26d55645375ca9a));
const $ea753f2b3db28e48$export$2ca9575c7da6bf18 = (0, $df4Sl.createSelector)($ea753f2b3db28e48$export$185c0864c82372e3, (ui)=>ui.doNotUseIsLoadingPromise);
const $ea753f2b3db28e48$export$b33a1a8958a8d805 = (0, $df4Sl.createSelector)($ea753f2b3db28e48$export$185c0864c82372e3, (ui)=>ui.loadingStage === (0, $d6ff0428d6ad71a2$export$1b56cc494043d9bf));
const $ea753f2b3db28e48$export$9b99fb9e23fc133 = (0, $df4Sl.createSelector)($ea753f2b3db28e48$export$185c0864c82372e3, (ui)=>ui.loadingStage === (0, $d6ff0428d6ad71a2$export$1660a2d7c2fff354));
const $ea753f2b3db28e48$export$18bc980d36bf93d = (0, $df4Sl.createSelector)($ea753f2b3db28e48$export$185c0864c82372e3, (ui)=>ui.loadingStage);
const $ea753f2b3db28e48$export$7cfd3e0dd7059b87 = (0, $df4Sl.createSelector)($ea753f2b3db28e48$export$185c0864c82372e3, (ui)=>!!(ui.issueDeletion && ui.issueDeletion.isDeleteIssueModalOpen));
const $ea753f2b3db28e48$export$d414d8eddcb409e4 = (0, $df4Sl.createSelector)($ea753f2b3db28e48$export$185c0864c82372e3, (ui)=>ui.issueDeletion ? ui.issueDeletion.isDeletingIssue : false);
const $ea753f2b3db28e48$export$834732624d2c73e1 = (0, $df4Sl.createSelector)($ea753f2b3db28e48$export$185c0864c82372e3, (ui)=>ui.issueDeletion ? ui.issueDeletion.didIssueDeleteFail : false);
const $ea753f2b3db28e48$export$47aec13333381be0 = (0, $df4Sl.createSelector)($ea753f2b3db28e48$export$185c0864c82372e3, (ui)=>ui.error);
const $ea753f2b3db28e48$export$9b1097e17c0e6dc2 = (0, $df4Sl.createSelector)($ea753f2b3db28e48$export$185c0864c82372e3, (ui)=>ui.errorMessage);
const $ea753f2b3db28e48$export$801a2f2bd4059665 = (0, $df4Sl.createSelector)($ea753f2b3db28e48$export$ccebe5cc5854d0fa, (entities)=>(userId)=>userId ? entities.users[userId] : undefined);
const $ea753f2b3db28e48$export$aa8980c49aba4478 = (0, $df4Sl.createSelector)($ea753f2b3db28e48$export$ccebe5cc5854d0fa, (entities)=>entities.parentLevelIssues);
const $ea753f2b3db28e48$export$a60a6c96db10acc4 = ()=>'jira';
const $ea753f2b3db28e48$export$57c6957997fb7f1d = (0, $df4Sl.createSelector)($ea753f2b3db28e48$export$69316f88206ca90b, (0, $7ZZxN.projectTypeToCanonicalId));
const $ea753f2b3db28e48$export$fa12ae06e35ebd67 = (0, $df4Sl.createSelector)($ea753f2b3db28e48$export$a60a6c96db10acc4, (0, $5JqpU.cloudIdSelector), (resourceOwner, cloudId)=>cloudId ? `ari:cloud:${resourceOwner}:${cloudId}` : null);
const $ea753f2b3db28e48$export$a2cdbba2136e72d3 = (0, $df4Sl.createSelector)($ea753f2b3db28e48$export$fa12ae06e35ebd67, $ea753f2b3db28e48$export$66c501bed2fcd648, (baseAri, issueId)=>{
    if (!baseAri || !issueId) return null;
    return `${baseAri}:issue/${issueId}`;
});
const $ea753f2b3db28e48$export$27abc48b8d528300 = (0, $df4Sl.createSelector)($ea753f2b3db28e48$export$27493ac3d8611290, (agile)=>agile && agile.epic && agile.epic.key || null);
const $ea753f2b3db28e48$export$d062a59cf4fc9cec = (fields)=>({}).hasOwnProperty.call(fields, (0, $f9RL0.EPIC_ISSUES));
const $ea753f2b3db28e48$export$6e8ebe94ad8bb62b = (0, $df4Sl.createSelector)((0, $fokFV.fieldsSelector), (fields)=>$ea753f2b3db28e48$export$d062a59cf4fc9cec(fields));
const $ea753f2b3db28e48$export$43d733e4b7e8c7d0 = (0, $df4Sl.createSelector)($ea753f2b3db28e48$export$69316f88206ca90b, (projectType)=>projectType === (0, $7ZZxN.SERVICE_DESK_PROJECT));

});
const $d6ff0428d6ad71a2$export$26d55645375ca9a = 'LOADING';
const $d6ff0428d6ad71a2$export$1b56cc494043d9bf = 'PREVIEW';
const $d6ff0428d6ad71a2$export$1660a2d7c2fff354 = 'COMPLETE';

parcelRegister("f9RL0", function(module, exports) {

$parcel$export(module.exports, "ISSUE_TYPE", () => $3183c1ede6a2aff4$export$ebb48b08205007c5);
$parcel$export(module.exports, "ISSUE_SUMMARY", () => $3183c1ede6a2aff4$export$a464614f8f5fe986);
$parcel$export(module.exports, "SUBTASK_PARENT", () => $3183c1ede6a2aff4$export$a311a3c9b207604e);
$parcel$export(module.exports, "WATCHES", () => $3183c1ede6a2aff4$export$289917d9a7031e1d);
$parcel$export(module.exports, "VOTES", () => $3183c1ede6a2aff4$export$81614f6dc3be5b00);
$parcel$export(module.exports, "SECURITY", () => $3183c1ede6a2aff4$export$72a5630aa398d6b4);
$parcel$export(module.exports, "ISSUE_RESTRICTION", () => $3183c1ede6a2aff4$export$caf1ff54fbdf44bf);
$parcel$export(module.exports, "ASSIGNEE", () => $3183c1ede6a2aff4$export$f8f7545d2bb78afb);
$parcel$export(module.exports, "REPORTER", () => $3183c1ede6a2aff4$export$6d7021166edc895c);
$parcel$export(module.exports, "DUE_DATE", () => $3183c1ede6a2aff4$export$cf7e173386d30cdd);
$parcel$export(module.exports, "PRIORITY", () => $3183c1ede6a2aff4$export$bb34f3538ba26c7e);
$parcel$export(module.exports, "LABELS", () => $3183c1ede6a2aff4$export$79b91d4669dcadcb);
$parcel$export(module.exports, "DEV_SUMMARY", () => $3183c1ede6a2aff4$export$950d47e775e208ee);
$parcel$export(module.exports, "EPIC", () => $3183c1ede6a2aff4$export$3cb4a99a332e4186);
$parcel$export(module.exports, "FIX_VERSIONS", () => $3183c1ede6a2aff4$export$d7e18f5730074533);
$parcel$export(module.exports, "AFFECTS_VERSIONS", () => $3183c1ede6a2aff4$export$c435f0000304e508);
$parcel$export(module.exports, "TIME_TRACKING", () => $3183c1ede6a2aff4$export$ee99ef6ee562a446);
$parcel$export(module.exports, "TIME_ESTIMATE", () => $3183c1ede6a2aff4$export$a6a74b4bc927d39f);
$parcel$export(module.exports, "STATUS", () => $3183c1ede6a2aff4$export$e50006273435e7d4);
$parcel$export(module.exports, "CREATED", () => $3183c1ede6a2aff4$export$ff39ebd4bb12b718);
$parcel$export(module.exports, "UPDATED", () => $3183c1ede6a2aff4$export$cd8e68094cb5c3cb);
$parcel$export(module.exports, "SLA_PANEL", () => $3183c1ede6a2aff4$export$1d0e0bb6a21b800b);
$parcel$export(module.exports, "LINKED_ALERTS", () => $3183c1ede6a2aff4$export$340fac260c3e3637);
$parcel$export(module.exports, "CHAT_CHANNEL", () => $3183c1ede6a2aff4$export$24ec4dcc8e5b08ef);
$parcel$export(module.exports, "MSTEAMS_CHANNEL", () => $3183c1ede6a2aff4$export$8631065e0909313);
$parcel$export(module.exports, "ZOOM_MEETING", () => $3183c1ede6a2aff4$export$3c4dccba7d7e0acb);
$parcel$export(module.exports, "CONFERENCE_CALL", () => $3183c1ede6a2aff4$export$cd5e9246357daec3);
$parcel$export(module.exports, "KNOWLEDGE_BASE", () => $3183c1ede6a2aff4$export$203643a6fd9496a0);
$parcel$export(module.exports, "SENTIMENT", () => $3183c1ede6a2aff4$export$9c83bd19c3ffd90d);
$parcel$export(module.exports, "ASSET_ONBOARDING", () => $3183c1ede6a2aff4$export$c5c04443c6097d6e);
$parcel$export(module.exports, "MANAGE_STAKEHOLDERS", () => $3183c1ede6a2aff4$export$26d855f4cd7e5fe9);
$parcel$export(module.exports, "SUMMARY", () => $3183c1ede6a2aff4$export$913055729e1380b2);
$parcel$export(module.exports, "DESCRIPTION", () => $3183c1ede6a2aff4$export$d44826c816b5619b);
$parcel$export(module.exports, "COMMENT", () => $3183c1ede6a2aff4$export$a29989082612d0d9);
$parcel$export(module.exports, "EPIC_ISSUES", () => $3183c1ede6a2aff4$export$8fe3d5be8cb17459);
$parcel$export(module.exports, "CHILDREN_ISSUES", () => $3183c1ede6a2aff4$export$3b3d0889022c85b3);
$parcel$export(module.exports, "ENVIRONMENT", () => $3183c1ede6a2aff4$export$be46596bc6608f3b);
$parcel$export(module.exports, "SUBTASKS", () => $3183c1ede6a2aff4$export$f528fadbfdb3c25e);
$parcel$export(module.exports, "DATA_CLASSIFICATION_FIELD", () => $3183c1ede6a2aff4$export$f10e53e8928b61bd);
$parcel$export(module.exports, "PARENT", () => $3183c1ede6a2aff4$export$e0dfb65d1047c53c);
$parcel$export(module.exports, "PORTFOLIO_CHILD_ISSUES", () => $3183c1ede6a2aff4$export$aba22e09a66f6826);
$parcel$export(module.exports, "FLAG_ACTIONS", () => $3183c1ede6a2aff4$export$cdbd1eb3b05729e0);
$parcel$export(module.exports, "CARD_COVER_ACTIONS", () => $3183c1ede6a2aff4$export$c161a774ec2e7e56);
$parcel$export(module.exports, "specialFields", () => $3183c1ede6a2aff4$export$89e5c40c0f5c7561);
$parcel$export(module.exports, "ecosystemCustomFields", () => $3183c1ede6a2aff4$export$87934b3672715c91);
$parcel$export(module.exports, "customFieldsToDisplay", () => $3183c1ede6a2aff4$export$efd443bccc4c01ed);
$parcel$export(module.exports, "itemDocumentationUrls", () => $3183c1ede6a2aff4$export$a18b3a656ee9c709);
$parcel$export(module.exports, "emptyConfiguration", () => $3183c1ede6a2aff4$export$a52507e68e7aeeb);
$parcel$export(module.exports, "softwareConfiguration", () => $3183c1ede6a2aff4$export$27e0678365e5dcff);
$parcel$export(module.exports, "simpleSoftwareBoardConfiguration", () => $3183c1ede6a2aff4$export$aebf676dfa727a1c);
$parcel$export(module.exports, "standardRoadmapConfiguration", () => $3183c1ede6a2aff4$export$1afca4d3eb6b218b);
$parcel$export(module.exports, "bitbucketConfiguration", () => $3183c1ede6a2aff4$export$8a060ed6f66c43b0);
$parcel$export(module.exports, "mobileConfiguration", () => $3183c1ede6a2aff4$export$78a2cb921e46f5eb);
$parcel$export(module.exports, "serviceDeskConfiguration", () => $3183c1ede6a2aff4$export$db1115186532f6d5);
$parcel$export(module.exports, "connectConfiguration", () => $3183c1ede6a2aff4$export$557d5094ec5cf234);
$parcel$export(module.exports, "getIssueConfiguration", () => $3183c1ede6a2aff4$export$902f6c5cc939598a);

var $2wUFy = parcelRequire("2wUFy");

var $7ZZxN = parcelRequire("7ZZxN");

var $lO4Or = parcelRequire("lO4Or");
const $3183c1ede6a2aff4$export$ebb48b08205007c5 = 'issuetype';
const $3183c1ede6a2aff4$export$a464614f8f5fe986 = 'summary';
const $3183c1ede6a2aff4$export$a311a3c9b207604e = 'parent';
const $3183c1ede6a2aff4$export$2a4f270075a033de = 'parent-issue';
const $3183c1ede6a2aff4$export$4561a4960baf1b2b = 'parent'; // new Hierarchy unification parent field
const $3183c1ede6a2aff4$export$289917d9a7031e1d = 'watches';
const $3183c1ede6a2aff4$export$81614f6dc3be5b00 = 'votes';
const $3183c1ede6a2aff4$export$72a5630aa398d6b4 = 'security';
const $3183c1ede6a2aff4$export$caf1ff54fbdf44bf = 'issuerestriction';
const $3183c1ede6a2aff4$export$f8f7545d2bb78afb = 'assignee';
const $3183c1ede6a2aff4$export$6d7021166edc895c = 'reporter';
const $3183c1ede6a2aff4$export$cf7e173386d30cdd = 'duedate';
const $3183c1ede6a2aff4$export$bb34f3538ba26c7e = 'priority';
const $3183c1ede6a2aff4$export$79b91d4669dcadcb = 'labels';
const $3183c1ede6a2aff4$export$cbedbfe2cd0caec7 = 'components';
const $3183c1ede6a2aff4$export$950d47e775e208ee = 'devSummary';
const $3183c1ede6a2aff4$export$f91d2bb4cc99fa5e = 'releases';
const $3183c1ede6a2aff4$export$a316570a0dbfd2b0 = 'sprint';
const $3183c1ede6a2aff4$export$405b6d72f2d243a9 = 'storyPointsField';
const $3183c1ede6a2aff4$export$3cb4a99a332e4186 = 'epic';
const $3183c1ede6a2aff4$export$d7e18f5730074533 = 'fixVersions';
const $3183c1ede6a2aff4$export$c435f0000304e508 = 'versions';
const $3183c1ede6a2aff4$export$ee99ef6ee562a446 = 'timetracking';
const $3183c1ede6a2aff4$export$a6a74b4bc927d39f = 'timeoriginalestimate';
const $3183c1ede6a2aff4$export$e50006273435e7d4 = 'status';
const $3183c1ede6a2aff4$export$f1a6ce22cbb7eb32 = 'resolution';
const $3183c1ede6a2aff4$export$ff39ebd4bb12b718 = 'created';
const $3183c1ede6a2aff4$export$cd8e68094cb5c3cb = 'updated';
const $3183c1ede6a2aff4$export$1d0e0bb6a21b800b = 'SLA_PANEL';
const $3183c1ede6a2aff4$export$340fac260c3e3637 = 'LINKED_ALERTS';
const $3183c1ede6a2aff4$export$24ec4dcc8e5b08ef = 'CHAT_CHANNEL';
const $3183c1ede6a2aff4$export$8631065e0909313 = 'MSTEAMS_CHANNEL';
const $3183c1ede6a2aff4$export$3c4dccba7d7e0acb = 'ZOOM_MEETING';
const $3183c1ede6a2aff4$export$cd5e9246357daec3 = 'CONFERENCE_CALL';
const $3183c1ede6a2aff4$export$203643a6fd9496a0 = 'KNOWLEDGE_BASE';
const $3183c1ede6a2aff4$export$9c83bd19c3ffd90d = 'SENTIMENT';
const $3183c1ede6a2aff4$export$c5c04443c6097d6e = 'ASSET_ONBOARDING';
const $3183c1ede6a2aff4$export$26d855f4cd7e5fe9 = 'MANAGE_STAKEHOLDERS';
const $3183c1ede6a2aff4$export$913055729e1380b2 = 'summary';
const $3183c1ede6a2aff4$export$d44826c816b5619b = 'description';
const $3183c1ede6a2aff4$export$a29989082612d0d9 = 'comment';
const $3183c1ede6a2aff4$export$8fe3d5be8cb17459 = 'epic-issues'; // this field is only served in classic projects
const $3183c1ede6a2aff4$export$3b3d0889022c85b3 = 'children-issues';
const $3183c1ede6a2aff4$export$be46596bc6608f3b = 'environment';
const $3183c1ede6a2aff4$export$f528fadbfdb3c25e = 'subtasks';
const $3183c1ede6a2aff4$export$f10e53e8928b61bd = 'dataclassification';
const $3183c1ede6a2aff4$export$e0dfb65d1047c53c = (0, $lO4Or.PARENT_CF_TYPE);
const $3183c1ede6a2aff4$export$aba22e09a66f6826 = 'portfolio-child-issues';
const $3183c1ede6a2aff4$export$cdbd1eb3b05729e0 = 'flagActions';
const $3183c1ede6a2aff4$export$c161a774ec2e7e56 = 'cardCoverActions';
const $3183c1ede6a2aff4$export$89e5c40c0f5c7561 = ()=>{
    const fields = {
        [$3183c1ede6a2aff4$export$3cb4a99a332e4186]: 'com.pyxis.greenhopper.jira:gh-epic-link',
        [$3183c1ede6a2aff4$export$a316570a0dbfd2b0]: 'com.pyxis.greenhopper.jira:gh-sprint',
        [$3183c1ede6a2aff4$export$405b6d72f2d243a9]: 'com.atlassian.jira.plugin.system.customfieldtypes:storypoint',
        [(0, $lO4Or.TEAM_CF_TYPE)]: (0, $lO4Or.TEAM_CF_TYPE),
        [(0, $lO4Or.PARENT_CF_TYPE)]: (0, $lO4Or.PARENT_CF_TYPE),
        [(0, $lO4Or.BASELINE_START_CF_TYPE)]: (0, $lO4Or.BASELINE_START_CF_TYPE),
        [(0, $lO4Or.BASELINE_END_CF_TYPE)]: (0, $lO4Or.BASELINE_END_CF_TYPE),
        [(0, $lO4Or.COLOR_CF_TYPE)]: (0, $lO4Or.COLOR_CF_TYPE),
        [(0, $lO4Or.EPIC_COLOR_TYPE)]: (0, $lO4Or.EPIC_COLOR_TYPE),
        [(0, $lO4Or.EPIC_NAME_TYPE)]: (0, $lO4Or.EPIC_NAME_TYPE)
    };
    return fields;
};
const $3183c1ede6a2aff4$export$87934b3672715c91 = [
    (0, $lO4Or.ISSUE_FIELD_NUMBER_CF_TYPE),
    (0, $lO4Or.ISSUE_FIELD_STRING_CF_TYPE),
    (0, $lO4Or.ISSUE_FIELD_DATETIME_CF_TYPE),
    (0, $lO4Or.ISSUE_FIELD_SINGLE_SELECT_CF_TYPE),
    (0, $lO4Or.ISSUE_FIELD_MULTI_SELECT_CF_TYPE)
];
const $3183c1ede6a2aff4$var$serviceDeskCustomFields = [
    (0, $lO4Or.REQUEST_PARTICIPANTS_CF_TYPE),
    (0, $lO4Or.ORGANIZATIONS_CF_TYPE),
    (0, $lO4Or.REQUEST_LANGUAGE_CF_TYPE),
    (0, $lO4Or.REQUEST_FEEDBACK_CF_TYPE),
    (0, $lO4Or.APPROVALS_CF_TYPE),
    (0, $lO4Or.APPROVERS_LIST_CF_TYPE),
    (0, $lO4Or.REQUEST_TYPE_CF_TYPE),
    (0, $lO4Or.CMDB_OBJECT_CF_TYPE),
    (0, $lO4Or.RESPONDERS_CF_TYPE),
    (0, $lO4Or.MAJOR_INCIDENT_CF_TYPE),
    (0, $lO4Or.ENTITLEMENT_CF_TYPE),
    (0, $lO4Or.SENTIMENT_CF_TYPE)
];
const $3183c1ede6a2aff4$export$efd443bccc4c01ed = ()=>[
        (0, $lO4Or.LABELS_CF_TYPE),
        (0, $lO4Or.TEXT_CF_TYPE),
        (0, $lO4Or.MULTI_USER_CF_TYPE),
        (0, $lO4Or.PARTICIPANTS_CF_TYPE),
        (0, $lO4Or.URL_CF_TYPE),
        (0, $lO4Or.NUMBER_CF_TYPE),
        (0, $lO4Or.STORY_POINT_ESTIMATE_CF_TYPE),
        (0, $lO4Or.SELECT_CF_TYPE),
        (0, $lO4Or.MULTI_SELECT_CF_TYPE),
        (0, $lO4Or.VERSION_CF_TYPE),
        (0, $lO4Or.TEXT_AREA_CF_TYPE),
        (0, $lO4Or.MULTI_VERSION_CF_TYPE),
        (0, $lO4Or.DATE_CF_TYPE),
        (0, $lO4Or.GROUP_CF_TYPE),
        (0, $lO4Or.MULTI_GROUP_CF_TYPE),
        (0, $lO4Or.USER_CF_TYPE),
        (0, $lO4Or.MULTI_CHECKBOXES_CF_TYPE),
        (0, $lO4Or.RADIO_BUTTONS_CF_TYPE),
        (0, $lO4Or.DATETIME_CF_TYPE),
        (0, $lO4Or.ASSETS_CF_TYPE),
        (0, $lO4Or.SERVICE_ENTITY_CF_TYPE),
        (0, $lO4Or.PEOPLE_CF_TYPE),
        (0, $lO4Or.CASCADING_SELECT_CF_TYPE),
        (0, $lO4Or.PROJECT_PICKER_CF_TYPE),
        (0, $lO4Or.TEAMS_PLATFORM_CF_TYPE),
        (0, $lO4Or.READ_ONLY_CF_TYPE),
        (0, $lO4Or.EPIC_STATUS_TYPE),
        (0, $lO4Or.MESSAGE_VIEW_CF_TYPE),
        (0, $lO4Or.MESSAGE_EDIT_CF_TYPE),
        (0, $lO4Or.CATEGORY_TYPE),
        (0, $lO4Or.GOALS_CF_TYPE),
        ...$3183c1ede6a2aff4$export$87934b3672715c91,
        ...$3183c1ede6a2aff4$var$serviceDeskCustomFields
    ];
const $3183c1ede6a2aff4$export$a18b3a656ee9c709 = {
    [(0, $7ZZxN.SOFTWARE_PROJECT)]: 'https://confluence.atlassian.com/jirasoftwarecloud/configure-field-layout-in-the-issue-view-961798059.html',
    [(0, $7ZZxN.CORE_PROJECT)]: 'https://confluence.atlassian.com/jiracorecloud/configure-field-layout-in-the-issue-view-961798123.html',
    [(0, $7ZZxN.SERVICE_DESK_PROJECT)]: 'https://support.atlassian.com/jira-service-desk-cloud/docs/what-are-the-different-sections-in-the-issue-view/'
};
const $3183c1ede6a2aff4$export$a52507e68e7aeeb = ()=>({
        issueActions: []
    });
const $3183c1ede6a2aff4$export$381ce08838c53afa = ()=>({
        applicationKey: (0, $2wUFy.default).CORE_ISSUE,
        issueActions: [],
        ecosystemEnabled: true
    });
const $3183c1ede6a2aff4$export$27e0678365e5dcff = ()=>({
        applicationKey: (0, $2wUFy.default).SOFTWARE_ISSUE,
        issueActions: [
            $3183c1ede6a2aff4$export$cdbd1eb3b05729e0
        ],
        ecosystemEnabled: true
    });
const $3183c1ede6a2aff4$export$aebf676dfa727a1c = ()=>({
        applicationKey: (0, $2wUFy.default).SIMPLE_SOFTWARE_BOARD,
        issueActions: [
            $3183c1ede6a2aff4$export$cdbd1eb3b05729e0,
            $3183c1ede6a2aff4$export$c161a774ec2e7e56
        ],
        ecosystemEnabled: true
    });
const $3183c1ede6a2aff4$export$1afca4d3eb6b218b = ()=>({
        applicationKey: (0, $2wUFy.default).STANDARD_ROADMAP_ISSUE,
        issueActions: [
            $3183c1ede6a2aff4$export$cdbd1eb3b05729e0
        ],
        ecosystemEnabled: true
    });
const $3183c1ede6a2aff4$export$8a060ed6f66c43b0 = ()=>({
        applicationKey: (0, $2wUFy.default).BITBUCKET_ISSUE,
        issueActions: []
    });
const $3183c1ede6a2aff4$export$78a2cb921e46f5eb = ()=>({
        applicationKey: (0, $2wUFy.default).MOBILE_ISSUE,
        issueActions: []
    });
const $3183c1ede6a2aff4$export$db1115186532f6d5 = ()=>({
        applicationKey: (0, $2wUFy.default).SERVICE_DESK,
        issueActions: [],
        ecosystemEnabled: true
    });
const $3183c1ede6a2aff4$export$557d5094ec5cf234 = ()=>({
        applicationKey: (0, $2wUFy.default).CONNECT_ISSUE,
        issueActions: [],
        ecosystemEnabled: true
    });
const $3183c1ede6a2aff4$export$902f6c5cc939598a = (config)=>{
    if (config) switch(config.projectType){
        case 0, $7ZZxN.SOFTWARE_PROJECT:
            if (config.isSimplified) return $3183c1ede6a2aff4$export$aebf676dfa727a1c();
            return $3183c1ede6a2aff4$export$27e0678365e5dcff();
        case 0, $7ZZxN.CORE_PROJECT:
            return $3183c1ede6a2aff4$export$381ce08838c53afa();
        case 0, $7ZZxN.SERVICE_DESK_PROJECT:
            return $3183c1ede6a2aff4$export$db1115186532f6d5();
        default:
            // fallback to sofware config
            return $3183c1ede6a2aff4$export$27e0678365e5dcff();
    }
    return $3183c1ede6a2aff4$export$27e0678365e5dcff();
};

});
parcelRegister("2wUFy", function(module, exports) {

$parcel$export(module.exports, "default", () => $78d48529cb7f139c$export$2e2bcd8739ae039);
const $78d48529cb7f139c$var$keys = {
    CONNECT_ISSUE: 'connect-issue',
    BITBUCKET_ISSUE: 'bitbucket-issue',
    CORE_ISSUE: 'core-issue',
    MOBILE_ISSUE: 'mobile-issue',
    SIMPLE_SOFTWARE_BOARD: 'simple-software-board',
    SOFTWARE_ISSUE: 'software-issue',
    STANDARD_ROADMAP_ISSUE: 'standard-roadmap-issue',
    SERVICE_DESK: 'service-desk',
    EMPTY_APPLICATION_KEY: ''
};
var $78d48529cb7f139c$export$2e2bcd8739ae039 = $78d48529cb7f139c$var$keys;

});

parcelRegister("lO4Or", function(module, exports) {

$parcel$export(module.exports, "ISSUE_LINK_SEARCH", () => $4eac1b8021be0c88$export$b144116dae474c88);
$parcel$export(module.exports, "ISSUE_FIELD_NUMBER_CF_TYPE", () => $4eac1b8021be0c88$export$bc917bc699b25f75);
$parcel$export(module.exports, "ISSUE_FIELD_STRING_CF_TYPE", () => $4eac1b8021be0c88$export$5f26ca419fdffbe7);
$parcel$export(module.exports, "ISSUE_FIELD_DATETIME_CF_TYPE", () => $4eac1b8021be0c88$export$ce9bfd823c7e1a6d);
$parcel$export(module.exports, "ISSUE_FIELD_DATE_CF_TYPE", () => $4eac1b8021be0c88$export$346b72b1f7cd6d5a);
$parcel$export(module.exports, "ISSUE_FIELD_SINGLE_SELECT_CF_TYPE", () => $4eac1b8021be0c88$export$b20fbcacd7942c2a);
$parcel$export(module.exports, "ISSUE_FIELD_ANY_CF_TYPE", () => $4eac1b8021be0c88$export$a2e8554bffc61ece);
$parcel$export(module.exports, "ISSUE_FIELD_MULTI_SELECT_CF_TYPE", () => $4eac1b8021be0c88$export$f25cd4907cbb25b9);
$parcel$export(module.exports, "ISSUE_FIELD_USER_CF_TYPE", () => $4eac1b8021be0c88$export$5600354b43577e17);
$parcel$export(module.exports, "ISSUE_FIELD_SINGLE_GROUP_CF_TYPE", () => $4eac1b8021be0c88$export$5dbc9917f72d0d2a);
$parcel$export(module.exports, "ISSUE_FIELD_OBJECT_CF_TYPE", () => $4eac1b8021be0c88$export$253649f07fb55948);
$parcel$export(module.exports, "ISSUE_FIELD_GROUPS_CF_TYPE", () => $4eac1b8021be0c88$export$eb39592ba5247ee7);
$parcel$export(module.exports, "ISSUE_FIELD_STRINGS_CF_TYPE", () => $4eac1b8021be0c88$export$f48a9be226105736);
$parcel$export(module.exports, "ISSUE_FIELD_VERSION_CF_TYPE", () => $4eac1b8021be0c88$export$42e2e93fc721df5d);
$parcel$export(module.exports, "APPROVALS_PANEL_TYPE", () => $4eac1b8021be0c88$export$7773375e72c953ed);
$parcel$export(module.exports, "ISSUE_FIELD_PROJECT_CF_TYPE", () => $4eac1b8021be0c88$export$80ad0037098f3919);
$parcel$export(module.exports, "AFFECTED_SERVICES_GQL_FIELD", () => $4eac1b8021be0c88$export$6875c7efa3a5e380);
$parcel$export(module.exports, "ASSIGNEE_GQL_FIELD", () => $4eac1b8021be0c88$export$7c1a5c7d37b8f968);
$parcel$export(module.exports, "ATLASSIAN_TEAM_GQL_FIELD", () => $4eac1b8021be0c88$export$c5931a5d7dbfb40b);
$parcel$export(module.exports, "BOOLEAN_GQL_FIELD", () => $4eac1b8021be0c88$export$c979d9c548c05133);
$parcel$export(module.exports, "CASCADING_SELECT_GQL_FIELD", () => $4eac1b8021be0c88$export$ff25e7412c4ae9c7);
$parcel$export(module.exports, "CHECKBOX_GQL_FIELD", () => $4eac1b8021be0c88$export$16dbdf57e34e8d63);
$parcel$export(module.exports, "CHILDREN_EXCEEDING_LIMIT_GQL_FIELD", () => $4eac1b8021be0c88$export$1bf8bec92e6e84df);
$parcel$export(module.exports, "CHILDREN_WITHIN_LIMIT_GQL_FIELD", () => $4eac1b8021be0c88$export$c32f5d822fe5ea95);
$parcel$export(module.exports, "CMDB_GQL_FIELD", () => $4eac1b8021be0c88$export$b0deb225eed90fbd);
$parcel$export(module.exports, "COLOR_GQL_FIELD", () => $4eac1b8021be0c88$export$add3775cfea8fde3);
$parcel$export(module.exports, "COMPONENTS_GQL_FIELD", () => $4eac1b8021be0c88$export$9631d4098abab3eb);
$parcel$export(module.exports, "CONNECT_DATE_TIME_GQL_FIELD", () => $4eac1b8021be0c88$export$ee42bc16c09ee564);
$parcel$export(module.exports, "CONNECT_NUMBER_GQL_FIELD", () => $4eac1b8021be0c88$export$fbcebbdce821f712);
$parcel$export(module.exports, "CONNECT_MULTI_SELECT_GQL_FIELD", () => $4eac1b8021be0c88$export$41dd2eb1f33d3042);
$parcel$export(module.exports, "CONNECT_RICH_TEXT_GQL_FIELD", () => $4eac1b8021be0c88$export$f4e3e72a3be84e5b);
$parcel$export(module.exports, "CONNECT_SINGLE_SELECT_GQL_FIELD", () => $4eac1b8021be0c88$export$d6738c8a6d1a735d);
$parcel$export(module.exports, "CONNECT_TEXT_GQL_FIELD", () => $4eac1b8021be0c88$export$79a75502a3f0c4c4);
$parcel$export(module.exports, "DATE_PICKER_GQL_FIELD", () => $4eac1b8021be0c88$export$ed2eabcf0931df31);
$parcel$export(module.exports, "DATE_TIME_GQL_FIELD", () => $4eac1b8021be0c88$export$1f17904e959f2f0b);
$parcel$export(module.exports, "EPIC_LINK_GQL_FIELD", () => $4eac1b8021be0c88$export$6d8da4497234455);
$parcel$export(module.exports, "FLAG_GQL_FIELD", () => $4eac1b8021be0c88$export$9bcfac568e4fa59c);
$parcel$export(module.exports, "ISSUE_RESTRICTION_GQL_FIELD", () => $4eac1b8021be0c88$export$dd84cd6c957c6f5e);
$parcel$export(module.exports, "ISSUE_TYPE_GQL_FIELD", () => $4eac1b8021be0c88$export$5cc7c39d7d1cf6d5);
$parcel$export(module.exports, "LABEL_GQL_FIELD", () => $4eac1b8021be0c88$export$810709f0c5c2e9db);
$parcel$export(module.exports, "MULTI_SELECT_GQL_FIELD", () => $4eac1b8021be0c88$export$82cb6735134c23a2);
$parcel$export(module.exports, "MULTI_USER_PICKER_GQL_FIELD", () => $4eac1b8021be0c88$export$85e04e9a3a81ee1);
$parcel$export(module.exports, "MULTI_VERSION_GQL_FIELD", () => $4eac1b8021be0c88$export$24c916a8a33ed20c);
$parcel$export(module.exports, "MULTI_GROUP_PICKER_GQL_FIELD", () => $4eac1b8021be0c88$export$c049920d930c3b8a);
$parcel$export(module.exports, "NUMBER_GQL_FIELD", () => $4eac1b8021be0c88$export$3b6d7fc1833bf7da);
$parcel$export(module.exports, "ORIGINAL_ESTIMATE_GQL_FIELD", () => $4eac1b8021be0c88$export$bd3e2fe853319c13);
$parcel$export(module.exports, "PARENT_GQL_FIELD", () => $4eac1b8021be0c88$export$6dfd3fc78bc751a0);
$parcel$export(module.exports, "PEOPLE_GQL_FIELD", () => $4eac1b8021be0c88$export$31aea7548807c6b5);
$parcel$export(module.exports, "PRIORITY_GQL_FIELD", () => $4eac1b8021be0c88$export$e89fbbf3983c0219);
$parcel$export(module.exports, "PROFORMA_FORMS_GQL_FIELD", () => $4eac1b8021be0c88$export$f5e2fb1022ff7912);
$parcel$export(module.exports, "PROJECT_GQL_FIELD", () => $4eac1b8021be0c88$export$12f54499c6252188);
$parcel$export(module.exports, "RADIO_GQL_FIELD", () => $4eac1b8021be0c88$export$8e4293d806f435e0);
$parcel$export(module.exports, "REPORTER_GQL_FIELD", () => $4eac1b8021be0c88$export$c69486dd643dfb69);
$parcel$export(module.exports, "RESOLUTION_GQL_FIELD", () => $4eac1b8021be0c88$export$1e4faa0d6dc58a81);
$parcel$export(module.exports, "RICH_TEXT_GQL_FIELD", () => $4eac1b8021be0c88$export$37f4daaa7b409554);
$parcel$export(module.exports, "SECURITY_GQL_FIELD", () => $4eac1b8021be0c88$export$ca57cccd6d7bf97c);
$parcel$export(module.exports, "SINGLE_GROUP_PICKER_GQL_FIELD", () => $4eac1b8021be0c88$export$bea889616fd5bdab);
$parcel$export(module.exports, "SINGLE_SELECT_GQL_FIELD", () => $4eac1b8021be0c88$export$ab5cecc580898d1c);
$parcel$export(module.exports, "SPRINT_GQL_FIELD", () => $4eac1b8021be0c88$export$bb63813d13e8eaf7);
$parcel$export(module.exports, "STATUS_GQL_FIELD", () => $4eac1b8021be0c88$export$e40f819979b3881d);
$parcel$export(module.exports, "TEAM_GQL_FIELD", () => $4eac1b8021be0c88$export$6c243704a22baffe);
$parcel$export(module.exports, "TEAM_VIEW_GQL_FIELD", () => $4eac1b8021be0c88$export$6c32429bac235203);
$parcel$export(module.exports, "TEXT_GQL_FIELD", () => $4eac1b8021be0c88$export$61b514b470cbbf07);
$parcel$export(module.exports, "TIME_TRACKING_GQL_FIELD", () => $4eac1b8021be0c88$export$e4bcb1729da5683);
$parcel$export(module.exports, "URL_GQL_FIELD", () => $4eac1b8021be0c88$export$37ccd11f08a93ccb);
$parcel$export(module.exports, "USER_PICKER_GQL_FIELD", () => $4eac1b8021be0c88$export$abf1bf8c1106ba7d);
$parcel$export(module.exports, "VERSION_GQL_FIELD", () => $4eac1b8021be0c88$export$b55604041ae7179e);
$parcel$export(module.exports, "VOTES_GQL_FIELD", () => $4eac1b8021be0c88$export$c8bf66d62e74cdd2);
$parcel$export(module.exports, "WATCHES_GQL_FIELD", () => $4eac1b8021be0c88$export$aa815aaa741ae18);
$parcel$export(module.exports, "JSM_ASSETS_GQL_FIELD", () => $4eac1b8021be0c88$export$e805f89b15d2abf4);
$parcel$export(module.exports, "JSM_PEOPLE_GQL_FIELD", () => $4eac1b8021be0c88$export$5bfd36acd96f04c2);
$parcel$export(module.exports, "JSM_ORGANIZATION_GQL_FIELD", () => $4eac1b8021be0c88$export$695423a2bc8a9ac4);
$parcel$export(module.exports, "FORGE_STRING_GQL_FIELD", () => $4eac1b8021be0c88$export$d29b0ba0d80bc129);
$parcel$export(module.exports, "FORGE_STRINGS_GQL_FIELD", () => $4eac1b8021be0c88$export$ac6c7b30703608d6);
$parcel$export(module.exports, "FORGE_NUMBER_GQL_FIELD", () => $4eac1b8021be0c88$export$478b546dccd33e1e);
$parcel$export(module.exports, "FORGE_DATETIME_GQL_FIELD", () => $4eac1b8021be0c88$export$f90c042e9eb983e7);
$parcel$export(module.exports, "FORGE_DATE_GQL_FIELD", () => $4eac1b8021be0c88$export$753ca4fb34ff3f2b);
$parcel$export(module.exports, "FORGE_OBJECT_GQL_FIELD", () => $4eac1b8021be0c88$export$b7aed9efb4a9154b);
$parcel$export(module.exports, "FORGE_GROUP_GQL_FIELD", () => $4eac1b8021be0c88$export$1763713d718f7ef0);
$parcel$export(module.exports, "FORGE_USER_GQL_FIELD", () => $4eac1b8021be0c88$export$ebb0caa2a98dcf9e);
$parcel$export(module.exports, "FORGE_GROUPS_GQL_FIELD", () => $4eac1b8021be0c88$export$671131ba12d94144);
$parcel$export(module.exports, "FORGE_USERS_GQL_FIELD", () => $4eac1b8021be0c88$export$c48132adab502d6b);
$parcel$export(module.exports, "JSM_APPROVAL_GQL_FIELD", () => $4eac1b8021be0c88$export$6cd83226f31c7072);
$parcel$export(module.exports, "JSM_USER_APPROVER_PRINCIPAL_FIELD", () => $4eac1b8021be0c88$export$7de726bd6d97a9a7);
$parcel$export(module.exports, "JSM_GROUP_APPROVER_PRINCIPAL_FIELD", () => $4eac1b8021be0c88$export$8e4b538f77340a05);
$parcel$export(module.exports, "JSM_REQUEST_FEEDBACK_GQL_FIELD", () => $4eac1b8021be0c88$export$10ba8c0d74470907);
$parcel$export(module.exports, "JSM_REQUEST_LANGUAGE_GQL_FIELD", () => $4eac1b8021be0c88$export$1756bb4eff1cc3c6);
$parcel$export(module.exports, "JSM_REQUEST_TYPE_GQL_FIELD", () => $4eac1b8021be0c88$export$5876b4be3c4407b);
$parcel$export(module.exports, "JSM_RESPONDERS_GQL_FIELD", () => $4eac1b8021be0c88$export$e7fe49e6f36c7154);
$parcel$export(module.exports, "JSM_USER_RESPONDER_GQL_FIELD", () => $4eac1b8021be0c88$export$aeed3395a6bca18b);
$parcel$export(module.exports, "JSM_ENTITLEMENTS_GQL_FIELD", () => $4eac1b8021be0c88$export$9b725a1eafd02e4f);
$parcel$export(module.exports, "JSM_SENTIMENT_GQL_FIELD", () => $4eac1b8021be0c88$export$699805cbca2c41d);
$parcel$export(module.exports, "JSM_TEAM_RESPONDER_FIELD", () => $4eac1b8021be0c88$export$f658d5c0f0b5dbc2);
$parcel$export(module.exports, "JSM_MAJOR_INCIDENT_FIELD", () => $4eac1b8021be0c88$export$e469bcb2060000af);
$parcel$export(module.exports, "DATA_CLASSIFICATION_FIELD", () => $4eac1b8021be0c88$export$f10e53e8928b61bd);
$parcel$export(module.exports, "GOALS_GQL_FIELD", () => $4eac1b8021be0c88$export$bfcb1a91094f113a);
$parcel$export(module.exports, "DURATION_GQL_FIELD", () => $4eac1b8021be0c88$export$db0bd6c04eb7d04a);
$parcel$export(module.exports, "FORGE_CUSTOM_FIELD_TYPE", () => $4eac1b8021be0c88$export$798d2f5814884447);
$parcel$export(module.exports, "TEAMS_PLATFORM_CF_TYPE", () => $4eac1b8021be0c88$export$269d70c1b1c9fb80);
$parcel$export(module.exports, "APPROVALS_CF_TYPE", () => $4eac1b8021be0c88$export$f0f17ef462331df4);
$parcel$export(module.exports, "CATEGORY_TYPE", () => $4eac1b8021be0c88$export$3c7d8923295a5199);
$parcel$export(module.exports, "PEOPLE_CF_TYPE", () => $4eac1b8021be0c88$export$fb431e758c9252df);
$parcel$export(module.exports, "NUMBER_CF_TYPE", () => $4eac1b8021be0c88$export$c7faa96db185cfc6);
$parcel$export(module.exports, "STORY_POINT_ESTIMATE_CF_TYPE", () => $4eac1b8021be0c88$export$492b0fa4fe201a22);
$parcel$export(module.exports, "URL_CF_TYPE", () => $4eac1b8021be0c88$export$60f0bd6e4b582fe6);
$parcel$export(module.exports, "TEXT_CF_TYPE", () => $4eac1b8021be0c88$export$68c7e01d5460d298);
$parcel$export(module.exports, "TEXT_AREA_CF_TYPE", () => $4eac1b8021be0c88$export$39cd48613b53ce2f);
$parcel$export(module.exports, "TEXT_READONLY_CF_TYPE", () => $4eac1b8021be0c88$export$977db5973ce73e44);
$parcel$export(module.exports, "LABELS_CF_TYPE", () => $4eac1b8021be0c88$export$ad4eb83f78528e13);
$parcel$export(module.exports, "DATE_CF_TYPE", () => $4eac1b8021be0c88$export$ff745f432984005d);
$parcel$export(module.exports, "DATETIME_CF_TYPE", () => $4eac1b8021be0c88$export$42d097f7b1622ef1);
$parcel$export(module.exports, "RADIO_BUTTONS_CF_TYPE", () => $4eac1b8021be0c88$export$65524be5675e57e6);
$parcel$export(module.exports, "MULTI_CHECKBOXES_CF_TYPE", () => $4eac1b8021be0c88$export$5280e5501a801dc0);
$parcel$export(module.exports, "MULTI_SELECT_CF_TYPE", () => $4eac1b8021be0c88$export$c5d13ea26562d57a);
$parcel$export(module.exports, "SELECT_CF_TYPE", () => $4eac1b8021be0c88$export$22ac48a51c014e4b);
$parcel$export(module.exports, "EPIC_STATUS_TYPE", () => $4eac1b8021be0c88$export$6769c2c97b828e11);
$parcel$export(module.exports, "MULTI_VERSION_CF_TYPE", () => $4eac1b8021be0c88$export$39866626496bbfc8);
$parcel$export(module.exports, "VERSION_CF_TYPE", () => $4eac1b8021be0c88$export$24382b4e8c58336b);
$parcel$export(module.exports, "GROUP_CF_TYPE", () => $4eac1b8021be0c88$export$b075907882e80160);
$parcel$export(module.exports, "MULTI_GROUP_CF_TYPE", () => $4eac1b8021be0c88$export$b600addfa3355c57);
$parcel$export(module.exports, "USER_CF_TYPE", () => $4eac1b8021be0c88$export$c491a4b98394028e);
$parcel$export(module.exports, "MULTI_USER_CF_TYPE", () => $4eac1b8021be0c88$export$5365f2d3fac5261a);
$parcel$export(module.exports, "PARTICIPANTS_CF_TYPE", () => $4eac1b8021be0c88$export$cc8ffff49170b0f4);
$parcel$export(module.exports, "FLAGGED_CF_TYPE", () => $4eac1b8021be0c88$export$b7178f601d7373f9);
$parcel$export(module.exports, "TEAM_CF_TYPE", () => $4eac1b8021be0c88$export$eb1f1dca13a0f02d);
$parcel$export(module.exports, "PARENT_CF_TYPE", () => $4eac1b8021be0c88$export$3e71e11f80203acb);
$parcel$export(module.exports, "BASELINE_START_CF_TYPE", () => $4eac1b8021be0c88$export$d10d66823a65e688);
$parcel$export(module.exports, "BASELINE_END_CF_TYPE", () => $4eac1b8021be0c88$export$dfc6da4a9963d5dc);
$parcel$export(module.exports, "COLOR_CF_TYPE", () => $4eac1b8021be0c88$export$b4a1fbc1cf0059cf);
$parcel$export(module.exports, "EPIC_COLOR_TYPE", () => $4eac1b8021be0c88$export$4838a8a8d62a64fd);
$parcel$export(module.exports, "ASSETS_CF_TYPE", () => $4eac1b8021be0c88$export$ed2de20ab8b7ad3d);
$parcel$export(module.exports, "SERVICE_ENTITY_CF_TYPE", () => $4eac1b8021be0c88$export$b755e97dbfa92610);
$parcel$export(module.exports, "REQUEST_PARTICIPANTS_CF_TYPE", () => $4eac1b8021be0c88$export$1be1ecd4dfc06fab);
$parcel$export(module.exports, "ORGANIZATIONS_CF_TYPE", () => $4eac1b8021be0c88$export$34317c2d84a93553);
$parcel$export(module.exports, "REQUEST_LANGUAGE_CF_TYPE", () => $4eac1b8021be0c88$export$555b4f35f98a3210);
$parcel$export(module.exports, "REQUEST_FEEDBACK_CF_TYPE", () => $4eac1b8021be0c88$export$1f2859a3ef701a14);
$parcel$export(module.exports, "REQUEST_FEEDBACK_DATE_CF_TYPE", () => $4eac1b8021be0c88$export$68f62eb762e4157f);
$parcel$export(module.exports, "REQUEST_TYPE_CF_TYPE", () => $4eac1b8021be0c88$export$6da975fce1fbd38e);
$parcel$export(module.exports, "APPROVERS_LIST_CF_TYPE", () => $4eac1b8021be0c88$export$c6dd874aae21e51f);
$parcel$export(module.exports, "CASCADING_SELECT_CF_TYPE", () => $4eac1b8021be0c88$export$c3c9f8a8a8dc0b30);
$parcel$export(module.exports, "RANK_CF_TYPE", () => $4eac1b8021be0c88$export$af89c0396aaf23e3);
$parcel$export(module.exports, "CMDB_OBJECT_CF_TYPE", () => $4eac1b8021be0c88$export$3b5a62bb34372404);
$parcel$export(module.exports, "READ_ONLY_CF_TYPE", () => $4eac1b8021be0c88$export$247829aef464243f);
$parcel$export(module.exports, "PROJECT_PICKER_CF_TYPE", () => $4eac1b8021be0c88$export$65a6076c0927d413);
$parcel$export(module.exports, "RESPONDERS_CF_TYPE", () => $4eac1b8021be0c88$export$bcf83e1d934501c9);
$parcel$export(module.exports, "MAJOR_INCIDENT_CF_TYPE", () => $4eac1b8021be0c88$export$ae0eeec12e90a01e);
$parcel$export(module.exports, "ENTITLEMENT_CF_TYPE", () => $4eac1b8021be0c88$export$c23f6b40da18371a);
$parcel$export(module.exports, "SENTIMENT_CF_TYPE", () => $4eac1b8021be0c88$export$c23cfbdf83daa90d);
$parcel$export(module.exports, "MESSAGE_VIEW_CF_TYPE", () => $4eac1b8021be0c88$export$21dda64db57e4883);
$parcel$export(module.exports, "MESSAGE_EDIT_CF_TYPE", () => $4eac1b8021be0c88$export$45700f3bf92a003a);
$parcel$export(module.exports, "LAST_UPDATER_OR_COMMENTER_CF_TYPE", () => $4eac1b8021be0c88$export$2d75b47d12efc812);
$parcel$export(module.exports, "USER_PROPERTY_CF_TYPE", () => $4eac1b8021be0c88$export$7b79405842547ccb);
$parcel$export(module.exports, "FIRST_RESPONSE_DATE_CF_TYPE", () => $4eac1b8021be0c88$export$fc276d6ccf118a14);
$parcel$export(module.exports, "DEV_SUMMARY_CF_TYPE", () => $4eac1b8021be0c88$export$8b0718167d092603);
$parcel$export(module.exports, "CHILDREN_ISSUES_CF_TYPE", () => $4eac1b8021be0c88$export$904b40dd2afd17a2);
$parcel$export(module.exports, "GOALS_CF_TYPE", () => $4eac1b8021be0c88$export$2bbb7f69c97ea279);
$parcel$export(module.exports, "ASSIGNEE_TYPE", () => $4eac1b8021be0c88$export$fba8634fd401ba8b);
$parcel$export(module.exports, "REPORTER_TYPE", () => $4eac1b8021be0c88$export$a91aea2438afcce8);
$parcel$export(module.exports, "DUE_DATE_TYPE", () => $4eac1b8021be0c88$export$b159f8b8f27aae4c);
$parcel$export(module.exports, "PRIORITY_TYPE", () => $4eac1b8021be0c88$export$34740f8d07d23ac0);
$parcel$export(module.exports, "LABELS_TYPE", () => $4eac1b8021be0c88$export$43b6e33ec70f2272);
$parcel$export(module.exports, "CREATED", () => $4eac1b8021be0c88$export$ff39ebd4bb12b718);
$parcel$export(module.exports, "UPDATED", () => $4eac1b8021be0c88$export$cd8e68094cb5c3cb);
$parcel$export(module.exports, "RESOLUTION_DATE", () => $4eac1b8021be0c88$export$6a052efb0b4ec5d2);
$parcel$export(module.exports, "COMPONENTS_TYPE", () => $4eac1b8021be0c88$export$37abf56f13f61ec5);
$parcel$export(module.exports, "SERVICEDESK_APPROVAL_TYPE", () => $4eac1b8021be0c88$export$aef0c22aecd16996);
$parcel$export(module.exports, "SERVICEDESK_PRACTICES_TYPE", () => $4eac1b8021be0c88$export$cff5b6d1e7135679);
$parcel$export(module.exports, "SERVICEDESK_INCIDENT_MANAGEMENT_TYPE", () => $4eac1b8021be0c88$export$791007408faf42f4);
$parcel$export(module.exports, "DEV_SUMMARY_TYPE", () => $4eac1b8021be0c88$export$827a1c600bac12a3);
$parcel$export(module.exports, "RELEASES_TYPE", () => $4eac1b8021be0c88$export$e9ba671d077969f8);
$parcel$export(module.exports, "SPRINT_TYPE", () => $4eac1b8021be0c88$export$3d37701ba6fb68ec);
$parcel$export(module.exports, "STORY_POINTS_TYPE", () => $4eac1b8021be0c88$export$36fd22f47020f37b);
$parcel$export(module.exports, "EPIC_TYPE", () => $4eac1b8021be0c88$export$9f2fedcd916d2a79);
$parcel$export(module.exports, "EPIC_NAME_TYPE", () => $4eac1b8021be0c88$export$dfc63737b8c0150d);
$parcel$export(module.exports, "FIX_VERSIONS_TYPE", () => $4eac1b8021be0c88$export$a5c9f63aadcb220);
$parcel$export(module.exports, "AFFECTS_VERSIONS_TYPE", () => $4eac1b8021be0c88$export$94009605902e4fe5);
$parcel$export(module.exports, "DESCRIPTION_TYPE", () => $4eac1b8021be0c88$export$5e7324042f1d6b31);
$parcel$export(module.exports, "ENVIRONMENT_TYPE", () => $4eac1b8021be0c88$export$113281d03e6830ef);
$parcel$export(module.exports, "WATCHES_TYPE", () => $4eac1b8021be0c88$export$5ff798870a3dffbf);
$parcel$export(module.exports, "SUMMARY_TYPE", () => $4eac1b8021be0c88$export$907219511d14ba3d);
$parcel$export(module.exports, "PROFORMA_FORMS", () => $4eac1b8021be0c88$export$d09aa6a4f3538063);
$parcel$export(module.exports, "RESOLUTION_TYPE", () => $4eac1b8021be0c88$export$3aca8c91b58a42e2);
$parcel$export(module.exports, "TIME_TRACKING_TYPE", () => $4eac1b8021be0c88$export$ccb5ffefbf8b987c);
$parcel$export(module.exports, "TIME_ESTIMATE_TYPE", () => $4eac1b8021be0c88$export$c8bedad98a5e7f5f);
$parcel$export(module.exports, "STATUS_TYPE", () => $4eac1b8021be0c88$export$358267065be1e);
$parcel$export(module.exports, "STATUS_CATEGORY_TYPE", () => $4eac1b8021be0c88$export$dcaa788c7ada56de);
$parcel$export(module.exports, "ISSUE_TYPE", () => $4eac1b8021be0c88$export$ebb48b08205007c5);
$parcel$export(module.exports, "ISSUE_KEY_TYPE", () => $4eac1b8021be0c88$export$5e91047fe9955d0e);
$parcel$export(module.exports, "CHILDREN_ISSUES", () => $4eac1b8021be0c88$export$3b3d0889022c85b3);
$parcel$export(module.exports, "HIERARCHY_LEVEL_BELOW", () => $4eac1b8021be0c88$export$335851d83a79891);
$parcel$export(module.exports, "GRAPHQL_HIERARCHY_LEVEL_BELOW", () => $4eac1b8021be0c88$export$7b76bbcb87d41695);
$parcel$export(module.exports, "HIERARCHY_LEVEL_ABOVE", () => $4eac1b8021be0c88$export$297b67ac63f09f72);
$parcel$export(module.exports, "GRAPHQL_HIERARCHY_LEVEL_ABOVE", () => $4eac1b8021be0c88$export$ae87161126086be);
$parcel$export(module.exports, "HIERARCHY_LEVEL_SAME_LEVEL", () => $4eac1b8021be0c88$export$6a88420fc2f6901d);
$parcel$export(module.exports, "GRAPHQL_HIERARCHY_LEVEL_SAME_LEVEL", () => $4eac1b8021be0c88$export$ef1a0421bd42c0e4);
$parcel$export(module.exports, "CUSTOMER_CONTEXT_TYPE", () => $4eac1b8021be0c88$export$dd695c8c5ab62f9d);
$parcel$export(module.exports, "SLA_PANEL_TYPE", () => $4eac1b8021be0c88$export$7b3d247435a784fa);
$parcel$export(module.exports, "LINKED_ALERTS_TYPE", () => $4eac1b8021be0c88$export$17b7080ed1fe8cfd);
$parcel$export(module.exports, "CHAT_CHANNEL_TYPE", () => $4eac1b8021be0c88$export$29fe745131dad7ba);
$parcel$export(module.exports, "MSTEAMS_CHANNEL_TYPE", () => $4eac1b8021be0c88$export$9c245100c3091ec3);
$parcel$export(module.exports, "ZOOM_MEETING_TYPE", () => $4eac1b8021be0c88$export$51eb15cea47a37ba);
$parcel$export(module.exports, "MANAGE_STAKEHOLDERS_TYPE", () => $4eac1b8021be0c88$export$c7ae0622b0bd5d56);
$parcel$export(module.exports, "CONFERENCE_CALL_TYPE", () => $4eac1b8021be0c88$export$f7dcde9e9e88aff2);
$parcel$export(module.exports, "KNOWLEDGE_BASE_TYPE", () => $4eac1b8021be0c88$export$b5358afda8ff335e);
$parcel$export(module.exports, "ASSET_ONBOARDING_TYPE", () => $4eac1b8021be0c88$export$63cf6f392da16c25);
$parcel$export(module.exports, "SIMILAR_ISSUES_TYPE", () => $4eac1b8021be0c88$export$22f61ccc2730431f);
$parcel$export(module.exports, "SUBTASKS_TYPE", () => $4eac1b8021be0c88$export$8bbb446f57294715);
$parcel$export(module.exports, "VOTES_TYPE", () => $4eac1b8021be0c88$export$34fcd7cb291a1e4d);
$parcel$export(module.exports, "PARENT_TYPE", () => $4eac1b8021be0c88$export$5e93f2a57cc4ca3a);
$parcel$export(module.exports, "PROJECT_TYPE", () => $4eac1b8021be0c88$export$91a9dba2d38d9a6f);
$parcel$export(module.exports, "TIME_SPENT_TYPE", () => $4eac1b8021be0c88$export$ede0a4c20124ec85);
$parcel$export(module.exports, "DATA_CLASSIFICATION_TYPE", () => $4eac1b8021be0c88$export$3eeb79d48fb5f667);
$parcel$export(module.exports, "SENTIMENT_TYPE", () => $4eac1b8021be0c88$export$45e72c9a63ab61ab);
$parcel$export(module.exports, "ECOSYSTEM_GLANCE_TYPE", () => $4eac1b8021be0c88$export$99ad62164189f781);
$parcel$export(module.exports, "FORGE_GLANCE_TYPE", () => $4eac1b8021be0c88$export$7719ef6e9283671);
$parcel$export(module.exports, "ECOSYSTEM_CONTEXT_TYPE", () => $4eac1b8021be0c88$export$bfebea5ce2e1887a);
$parcel$export(module.exports, "ISSUE_RESTRICTION_TYPE", () => $4eac1b8021be0c88$export$84e5674890d55030);
$parcel$export(module.exports, "SECURITY_LEVEL_TYPE", () => $4eac1b8021be0c88$export$326a5522a485e43d);
$parcel$export(module.exports, "SECURITY_LEVEL_TYPE_OVERRIDE", () => $4eac1b8021be0c88$export$c9f3f01e2c535302);
$parcel$export(module.exports, "TEAM_TYPE", () => $4eac1b8021be0c88$export$66519f3bbff1796a);
$parcel$export(module.exports, "ESTIMATE_TYPE", () => $4eac1b8021be0c88$export$a4ee0bca77cc8463);
$parcel$export(module.exports, "DUE_DATE_PORTFOLIO_TYPE", () => $4eac1b8021be0c88$export$fed53408e89e0497);
$parcel$export(module.exports, "TARGET_START_TYPE", () => $4eac1b8021be0c88$export$d53c26f9ce31f56b);
$parcel$export(module.exports, "TARGET_END_TYPE", () => $4eac1b8021be0c88$export$48f82d653f85e459);
$parcel$export(module.exports, "START_DATE_TYPE", () => $4eac1b8021be0c88$export$ea5a888f39f722c7);
$parcel$export(module.exports, "COLOR_TYPE", () => $4eac1b8021be0c88$export$f245bbec12cc0e40);
$parcel$export(module.exports, "ATTACHMENT_TYPE", () => $4eac1b8021be0c88$export$aed630b4b7114a59);
$parcel$export(module.exports, "ISSUE_LINKS_TYPE", () => $4eac1b8021be0c88$export$b50c1a8fef07104);
$parcel$export(module.exports, "TIME_ESTIMATE_CONFIG_TYPE", () => $4eac1b8021be0c88$export$ea3d72f4bb7738ba);
$parcel$export(module.exports, "COMMENT_TYPE", () => $4eac1b8021be0c88$export$a4cab0124760d860);
$parcel$export(module.exports, "WORK_LOG_TYPE", () => $4eac1b8021be0c88$export$734929aef118d7e2);
$parcel$export(module.exports, "PARENT_FIELD_TYPE", () => $4eac1b8021be0c88$export$ffbacacb07c1d46d);
$parcel$export(module.exports, "getLayoutFieldTypes", () => $4eac1b8021be0c88$export$3c3e26aadbfa2c32);

var $5iWql = parcelRequire("5iWql");

var $1ybV0 = parcelRequire("1ybV0");
const $4eac1b8021be0c88$export$b144116dae474c88 = 'issue-link-search';
const $4eac1b8021be0c88$export$bc917bc699b25f75 = 'number';
const $4eac1b8021be0c88$export$5f26ca419fdffbe7 = 'string';
const $4eac1b8021be0c88$export$ce9bfd823c7e1a6d = 'datetime';
const $4eac1b8021be0c88$export$346b72b1f7cd6d5a = 'date';
const $4eac1b8021be0c88$export$b20fbcacd7942c2a = 'option2';
const $4eac1b8021be0c88$export$20737ab0ca5fa93f = 'option'; // graphql currently returns this type
const $4eac1b8021be0c88$export$a2e8554bffc61ece = 'any';
const $4eac1b8021be0c88$export$f25cd4907cbb25b9 = 'array';
const $4eac1b8021be0c88$export$5600354b43577e17 = 'user';
const $4eac1b8021be0c88$export$5dbc9917f72d0d2a = 'group';
const $4eac1b8021be0c88$export$253649f07fb55948 = 'object';
const $4eac1b8021be0c88$export$eb39592ba5247ee7 = 'group-list';
const $4eac1b8021be0c88$export$f48a9be226105736 = 'array-string';
const $4eac1b8021be0c88$export$42e2e93fc721df5d = 'version';
const $4eac1b8021be0c88$export$a603eef6fee2a5f0 = 'parent-issues'; // Remove on FD-30157 clean-up
const $4eac1b8021be0c88$export$7773375e72c953ed = 'approval-panel';
const $4eac1b8021be0c88$export$80ad0037098f3919 = 'project';
const $4eac1b8021be0c88$export$6875c7efa3a5e380 = 'JiraAffectedServicesField';
const $4eac1b8021be0c88$export$7c1a5c7d37b8f968 = 'JiraAssigneeField';
const $4eac1b8021be0c88$export$d74e2f14098ef8f6 = 'JiraAttachmentsField';
const $4eac1b8021be0c88$export$c5931a5d7dbfb40b = 'JiraAtlassianTeamField';
const $4eac1b8021be0c88$export$c979d9c548c05133 = 'JiraBooleanField';
const $4eac1b8021be0c88$export$ff25e7412c4ae9c7 = 'JiraCascadingSelectField';
const $4eac1b8021be0c88$export$16dbdf57e34e8d63 = 'JiraCheckboxesField';
const $4eac1b8021be0c88$export$1bf8bec92e6e84df = 'JiraChildIssuesExceedingLimit';
const $4eac1b8021be0c88$export$c32f5d822fe5ea95 = 'JiraChildIssuesWithinLimit';
const $4eac1b8021be0c88$export$b0deb225eed90fbd = 'JiraCMDBField';
const $4eac1b8021be0c88$export$add3775cfea8fde3 = 'JiraColorField';
const $4eac1b8021be0c88$export$9631d4098abab3eb = 'JiraComponentsField';
const $4eac1b8021be0c88$export$ee42bc16c09ee564 = 'JiraConnectDateTimeField';
const $4eac1b8021be0c88$export$fbcebbdce821f712 = 'JiraConnectNumberField';
const $4eac1b8021be0c88$export$41dd2eb1f33d3042 = 'JiraConnectMultipleSelectField';
const $4eac1b8021be0c88$export$f4e3e72a3be84e5b = 'JiraConnectRichTextField';
const $4eac1b8021be0c88$export$d6738c8a6d1a735d = 'JiraConnectSingleSelectField';
const $4eac1b8021be0c88$export$79a75502a3f0c4c4 = 'JiraConnectTextField';
const $4eac1b8021be0c88$export$ed2eabcf0931df31 = 'JiraDatePickerField';
const $4eac1b8021be0c88$export$1f17904e959f2f0b = 'JiraDateTimePickerField';
const $4eac1b8021be0c88$export$6d8da4497234455 = 'JiraEpicLinkField';
const $4eac1b8021be0c88$export$9bcfac568e4fa59c = 'JiraFlagField';
const $4eac1b8021be0c88$export$ff2e58d499eebe1d = 'JiraIssueLinkField';
const $4eac1b8021be0c88$export$dd84cd6c957c6f5e = 'JiraIssueRestrictionField';
const $4eac1b8021be0c88$export$5cc7c39d7d1cf6d5 = 'JiraIssueTypeField';
const $4eac1b8021be0c88$export$810709f0c5c2e9db = 'JiraLabelsField';
const $4eac1b8021be0c88$export$82cb6735134c23a2 = 'JiraMultipleSelectField';
const $4eac1b8021be0c88$export$85e04e9a3a81ee1 = 'JiraMultipleSelectUserPickerField';
const $4eac1b8021be0c88$export$24c916a8a33ed20c = 'JiraMultipleVersionPickerField';
const $4eac1b8021be0c88$export$c049920d930c3b8a = 'JiraMultipleGroupPickerField';
const $4eac1b8021be0c88$export$3b6d7fc1833bf7da = 'JiraNumberField';
const $4eac1b8021be0c88$export$bd3e2fe853319c13 = 'JiraOriginalTimeEstimateField';
const $4eac1b8021be0c88$export$6dfd3fc78bc751a0 = 'JiraParentIssueField';
const $4eac1b8021be0c88$export$31aea7548807c6b5 = 'JiraPeopleField';
const $4eac1b8021be0c88$export$e89fbbf3983c0219 = 'JiraPriorityField';
const $4eac1b8021be0c88$export$f5e2fb1022ff7912 = 'JiraProformaFormsField';
const $4eac1b8021be0c88$export$12f54499c6252188 = 'JiraProjectField';
const $4eac1b8021be0c88$export$8e4293d806f435e0 = 'JiraRadioSelectField';
const $4eac1b8021be0c88$export$c69486dd643dfb69 = 'JiraReporterField';
const $4eac1b8021be0c88$export$1e18a858257aca2f = 'JiraRequestTypeField';
const $4eac1b8021be0c88$export$1e4faa0d6dc58a81 = 'JiraResolutionField';
const $4eac1b8021be0c88$export$37f4daaa7b409554 = 'JiraRichTextField';
const $4eac1b8021be0c88$export$ca57cccd6d7bf97c = 'JiraSecurityLevelField';
const $4eac1b8021be0c88$export$bea889616fd5bdab = 'JiraSingleGroupPickerField';
const $4eac1b8021be0c88$export$ab5cecc580898d1c = 'JiraSingleSelectField';
const $4eac1b8021be0c88$export$bb63813d13e8eaf7 = 'JiraSprintField';
const $4eac1b8021be0c88$export$e40f819979b3881d = 'JiraStatusField';
const $4eac1b8021be0c88$export$6c243704a22baffe = 'JiraTeamField';
const $4eac1b8021be0c88$export$6c32429bac235203 = 'JiraTeamViewField';
const $4eac1b8021be0c88$export$61b514b470cbbf07 = 'JiraSingleLineTextField';
const $4eac1b8021be0c88$export$e4bcb1729da5683 = 'JiraTimeTrackingField';
const $4eac1b8021be0c88$export$37ccd11f08a93ccb = 'JiraUrlField';
const $4eac1b8021be0c88$export$abf1bf8c1106ba7d = 'JiraSingleSelectUserPickerField';
const $4eac1b8021be0c88$export$b55604041ae7179e = 'JiraSingleVersionPickerField';
const $4eac1b8021be0c88$export$c8bf66d62e74cdd2 = 'JiraVotesField';
const $4eac1b8021be0c88$export$aa815aaa741ae18 = 'JiraWatchesField';
const $4eac1b8021be0c88$export$e805f89b15d2abf4 = 'JiraAssetField';
const $4eac1b8021be0c88$export$5bfd36acd96f04c2 = 'JiraServiceManagementPeopleField';
const $4eac1b8021be0c88$export$695423a2bc8a9ac4 = 'JiraServiceManagementOrganizationField';
const $4eac1b8021be0c88$export$d29b0ba0d80bc129 = 'JiraForgeStringField';
const $4eac1b8021be0c88$export$ac6c7b30703608d6 = 'JiraForgeStringsField';
const $4eac1b8021be0c88$export$478b546dccd33e1e = 'JiraForgeNumberField';
const $4eac1b8021be0c88$export$f90c042e9eb983e7 = 'JiraForgeDatetimeField';
const $4eac1b8021be0c88$export$753ca4fb34ff3f2b = 'JiraForgeDateField';
const $4eac1b8021be0c88$export$b7aed9efb4a9154b = 'JiraForgeObjectField';
const $4eac1b8021be0c88$export$1763713d718f7ef0 = 'JiraForgeGroupField';
const $4eac1b8021be0c88$export$ebb0caa2a98dcf9e = 'JiraForgeUserField';
const $4eac1b8021be0c88$export$671131ba12d94144 = 'JiraForgeGroupsField';
const $4eac1b8021be0c88$export$c48132adab502d6b = 'JiraForgeUsersField';
const $4eac1b8021be0c88$export$6cd83226f31c7072 = 'JiraServiceManagementApprovalField';
const $4eac1b8021be0c88$export$7de726bd6d97a9a7 = 'JiraServiceManagementUserApproverPrincipal';
const $4eac1b8021be0c88$export$8e4b538f77340a05 = 'JiraServiceManagementGroupApproverPrincipal';
const $4eac1b8021be0c88$export$10ba8c0d74470907 = 'JiraServiceManagementRequestFeedbackField';
const $4eac1b8021be0c88$export$1756bb4eff1cc3c6 = 'JiraServiceManagementRequestLanguageField';
const $4eac1b8021be0c88$export$5876b4be3c4407b = 'JiraServiceManagementRequestTypeField';
const $4eac1b8021be0c88$export$e7fe49e6f36c7154 = 'JiraServiceManagementRespondersField';
const $4eac1b8021be0c88$export$aeed3395a6bca18b = 'JiraServiceManagementUserResponder';
const $4eac1b8021be0c88$export$9b725a1eafd02e4f = 'JiraServiceManagementEntitlementField';
const $4eac1b8021be0c88$export$699805cbca2c41d = 'JiraServiceManagementSentimentField';
const $4eac1b8021be0c88$export$f658d5c0f0b5dbc2 = 'JiraServiceManagementTeamResponder';
const $4eac1b8021be0c88$export$e469bcb2060000af = 'JiraServiceManagementMajorIncidentField';
const $4eac1b8021be0c88$export$f10e53e8928b61bd = 'JiraDataClassificationField';
const $4eac1b8021be0c88$export$bfcb1a91094f113a = 'JiraGoalsField';
const $4eac1b8021be0c88$export$db0bd6c04eb7d04a = 'JiraDurationField';
const $4eac1b8021be0c88$export$798d2f5814884447 = 'forgeCustomField';
const $4eac1b8021be0c88$export$269d70c1b1c9fb80 = 'com.atlassian.jira.plugin.system.customfieldtypes:atlassian-team';
const $4eac1b8021be0c88$export$f0f17ef462331df4 = 'com.atlassian.servicedesk.approvals-plugin:sd-approvals';
const $4eac1b8021be0c88$export$3c7d8923295a5199 = 'com.atlassian.jira.plugin.system.customfieldtypes:jwm-category';
const $4eac1b8021be0c88$export$fb431e758c9252df = 'com.atlassian.jira.plugin.system.customfieldtypes:people';
const $4eac1b8021be0c88$export$c7faa96db185cfc6 = 'com.atlassian.jira.plugin.system.customfieldtypes:float';
const $4eac1b8021be0c88$export$492b0fa4fe201a22 = 'com.pyxis.greenhopper.jira:jsw-story-points';
const $4eac1b8021be0c88$export$60f0bd6e4b582fe6 = 'com.atlassian.jira.plugin.system.customfieldtypes:url';
const $4eac1b8021be0c88$export$68c7e01d5460d298 = 'com.atlassian.jira.plugin.system.customfieldtypes:textfield';
const $4eac1b8021be0c88$export$39cd48613b53ce2f = 'com.atlassian.jira.plugin.system.customfieldtypes:textarea';
const $4eac1b8021be0c88$export$977db5973ce73e44 = 'com.atlassian.jira.plugin.system.customfieldtypes:readonlyfield';
const $4eac1b8021be0c88$export$ad4eb83f78528e13 = 'com.atlassian.jira.plugin.system.customfieldtypes:labels';
const $4eac1b8021be0c88$export$ff745f432984005d = 'com.atlassian.jira.plugin.system.customfieldtypes:datepicker';
const $4eac1b8021be0c88$export$42d097f7b1622ef1 = 'com.atlassian.jira.plugin.system.customfieldtypes:datetime';
const $4eac1b8021be0c88$export$65524be5675e57e6 = 'com.atlassian.jira.plugin.system.customfieldtypes:radiobuttons';
const $4eac1b8021be0c88$export$5280e5501a801dc0 = 'com.atlassian.jira.plugin.system.customfieldtypes:multicheckboxes';
const $4eac1b8021be0c88$export$c5d13ea26562d57a = 'com.atlassian.jira.plugin.system.customfieldtypes:multiselect';
const $4eac1b8021be0c88$export$22ac48a51c014e4b = 'com.atlassian.jira.plugin.system.customfieldtypes:select';
const $4eac1b8021be0c88$export$6769c2c97b828e11 = 'com.pyxis.greenhopper.jira:gh-epic-status';
const $4eac1b8021be0c88$export$39866626496bbfc8 = 'com.atlassian.jira.plugin.system.customfieldtypes:multiversion';
const $4eac1b8021be0c88$export$24382b4e8c58336b = 'com.atlassian.jira.plugin.system.customfieldtypes:version';
const $4eac1b8021be0c88$export$b075907882e80160 = 'com.atlassian.jira.plugin.system.customfieldtypes:grouppicker';
const $4eac1b8021be0c88$export$b600addfa3355c57 = 'com.atlassian.jira.plugin.system.customfieldtypes:multigrouppicker';
const $4eac1b8021be0c88$export$c491a4b98394028e = 'com.atlassian.jira.plugin.system.customfieldtypes:userpicker';
const $4eac1b8021be0c88$export$5365f2d3fac5261a = 'com.atlassian.jira.plugin.system.customfieldtypes:multiuserpicker';
const $4eac1b8021be0c88$export$cc8ffff49170b0f4 = 'com.atlassian.jira.toolkit:participants';
const $4eac1b8021be0c88$export$b7178f601d7373f9 = 'com.atlassian.jira.plugin.system.customfieldtypes:flagged';
const $4eac1b8021be0c88$export$eb1f1dca13a0f02d = 'com.atlassian.teams:rm-teams-custom-field-team';
const $4eac1b8021be0c88$export$3e71e11f80203acb = 'com.atlassian.jpo:jpo-custom-field-parent';
const $4eac1b8021be0c88$export$9f47a86016048ac3 = 'com.atlassian.graphql:parent-issues';
const $4eac1b8021be0c88$export$d10d66823a65e688 = 'com.atlassian.jpo:jpo-custom-field-baseline-start';
const $4eac1b8021be0c88$export$dfc6da4a9963d5dc = 'com.atlassian.jpo:jpo-custom-field-baseline-end';
const $4eac1b8021be0c88$export$b4a1fbc1cf0059cf = 'com.pyxis.greenhopper.jira:jsw-issue-color';
const $4eac1b8021be0c88$export$4838a8a8d62a64fd = 'com.pyxis.greenhopper.jira:gh-epic-color';
const $4eac1b8021be0c88$export$ed2de20ab8b7ad3d = 'com.atlassian.servicedesk.assets-plugin:assetfield';
const $4eac1b8021be0c88$export$b755e97dbfa92610 = 'com.atlassian.jira.plugins.service-entity:service-entity-field-cftype';
const $4eac1b8021be0c88$export$1be1ecd4dfc06fab = 'com.atlassian.servicedesk:sd-request-participants';
const $4eac1b8021be0c88$export$34317c2d84a93553 = 'com.atlassian.servicedesk:sd-customer-organizations';
const $4eac1b8021be0c88$export$555b4f35f98a3210 = 'com.atlassian.servicedesk.servicedesk-lingo-integration-plugin:sd-request-language';
const $4eac1b8021be0c88$export$1f2859a3ef701a14 = 'com.atlassian.servicedesk:sd-request-feedback';
const $4eac1b8021be0c88$export$68f62eb762e4157f = 'com.atlassian.servicedesk:sd-request-feedback-date';
const $4eac1b8021be0c88$export$6da975fce1fbd38e = 'com.atlassian.servicedesk:vp-origin';
const $4eac1b8021be0c88$export$c6dd874aae21e51f = 'com.atlassian.jira.plugin.system.customfieldtypes:servicedesk-approvers-list';
const $4eac1b8021be0c88$export$c3c9f8a8a8dc0b30 = 'com.atlassian.jira.plugin.system.customfieldtypes:cascadingselect';
const $4eac1b8021be0c88$export$af89c0396aaf23e3 = 'com.pyxis.greenhopper.jira:gh-lexo-rank';
const $4eac1b8021be0c88$export$3b5a62bb34372404 = 'com.atlassian.jira.plugins.cmdb:cmdb-object-cftype';
const $4eac1b8021be0c88$export$247829aef464243f = 'com.atlassian.jira.plugin.system.customfieldtypes:readonlyfield';
const $4eac1b8021be0c88$export$65a6076c0927d413 = 'com.atlassian.jira.plugin.system.customfieldtypes:project';
const $4eac1b8021be0c88$export$bcf83e1d934501c9 = 'com.atlassian.jira.modules.servicemanagement.responders-entity:responders-entity-field-cftype';
const $4eac1b8021be0c88$export$ae0eeec12e90a01e = 'com.atlassian.jira.modules.servicemanagement.major-incident-entity:major-incident-entity-field-cftype';
const $4eac1b8021be0c88$export$f94696506ee781f9 = 'com.atlassian.jira.plugins.jim-plugin:bug-importid';
const $4eac1b8021be0c88$export$8ba6ed64df1ce64a = 'com.atlassian.jira.plugin.system.customfieldtypes:importid';
const $4eac1b8021be0c88$export$e90ce947f06b085d = 'com.atlassian.jconnect.jconnect-plugin:uuid';
const $4eac1b8021be0c88$export$c23f6b40da18371a = 'com.atlassian.servicedesk.customer-context:sd-csm-entitlement';
const $4eac1b8021be0c88$export$c23cfbdf83daa90d = 'com.atlassian.servicedesk.sentiment:sd-sentiment';
const $4eac1b8021be0c88$export$21dda64db57e4883 = 'com.atlassian.jira.toolkit:viewmessage';
const $4eac1b8021be0c88$export$45700f3bf92a003a = 'com.atlassian.jira.toolkit:message';
const $4eac1b8021be0c88$export$2d75b47d12efc812 = 'com.atlassian.jira.toolkit:lastupdaterorcommenter';
const $4eac1b8021be0c88$export$36500b2821f7114f = 'com.atlassian.jira.toolkit:attachments';
const $4eac1b8021be0c88$export$37dc91333ba7a96 = 'com.atlassian.jira.toolkit:LastCommentDate';
const $4eac1b8021be0c88$export$7b79405842547ccb = 'com.atlassian.jira.toolkit:userproperty';
const $4eac1b8021be0c88$export$ac9f7d2dfc7c6826 = 'com.atlassian.jira.toolkit:assigneedomain';
const $4eac1b8021be0c88$export$a3d9c149d737aa78 = 'com.atlassian.jira.toolkit:reporterdomain';
const $4eac1b8021be0c88$export$4745e551386233a5 = 'com.atlassian.jira.toolkit:comments';
const $4eac1b8021be0c88$export$5ee213d6fd4c9b2b = 'com.atlassian.jira.toolkit:dayslastcommented';
const $4eac1b8021be0c88$export$fb0b6a2e098e1fe2 = 'com.atlassian.jira.toolkit:lastusercommented';
const $4eac1b8021be0c88$export$fe1291c40f590f35 = 'com.atlassian.servicedesk:sd-sla-field';
const $4eac1b8021be0c88$export$e9c81bef34f2c86c = 'sd-servicelevelagreement';
const $4eac1b8021be0c88$export$96201d0ae03ca323 = 'com.atlassian.jira.ext.charting:timeinstatus';
const $4eac1b8021be0c88$export$fc276d6ccf118a14 = 'com.atlassian.jira.ext.charting:firstresponsedate';
const $4eac1b8021be0c88$export$8b0718167d092603 = 'com.atlassian.jira.plugins.jira-development-integration-plugin:devsummarycf';
const $4eac1b8021be0c88$export$904b40dd2afd17a2 = 'com.atlassian.graphql:children-issues';
const $4eac1b8021be0c88$export$4063d93c74c89472 = 'com.atlassian.graphql:epic-issues';
const $4eac1b8021be0c88$export$f0eeb5dcfbc42177 = 'com.atlassian.graphql:portfolio-child-issues';
const $4eac1b8021be0c88$export$2bbb7f69c97ea279 = 'com.atlassian.jira.plugin.system.customfieldtypes:goals';
const $4eac1b8021be0c88$export$fba8634fd401ba8b = 'assignee';
const $4eac1b8021be0c88$export$a91aea2438afcce8 = 'reporter';
const $4eac1b8021be0c88$export$b159f8b8f27aae4c = 'duedate';
const $4eac1b8021be0c88$export$34740f8d07d23ac0 = 'priority';
const $4eac1b8021be0c88$export$43b6e33ec70f2272 = 'labels';
const $4eac1b8021be0c88$export$ff39ebd4bb12b718 = 'created';
const $4eac1b8021be0c88$export$cd8e68094cb5c3cb = 'updated';
const $4eac1b8021be0c88$export$6a052efb0b4ec5d2 = 'resolutiondate';
const $4eac1b8021be0c88$export$37abf56f13f61ec5 = 'components';
const $4eac1b8021be0c88$export$aef0c22aecd16996 = 'servicedesk-approvals';
const $4eac1b8021be0c88$export$cff5b6d1e7135679 = 'servicedesk-practices';
const $4eac1b8021be0c88$export$d925edcf818f4885 = 'servicedesk-incident-linking';
const $4eac1b8021be0c88$export$e7c590d96ed1c7fa = 'servicedesk-incident-escalate';
const $4eac1b8021be0c88$export$791007408faf42f4 = 'servicedesk-incident-management';
const $4eac1b8021be0c88$export$827a1c600bac12a3 = 'devSummary';
const $4eac1b8021be0c88$export$e9ba671d077969f8 = 'releases';
const $4eac1b8021be0c88$export$3d37701ba6fb68ec = 'com.pyxis.greenhopper.jira:gh-sprint';
const $4eac1b8021be0c88$export$36fd22f47020f37b = 'com.atlassian.jira.plugin.system.customfieldtypes:storypoint';
const $4eac1b8021be0c88$export$9f2fedcd916d2a79 = 'com.pyxis.greenhopper.jira:gh-epic-link';
const $4eac1b8021be0c88$export$dfc63737b8c0150d = 'com.pyxis.greenhopper.jira:gh-epic-label';
const $4eac1b8021be0c88$export$a5c9f63aadcb220 = 'fixVersions';
const $4eac1b8021be0c88$export$94009605902e4fe5 = 'versions';
const $4eac1b8021be0c88$export$5e7324042f1d6b31 = 'description';
const $4eac1b8021be0c88$export$113281d03e6830ef = 'environment';
const $4eac1b8021be0c88$export$5ff798870a3dffbf = 'watches';
const $4eac1b8021be0c88$export$907219511d14ba3d = 'summary';
const $4eac1b8021be0c88$export$d09aa6a4f3538063 = 'proforma-forms';
const $4eac1b8021be0c88$export$3aca8c91b58a42e2 = 'resolution';
const $4eac1b8021be0c88$export$ccb5ffefbf8b987c = 'timetracking';
const $4eac1b8021be0c88$export$c8bedad98a5e7f5f = 'timeoriginalestimate';
const $4eac1b8021be0c88$export$358267065be1e = 'status';
const $4eac1b8021be0c88$export$dcaa788c7ada56de = 'statusCategory';
const $4eac1b8021be0c88$export$ebb48b08205007c5 = 'issuetype';
const $4eac1b8021be0c88$export$5e91047fe9955d0e = 'issuekey';
const $4eac1b8021be0c88$export$3b3d0889022c85b3 = 'children-issues';
const $4eac1b8021be0c88$export$aba22e09a66f6826 = 'portfolio-child-issues';
const $4eac1b8021be0c88$export$8fe3d5be8cb17459 = 'epic-issues';
const $4eac1b8021be0c88$export$335851d83a79891 = 'hierarchy-level-below';
const $4eac1b8021be0c88$export$7b76bbcb87d41695 = 'com.atlassian.graphql:hierarchy-level-below';
const $4eac1b8021be0c88$export$297b67ac63f09f72 = 'hierarchy-level-above';
const $4eac1b8021be0c88$export$ae87161126086be = 'com.atlassian.graphql:hierarchy-level-above';
const $4eac1b8021be0c88$export$6a88420fc2f6901d = 'hierarchy-level-same-level';
const $4eac1b8021be0c88$export$ef1a0421bd42c0e4 = 'com.atlassian.graphql:hierarchy-level-same-level';
const $4eac1b8021be0c88$export$dd695c8c5ab62f9d = 'CUSTOMER_CONTEXT';
const $4eac1b8021be0c88$export$7b3d247435a784fa = 'SLA_PANEL';
const $4eac1b8021be0c88$export$17b7080ed1fe8cfd = 'LINKED_ALERTS';
const $4eac1b8021be0c88$export$29fe745131dad7ba = 'CHAT_CHANNEL';
const $4eac1b8021be0c88$export$9c245100c3091ec3 = 'MSTEAMS_CHANNEL';
const $4eac1b8021be0c88$export$51eb15cea47a37ba = 'ZOOM_MEETING';
const $4eac1b8021be0c88$export$c7ae0622b0bd5d56 = 'MANAGE_STAKEHOLDERS';
const $4eac1b8021be0c88$export$f7dcde9e9e88aff2 = 'CONFERENCE_CALL';
const $4eac1b8021be0c88$export$b5358afda8ff335e = 'KNOWLEDGE_BASE';
const $4eac1b8021be0c88$export$63cf6f392da16c25 = 'ASSET_ONBOARDING';
const $4eac1b8021be0c88$export$22f61ccc2730431f = 'similar-issues';
const $4eac1b8021be0c88$export$8bbb446f57294715 = 'subtasks';
const $4eac1b8021be0c88$export$34fcd7cb291a1e4d = 'votes';
const $4eac1b8021be0c88$export$5e93f2a57cc4ca3a = 'parent';
const $4eac1b8021be0c88$export$be3891c8b47ab821 = 'parent-issue'; // Remove on FD-30157 clean-up
const $4eac1b8021be0c88$export$91a9dba2d38d9a6f = 'project';
const $4eac1b8021be0c88$export$df36fc05622c402 = 'worklog';
const $4eac1b8021be0c88$export$ede0a4c20124ec85 = 'timespent';
const $4eac1b8021be0c88$export$3eeb79d48fb5f667 = 'dataclassification';
const $4eac1b8021be0c88$export$45e72c9a63ab61ab = 'SENTIMENT';
const $4eac1b8021be0c88$export$99ad62164189f781 = 'ecosystemGlance';
const $4eac1b8021be0c88$export$7719ef6e9283671 = 'forgeGlance';
const $4eac1b8021be0c88$export$bfebea5ce2e1887a = 'ecosystemContext';
const $4eac1b8021be0c88$export$be8e68fb1aed253e = 'forgeContext';
const $4eac1b8021be0c88$export$84e5674890d55030 = 'issuerestriction';
const $4eac1b8021be0c88$export$326a5522a485e43d = 'security';
const $4eac1b8021be0c88$export$c9f3f01e2c535302 = 'securitylevel';
const $4eac1b8021be0c88$export$35e5652f764785bd = 'creator';
const $4eac1b8021be0c88$export$66519f3bbff1796a = 'team';
const $4eac1b8021be0c88$export$a4ee0bca77cc8463 = 'estimate';
const $4eac1b8021be0c88$export$fed53408e89e0497 = 'dueDate';
const $4eac1b8021be0c88$export$d53c26f9ce31f56b = 'targetStart';
const $4eac1b8021be0c88$export$48f82d653f85e459 = 'targetEnd';
const $4eac1b8021be0c88$export$ea5a888f39f722c7 = 'startDate';
const $4eac1b8021be0c88$export$f245bbec12cc0e40 = 'color';
const $4eac1b8021be0c88$export$aed630b4b7114a59 = 'attachment';
const $4eac1b8021be0c88$export$b50c1a8fef07104 = 'issuelinks';
const $4eac1b8021be0c88$export$ea3d72f4bb7738ba = 'timeestimate';
const $4eac1b8021be0c88$export$a4cab0124760d860 = 'comment';
const $4eac1b8021be0c88$export$734929aef118d7e2 = 'worklog';
const $4eac1b8021be0c88$export$ffbacacb07c1d46d = 'parent';
const $4eac1b8021be0c88$export$871661506c0a91ea = 'aggregatetimeoriginalestimate';
const $4eac1b8021be0c88$export$278c072e2f9176ab = 'aggregatetimespent';
const $4eac1b8021be0c88$export$4a7ecfe931ab6c07 = 'aggregatetimeestimate';
const $4eac1b8021be0c88$export$fbc5ebe2e580bf8b = 'progress';
const $4eac1b8021be0c88$export$aa3b37e271efd578 = 'aggregateprogress';
const $4eac1b8021be0c88$export$444bffe6526fb5f2 = 'workratio';
/**
 * Fields shown in the issue layout
 *
 * Cannot declare as simple object - in case there is a FF in getLayoutItemMap() (which happens when we add a new field), because we cannot get FF value in SSR.
 * Memoization is needed not to rerender too many times.
 */ const $4eac1b8021be0c88$var$getLayoutFieldTypesNonMemoized = ()=>{
    const types = {
        ASSIGNEE_TYPE: $4eac1b8021be0c88$export$fba8634fd401ba8b,
        DUE_DATE_TYPE: $4eac1b8021be0c88$export$b159f8b8f27aae4c,
        PRIORITY_TYPE: $4eac1b8021be0c88$export$34740f8d07d23ac0,
        REPORTER_TYPE: $4eac1b8021be0c88$export$a91aea2438afcce8,
        DESCRIPTION_TYPE: $4eac1b8021be0c88$export$5e7324042f1d6b31,
        LABELS_TYPE: $4eac1b8021be0c88$export$43b6e33ec70f2272,
        COMPONENTS_TYPE: $4eac1b8021be0c88$export$37abf56f13f61ec5,
        SPRINT_TYPE: $4eac1b8021be0c88$export$3d37701ba6fb68ec,
        STORY_POINTS_TYPE: $4eac1b8021be0c88$export$36fd22f47020f37b,
        TEAMS_PLATFORM_CF_TYPE: $4eac1b8021be0c88$export$269d70c1b1c9fb80,
        EPIC_TYPE: $4eac1b8021be0c88$export$9f2fedcd916d2a79,
        FIX_VERSIONS_TYPE: $4eac1b8021be0c88$export$a5c9f63aadcb220,
        AFFECTS_VERSIONS_TYPE: $4eac1b8021be0c88$export$94009605902e4fe5,
        TIME_ESTIMATE_TYPE: $4eac1b8021be0c88$export$c8bedad98a5e7f5f,
        TIME_TRACKING_TYPE: $4eac1b8021be0c88$export$ccb5ffefbf8b987c,
        ENVIRONMENT_TYPE: $4eac1b8021be0c88$export$113281d03e6830ef,
        DEV_SUMMARY_TYPE: $4eac1b8021be0c88$export$827a1c600bac12a3,
        APPROVALS_PANEL_TYPE: $4eac1b8021be0c88$export$7773375e72c953ed,
        KNOWLEDGE_BASE_TYPE: $4eac1b8021be0c88$export$b5358afda8ff335e,
        SLA_PANEL_TYPE: $4eac1b8021be0c88$export$7b3d247435a784fa,
        LINKED_ALERTS_TYPE: $4eac1b8021be0c88$export$17b7080ed1fe8cfd,
        CHAT_CHANNEL_TYPE: $4eac1b8021be0c88$export$29fe745131dad7ba,
        MSTEAMS_CHANNEL_TYPE: $4eac1b8021be0c88$export$9c245100c3091ec3,
        ZOOM_MEETING_TYPE: $4eac1b8021be0c88$export$51eb15cea47a37ba,
        MANAGE_STAKEHOLDERS_TYPE: $4eac1b8021be0c88$export$c7ae0622b0bd5d56,
        CONFERENCE_CALL_TYPE: $4eac1b8021be0c88$export$f7dcde9e9e88aff2,
        ASSETS_CF_TYPE: $4eac1b8021be0c88$export$ed2de20ab8b7ad3d,
        RESPONDERS_CF_TYPE: $4eac1b8021be0c88$export$bcf83e1d934501c9,
        MAJOR_INCIDENT_CF_TYPE: $4eac1b8021be0c88$export$ae0eeec12e90a01e,
        COLOR_CF_TYPE: $4eac1b8021be0c88$export$b4a1fbc1cf0059cf,
        EPIC_COLOR_TYPE: $4eac1b8021be0c88$export$4838a8a8d62a64fd,
        RELEASES_TYPE: $4eac1b8021be0c88$export$e9ba671d077969f8,
        PARENT_CF_TYPE: $4eac1b8021be0c88$export$3e71e11f80203acb,
        BASELINE_START_CF_TYPE: $4eac1b8021be0c88$export$d10d66823a65e688,
        BASELINE_END_CF_TYPE: $4eac1b8021be0c88$export$dfc6da4a9963d5dc,
        LABELS_CF_TYPE: $4eac1b8021be0c88$export$ad4eb83f78528e13,
        TEXT_CF_TYPE: $4eac1b8021be0c88$export$68c7e01d5460d298,
        MULTI_USER_CF_TYPE: $4eac1b8021be0c88$export$5365f2d3fac5261a,
        PARTICIPANTS_CF_TYPE: $4eac1b8021be0c88$export$cc8ffff49170b0f4,
        URL_CF_TYPE: $4eac1b8021be0c88$export$60f0bd6e4b582fe6,
        NUMBER_CF_TYPE: $4eac1b8021be0c88$export$c7faa96db185cfc6,
        STORY_POINT_ESTIMATE_CF_TYPE: $4eac1b8021be0c88$export$492b0fa4fe201a22,
        SELECT_CF_TYPE: $4eac1b8021be0c88$export$22ac48a51c014e4b,
        EPIC_STATUS_TYPE: $4eac1b8021be0c88$export$6769c2c97b828e11,
        MULTI_SELECT_CF_TYPE: $4eac1b8021be0c88$export$c5d13ea26562d57a,
        ECOSYSTEM_GLANCE_TYPE: $4eac1b8021be0c88$export$99ad62164189f781,
        FORGE_CUSTOM_FIELD_TYPE: $4eac1b8021be0c88$export$798d2f5814884447,
        ISSUE_FIELD_USER_CF_TYPE: $4eac1b8021be0c88$export$5600354b43577e17,
        ISSUE_FIELD_GROUPS_CF_TYPE: $4eac1b8021be0c88$export$eb39592ba5247ee7,
        ISSUE_FIELD_STRINGS_CF_TYPE: $4eac1b8021be0c88$export$f48a9be226105736,
        FORGE_GLANCE_TYPE: $4eac1b8021be0c88$export$7719ef6e9283671,
        TEXT_AREA_CF_TYPE: $4eac1b8021be0c88$export$39cd48613b53ce2f,
        MULTI_VERSION_CF_TYPE: $4eac1b8021be0c88$export$39866626496bbfc8,
        VERSION_CF_TYPE: $4eac1b8021be0c88$export$24382b4e8c58336b,
        DATE_CF_TYPE: $4eac1b8021be0c88$export$ff745f432984005d,
        GROUP_CF_TYPE: $4eac1b8021be0c88$export$b075907882e80160,
        MULTI_GROUP_CF_TYPE: $4eac1b8021be0c88$export$b600addfa3355c57,
        USER_CF_TYPE: $4eac1b8021be0c88$export$c491a4b98394028e,
        DATETIME_CF_TYPE: $4eac1b8021be0c88$export$42d097f7b1622ef1,
        MULTI_CHECKBOXES_CF_TYPE: $4eac1b8021be0c88$export$5280e5501a801dc0,
        RADIO_BUTTONS_CF_TYPE: $4eac1b8021be0c88$export$65524be5675e57e6,
        TEAM_CF_TYPE: $4eac1b8021be0c88$export$eb1f1dca13a0f02d,
        ISSUE_FIELD_NUMBER_CF_TYPE: $4eac1b8021be0c88$export$bc917bc699b25f75,
        ISSUE_FIELD_DATETIME_CF_TYPE: $4eac1b8021be0c88$export$ce9bfd823c7e1a6d,
        ISSUE_FIELD_STRING_CF_TYPE: $4eac1b8021be0c88$export$5f26ca419fdffbe7,
        ISSUE_FIELD_SINGLE_SELECT_CF_TYPE: $4eac1b8021be0c88$export$b20fbcacd7942c2a,
        ISSUE_FIELD_MULTI_SELECT_CF_TYPE: $4eac1b8021be0c88$export$f25cd4907cbb25b9,
        REQUEST_TYPE_CF_TYPE: $4eac1b8021be0c88$export$6da975fce1fbd38e,
        SERVICE_ENTITY_CF_TYPE: $4eac1b8021be0c88$export$b755e97dbfa92610,
        REQUEST_PARTICIPANTS_CF_TYPE: $4eac1b8021be0c88$export$1be1ecd4dfc06fab,
        ORGANIZATIONS_CF_TYPE: $4eac1b8021be0c88$export$34317c2d84a93553,
        REQUEST_FEEDBACK_CF_TYPE: $4eac1b8021be0c88$export$1f2859a3ef701a14,
        PEOPLE_CF_TYPE: $4eac1b8021be0c88$export$fb431e758c9252df,
        REQUEST_LANGUAGE_CF_TYPE: $4eac1b8021be0c88$export$555b4f35f98a3210,
        ASSET_ONBOARDING_TYPE: $4eac1b8021be0c88$export$63cf6f392da16c25,
        APPROVERS_LIST_CF_TYPE: $4eac1b8021be0c88$export$c6dd874aae21e51f,
        CASCADING_SELECT_CF_TYPE: $4eac1b8021be0c88$export$c3c9f8a8a8dc0b30,
        PROJECT_PICKER_CF_TYPE: $4eac1b8021be0c88$export$65a6076c0927d413,
        CMDB_OBJECT_CF_TYPE: $4eac1b8021be0c88$export$3b5a62bb34372404,
        READ_ONLY_CF_TYPE: $4eac1b8021be0c88$export$247829aef464243f,
        MESSAGE_VIEW_CF_TYPE: $4eac1b8021be0c88$export$21dda64db57e4883,
        MESSAGE_EDIT_CF_TYPE: $4eac1b8021be0c88$export$45700f3bf92a003a,
        EPIC_NAME_TYPE: $4eac1b8021be0c88$export$dfc63737b8c0150d,
        ECOSYSTEM_CONTEXT_TYPE: $4eac1b8021be0c88$export$bfebea5ce2e1887a,
        CATEGORY_TYPE: $4eac1b8021be0c88$export$3c7d8923295a5199,
        ENTITLEMENT_CF_TYPE: $4eac1b8021be0c88$export$c23f6b40da18371a,
        GOALS_CF_TYPE: $4eac1b8021be0c88$export$2bbb7f69c97ea279
    };
    Object.assign(types, {
        FORGE_CONTEXT_TYPE: $4eac1b8021be0c88$export$be8e68fb1aed253e
    });
    if ((0, $1ybV0.ff)('parent-field-in-issue-view_x4zn4')) Object.assign(types, {
        PARENT_TYPE: $4eac1b8021be0c88$export$5e93f2a57cc4ca3a
    });
    if ((0, $1ybV0.ff)('jsm-sentiment-analysis_1dage')) Object.assign(types, {
        SENTIMENT_TYPE: $4eac1b8021be0c88$export$45e72c9a63ab61ab
    });
    if ((0, $1ybV0.ff)('sentiment-custom-field')) Object.assign(types, {
        SENTIMENT_CF_TYPE: $4eac1b8021be0c88$export$c23cfbdf83daa90d
    });
    return types;
};
const $4eac1b8021be0c88$export$3c3e26aadbfa2c32 = (0, $5iWql.default)($4eac1b8021be0c88$var$getLayoutFieldTypesNonMemoized);

});


parcelRegister("5JqpU", function(module, exports) {

$parcel$export(module.exports, "contextSelector", () => $2109a7cb7c7dfa9a$export$c420c9f40402ab6d);
$parcel$export(module.exports, "accountIdloggedInUserSelector", () => $2109a7cb7c7dfa9a$export$cb29341089829e17);
$parcel$export(module.exports, "orgIdSelector", () => $2109a7cb7c7dfa9a$export$24984a39db14d8);
$parcel$export(module.exports, "baseUrlSelector", () => $2109a7cb7c7dfa9a$export$1ca9a92a5f28e233);
$parcel$export(module.exports, "loginRedirectUrlSelector", () => $2109a7cb7c7dfa9a$export$767583fcce1653ec);
$parcel$export(module.exports, "issueKeySelector", () => $2109a7cb7c7dfa9a$export$d22bc6271070f453);
$parcel$export(module.exports, "issueIdSelector", () => $2109a7cb7c7dfa9a$export$31efbca30077ec1e);
$parcel$export(module.exports, "projectKeySelector", () => $2109a7cb7c7dfa9a$export$404de5ac601b84bc);
$parcel$export(module.exports, "analyticsSourceSelector", () => $2109a7cb7c7dfa9a$export$85a9d212d56669b4);
$parcel$export(module.exports, "cloudIdSelector", () => $2109a7cb7c7dfa9a$export$b5a643cfff945455);
$parcel$export(module.exports, "activationIdSelector", () => $2109a7cb7c7dfa9a$export$2335b963a9875096);
$parcel$export(module.exports, "isAnonymousSelector", () => $2109a7cb7c7dfa9a$export$a165ec261432d0b8);
$parcel$export(module.exports, "localeSelector", () => $2109a7cb7c7dfa9a$export$f7b7935883444b11);
$parcel$export(module.exports, "issueActionsSelector", () => $2109a7cb7c7dfa9a$export$b62cb5286b153905);
$parcel$export(module.exports, "applicationKeySelector", () => $2109a7cb7c7dfa9a$export$6c7d07328f197de7);
$parcel$export(module.exports, "isMobileSelector", () => $2109a7cb7c7dfa9a$export$4cbb8c74e98876a5);
$parcel$export(module.exports, "isBitbucketSelector", () => $2109a7cb7c7dfa9a$export$245e5ba54167b84a);
$parcel$export(module.exports, "isServiceDeskSelector", () => $2109a7cb7c7dfa9a$export$43d733e4b7e8c7d0);
$parcel$export(module.exports, "isEcosystemEnabledSelector", () => $2109a7cb7c7dfa9a$export$9bffc1987c753bd9);
$parcel$export(module.exports, "rapidViewIdSelector", () => $2109a7cb7c7dfa9a$export$718e830000b27a0e);
$parcel$export(module.exports, "boardTypeSelector", () => $2109a7cb7c7dfa9a$export$5af08fd769c0f0);
$parcel$export(module.exports, "boardIdSelector", () => $2109a7cb7c7dfa9a$export$955e7dbf76b61f80);
$parcel$export(module.exports, "siteAdminStatusSelector", () => $2109a7cb7c7dfa9a$export$93badd2a066af8bd);
$parcel$export(module.exports, "licensedProductsSelector", () => $2109a7cb7c7dfa9a$export$f29192b357e6beca);
$parcel$export(module.exports, "appPermissionsSelector", () => $2109a7cb7c7dfa9a$export$5b71e1eb43056b6c);
$parcel$export(module.exports, "isModalSelector", () => $2109a7cb7c7dfa9a$export$5fa593caa6a15917);
$parcel$export(module.exports, "shouldRenderHeaderSelector", () => $2109a7cb7c7dfa9a$export$631793d49dec78de);
$parcel$export(module.exports, "viewModeSelector", () => $2109a7cb7c7dfa9a$export$1f11fe78e4f22d45);
$parcel$export(module.exports, "appEditionsSelector", () => $2109a7cb7c7dfa9a$export$28ca74e18c8f4529);
$parcel$export(module.exports, "tenantHasActiveServiceDeskLicenseSelector", () => $2109a7cb7c7dfa9a$export$96c87532aec3474a);
$parcel$export(module.exports, "hasShownIntentToXflowToConfluenceTraitSelector", () => $2109a7cb7c7dfa9a$export$ab1f876d8f682229);
$parcel$export(module.exports, "hasActivatedConfluenceWithinFourteenDaysSelector", () => $2109a7cb7c7dfa9a$export$2b8e6729c89e24f5);

var $df4Sl = parcelRequire("df4Sl");

var $7n7Dc = parcelRequire("7n7Dc");
var $kWEgJ = parcelRequire("kWEgJ");
var $3xcI8 = parcelRequire("3xcI8");
var $3jYzf = parcelRequire("3jYzf");
var $9FEvp = parcelRequire("9FEvp");


var $e91YZ = parcelRequire("e91YZ");

var $jBy23 = parcelRequire("jBy23");

var $f9RL0 = parcelRequire("f9RL0");

var $7HKaW = parcelRequire("7HKaW");
var $6vrw7 = parcelRequire("6vrw7");
const $2109a7cb7c7dfa9a$export$c420c9f40402ab6d = (state)=>state.context;
const $2109a7cb7c7dfa9a$export$cb29341089829e17 = (0, $df4Sl.createSelector)($2109a7cb7c7dfa9a$export$c420c9f40402ab6d, (context)=>context.atlassianAccountId);
const $2109a7cb7c7dfa9a$export$24984a39db14d8 = (0, $df4Sl.createSelector)($2109a7cb7c7dfa9a$export$c420c9f40402ab6d, (context)=>context?.orgId || null);
const $2109a7cb7c7dfa9a$export$1ca9a92a5f28e233 = (_)=>'';
const $2109a7cb7c7dfa9a$export$767583fcce1653ec = (0, $df4Sl.createSelector)($2109a7cb7c7dfa9a$export$c420c9f40402ab6d, (context)=>context.loginRedirectUrl);
const $2109a7cb7c7dfa9a$export$d22bc6271070f453 = (0, $df4Sl.createSelector)($2109a7cb7c7dfa9a$export$c420c9f40402ab6d, (context)=>(0, $6vrw7.toIssueKey)(context.issueKey));
const $2109a7cb7c7dfa9a$export$31efbca30077ec1e = (0, $df4Sl.createSelector)($2109a7cb7c7dfa9a$export$c420c9f40402ab6d, (context)=>context.issueId);
const $2109a7cb7c7dfa9a$export$404de5ac601b84bc = (0, $df4Sl.createSelector)($2109a7cb7c7dfa9a$export$d22bc6271070f453, (issueKey)=>(0, $jBy23.extractProjectKey)(issueKey));
const $2109a7cb7c7dfa9a$export$85a9d212d56669b4 = (0, $df4Sl.createSelector)($2109a7cb7c7dfa9a$export$c420c9f40402ab6d, (context)=>context.analyticsSource !== undefined ? context.analyticsSource : undefined);
const $2109a7cb7c7dfa9a$export$b5a643cfff945455 = (0, $df4Sl.createSelector)($2109a7cb7c7dfa9a$export$c420c9f40402ab6d, (context)=>context.cloudId || (0, $6vrw7.toCloudId)(''));
const $2109a7cb7c7dfa9a$export$2335b963a9875096 = (0, $df4Sl.createSelector)($2109a7cb7c7dfa9a$export$c420c9f40402ab6d, (context)=>context.activationId || (0, $6vrw7.toActivationId)(''));
const $2109a7cb7c7dfa9a$export$a165ec261432d0b8 = (0, $df4Sl.createSelector)($2109a7cb7c7dfa9a$export$c420c9f40402ab6d, (context)=>context.isAnonymous);
const $2109a7cb7c7dfa9a$export$f7b7935883444b11 = (0, $df4Sl.createSelector)($2109a7cb7c7dfa9a$export$c420c9f40402ab6d, (context)=>context.locale);
const $2109a7cb7c7dfa9a$export$b62cb5286b153905 = (0, $df4Sl.createSelector)($2109a7cb7c7dfa9a$export$c420c9f40402ab6d, (context)=>context.issueActions || []);
const $2109a7cb7c7dfa9a$export$6c7d07328f197de7 = (0, $df4Sl.createSelector)($2109a7cb7c7dfa9a$export$c420c9f40402ab6d, (context)=>context.applicationKey);
const $2109a7cb7c7dfa9a$export$4cbb8c74e98876a5 = (0, $df4Sl.createSelector)(// @ts-expect-error - TS2769 - No overload matches this call.
$2109a7cb7c7dfa9a$export$85a9d212d56669b4, (analyticsSource)=>analyticsSource === (0, $0100842672acae20$export$ce88447986394f2d));
const $2109a7cb7c7dfa9a$export$6fbe1dbaf5b67cc5 = (0, $df4Sl.createSelector)($2109a7cb7c7dfa9a$export$6c7d07328f197de7, (applicationKey)=>applicationKey === (0, $f9RL0.simpleSoftwareBoardConfiguration)().applicationKey || applicationKey === (0, $f9RL0.standardRoadmapConfiguration)().applicationKey);
const $2109a7cb7c7dfa9a$export$7479ef2453efd3b4 = (0, $df4Sl.createSelector)($2109a7cb7c7dfa9a$export$6c7d07328f197de7, (applicationKey)=>applicationKey === (0, $f9RL0.softwareConfiguration)().applicationKey);
const $2109a7cb7c7dfa9a$export$245e5ba54167b84a = (0, $df4Sl.createSelector)(// @ts-expect-error - TS2769 - No overload matches this call.
$2109a7cb7c7dfa9a$export$85a9d212d56669b4, (analyticsSource)=>analyticsSource === (0, $0100842672acae20$export$7552fe2669628499));
const $2109a7cb7c7dfa9a$export$43d733e4b7e8c7d0 = (0, $df4Sl.createSelector)($2109a7cb7c7dfa9a$export$6c7d07328f197de7, (applicationKey)=>applicationKey === (0, $f9RL0.serviceDeskConfiguration)().applicationKey);
const $2109a7cb7c7dfa9a$export$9bffc1987c753bd9 = (0, $df4Sl.createSelector)($2109a7cb7c7dfa9a$export$c420c9f40402ab6d, (context)=>!!context.ecosystemEnabled);
const $2109a7cb7c7dfa9a$export$718e830000b27a0e = (0, $df4Sl.createSelector)($2109a7cb7c7dfa9a$export$c420c9f40402ab6d, (context)=>context.rapidViewId);
const $2109a7cb7c7dfa9a$export$8065de5fbcf23af5 = (0, $df4Sl.createSelector)($2109a7cb7c7dfa9a$export$c420c9f40402ab6d, (context)=>context.estimationStatistic || null);
const $2109a7cb7c7dfa9a$export$5af08fd769c0f0 = (0, $df4Sl.createSelector)($2109a7cb7c7dfa9a$export$c420c9f40402ab6d, (context)=>context.boardType);
const $2109a7cb7c7dfa9a$export$955e7dbf76b61f80 = (0, $df4Sl.createSelector)($2109a7cb7c7dfa9a$export$c420c9f40402ab6d, (context)=>context.boardId);
const $2109a7cb7c7dfa9a$export$93badd2a066af8bd = (0, $df4Sl.createSelector)($2109a7cb7c7dfa9a$export$c420c9f40402ab6d, (context)=>context.siteAdminStatus);
const $2109a7cb7c7dfa9a$export$b468116a08f9183e = (0, $df4Sl.createSelector)($2109a7cb7c7dfa9a$export$c420c9f40402ab6d, (context)=>context.productCrossSellConfig);
const $2109a7cb7c7dfa9a$export$f29192b357e6beca = (0, $df4Sl.createSelector)($2109a7cb7c7dfa9a$export$c420c9f40402ab6d, (context)=>context.licensedProducts);
const $2109a7cb7c7dfa9a$export$5b71e1eb43056b6c = (0, $df4Sl.createSelector)($2109a7cb7c7dfa9a$export$c420c9f40402ab6d, (context)=>context.appPermissions);
const $2109a7cb7c7dfa9a$export$5fa593caa6a15917 = (0, $df4Sl.createSelector)($2109a7cb7c7dfa9a$export$c420c9f40402ab6d, (context)=>context.isModal);
const $2109a7cb7c7dfa9a$export$631793d49dec78de = (0, $df4Sl.createSelector)($2109a7cb7c7dfa9a$export$5fa593caa6a15917, $2109a7cb7c7dfa9a$export$4cbb8c74e98876a5, (isModal, isMobile)=>!isModal && !isMobile);
const $2109a7cb7c7dfa9a$export$1f11fe78e4f22d45 = (0, $df4Sl.createSelector)($2109a7cb7c7dfa9a$export$c420c9f40402ab6d, (context)=>context.viewMode);
const $2109a7cb7c7dfa9a$export$28ca74e18c8f4529 = (0, $df4Sl.createSelector)($2109a7cb7c7dfa9a$export$c420c9f40402ab6d, (context)=>context.appEditions);
const $2109a7cb7c7dfa9a$export$beea798086c18f0a = (0, $df4Sl.createSelector)($2109a7cb7c7dfa9a$export$c420c9f40402ab6d, (context)=>context.licenseStates);
const $2109a7cb7c7dfa9a$export$40487a15195e570e = (0, $df4Sl.createSelector)($2109a7cb7c7dfa9a$export$beea798086c18f0a, (licenseStates)=>licenseStates && licenseStates.serviceDesk === (0, $7HKaW.LICENSE_STATE_ACTIVE));
const $2109a7cb7c7dfa9a$export$96c87532aec3474a = (0, $df4Sl.createSelector)($2109a7cb7c7dfa9a$export$f29192b357e6beca, $2109a7cb7c7dfa9a$export$40487a15195e570e, (licensedProducts, isServiceDeskLicenseActive)=>licensedProducts && licensedProducts[(0, $e91YZ.LICENSED_PRODUCTS).JIRA_SERVICEDESK] && isServiceDeskLicenseActive);
const $2109a7cb7c7dfa9a$export$ab1f876d8f682229 = (0, $df4Sl.createSelector)($2109a7cb7c7dfa9a$export$c420c9f40402ab6d, (context)=>context.hasShownIntentToXflowToConfluence);
const $2109a7cb7c7dfa9a$export$747a61878b414bda = (0, $df4Sl.createSelector)($2109a7cb7c7dfa9a$export$c420c9f40402ab6d, (context)=>context.confluenceActivationDate);
const $2109a7cb7c7dfa9a$export$2b8e6729c89e24f5 = (0, $df4Sl.createSelector)($2109a7cb7c7dfa9a$export$747a61878b414bda, (confluenceActivationDate)=>{
    try {
        if (!confluenceActivationDate) return false;
        const today = (0, $7n7Dc.default)(new Date());
        const fourteenDaysAgo = (0, $3jYzf.default)((0, $9FEvp.default)(today, 14));
        const dateToCheck = (0, $3xcI8.default)(confluenceActivationDate);
        return (0, $kWEgJ.default)(dateToCheck, {
            start: fourteenDaysAgo,
            end: today
        });
    } catch (error) {
        return false;
    }
});

});

parcelRegister("fokFV", function(module, exports) {

$parcel$export(module.exports, "fieldsSelector", () => $d3e83eef394576d0$export$e1512647ca813bfa);
$parcel$export(module.exports, "getFieldHandlingSpecialFields", () => $d3e83eef394576d0$export$46dde968006cd8d4);
$parcel$export(module.exports, "fieldByCustomTypeSelector", () => $d3e83eef394576d0$export$72dfc619a02c972c);
$parcel$export(module.exports, "customFieldIdSelector", () => $d3e83eef394576d0$export$8ad8506b941e30dc);
$parcel$export(module.exports, "fieldSelector", () => $d3e83eef394576d0$export$4ee5e7baedf94214);
$parcel$export(module.exports, "hasIssueLinksSelector", () => $d3e83eef394576d0$export$3c65f67962ca81cc);
$parcel$export(module.exports, "hasSubtasksSelector", () => $d3e83eef394576d0$export$f363078714850fd9);
$parcel$export(module.exports, "hasSubtasksValuesSelector", () => $d3e83eef394576d0$export$689f8f96c9d81e1b);
$parcel$export(module.exports, "hasPortfolioChildIssuesSelector", () => $d3e83eef394576d0$export$724b8972771ff092);
$parcel$export(module.exports, "hasPortfolioChildIssueValuesSelector", () => $d3e83eef394576d0$export$c6d2d4f8e243ac37);
$parcel$export(module.exports, "hasChildrenIssuesSelector", () => $d3e83eef394576d0$export$29f34d4d7c528e9c);
$parcel$export(module.exports, "hasChildrenIssueValuesSelector", () => $d3e83eef394576d0$export$9034aaa32d45814b);
$parcel$export(module.exports, "childIssuesLimitUrlSelector", () => $d3e83eef394576d0$export$762e13908aaafb2d);
$parcel$export(module.exports, "availableFieldIdsSelector", () => $d3e83eef394576d0$export$641248fa887fb9ea);
$parcel$export(module.exports, "fieldSchemaConfigurationSelector", () => $d3e83eef394576d0$export$3c65874760e68948);
$parcel$export(module.exports, "isFieldEditableSelector", () => $d3e83eef394576d0$export$76ece3d8c4244af2);
$parcel$export(module.exports, "fieldNameSelector", () => $d3e83eef394576d0$export$2d1abc174b8a710e);
$parcel$export(module.exports, "fieldMetaKeySelector", () => $d3e83eef394576d0$export$351970d5fcbd0b29);
$parcel$export(module.exports, "fieldARISelector", () => $d3e83eef394576d0$export$f6363cecfaa3a9b0);
$parcel$export(module.exports, "fieldAutoCompleteUrlSelector", () => $d3e83eef394576d0$export$d27105f13ab27906);
$parcel$export(module.exports, "fieldAllowedValuesSelector", () => $d3e83eef394576d0$export$351dc1c32c2771ea);
$parcel$export(module.exports, "isFieldRequiredSelector", () => $d3e83eef394576d0$export$4c5f76e28914074);
$parcel$export(module.exports, "fieldTypeSelector", () => $d3e83eef394576d0$export$9e2f15437ff59992);
$parcel$export(module.exports, "fieldPersistedValueSelector", () => $d3e83eef394576d0$export$ae4660b0b7ebeee9);
$parcel$export(module.exports, "fieldPendingValueSelector", () => $d3e83eef394576d0$export$2ae929653dce6648);
$parcel$export(module.exports, "fieldEditingValueSelector", () => $d3e83eef394576d0$export$487becf51bedcd03);
$parcel$export(module.exports, "fieldEditingAdfValueSelector", () => $d3e83eef394576d0$export$31406f841bca5b75);
$parcel$export(module.exports, "fieldHtmlValueSelector", () => $d3e83eef394576d0$export$e69c8171ecd8fde2);
$parcel$export(module.exports, "isFieldEditingSelector", () => $d3e83eef394576d0$export$29e6b1cade110749);
$parcel$export(module.exports, "fieldEditSessionIdSelector", () => $d3e83eef394576d0$export$c53ab145ef243c95);
$parcel$export(module.exports, "isFieldWaitingSelector", () => $d3e83eef394576d0$export$30e972ebce44d9b8);
$parcel$export(module.exports, "fieldInvalidMessageSelector", () => $d3e83eef394576d0$export$d323462f155519c3);
$parcel$export(module.exports, "fieldInvalidSelector", () => $d3e83eef394576d0$export$e35f4d21d9739426);
$parcel$export(module.exports, "isRichTextFieldSelector", () => $d3e83eef394576d0$export$120a4249e9b3c231);
$parcel$export(module.exports, "richTextFieldIdsSelector", () => $d3e83eef394576d0$export$862745d3ab4003e5);
$parcel$export(module.exports, "isRichTextFieldEditingSelector", () => $d3e83eef394576d0$export$df9b7004d8b93e46);
$parcel$export(module.exports, "isMultilineFieldSelector", () => $d3e83eef394576d0$export$4d0b1fe809ae5e75);
$parcel$export(module.exports, "getEditingMultilineFieldIdsSelector", () => $d3e83eef394576d0$export$2469330614f0dba9);
$parcel$export(module.exports, "getVersionsFieldIds", () => $d3e83eef394576d0$export$a2fc0905011957cb);

var $df4Sl = parcelRequire("df4Sl");

var $8i1R8 = parcelRequire("8i1R8");

var $gUUjF = parcelRequire("gUUjF");


var $btjMs = parcelRequire("btjMs");

var $f9RL0 = parcelRequire("f9RL0");

var $lO4Or = parcelRequire("lO4Or");


var $5JqpU = parcelRequire("5JqpU");

var $9BmVu = parcelRequire("9BmVu");

var $7K0ls = parcelRequire("7K0ls");
// eslint-disable-next-line @typescript-eslint/no-explicit-any
const $d3e83eef394576d0$var$STABLE_EMPTY_ARRAY = [];
// eslint-disable-next-line @typescript-eslint/no-explicit-any
const $d3e83eef394576d0$var$STABLE_EMPTY_OBJECT = {};
const $d3e83eef394576d0$export$e1512647ca813bfa = (state)=>state.fields || $d3e83eef394576d0$var$STABLE_EMPTY_OBJECT;
const $d3e83eef394576d0$var$getFieldByCustomType = (customType, fields)=>(0, (/*@__PURE__*/$parcel$interopDefault($8i1R8)))(fields, (field)=>(field.schema && field.schema.custom) === customType);
const $d3e83eef394576d0$export$46dde968006cd8d4 = (fieldId, fields)=>{
    let field = fields[fieldId];
    const customSystemFields = (0, $f9RL0.specialFields)();
    if (!field && Object.keys(customSystemFields).includes(fieldId)) {
        // @ts-expect-error - TS7053 - Element implicitly has an 'any' type because expression of type 'string' can't be used to index type 'SpecialFieldTypes'.
        const customType = customSystemFields[fieldId];
        // @ts-expect-error - TS2322 - Type 'Field | undefined' is not assignable to type 'Field'.
        field = $d3e83eef394576d0$var$getFieldByCustomType(customType, fields);
    }
    return field;
};
const $d3e83eef394576d0$export$cb67eba45dd11f50 = (0, $df4Sl.createSelector)($d3e83eef394576d0$export$e1512647ca813bfa, (state, { fieldId: fieldId })=>fieldId, (fields, fieldId)=>!!fields[fieldId]);
const $d3e83eef394576d0$export$309344981947f228 = (fieldsState, fieldName)=>Array.isArray(fieldsState[fieldName]?.value) ? fieldsState[fieldName].value.length > 0 : fieldsState[fieldName]?.value != null;
const $d3e83eef394576d0$export$72dfc619a02c972c = (customType)=>(0, $df4Sl.createSelector)($d3e83eef394576d0$export$e1512647ca813bfa, (fields)=>$d3e83eef394576d0$var$getFieldByCustomType(customType, fields));
const $d3e83eef394576d0$export$8ad8506b941e30dc = (customFieldType)=>(0, $df4Sl.createSelector)($d3e83eef394576d0$export$72dfc619a02c972c(customFieldType), (customField)=>{
        const idCandidates = customField ? customField.key.match(/customfield_(\d+)$/i) : null;
        return idCandidates ? +idCandidates[1] : null;
    });
const $d3e83eef394576d0$export$4ee5e7baedf94214 = (fieldId)=>(0, $df4Sl.createSelector)($d3e83eef394576d0$export$e1512647ca813bfa, (fields)=>$d3e83eef394576d0$export$46dde968006cd8d4(fieldId, fields));
const $d3e83eef394576d0$export$b8de62018cc85a18 = (0, $df4Sl.createSelector)($d3e83eef394576d0$export$e1512647ca813bfa, (state, { fieldId: fieldId })=>fieldId, (fields, fieldId)=>$d3e83eef394576d0$export$46dde968006cd8d4(fieldId, fields));
const $d3e83eef394576d0$export$3c65f67962ca81cc = (0, $df4Sl.createSelector)($d3e83eef394576d0$export$e1512647ca813bfa, (fields)=>!!Object.keys(fields).includes((0, $ebc098a76317be78$export$a5fc282ab2bf9b89)));
const $d3e83eef394576d0$export$f363078714850fd9 = (0, $df4Sl.createSelector)($d3e83eef394576d0$export$e1512647ca813bfa, (fields)=>!!Object.keys(fields).includes('subtasks'));
const $d3e83eef394576d0$export$689f8f96c9d81e1b = (0, $df4Sl.createSelector)($d3e83eef394576d0$export$e1512647ca813bfa, (fields)=>$d3e83eef394576d0$export$309344981947f228(fields, 'subtasks'));
const $d3e83eef394576d0$export$724b8972771ff092 = (0, $df4Sl.createSelector)($d3e83eef394576d0$export$e1512647ca813bfa, (fields)=>!!Object.keys(fields).includes((0, $f9RL0.PORTFOLIO_CHILD_ISSUES)));
const $d3e83eef394576d0$export$c6d2d4f8e243ac37 = (0, $df4Sl.createSelector)($d3e83eef394576d0$export$e1512647ca813bfa, (fields)=>$d3e83eef394576d0$export$309344981947f228(fields, (0, $f9RL0.PORTFOLIO_CHILD_ISSUES)));
const $d3e83eef394576d0$export$29f34d4d7c528e9c = (0, $df4Sl.createSelector)($d3e83eef394576d0$export$e1512647ca813bfa, (fields)=>!!Object.keys(fields).includes((0, $f9RL0.CHILDREN_ISSUES)));
const $d3e83eef394576d0$export$9034aaa32d45814b = (0, $df4Sl.createSelector)($d3e83eef394576d0$export$e1512647ca813bfa, (fields)=>$d3e83eef394576d0$export$309344981947f228(fields, (0, $f9RL0.CHILDREN_ISSUES)));
const $d3e83eef394576d0$export$762e13908aaafb2d = (0, $df4Sl.createSelector)($d3e83eef394576d0$export$e1512647ca813bfa, (fields)=>{
    const getChildIssueUrlSelector = (fieldId)=>fields?.[fieldId]?.issueLimitUrl || '';
    return getChildIssueUrlSelector;
});
const $d3e83eef394576d0$export$9ee3b3f5d4ad4423 = (0, $df4Sl.createSelector)($d3e83eef394576d0$export$e1512647ca813bfa, (fields)=>Object.keys(fields).map((fieldKey)=>$d3e83eef394576d0$export$46dde968006cd8d4(fieldKey, fields)).filter(Boolean));
const $d3e83eef394576d0$export$641248fa887fb9ea = (0, $df4Sl.createSelector)($d3e83eef394576d0$export$e1512647ca813bfa, (fields)=>Object.keys(fields));
const $d3e83eef394576d0$export$e50b5889a6b86caf = (field)=>field ? field.editable : false;
const $d3e83eef394576d0$export$3c65874760e68948 = (fieldId)=>(0, $df4Sl.createSelector)($d3e83eef394576d0$export$4ee5e7baedf94214(fieldId), (field)=>field && field.schema && field.schema.configuration && // eslint-disable-next-line @typescript-eslint/no-explicit-any
        field.schema.configuration.reduce((config, { key: key, value: value })=>({
                // eslint-disable-next-line jira/js/no-reduce-accumulator-spread
                ...config,
                [key]: value
            }), {}));
const $d3e83eef394576d0$export$76ece3d8c4244af2 = (fieldId)=>(0, $df4Sl.createSelector)($d3e83eef394576d0$export$4ee5e7baedf94214(fieldId), (field)=>$d3e83eef394576d0$export$e50b5889a6b86caf(field));
const $d3e83eef394576d0$export$2d1abc174b8a710e = (fieldId)=>(0, $df4Sl.createSelector)($d3e83eef394576d0$export$4ee5e7baedf94214(fieldId), (field)=>{
        if (field && field.title) return field.title;
        (0, $gUUjF.default).safeWarnWithoutCustomerData('issue.field.selector', `${fieldId} does not have a field title`);
        return '';
    });
const $d3e83eef394576d0$export$d20285fb6e3fb007 = (0, $df4Sl.createSelector)($d3e83eef394576d0$export$b8de62018cc85a18, (state, { fieldId: fieldId })=>fieldId, (field, fieldId)=>{
    if (field?.title) return field.title;
    (0, $gUUjF.default).safeWarnWithoutCustomerData('issue.field.selector', `${fieldId} does not have a field title`);
    return '';
});
const $d3e83eef394576d0$export$351970d5fcbd0b29 = (fieldId)=>(0, $df4Sl.createSelector)($d3e83eef394576d0$export$4ee5e7baedf94214(fieldId), (field)=>field && field.key);
const $d3e83eef394576d0$export$f6363cecfaa3a9b0 = (fieldId)=>(0, $df4Sl.createSelector)($d3e83eef394576d0$export$4ee5e7baedf94214(fieldId), (field)=>field ? field.ari : undefined);
const $d3e83eef394576d0$export$d27105f13ab27906 = (fieldId)=>// @ts-expect-error - TS2322 - Type 'OutputSelector<Readonly<{ agile: Agile; context: ContextState; entities: Readonly<{ applicationRoles?: ApplicationRole[] | undefined; cardCover: CardCover; childrenIssues: ChildrenIssuesState; ... 29 more ...; myPreferences?: Partial<...> | undefined; }>; ... 5 more ...; validators: Validators; }>, string | ... 1 mo...' is not assignable to type '(arg1: Readonly<{ agile: Agile; context: ContextState; entities: Readonly<{ applicationRoles?: ApplicationRole[] | undefined; cardCover: CardCover; childrenIssues: ChildrenIssuesState; ... 29 more ...; myPreferences?: Partial<...> | undefined; }>; ... 5 more ...; validators: Validators; }>) => string | null'.
    (0, $df4Sl.createSelector)($d3e83eef394576d0$export$4ee5e7baedf94214(fieldId), (field)=>field && field.autoCompleteUrl);
const $d3e83eef394576d0$export$351dc1c32c2771ea = (fieldId)=>// eslint-disable-next-line @typescript-eslint/no-explicit-any
    (0, $df4Sl.createSelector)($d3e83eef394576d0$export$4ee5e7baedf94214(fieldId), (field)=>field ? field.allowedValues : $d3e83eef394576d0$var$STABLE_EMPTY_ARRAY);
const $d3e83eef394576d0$export$4c5f76e28914074 = (fieldId)=>(0, $df4Sl.createSelector)($d3e83eef394576d0$export$4ee5e7baedf94214(fieldId), (field)=>field ? field.required : false);
const $d3e83eef394576d0$export$9e2f15437ff59992 = (fieldId)=>// @ts-expect-error - TS2322 - Type 'OutputSelector<Readonly<{ agile: Agile; context: ContextState; entities: Readonly<{ applicationRoles?: ApplicationRole[] | undefined; cardCover: CardCover; childrenIssues: ChildrenIssuesState; ... 29 more ...; myPreferences?: Partial<...> | undefined; }>; ... 5 more ...; validators: Validators; }>, string | ... 1 mo...' is not assignable to type '(arg1: Readonly<{ agile: Agile; context: ContextState; entities: Readonly<{ applicationRoles?: ApplicationRole[] | undefined; cardCover: CardCover; childrenIssues: ChildrenIssuesState; ... 29 more ...; myPreferences?: Partial<...> | undefined; }>; ... 5 more ...; validators: Validators; }>) => string | null'.
    (0, $df4Sl.createSelector)($d3e83eef394576d0$export$4ee5e7baedf94214(fieldId), (field)=>field && (0, $btjMs.getFieldType)(field));
const $d3e83eef394576d0$export$ae4660b0b7ebeee9 = (fieldId)=>// eslint-disable-next-line @typescript-eslint/no-explicit-any
    (0, $df4Sl.createSelector)($d3e83eef394576d0$export$4ee5e7baedf94214(fieldId), (field)=>field && field.value);
const $d3e83eef394576d0$export$bf3f8fd2c145740 = (0, $df4Sl.createSelector)($d3e83eef394576d0$export$b8de62018cc85a18, (field)=>field?.value);
const $d3e83eef394576d0$export$2ae929653dce6648 = (fieldId)=>(0, $df4Sl.createSelector)($d3e83eef394576d0$export$4ee5e7baedf94214(fieldId), (field)=>field && (0, $7K0ls.default)(field));
const $d3e83eef394576d0$export$487becf51bedcd03 = (fieldId)=>(0, $df4Sl.createSelector)($d3e83eef394576d0$export$4ee5e7baedf94214(fieldId), (field)=>field && (0, $9BmVu.default)(field));
const $d3e83eef394576d0$export$31406f841bca5b75 = (fieldId)=>(0, $df4Sl.createSelector)($d3e83eef394576d0$export$4ee5e7baedf94214(fieldId), // eslint-disable-next-line @typescript-eslint/no-explicit-any
    (field)=>field && (0, $9BmVu.getEditingAdfValue)(field));
const $d3e83eef394576d0$export$e69c8171ecd8fde2 = (fieldId)=>// eslint-disable-next-line @typescript-eslint/no-explicit-any
    (0, $df4Sl.createSelector)($d3e83eef394576d0$export$4ee5e7baedf94214(fieldId), (field)=>field && field.renderedValue);
const $d3e83eef394576d0$export$4e96991314eba25 = (0, $df4Sl.createSelector)($d3e83eef394576d0$export$b8de62018cc85a18, (field)=>field?.renderedValue);
const $d3e83eef394576d0$export$18ec1d851ee244b3 = (field)=>field ? field.editingValue !== undefined : false;
const $d3e83eef394576d0$export$29e6b1cade110749 = (fieldId)=>(0, $df4Sl.createSelector)($d3e83eef394576d0$export$4ee5e7baedf94214(fieldId), (field)=>$d3e83eef394576d0$export$18ec1d851ee244b3(field));
const $d3e83eef394576d0$export$c53ab145ef243c95 = (fieldId)=>(0, $df4Sl.createSelector)($d3e83eef394576d0$export$4ee5e7baedf94214(fieldId), (field)=>(field ? field.fieldEditSessionId : null) || '');
const $d3e83eef394576d0$export$30e972ebce44d9b8 = (fieldId)=>(0, $df4Sl.createSelector)($d3e83eef394576d0$export$4ee5e7baedf94214(fieldId), (field)=>field ? field.pendingValue !== undefined : false);
const $d3e83eef394576d0$export$d323462f155519c3 = (fieldId, fallbackInvalidMessage)=>// @ts-expect-error - TS2322 - Type 'OutputSelector<Readonly<{ agile: Agile; context: ContextState; entities: Readonly<{ applicationRoles?: ApplicationRole[] | undefined; cardCover: CardCover; childrenIssues: ChildrenIssuesState; ... 29 more ...; myPreferences?: Partial<...> | undefined; }>; ... 5 more ...; validators: Validators; }>, string | ... 1 mo...' is not assignable to type '(arg1: Readonly<{ agile: Agile; context: ContextState; entities: Readonly<{ applicationRoles?: ApplicationRole[] | undefined; cardCover: CardCover; childrenIssues: ChildrenIssuesState; ... 29 more ...; myPreferences?: Partial<...> | undefined; }>; ... 5 more ...; validators: Validators; }>) => string | null'.
    (0, $df4Sl.createSelector)($d3e83eef394576d0$export$4ee5e7baedf94214(fieldId), (field)=>field && (field.isInvalid ? field.invalidMessage || fallbackInvalidMessage : null));
const $d3e83eef394576d0$export$e35f4d21d9739426 = (fieldId)=>(0, $df4Sl.createSelector)($d3e83eef394576d0$export$4ee5e7baedf94214(fieldId), (field)=>Boolean(field && field.isInvalid));
const $d3e83eef394576d0$export$448aaad27e620666 = (fieldId)=>// @ts-expect-error - TS2322 - Type 'OutputSelector<Readonly<{ agile: Agile; context: ContextState; entities: Readonly<{ applicationRoles?: ApplicationRole[] | undefined; cardCover: CardCover; childrenIssues: ChildrenIssuesState; ... 29 more ...; myPreferences?: Partial<...> | undefined; }>; ... 5 more ...; validators: Validators; }>, string | ... 1 mo...' is not assignable to type '(arg1: Readonly<{ agile: Agile; context: ContextState; entities: Readonly<{ applicationRoles?: ApplicationRole[] | undefined; cardCover: CardCover; childrenIssues: ChildrenIssuesState; ... 29 more ...; myPreferences?: Partial<...> | undefined; }>; ... 5 more ...; validators: Validators; }>) => string | null'.
    (0, $df4Sl.createSelector)($d3e83eef394576d0$export$4ee5e7baedf94214(fieldId), (field)=>field && field.schema && field.schema.renderer);
const $d3e83eef394576d0$export$94cc87cea4e06b09 = (fieldType)=>fieldType === (0, $lO4Or.TEXT_AREA_CF_TYPE) || fieldType === (0, $f9RL0.ENVIRONMENT) || fieldType === (0, $f9RL0.DESCRIPTION);
const $d3e83eef394576d0$export$120a4249e9b3c231 = (fieldId)=>(0, $df4Sl.createSelector)((0, $5JqpU.isServiceDeskSelector), $d3e83eef394576d0$export$9e2f15437ff59992(fieldId), $d3e83eef394576d0$export$448aaad27e620666(fieldId), (isServiceDesk, fieldType, fieldRenderer)=>{
        const isDescription = fieldId === (0, $f9RL0.DESCRIPTION);
        const isMultilineRichTextField = $d3e83eef394576d0$export$94cc87cea4e06b09(fieldType) && fieldRenderer === (0, $c7e7b1d3600a0c0f$export$89b8c5d86c10a68c);
        return isDescription || isMultilineRichTextField;
    });
const $d3e83eef394576d0$export$862745d3ab4003e5 = (0, $df4Sl.createSelector)($d3e83eef394576d0$export$e1512647ca813bfa, (state)=>state, (fields, state)=>Object.keys(fields).filter((fieldId)=>$d3e83eef394576d0$export$120a4249e9b3c231(fieldId)(state)));
const $d3e83eef394576d0$export$df9b7004d8b93e46 = (0, $df4Sl.createSelector)($d3e83eef394576d0$export$862745d3ab4003e5, (state)=>state, (richTextFieldIds, state)=>richTextFieldIds.some((fieldId)=>$d3e83eef394576d0$export$29e6b1cade110749(fieldId)(state)));
const $d3e83eef394576d0$export$4d0b1fe809ae5e75 = (fieldId)=>(0, $df4Sl.createSelector)($d3e83eef394576d0$export$9e2f15437ff59992(fieldId), (fieldType)=>$d3e83eef394576d0$export$94cc87cea4e06b09(fieldType));
const $d3e83eef394576d0$export$3263c202444b0e0 = (0, $df4Sl.createSelector)($d3e83eef394576d0$export$e1512647ca813bfa, (state)=>state, (fields, state)=>Object.keys(fields).filter((fieldId)=>$d3e83eef394576d0$export$4d0b1fe809ae5e75(fieldId)(state)));
const $d3e83eef394576d0$export$2469330614f0dba9 = (0, $df4Sl.createSelector)($d3e83eef394576d0$export$3263c202444b0e0, (state)=>state, (multilineFieldsIds, state)=>multilineFieldsIds.filter((fieldId)=>$d3e83eef394576d0$export$29e6b1cade110749(fieldId)(state)));
const $d3e83eef394576d0$export$a2fc0905011957cb = (0, $df4Sl.createSelector)($d3e83eef394576d0$export$4ee5e7baedf94214((0, $f9RL0.FIX_VERSIONS)), $d3e83eef394576d0$export$4ee5e7baedf94214((0, $f9RL0.AFFECTS_VERSIONS)), (fixVersions, affectsVersions)=>{
    const ids = [];
    if (fixVersions) ids.push(fixVersions.key);
    if (affectsVersions) ids.push(affectsVersions.key);
    return ids;
});

});
const $c7e7b1d3600a0c0f$export$89b8c5d86c10a68c = 'atlassian-wiki-renderer';
const $c7e7b1d3600a0c0f$export$a4a240cb4053b29f = 'jira-text-renderer';
const $c7e7b1d3600a0c0f$export$840ed33fa94f7693 = 'frother-control-renderer';

parcelRegister("btjMs", function(module, exports) {

$parcel$export(module.exports, "getFieldType", () => $2e3967e17ab00816$export$b9089a6e41ed43aa);
$parcel$export(module.exports, "isRichTextSupported", () => $2e3967e17ab00816$export$24d1b07fa0e9f9f1);


var $f9RL0 = parcelRequire("f9RL0");

var $lO4Or = parcelRequire("lO4Or");
const $2e3967e17ab00816$var$atlassianSystemCFTypes = ()=>{
    const customSystemFields = (0, $f9RL0.specialFields)();
    return [
        ...(0, $f9RL0.customFieldsToDisplay)().filter((cf)=>!(0, $f9RL0.ecosystemCustomFields).includes(cf)),
        // @ts-expect-error - TS7053 - Element implicitly has an 'any' type because expression of type 'string' can't be used to index type 'SpecialFieldTypes'.
        ...Object.keys(customSystemFields).map((key)=>customSystemFields[key]),
        (0, $lO4Or.FLAGGED_CF_TYPE)
    ];
};
const $2e3967e17ab00816$export$f521834fc2bfcd81 = (custom)=>$2e3967e17ab00816$var$atlassianSystemCFTypes().find((type)=>type === custom);
const $2e3967e17ab00816$export$b9089a6e41ed43aa = (field)=>{
    const fieldSchema = field ? field.schema : undefined;
    return fieldSchema ? $2e3967e17ab00816$export$f521834fc2bfcd81(fieldSchema.custom) || fieldSchema.system || fieldSchema.type : undefined;
};
const $2e3967e17ab00816$export$24d1b07fa0e9f9f1 = (field)=>{
    const fieldSchema = field ? field.schema : undefined;
    return fieldSchema ? fieldSchema.type === (0, $lO4Or.ISSUE_FIELD_STRING_CF_TYPE) && fieldSchema.renderer === (0, $c7e7b1d3600a0c0f$export$89b8c5d86c10a68c) || $2e3967e17ab00816$export$b9089a6e41ed43aa(field) === (0, $lO4Or.DESCRIPTION_TYPE) : false;
};

});

const $ebc098a76317be78$export$e18419056f3d184a = 'assignee';
const $ebc098a76317be78$export$45cafdfd629c3ca1 = 'reporter';
const $ebc098a76317be78$export$d5bc879e3b748593 = 'description';
const $ebc098a76317be78$export$a68dbc90211df1a8 = 'fixVersions';
const $ebc098a76317be78$export$93605f2a09aa8d26 = 'labels';
const $ebc098a76317be78$export$4420b7468f889692 = 'status';
const $ebc098a76317be78$export$e7cf1830fe735d1f = 'summary';
const $ebc098a76317be78$export$5fbd3b15555b9ef2 = 'timeoriginalestimate';
const $ebc098a76317be78$export$a5fc282ab2bf9b89 = 'issuelinks';
const $ebc098a76317be78$export$b52547457d714bc0 = 'epic-issues';
const $ebc098a76317be78$export$3cca6e37a5823d5a = 'children-issues';
const $ebc098a76317be78$export$98a935eb30de54ab = 'components';

parcelRegister("9BmVu", function(module, exports) {

$parcel$export(module.exports, "default", () => $d346be13db9b307d$export$2e2bcd8739ae039);
$parcel$export(module.exports, "getEditingAdfValue", () => $d346be13db9b307d$export$a799cf637c5b7727);

var $7K0ls = parcelRequire("7K0ls");
var /**
 * Returns the first available value for a given field.
 * editingValue => pendingValue => value
 */ // eslint-disable-next-line jira/import/no-anonymous-default-export
$d346be13db9b307d$export$2e2bcd8739ae039 = (field)=>typeof field.editingValue !== 'undefined' ? field.editingValue : (0, $7K0ls.default)(field);
const $d346be13db9b307d$export$a799cf637c5b7727 = (field)=>field.editingValue || (0, $7K0ls.getPendingAdfValue)(field);

});
parcelRegister("7K0ls", function(module, exports) {

$parcel$export(module.exports, "default", () => $8d564564465be8d6$export$2e2bcd8739ae039);
$parcel$export(module.exports, "getPendingAdfValue", () => $8d564564465be8d6$export$5012210a9f91b010);
var /**
 * Returns the first available value for a given field, excluding editingValue
 * pendingValue => value
 */ // eslint-disable-next-line jira/import/no-anonymous-default-export
$8d564564465be8d6$export$2e2bcd8739ae039 = (field)=>typeof field.pendingValue !== 'undefined' ? field.pendingValue : field.value;
const $8d564564465be8d6$export$5012210a9f91b010 = (field)=>field.pendingValue || field.adfValue || field.value;

});





parcelRegister("lMwBY", function(module, exports) {

$parcel$export(module.exports, "afterPaintEmit", () => $6a5d9a384a9292d0$export$dc4c3408669b8f4e);

var $6iz4v = parcelRequire("6iz4v");

const $6a5d9a384a9292d0$export$dc4c3408669b8f4e = (emitMetrics, metric)=>{
    const stopTime = performance.now();
    setTimeout(()=>{
        metric.mark((0, $37f655a4e4d5690e$export$99c08ec92759c71c));
        (0, $6iz4v.setMark)((0, $37f655a4e4d5690e$export$99c08ec92759c71c));
        setTimeout(()=>{
            emitMetrics(stopTime);
        }, 500);
    });
};

});
const $37f655a4e4d5690e$export$56940a9488e85199 = 'jira.fe.spa-';
const $37f655a4e4d5690e$export$45c4b6bf7935c69a = `${$37f655a4e4d5690e$export$56940a9488e85199}start`;
const $37f655a4e4d5690e$export$135c96ab5afee429 = 'ssr.spa.rendered';
const $37f655a4e4d5690e$export$ff834eccc35b9089 = 'appBundleReady';
const $37f655a4e4d5690e$export$86b05e34d462ead8 = 'prefetchApiReady';
const $37f655a4e4d5690e$export$d6a604a7d9a390fb = 'prefetchApiStart';
const $37f655a4e4d5690e$export$1211adfff27a31fe = 'issueViewInitialDataReady';
const $37f655a4e4d5690e$export$3ae43cc1782d058f = 'jswRenderStart';
const $37f655a4e4d5690e$export$363f6703ffa600be = 'jswCreateReduxStoreStart';
const $37f655a4e4d5690e$export$e87b74567b79c8 = 'jswCreateReduxStoreEnd';
const $37f655a4e4d5690e$export$99fe642459a8b02 = 'jswTransformCriticalDataStart';
const $37f655a4e4d5690e$export$ab1f5705fc8e0571 = 'jswTransformCriticalDataEnd';
const $37f655a4e4d5690e$export$8c3a9046da692c35 = 'jswReduxSoftwareAppLoadedStart';
const $37f655a4e4d5690e$export$5aa497d1efdcc5bf = 'jswReduxSoftwareAppLoadedEnd';
const $37f655a4e4d5690e$export$99c08ec92759c71c = 'tti-raf-mark';
const $37f655a4e4d5690e$export$48552baa9db8ce1d = 'tti-raf';


parcelRegister("iTvzN", function(module, exports) {

$parcel$export(module.exports, "startUimTti", () => $f4d69f5c84cf80c8$export$1422384676f6de7a);
$parcel$export(module.exports, "markUimTtiIssueViewLoaded", () => $f4d69f5c84cf80c8$export$5a9389b70d93def2);
$parcel$export(module.exports, "stopTTI", () => $f4d69f5c84cf80c8$export$30ca4c461fab486c);
$parcel$export(module.exports, "cancelTTI", () => $f4d69f5c84cf80c8$export$27f2445288b528c);
$parcel$export(module.exports, "markIframeLoad", () => $f4d69f5c84cf80c8$export$7a2709fc1e33401a);
$parcel$export(module.exports, "markFieldsRegistered", () => $f4d69f5c84cf80c8$export$cf3893335c93e33b);
$parcel$export(module.exports, "markOnInitResolved", () => $f4d69f5c84cf80c8$export$d86f4868694f2aa7);

var $lNfG4 = parcelRequire("lNfG4");

var $gGRYc = parcelRequire("gGRYc");
const $f4d69f5c84cf80c8$var$uimInIssueViewTTI = (0, $lNfG4.metrics).interaction({
    key: 'ui-modifications-in-issue-view',
    timings: [
        {
            key: 'issue-view-tti-delta',
            startMark: 'issue-view-tti'
        },
        {
            key: 'script-execution',
            startMark: 'iframe-load'
        },
        {
            key: 'loading-indicators-visibility',
            startMark: 'fields-registered'
        },
        {
            key: 'time-until-oninit-resolved',
            endMark: 'oninit-resolved'
        }
    ],
    featureFlags: (0, $gGRYc.TTIFFs)
});
const $f4d69f5c84cf80c8$export$1422384676f6de7a = ()=>{
    $f4d69f5c84cf80c8$var$uimInIssueViewTTI.start();
};
const $f4d69f5c84cf80c8$export$5a9389b70d93def2 = ()=>{
    $f4d69f5c84cf80c8$var$uimInIssueViewTTI.mark('issue-view-tti');
};
const $f4d69f5c84cf80c8$export$30ca4c461fab486c = (customData)=>{
    $f4d69f5c84cf80c8$var$uimInIssueViewTTI.stop({
        customData: customData
    });
};
const $f4d69f5c84cf80c8$export$27f2445288b528c = ()=>{
    $f4d69f5c84cf80c8$var$uimInIssueViewTTI.cancel();
};
const $f4d69f5c84cf80c8$export$7a2709fc1e33401a = ()=>{
    $f4d69f5c84cf80c8$var$uimInIssueViewTTI.mark('iframe-load');
};
const $f4d69f5c84cf80c8$export$cf3893335c93e33b = ()=>{
    $f4d69f5c84cf80c8$var$uimInIssueViewTTI.mark('fields-registered');
};
const $f4d69f5c84cf80c8$export$d86f4868694f2aa7 = ()=>{
    $f4d69f5c84cf80c8$var$uimInIssueViewTTI.mark('oninit-resolved');
};

});
parcelRegister("gGRYc", function(module, exports) {

$parcel$export(module.exports, "TTIFFs", () => $05ae9ccc47102fc0$export$c396ba1504d97f3f);
const $05ae9ccc47102fc0$export$c396ba1504d97f3f = [
    'uim-1689-gql-fetch-ui-adjustments_zbqgh'
];

});


parcelRegister("3iMaY", function(module, exports) {

$parcel$export(module.exports, "default", () => $ac8385c71ad69743$export$2e2bcd8739ae039);
$parcel$export(module.exports, "addUFOCustomData", () => $ac8385c71ad69743$export$d12f56a472cdbe6c);

var $eUqFw = parcelRequire("eUqFw");

var $3Hphq = parcelRequire("3Hphq");

var $51JrV = parcelRequire("51JrV");

var $fYqUr = parcelRequire("fYqUr");
function $ac8385c71ad69743$export$2e2bcd8739ae039({ data: data }) {
    const interactionContext = (0, $eUqFw.useContext)((0, $3Hphq.default));
    (0, $eUqFw.useMemo)(()=>{
        if (!interactionContext) return;
        interactionContext.addCustomData(data);
    }, [
        data,
        interactionContext
    ]);
    return null;
}
function $ac8385c71ad69743$export$d12f56a472cdbe6c(data) {
    const interactionId = (0, $51JrV.getInteractionId)();
    const currentInteractionId = interactionId.current;
    if (!currentInteractionId) return;
    (0, $fYqUr.addCustomData)(currentInteractionId, [], data);
}

});

parcelRegister("eJ3kO", function(module, exports) {

$parcel$export(module.exports, "getBm3Timings", () => $8841aa10a213faf4$export$f02972da195a43bb);
$parcel$export(module.exports, "UFOBM3TimingsToUFO", () => $8841aa10a213faf4$export$30f0b5e5acd268bf);
$parcel$export(module.exports, "addBM3TimingsToUFO", () => $8841aa10a213faf4$export$d93d677ef2f33c5c);

var $eUqFw = parcelRequire("eUqFw");

var $3Hphq = parcelRequire("3Hphq");

var $51JrV = parcelRequire("51JrV");

var $fYqUr = parcelRequire("fYqUr");
function $8841aa10a213faf4$export$f02972da195a43bb(marks, timingConfigs) {
    const bm3Timings = {};
    if (!marks || !timingConfigs) return bm3Timings;
    timingConfigs.forEach((item)=>{
        if (!item.startMark || !item.endMark) return;
        const startTime = marks[item.startMark];
        if (!startTime) return;
        const endTime = marks[item.endMark];
        if (!endTime) return;
        bm3Timings[item.key] = {
            startTime: startTime,
            endTime: endTime
        };
    });
    return bm3Timings;
}
function $8841aa10a213faf4$export$30f0b5e5acd268bf({ marks: marks, timings: timings }) {
    const interactionContext = (0, $eUqFw.useContext)((0, $3Hphq.default));
    const interactionId = (0, $51JrV.getInteractionId)().current;
    (0, $eUqFw.useMemo)(()=>{
        if (interactionContext != null && interactionId != null && marks != null && timings != null) {
            const interactionType = (0, $fYqUr.getCurrentInteractionType)(interactionId);
            if (interactionType === 'press') return;
            const bm3Timings = $8841aa10a213faf4$export$f02972da195a43bb(marks, timings);
            interactionContext.addCustomTimings(bm3Timings);
        }
    }, [
        interactionContext,
        interactionId,
        marks,
        timings
    ]);
    return null;
}
function $8841aa10a213faf4$export$d93d677ef2f33c5c(marks, timingsConfig) {
    const interactionId = (0, $51JrV.getInteractionId)().current;
    if (interactionId) {
        const interactionType = (0, $fYqUr.getCurrentInteractionType)(interactionId);
        if (interactionType === 'press') return;
        const bm3Timings = $8841aa10a213faf4$export$f02972da195a43bb(marks, timingsConfig);
        (0, $fYqUr.addCustomTiming)(interactionId, [], bm3Timings);
    }
}

});

parcelRegister("9OxOE", function(module, exports) {

$parcel$export(module.exports, "blockedOnBackendEntryLog", () => $93a7d723277e8ab3$export$dd1b3502b1e8ca97);
$parcel$export(module.exports, "getBackendBlockingTime", () => $93a7d723277e8ab3$export$8720c1f879c7ca46);

var $6iz4v = parcelRequire("6iz4v");


var $fxvfh = parcelRequire("fxvfh");

var $aLdVB = parcelRequire("aLdVB");
const $93a7d723277e8ab3$export$dd1b3502b1e8ca97 = (0, $fxvfh.createBlockedOnBackendEntryLog)();
function $93a7d723277e8ab3$var$measureBlockingEntry(measureName, backendBlockingStart, backendBlockingEnd) {
    (0, $6iz4v.setMark)(`${measureName}Start`, {
        startTime: backendBlockingStart
    });
    (0, $6iz4v.setMark)(`${measureName}End`, {
        startTime: backendBlockingEnd
    });
    (0, $6iz4v.setMeasure)(`${measureName}`, `${measureName}Start`, `${measureName}End`);
}
const $93a7d723277e8ab3$export$8720c1f879c7ca46 = (args)=>{
    const { blockingStart: blockingStartOrZero, totalBlockingDuration: totalBlockingDuration } = (0, $aLdVB.getSimplifiedBlockingTime)($93a7d723277e8ab3$export$dd1b3502b1e8ca97);
    const backendBlockingStart = Math.max(args.issueViewLoad.startTime, blockingStartOrZero);
    // Add the marks to the issueViewLoad BM3 event
    const backendBlockingEnd = backendBlockingStart + totalBlockingDuration;
    args.issueViewLoad.mark($848ef1328a091c81$export$e52cc35f872875f7, backendBlockingEnd);
    args.issueViewLoad.mark($848ef1328a091c81$export$e64e32643802b552, backendBlockingStart);
    $93a7d723277e8ab3$export$dd1b3502b1e8ca97.getBlockedOnBackendEntries().forEach(([blockingReason, { blockingStart: blockingStart, blockingEnd: blockingEnd }])=>$93a7d723277e8ab3$var$measureBlockingEntry(`issueView_blockedOnBackend_${blockingReason}`, blockingStart, blockingEnd));
    return {
        issueDataAvailable: backendBlockingEnd,
        issueReadyForData: backendBlockingStart
    };
};

});
parcelRegister("fxvfh", function(module, exports) {

$parcel$export(module.exports, "createBlockedOnBackendEntryLog", () => $929fa833717a1818$export$44ddca89673a78bc);
const $929fa833717a1818$export$44ddca89673a78bc = ()=>{
    const blockedOnBackendState = {
        timestamps: {}
    };
    // Internal use, use initialiseBlockedOnBackendStateForUpdatedKey externally
    const clearBlockedOnBackendState = ()=>{
        blockedOnBackendState.timestamps = {};
        blockedOnBackendState.currentKey = undefined;
    };
    // Internal use, use markStartBackendBlockingTimestamp or markEndBackendBlockingTimestamp
    const getOrCreateTimestampsEntryForKey = (blockingReasonKey)=>{
        let blockingDurationTimestamps = blockedOnBackendState.timestamps[blockingReasonKey];
        if (!blockingDurationTimestamps) {
            blockingDurationTimestamps = {};
            blockedOnBackendState.timestamps[blockingReasonKey] = blockingDurationTimestamps;
        }
        return blockingDurationTimestamps;
    };
    /**
	 * Initialise the store for a given key string.
	 * Only resets the state the first if the key string updates from its initial undefined OR if the key updates from the last time this was called
	 */ const initialiseBlockedOnBackendStateForUpdatedKey = (key)=>{
        if (key !== blockedOnBackendState.currentKey) {
            clearBlockedOnBackendState();
            blockedOnBackendState.currentKey = key;
        }
    };
    /**
	 * Fire this to mark the start of being blocked on backend for a given reason.
	 * @param blockingReasonKey An identifier for the reason for blocking. Until state is re-initialised, this reason cannot be used again to start a blocking span. Overlapping reasons will not be double counted
	 * @param timestamp optional, defaults to current time
	 */ const markStartBackendBlockingTimestamp = (blockingReasonKey, timestamp = performance.now())=>{
        const blockingDurationTimestamps = getOrCreateTimestampsEntryForKey(blockingReasonKey);
        if (!blockingDurationTimestamps.blockingStart) blockingDurationTimestamps.blockingStart = timestamp;
    };
    /**
	 * Fire this to mark the end of being blocked on backend for a given reason
	 * @param blockingReasonKey
	 * @param timestamp optional, defaults to current time
	 */ const markEndBackendBlockingTimestamp = (blockingReasonKey, timestamp = performance.now())=>{
        const blockingDurationTimestamps = getOrCreateTimestampsEntryForKey(blockingReasonKey);
        if (!blockingDurationTimestamps.blockingEnd) blockingDurationTimestamps.blockingEnd = timestamp;
    };
    /**
	 * Return a list of the entries gathered so far
	 * @param sorted whether the returned results should be sorted based on their start time. true by default
	 */ const getBlockedOnBackendEntries = ({ sorted: sorted = true } = {})=>{
        let entries = Object.entries(blockedOnBackendState.timestamps).filter((entry)=>{
            const [, blockingTimestamps] = entry;
            return blockingTimestamps.blockingStart != null && blockingTimestamps.blockingEnd != null && blockingTimestamps.blockingStart <= blockingTimestamps.blockingEnd;
        });
        if (sorted) // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
        entries = entries.sort(([, { blockingStart: start1 }], [, { blockingStart: start2 }])=>start1 - start2);
        return entries;
    };
    return {
        initialiseBlockedOnBackendStateForUpdatedKey: initialiseBlockedOnBackendStateForUpdatedKey,
        markStartBackendBlockingTimestamp: markStartBackendBlockingTimestamp,
        markEndBackendBlockingTimestamp: markEndBackendBlockingTimestamp,
        getBlockedOnBackendEntries: getBlockedOnBackendEntries
    };
};

});

parcelRegister("aLdVB", function(module, exports) {

$parcel$export(module.exports, "getSimplifiedBlockingTime", () => $da7b43236f8323c7$export$580550d1d1ffca6c);

var $iHCl1 = parcelRequire("iHCl1");
const $da7b43236f8323c7$export$580550d1d1ffca6c = (entryLog)=>{
    const blockingTimestampEntries = entryLog.getBlockedOnBackendEntries({
        sorted: true
    });
    const blockingSpans = (0, $iHCl1.mergeOverlappingBlockingEntries)(blockingTimestampEntries);
    const blockingStartTimes = blockingSpans.map(({ blockingStart: blockingStart })=>blockingStart ?? 0);
    const blockingDurations = blockingSpans.map(({ blockingEnd: blockingEnd, blockingStart: blockingStart })=>blockingEnd - blockingStart);
    const blockingStart = Math.min(...blockingStartTimes.length ? blockingStartTimes : [
        0
    ]);
    const totalBlockingDuration = blockingDurations.reduce((a, b)=>a + b, 0);
    return {
        blockingStart: blockingStart,
        totalBlockingDuration: totalBlockingDuration
    };
};

});
parcelRegister("iHCl1", function(module, exports) {

$parcel$export(module.exports, "mergeOverlappingBlockingEntries", () => $1e46ae3ace8b54ee$export$e63ec487944afc72);
function $1e46ae3ace8b54ee$export$e63ec487944afc72(blockingTimestampEntriesSortedByStartTime) {
    return blockingTimestampEntriesSortedByStartTime.reduce((nonOverlappingSpans, [, { blockingStart: blockingStart, blockingEnd: blockingEnd }])=>{
        const lastSpan = nonOverlappingSpans[nonOverlappingSpans.length - 1];
        if (!lastSpan || blockingStart > lastSpan.blockingEnd) nonOverlappingSpans.push({
            blockingStart: blockingStart,
            blockingEnd: blockingEnd
        }); // add the span as-is to the known non-overlapping spans
        else if (lastSpan.blockingEnd < blockingEnd) lastSpan.blockingEnd = blockingEnd;
        return nonOverlappingSpans;
    }, // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
    []);
}

});



parcelRegister("7iu2Y", function(module, exports) {

$parcel$export(module.exports, "issueScaleabilityReporterFactory", () => $c5094ff7f20cdaa9$export$9f6c068bd6582299);

var $1ybV0 = parcelRequire("1ybV0");


var $6azHZ = parcelRequire("6azHZ");

var $f9RL0 = parcelRequire("f9RL0");

var $kSuBQ = parcelRequire("kSuBQ");

var $4sNXH = parcelRequire("4sNXH");

var $5JqpU = parcelRequire("5JqpU");

var $fokFV = parcelRequire("fokFV");

var $jZDJX = parcelRequire("jZDJX");

var $8CSFK = parcelRequire("8CSFK");

var $8QKSg = parcelRequire("8QKSg");

var $1b2Vj = parcelRequire("1b2Vj");

var $cj1Xt = parcelRequire("cj1Xt");

var $9D3Vo = parcelRequire("9D3Vo");

var $dmojD = parcelRequire("dmojD");

var $cFY86 = parcelRequire("cFY86");

var $ke6cX = parcelRequire("ke6cX");

var $6Fp9G = parcelRequire("6Fp9G");

var $dv9do = parcelRequire("dv9do");

var $lO4Or = parcelRequire("lO4Or");

var $9s86T = parcelRequire("9s86T");

var $6VKiL = parcelRequire("6VKiL");
const $c5094ff7f20cdaa9$var$getCascadingSelectFields = (state)=>Object.values((0, $fokFV.fieldsSelector)(state)).filter((fieldValues)=>fieldValues.schema.custom === (0, $lO4Or.CASCADING_SELECT_CF_TYPE));
const $c5094ff7f20cdaa9$var$getAtlassianTeamFields = (state)=>Object.values((0, $fokFV.fieldsSelector)(state)).filter((fieldValues)=>fieldValues.schema.custom === (0, $lO4Or.TEAMS_PLATFORM_CF_TYPE));
// eslint-disable-next-line @typescript-eslint/no-explicit-any
const $c5094ff7f20cdaa9$var$getCascadingSelectOptionChildrenCount = (cascadingSelectFieldValue)=>{
    if (cascadingSelectFieldValue.length === 0) return 0;
    return Object.values(cascadingSelectFieldValue).reduce((accumulatedCount, parentValue)=>accumulatedCount + (parentValue?.children?.length || 1), 0);
};
const $c5094ff7f20cdaa9$var$getCascadingSelectOptionsTotalCount = (state)=>{
    const cascadingSelectFields = $c5094ff7f20cdaa9$var$getCascadingSelectFields(state);
    if (cascadingSelectFields.length === 0) return 0;
    return cascadingSelectFields.reduce((accumulatedCount, cascadingSelectField)=>accumulatedCount + ($c5094ff7f20cdaa9$var$getCascadingSelectOptionChildrenCount(cascadingSelectField.allowedValues) || 1), 0);
};
const $c5094ff7f20cdaa9$export$ae327590f8230d00 = ({ projectKey: projectKey, ecosystem: ecosystem, forge: forge })=>{
    let open = 0;
    let closed = 0;
    if (projectKey !== undefined) {
        // The context groups store the state of open / closed inside local storage, so we need to get access to that
        // here. It's not held in redux which is why we look it up this way.
        const groupLocalStorageName = (0, $kSuBQ.getGroupLocalStorageName)(projectKey, 'context-group');
        try {
            // It's possible panels are uninstalled and not removed from localstorage, so we need to check they are installed
            // otherwise the analytics may be incorrectly advising how many panels are open
            const installedPanels = [
                ...ecosystem.map((item)=>`${groupLocalStorageName}-${(0, $4sNXH.generateContextPanelId)(item)}`),
                ...forge.map((item)=>`${groupLocalStorageName}-${item.id}`)
            ];
            open = Object.values((0, $kSuBQ.getGroupsLocalStorage)(installedPanels, (0, $ab2aafcdf11a1361$export$e1184c3be46bd7cb))).filter(Boolean).length;
            // Panels may not exist in localStorage but may be installed, in which case they are closed as this is the default state
            closed = installedPanels.length - open;
        } catch  {
        // No action required
        }
    }
    return {
        open: open,
        closed: closed
    };
};
const $c5094ff7f20cdaa9$export$9f6c068bd6582299 = (store, issueContextActions)=>()=>{
        const state = store.getState();
        const { permalinkType: permalinkType } = (0, $9s86T.getPermalinkTypeAndId)() || {};
        const childIssues = (0, $fokFV.fieldSelector)((0, $lO4Or.CHILDREN_ISSUES))(state);
        const proformaHarmonisation = (0, $fokFV.fieldSelector)((0, $lO4Or.PROFORMA_FORMS))(state);
        const { open: contextPanelOpenCount, closed: contextPanelClosedCount } = $c5094ff7f20cdaa9$export$ae327590f8230d00({
            projectKey: state?.entities?.project?.projectKey,
            ecosystem: (0, $8CSFK.contextPanelEntitiesSelector)(state),
            forge: (0, $8QKSg.forgeContextPanelsSelector)(state)
        });
        const subtaskCount = (0, $fokFV.childIssuesLimitUrlSelector)(state)((0, $f9RL0.SUBTASKS)) && issueContextActions ? (0, $6azHZ.getChildIssuesLimitExceededAnalyticsCount)(issueContextActions.getChildIssuesLimit()) : (0, $dv9do.subtaskEntitiesSelector)(state).length;
        const childIssuesCount = (0, $fokFV.childIssuesLimitUrlSelector)(state)((0, $lO4Or.CHILDREN_ISSUES)) && issueContextActions ? (0, $6azHZ.getChildIssuesLimitExceededAnalyticsCount)(issueContextActions.getChildIssuesLimit()) : childIssues?.value.length ?? 0;
        // If a portfolio issue is over the limit we cannot tell because
        // only the subtasks panel is displayed. Once the portfolio issue
        // type hierarchy level is a value > 1 then we can set this to ">100".
        let portfolioChildIssueCount;
        let actualSubtaskCount;
        let actualChildIssueCount;
        let actualEpicIssueCount;
        let epicIssueCount;
        const subtasks = (0, $fokFV.fieldSelector)((0, $f9RL0.SUBTASKS))(state);
        const epicIssues = (0, $fokFV.fieldSelector)((0, $f9RL0.EPIC_ISSUES))(state);
        const portfolioChildIssues = (0, $fokFV.fieldSelector)((0, $f9RL0.PORTFOLIO_CHILD_ISSUES))(state);
        const getChildIssuesLimitUrl = (0, $fokFV.childIssuesLimitUrlSelector)(state);
        const isEpicIssuesOverLimit = Boolean(getChildIssuesLimitUrl((0, $f9RL0.EPIC_ISSUES)));
        const isOverLimit = Boolean(getChildIssuesLimitUrl((0, $f9RL0.SUBTASKS))) || Boolean(getChildIssuesLimitUrl((0, $lO4Or.CHILDREN_ISSUES))) || isEpicIssuesOverLimit;
        if (isOverLimit) {
            actualChildIssueCount = childIssues?.originalContentLength ?? 0;
            actualEpicIssueCount = epicIssues?.originalContentLength ?? 0;
            // If epic issue is over the limit, we exclude the subtasks field
            // from the store. So we need to grab the data from the epicIssues field.
            actualSubtaskCount = isEpicIssuesOverLimit ? epicIssues?.otherOriginalChildIssuesLength ?? 0 : subtasks?.originalContentLength ?? 0;
            epicIssueCount = isEpicIssuesOverLimit && issueContextActions ? (0, $6azHZ.getChildIssuesLimitExceededAnalyticsCount)(issueContextActions.getChildIssuesLimit()) : epicIssues?.originalContentLength ?? 0;
            // If portfolio issue is over the limit, we exclude the portfolio-child-issues field
            // from the store. So we need to grab the data from the subtasks field.
            portfolioChildIssueCount = subtasks?.otherOriginalChildIssuesLength ?? 0;
        } else {
            actualChildIssueCount = childIssues?.value.length ?? 0;
            actualSubtaskCount = subtasks?.value.length ?? 0;
            actualEpicIssueCount = epicIssues?.value.length ?? 0;
            portfolioChildIssueCount = portfolioChildIssues?.value.length ?? 0;
            epicIssueCount = actualEpicIssueCount;
        }
        // Properties added here show up in:
        // - jira.fe.custom.issue-view-on-page-load
        // - jira.fe.page-load.issue-view
        // - and jira.fe.custom.embedded-issue-view-load
        // Verify these in the BM3 tab of the Chrome Analytics extension.
        return {
            ecosystemGlances: (0, $8CSFK.glancesSelector)(state).length,
            ecosystemContentPanels: (0, $8CSFK.allContentPanelsSelector)(state).length,
            contextPanelOpenCount: contextPanelOpenCount,
            contextPanelClosedCount: contextPanelClosedCount,
            ecosystemActivityPanels: (0, $8CSFK.activityPanelsSelector)(state).length,
            ...!(0, $1ybV0.ff)('issue-view-remove-connect-operations-from-critical-fetch_vtk4w') ? {
                ecosystemOperations: (0, $8CSFK.operationsSelector)(state).length
            } : {},
            ecosystemCustomsFields: (0, $cj1Xt.ecosystemCustomFieldIdsSelector)(state).length,
            childIssues: childIssuesCount,
            linkIssueCount: (0, $cFY86.combinedLinkedIssueCountSelector)(state),
            subtaskCount: subtaskCount,
            actualChildIssueCount: actualChildIssueCount,
            actualSubtaskCount: actualSubtaskCount,
            actualEpicIssueCount: actualEpicIssueCount,
            actualPortfolioChildIssueCount: portfolioChildIssueCount,
            epicIssueCount: epicIssueCount,
            portfolioChildIssueCount: portfolioChildIssueCount,
            issueId: (0, $5JqpU.issueIdSelector)(state),
            commentsTotalCount: (0, $dmojD.totalCommentsSelector)(state),
            hasCommentPermalink: permalinkType === (0, $6VKiL.COMMENTS),
            cascadingSelectCount: $c5094ff7f20cdaa9$var$getCascadingSelectFields(state).length,
            isAtlassianTeamFieldEnabled: $c5094ff7f20cdaa9$var$getAtlassianTeamFields(state).length > 0,
            cascadingSelectOptionsTotalCount: $c5094ff7f20cdaa9$var$getCascadingSelectOptionsTotalCount(state),
            proformaHarmonisationEnabled: proformaHarmonisation ? proformaHarmonisation.value.isHarmonisationEnabled : false,
            hasSubtasksTypes: (0, $6Fp9G.isSubtaskTypesPresentSelector)(state),
            issueTypesCount: (0, $ke6cX.issueTypesSelector)(state).length,
            issueTypeHierarchyLevel: !(0, $jZDJX.isSimplifiedProjectSelector)(state) ? (0, $9D3Vo.issueTypeHierarchyLevelSelector)(state) : (0, $1b2Vj.hierarchyLevelSelector)(state)
        };
    };

});
const $ab2aafcdf11a1361$export$dcd281f501ceae1a = 'issue-view-layout-templates-views.ui.context.visible-hidden.ui.pinned-fields';
const $ab2aafcdf11a1361$export$e1184c3be46bd7cb = false;
const $ab2aafcdf11a1361$export$2028cf1423b28cf8 = 'global-spotlight-target-';
const $ab2aafcdf11a1361$export$988f0f6f6457039a = 'status-and-approval-spotlight';

parcelRegister("6azHZ", function(module, exports) {

$parcel$export(module.exports, "getChildIssuesLimitExceededAnalyticsCount", () => $fdeece38e8748ab6$export$8cbe27041ec414b7);

var $8Y8Vi = parcelRequire("8Y8Vi");
const $fdeece38e8748ab6$export$1e3c128c36bad9a4 = 'CHILD_ISSUES_LIMIT_EXCEEDED';
const $fdeece38e8748ab6$export$8cbe27041ec414b7 = (childIssuesLimit)=>`>${childIssuesLimit}`;

});
parcelRegister("8Y8Vi", function(module, exports) {

$parcel$export(module.exports, "associatedIssueErrorTypes", () => $91892c2c67b32e99$export$e1cf8628ef0f1215);
const $91892c2c67b32e99$export$e1cf8628ef0f1215 = {
    createChild: 'createChild',
    linkChild: 'linkChild'
};

});


parcelRegister("kSuBQ", function(module, exports) {

$parcel$export(module.exports, "getGroupLocalStorageName", () => $d054c54ec3a75126$export$a3b190a19b138f2e);
$parcel$export(module.exports, "isGroupPanelOpen", () => $d054c54ec3a75126$export$e79995f22545fd3e);
$parcel$export(module.exports, "getGroupsLocalStorage", () => $d054c54ec3a75126$export$d0a5ccc42f3bcd33);
$parcel$export(module.exports, "useGroupLocalStorage", () => $d054c54ec3a75126$export$4e1a840a45fb467c);

var $eUqFw = parcelRequire("eUqFw");
const $d054c54ec3a75126$export$a3b190a19b138f2e = (projectKey, id)=>`group.state.${projectKey}.${id}`;
const $d054c54ec3a75126$export$a7e7b7df48874d2c = (keyName, defaultValue)=>{
    try {
        const item = window.localStorage.getItem(keyName);
        if (item === 'true') return true;
        if (item === 'false') return false;
        throw Error('Invalid group state value');
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    } catch (_) {
        return defaultValue;
    }
};
const $d054c54ec3a75126$export$e79995f22545fd3e = (projectKey, group, panelId, defaultValue)=>{
    const groupLocalStorageName = $d054c54ec3a75126$export$a3b190a19b138f2e(projectKey, group);
    return $d054c54ec3a75126$export$a7e7b7df48874d2c(`${groupLocalStorageName}-${panelId}`, defaultValue);
};
const $d054c54ec3a75126$export$d0a5ccc42f3bcd33 = (keyNames, initialOpened)=>{
    const items = {};
    keyNames.forEach((key)=>{
        items[key] = $d054c54ec3a75126$export$a7e7b7df48874d2c(key, initialOpened);
    });
    return items;
};
const $d054c54ec3a75126$export$4e1a840a45fb467c = (projectKey, id, initialOpened)=>{
    const keyName = $d054c54ec3a75126$export$a3b190a19b138f2e(projectKey, id);
    const [storedValue, setStoredValue] = (0, $eUqFw.useState)(()=>$d054c54ec3a75126$export$a7e7b7df48874d2c(keyName, initialOpened));
    const setValue = (0, $eUqFw.useCallback)((value)=>{
        try {
            setStoredValue(value);
            window.localStorage.setItem(keyName, String(value));
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        } catch (_) {
        // Not decided what we do when we reach here.
        }
    }, [
        keyName
    ]);
    return [
        storedValue,
        setValue
    ];
};

});

parcelRegister("4sNXH", function(module, exports) {

$parcel$export(module.exports, "shouldHideNullUneditableField", () => $677ed9cfdaabf5a5$export$e7987ba89f8e2996);
$parcel$export(module.exports, "ecosystemGlancesToLayoutItem", () => $677ed9cfdaabf5a5$export$8dd9174e11169a13);
$parcel$export(module.exports, "ecosystemContextsToLayoutItem", () => $677ed9cfdaabf5a5$export$ff0381f8ed1f6cc7);
$parcel$export(module.exports, "useForgeGlancesAsLayoutItems", () => $677ed9cfdaabf5a5$export$969c8278a214a2d9);
$parcel$export(module.exports, "useForgeContextPanelsAsLayoutItems", () => $677ed9cfdaabf5a5$export$b4095ac407369aa0);
$parcel$export(module.exports, "addChangeboardingRefToFirstItem", () => $677ed9cfdaabf5a5$export$b7aff69af7ee8f70);
$parcel$export(module.exports, "getPinnedFieldItems", () => $677ed9cfdaabf5a5$export$7fc9f8048722ede9);
$parcel$export(module.exports, "generateContextPanelId", () => $677ed9cfdaabf5a5$export$c55ff2c236d30544);

var $8i1R8 = parcelRequire("8i1R8");

var $fTsDx = parcelRequire("fTsDx");

var $hJ992 = parcelRequire("hJ992");

var $kmr29 = parcelRequire("kmr29");

var $bLiXo = parcelRequire("bLiXo");

var $fkvsU = parcelRequire("fkvsU");


var $4faf8 = parcelRequire("4faf8");

var $f9RL0 = parcelRequire("f9RL0");

var $2Sajo = parcelRequire("2Sajo");


var $g8to1 = parcelRequire("g8to1");

var $lO4Or = parcelRequire("lO4Or");

var $guDlK = parcelRequire("guDlK");

var $5YYzL = parcelRequire("5YYzL");
const $677ed9cfdaabf5a5$export$87af144309c7a3c5 = (canLogTime, isNativeJiraTimeTrackingEnabled)=>// Here we assume that if the time tracking field is an available field
    // but isNativeJiraTimeTrackingEnabled is false, a 3rd party time tracking app is installed.
    isNativeJiraTimeTrackingEnabled ? !canLogTime : false;
const $677ed9cfdaabf5a5$var$getFieldByCustomType = (customType, fieldsConfiguration)=>(0, (/*@__PURE__*/$parcel$interopDefault($8i1R8)))(fieldsConfiguration, (field)=>(field.schema && field.schema.custom) === customType);
const $677ed9cfdaabf5a5$var$getFieldConfiguration = (fieldId, fields)=>{
    const field = fields[fieldId];
    const customSystemFields = (0, $f9RL0.specialFields)();
    const condition = !field && Object.prototype.hasOwnProperty.call(customSystemFields, fieldId);
    if (condition) {
        // @ts-expect-error - TS7053 - Element implicitly has an 'any' type because expression of type 'string' can't be used to index type 'SpecialFieldTypes'.
        const customType = customSystemFields[fieldId];
        return $677ed9cfdaabf5a5$var$getFieldByCustomType(customType, fields);
    }
    return field;
};
const $677ed9cfdaabf5a5$export$e7987ba89f8e2996 = (itemId, issueFieldsConfig, value, canLogTime, isNativeJiraTimeTrackingEnabled)=>{
    const fieldConfig = $677ed9cfdaabf5a5$var$getFieldConfiguration(itemId, issueFieldsConfig);
    const fieldType = (0, $g8to1.getFieldType)(fieldConfig);
    if ((0, $g8to1.getPanels)().includes(itemId)) return false;
    if (!fieldConfig || fieldType === undefined) return true;
    if ((0, $g8to1.isEmpty)(value) && !fieldConfig.isEditable) {
        if (itemId === (0, $lO4Or.ASSIGNEE_TYPE) || fieldType === (0, $lO4Or.REQUEST_TYPE_CF_TYPE) || fieldType === (0, $lO4Or.REQUEST_LANGUAGE_CF_TYPE)) return false;
        // ARKEN-40: Forge custom fields with readonly and an empty value must still be shown as primary or secondary items
        if ((0, $4faf8.isForgeField)(fieldConfig)) return false;
        if (itemId === (0, $lO4Or.TIME_TRACKING_TYPE)) return $677ed9cfdaabf5a5$export$87af144309c7a3c5(canLogTime, isNativeJiraTimeTrackingEnabled);
        return true;
    }
    return false;
};
const $677ed9cfdaabf5a5$export$8dd9174e11169a13 = (ecosystemGlances)=>{
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    const result = Object.keys(ecosystemGlances).reduce((acc, next)=>{
        const ecosystem = ecosystemGlances[next];
        const modules = Object.keys(ecosystem).map((moduleKey)=>ecosystem[moduleKey]);
        // eslint-disable-next-line jira/js/no-reduce-accumulator-spread
        return [
            ...acc,
            ...modules
        ];
    }, []);
    return result.map((connectGlance)=>({
            id: `${0, $lO4Or.ECOSYSTEM_GLANCE_TYPE}__${connectGlance.appKey}__${connectGlance.moduleKey}`,
            type: (0, $lO4Or.ECOSYSTEM_GLANCE_TYPE),
            payload: {
                ...connectGlance,
                glanceType: (0, $fkvsU.CONNECT_ENTITY_TYPE)
            }
        }));
};
const $677ed9cfdaabf5a5$export$ff0381f8ed1f6cc7 = (ecosystemContextPanels)=>{
    const contextPanels = [];
    Object.values(ecosystemContextPanels).forEach((contextPanelObject)=>{
        contextPanels.push(Object.values(contextPanelObject)[0]);
    });
    return contextPanels.map((connectContextPanel)=>({
            id: `${0, $lO4Or.ECOSYSTEM_CONTEXT_TYPE}__${connectContextPanel.appKey}__${connectContextPanel.moduleKey}`,
            type: (0, $lO4Or.ECOSYSTEM_CONTEXT_TYPE),
            payload: {
                ...connectContextPanel,
                contextPanelType: (0, $fkvsU.CONNECT_ENTITY_TYPE)
            }
        }));
};
const $677ed9cfdaabf5a5$var$ISSUE_TYPE = 'issuetype';
const $677ed9cfdaabf5a5$export$ea6c3ae2bd3a5510 = ()=>{
    const issueKey = (0, $hJ992.useIssueKey)();
    const issueId = (0, $hJ992.useIssueId)();
    const projectKey = (0, $guDlK.useProjectKey)(issueKey);
    const [permissions] = (0, $5YYzL.useProjectPermissions)(projectKey);
    const projectType = (0, $guDlK.useProjectType)(projectKey);
    const projectId = (0, $guDlK.useProjectId)(projectKey);
    const [issueType] = (0, $kmr29.useFieldValue)({
        issueKey: issueKey,
        fieldKey: $677ed9cfdaabf5a5$var$ISSUE_TYPE
    });
    return {
        issueId: issueId || null,
        issueKey: issueKey,
        issueType: issueType && issueType.name,
        projectId: projectId,
        projectKey: projectKey,
        projectType: projectType || null,
        // Prop normalisation copied from original redux selector - Props names are exposed externally.
        canAddComments: permissions.canAddComments,
        canAdministerJira: permissions.canAdministerJira,
        canAdministerProjects: permissions.canAdministerProject,
        canAssignIssues: permissions.canAssignIssues,
        canBeAssignedToIssues: permissions.canBeAssignedToIssues,
        canCloneIssues: permissions.canCloneIssue,
        canCreateAttachments: permissions.canCreateAttachments,
        canCreateChildren: permissions.canCreateChildren,
        canCreateSubtasks: permissions.canCreateSubtask,
        canDeleteAllAttachments: permissions.canDeleteAllAttachments,
        canDeleteAllComments: permissions.canDeleteAllComments,
        canDeleteAllWorklogs: permissions.canDeleteAllWorklogs,
        canDeleteIssues: permissions.canDeleteIssue,
        canDeleteOwnAttachments: permissions.canDeleteOwnAttachments,
        canDeleteOwnComments: permissions.canDeleteOwnComments,
        canDeleteOwnWorklogs: permissions.canDeleteOwnWorklogs,
        canEditAllComments: permissions.canEditAllComments,
        canEditAllWorklogs: permissions.canEditAllWorklogs,
        canEditIssues: permissions.canEditIssues,
        canEditOwnComments: permissions.canEditOwnComments,
        canEditOwnWorklogs: permissions.canEditOwnWorklogs,
        canLinkIssues: permissions.canLinkIssues,
        canLogWork: permissions.canLogWork,
        canManageWatchers: permissions.canManageWatchers,
        canModifyReporters: permissions.canModifyReporter,
        canMoveIssues: permissions.canMoveIssue,
        canScheduleIssues: permissions.canScheduleIssues,
        canUseServiceManagementAgentFeatures: permissions.canUseServiceDeskAgentFeatures,
        canBrowseUsers: permissions.canBrowseUsers,
        canViewDevTools: permissions.canViewDevTools,
        canViewWatchers: permissions.canViewWatchers
    };
};
const $677ed9cfdaabf5a5$export$969c8278a214a2d9 = ()=>{
    const [forgeGlances] = (0, $2Sajo.useForgeGlances)();
    const staticContext = $677ed9cfdaabf5a5$export$ea6c3ae2bd3a5510();
    return forgeGlances.filter((extension)=>(0, $fTsDx.doesExtensionMeetConditions)(extension, staticContext)).map((forgeGlance)=>{
        const { id: id, properties: { title: title, label: label, status: status, icon: icon } } = forgeGlance;
        return {
            id: id,
            type: (0, $lO4Or.FORGE_GLANCE_TYPE),
            payload: {
                label: label,
                title: title,
                status: status,
                icon: icon,
                extension: forgeGlance,
                glanceType: (0, $fe92e572161b5748$export$6f3804b3f188f650),
                moduleKey: id,
                appKey: id
            }
        };
    });
};
const $677ed9cfdaabf5a5$export$b4095ac407369aa0 = ()=>{
    const issueKey = (0, $hJ992.useIssueKey)();
    const projectKey = (0, $guDlK.useProjectKey)(issueKey);
    const { ecosystemEnabled: ecosystemEnabled } = (0, $guDlK.useProjectConfiguration)(projectKey);
    const [forgeContextPanels] = (0, $2Sajo.useForgeContextPanels)();
    const staticContext = $677ed9cfdaabf5a5$export$ea6c3ae2bd3a5510();
    if (!ecosystemEnabled) return [];
    return forgeContextPanels.filter((extension)=>(0, $fTsDx.doesExtensionMeetConditions)(extension, staticContext)).map((contextPanels)=>{
        const { id: id, properties: { title: title, label: label, status: status, icon: url } } = contextPanels;
        return {
            id: id,
            type: (0, $bLiXo.FORGE_CONTEXT_TYPE),
            payload: {
                type: (0, $bLiXo.FORGE_CONTEXT_TYPE),
                label: label,
                name: title,
                status: status || null,
                icon: url ? {
                    url: url
                } : null,
                extension: contextPanels,
                contextPanelType: (0, $fe92e572161b5748$export$6f3804b3f188f650),
                moduleKey: id,
                appKey: id,
                options: null
            }
        };
    });
};
const $677ed9cfdaabf5a5$export$b7aff69af7ee8f70 = (items)=>{
    let wrapperAdded = false;
    const allowedTypes = [
        (0, $bLiXo.layoutContainerItemTypes).field,
        (0, $bLiXo.layoutContainerItemTypes).panel
    ];
    const disallowedIds = [
        (0, $lO4Or.ASSIGNEE_TYPE),
        (0, $lO4Or.SLA_PANEL_TYPE)
    ];
    return items.map((item)=>{
        const typename = item.type !== undefined ? item.type : '';
        // @ts-expect-error - TS2345 - Argument of type 'any' is not assignable to parameter of type 'never'.
        if (!wrapperAdded && !disallowedIds.includes(item.id) && allowedTypes.includes(typename)) {
            wrapperAdded = true;
            // if it was added to csat field and csat field to be removed later in servicedesk template, this effectively won't work
            return {
                ...item,
                globalRef: (0, $ab3fc2ac1a2f2638$export$95ff4d03075475e2)
            };
        }
        return item;
    });
};
const $677ed9cfdaabf5a5$export$7fc9f8048722ede9 = (dedupedItems, pinnedFields)=>pinnedFields.reduce((result, pinnedId)=>{
        const item = dedupedItems.find((dedupedItem)=>dedupedItem.type === (0, $bLiXo.layoutContainerItemTypes).field && dedupedItem.fieldItemId === pinnedId || dedupedItem.type === (0, $bLiXo.layoutContainerItemTypes).panel && dedupedItem.panelItemId === pinnedId);
        if (item !== undefined) result.push(item);
        return result;
    // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
    }, []);
const $677ed9cfdaabf5a5$export$c55ff2c236d30544 = ({ appKey: appKey, moduleKey: moduleKey })=>`${0, $lO4Or.ECOSYSTEM_CONTEXT_TYPE}__${appKey}__${moduleKey}`;

});
parcelRegister("fTsDx", function(module, exports) {

$parcel$export(module.exports, "useDoesExtensionMeetConditions", () => $f49523f1e6c1d89f$export$642911220fb6609f);
$parcel$export(module.exports, "doesExtensionMeetConditions", () => $f49523f1e6c1d89f$export$b1e4ed7044e85aa3);

var $eUqFw = parcelRequire("eUqFw");

var $iPaeE = parcelRequire("iPaeE");

var $e91YZ = parcelRequire("e91YZ");

var $fz8wa = parcelRequire("fz8wa");
var $gd0Sp = parcelRequire("gd0Sp");
const $f49523f1e6c1d89f$export$642911220fb6609f = ()=>{
    const { isAdmin: isAdmin, isAnonymous: isAnonymous, isSiteAdmin: isSiteAdmin } = (0, $gd0Sp.useTenantContext)();
    const { hasCoreAccess: hasCoreAccess, hasSoftwareAccess: hasSoftwareAccess, hasServiceDeskAccess: hasServiceManagementAccess } = (0, $fz8wa.useApplicationPermissions)();
    return (0, $eUqFw.useCallback)((extension, extraContext)=>{
        const { displayConditions: displayConditions } = extension.properties;
        if (displayConditions == null) return true;
        const context = {
            ...extraContext,
            isAdmin: // User info
            isAdmin,
            isLoggedIn: !isAnonymous,
            isSiteAdmin: isSiteAdmin,
            hasCoreAccess: // App permissions
            hasCoreAccess,
            hasServiceManagementAccess: hasServiceManagementAccess,
            hasSoftwareAccess: hasSoftwareAccess
        };
        return (0, $iPaeE.doesMeetConditions)(displayConditions, context);
    }, [
        hasCoreAccess,
        hasServiceManagementAccess,
        hasSoftwareAccess,
        isAdmin,
        isAnonymous,
        isSiteAdmin
    ]);
};
const $f49523f1e6c1d89f$export$b1e4ed7044e85aa3 = (extension, extraContext)=>{
    const { displayConditions: displayConditions } = extension.properties;
    const { appPermissions: { hasSoftwareAccess: hasSoftwareAccess, hasServiceDeskAccess: hasServiceDeskAccess, hasCoreAccess: hasCoreAccess }, isAdmin: isAdmin, isAnonymous: isAnonymous, isSiteAdmin: isSiteAdmin } = (0, $e91YZ.getTenantContext_DEPRECATED_DO_NOT_USE)();
    const context = {
        // Whatever extension needs
        ...extraContext,
        isAdmin: // User info
        isAdmin,
        isLoggedIn: !isAnonymous,
        isSiteAdmin: isSiteAdmin,
        hasSoftwareAccess: // App permissions
        hasSoftwareAccess,
        hasServiceManagementAccess: hasServiceDeskAccess,
        hasCoreAccess: hasCoreAccess
    };
    return displayConditions ? (0, $iPaeE.doesMeetConditions)(displayConditions, context) : true;
};

});

parcelRegister("hJ992", function(module, exports) {

$parcel$export(module.exports, "useChildIssuesLimit", () => $7e3614f655e5103c$export$8d75f312eaa63aec);
$parcel$export(module.exports, "useChildIssuesIssueLimitUrl", () => $7e3614f655e5103c$export$65a59acd1ffc5bba);
$parcel$export(module.exports, "useIsModal", () => $7e3614f655e5103c$export$9ce8428ff198804a);
$parcel$export(module.exports, "useIssueKey", () => $7e3614f655e5103c$export$22108eca27445997);
$parcel$export(module.exports, "useIssueId", () => $7e3614f655e5103c$export$9df8176b5ffce5ab);
$parcel$export(module.exports, "useIsArchived", () => $7e3614f655e5103c$export$7cd1821433aafaee);
$parcel$export(module.exports, "useIsClassifyEditEnabled", () => $7e3614f655e5103c$export$b23b36ed5c42e920);
$parcel$export(module.exports, "useProjectKey", () => $7e3614f655e5103c$export$f87be37f8e8be65);
$parcel$export(module.exports, "useAnalyticsSource", () => $7e3614f655e5103c$export$aad3917152559b87);
$parcel$export(module.exports, "useIssueContextActions", () => $7e3614f655e5103c$export$d6ec1293313f49ac);
$parcel$export(module.exports, "useRapidViewMap", () => $7e3614f655e5103c$export$4d204e800e4e0be7);
$parcel$export(module.exports, "useEstimationStatistic", () => $7e3614f655e5103c$export$5b20e30ee6db56e9);
$parcel$export(module.exports, "useViewMode", () => $7e3614f655e5103c$export$3a7c3e259b6adb93);
$parcel$export(module.exports, "useBackButtonUrl", () => $7e3614f655e5103c$export$cfe64a334903927c);
$parcel$export(module.exports, "useIssueNavigatorData", () => $7e3614f655e5103c$export$aa008a00bae7e7ab);
$parcel$export(module.exports, "useOnIssueKeyChange", () => $7e3614f655e5103c$export$52c975cf0b623556);
$parcel$export(module.exports, "useRapidViewId", () => $7e3614f655e5103c$export$b34d0ea0bf41fee);
$parcel$export(module.exports, "useViewScreenId", () => $7e3614f655e5103c$export$7c142b5701b4c3f9);
$parcel$export(module.exports, "useHasSoftwareAccess", () => $7e3614f655e5103c$export$dcc0d1c3cd4bd9fb);
$parcel$export(module.exports, "useIsFullPageIssueView", () => $7e3614f655e5103c$export$2e131fc4108f9106);
$parcel$export(module.exports, "useIsEmbedPageIssueView", () => $7e3614f655e5103c$export$4596c26005fbb859);
$parcel$export(module.exports, "useIsAiOptInEnabled", () => $7e3614f655e5103c$export$b131d9f6da853161);

var $eUqFw = parcelRequire("eUqFw");


var $e91YZ = parcelRequire("e91YZ");

var $7HKaW = parcelRequire("7HKaW");
var $6vrw7 = parcelRequire("6vrw7");

var $j3FUN = parcelRequire("j3FUN");
var $jBTMs = parcelRequire("jBTMs");

var $hWdjG = parcelRequire("hWdjG");
const $7e3614f655e5103c$export$8d75f312eaa63aec = ()=>{
    const [childIssuesLimit] = (0, $hWdjG.useIssueContextStoreChildIssuesLimit)();
    return childIssuesLimit;
};
const $7e3614f655e5103c$export$cc6e0a43a2a9b17a = ()=>{
    const [childIssuesIssueLimitUrls] = (0, $hWdjG.useIssueContextStoreChildIssuesIssueLimitUrls)();
    return childIssuesIssueLimitUrls;
};
const $7e3614f655e5103c$export$65a59acd1ffc5bba = (fieldId)=>{
    const childIssuesIssueLimitUrls = $7e3614f655e5103c$export$cc6e0a43a2a9b17a();
    return childIssuesIssueLimitUrls?.[fieldId];
};
const $7e3614f655e5103c$export$9ce8428ff198804a = ()=>{
    const [isModal] = (0, $hWdjG.useIssueContextStoreIsModal)();
    return isModal;
};
const $7e3614f655e5103c$export$22108eca27445997 = ()=>{
    const [issueKey] = (0, $hWdjG.useIssueContextStoreIssueKey)();
    return issueKey;
};
const $7e3614f655e5103c$export$9df8176b5ffce5ab = ()=>{
    const [issueId] = (0, $hWdjG.useIssueContextStoreIssueId)();
    return issueId;
};
const $7e3614f655e5103c$export$7cd1821433aafaee = ()=>{
    const [isArchived] = (0, $hWdjG.useIssueContextStoreIsArchived)();
    return isArchived;
};
const $7e3614f655e5103c$export$b23b36ed5c42e920 = ()=>{
    const [isClassifyEditEnabled] = (0, $hWdjG.useIssueContextStoreIsClassifyEditEnabled)();
    return isClassifyEditEnabled;
};
const $7e3614f655e5103c$export$f87be37f8e8be65 = ()=>{
    const [issueKey] = (0, $hWdjG.useIssueContextStoreIssueKey)();
    return (0, $6vrw7.toProjectKey)(issueKey.split('-')[0]);
};
const $7e3614f655e5103c$export$aad3917152559b87 = ()=>{
    const [analyticsSource] = (0, $hWdjG.useIssueContextStoreAnalyticsSource)();
    return analyticsSource;
};
const $7e3614f655e5103c$export$d6ec1293313f49ac = ()=>{
    const [, { setIssueContext: setIssueContext, mergeIssueContext: mergeIssueContext, getChildIssuesLimit: getChildIssuesLimit, getMaxTokenLength: getMaxTokenLength, getIsLoadedWithPage: getIsLoadedWithPage, getBackButtonUrl: getBackButtonUrl, getIsSpaEnabled: getIsSpaEnabled, getIssueKey: getIssueKey, setDetailViewAsModal: setDetailViewAsModal, setDetailViewAsSidebar: setDetailViewAsSidebar, resetDetailView: resetDetailView }] = (0, $hWdjG.useIssueContextStoreActions)();
    const actions = (0, $eUqFw.useMemo)(()=>({
            setIssueContext: setIssueContext,
            mergeIssueContext: mergeIssueContext,
            getChildIssuesLimit: getChildIssuesLimit,
            getMaxTokenLength: getMaxTokenLength,
            getIsLoadedWithPage: getIsLoadedWithPage,
            getBackButtonUrl: getBackButtonUrl,
            getIsSpaEnabled: getIsSpaEnabled,
            getIssueKey: getIssueKey,
            setDetailViewAsModal: setDetailViewAsModal,
            setDetailViewAsSidebar: setDetailViewAsSidebar,
            resetDetailView: resetDetailView
        }), [
        setIssueContext,
        mergeIssueContext,
        getChildIssuesLimit,
        getMaxTokenLength,
        getIsLoadedWithPage,
        getBackButtonUrl,
        getIsSpaEnabled,
        getIssueKey,
        setDetailViewAsModal,
        setDetailViewAsSidebar,
        resetDetailView
    ]);
    return [
        undefined,
        actions
    ];
};
const $7e3614f655e5103c$export$4d204e800e4e0be7 = ()=>{
    const [rapidViewMap] = (0, $hWdjG.useIssueContextRapidViewMap)();
    return rapidViewMap;
};
const $7e3614f655e5103c$export$e0d7666ae716c88a = ()=>{
    const [maxTokenLength] = (0, $hWdjG.useIssueContextStoreMaxTokenLength)();
    return maxTokenLength;
};
const $7e3614f655e5103c$export$b4199f923267161e = ()=>{
    const [isLoadedWithPage] = (0, $hWdjG.useIssueContextStoreIsLoadedWithPage)();
    return isLoadedWithPage;
};
const $7e3614f655e5103c$export$5b20e30ee6db56e9 = ()=>{
    const [estimationStatistic] = (0, $hWdjG.useIssueContextStoreEstimationStatistic)();
    return estimationStatistic;
};
const $7e3614f655e5103c$export$4dface15d86304a4 = ()=>{
    const [isLoading] = (0, $hWdjG.useIssueContextStoreIsLoading)();
    return isLoading;
};
const $7e3614f655e5103c$export$3a7c3e259b6adb93 = ()=>{
    const [viewMode] = (0, $hWdjG.useIssueContextStoreViewMode)();
    return viewMode;
};
const $7e3614f655e5103c$export$cfe64a334903927c = ()=>{
    const [backButtonUrl] = (0, $hWdjG.useIssueContextStoreBackButtonUrl)();
    return backButtonUrl;
};
const $7e3614f655e5103c$export$aa008a00bae7e7ab = ()=>{
    const [issueNavigatorData] = (0, $hWdjG.useIssueContextStoreIssueNavigatorData)();
    return issueNavigatorData;
};
const $7e3614f655e5103c$export$b49754504c41149f = ()=>{
    const [boardId] = (0, $hWdjG.useIssueContextStoreBoardId)();
    return boardId;
};
const $7e3614f655e5103c$export$91aab984882a2a2c = ()=>{
    const [boardType] = (0, $hWdjG.useIssueContextStoreBoardType)();
    return boardType;
};
const $7e3614f655e5103c$export$dbad9dbd4871f2e9 = ()=>{
    const [isSpaEnabled] = (0, $hWdjG.useIssueContextStoreIsSpaEnabled)();
    return isSpaEnabled;
};
const $7e3614f655e5103c$export$7be495880d433ab9 = ()=>{
    const [loginRedirectUrl] = (0, $hWdjG.useIssueContextStoreLoginRedirctUrl)();
    return loginRedirectUrl;
};
const $7e3614f655e5103c$export$52c975cf0b623556 = ()=>{
    const [onIssueKeyChange] = (0, $hWdjG.useIssueContextStoreOnIssueKeyChange)();
    return onIssueKeyChange;
};
const $7e3614f655e5103c$export$b34d0ea0bf41fee = ()=>{
    const [rapidViewId] = (0, $hWdjG.useIssueContextStoreRapidViewId)();
    return rapidViewId;
};
const $7e3614f655e5103c$export$7c142b5701b4c3f9 = ()=>{
    const [viewScreenId] = (0, $hWdjG.useIssueContextStoreViewScreenId)();
    return viewScreenId;
};
const $7e3614f655e5103c$export$dcc0d1c3cd4bd9fb = ()=>{
    const licensedProducts = (0, $j3FUN.useLicensedProducts)();
    const licenseStates = (0, $jBTMs.useLicenseStates)();
    const isJiraSoftwareLicenseActive = licenseStates && licenseStates.software === (0, $7HKaW.LICENSE_STATE_ACTIVE);
    return licensedProducts[(0, $e91YZ.LICENSED_PRODUCTS).JIRA_SOFTWARE] && isJiraSoftwareLicenseActive;
};
const $7e3614f655e5103c$export$2e131fc4108f9106 = ()=>{
    const analyticsSource = $7e3614f655e5103c$export$aad3917152559b87();
    return analyticsSource === (0, $0100842672acae20$export$b19f949fb9713614);
};
const $7e3614f655e5103c$export$4596c26005fbb859 = ()=>{
    const analyticsSource = $7e3614f655e5103c$export$aad3917152559b87();
    return analyticsSource === (0, $0100842672acae20$export$a5132300c5214280);
};
const $7e3614f655e5103c$export$b131d9f6da853161 = ()=>{
    const [isAiOptInEnabled] = (0, $hWdjG.useIssueContextIsAiOptInEnabled)();
    return isAiOptInEnabled;
};

});
parcelRegister("j3FUN", function(module, exports) {

$parcel$export(module.exports, "useLicensedProducts", () => $02df0e5ac33ae573$export$54d534cc91e54850);

var $gd0Sp = parcelRequire("gd0Sp");
const $02df0e5ac33ae573$export$54d534cc91e54850 = ()=>{
    const tenantContext = (0, $gd0Sp.useTenantContext)();
    return tenantContext && tenantContext.licensedProducts || {};
};

});

parcelRegister("jBTMs", function(module, exports) {

$parcel$export(module.exports, "useLicenseStates", () => $0a5df676eadd90b5$export$268651a63abe408a);

var $gd0Sp = parcelRequire("gd0Sp");
const $0a5df676eadd90b5$export$268651a63abe408a = ()=>{
    const tenantContext = (0, $gd0Sp.useTenantContext)();
    return tenantContext && tenantContext.licenseStates;
};

});

parcelRegister("hWdjG", function(module, exports) {

$parcel$export(module.exports, "useIssueContextStoreChildIssuesLimit", () => $c495211a89197754$export$abdbea56d86b4aac);
$parcel$export(module.exports, "useIssueContextStoreChildIssuesIssueLimitUrls", () => $c495211a89197754$export$326ff2b963d51c5c);
$parcel$export(module.exports, "useIssueContextStoreIssueKey", () => $c495211a89197754$export$44bcaaabb74e402b);
$parcel$export(module.exports, "useIssueContextStoreIssueId", () => $c495211a89197754$export$332dcee0cf9f4e45);
$parcel$export(module.exports, "useIssueContextStoreIsArchived", () => $c495211a89197754$export$c940355b1fc6e1c4);
$parcel$export(module.exports, "useIssueContextStoreIsClassifyEditEnabled", () => $c495211a89197754$export$b9eebaa1da421997);
$parcel$export(module.exports, "useIssueContextStoreIsModal", () => $c495211a89197754$export$daa47fd600e43a32);
$parcel$export(module.exports, "useIssueContextStoreViewScreenId", () => $c495211a89197754$export$ba2e9546ab5ba6f);
$parcel$export(module.exports, "useIssueContextStoreAnalyticsSource", () => $c495211a89197754$export$74d38d6c437efc1b);
$parcel$export(module.exports, "useIssueContextRapidViewMap", () => $c495211a89197754$export$2092528ee170d9e7);
$parcel$export(module.exports, "useIssueContextStoreMaxTokenLength", () => $c495211a89197754$export$57898374e6239a5a);
$parcel$export(module.exports, "useIssueContextStoreIsLoadedWithPage", () => $c495211a89197754$export$ff0264ec4c015dc1);
$parcel$export(module.exports, "useIssueContextStoreEstimationStatistic", () => $c495211a89197754$export$6c8b81f6dca8c23d);
$parcel$export(module.exports, "useIssueContextStoreIsLoading", () => $c495211a89197754$export$fe7085456138f0fc);
$parcel$export(module.exports, "useIssueContextStoreViewMode", () => $c495211a89197754$export$c339e36468c12443);
$parcel$export(module.exports, "useIssueContextStoreBackButtonUrl", () => $c495211a89197754$export$ef3bfa2642bb98cd);
$parcel$export(module.exports, "useIssueContextStoreIssueNavigatorData", () => $c495211a89197754$export$8accd063c74cd455);
$parcel$export(module.exports, "useIssueContextStoreBoardId", () => $c495211a89197754$export$e7edffc2a20027e7);
$parcel$export(module.exports, "useIssueContextStoreBoardType", () => $c495211a89197754$export$48aaa3a6bc2085d7);
$parcel$export(module.exports, "useIssueContextStoreIsSpaEnabled", () => $c495211a89197754$export$4a4b96bcf5166327);
$parcel$export(module.exports, "useIssueContextStoreLoginRedirctUrl", () => $c495211a89197754$export$bbd8ba0180545556);
$parcel$export(module.exports, "useIssueContextStoreOnIssueKeyChange", () => $c495211a89197754$export$aaa89627762c7d00);
$parcel$export(module.exports, "useIssueContextStoreRapidViewId", () => $c495211a89197754$export$796589b0ec52848a);
$parcel$export(module.exports, "useIssueContextIsAiOptInEnabled", () => $c495211a89197754$export$7e70ee570119a0a7);
$parcel$export(module.exports, "IssueContextContainer", () => $c495211a89197754$export$93db6a8f3342dddf);
$parcel$export(module.exports, "useIssueContextStoreActions", () => $c495211a89197754$export$965360ae27fcae98);

var $6vrw7 = parcelRequire("6vrw7");

var $96gVp = parcelRequire("96gVp");
var $1yZQx = parcelRequire("1yZQx");
var $kEDjj = parcelRequire("kEDjj");

var $8d785 = parcelRequire("8d785");

var $hHM8F = parcelRequire("hHM8F");

var $fhgeS = parcelRequire("fhgeS");
const $c495211a89197754$export$d4c72bab9d6cc13a = {
    childIssuesLimit: undefined,
    childIssuesIssueLimitUrls: undefined,
    issueKey: (0, $6vrw7.toIssueKey)(''),
    isArchived: false,
    isClassifyEditEnabled: false,
    isModal: false,
    maxTokenLength: 0,
    isLoadedWithPage: false,
    rapidViewMap: undefined,
    estimationStatistic: undefined,
    isLoading: false,
    // initialise viewMode with the value stored in local storage
    viewMode: (0, $fhgeS.getViewModeFromLocalStorage)(),
    analyticsSource: undefined,
    backButtonUrl: undefined,
    issueNavigatorData: undefined,
    boardId: undefined,
    boardType: undefined,
    isSpaEnabled: false,
    loginRedirectUrl: undefined,
    onIssueKeyChange: undefined,
    rapidViewId: undefined,
    viewScreenId: undefined,
    isAiOptInEnabled: false
};
const $c495211a89197754$export$6f57813fe9f31bf9 = (0, $kEDjj.createStore)({
    name: 'issue-context',
    initialState: $c495211a89197754$export$d4c72bab9d6cc13a,
    actions: $8d785.actions
});
const $c495211a89197754$var$getIssueContext = (state)=>state;
const $c495211a89197754$var$getIsModal = (state)=>state.isModal;
const $c495211a89197754$var$getIssueKey = (state)=>state.issueKey;
const $c495211a89197754$var$getIsArchived = (state)=>state.isArchived;
const $c495211a89197754$var$getIsClassifyEditEnabled = (state)=>state.isClassifyEditEnabled;
const $c495211a89197754$var$getIssueId = (state)=>state.issueId;
// @ts-expect-error - TS7006 - Parameter 'state' implicitly has an 'any' type.
const $c495211a89197754$var$getAnalyticsSource = (state)=>state.analyticsSource !== undefined ? state.analyticsSource : undefined;
const $c495211a89197754$var$getRapidViewMap = (state)=>state.rapidViewMap;
const $c495211a89197754$var$getMaxTokenLength = (state)=>state.maxTokenLength;
const $c495211a89197754$var$getIsLoadedWithPage = (state)=>state.isLoadedWithPage;
const $c495211a89197754$var$getEstimationStatistic = (state)=>state.estimationStatistic;
const $c495211a89197754$var$getIsLoading = (state)=>state.isLoading;
const $c495211a89197754$var$getViewMode = (state)=>state.viewMode;
const $c495211a89197754$var$getBackButtonUrl = (state)=>state.backButtonUrl;
const $c495211a89197754$var$getIssueNavigatorData = (state)=>state.issueNavigatorData;
const $c495211a89197754$var$getBoardId = (state)=>state.boardId;
const $c495211a89197754$var$getBoardType = (state)=>state.boardType;
const $c495211a89197754$var$getIsSpaEnabled = (state)=>state.isSpaEnabled;
const $c495211a89197754$var$getLoginRedirectUrl = (state)=>state.loginRedirectUrl;
const $c495211a89197754$var$getOnIssueKeyChange = (state)=>state.onIssueKeyChange;
const $c495211a89197754$var$getRapidViewId = (state)=>state.rapidViewId;
const $c495211a89197754$var$getViewScreenId = (state)=>state.viewScreenId;
const $c495211a89197754$var$getIsAiOptInEnabled = (state)=>Boolean(state.isAiOptInEnabled);
const $c495211a89197754$export$f6e0a3ee03299fbc = (0, $1yZQx.createHook)($c495211a89197754$export$6f57813fe9f31bf9, {
    selector: $c495211a89197754$var$getIssueContext
});
const $c495211a89197754$export$abdbea56d86b4aac = (0, $1yZQx.createHook)($c495211a89197754$export$6f57813fe9f31bf9, {
    selector: (0, $hHM8F.getChildIssuesLimit)
});
const $c495211a89197754$export$326ff2b963d51c5c = (0, $1yZQx.createHook)($c495211a89197754$export$6f57813fe9f31bf9, {
    selector: (0, $hHM8F.getChildIssuesIssueLimitUrls)
});
const $c495211a89197754$export$44bcaaabb74e402b = (0, $1yZQx.createHook)($c495211a89197754$export$6f57813fe9f31bf9, {
    selector: $c495211a89197754$var$getIssueKey
});
const $c495211a89197754$export$332dcee0cf9f4e45 = (0, $1yZQx.createHook)($c495211a89197754$export$6f57813fe9f31bf9, {
    selector: $c495211a89197754$var$getIssueId
});
const $c495211a89197754$export$c940355b1fc6e1c4 = (0, $1yZQx.createHook)($c495211a89197754$export$6f57813fe9f31bf9, {
    selector: $c495211a89197754$var$getIsArchived
});
const $c495211a89197754$export$b9eebaa1da421997 = (0, $1yZQx.createHook)($c495211a89197754$export$6f57813fe9f31bf9, {
    selector: $c495211a89197754$var$getIsClassifyEditEnabled
});
const $c495211a89197754$export$daa47fd600e43a32 = (0, $1yZQx.createHook)($c495211a89197754$export$6f57813fe9f31bf9, {
    selector: $c495211a89197754$var$getIsModal
});
const $c495211a89197754$export$ba2e9546ab5ba6f = (0, $1yZQx.createHook)($c495211a89197754$export$6f57813fe9f31bf9, {
    selector: $c495211a89197754$var$getViewScreenId
});
const $c495211a89197754$export$74d38d6c437efc1b = (0, $1yZQx.createHook)($c495211a89197754$export$6f57813fe9f31bf9, {
    selector: $c495211a89197754$var$getAnalyticsSource
});
const $c495211a89197754$export$2092528ee170d9e7 = (0, $1yZQx.createHook)($c495211a89197754$export$6f57813fe9f31bf9, {
    selector: $c495211a89197754$var$getRapidViewMap
});
const $c495211a89197754$export$57898374e6239a5a = (0, $1yZQx.createHook)($c495211a89197754$export$6f57813fe9f31bf9, {
    selector: $c495211a89197754$var$getMaxTokenLength
});
const $c495211a89197754$export$ff0264ec4c015dc1 = (0, $1yZQx.createHook)($c495211a89197754$export$6f57813fe9f31bf9, {
    selector: $c495211a89197754$var$getIsLoadedWithPage
});
const $c495211a89197754$export$6c8b81f6dca8c23d = (0, $1yZQx.createHook)($c495211a89197754$export$6f57813fe9f31bf9, {
    selector: $c495211a89197754$var$getEstimationStatistic
});
const $c495211a89197754$export$fe7085456138f0fc = (0, $1yZQx.createHook)($c495211a89197754$export$6f57813fe9f31bf9, {
    selector: $c495211a89197754$var$getIsLoading
});
const $c495211a89197754$export$c339e36468c12443 = (0, $1yZQx.createHook)($c495211a89197754$export$6f57813fe9f31bf9, {
    selector: $c495211a89197754$var$getViewMode
});
const $c495211a89197754$export$ef3bfa2642bb98cd = (0, $1yZQx.createHook)($c495211a89197754$export$6f57813fe9f31bf9, {
    selector: $c495211a89197754$var$getBackButtonUrl
});
const $c495211a89197754$export$8accd063c74cd455 = (0, $1yZQx.createHook)($c495211a89197754$export$6f57813fe9f31bf9, {
    selector: $c495211a89197754$var$getIssueNavigatorData
});
const $c495211a89197754$export$e7edffc2a20027e7 = (0, $1yZQx.createHook)($c495211a89197754$export$6f57813fe9f31bf9, {
    selector: $c495211a89197754$var$getBoardId
});
const $c495211a89197754$export$48aaa3a6bc2085d7 = (0, $1yZQx.createHook)($c495211a89197754$export$6f57813fe9f31bf9, {
    selector: $c495211a89197754$var$getBoardType
});
const $c495211a89197754$export$4a4b96bcf5166327 = (0, $1yZQx.createHook)($c495211a89197754$export$6f57813fe9f31bf9, {
    selector: $c495211a89197754$var$getIsSpaEnabled
});
const $c495211a89197754$export$bbd8ba0180545556 = (0, $1yZQx.createHook)($c495211a89197754$export$6f57813fe9f31bf9, {
    selector: $c495211a89197754$var$getLoginRedirectUrl
});
const $c495211a89197754$export$aaa89627762c7d00 = (0, $1yZQx.createHook)($c495211a89197754$export$6f57813fe9f31bf9, {
    selector: $c495211a89197754$var$getOnIssueKeyChange
});
const $c495211a89197754$export$796589b0ec52848a = (0, $1yZQx.createHook)($c495211a89197754$export$6f57813fe9f31bf9, {
    selector: $c495211a89197754$var$getRapidViewId
});
const $c495211a89197754$export$7e70ee570119a0a7 = (0, $1yZQx.createHook)($c495211a89197754$export$6f57813fe9f31bf9, {
    selector: $c495211a89197754$var$getIsAiOptInEnabled
});
const $c495211a89197754$export$93db6a8f3342dddf = (0, $96gVp.createContainer)($c495211a89197754$export$6f57813fe9f31bf9);
const $c495211a89197754$export$965360ae27fcae98 = (0, $1yZQx.createHook)($c495211a89197754$export$6f57813fe9f31bf9, {
    selector: null
});

});
parcelRegister("8d785", function(module, exports) {

$parcel$export(module.exports, "actions", () => $0a3f8ba487c482e8$export$e324594224ef24da);

var $7LyiF = parcelRequire("7LyiF");

var $hHM8F = parcelRequire("hHM8F");

var $fhgeS = parcelRequire("fhgeS");
const $0a3f8ba487c482e8$export$784a03c4b74da53e = (issueContext)=>({ setState: setState, getState: getState })=>{
        const { issueKey: currentIssueKey, issueId: currentIssueId } = getState();
        // ARKEN-792: reset issueId on issueKey change if issueId isn't provided
        if (currentIssueId && currentIssueKey && !issueContext.issueId && issueContext.issueKey !== currentIssueKey) setState({
            ...issueContext,
            issueId: undefined,
            viewMode: issueContext.viewMode || getState().viewMode
        });
        else setState({
            ...issueContext,
            viewMode: issueContext.viewMode || getState().viewMode
        });
    };
const $0a3f8ba487c482e8$export$666ee48e0eaf4f13 = (partialIssueContext)=>({ getState: getState, setState: setState })=>{
        const { issueKey: currentIssueKey, issueId: currentIssueId } = getState();
        // ARKEN-792: reset issueId on issueKey change if issueId isn't provided
        if (currentIssueId && currentIssueKey && !partialIssueContext.issueId && partialIssueContext.issueKey && partialIssueContext.issueKey !== currentIssueKey) setState({
            ...getState(),
            ...partialIssueContext,
            issueId: undefined
        });
        else setState({
            ...getState(),
            ...partialIssueContext
        });
    };
const $0a3f8ba487c482e8$export$89b6937a83edcaa6 = ()=>({ getState: getState })=>(0, $hHM8F.getChildIssuesLimit)(getState());
const $0a3f8ba487c482e8$export$e40f2acaf1a50b00 = ()=>({ getState: getState })=>getState().maxTokenLength;
const $0a3f8ba487c482e8$export$2fe981b90be13483 = ()=>({ getState: getState })=>getState().isLoadedWithPage;
const $0a3f8ba487c482e8$export$afce556782490aae = ()=>({ getState: getState })=>getState().backButtonUrl;
const $0a3f8ba487c482e8$export$711dfa096bf81f2d = ()=>({ getState: getState })=>getState().isSpaEnabled;
const $0a3f8ba487c482e8$export$4a030f6192bebe03 = ()=>({ getState: getState })=>getState().issueKey;
const $0a3f8ba487c482e8$export$b41341ac6c74ca6 = ()=>({ getState: getState })=>getState().isArchived;
const $0a3f8ba487c482e8$export$77ec0de2f63f10c4 = (willSave = true)=>({ setState: setState })=>{
        if (willSave) (0, $7LyiF.localStorage).set((0, $7LyiF.VIEW_MODE_STORAGE_KEY), 'MODAL');
        setState({
            viewMode: 'MODAL'
        });
    };
const $0a3f8ba487c482e8$export$b303af51de56a0e = (willSave = true)=>({ setState: setState })=>{
        if (willSave) (0, $7LyiF.localStorage).set((0, $7LyiF.VIEW_MODE_STORAGE_KEY), 'SIDEBAR');
        setState({
            viewMode: 'SIDEBAR'
        });
    };
const $0a3f8ba487c482e8$export$75007d125f198b78 = ()=>({ setState: setState })=>{
        setState({
            viewMode: (0, $fhgeS.getViewModeFromLocalStorage)()
        });
    };
const $0a3f8ba487c482e8$export$e324594224ef24da = {
    setIssueContext: $0a3f8ba487c482e8$export$784a03c4b74da53e,
    mergeIssueContext: $0a3f8ba487c482e8$export$666ee48e0eaf4f13,
    getChildIssuesLimit: $0a3f8ba487c482e8$export$89b6937a83edcaa6,
    getMaxTokenLength: $0a3f8ba487c482e8$export$e40f2acaf1a50b00,
    getIsLoadedWithPage: $0a3f8ba487c482e8$export$2fe981b90be13483,
    getBackButtonUrl: $0a3f8ba487c482e8$export$afce556782490aae,
    getIsSpaEnabled: $0a3f8ba487c482e8$export$711dfa096bf81f2d,
    getIssueKey: $0a3f8ba487c482e8$export$4a030f6192bebe03,
    getIsArchived: $0a3f8ba487c482e8$export$b41341ac6c74ca6,
    setDetailViewAsModal: $0a3f8ba487c482e8$export$77ec0de2f63f10c4,
    setDetailViewAsSidebar: $0a3f8ba487c482e8$export$b303af51de56a0e,
    resetDetailView: $0a3f8ba487c482e8$export$75007d125f198b78
};

});
parcelRegister("7LyiF", function(module, exports) {

$parcel$export(module.exports, "LOG_LOCATION", () => $7643f341d271ccc9$export$25a759e49d5049db);
$parcel$export(module.exports, "localStorage", () => $7643f341d271ccc9$export$c2ed3351cac403d1);
$parcel$export(module.exports, "VIEW_MODE_STORAGE_KEY", () => $7643f341d271ccc9$export$a13f7f627010bccd);

var $aZaPn = parcelRequire("aZaPn");
const $7643f341d271ccc9$export$25a759e49d5049db = 'issue.issue-context-service';
const $7643f341d271ccc9$export$c2ed3351cac403d1 = (0, $aZaPn.createLocalStorageProvider)('jira_issue_view');
const $7643f341d271ccc9$export$a13f7f627010bccd = 'view-mode';

});

parcelRegister("hHM8F", function(module, exports) {

$parcel$export(module.exports, "getChildIssuesLimit", () => $a9a8c93b5bcca8ab$export$89b6937a83edcaa6);
$parcel$export(module.exports, "getChildIssuesIssueLimitUrls", () => $a9a8c93b5bcca8ab$export$8f43520910e8128c);

var $gUUjF = parcelRequire("gUUjF");

var $7LyiF = parcelRequire("7LyiF");
// This is here solely as a last resort option if the backend for some reason
// is unable to propagate the limit. Or if somehow the code that populates
// this store is broken.
// 500 is the current limit reflected in the backend at the time of writing.
const $a9a8c93b5bcca8ab$var$FALLBACK_CHILD_ISSUES_LIMIT = 500;
const $a9a8c93b5bcca8ab$var$getFallbackChildIssuesLimitAndLogAsUnexpected = ()=>{
    (0, $gUUjF.default).safeErrorWithoutCustomerData(`${(0, $7LyiF.LOG_LOCATION)}.selectors.getChildIssuesLimit`, 'The child issues limit is undefined using the fallback child issues limit');
    return $a9a8c93b5bcca8ab$var$FALLBACK_CHILD_ISSUES_LIMIT;
};
const $a9a8c93b5bcca8ab$export$89b6937a83edcaa6 = (state)=>state.childIssuesLimit ?? $a9a8c93b5bcca8ab$var$getFallbackChildIssuesLimitAndLogAsUnexpected();
const $a9a8c93b5bcca8ab$export$8f43520910e8128c = (state)=>state.childIssuesIssueLimitUrls;

});

parcelRegister("fhgeS", function(module, exports) {

$parcel$export(module.exports, "getViewModeFromLocalStorage", () => $49ad189ccd6ad8c9$export$cae7c4c591dcc261);

var $7LyiF = parcelRequire("7LyiF");
const $49ad189ccd6ad8c9$export$cae7c4c591dcc261 = ()=>(0, $7LyiF.localStorage).get((0, $7LyiF.VIEW_MODE_STORAGE_KEY)) || 'DEFAULT';

});




parcelRegister("kmr29", function(module, exports) {

$parcel$export(module.exports, "useFieldValue", () => $da19d1ee706d4a81$export$b79fae7fbe3ac392);
$parcel$export(module.exports, "useFieldsValues", () => $da19d1ee706d4a81$export$25b73e671fe7a8fa);
$parcel$export(module.exports, "useFieldValuesForIssues", () => $da19d1ee706d4a81$export$ac289b84121829df);
$parcel$export(module.exports, "useMultiFieldValuesForIssues", () => $da19d1ee706d4a81$export$915cdeec521b54f7);
$parcel$export(module.exports, "FieldValueSubscriber", () => $da19d1ee706d4a81$export$4e5f1f4ed08d155e);
$parcel$export(module.exports, "useFieldsValuesActions", () => $da19d1ee706d4a81$export$612d9bcb0c9d8976);

var $eUqFw = parcelRequire("eUqFw");

var $2vzCR = parcelRequire("2vzCR");

var $1yZQx = parcelRequire("1yZQx");
var $kEDjj = parcelRequire("kEDjj");
var $2HpOy = parcelRequire("2HpOy");
const $da19d1ee706d4a81$var$setIssue = (issueKey, fields)=>({ setState: setState })=>{
        setState({
            // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
            [issueKey]: fields
        });
    };
const $da19d1ee706d4a81$var$setIssues = (issues)=>({ setState: setState })=>{
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        const newIssues = {};
        issues.forEach((issue)=>{
            Object.assign(newIssues, issue);
        });
        setState(newIssues);
    };
const $da19d1ee706d4a81$var$setFieldValue = (issueKey, fieldKey, value)=>({ setState: setState, getState: getState })=>{
        setState({
            // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
            [issueKey]: {
                ...getState()[issueKey],
                [fieldKey]: value
            }
        });
    };
const $da19d1ee706d4a81$var$getFieldValue = (issueKey, fieldKey)=>({ getState: getState })=>{
        const issueFieldValues = getState()[issueKey];
        return issueFieldValues && issueFieldValues[fieldKey];
    };
const $da19d1ee706d4a81$var$mergeIssue = (issueKey, fields)=>({ setState: setState, getState: getState })=>{
        setState({
            // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
            [issueKey]: (0, (/*@__PURE__*/$parcel$interopDefault($2vzCR)))({}, getState()[issueKey], fields)
        });
    };
const $da19d1ee706d4a81$export$11aa02e14fdf7753 = (issues)=>({ setState: setState, getState: getState })=>{
        if (issues.length === 0) return;
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        const newIssues = {};
        issues.forEach((issue)=>{
            Object.assign(newIssues, issue);
        });
        setState((0, (/*@__PURE__*/$parcel$interopDefault($2vzCR)))({}, getState(), newIssues));
    };
const $da19d1ee706d4a81$var$actions = {
    setFieldValue: $da19d1ee706d4a81$var$setFieldValue,
    getFieldValue: $da19d1ee706d4a81$var$getFieldValue,
    setIssue: $da19d1ee706d4a81$var$setIssue,
    mergeIssue: $da19d1ee706d4a81$var$mergeIssue,
    setIssues: $da19d1ee706d4a81$var$setIssues,
    mergeIssues: $da19d1ee706d4a81$export$11aa02e14fdf7753
};
// this is a global store
const $da19d1ee706d4a81$var$store = (0, $kEDjj.createStore)({
    name: 'issue-fields',
    initialState: {},
    actions: $da19d1ee706d4a81$var$actions
});
const $da19d1ee706d4a81$var$getFieldValueSelector = (state, { issueKey: issueKey, fieldKey: fieldKey })=>{
    const issueFieldValues = state[issueKey];
    return issueFieldValues && issueFieldValues[fieldKey];
};
const $da19d1ee706d4a81$var$getFieldValuesForIssuesSelector = (state, { issueKeys: issueKeys, fieldKey: fieldKey })=>(issueKeys || []).map((issueKey)=>$da19d1ee706d4a81$var$getFieldValueSelector(state, {
            fieldKey: fieldKey,
            issueKey: issueKey
        }));
const $da19d1ee706d4a81$var$getMultiFieldValuesForIssuesSelector = (state, { issueKeys: issueKeys, fieldKeys: fieldKeys })=>(issueKeys || []).reduce((accumulator, issueKey)=>{
        if (!state[issueKey]) return accumulator;
        const fieldValue = fieldKeys.reduce((acc, fieldKey)=>{
            acc[fieldKey] = $da19d1ee706d4a81$var$getFieldValueSelector(state, {
                fieldKey: fieldKey,
                issueKey: issueKey
            });
            return acc;
        }, {});
        accumulator[issueKey] = fieldValue;
        return accumulator;
    }, {});
const $da19d1ee706d4a81$var$getAllFields = (state, issueKey)=>state[issueKey];
const $da19d1ee706d4a81$export$b79fae7fbe3ac392 = (0, $1yZQx.createHook)($da19d1ee706d4a81$var$store, {
    selector: $da19d1ee706d4a81$var$getFieldValueSelector
});
const $da19d1ee706d4a81$export$25b73e671fe7a8fa = (0, $1yZQx.createHook)($da19d1ee706d4a81$var$store, {
    selector: $da19d1ee706d4a81$var$getAllFields
});
const $da19d1ee706d4a81$export$ac289b84121829df = (0, $1yZQx.createHook)($da19d1ee706d4a81$var$store, {
    selector: $da19d1ee706d4a81$var$getFieldValuesForIssuesSelector
});
const $da19d1ee706d4a81$export$915cdeec521b54f7 = (0, $1yZQx.createHook)($da19d1ee706d4a81$var$store, {
    selector: $da19d1ee706d4a81$var$getMultiFieldValuesForIssuesSelector
});
const $da19d1ee706d4a81$export$4e5f1f4ed08d155e = (0, $2HpOy.createSubscriber)($da19d1ee706d4a81$var$store, {
    selector: $da19d1ee706d4a81$var$getFieldValueSelector
});
const $da19d1ee706d4a81$var$useFieldValueStoreActions = (0, $1yZQx.createHook)($da19d1ee706d4a81$var$store, {
    selector: null
});
const $da19d1ee706d4a81$export$612d9bcb0c9d8976 = ()=>{
    const [, fieldValueStoreActions] = $da19d1ee706d4a81$var$useFieldValueStoreActions();
    const fieldsValuesActions = (0, $eUqFw.useMemo)(()=>{
        const setIssueAction = (issueKey, fields)=>fieldValueStoreActions.setIssue(issueKey, fields);
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        const setFieldValueAction = (issueKey, fieldKey, value)=>fieldValueStoreActions.setFieldValue(issueKey, fieldKey, value);
        const getFieldValueAction = (issueKey, fieldKey)=>fieldValueStoreActions.getFieldValue(issueKey, fieldKey);
        const mergeIssueAction = (issueKey, fields)=>fieldValueStoreActions.mergeIssue(issueKey, fields);
        const setIssuesAction = (issues)=>fieldValueStoreActions.setIssues(issues);
        const mergeIssuesAction = (issues)=>fieldValueStoreActions.mergeIssues(issues);
        return {
            setIssue: setIssueAction,
            setFieldValue: setFieldValueAction,
            getFieldValue: getFieldValueAction,
            mergeIssue: mergeIssueAction,
            setIssues: setIssuesAction,
            mergeIssues: mergeIssuesAction
        };
    }, [
        fieldValueStoreActions
    ]);
    return [
        null,
        fieldsValuesActions
    ];
};

});

parcelRegister("bLiXo", function(module, exports) {

$parcel$export(module.exports, "ECOSYSTEM_GLANCE_TYPE", () => $9366007edb455895$export$99ad62164189f781);
$parcel$export(module.exports, "FORGE_GLANCE_TYPE", () => $9366007edb455895$export$7719ef6e9283671);
$parcel$export(module.exports, "ECOSYSTEM_CONTEXT_TYPE", () => $9366007edb455895$export$bfebea5ce2e1887a);
$parcel$export(module.exports, "FORGE_CONTEXT_TYPE", () => $9366007edb455895$export$be8e68fb1aed253e);
$parcel$export(module.exports, "CONTEXT_AREA", () => $9366007edb455895$export$7bf561e6ab380ea1);
$parcel$export(module.exports, "CONTENT_AREA", () => $9366007edb455895$export$f42c11634d75863e);
$parcel$export(module.exports, "CONTENT_REQUEST_AREA", () => $9366007edb455895$export$b38842736b6dbc1d);
$parcel$export(module.exports, "REACT_KEY_SUMMARY", () => $9366007edb455895$export$605c43f1b33ab69);
$parcel$export(module.exports, "CUSTOM_ITEM_TYPE", () => $9366007edb455895$export$e655b77b9efe622f);
$parcel$export(module.exports, "layoutContainerItemTypes", () => $9366007edb455895$export$5507f31126c8b283);
$parcel$export(module.exports, "isLayoutContainerTabItem", () => $9366007edb455895$export$ad3536b13febb432);
const $9366007edb455895$export$99ad62164189f781 = 'ecosystemGlance';
const $9366007edb455895$export$7719ef6e9283671 = 'forgeGlance';
const $9366007edb455895$export$bfebea5ce2e1887a = 'ecosystemContext';
const $9366007edb455895$export$be8e68fb1aed253e = 'forgeContext';
const $9366007edb455895$export$7bf561e6ab380ea1 = 'context';
const $9366007edb455895$export$f42c11634d75863e = 'content';
const $9366007edb455895$export$b38842736b6dbc1d = 'content-request';
const $9366007edb455895$export$bc9fa2d93b5fabae = 'FIELD';
const $9366007edb455895$var$STATUS_TYPE = 'STATUS';
const $9366007edb455895$var$TAB_TYPE = 'TAB';
const $9366007edb455895$var$PANEL_TYPE = 'PANEL';
const $9366007edb455895$var$ECOSYSTEM_TYPE = 'ECOSYSTEM';
const $9366007edb455895$var$FORGE_TYPE = 'FORGE';
const $9366007edb455895$export$605c43f1b33ab69 = 'SUMMARY';
const $9366007edb455895$export$e655b77b9efe622f = 'CustomItem';
const $9366007edb455895$export$5cf403de05e9bea = 'FieldSectionItem';
const $9366007edb455895$export$30f7f9a86f182492 = 'TabLayout';
const $9366007edb455895$export$196e597ad9a97f7a = 'PanelSectionItem';
const $9366007edb455895$var$ECOSYSTEM_SECTION_ITEM = 'EcosystemSectionItem';
const $9366007edb455895$var$FORGE_SECTION_ITEM = 'ForgeSectionItem';
const $9366007edb455895$export$5507f31126c8b283 = {
    field: 'JiraIssueItemFieldItem',
    panel: 'JiraIssueItemPanelItem',
    tab: 'JiraIssueItemTabContainer'
};
const $9366007edb455895$export$ad3536b13febb432 = (node)=>node.type === $9366007edb455895$export$5507f31126c8b283.tab;

});

parcelRegister("fkvsU", function(module, exports) {

$parcel$export(module.exports, "FORGE_ENTITY_TYPE", () => $f4e7965032899654$export$6f3804b3f188f650);
$parcel$export(module.exports, "CONNECT_ENTITY_TYPE", () => $f4e7965032899654$export$1b2059a011c9174d);
const $f4e7965032899654$export$6f3804b3f188f650 = 'FORGE_ENTITY_TYPE';
const $f4e7965032899654$export$1b2059a011c9174d = 'CONNECT_ENTITY_TYPE';
const $f4e7965032899654$export$38f0fc1cf1f24cba = [
    $f4e7965032899654$export$6f3804b3f188f650,
    $f4e7965032899654$export$1b2059a011c9174d
];

});

/**
 * Opt into the new issue view modal key. To be cleaned up with issue.details.opt-back-in
 * This key is stored in the API and should not be renamed.
 * @see https://hello.atlassian.net/wiki/spaces/JIE/pages/920124493/How+to+re-set+new+Bento+Change+Boarding#Re-set-Opt-In-Back-Modal
 */ const $ab3fc2ac1a2f2638$export$a3338d0a4845edfa = 'jira.details.opt-in-back.next-reminding-date';
const $ab3fc2ac1a2f2638$export$26de4b42c139644c = 'jira.user.issue.should.show.welcome.message';
const $ab3fc2ac1a2f2638$export$ece45f325779a5d5 = 'jira.user.issue.opt.in.back.modal.has.dismissed';
const $ab3fc2ac1a2f2638$export$4603581e6066a63f = 'jira.user.issue.opt.in.back.banner.has.dismissed';
const $ab3fc2ac1a2f2638$export$af60a7ae4202be66 = 'issue-details-changeboarding';
const $ab3fc2ac1a2f2638$export$7b98e5a33c854454 = 30;
const $ab3fc2ac1a2f2638$export$956fcd3a2e5c48a8 = 'SOFTWARE_ISSUE_STATUS';
const $ab3fc2ac1a2f2638$export$ebb7dcd60318cfac = 'SERVICEDESK_ISSUE_STATUS';
const $ab3fc2ac1a2f2638$export$a446d697df3d6b2c = 'SERVICEDESK_REQUEST_PANEL';
const $ab3fc2ac1a2f2638$export$d3dadb39db0c423 = 'SERVICEDESK_CREATE_COMMENT_ACTIONS';
const $ab3fc2ac1a2f2638$export$75867eab2abae162 = 'SERVICEDESK_PLACEHOLDER_CREATE_COMMENT_ACTIONS';
const $ab3fc2ac1a2f2638$export$483d9bcbbd8280a6 = 'status-spotlight';
const $ab3fc2ac1a2f2638$export$95f98990d7202b31 = 'SHOW_MORE';
const $ab3fc2ac1a2f2638$export$95ff4d03075475e2 = 'PIN_FIELD';
const $ab3fc2ac1a2f2638$export$256eddbefbf4b2ce = 'EDIT_FIELD';
const $ab3fc2ac1a2f2638$export$6f48b612d5c03f4d = 'PERMALINK';
const $ab3fc2ac1a2f2638$export$d84e7970e2d564af = 'BOARD_SIDEBAR';
const $ab3fc2ac1a2f2638$export$fa5ad81958817beb = 'issue-view-layout-templates-views.ui.context.visible-hidden.ui.context-group.container.details-group';
const $ab3fc2ac1a2f2638$export$1ba8bc5ff9e50d09 = 'QUICK_ADDS';
const $ab3fc2ac1a2f2638$export$f9baa44349b5d6b8 = 'JSW_ACTIVITY_FEED_BUTTONS';
const $ab3fc2ac1a2f2638$export$f49830a0e4ffb3f9 = 'issue-view-layout-templates-views.ui.context.visible-hidden.ui.context-group.container.sla-group';
const $ab3fc2ac1a2f2638$export$efb12103a5e32a1e = 'PIN_FIELD_PLACEHOLDER_BANNER';
const $ab3fc2ac1a2f2638$export$4288bce987c22af4 = 'PINNED_FIELDS_PANEL';

parcelRegister("4faf8", function(module, exports) {

$parcel$export(module.exports, "isForgeField", () => $45669342ae4293ea$export$f4484ef180517e0e);
$parcel$export(module.exports, "getForgeFieldType", () => $45669342ae4293ea$export$3f8bcfe7fea0362a);

var $6G5mG = parcelRequire("6G5mG");

var $ldoFd = parcelRequire("ldoFd");

var $lO4Or = parcelRequire("lO4Or");
const $45669342ae4293ea$export$f4484ef180517e0e = (field)=>field && (0, (/*@__PURE__*/$parcel$interopDefault($6G5mG)))(field, 'schema.custom') && !(0, (/*@__PURE__*/$parcel$interopDefault($ldoFd)))(field.schema.custom) && field.schema.custom.includes('ari:cloud:ecosystem::extension');
const $45669342ae4293ea$export$3f8bcfe7fea0362a = (field)=>{
    if (!$45669342ae4293ea$export$f4484ef180517e0e(field)) return null;
    if (false) return field.schema.type;
    return 0, $lO4Or.FORGE_CUSTOM_FIELD_TYPE;
};

});

parcelRegister("2Sajo", function(module, exports) {

$parcel$export(module.exports, "useForgeGlances", () => $dcae2a1bd36bdf24$export$dc79f3e7b8a6c3e1);
$parcel$export(module.exports, "useForgeContextPanels", () => $dcae2a1bd36bdf24$export$a1a589b738ca01b8);
$parcel$export(module.exports, "useForgeDataComplete", () => $dcae2a1bd36bdf24$export$db75d05b888b2963);
$parcel$export(module.exports, "useForgeCustomField", () => $dcae2a1bd36bdf24$export$2a006c08e9ab6fc3);
$parcel$export(module.exports, "useForgeActions", () => $dcae2a1bd36bdf24$export$4f3ebb446fd03f21);
$parcel$export(module.exports, "useForgeLoadingFailed", () => $dcae2a1bd36bdf24$export$25b2fc6a75c5447b);
$parcel$export(module.exports, "useForgeUimModules", () => $dcae2a1bd36bdf24$export$37d5ed3ba137e5df);
$parcel$export(module.exports, "useHasBlockedExtensions", () => $dcae2a1bd36bdf24$export$955dca49c49bfb60);
$parcel$export(module.exports, "useBlockedExtensions", () => $dcae2a1bd36bdf24$export$61349d0d8e89be3);
$parcel$export(module.exports, "useIsForgeDataEmpty", () => $dcae2a1bd36bdf24$export$57f2fa4b04feb8c2);

var $eUqFw = parcelRequire("eUqFw");

var $kFGm5 = parcelRequire("kFGm5");

var $ala54 = parcelRequire("ala54");

var $2W5Mi = parcelRequire("2W5Mi");
const $dcae2a1bd36bdf24$export$dc79f3e7b8a6c3e1 = ()=>{
    const [forge] = (0, $2W5Mi.useForgeStore)();
    return [
        forge.issueGlance
    ];
};
const $dcae2a1bd36bdf24$export$a1a589b738ca01b8 = ()=>{
    const [forge] = (0, $2W5Mi.useForgeStore)();
    return [
        forge.issueContext
    ];
};
const $dcae2a1bd36bdf24$export$db75d05b888b2963 = ()=>{
    const [forge] = (0, $2W5Mi.useForgeStore)();
    return [
        forge.isForgeDataComplete
    ];
};
const $dcae2a1bd36bdf24$export$1a3a35919478733d = ()=>{
    const [forge] = (0, $2W5Mi.useForgeStore)();
    return [
        [
            ...forge.customField,
            ...forge.customFieldType
        ]
    ];
};
const $dcae2a1bd36bdf24$export$2a006c08e9ab6fc3 = (extensionId)=>{
    const [customFieldExtensions] = $dcae2a1bd36bdf24$export$1a3a35919478733d();
    return (0, $ala54.useMemoizedStateObject)((0, $eUqFw.useMemo)(()=>customFieldExtensions.find((ext)=>ext.id === extensionId), [
        customFieldExtensions,
        extensionId
    ]));
};
const $dcae2a1bd36bdf24$export$4f3ebb446fd03f21 = ()=>{
    const [, actions] = (0, $2W5Mi.useForgeActionsStore)();
    return [
        undefined,
        actions
    ];
};
const $dcae2a1bd36bdf24$export$25b2fc6a75c5447b = ()=>{
    const [forge] = (0, $2W5Mi.useForgeStore)();
    return forge.isForgeLoadingFailed;
};
const $dcae2a1bd36bdf24$export$37d5ed3ba137e5df = ()=>{
    const [forge] = (0, $2W5Mi.useForgeStore)();
    return forge.uiModifications;
};
const $dcae2a1bd36bdf24$export$955dca49c49bfb60 = ()=>{
    const [forge] = (0, $2W5Mi.useForgeStore)();
    return (0, $eUqFw.useMemo)(()=>forge.blockedExtensions ? Object.values((0, (/*@__PURE__*/$parcel$interopDefault($kFGm5)))(forge.blockedExtensions, [
            'jiraIssueViewBackgroundScript',
            'jiraUiModifications'
        ])).some((blockedExtensions)=>blockedExtensions.length > 0) : false, [
        forge.blockedExtensions
    ]);
};
const $dcae2a1bd36bdf24$export$61349d0d8e89be3 = ()=>{
    const [forge] = (0, $2W5Mi.useForgeStore)();
    return forge.blockedExtensions;
};
const $dcae2a1bd36bdf24$export$57f2fa4b04feb8c2 = ()=>{
    const [forge] = (0, $2W5Mi.useForgeStore)();
    const isExtensionsEmpty = Object.keys(forge).every((key)=>// eslint-disable-next-line @typescript-eslint/consistent-type-assertions
        Array.isArray(forge[key]) ? // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
        forge[key].length === 0 : true);
    const isBlockedExtensionsEmpty = Object.keys(forge.blockedExtensions).every(// eslint-disable-next-line @typescript-eslint/consistent-type-assertions
    (key)=>forge.blockedExtensions[key].length === 0);
    return isExtensionsEmpty && isBlockedExtensionsEmpty;
};

});
parcelRegister("ala54", function(module, exports) {

$parcel$export(module.exports, "useMemoizedStateObject", () => $18a93586b800a37c$export$cc725e2aa41de44a);

var $eUqFw = parcelRequire("eUqFw");

var $hTLlD = parcelRequire("hTLlD");
const $18a93586b800a37c$export$cc725e2aa41de44a = (data, equalityCheck = (0, (/*@__PURE__*/$parcel$interopDefault($hTLlD))))=>{
    const memoizedData = (0, $eUqFw.useRef)(data);
    return (0, $eUqFw.useMemo)(()=>{
        if (!equalityCheck(data, memoizedData.current)) {
            memoizedData.current = data;
            return data;
        }
        return memoizedData.current;
    }, [
        data,
        equalityCheck
    ]);
};

});

parcelRegister("2W5Mi", function(module, exports) {

$parcel$export(module.exports, "useForgeStore", () => $f3300ca6503131e5$export$10f3118dc1498dfc);
$parcel$export(module.exports, "useForgeActionsStore", () => $f3300ca6503131e5$export$7dd6be1114d73937);
$parcel$export(module.exports, "ForceStoreContainer", () => $f3300ca6503131e5$export$540c057b33607be9);

var $96gVp = parcelRequire("96gVp");
var $1yZQx = parcelRequire("1yZQx");
var $kEDjj = parcelRequire("kEDjj");

var $eazmh = parcelRequire("eazmh");
const $f3300ca6503131e5$export$6f57813fe9f31bf9 = (0, $kEDjj.createStore)({
    name: 'issue-view-layout-forge-apps-service',
    initialState: {
        issueGlance: [],
        issueContext: [],
        issueAction: [],
        issuePanel: [],
        issueActivity: [],
        customField: [],
        issueViewBackgroundScript: [],
        customFieldType: [],
        activeAction: null,
        uiModifications: [],
        isForgeLoadingFailed: false,
        isForgeDataComplete: false,
        blockedExtensions: {
            issueGlance: [],
            issueContext: [],
            issueAction: [],
            issuePanel: [],
            issueActivity: [],
            customField: [],
            issueViewBackgroundScript: [],
            customFieldType: [],
            uiModifications: []
        },
        // Not rate limited
        forgeRateLimitedUntil: 0,
        failedEventsCount: 0
    },
    actions: $eazmh
});
const $f3300ca6503131e5$export$10f3118dc1498dfc = (0, $1yZQx.createHook)($f3300ca6503131e5$export$6f57813fe9f31bf9);
const $f3300ca6503131e5$export$7dd6be1114d73937 = (0, $1yZQx.createHook)($f3300ca6503131e5$export$6f57813fe9f31bf9, {
    selector: null
});
const $f3300ca6503131e5$export$540c057b33607be9 = (0, $96gVp.createContainer)($f3300ca6503131e5$export$6f57813fe9f31bf9);

});
parcelRegister("eazmh", function(module, exports) {

$parcel$export(module.exports, "setForge", () => $4b1f8e23931858cc$export$8307a9da1b91b3b4);
$parcel$export(module.exports, "setForgeLoadingFailed", () => $4b1f8e23931858cc$export$7ff580b28fd472d0);
$parcel$export(module.exports, "setFailedEventsCount", () => $4b1f8e23931858cc$export$2c9ac2591e62f664);
$parcel$export(module.exports, "isForgeRateLimited", () => $4b1f8e23931858cc$export$161809ef1d8417c5);

var $7wgLf = parcelRequire("7wgLf");
const $4b1f8e23931858cc$export$8307a9da1b91b3b4 = (forge)=>({ setState: setState })=>{
        setState(forge);
    };
const $4b1f8e23931858cc$export$7ff580b28fd472d0 = ()=>({ setState: setState })=>{
        setState({
            isForgeLoadingFailed: true
        });
    };
const $4b1f8e23931858cc$export$2c9ac2591e62f664 = (param)=>({ setState: setState, getState: getState })=>{
        if (typeof param === 'function') {
            const currentFailedEventsCount = getState().failedEventsCount;
            const result = param(currentFailedEventsCount);
            setState({
                failedEventsCount: result,
                forgeRateLimitedUntil: (0, $7wgLf.calculateRateLimitedUntil)(result)
            });
            return;
        }
        setState({
            failedEventsCount: param,
            forgeRateLimitedUntil: (0, $7wgLf.calculateRateLimitedUntil)(param)
        });
    };
const $4b1f8e23931858cc$export$161809ef1d8417c5 = ()=>({ getState: getState })=>{
        const state = getState();
        const throttleTime = state.forgeRateLimitedUntil - Date.now();
        return throttleTime > 0;
    };

});
parcelRegister("7wgLf", function(module, exports) {

$parcel$export(module.exports, "calculateRateLimitedUntil", () => $169737d2797a25da$export$d47414e51d623595);
/**
 * Defines the time gaps between retries in seconds for rate limited requests.
 * The first value is 0, because the first retry should be immediate.
 */ const $169737d2797a25da$export$565f18fa3aa433b0 = [
    0,
    3,
    8,
    21
];
function $169737d2797a25da$export$d47414e51d623595(failedEventsCount) {
    const currentDate = new Date();
    const gap = $169737d2797a25da$export$565f18fa3aa433b0[Math.min($169737d2797a25da$export$565f18fa3aa433b0.length - 1, failedEventsCount)];
    return gap ? new Date(currentDate.getTime() + gap * 1000).getTime() : 0;
}

});




const $fe92e572161b5748$export$6f3804b3f188f650 = 'FORGE_ENTITY_TYPE';

parcelRegister("g8to1", function(module, exports) {

$parcel$export(module.exports, "getPanels", () => $55eb035be1758949$export$be078297eeb6e8a2);
$parcel$export(module.exports, "isEmpty", () => $55eb035be1758949$export$dd1bc94b04021eeb);
$parcel$export(module.exports, "getAtlassianCustomFieldType", () => $55eb035be1758949$export$f521834fc2bfcd81);
$parcel$export(module.exports, "fieldTypeHandler", () => $55eb035be1758949$export$b2cc0ead6ce019e3);
$parcel$export(module.exports, "getFieldType", () => $55eb035be1758949$export$b9089a6e41ed43aa);
$parcel$export(module.exports, "isUnsupportedItem", () => $55eb035be1758949$export$3d38168d24278ebb);

var $1c8hB = parcelRequire("1c8hB");

var $ldoFd = parcelRequire("ldoFd");

var $jtsd5 = parcelRequire("jtsd5");

var $dfBCt = parcelRequire("dfBCt");

var $1ybV0 = parcelRequire("1ybV0");

var $bLiXo = parcelRequire("bLiXo");

var $4faf8 = parcelRequire("4faf8");

var $f9RL0 = parcelRequire("f9RL0");

var $dZWHl = parcelRequire("dZWHl");

var $lO4Or = parcelRequire("lO4Or");
const $55eb035be1758949$export$272b07e3e852ec4 = [
    (0, $f9RL0.DEV_SUMMARY),
    (0, $f9RL0.SLA_PANEL),
    (0, $f9RL0.KNOWLEDGE_BASE),
    (0, $f9RL0.ASSET_ONBOARDING),
    (0, $f9RL0.SENTIMENT)
];
const $55eb035be1758949$export$be078297eeb6e8a2 = ()=>[
        ...$55eb035be1758949$export$272b07e3e852ec4,
        (0, $f9RL0.LINKED_ALERTS),
        ...(0, $dfBCt.isFedRamp)() ? [] : [
            (0, $f9RL0.CHAT_CHANNEL)
        ],
        ...(0, $dfBCt.isFedRamp)() ? [] : [
            (0, $f9RL0.MSTEAMS_CHANNEL)
        ],
        ...(0, $dfBCt.isFedRamp)() ? [] : [
            (0, $f9RL0.ZOOM_MEETING)
        ],
        (0, $f9RL0.MANAGE_STAKEHOLDERS),
        ...(0, $1ybV0.ff)('hide-icc-for-all-users_avyh5') ? [] : [
            (0, $f9RL0.CONFERENCE_CALL)
        ]
    ];
const $55eb035be1758949$export$dd1bc94b04021eeb = (value)=>(0, (/*@__PURE__*/$parcel$interopDefault($ldoFd)))(value) || (0, (/*@__PURE__*/$parcel$interopDefault($1c8hB)))(value) && value.length === 0 || (0, (/*@__PURE__*/$parcel$interopDefault($jtsd5)))(value) && Object.keys(value).length === 0 || (0, (/*@__PURE__*/$parcel$interopDefault($jtsd5)))(value) && value.type === 'doc' && value.content && Object.keys(value.content).length === 0;
const $55eb035be1758949$var$atlassianSystemCFTypes = ()=>{
    const customSystemFields = (0, $f9RL0.specialFields)();
    return [
        ...(0, $f9RL0.customFieldsToDisplay)().filter((cf)=>!(0, $f9RL0.ecosystemCustomFields).includes(cf)),
        // @ts-expect-error - TS7053 - Element implicitly has an 'any' type because expression of type 'string' can't be used to index type 'SpecialFieldTypes'.
        ...Object.keys(customSystemFields).map((key)=>customSystemFields[key]),
        (0, $lO4Or.FLAGGED_CF_TYPE)
    ];
};
const $55eb035be1758949$export$f521834fc2bfcd81 = (custom)=>$55eb035be1758949$var$atlassianSystemCFTypes().find((type)=>type === custom);
const $55eb035be1758949$export$b2cc0ead6ce019e3 = (fieldConfig, layoutItem)=>{
    const id = (0, $dZWHl.getLayoutItemId)(layoutItem);
    const { type: type } = layoutItem;
    if (type === (0, $bLiXo.layoutContainerItemTypes).tab || type === (0, $lO4Or.ECOSYSTEM_GLANCE_TYPE) || type === (0, $lO4Or.FORGE_GLANCE_TYPE) || type === (0, $lO4Or.ECOSYSTEM_CONTEXT_TYPE) || type === (0, $bLiXo.FORGE_CONTEXT_TYPE)) return {
        type: type,
        id: id
    };
    if ($55eb035be1758949$export$be078297eeb6e8a2().includes(id)) return {
        id: id,
        type: id
    };
    const forgeCustomField = (0, $4faf8.getForgeFieldType)(fieldConfig);
    if (forgeCustomField !== null) return {
        type: forgeCustomField,
        id: id
    };
    const fieldSchema = fieldConfig?.schema || {};
    const systemType = fieldSchema.system !== null ? fieldSchema.system : '';
    return {
        type: $55eb035be1758949$export$f521834fc2bfcd81(fieldSchema.custom) || systemType || fieldSchema.type,
        id: id
    };
};
const $55eb035be1758949$export$b9089a6e41ed43aa = (field)=>{
    const fieldSchema = field ? field.schema : undefined;
    return fieldSchema ? $55eb035be1758949$export$f521834fc2bfcd81(fieldSchema.custom) || fieldSchema.system || fieldSchema.type : undefined;
};
// This typing exists to ensure that we include fields here when adding new ones.
const $55eb035be1758949$var$BASE_SUPPORTED_ITEMS = {
    // @ts-expect-error - TS2322 - Type '{ ecosystemGlance: boolean; forgeGlance: boolean; "com.pyxis.greenhopper.jira:gh-epic-status": true; "com.atlassian.jira.plugin.system.customfieldtypes:cascadingselect": true; assignee: true; ... 75 more ...; "com.pyxis.greenhopper.jira:gh-epic-label": true; }' is not assignable to type 'CheckFieldTypeDefinitions<CheckedLegacyFieldTypeDefinitions<boolean>, IgnoredFieldChecks<boolean>>'.
    [(0, $lO4Or.ECOSYSTEM_GLANCE_TYPE)]: true,
    [(0, $lO4Or.FORGE_GLANCE_TYPE)]: true,
    [(0, $bLiXo.FORGE_CONTEXT_TYPE)]: true,
    [(0, $lO4Or.ECOSYSTEM_CONTEXT_TYPE)]: true,
    [(0, $lO4Or.EPIC_STATUS_TYPE)]: true,
    [(0, $lO4Or.CASCADING_SELECT_CF_TYPE)]: true,
    [(0, $lO4Or.ASSIGNEE_TYPE)]: true,
    [(0, $lO4Or.REPORTER_TYPE)]: true,
    [(0, $lO4Or.DESCRIPTION_TYPE)]: true,
    [(0, $lO4Or.ENVIRONMENT_TYPE)]: true,
    [(0, $lO4Or.DUE_DATE_TYPE)]: true,
    [(0, $lO4Or.PRIORITY_TYPE)]: true,
    [(0, $lO4Or.LABELS_TYPE)]: true,
    [(0, $lO4Or.COMPONENTS_TYPE)]: true,
    [(0, $lO4Or.SPRINT_TYPE)]: true,
    [(0, $lO4Or.STORY_POINTS_TYPE)]: true,
    [(0, $lO4Or.EPIC_TYPE)]: true,
    [(0, $lO4Or.FIX_VERSIONS_TYPE)]: true,
    [(0, $lO4Or.AFFECTS_VERSIONS_TYPE)]: true,
    [(0, $lO4Or.TIME_TRACKING_TYPE)]: true,
    [(0, $lO4Or.TIME_ESTIMATE_TYPE)]: true,
    [(0, $lO4Or.LABELS_CF_TYPE)]: true,
    [(0, $lO4Or.TEXT_CF_TYPE)]: true,
    [(0, $lO4Or.MULTI_USER_CF_TYPE)]: true,
    [(0, $lO4Or.PARTICIPANTS_CF_TYPE)]: true,
    [(0, $lO4Or.URL_CF_TYPE)]: true,
    [(0, $lO4Or.NUMBER_CF_TYPE)]: true,
    [(0, $lO4Or.STORY_POINT_ESTIMATE_CF_TYPE)]: true,
    [(0, $lO4Or.SELECT_CF_TYPE)]: true,
    [(0, $lO4Or.MULTI_SELECT_CF_TYPE)]: true,
    [(0, $lO4Or.VERSION_CF_TYPE)]: true,
    [(0, $lO4Or.TEXT_AREA_CF_TYPE)]: true,
    [(0, $lO4Or.MULTI_VERSION_CF_TYPE)]: true,
    [(0, $lO4Or.DATE_CF_TYPE)]: true,
    [(0, $lO4Or.GROUP_CF_TYPE)]: true,
    [(0, $lO4Or.MULTI_GROUP_CF_TYPE)]: true,
    [(0, $lO4Or.USER_CF_TYPE)]: true,
    [(0, $lO4Or.PEOPLE_CF_TYPE)]: true,
    [(0, $lO4Or.MULTI_CHECKBOXES_CF_TYPE)]: true,
    [(0, $lO4Or.RADIO_BUTTONS_CF_TYPE)]: true,
    [(0, $lO4Or.DATETIME_CF_TYPE)]: true,
    [(0, $lO4Or.TEAMS_PLATFORM_CF_TYPE)]: true,
    [(0, $lO4Or.TEAM_CF_TYPE)]: true,
    [(0, $lO4Or.PARENT_CF_TYPE)]: true,
    [(0, $lO4Or.PARENT_FIELD_TYPE)]: true,
    [(0, $lO4Or.BASELINE_START_CF_TYPE)]: true,
    [(0, $lO4Or.BASELINE_END_CF_TYPE)]: true,
    [(0, $lO4Or.COLOR_CF_TYPE)]: true,
    [(0, $lO4Or.REQUEST_TYPE_CF_TYPE)]: true,
    [(0, $lO4Or.APPROVALS_CF_TYPE)]: true,
    [(0, $lO4Or.REQUEST_LANGUAGE_CF_TYPE)]: true,
    [(0, $lO4Or.REQUEST_PARTICIPANTS_CF_TYPE)]: true,
    [(0, $lO4Or.ORGANIZATIONS_CF_TYPE)]: true,
    [(0, $lO4Or.ISSUE_FIELD_NUMBER_CF_TYPE)]: true,
    [(0, $lO4Or.ISSUE_FIELD_STRING_CF_TYPE)]: true,
    [(0, $lO4Or.ISSUE_FIELD_SINGLE_SELECT_CF_TYPE)]: true,
    [(0, $lO4Or.ISSUE_FIELD_MULTI_SELECT_CF_TYPE)]: true,
    [(0, $lO4Or.ISSUE_FIELD_DATETIME_CF_TYPE)]: true,
    [(0, $lO4Or.ASSETS_CF_TYPE)]: true,
    [(0, $lO4Or.SERVICE_ENTITY_CF_TYPE)]: true,
    [(0, $lO4Or.APPROVERS_LIST_CF_TYPE)]: true,
    [(0, $lO4Or.CMDB_OBJECT_CF_TYPE)]: true,
    [(0, $lO4Or.REQUEST_FEEDBACK_CF_TYPE)]: true,
    [(0, $lO4Or.ISSUE_FIELD_USER_CF_TYPE)]: true,
    [(0, $lO4Or.ISSUE_FIELD_GROUPS_CF_TYPE)]: true,
    [(0, $lO4Or.ISSUE_FIELD_STRINGS_CF_TYPE)]: true,
    [(0, $lO4Or.READ_ONLY_CF_TYPE)]: true,
    [(0, $lO4Or.PROJECT_PICKER_CF_TYPE)]: true,
    [(0, $lO4Or.FORGE_CUSTOM_FIELD_TYPE)]: true,
    [(0, $lO4Or.KNOWLEDGE_BASE_TYPE)]: true,
    [(0, $lO4Or.SLA_PANEL_TYPE)]: true,
    [(0, $lO4Or.SENTIMENT_TYPE)]: true,
    [(0, $lO4Or.DEV_SUMMARY_TYPE)]: true,
    [(0, $lO4Or.RELEASES_TYPE)]: true,
    [(0, $lO4Or.ASSET_ONBOARDING_TYPE)]: true,
    [(0, $lO4Or.LINKED_ALERTS_TYPE)]: true,
    [(0, $lO4Or.CHAT_CHANNEL_TYPE)]: !false && !(0, $dfBCt.isFedRamp)(),
    [(0, $lO4Or.MSTEAMS_CHANNEL_TYPE)]: !false && !(0, $dfBCt.isFedRamp)(),
    [(0, $lO4Or.ZOOM_MEETING_TYPE)]: !false && !(0, $dfBCt.isFedRamp)(),
    [(0, $lO4Or.MANAGE_STAKEHOLDERS_TYPE)]: !false,
    // eslint-disable-next-line jira/ff/no-module-level-eval
    [(0, $lO4Or.CONFERENCE_CALL_TYPE)]: !false && !(0, $1ybV0.ff)('hide-icc-for-all-users_avyh5'),
    [(0, $lO4Or.RESPONDERS_CF_TYPE)]: true,
    [(0, $lO4Or.MAJOR_INCIDENT_CF_TYPE)]: true,
    [(0, $lO4Or.MESSAGE_EDIT_CF_TYPE)]: true,
    [(0, $lO4Or.MESSAGE_VIEW_CF_TYPE)]: true,
    [(0, $lO4Or.EPIC_NAME_TYPE)]: true,
    [(0, $lO4Or.CATEGORY_TYPE)]: true,
    [(0, $lO4Or.ENTITLEMENT_CF_TYPE)]: true,
    [(0, $lO4Or.SENTIMENT_CF_TYPE)]: true,
    [(0, $lO4Or.GOALS_CF_TYPE)]: true
};
const $55eb035be1758949$export$3d38168d24278ebb = (type)=>!$55eb035be1758949$var$BASE_SUPPORTED_ITEMS[type];

});
parcelRegister("dZWHl", function(module, exports) {

$parcel$export(module.exports, "getLayoutItemId", () => $b8d413cf2e7e532a$export$fec1c0749fa149f4);
$parcel$export(module.exports, "filterOutItemsWithProvidedIds", () => $b8d413cf2e7e532a$export$355607dae809ec65);

var $bLiXo = parcelRequire("bLiXo");
const $b8d413cf2e7e532a$export$fec1c0749fa149f4 = (layoutItem)=>{
    switch(layoutItem.type){
        case (0, $bLiXo.layoutContainerItemTypes).field:
            return layoutItem.fieldItemId;
        case (0, $bLiXo.layoutContainerItemTypes).panel:
            return layoutItem.panelItemId;
        case (0, $bLiXo.layoutContainerItemTypes).tab:
            return layoutItem.tabContainerId;
        default:
            return layoutItem.id;
    }
};
const $b8d413cf2e7e532a$export$355607dae809ec65 = (items, idsToBeFilteredOut)=>{
    const filteredOutIdsSet = new Set(idsToBeFilteredOut);
    return items// Filter out items with the provided Ids
    .filter((item)=>!filteredOutIdsSet.has($b8d413cf2e7e532a$export$fec1c0749fa149f4(item)))// Filter out items with the provided Ids nested in the container tab items
    .map((item)=>{
        if (item.type === (0, $bLiXo.layoutContainerItemTypes).tab && item.items?.nodes) return {
            ...item,
            items: {
                // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
                nodes: $b8d413cf2e7e532a$export$355607dae809ec65(item.items.nodes, idsToBeFilteredOut)
            }
        };
        return item;
    });
};

});


parcelRegister("guDlK", function(module, exports) {

$parcel$export(module.exports, "useProjectKey", () => $598d4d607d97d3ec$export$f87be37f8e8be65);
$parcel$export(module.exports, "useProjectContextActions", () => $598d4d607d97d3ec$export$bd73624ca941f105);
$parcel$export(module.exports, "useProjectType", () => $598d4d607d97d3ec$export$6de29d851c914935);
$parcel$export(module.exports, "useProjectContext", () => $598d4d607d97d3ec$export$8f31c2503e1efa93);
$parcel$export(module.exports, "useApplication", () => $598d4d607d97d3ec$export$aaf75bb403fe1fb5);
$parcel$export(module.exports, "useEdition", () => $598d4d607d97d3ec$export$d56c02945cf5a9e5);
$parcel$export(module.exports, "useIsSimplifiedProject", () => $598d4d607d97d3ec$export$524ef4f6102ed540);
$parcel$export(module.exports, "useIsClassicProject", () => $598d4d607d97d3ec$export$e2cf96f40a8867ce);
$parcel$export(module.exports, "useProjectId", () => $598d4d607d97d3ec$export$16d1475ed6c26568);
$parcel$export(module.exports, "useProjectStatus", () => $598d4d607d97d3ec$export$30f16f2782a4113b);
$parcel$export(module.exports, "useProjectConfiguration", () => $598d4d607d97d3ec$export$af19ad68b52fa1a6);
$parcel$export(module.exports, "useProjectIssueTypes", () => $598d4d607d97d3ec$export$80bef597b440cf71);

var $eUqFw = parcelRequire("eUqFw");

var $1ybV0 = parcelRequire("1ybV0");

var $3FyZ4 = parcelRequire("3FyZ4");

var $eIp1n = parcelRequire("eIp1n");
var $6WXNs = parcelRequire("6WXNs");
var $6vrw7 = parcelRequire("6vrw7");

var $gd0Sp = parcelRequire("gd0Sp");

var $lbuGg = parcelRequire("lbuGg");

var $9ZB9O = parcelRequire("9ZB9O");
const $598d4d607d97d3ec$export$f87be37f8e8be65 = (issueKey)=>(0, $6vrw7.toProjectKey)(issueKey.split('-')[0]);
const $598d4d607d97d3ec$export$bd73624ca941f105 = ()=>{
    const [, { setProjectContext: setProjectContext, mergeProjectProperty: mergeProjectProperty }] = (0, $lbuGg.useProjectContextActionStore)();
    const actions = (0, $eUqFw.useMemo)(()=>({
            setProjectContext: setProjectContext,
            mergeProjectProperty: mergeProjectProperty
        }), [
        setProjectContext,
        mergeProjectProperty
    ]);
    return [
        null,
        actions
    ];
};
const $598d4d607d97d3ec$export$6de29d851c914935 = (projectKey)=>{
    const [projectType] = (0, $lbuGg.useProjectContextProjectTypeStore)({
        projectKey: projectKey
    });
    return projectType;
};
const $598d4d607d97d3ec$export$8f31c2503e1efa93 = (projectKey)=>{
    const [projectContext] = (0, $lbuGg.useProjectContextStore)({
        projectKey: projectKey
    });
    return projectContext;
};
const $598d4d607d97d3ec$export$aaf75bb403fe1fb5 = (projectKey, failSafely = false)=>{
    const projectType = $598d4d607d97d3ec$export$6de29d851c914935(projectKey);
    if (projectType === undefined) {
        if ((0, $1ybV0.ff)('ken-432-missing-project-key-log_hr7zv')) (0, $3FyZ4.getAnalyticsWebClientPromise)().then((client)=>{
            client.getInstance().sendTrackEvent({
                action: 'project-type-investigation',
                attributes: {
                    message: 'projectType was missing inside the hook'
                },
                actionSubject: 'project-context',
                source: 'project-context-service'
            });
        });
        if (failSafely) return undefined;
        throw new Error(`No project type for project key ${projectKey} in Project Context Service`);
    }
    return (0, $eIp1n.getApplicationForProject)(projectType);
};
const $598d4d607d97d3ec$export$d56c02945cf5a9e5 = (projectKey, failSafely = false)=>{
    const { appEditions: appEditions } = (0, $gd0Sp.useTenantContext)();
    const application = $598d4d607d97d3ec$export$aaf75bb403fe1fb5(projectKey, failSafely);
    if (!application) return undefined;
    return (0, $6WXNs.getEdition)(application, appEditions);
};
const $598d4d607d97d3ec$export$524ef4f6102ed540 = (projectKey)=>{
    const [projectContext] = (0, $lbuGg.useProjectContextStore)({
        projectKey: projectKey
    });
    return projectContext?.isSimplified || false;
};
const $598d4d607d97d3ec$export$e2cf96f40a8867ce = (projectKey)=>{
    const [projectContext] = (0, $lbuGg.useProjectContextStore)({
        projectKey: projectKey
    });
    return !projectContext?.isSimplified;
};
const $598d4d607d97d3ec$export$16d1475ed6c26568 = (projectKey)=>{
    const [projectContext] = (0, $lbuGg.useProjectContextStore)({
        projectKey: projectKey
    });
    return projectContext?.projectId;
};
const $598d4d607d97d3ec$export$30f16f2782a4113b = (projectKey)=>{
    const [projectContext] = (0, $lbuGg.useProjectContextStore)({
        projectKey: projectKey
    });
    return projectContext?.projectStatus;
};
const $598d4d607d97d3ec$export$af19ad68b52fa1a6 = (projectKey)=>{
    const projectType = $598d4d607d97d3ec$export$6de29d851c914935(projectKey);
    const isSimplified = $598d4d607d97d3ec$export$524ef4f6102ed540(projectKey);
    return (0, $9ZB9O.getIssueConfiguration)({
        isSimplified: isSimplified,
        projectType: projectType
    });
};
const $598d4d607d97d3ec$export$654dd2c557853fbe = (projectKey)=>{
    const [projectName] = (0, $lbuGg.useProjectContextProjectNameStore)({
        projectKey: projectKey
    });
    return projectName;
};
const $598d4d607d97d3ec$export$80bef597b440cf71 = (projectKey)=>{
    const [issueTypes] = (0, $lbuGg.useProjectContextIssueTypesStore)({
        projectKey: projectKey
    });
    return issueTypes;
};

});
parcelRegister("lbuGg", function(module, exports) {

$parcel$export(module.exports, "useProjectContextActionStore", () => $4715ac6bc4ce2fb7$export$9afb89c1fe103bbe);
$parcel$export(module.exports, "useProjectContextStore", () => $4715ac6bc4ce2fb7$export$8b09478b33186ec);
$parcel$export(module.exports, "useProjectContextProjectTypeStore", () => $4715ac6bc4ce2fb7$export$f2e1ed3b2b4707cb);
$parcel$export(module.exports, "useProjectContextProjectNameStore", () => $4715ac6bc4ce2fb7$export$9469fde70658518);
$parcel$export(module.exports, "useProjectContextIssueTypesStore", () => $4715ac6bc4ce2fb7$export$f73e9904779f6be5);

var $1yZQx = parcelRequire("1yZQx");
var $kEDjj = parcelRequire("kEDjj");

var $bAXOf = parcelRequire("bAXOf");
// eslint-disable-next-line @typescript-eslint/no-explicit-any
const $4715ac6bc4ce2fb7$var$initialState = {};
const $4715ac6bc4ce2fb7$export$6f57813fe9f31bf9 = (0, $kEDjj.createStore)({
    name: 'project-context',
    initialState: $4715ac6bc4ce2fb7$var$initialState,
    actions: $bAXOf
});
const $4715ac6bc4ce2fb7$export$9afb89c1fe103bbe = (0, $1yZQx.createHook)($4715ac6bc4ce2fb7$export$6f57813fe9f31bf9, {
    selector: null
});
const $4715ac6bc4ce2fb7$var$getProjectContext = (state, { projectKey: projectKey })=>state[projectKey];
const $4715ac6bc4ce2fb7$export$8b09478b33186ec = (0, $1yZQx.createHook)($4715ac6bc4ce2fb7$export$6f57813fe9f31bf9, {
    selector: $4715ac6bc4ce2fb7$var$getProjectContext
});
const $4715ac6bc4ce2fb7$var$getProjectType = (state, { projectKey: projectKey })=>{
    const projectContext = $4715ac6bc4ce2fb7$var$getProjectContext(state, {
        projectKey: projectKey
    });
    return projectContext?.projectType;
};
const $4715ac6bc4ce2fb7$export$f2e1ed3b2b4707cb = (0, $1yZQx.createHook)($4715ac6bc4ce2fb7$export$6f57813fe9f31bf9, {
    selector: $4715ac6bc4ce2fb7$var$getProjectType
});
const $4715ac6bc4ce2fb7$var$getProjectName = (state, { projectKey: projectKey })=>{
    const projectContext = $4715ac6bc4ce2fb7$var$getProjectContext(state, {
        projectKey: projectKey
    });
    return projectContext?.projectName;
};
const $4715ac6bc4ce2fb7$export$9469fde70658518 = (0, $1yZQx.createHook)($4715ac6bc4ce2fb7$export$6f57813fe9f31bf9, {
    selector: $4715ac6bc4ce2fb7$var$getProjectName
});
const $4715ac6bc4ce2fb7$var$getIssueTypes = (state, { projectKey: projectKey })=>{
    const projectContext = $4715ac6bc4ce2fb7$var$getProjectContext(state, {
        projectKey: projectKey
    });
    return projectContext?.issueTypes;
};
const $4715ac6bc4ce2fb7$export$f73e9904779f6be5 = (0, $1yZQx.createHook)($4715ac6bc4ce2fb7$export$6f57813fe9f31bf9, {
    selector: $4715ac6bc4ce2fb7$var$getIssueTypes
});

});
parcelRegister("bAXOf", function(module, exports) {

$parcel$export(module.exports, "setProjectContext", () => $f8fc64b164fe014a$export$d64151aab9ae5f09);
$parcel$export(module.exports, "mergeProjectProperty", () => $f8fc64b164fe014a$export$78f1c6052937615f);
const $f8fc64b164fe014a$export$d64151aab9ae5f09 = (key, projectContext)=>({ setState: setState })=>{
        // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
        setState({
            [key]: projectContext
        });
    };
const $f8fc64b164fe014a$export$78f1c6052937615f = (key, projectContext)=>({ setState: setState, getState: getState })=>{
        const currentState = getState();
        const currentProjectContext = currentState[key];
        const newProjectContext = {
            ...currentProjectContext,
            ...projectContext
        };
        // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
        setState({
            [key]: newProjectContext
        });
    };

});


parcelRegister("9ZB9O", function(module, exports) {

$parcel$export(module.exports, "getIssueConfiguration", () => $78bf57e6f575c3aa$export$902f6c5cc939598a);

var $2wUFy = parcelRequire("2wUFy");

var $7ZZxN = parcelRequire("7ZZxN");
const $78bf57e6f575c3aa$export$cdbd1eb3b05729e0 = 'flagActions';
const $78bf57e6f575c3aa$export$c161a774ec2e7e56 = 'cardCoverActions';
const $78bf57e6f575c3aa$export$a52507e68e7aeeb = ()=>({
        issueActions: []
    });
const $78bf57e6f575c3aa$export$381ce08838c53afa = ()=>({
        applicationKey: (0, $2wUFy.default).CORE_ISSUE,
        issueActions: [],
        ecosystemEnabled: true
    });
const $78bf57e6f575c3aa$export$27e0678365e5dcff = ()=>({
        applicationKey: (0, $2wUFy.default).SOFTWARE_ISSUE,
        issueActions: [
            $78bf57e6f575c3aa$export$cdbd1eb3b05729e0
        ],
        ecosystemEnabled: true
    });
const $78bf57e6f575c3aa$export$aebf676dfa727a1c = ()=>({
        applicationKey: (0, $2wUFy.default).SIMPLE_SOFTWARE_BOARD,
        issueActions: [
            $78bf57e6f575c3aa$export$cdbd1eb3b05729e0,
            $78bf57e6f575c3aa$export$c161a774ec2e7e56
        ],
        ecosystemEnabled: true
    });
const $78bf57e6f575c3aa$export$1afca4d3eb6b218b = ()=>({
        applicationKey: (0, $2wUFy.default).STANDARD_ROADMAP_ISSUE,
        issueActions: [
            $78bf57e6f575c3aa$export$cdbd1eb3b05729e0
        ],
        ecosystemEnabled: true
    });
const $78bf57e6f575c3aa$export$8a060ed6f66c43b0 = ()=>({
        applicationKey: (0, $2wUFy.default).BITBUCKET_ISSUE,
        issueActions: []
    });
const $78bf57e6f575c3aa$export$78a2cb921e46f5eb = ()=>({
        applicationKey: (0, $2wUFy.default).MOBILE_ISSUE,
        issueActions: []
    });
const $78bf57e6f575c3aa$export$db1115186532f6d5 = ()=>({
        applicationKey: (0, $2wUFy.default).SERVICE_DESK,
        issueActions: [],
        ecosystemEnabled: true
    });
const $78bf57e6f575c3aa$export$902f6c5cc939598a = (config)=>{
    if (config) switch(config.projectType){
        case 0, $7ZZxN.SOFTWARE_PROJECT:
            if (config.isSimplified) return $78bf57e6f575c3aa$export$aebf676dfa727a1c();
            return $78bf57e6f575c3aa$export$27e0678365e5dcff();
        case 0, $7ZZxN.CORE_PROJECT:
            return $78bf57e6f575c3aa$export$381ce08838c53afa();
        case 0, $7ZZxN.SERVICE_DESK_PROJECT:
            return $78bf57e6f575c3aa$export$db1115186532f6d5();
        default:
            // fallback to sofware config
            return $78bf57e6f575c3aa$export$27e0678365e5dcff();
    }
    return $78bf57e6f575c3aa$export$27e0678365e5dcff();
};

});


parcelRegister("5YYzL", function(module, exports) {

$parcel$export(module.exports, "useProjectPermissions", () => $bc17d6d67083dab8$export$c6c6b35628cf47a8);
$parcel$export(module.exports, "useCanAdministerProject", () => $bc17d6d67083dab8$export$f39ed5a161efa614);
$parcel$export(module.exports, "useCanAdministerJira", () => $bc17d6d67083dab8$export$ec12ddafd19b95ac);
$parcel$export(module.exports, "useCanConfigureIssue", () => $bc17d6d67083dab8$export$e7267b8a084eadb3);
$parcel$export(module.exports, "useCanUseServiceDeskAgentFeatures", () => $bc17d6d67083dab8$export$756d7c97077a2f76);
$parcel$export(module.exports, "useProjectPermissionsActions", () => $bc17d6d67083dab8$export$86c656cdb87052cd);

var $eUqFw = parcelRequire("eUqFw");

var $gd0Sp = parcelRequire("gd0Sp");

var $anOKD = parcelRequire("anOKD");
const $bc17d6d67083dab8$export$c6c6b35628cf47a8 = (projectKey)=>{
    const [permissions, { setProjectPermissions: setProjectPermissions }] = (0, $anOKD.useProjectPermissionsStore)({
        projectKey: projectKey
    });
    const actions = (0, $eUqFw.useMemo)(()=>({
            setProjectPermissions: setProjectPermissions
        }), [
        setProjectPermissions
    ]);
    return [
        permissions,
        actions
    ];
};
const $bc17d6d67083dab8$export$f39ed5a161efa614 = (projectKey)=>{
    const [permissions] = (0, $anOKD.useProjectPermissionsStore)({
        projectKey: projectKey
    });
    return permissions.canAdministerProject;
};
const $bc17d6d67083dab8$export$ec12ddafd19b95ac = (projectKey)=>{
    const [permissions] = (0, $anOKD.useProjectPermissionsStore)({
        projectKey: projectKey
    });
    return permissions.canAdministerJira;
};
const $bc17d6d67083dab8$export$e7267b8a084eadb3 = (projectKey)=>{
    const canConfigureAdministerProject = $bc17d6d67083dab8$export$f39ed5a161efa614(projectKey);
    const canAdministerJira = $bc17d6d67083dab8$export$ec12ddafd19b95ac(projectKey);
    return canConfigureAdministerProject || canAdministerJira;
};
const $bc17d6d67083dab8$export$756d7c97077a2f76 = (projectKey)=>{
    const [permissions] = (0, $anOKD.useProjectPermissionsStore)({
        projectKey: projectKey
    });
    const { appPermissions: appPermissions } = (0, $gd0Sp.useTenantContext)();
    return permissions.canUseServiceDeskAgentFeatures && appPermissions?.hasServiceDeskAccess;
};
const $bc17d6d67083dab8$export$86c656cdb87052cd = ()=>{
    const [, { setProjectPermissions: setProjectPermissions }] = (0, $anOKD.useProjectPermissionsStoreActions)();
    const actions = (0, $eUqFw.useMemo)(()=>({
            setProjectPermissions: setProjectPermissions
        }), [
        setProjectPermissions
    ]);
    return [
        null,
        actions
    ];
};

});
parcelRegister("anOKD", function(module, exports) {

$parcel$export(module.exports, "defaultPermissions", () => $777dfd95ecbd2e05$export$ccfee65526b322ca);
$parcel$export(module.exports, "useProjectPermissionsStore", () => $777dfd95ecbd2e05$export$4919fa09a3d81224);
$parcel$export(module.exports, "useProjectPermissionsStoreActions", () => $777dfd95ecbd2e05$export$e8436ef485b33bdb);

var $1yZQx = parcelRequire("1yZQx");
var $kEDjj = parcelRequire("kEDjj");

var $1TYLm = parcelRequire("1TYLm");
const $777dfd95ecbd2e05$export$ccfee65526b322ca = {
    canAddComments: false,
    canAdministerJira: false,
    canAdministerProject: false,
    canAssignIssues: false,
    canBeAssignedToIssues: false,
    canCloneIssue: false,
    canCreateAttachments: false,
    canCreateChildren: false,
    canCreateSubtask: false,
    canDeleteAllAttachments: false,
    canDeleteAllComments: false,
    canDeleteAllWorklogs: false,
    canDeleteIssue: false,
    canDeleteOwnAttachments: false,
    canDeleteOwnComments: false,
    canDeleteOwnWorklogs: false,
    canEditAllComments: false,
    canEditAllWorklogs: false,
    canEditIssues: false,
    canEditOwnComments: false,
    canEditOwnWorklogs: false,
    canLinkIssues: false,
    canLogWork: false,
    canManageWatchers: false,
    canMoveIssue: false,
    canModifyReporter: false,
    canScheduleIssues: false,
    canUseServiceDeskAgentFeatures: false,
    canBrowseUsers: false,
    canViewDevTools: false,
    canViewWatchers: false,
    canViewVoters: false,
    canCreateIssuesInClassicProjectEpic: false,
    canResolveIssues: false,
    canExportIssue: false,
    canArchiveIssue: false,
    canUnarchiveIssue: false
};
const $777dfd95ecbd2e05$export$6f57813fe9f31bf9 = (0, $kEDjj.createStore)({
    name: 'project-permissions',
    initialState: {},
    actions: $1TYLm
});
const $777dfd95ecbd2e05$var$getProjectPermissionSelector = (state, { projectKey: projectKey })=>state[projectKey] || $777dfd95ecbd2e05$export$ccfee65526b322ca;
const $777dfd95ecbd2e05$export$4919fa09a3d81224 = (0, $1yZQx.createHook)($777dfd95ecbd2e05$export$6f57813fe9f31bf9, {
    selector: $777dfd95ecbd2e05$var$getProjectPermissionSelector
});
const $777dfd95ecbd2e05$export$e8436ef485b33bdb = (0, $1yZQx.createHook)($777dfd95ecbd2e05$export$6f57813fe9f31bf9, {
    selector: null
});

});
parcelRegister("1TYLm", function(module, exports) {

$parcel$export(module.exports, "setProjectPermissions", () => $54a1a48853cdbc94$export$53f5cc27627e5fe3);
const $54a1a48853cdbc94$export$53f5cc27627e5fe3 = (projectKey, permissions)=>({ setState: setState })=>{
        setState({
            // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
            [projectKey]: permissions
        });
    };

});




parcelRegister("8CSFK", function(module, exports) {

$parcel$export(module.exports, "ecosystemBackgroundScriptsSelector", () => $ed8f699fce32689f$export$4bf619a76f77f026);
$parcel$export(module.exports, "issueViewBackgroundScriptsSelector", () => $ed8f699fce32689f$export$eef935056c1a5112);
$parcel$export(module.exports, "issueContentPanelsSelector", () => $ed8f699fce32689f$export$80fcdb58a34c02a8);
$parcel$export(module.exports, "isIssueContentPanelCustomisedSelector", () => $ed8f699fce32689f$export$7d77b0f1f3d84166);
$parcel$export(module.exports, "canInstallAddonsSelector", () => $ed8f699fce32689f$export$779e1275bbd7ba59);
$parcel$export(module.exports, "isIssueCreatedAfterEcosystemOnSelector", () => $ed8f699fce32689f$export$528e2c054f1a65f6);
$parcel$export(module.exports, "contextPanelEntitiesSelector", () => $ed8f699fce32689f$export$830512515d42357);
$parcel$export(module.exports, "glancesSelector", () => $ed8f699fce32689f$export$d73d3447fc053be);
$parcel$export(module.exports, "ecosystemGlancesSelector", () => $ed8f699fce32689f$export$df7140249f849373);
$parcel$export(module.exports, "glancePanelSelector", () => $ed8f699fce32689f$export$e8938da368c7c5c4);
$parcel$export(module.exports, "allContentPanelsSelector", () => $ed8f699fce32689f$export$7bc028a03185fc96);
$parcel$export(module.exports, "ecosystemAllPanelsSelector", () => $ed8f699fce32689f$export$47d3fa7df862ae6f);
$parcel$export(module.exports, "ecosystemAddedContentPanelsSelector", () => $ed8f699fce32689f$export$a48c28ad36cb708e);
$parcel$export(module.exports, "selectedContentPanelSelector", () => $ed8f699fce32689f$export$1a9c93efcb1ffec7);
$parcel$export(module.exports, "operationsSelector", () => $ed8f699fce32689f$export$5244c0030b3a418e);
$parcel$export(module.exports, "ecosystemOperationsSelector", () => $ed8f699fce32689f$export$5d88ae12b2751fc1);
$parcel$export(module.exports, "activityPanelsSelector", () => $ed8f699fce32689f$export$dd6c9850f9e61a72);
$parcel$export(module.exports, "ecosystemActivityPanelsSelector", () => $ed8f699fce32689f$export$9222e43f5478367f);

var $df4Sl = parcelRequire("df4Sl");

var $6ZDS2 = parcelRequire("6ZDS2");

var $gdPSX = parcelRequire("gdPSX");

var $7C4za = parcelRequire("7C4za");

var $fkvsU = parcelRequire("fkvsU");

var $duMa0 = parcelRequire("duMa0");

var $5JqpU = parcelRequire("5JqpU");

var $jZDJX = parcelRequire("jZDJX");

var $9F6MO = parcelRequire("9F6MO");


var $9Hrk7 = parcelRequire("9Hrk7");

var $8QKSg = parcelRequire("8QKSg");
const $ed8f699fce32689f$export$4bf619a76f77f026 = (0, $df4Sl.createSelector)((0, $9Hrk7.ecosystemEntitiesSelector), (ecosystem)=>ecosystem.backgroundScripts || []);
const $ed8f699fce32689f$export$eef935056c1a5112 = (0, $df4Sl.createSelector)((0, $9Hrk7.forgeEntitiesSelector), (forge)=>forge.backgroundScripts || []);
const $ed8f699fce32689f$export$80fcdb58a34c02a8 = (0, $df4Sl.createSelector)((0, $jZDJX.entitiesSelector), (entities)=>entities.issueContentPanels || []);
const $ed8f699fce32689f$export$7d77b0f1f3d84166 = (0, $df4Sl.createSelector)((0, $jZDJX.entitiesSelector), (entities)=>!!entities.issueContentPanels && entities.issueContentPanels.includes((0, $6c91ecd17276581e$export$bdafa6b589be8b30)));
const $ed8f699fce32689f$export$779e1275bbd7ba59 = (0, $df4Sl.createSelector)((0, $9F6MO.canAdministerJiraPermissionsSelector), (canAdministerJira)=>canAdministerJira);
const $ed8f699fce32689f$export$528e2c054f1a65f6 = (0, $df4Sl.createSelector)((0, $jZDJX.entitiesSelector), (entities)=>entities.ecosystem && !!entities.ecosystem.ecosystemOnDate && // @ts-expect-error - TS2345 - Argument of type 'AuthoredTimestamp | undefined' is not assignable to parameter of type 'string'.
    Date.parse(entities.createdDate) > entities.ecosystem.ecosystemOnDate);
const $ed8f699fce32689f$var$extractSecondLevelDeepValuesFromObject = (obj)=>Object.keys(obj || {}).flatMap((key)=>Object.values(obj ? obj[key] : {}));
const $ed8f699fce32689f$var$glanceEntitiesSelector = (0, $df4Sl.createSelector)((0, $9Hrk7.ecosystemEntitiesSelector), (ecosystem)=>$ed8f699fce32689f$var$extractSecondLevelDeepValuesFromObject(ecosystem.glances || {}));
const $ed8f699fce32689f$export$830512515d42357 = (0, $df4Sl.createSelector)((0, $9Hrk7.ecosystemEntitiesSelector), (ecosystem)=>$ed8f699fce32689f$var$extractSecondLevelDeepValuesFromObject(ecosystem.contextPanels));
const $ed8f699fce32689f$var$contentPanelsEntitiesSelector = (0, $df4Sl.createSelector)((0, $9Hrk7.ecosystemEntitiesSelector), (ecosystem)=>$ed8f699fce32689f$var$extractSecondLevelDeepValuesFromObject(ecosystem.contentPanels));
const $ed8f699fce32689f$var$activityPanelsEntitiesSelector = (0, $df4Sl.createSelector)((0, $9Hrk7.ecosystemEntitiesSelector), (ecosystem)=>$ed8f699fce32689f$var$extractSecondLevelDeepValuesFromObject(ecosystem.activityPanels));
const $ed8f699fce32689f$export$7fec16e3d5cd5f4e = (selector)=>(0, $df4Sl.createSelector)((0, $5JqpU.isEcosystemEnabledSelector), selector, // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
    (ecosystemEnabled, otherSelector)=>ecosystemEnabled && otherSelector || []);
const $ed8f699fce32689f$export$d73d3447fc053be = $ed8f699fce32689f$export$7fec16e3d5cd5f4e((0, $df4Sl.createSelector)($ed8f699fce32689f$var$glanceEntitiesSelector, (glanceEntities)=>glanceEntities.map((entity)=>({
            appKey: entity.appKey,
            moduleKey: entity.moduleKey,
            name: entity.name,
            icon: entity.icon && entity.icon.url && {
                url: entity.icon.url
            },
            label: entity.label,
            status: entity.status,
            type: entity.type,
            glanceType: (0, $fkvsU.CONNECT_ENTITY_TYPE)
        }))));
const $ed8f699fce32689f$export$df7140249f849373 = (0, $df4Sl.createSelector)([
    (0, $8QKSg.forgeGlancesSelector),
    $ed8f699fce32689f$export$d73d3447fc053be
], (forge, connect)=>[
        ...forge,
        ...connect
    ]);
const $ed8f699fce32689f$export$e8938da368c7c5c4 = (appKey, moduleKey)=>(0, $df4Sl.createSelector)((0, $9Hrk7.ecosystemEntitiesSelector), (ecosystem)=>ecosystem && ecosystem.glances && ecosystem.glances[appKey] && ecosystem.glances[appKey][moduleKey]);
const $ed8f699fce32689f$export$7bc028a03185fc96 = $ed8f699fce32689f$export$7fec16e3d5cd5f4e((0, $df4Sl.createSelector)($ed8f699fce32689f$var$contentPanelsEntitiesSelector, (contentPanelEntities)=>contentPanelEntities));
const $ed8f699fce32689f$export$47d3fa7df862ae6f = (0, $df4Sl.createSelector)([
    (0, $8QKSg.forgePanelsSelector),
    $ed8f699fce32689f$export$7bc028a03185fc96
], (forge, connect)=>[
        ...forge,
        ...connect
    ]);
const $ed8f699fce32689f$var$panelsComparator = (firstPanel, secondPanel)=>{
    // The sort order rule:
    // 1. Forge panels without quick add button (no dateAdded prop)
    // 2. Forge panels sorted by date added (oldest > newest)
    // 3. Connect panels, sorting criteria won't be changed
    if (firstPanel.type === (0, $fkvsU.FORGE_ENTITY_TYPE)) {
        // @ts-expect-error - TS2339 - Property 'dateAdded' does not exist on type 'AddedPanel'.
        const firstValue = firstPanel.dateAdded || 1;
        if (secondPanel.type === (0, $fkvsU.FORGE_ENTITY_TYPE)) {
            // @ts-expect-error - TS2339 - Property 'dateAdded' does not exist on type 'AddedPanel'.
            const secondValue = secondPanel.dateAdded || 1;
            return firstValue - secondValue;
        }
        return firstValue;
    }
    return Infinity;
};
const $ed8f699fce32689f$var$sortPanels = (allPanelsToAddedPanels)=>allPanelsToAddedPanels// @ts-expect-error - TS2769 - No overload matches this call.
    .map((panel)=>[].concat(panel)).sort((firstPanel, secondPanel)=>$ed8f699fce32689f$var$panelsComparator(firstPanel[0], secondPanel[0]));
const $ed8f699fce32689f$export$b2c15e41218fc96 = (firstActivity, secondActivity)=>{
    // The sort order rule:
    // 1. Forge activity ordered alphabetically.
    // 2. Connect panels, sorting criteria won't be changed
    if (firstActivity.type === (0, $fkvsU.FORGE_ENTITY_TYPE)) {
        const firstValue = firstActivity.name.toLowerCase();
        if (secondActivity.type === (0, $fkvsU.FORGE_ENTITY_TYPE)) {
            const secondValue = secondActivity.name.toLowerCase();
            if (firstValue < secondValue) return -Infinity;
            if (firstValue > secondValue) return Infinity;
            return 0;
        }
        return Infinity;
    }
    return Infinity;
};
const $ed8f699fce32689f$export$a48c28ad36cb708e = $ed8f699fce32689f$export$7fec16e3d5cd5f4e((0, $df4Sl.createSelector)($ed8f699fce32689f$export$80fcdb58a34c02a8, $ed8f699fce32689f$export$47d3fa7df862ae6f, $ed8f699fce32689f$export$7d77b0f1f3d84166, $ed8f699fce32689f$export$528e2c054f1a65f6, (0, $5JqpU.analyticsSourceSelector), (selectedPanels, allPanels, customised, newIssue, analyticsSource)=>{
    const allPanelsToAddedPanels = allPanels.map((panel)=>{
        // Forge-defined panels
        if (panel.type === (0, $fkvsU.FORGE_ENTITY_TYPE)) {
            // eslint-disable-next-line @typescript-eslint/consistent-type-assertions, @typescript-eslint/no-explicit-any
            const forgePanel = panel;
            // For a transition period we always render panels without a quick add button
            if (!forgePanel.iconUrl) return forgePanel;
            const prefix = `${forgePanel.appKey}/${forgePanel.moduleKey}-`;
            const filteredSelectedPanels = selectedPanels.filter((sPanel)=>(0, $7C4za.isKeyMatchPrefix)(sPanel, prefix)).map((sPanel)=>{
                const panelProperties = (0, $duMa0.parseForgeIssuePanel)(sPanel);
                if (panelProperties == null) (0, $gdPSX.fireOperationalFailedEvent)(analyticsSource, {
                    error: Error(`Panel key doesn't match regexp: ${sPanel}`)
                });
                return panelProperties && {
                    ...forgePanel,
                    dateAdded: panelProperties.added,
                    panelInstanceId: panelProperties.id
                };
            }).filter(Boolean);
            return filteredSelectedPanels.length > 0 && filteredSelectedPanels;
        }
        // Connect-defined panels
        if (!customised && !newIssue) return panel;
        const isSelected = selectedPanels.includes(`${panel.appKey}_${panel.moduleKey}`) || // BENTO-2491 SelectedPanels could be saved using keys without tailing digits
        selectedPanels.includes(`${panel.appKey}_${(0, $duMa0.removeTimestamp)(panel.moduleKey, 10)}`) || panel.showByDefault;
        return isSelected && panel;
    });
    const addedPanels = (0, (/*@__PURE__*/$parcel$interopDefault($6ZDS2)))($ed8f699fce32689f$var$sortPanels(allPanelsToAddedPanels.filter(Boolean)));
    return addedPanels;
}));
const $ed8f699fce32689f$export$9f3aeb87662f360b = (appKey, moduleKey)=>(0, $df4Sl.createSelector)((0, $9Hrk7.ecosystemEntitiesSelector), (ecosystem)=>ecosystem && ecosystem.contentPanels && ecosystem.contentPanels[appKey] && ecosystem.contentPanels[appKey][moduleKey]);
const $ed8f699fce32689f$export$1a9c93efcb1ffec7 = (appKey, moduleKey)=>(0, $df4Sl.createSelector)((0, $9Hrk7.ecosystemEntitiesSelector), (ecosystem)=>Boolean(ecosystem && ecosystem.selectedContentPanel && (ecosystem.selectedContentPanel === `${appKey}_${moduleKey}` || ecosystem.selectedContentPanel === `${appKey}_${(0, $duMa0.removeTimestamp)(moduleKey, 10)}`)));
const $ed8f699fce32689f$export$5244c0030b3a418e = $ed8f699fce32689f$export$7fec16e3d5cd5f4e((0, $df4Sl.createSelector)((0, $9Hrk7.ecosystemEntitiesSelector), (ecosystem)=>ecosystem.operations || []));
const $ed8f699fce32689f$export$5d88ae12b2751fc1 = $ed8f699fce32689f$export$7fec16e3d5cd5f4e((0, $df4Sl.createSelector)([
    (0, $8QKSg.forgeIssueActionsSelector),
    $ed8f699fce32689f$export$5244c0030b3a418e
], (forge, connect)=>[
        ...forge,
        ...connect
    ]));
const $ed8f699fce32689f$export$dd6c9850f9e61a72 = (0, $df4Sl.createSelector)((0, $5JqpU.isEcosystemEnabledSelector), $ed8f699fce32689f$var$activityPanelsEntitiesSelector, (isEcosystemEnabled, activityPanelEntities)=>isEcosystemEnabled ? activityPanelEntities.map((entity)=>({
            name: entity.name,
            appKey: entity.appKey,
            moduleKey: entity.moduleKey,
            options: entity.options,
            type: (0, $fkvsU.CONNECT_ENTITY_TYPE)
        })) : []);
const $ed8f699fce32689f$export$9222e43f5478367f = (0, $df4Sl.createSelector)([
    (0, $8QKSg.forgeIssueActivitySelector),
    $ed8f699fce32689f$export$dd6c9850f9e61a72
], (forge, connect)=>[
        ...forge,
        ...connect
    ].sort($ed8f699fce32689f$export$b2c15e41218fc96));

});
parcelRegister("gdPSX", function(module, exports) {

$parcel$export(module.exports, "fireOperationalFailedEvent", () => $efc14f04fccc55bd$export$add44f896fb31ba3);
$parcel$export(module.exports, "fireUiActionClickedEvent", () => $efc14f04fccc55bd$export$a645c87ca2607d94);
$parcel$export(module.exports, "fireTrackActionSucceedEvent", () => $efc14f04fccc55bd$export$435f030e21a120be);
$parcel$export(module.exports, "fireOperationalActionFailedEvent", () => $efc14f04fccc55bd$export$828a66ad00e9a886);
$parcel$export(module.exports, "fireTrackSavedEvent", () => $efc14f04fccc55bd$export$1dbf5d2537a38bd8);
$parcel$export(module.exports, "fireOperationalSaveFailedEvent", () => $efc14f04fccc55bd$export$cda76554fa8eee1d);
$parcel$export(module.exports, "fireUiRemoveClickedEvent", () => $efc14f04fccc55bd$export$2e4d409fc887e7e);
$parcel$export(module.exports, "fireTrackRemovedEvent", () => $efc14f04fccc55bd$export$daf10221407e1b30);
$parcel$export(module.exports, "fireOperationalRemoveFailedEvent", () => $efc14f04fccc55bd$export$d12e864ea545eb36);
$parcel$export(module.exports, "fireUiTriggerSelectedEvent", () => $efc14f04fccc55bd$export$4d7a3fdb2dd15cbb);
$parcel$export(module.exports, "fireUiCollapseExpandClickedEvent", () => $efc14f04fccc55bd$export$c157193e598947ac);
$parcel$export(module.exports, "fireTrackUpdateSucceedEvent", () => $efc14f04fccc55bd$export$98e4a25792520246);
$parcel$export(module.exports, "fireOperationalUpdateFailedEvent", () => $efc14f04fccc55bd$export$9ee09996d253231a);

var $2Rqjr = parcelRequire("2Rqjr");

var $8XU7c = parcelRequire("8XU7c");

var $cYWDh = parcelRequire("cYWDh");

var $d6g7g = parcelRequire("d6g7g");

var $hRcYT = parcelRequire("hRcYT");
const $efc14f04fccc55bd$var$moduleEventId = (0, $8XU7c.getEventId)({
    module: (0, $2Rqjr.ISSUE_PANEL_MODULE),
    moduleType: (0, $hRcYT.MODULE_TYPE_EXTENSION)
});
const $efc14f04fccc55bd$var$triggerEventId = (0, $8XU7c.getEventId)({
    module: (0, $2Rqjr.ISSUE_PANEL_MODULE),
    moduleType: (0, $hRcYT.MODULE_TYPE_TRIGGER)
});
const $efc14f04fccc55bd$export$add44f896fb31ba3 = (source, attributes)=>(0, $cYWDh.fireOperationalEvent)((0, $hRcYT.OPERATIONAL_ACTIONS).FAILED, {
        id: $efc14f04fccc55bd$var$moduleEventId,
        source: source,
        attributes: attributes
    });
const $efc14f04fccc55bd$export$a645c87ca2607d94 = (source, attributes)=>(0, $cYWDh.fireUiEvent)((0, $hRcYT.UI_ACTIONS).ACTION_CLICKED, {
        id: $efc14f04fccc55bd$var$moduleEventId,
        source: source,
        attributes: attributes
    });
const $efc14f04fccc55bd$export$435f030e21a120be = (source, attributes)=>(0, $cYWDh.fireTrackEvent)((0, $hRcYT.TRACK_ACTIONS).ACTION_SUCCEED, {
        id: $efc14f04fccc55bd$var$moduleEventId,
        source: source,
        attributes: attributes
    });
const $efc14f04fccc55bd$export$828a66ad00e9a886 = (source, attributes)=>(0, $cYWDh.fireOperationalEvent)((0, $hRcYT.OPERATIONAL_ACTIONS).ACTION_FAILED, {
        id: $efc14f04fccc55bd$var$moduleEventId,
        source: source,
        attributes: attributes
    });
const $efc14f04fccc55bd$export$1dbf5d2537a38bd8 = (source, attributes)=>(0, $cYWDh.fireTrackEvent)((0, $hRcYT.TRACK_ACTIONS).SAVED, {
        id: $efc14f04fccc55bd$var$moduleEventId,
        source: source,
        attributes: attributes
    });
const $efc14f04fccc55bd$export$cda76554fa8eee1d = (source, attributes)=>(0, $cYWDh.fireOperationalEvent)((0, $hRcYT.OPERATIONAL_ACTIONS).SAVE_FAILED, {
        id: $efc14f04fccc55bd$var$moduleEventId,
        source: source,
        attributes: attributes
    });
const $efc14f04fccc55bd$export$2e4d409fc887e7e = (source, attributes)=>(0, $cYWDh.fireUiEvent)((0, $hRcYT.UI_ACTIONS).REMOVE_CLICKED, {
        id: $efc14f04fccc55bd$var$moduleEventId,
        source: source,
        attributes: attributes
    });
const $efc14f04fccc55bd$export$daf10221407e1b30 = (source, attributes)=>(0, $cYWDh.fireTrackEvent)((0, $hRcYT.TRACK_ACTIONS).REMOVED, {
        id: $efc14f04fccc55bd$var$moduleEventId,
        source: source,
        attributes: attributes
    });
const $efc14f04fccc55bd$export$d12e864ea545eb36 = (source, attributes)=>(0, $cYWDh.fireOperationalEvent)((0, $hRcYT.OPERATIONAL_ACTIONS).REMOVE_FAILED, {
        id: $efc14f04fccc55bd$var$moduleEventId,
        source: source,
        attributes: attributes
    });
const $efc14f04fccc55bd$export$4d7a3fdb2dd15cbb = (extensionId, source, attributes)=>{
    (0, $d6g7g.forgeModulesConcurrentLoadTime)(extensionId).start({
        startTime: performance.now()
    });
    return (0, $cYWDh.fireUiEvent)((0, $hRcYT.UI_ACTIONS).SELECTED, {
        id: $efc14f04fccc55bd$var$triggerEventId,
        source: source,
        attributes: attributes
    });
};
const $efc14f04fccc55bd$export$c157193e598947ac = (source, attributes)=>(0, $cYWDh.fireUiEvent)((0, $hRcYT.UI_ACTIONS).COLLAPSE_EXPAND_CLICKED, {
        id: $efc14f04fccc55bd$var$moduleEventId,
        source: source,
        attributes: attributes
    });
const $efc14f04fccc55bd$export$98e4a25792520246 = (source, attributes)=>(0, $cYWDh.fireTrackEvent)((0, $hRcYT.TRACK_ACTIONS).UPDATE_SUCCEED, {
        id: $efc14f04fccc55bd$var$moduleEventId,
        source: source,
        attributes: attributes
    });
const $efc14f04fccc55bd$export$9ee09996d253231a = (source, attributes)=>(0, $cYWDh.fireOperationalEvent)((0, $hRcYT.OPERATIONAL_ACTIONS).UPDATE_FAILED, {
        id: $efc14f04fccc55bd$var$moduleEventId,
        source: source,
        attributes: attributes
    });

});
parcelRegister("8XU7c", function(module, exports) {

$parcel$export(module.exports, "getEventId", () => $ea56d020133ed4ec$export$5639f6a927500d9);
$parcel$export(module.exports, "getBrowserMetricsEventId", () => $ea56d020133ed4ec$export$25830fc7d037f0f2);
$parcel$export(module.exports, "getEventActionName", () => $ea56d020133ed4ec$export$644ccb9a67b9a9c1);

var $2Rqjr = parcelRequire("2Rqjr");

var $TrUS5 = parcelRequire("TrUS5");

var $hRcYT = parcelRequire("hRcYT");


var $eTZsp = parcelRequire("eTZsp");

var $d6g7g = parcelRequire("d6g7g");
const $ea56d020133ed4ec$var$capitalizeFirstLetter = (str)=>str != null && str.charAt(0).toUpperCase() + str.slice(1) || '';
const $ea56d020133ed4ec$var$prepareModuleMode = (entryPoint)=>`${$ea56d020133ed4ec$var$capitalizeFirstLetter(entryPoint)}`;
const $ea56d020133ed4ec$export$3e50bc81d8ed2e3f = (moduleName)=>moduleName.replace(/^jira:/, '');
const $ea56d020133ed4ec$var$prepareModuleName = (moduleName)=>(0, $2Rqjr.SUPPORTED_MODULES).includes(moduleName) ? $ea56d020133ed4ec$export$3e50bc81d8ed2e3f(moduleName) : 'unknown';
const $ea56d020133ed4ec$export$5639f6a927500d9 = ({ module: module, moduleType: moduleType = (0, $hRcYT.MODULE_TYPE_EXTENSION), entryPoint: entryPoint })=>{
    const eventNamePostfix = moduleType === 'trigger' ? 'Trigger' : '';
    return (0, $TrUS5.toEventId)(`${$ea56d020133ed4ec$var$prepareModuleName(module)}${$ea56d020133ed4ec$var$prepareModuleMode(entryPoint)}${eventNamePostfix}`);
};
const $ea56d020133ed4ec$export$25830fc7d037f0f2 = ({ module: module, entryPoint: entryPoint, forgeUiType: forgeUiType })=>(0, $TrUS5.toEventId)(`${$ea56d020133ed4ec$var$prepareModuleName(module)}${$ea56d020133ed4ec$var$prepareModuleMode(entryPoint)}-${forgeUiType}`);
const $ea56d020133ed4ec$export$644ccb9a67b9a9c1 = (eventId, action)=>`${0, $hRcYT.PACKAGE_NAME_GASV3}.${eventId} ${action}`;

});


parcelRegister("7C4za", function(module, exports) {

$parcel$export(module.exports, "toForgeKey", () => $7c20fcbbb166c6a7$export$fef910e3c6a21573);
$parcel$export(module.exports, "toForgeKeyWithDate", () => $7c20fcbbb166c6a7$export$4a8bc976ef8470fb);
$parcel$export(module.exports, "toForgeKeyFromExtensionId", () => $7c20fcbbb166c6a7$export$72368b9e5ac31f04);
$parcel$export(module.exports, "toConnectKey", () => $7c20fcbbb166c6a7$export$f1cde82a5f64810e);
$parcel$export(module.exports, "toEcosystemKeys", () => $7c20fcbbb166c6a7$export$c9483bbc66b4fb20);
$parcel$export(module.exports, "isForgeExtension", () => $7c20fcbbb166c6a7$export$b0ed77f2dd403096);
$parcel$export(module.exports, "isKeyMatchPrefix", () => $7c20fcbbb166c6a7$export$75f2b72396a13fc0);

var $2Rqjr = parcelRequire("2Rqjr");
const $7c20fcbbb166c6a7$export$fef910e3c6a21573 = (appKey, moduleKey)=>`${appKey}/${moduleKey}`;
const $7c20fcbbb166c6a7$export$4a8bc976ef8470fb = (appKey, moduleKey, panelInstanceId, dateAdded)=>`${appKey}/${moduleKey}-${panelInstanceId}-${dateAdded}`;
const $7c20fcbbb166c6a7$export$72368b9e5ac31f04 = (extensionId, panelInstanceId, dateAdded)=>panelInstanceId != null ? `${extensionId}-${panelInstanceId}-${dateAdded}` : `${extensionId}-${0, $2Rqjr.NONE_PANEL_INSTANCE_ID}-${dateAdded}`;
const $7c20fcbbb166c6a7$export$f1cde82a5f64810e = (appKey, moduleKey)=>`${appKey}_${moduleKey}`;
const $7c20fcbbb166c6a7$export$c9483bbc66b4fb20 = (extensionId)=>{
    const [prefix, appId, envId, ...rest] = extensionId.split('/');
    const appKey = [
        prefix,
        appId,
        envId
    ].join('/');
    const moduleKey = rest.join('/');
    return {
        appKey: appKey,
        moduleKey: moduleKey
    };
};
const $7c20fcbbb166c6a7$export$b0ed77f2dd403096 = (appKey)=>appKey.startsWith((0, $2Rqjr.FORGE_FIELD_TYPE_PREFIX));
const $7c20fcbbb166c6a7$export$75f2b72396a13fc0 = (key, prefix)=>key.startsWith(prefix) && /^\w+-\d+$/.test(key.slice(prefix.length));

});

parcelRegister("duMa0", function(module, exports) {

$parcel$export(module.exports, "removeTimestamp", () => $5a77e887744126ed$export$8144a1156e1fc1b3);
$parcel$export(module.exports, "parseForgeIssuePanel", () => $5a77e887744126ed$export$a21b4e384e411f26);
// when input is like 'my-issue-content-panel-5794110541888792068', output is 'my-issue-content-panel'
const $5a77e887744126ed$export$8144a1156e1fc1b3 = (str, minDigitsLen = 0)=>{
    const indexOfHyphen = str.lastIndexOf('-');
    const tail = str.substr(indexOfHyphen + 1);
    if (/^\d+$/.test(tail) && tail.length >= minDigitsLen) return str.substr(0, indexOfHyphen);
    return str;
};
const $5a77e887744126ed$export$a21b4e384e411f26 = (panelKey)=>{
    const match = panelKey.match(/^(.*)-(\w+)-(\d+)$/);
    if (match == null) return null;
    const [, extensionId, id, timestamp] = match;
    const added = Number(timestamp);
    return {
        extensionId: extensionId,
        id: id,
        added: added
    };
};

});

parcelRegister("9F6MO", function(module, exports) {

$parcel$export(module.exports, "permissionsSelector", () => $f28a7cb0a30833d7$export$7a13e26fbaa74911);
$parcel$export(module.exports, "canBeAssignedToIssuesPermissionsSelector", () => $f28a7cb0a30833d7$export$6da6e9cc5af6cc92);
$parcel$export(module.exports, "canAdministerProjectPermissionsSelector", () => $f28a7cb0a30833d7$export$106fd3c30fc8b230);
$parcel$export(module.exports, "canAdministerJiraPermissionsSelector", () => $f28a7cb0a30833d7$export$adf4ccad5657586d);
$parcel$export(module.exports, "canModifyReporterPermissionsSelector", () => $f28a7cb0a30833d7$export$85a3c8518f632ff1);
$parcel$export(module.exports, "canExportIssueSelector", () => $f28a7cb0a30833d7$export$a409252beda5dd99);
$parcel$export(module.exports, "watchersPermissionsSelector", () => $f28a7cb0a30833d7$export$b3bd1cf4683807d8);
$parcel$export(module.exports, "canViewDevToolsPermissionsSelector", () => $f28a7cb0a30833d7$export$dfc7b576e23ac861);
$parcel$export(module.exports, "canUseServiceDeskAgentFeaturesSelector", () => $f28a7cb0a30833d7$export$1b79be16305d8111);

var $df4Sl = parcelRequire("df4Sl");

var $czx3b = parcelRequire("czx3b");

var $7ZZxN = parcelRequire("7ZZxN");

var $5JqpU = parcelRequire("5JqpU");

var $jZDJX = parcelRequire("jZDJX");
const $f28a7cb0a30833d7$var$internalPermissionsSelector = (0, $df4Sl.createSelector)((0, $jZDJX.entitiesSelector), (entities)=>entities.permissions);
const $f28a7cb0a30833d7$var$jsdPermissionsSetThatNeedApplicationRoleAndAgentPerm = new Set([
    // In the BE this is not technically a veto'd permission, however it simplifies the FE code to pretend that it is.
    'canUseServiceDeskAgentFeatures',
    // Normal veto'd permissions as per ServiceDeskCollaboratorPermissionOverrideStrategy in BE
    'canEditIssues',
    'canTransitionIssues',
    'canScheduleIssues',
    'canMoveIssue',
    'canAssignIssues',
    'canBeAssignedToIssues',
    'canDeleteIssue',
    'canManageWatchers',
    'canEditAllComments',
    'canDeleteAllComments',
    'canDeleteAllAttachments',
    'canLogWork',
    'canEditOwnWorklogs',
    'canEditAllWorklogs',
    'canDeleteOwnWorklogs',
    'canDeleteAllWorklogs',
    // These should be vetoed, but aren't requested by JFE yet
    'canResolveIssues',
    'canViewReadonlyWorkflow',
    'canCloseIssues',
    'canModifyReporter',
    'canSetIssueSecurity',
    'canArchiveIssue',
    'canUnarchiveIssue'
]);
const $f28a7cb0a30833d7$export$7a13e26fbaa74911 = (0, $df4Sl.createSelector)((0, $5JqpU.appPermissionsSelector), (0, $jZDJX.projectTypeSelector), $f28a7cb0a30833d7$var$internalPermissionsSelector, (0, $5JqpU.tenantHasActiveServiceDeskLicenseSelector), (applicationPermissions, projectType, permissions, tenantHasActiveServiceDeskLicense)=>{
    if (projectType === (0, $7ZZxN.SERVICE_DESK_PROJECT) && tenantHasActiveServiceDeskLicense) {
        const { canUseServiceDeskAgentFeatures: canUseServiceDeskAgentFeatures } = permissions;
        const hasJsdAppRole = applicationPermissions.hasServiceDeskAccess;
        return (0, (/*@__PURE__*/$parcel$interopDefault($czx3b)))(permissions, (hasPermission, key)=>$f28a7cb0a30833d7$var$jsdPermissionsSetThatNeedApplicationRoleAndAgentPerm.has(key) ? hasPermission && hasJsdAppRole && canUseServiceDeskAgentFeatures : hasPermission);
    }
    return permissions;
});
const $f28a7cb0a30833d7$export$6da6e9cc5af6cc92 = (0, $df4Sl.createSelector)($f28a7cb0a30833d7$export$7a13e26fbaa74911, (permissions)=>!!permissions.canBeAssignedToIssues);
const $f28a7cb0a30833d7$export$106fd3c30fc8b230 = (0, $df4Sl.createSelector)($f28a7cb0a30833d7$export$7a13e26fbaa74911, (permissions)=>!!permissions.canAdministerProject);
const $f28a7cb0a30833d7$export$adf4ccad5657586d = (0, $df4Sl.createSelector)($f28a7cb0a30833d7$export$7a13e26fbaa74911, (permissions)=>!!permissions.canAdministerJira);
const $f28a7cb0a30833d7$var$canViewWatchersPermissionsSelector = (0, $df4Sl.createSelector)($f28a7cb0a30833d7$export$7a13e26fbaa74911, (permissions)=>permissions.canViewWatchers);
const $f28a7cb0a30833d7$var$canManageWatchersPermissionsSelector = (0, $df4Sl.createSelector)($f28a7cb0a30833d7$export$7a13e26fbaa74911, (permissions)=>permissions.canManageWatchers);
const $f28a7cb0a30833d7$export$85a3c8518f632ff1 = (0, $df4Sl.createSelector)($f28a7cb0a30833d7$export$7a13e26fbaa74911, (permissions)=>permissions.canModifyReporter);
const $f28a7cb0a30833d7$export$a409252beda5dd99 = (0, $df4Sl.createSelector)($f28a7cb0a30833d7$export$7a13e26fbaa74911, (permissions)=>permissions.canExportIssue);
const $f28a7cb0a30833d7$export$b3bd1cf4683807d8 = (0, $df4Sl.createSelector)($f28a7cb0a30833d7$var$canViewWatchersPermissionsSelector, $f28a7cb0a30833d7$var$canManageWatchersPermissionsSelector, (canViewWatchers, canManageWatchers)=>({
        canViewWatchers: canViewWatchers,
        canManageWatchers: canManageWatchers
    }));
const $f28a7cb0a30833d7$export$ca6b7f39a3de4ff9 = (0, $df4Sl.createSelector)($f28a7cb0a30833d7$export$7a13e26fbaa74911, (permissions)=>permissions.canBrowseUsers);
const $f28a7cb0a30833d7$export$dfc7b576e23ac861 = (0, $df4Sl.createSelector)($f28a7cb0a30833d7$export$7a13e26fbaa74911, (permissions)=>permissions.canViewDevTools);
const $f28a7cb0a30833d7$export$1b79be16305d8111 = (0, $df4Sl.createSelector)($f28a7cb0a30833d7$export$7a13e26fbaa74911, (permissions)=>permissions.canUseServiceDeskAgentFeatures);

});
parcelRegister("czx3b", function(module, exports) {

var $3pSMu = parcelRequire("3pSMu");

var $piimr = parcelRequire("piimr");

var $7qARj = parcelRequire("7qARj");
/**
 * Creates an object with the same keys as `object` and values generated
 * by running each own enumerable string keyed property of `object` thru
 * `iteratee`. The iteratee is invoked with three arguments:
 * (value, key, object).
 *
 * @static
 * @memberOf _
 * @since 2.4.0
 * @category Object
 * @param {Object} object The object to iterate over.
 * @param {Function} [iteratee=_.identity] The function invoked per iteration.
 * @returns {Object} Returns the new mapped object.
 * @see _.mapKeys
 * @example
 *
 * var users = {
 *   'fred':    { 'user': 'fred',    'age': 40 },
 *   'pebbles': { 'user': 'pebbles', 'age': 1 }
 * };
 *
 * _.mapValues(users, function(o) { return o.age; });
 * // => { 'fred': 40, 'pebbles': 1 } (iteration order is not guaranteed)
 *
 * // The `_.property` iteratee shorthand.
 * _.mapValues(users, 'age');
 * // => { 'fred': 40, 'pebbles': 1 } (iteration order is not guaranteed)
 */ function $9272640aa667e27d$var$mapValues(object, iteratee) {
    var result = {};
    iteratee = $7qARj(iteratee, 3);
    $piimr(object, function(value, key, object) {
        $3pSMu(result, key, iteratee(value, key, object));
    });
    return result;
}
module.exports = $9272640aa667e27d$var$mapValues;

});


const $6c91ecd17276581e$export$bdafa6b589be8b30 = 'issue.content.panel.customised.flag';

parcelRegister("9Hrk7", function(module, exports) {

$parcel$export(module.exports, "ecosystemEntitiesSelector", () => $683f24d420bc5103$export$8db07a5bb000e56f);
$parcel$export(module.exports, "forgeEntitiesSelector", () => $683f24d420bc5103$export$92b32d478f0e29fb);

var $df4Sl = parcelRequire("df4Sl");

var $jZDJX = parcelRequire("jZDJX");

var $k8iGR = parcelRequire("k8iGR");
const $683f24d420bc5103$export$8db07a5bb000e56f = (0, $df4Sl.createSelector)((0, $jZDJX.entitiesSelector), (entities)=>entities.ecosystem || {});
const $683f24d420bc5103$export$92b32d478f0e29fb = (0, $df4Sl.createSelector)((0, $jZDJX.entitiesSelector), (entities)=>entities.forge || (0, $k8iGR.initialState));

});
parcelRegister("k8iGR", function(module, exports) {

$parcel$export(module.exports, "initialState", () => $9fdfda2b324e48f8$export$d4c72bab9d6cc13a);
$parcel$export(module.exports, "default", () => $9fdfda2b324e48f8$export$2e2bcd8739ae039);

var $i7QJO = parcelRequire("i7QJO");

var $5nezI = parcelRequire("5nezI");

var $fYteL = parcelRequire("fYteL");
const $9fdfda2b324e48f8$export$d4c72bab9d6cc13a = {
    actions: [],
    glances: [],
    issueContexts: [],
    panels: [],
    activities: [],
    customFields: [],
    customFieldTypes: [],
    backgroundScripts: [],
    activeAction: null,
    panelsKeys: {
        newPanels: [],
        collapsedPanels: []
    },
    uiModifications: []
};
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$9fdfda2b324e48f8$export$2e2bcd8739ae039 = (state = $9fdfda2b324e48f8$export$d4c72bab9d6cc13a, action)=>{
    switch(action.type){
        case 0, $i7QJO.FETCH_FORGE_SUCCESS:
            return {
                ...state,
                actions: action.payload.issueAction,
                glances: action.payload.issueGlance,
                issueContexts: action.payload.issueContext,
                panels: action.payload.issuePanel,
                activities: action.payload.issueActivity,
                customFields: action.payload.customField,
                customFieldTypes: action.payload.customFieldType,
                backgroundScripts: action.payload.issueViewBackgroundScript,
                activeAction: null,
                panelsKeys: {
                    ...state.panelsKeys,
                    newPanels: []
                },
                uiModifications: action.payload.uiModifications
            };
        case 0, $i7QJO.FORGE_ISSUE_ACTION_EXEC:
            return {
                ...state,
                activeAction: {
                    action: action.payload,
                    isLoading: true
                }
            };
        case 0, $i7QJO.FORGE_ISSUE_ACTION_RENDERED:
            return {
                ...state,
                // @ts-expect-error - TS2322 - Type '{ isLoading: false; action?: Action | undefined; }' is not assignable to type 'ActiveAction'.
                activeAction: {
                    ...state.activeAction,
                    isLoading: false
                }
            };
        case 0, $i7QJO.FORGE_ISSUE_ACTION_CLOSE:
            return {
                ...state,
                activeAction: null
            };
        case 0, $i7QJO.FORGE_ISSUE_PANEL_ADDED:
            return {
                ...state,
                panelsKeys: {
                    ...state.panelsKeys,
                    newPanels: [
                        ...state.panelsKeys.newPanels,
                        action.payload
                    ]
                }
            };
        case 0, $i7QJO.FORGE_NEW_ISSUE_PANEL_UNTRACK:
            {
                const removedPanelKey = action.payload;
                const { panelsKeys: panelsKeys } = state;
                return {
                    ...state,
                    panelsKeys: {
                        ...panelsKeys,
                        newPanels: panelsKeys.newPanels.filter((panelKey)=>panelKey !== removedPanelKey)
                    }
                };
            }
        case 0, $i7QJO.FORGE_ISSUE_PANEL_REMOVED:
            {
                const removedPanelKey = action.payload;
                return {
                    ...state,
                    panelsKeys: {
                        newPanels: state.panelsKeys.newPanels.filter((panelKey)=>panelKey !== removedPanelKey),
                        collapsedPanels: state.panelsKeys.collapsedPanels.filter((panelKey)=>panelKey !== removedPanelKey)
                    }
                };
            }
        case 0, $i7QJO.FORGE_ISSUE_PANEL_UPDATED:
            {
                const { panelKey: panelKey, collapsed: collapsed } = action.payload;
                const updatedCollapsedPanels = collapsed ? Array.from(new Set([
                    ...state.panelsKeys.collapsedPanels,
                    panelKey
                ])) : state.panelsKeys.collapsedPanels.filter((key)=>key !== panelKey);
                return {
                    ...state,
                    panelsKeys: {
                        ...state.panelsKeys,
                        collapsedPanels: updatedCollapsedPanels
                    }
                };
            }
        case 0, $fYteL.FETCH_ISSUE_SUCCESS:
        case 0, $fYteL.REFRESH_ISSUE_SUCCESS:
        case 0, $5nezI.FETCH_ISSUE_REMOTE_DATA_SUCCESS:
            {
                const collapsedPanels = action.payload.forgeIssueProperties?.collapsedPanels || [];
                return {
                    ...state,
                    panelsKeys: {
                        ...state.panelsKeys,
                        collapsedPanels: Array.from(new Set([
                            ...state.panelsKeys.collapsedPanels,
                            ...collapsedPanels
                        ]))
                    }
                };
            }
        default:
            return state;
    }
};

});
parcelRegister("i7QJO", function(module, exports) {

$parcel$export(module.exports, "FETCH_FORGE_SUCCESS", () => $2c680f99c3f1e6c8$export$b40fce05e753d390);
$parcel$export(module.exports, "fetchForgeSuccess", () => $2c680f99c3f1e6c8$export$1b05a0184822bc74);
$parcel$export(module.exports, "FORGE_ISSUE_ACTION_EXEC", () => $2c680f99c3f1e6c8$export$8c062df60fb76839);
$parcel$export(module.exports, "forgeIssueActionExec", () => $2c680f99c3f1e6c8$export$3a189763780c504b);
$parcel$export(module.exports, "FORGE_ISSUE_ACTION_RENDERED", () => $2c680f99c3f1e6c8$export$dd307b8c5e0de67d);
$parcel$export(module.exports, "forgeIssueActionRendered", () => $2c680f99c3f1e6c8$export$2484a0b7a9a14f92);
$parcel$export(module.exports, "FORGE_ISSUE_ACTION_CLOSE", () => $2c680f99c3f1e6c8$export$d91b51ae909f8e95);
$parcel$export(module.exports, "forgeIssueActionClose", () => $2c680f99c3f1e6c8$export$335a03a463c5945a);
$parcel$export(module.exports, "FORGE_ISSUE_PANEL_ADDED", () => $2c680f99c3f1e6c8$export$7d7831d10e022e0);
$parcel$export(module.exports, "forgeIssuePanelAdded", () => $2c680f99c3f1e6c8$export$f24c609edeac582f);
$parcel$export(module.exports, "FORGE_NEW_ISSUE_PANEL_UNTRACK", () => $2c680f99c3f1e6c8$export$d36cecbf4e320d4a);
$parcel$export(module.exports, "forgeNewIssuePanelUntrack", () => $2c680f99c3f1e6c8$export$b93b979485d242c8);
$parcel$export(module.exports, "FORGE_ISSUE_PANEL_REMOVED", () => $2c680f99c3f1e6c8$export$798e467d6a4cb5c);
$parcel$export(module.exports, "forgeIssuePanelRemoved", () => $2c680f99c3f1e6c8$export$b584e6f1797702be);
$parcel$export(module.exports, "FORGE_ISSUE_PANEL_UPDATE_REQUEST", () => $2c680f99c3f1e6c8$export$bb2e005bc0498829);
$parcel$export(module.exports, "forgeIssuePanelUpdateRequest", () => $2c680f99c3f1e6c8$export$c67c4f64ec92ba7f);
$parcel$export(module.exports, "FORGE_ISSUE_PANEL_UPDATED", () => $2c680f99c3f1e6c8$export$2ce5fe154022894b);
$parcel$export(module.exports, "forgeIssuePanelUpdated", () => $2c680f99c3f1e6c8$export$e2eebb5b364492ce);
const $2c680f99c3f1e6c8$export$b40fce05e753d390 = 'FETCH_FORGE_SUCCESS';
const $2c680f99c3f1e6c8$export$1b05a0184822bc74 = (payload)=>({
        type: $2c680f99c3f1e6c8$export$b40fce05e753d390,
        payload: payload
    });
const $2c680f99c3f1e6c8$export$8c062df60fb76839 = 'FORGE_ISSUE_ACTION_EXEC';
const $2c680f99c3f1e6c8$export$3a189763780c504b = (action)=>({
        type: $2c680f99c3f1e6c8$export$8c062df60fb76839,
        payload: action
    });
const $2c680f99c3f1e6c8$export$dd307b8c5e0de67d = 'FORGE_ISSUE_ACTION_RENDERED';
const $2c680f99c3f1e6c8$export$2484a0b7a9a14f92 = ()=>({
        type: $2c680f99c3f1e6c8$export$dd307b8c5e0de67d
    });
const $2c680f99c3f1e6c8$export$d91b51ae909f8e95 = 'FORGE_ISSUE_ACTION_CLOSE';
const $2c680f99c3f1e6c8$export$335a03a463c5945a = ()=>({
        type: $2c680f99c3f1e6c8$export$d91b51ae909f8e95
    });
const $2c680f99c3f1e6c8$export$7d7831d10e022e0 = 'FORGE_ISSUE_PANEL_ADDED';
const $2c680f99c3f1e6c8$export$f24c609edeac582f = (issuePanelKey)=>({
        type: $2c680f99c3f1e6c8$export$7d7831d10e022e0,
        payload: issuePanelKey
    });
const $2c680f99c3f1e6c8$export$d36cecbf4e320d4a = 'FORGE_NEW_ISSUE_PANEL_UNTRACK';
const $2c680f99c3f1e6c8$export$b93b979485d242c8 = (issuePanelKey)=>({
        type: $2c680f99c3f1e6c8$export$d36cecbf4e320d4a,
        payload: issuePanelKey
    });
const $2c680f99c3f1e6c8$export$798e467d6a4cb5c = 'FORGE_ISSUE_PANEL_REMOVED';
const $2c680f99c3f1e6c8$export$b584e6f1797702be = (issuePanelKey)=>({
        type: $2c680f99c3f1e6c8$export$798e467d6a4cb5c,
        payload: issuePanelKey
    });
const $2c680f99c3f1e6c8$export$bb2e005bc0498829 = 'FORGE_ISSUE_PANEL_UPDATE_REQUEST';
const $2c680f99c3f1e6c8$export$c67c4f64ec92ba7f = (payload)=>({
        type: $2c680f99c3f1e6c8$export$bb2e005bc0498829,
        payload: payload
    });
const $2c680f99c3f1e6c8$export$2ce5fe154022894b = 'FORGE_ISSUE_PANEL_UPDATED';
const $2c680f99c3f1e6c8$export$e2eebb5b364492ce = (payload)=>({
        type: $2c680f99c3f1e6c8$export$2ce5fe154022894b,
        payload: payload
    });

});

parcelRegister("5nezI", function(module, exports) {

$parcel$export(module.exports, "FETCH_ISSUE_REMOTE_DATA_REQUEST", () => $739b73405dd64b1d$export$d8a6e69b46d6d184);
$parcel$export(module.exports, "fetchIssueRemoteDataRequest", () => $739b73405dd64b1d$export$222125e4e0f166e4);
$parcel$export(module.exports, "FETCH_ISSUE_REMOTE_DATA_SUCCESS", () => $739b73405dd64b1d$export$2cdd723fc40cdd47);
$parcel$export(module.exports, "fetchIssueRemoteDataSuccess", () => $739b73405dd64b1d$export$615a2d29b149df95);
$parcel$export(module.exports, "FETCH_ISSUE_REMOTE_DATA_FAILURE", () => $739b73405dd64b1d$export$396f0d977db541d9);
$parcel$export(module.exports, "fetchIssueRemoteDataFailure", () => $739b73405dd64b1d$export$f7fd18472eaf2b77);
const $739b73405dd64b1d$export$d8a6e69b46d6d184 = 'FETCH_ISSUE_REMOTE_DATA_REQUEST';
const $739b73405dd64b1d$export$222125e4e0f166e4 = (issueKey)=>({
        type: $739b73405dd64b1d$export$d8a6e69b46d6d184,
        payload: issueKey
    });
const $739b73405dd64b1d$export$2cdd723fc40cdd47 = 'FETCH_ISSUE_REMOTE_DATA_SUCCESS';
const $739b73405dd64b1d$export$615a2d29b149df95 = (entities)=>({
        type: $739b73405dd64b1d$export$2cdd723fc40cdd47,
        payload: entities
    });
const $739b73405dd64b1d$export$396f0d977db541d9 = 'FETCH_ISSUE_REMOTE_DATA_FAILURE';
const $739b73405dd64b1d$export$f7fd18472eaf2b77 = ()=>({
        type: $739b73405dd64b1d$export$396f0d977db541d9
    });

});

parcelRegister("fYteL", function(module, exports) {

$parcel$export(module.exports, "FETCH_ISSUE_REQUEST", () => $98506972d7379203$export$afc8565512ebbf99);
$parcel$export(module.exports, "fetchIssueRequest", () => $98506972d7379203$export$ff7cd1a46115d8ca);
$parcel$export(module.exports, "FETCH_ISSUE_SUCCESS", () => $98506972d7379203$export$c32d0e1f370b7914);
$parcel$export(module.exports, "fetchIssueSuccess", () => $98506972d7379203$export$1e39a30e3f37e9d1);
$parcel$export(module.exports, "FETCH_ISSUE_FAILURE", () => $98506972d7379203$export$700ca24f76d5bbe6);
$parcel$export(module.exports, "fetchIssueFailure", () => $98506972d7379203$export$625e6e61fad65793);
$parcel$export(module.exports, "REFRESH_ISSUE_REQUEST", () => $98506972d7379203$export$b48f53bf5b842d57);
$parcel$export(module.exports, "refreshIssueRequest", () => $98506972d7379203$export$ccd0db94940d9159);
$parcel$export(module.exports, "CANCEL_REFRESH_ISSUE_REQUEST", () => $98506972d7379203$export$6b6ca6acd76420d1);
$parcel$export(module.exports, "cancelRefreshIssueRequest", () => $98506972d7379203$export$a7629a657f902cbc);
$parcel$export(module.exports, "REFRESH_ISSUE_SUCCESS", () => $98506972d7379203$export$de11c913f06a7952);
$parcel$export(module.exports, "refreshIssueSuccess", () => $98506972d7379203$export$cbd1c08fb706639c);
$parcel$export(module.exports, "FETCH_FORGE_REQUEST", () => $98506972d7379203$export$36b76b7384d868f3);
$parcel$export(module.exports, "fetchForgeRequest", () => $98506972d7379203$export$6ce2430992033a55);
const $98506972d7379203$export$afc8565512ebbf99 = 'FETCH_ISSUE_REQUEST';
const $98506972d7379203$export$ff7cd1a46115d8ca = ()=>({
        type: $98506972d7379203$export$afc8565512ebbf99
    });
const $98506972d7379203$export$c32d0e1f370b7914 = 'FETCH_ISSUE_SUCCESS';
const $98506972d7379203$export$1e39a30e3f37e9d1 = (entities)=>({
        type: $98506972d7379203$export$c32d0e1f370b7914,
        payload: entities
    });
const $98506972d7379203$export$700ca24f76d5bbe6 = 'FETCH_ISSUE_FAILURE';
const $98506972d7379203$export$625e6e61fad65793 = (failureDescription)=>({
        type: $98506972d7379203$export$700ca24f76d5bbe6,
        payload: failureDescription
    });
const $98506972d7379203$export$b48f53bf5b842d57 = 'REFRESH_ISSUE_REQUEST';
const $98506972d7379203$export$ccd0db94940d9159 = (payload, meta)=>({
        type: $98506972d7379203$export$b48f53bf5b842d57,
        payload: payload,
        meta: meta
    });
const $98506972d7379203$export$6b6ca6acd76420d1 = 'CANCEL_REFRESH_ISSUE_REQUEST';
const $98506972d7379203$export$a7629a657f902cbc = ()=>({
        type: $98506972d7379203$export$6b6ca6acd76420d1
    });
const $98506972d7379203$export$de11c913f06a7952 = 'REFRESH_ISSUE_SUCCESS';
const $98506972d7379203$export$cbd1c08fb706639c = (entities)=>({
        type: $98506972d7379203$export$de11c913f06a7952,
        payload: entities
    });
const $98506972d7379203$export$36b76b7384d868f3 = 'FETCH_FORGE_REQUEST';
const $98506972d7379203$export$6ce2430992033a55 = ()=>({
        type: $98506972d7379203$export$36b76b7384d868f3
    });

});



parcelRegister("8QKSg", function(module, exports) {

$parcel$export(module.exports, "forgeContextPanelsSelector", () => $0fae948f4d8718f3$export$94c701814d50fed3);
$parcel$export(module.exports, "forgeGlancesSelector", () => $0fae948f4d8718f3$export$92747468cb57714e);
$parcel$export(module.exports, "forgeUiModificationsSelector", () => $0fae948f4d8718f3$export$325ea69d1eb5eda0);
$parcel$export(module.exports, "forgeIssueActionsSelector", () => $0fae948f4d8718f3$export$9bcd40b01af57823);
$parcel$export(module.exports, "forgePanelsSelector", () => $0fae948f4d8718f3$export$ca115d43abfd7206);
$parcel$export(module.exports, "forgeUserCanSaveIssuePanelSelector", () => $0fae948f4d8718f3$export$ae25fce59e44b253);
$parcel$export(module.exports, "forgeJustAddedPanelSelector", () => $0fae948f4d8718f3$export$9c375a0b9a6e5017);
$parcel$export(module.exports, "forgeActiveIssueActionSelector", () => $0fae948f4d8718f3$export$ccad5f28efcec42d);
$parcel$export(module.exports, "forgeIssueDataSelector", () => $0fae948f4d8718f3$export$d3cd515b7639ce61);
$parcel$export(module.exports, "forgeIssueActivitySelector", () => $0fae948f4d8718f3$export$18ce84b90b4920eb);
$parcel$export(module.exports, "isForgePanelNewToIssueSelector", () => $0fae948f4d8718f3$export$97dadedc102bebdf);
$parcel$export(module.exports, "getForgeIssuePanel", () => $0fae948f4d8718f3$export$b01f1fc9eba6d8cd);
$parcel$export(module.exports, "forgeIsCollapsedPanelSelector", () => $0fae948f4d8718f3$export$3d7856e5c65d2291);

var $df4Sl = parcelRequire("df4Sl");

var $ldoFd = parcelRequire("ldoFd");

var $fTsDx = parcelRequire("fTsDx");

var $7C4za = parcelRequire("7C4za");

var $bLiXo = parcelRequire("bLiXo");

var $fkvsU = parcelRequire("fkvsU");

var $duMa0 = parcelRequire("duMa0");

var $6vrw7 = parcelRequire("6vrw7");

var $5JqpU = parcelRequire("5JqpU");

var $fokFV = parcelRequire("fokFV");

var $jZDJX = parcelRequire("jZDJX");

var $9F6MO = parcelRequire("9F6MO");

var $9D3Vo = parcelRequire("9D3Vo");

var $9Hrk7 = parcelRequire("9Hrk7");
const $0fae948f4d8718f3$var$filterExtensions = (list, staticContext)=>list.filter((extension)=>(0, $fTsDx.doesExtensionMeetConditions)(extension, staticContext));
const $0fae948f4d8718f3$var$sortIssuePanels = (first, second)=>{
    if (first.name === second.name) return 0;
    return first.name > second.name ? 1 : -1;
};
const $0fae948f4d8718f3$export$b302c9df74ede99a = (0, $df4Sl.createSelector)((0, $9F6MO.permissionsSelector), (0, $5JqpU.issueIdSelector), (0, $5JqpU.issueKeySelector), (0, $9D3Vo.issueTypeNameSelector), (0, $jZDJX.projectIdSelector), (0, $5JqpU.projectKeySelector), (0, $jZDJX.projectTypeSelector), (permissions, issueId, issueKey, issueType, projectId, projectKey, projectType)=>({
        issueId: issueId || null,
        issueKey: issueKey,
        issueType: issueType,
        projectId: projectId,
        projectKey: projectKey,
        projectType: projectType || null,
        // Instead of dumping permissions as is we'd like to normalize prop names a bit
        // as they are exposed externally and have to look respectable
        canAddComments: permissions.canAddComments,
        canAdministerJira: permissions.canAdministerJira,
        canAdministerProjects: permissions.canAdministerProject,
        canArchiveIssue: permissions.canArchiveIssue,
        canAssignIssues: permissions.canAssignIssues,
        canBeAssignedToIssues: permissions.canBeAssignedToIssues,
        canCloneIssues: permissions.canCloneIssue,
        canCreateAttachments: permissions.canCreateAttachments,
        canCreateChildren: permissions.canCreateChildren,
        canCreateSubtasks: permissions.canCreateSubtask,
        canDeleteAllAttachments: permissions.canDeleteAllAttachments,
        canDeleteAllComments: permissions.canDeleteAllComments,
        canDeleteAllWorklogs: permissions.canDeleteAllWorklogs,
        canDeleteIssues: permissions.canDeleteIssue,
        canDeleteOwnAttachments: permissions.canDeleteOwnAttachments,
        canDeleteOwnComments: permissions.canDeleteOwnComments,
        canDeleteOwnWorklogs: permissions.canDeleteOwnWorklogs,
        canEditAllComments: permissions.canEditAllComments,
        canEditAllWorklogs: permissions.canEditAllWorklogs,
        canEditIssues: permissions.canEditIssues,
        canEditOwnComments: permissions.canEditOwnComments,
        canEditOwnWorklogs: permissions.canEditOwnWorklogs,
        canLinkIssues: permissions.canLinkIssues,
        canLogWork: permissions.canLogWork,
        canManageWatchers: permissions.canManageWatchers,
        canModifyReporters: permissions.canModifyReporter,
        canMoveIssues: permissions.canMoveIssue,
        canScheduleIssues: permissions.canScheduleIssues,
        canUnarchiveIssue: permissions.canUnarchiveIssue,
        canUseServiceManagementAgentFeatures: permissions.canUseServiceDeskAgentFeatures,
        canBrowseUsers: permissions.canBrowseUsers,
        canViewDevTools: permissions.canViewDevTools,
        canViewWatchers: permissions.canViewWatchers,
        canExportIssue: permissions.canExportIssue
    }));
const $0fae948f4d8718f3$export$94c701814d50fed3 = (0, $df4Sl.createSelector)((0, $5JqpU.isEcosystemEnabledSelector), (0, $9Hrk7.forgeEntitiesSelector), $0fae948f4d8718f3$export$b302c9df74ede99a, (isEcosystemEnabled, forge, issueViewStaticContext)=>{
    if (!isEcosystemEnabled || !Array.isArray(forge.issueContexts)) return [];
    return forge.issueContexts.filter((extension)=>(0, $fTsDx.doesExtensionMeetConditions)(extension, issueViewStaticContext)).map((contextPanels)=>{
        const { id: id, properties: { title: title, label: label, status: status, icon: url } } = contextPanels;
        return {
            id: id,
            type: (0, $bLiXo.FORGE_CONTEXT_TYPE),
            payload: {
                type: (0, $bLiXo.FORGE_CONTEXT_TYPE),
                label: label,
                name: title,
                status: status || null,
                icon: url ? {
                    url: url
                } : null,
                contextPanelType: (0, $fkvsU.FORGE_ENTITY_TYPE),
                moduleKey: id,
                appKey: id,
                options: null
            }
        };
    });
});
const $0fae948f4d8718f3$export$92747468cb57714e = (0, $df4Sl.createSelector)((0, $5JqpU.isEcosystemEnabledSelector), (0, $9Hrk7.forgeEntitiesSelector), $0fae948f4d8718f3$export$b302c9df74ede99a, (isEcosystemEnabled, forge, issueViewStaticContext)=>{
    if (!isEcosystemEnabled || !Array.isArray(forge.glances)) return [];
    return $0fae948f4d8718f3$var$filterExtensions(forge.glances, issueViewStaticContext).map((extension)=>{
        const { id: id, properties: { title: title, label: label, status: status, icon: icon } } = extension;
        return {
            title: title,
            label: label,
            status: status,
            icon: icon,
            extension: extension,
            glanceType: (0, $fkvsU.FORGE_ENTITY_TYPE),
            // Legacy props, too much refactoring needed in order to get rid of them
            moduleKey: id,
            appKey: id
        };
    });
});
const $0fae948f4d8718f3$export$325ea69d1eb5eda0 = (0, $df4Sl.createSelector)((0, $5JqpU.isEcosystemEnabledSelector), (0, $9Hrk7.forgeEntitiesSelector), (isEcosystemEnabled, forge)=>{
    if (!isEcosystemEnabled || !Array.isArray(forge.uiModifications)) return [];
    return forge.uiModifications;
});
const $0fae948f4d8718f3$export$9bcd40b01af57823 = (0, $df4Sl.createSelector)((0, $5JqpU.isEcosystemEnabledSelector), (0, $9Hrk7.forgeEntitiesSelector), $0fae948f4d8718f3$export$b302c9df74ede99a, (isEcosystemEnabled, forge, issueViewStaticContext)=>{
    if (!isEcosystemEnabled || !Array.isArray(forge.actions)) return [];
    return $0fae948f4d8718f3$var$filterExtensions(forge.actions, issueViewStaticContext).map((extension)=>{
        const { id: id, properties: { title: title } } = extension;
        return {
            id: id,
            title: title,
            extension: extension,
            type: (0, $fkvsU.FORGE_ENTITY_TYPE)
        };
    });
});
const $0fae948f4d8718f3$export$ca115d43abfd7206 = (0, $df4Sl.createSelector)((0, $5JqpU.isEcosystemEnabledSelector), (0, $9Hrk7.forgeEntitiesSelector), $0fae948f4d8718f3$export$b302c9df74ede99a, (isEcosystemEnabled, forge, issueViewStaticContext)=>{
    if (!isEcosystemEnabled || !Array.isArray(forge.panels)) return [];
    return $0fae948f4d8718f3$var$filterExtensions(forge.panels, issueViewStaticContext).filter((extension)=>extension.properties.icon != null).map((extension)=>{
        const { id: id, properties: { title: title, icon: icon, allowMultiple: allowMultiple } } = extension;
        const { appKey: appKey, moduleKey: moduleKey } = (0, $7C4za.toEcosystemKeys)(id);
        return {
            name: title,
            tooltip: title,
            iconUrl: icon,
            extension: extension,
            allowMultiple: !!allowMultiple,
            showByDefault: false,
            type: (0, $fkvsU.FORGE_ENTITY_TYPE),
            moduleKey: moduleKey,
            appKey: appKey
        };
    }).sort($0fae948f4d8718f3$var$sortIssuePanels);
});
const $0fae948f4d8718f3$export$ae25fce59e44b253 = (0, $df4Sl.createSelector)((0, $5JqpU.isEcosystemEnabledSelector), $0fae948f4d8718f3$export$b302c9df74ede99a, (isEcosystemEnabled, issueViewStaticContext)=>isEcosystemEnabled && issueViewStaticContext.canEditIssues);
const $0fae948f4d8718f3$export$9c375a0b9a6e5017 = (panelKey)=>(0, $df4Sl.createSelector)((0, $9Hrk7.ecosystemEntitiesSelector), (ecosystem)=>ecosystem && ecosystem.selectedContentPanel === panelKey);
const $0fae948f4d8718f3$export$38dd8c9ba1d48d98 = (0, $df4Sl.createSelector)((0, $5JqpU.isEcosystemEnabledSelector), (0, $9Hrk7.forgeEntitiesSelector), $0fae948f4d8718f3$export$b302c9df74ede99a, (isEcosystemEnabled, forge, issueViewStaticContext)=>{
    if (!isEcosystemEnabled || !Array.isArray(forge.customFields)) return [];
    return $0fae948f4d8718f3$var$filterExtensions(forge.customFields, issueViewStaticContext);
});
const $0fae948f4d8718f3$export$9cef69a20109a92c = (0, $df4Sl.createSelector)((0, $5JqpU.isEcosystemEnabledSelector), (0, $9Hrk7.forgeEntitiesSelector), $0fae948f4d8718f3$export$b302c9df74ede99a, (isEcosystemEnabled, forge, issueViewStaticContext)=>{
    if (!isEcosystemEnabled || !Array.isArray(forge.customFieldTypes)) return [];
    return $0fae948f4d8718f3$var$filterExtensions(forge.customFieldTypes, issueViewStaticContext);
});
const $0fae948f4d8718f3$export$2f1d736b0e7e1293 = (0, $df4Sl.createSelector)($0fae948f4d8718f3$export$38dd8c9ba1d48d98, (fields)=>fields.length > 0);
const $0fae948f4d8718f3$export$252a589d17b14921 = (0, $df4Sl.createSelector)($0fae948f4d8718f3$export$9cef69a20109a92c, (fieldsTypes)=>fieldsTypes.length > 0);
const $0fae948f4d8718f3$export$89b67d7e4e300f7d = (0, $df4Sl.createSelector)($0fae948f4d8718f3$export$2f1d736b0e7e1293, $0fae948f4d8718f3$export$252a589d17b14921, (hasCustomFields, hasCustomFieldTypes)=>hasCustomFields || hasCustomFieldTypes);
const $0fae948f4d8718f3$export$e824cf91ff446be9 = (0, $df4Sl.createSelector)($0fae948f4d8718f3$export$38dd8c9ba1d48d98, $0fae948f4d8718f3$export$9cef69a20109a92c, (customFields, customFieldTypes)=>[
        ...customFields,
        ...customFieldTypes
    ]);
const $0fae948f4d8718f3$export$ccad5f28efcec42d = (0, $df4Sl.createSelector)((0, $5JqpU.isEcosystemEnabledSelector), (0, $9Hrk7.forgeEntitiesSelector), (isEcosystemEnabled, forge)=>{
    if (!isEcosystemEnabled) return null;
    return forge.activeAction || null;
});
const $0fae948f4d8718f3$export$e04b25b621339356 = (0, $df4Sl.createSelector)((0, $fokFV.fieldsSelector), (state, { fieldId: fieldId })=>fieldId, (fields, fieldId)=>fields[fieldId]?.schema.custom || '');
const $0fae948f4d8718f3$export$fbab82209930cdab = (0, $df4Sl.createSelector)($0fae948f4d8718f3$export$e824cf91ff446be9, $0fae948f4d8718f3$export$e04b25b621339356, (forgeFields, extensionId)=>{
    const extension = forgeFields.find((field)=>field.id === extensionId);
    return extension || null;
});
const $0fae948f4d8718f3$export$c9095ffee4d5bbc0 = (0, $df4Sl.createSelector)((0, $5JqpU.isEcosystemEnabledSelector), (0, $9Hrk7.forgeEntitiesSelector), $0fae948f4d8718f3$export$e04b25b621339356, $0fae948f4d8718f3$export$b302c9df74ede99a, (isEcosystemEnabled, forge, extensionId, issueViewStaticContext)=>{
    if (!isEcosystemEnabled || !Array.isArray(forge.customFields) || !Array.isArray(forge.customFieldTypes)) return false;
    const extension = [
        ...forge.customFields,
        ...forge.customFieldTypes
    ].find((field)=>field.id === extensionId);
    return !extension ? false : !(0, $fTsDx.doesExtensionMeetConditions)(extension, issueViewStaticContext);
});
const $0fae948f4d8718f3$export$7640f867620fe598 = (0, $df4Sl.createSelector)($0fae948f4d8718f3$export$fbab82209930cdab, (extension)=>{
    if (!extension) return false;
    const hasRenderingFunction = !(0, (/*@__PURE__*/$parcel$interopDefault($ldoFd)))(extension.properties.function);
    const hasFormatterDefined = !(0, (/*@__PURE__*/$parcel$interopDefault($ldoFd)))(extension.properties.formatter);
    return !hasRenderingFunction && hasFormatterDefined;
});
const $0fae948f4d8718f3$export$d3cd515b7639ce61 = (0, $df4Sl.createSelector)((0, $5JqpU.issueKeySelector), (0, $5JqpU.issueIdSelector), (0, $9D3Vo.issueTypeIdSelector), (0, $9D3Vo.issueTypeNameSelector), (0, $5JqpU.projectKeySelector), (0, $jZDJX.projectIdSelector), (0, $jZDJX.projectTypeSelector), (issueKey, issueId, issueTypeId, issueType, projectKey, projectId, projectType)=>({
        issue: {
            key: issueKey,
            id: issueId,
            type: issueType,
            typeId: issueTypeId
        },
        project: {
            id: projectId !== null ? (0, $6vrw7.toProjectId)(projectId.toString()) : projectId,
            key: projectKey,
            type: projectType
        }
    }));
const $0fae948f4d8718f3$export$18ce84b90b4920eb = (0, $df4Sl.createSelector)((0, $5JqpU.isEcosystemEnabledSelector), (0, $9Hrk7.forgeEntitiesSelector), $0fae948f4d8718f3$export$b302c9df74ede99a, (isEcosystemEnabled, forge, issueViewStaticContext)=>{
    if (!isEcosystemEnabled || !Array.isArray(forge.actions)) return [];
    return $0fae948f4d8718f3$var$filterExtensions(forge.activities, issueViewStaticContext).map((extension)=>{
        const { id: id, properties: { title: title } } = extension;
        const { appKey: appKey, moduleKey: moduleKey } = (0, $7C4za.toEcosystemKeys)(id);
        return {
            name: title,
            extension: extension,
            type: (0, $fkvsU.FORGE_ENTITY_TYPE),
            moduleKey: moduleKey,
            appKey: appKey
        };
    });
});
const $0fae948f4d8718f3$export$97dadedc102bebdf = (0, $df4Sl.createSelector)((0, $9Hrk7.forgeEntitiesSelector), (_, issuePanelKey)=>issuePanelKey, (forge, issuePanelKey)=>forge.panelsKeys.newPanels.includes(issuePanelKey));
const $0fae948f4d8718f3$export$b01f1fc9eba6d8cd = (forgePanelKey)=>(0, $df4Sl.createSelector)($0fae948f4d8718f3$export$ca115d43abfd7206, (panels)=>{
        const { extensionId: extensionId } = (0, $duMa0.parseForgeIssuePanel)(forgePanelKey) || {};
        return panels.find((panel)=>extensionId === panel.extension.id);
    });
const $0fae948f4d8718f3$export$3d7856e5c65d2291 = (0, $df4Sl.createSelector)((0, $9Hrk7.forgeEntitiesSelector), (_, issuePanelKey)=>issuePanelKey, (forge, issuePanelKey)=>forge.panelsKeys.collapsedPanels.includes(issuePanelKey));

});
parcelRegister("9D3Vo", function(module, exports) {

$parcel$export(module.exports, "createFullIssueUrl", () => $77aaf5a68eaa155c$export$f107e3172d0c8a79);
$parcel$export(module.exports, "issueTypeSelector", () => $77aaf5a68eaa155c$export$c5a236f192993436);
$parcel$export(module.exports, "issueUrlSelector", () => $77aaf5a68eaa155c$export$7855e152de23b9ca);
$parcel$export(module.exports, "fullIssueUrlSelector", () => $77aaf5a68eaa155c$export$14eeb219bfe6649b);
$parcel$export(module.exports, "issueTypeNameSelector", () => $77aaf5a68eaa155c$export$477df8db13e4dac3);
$parcel$export(module.exports, "issueTypeHierarchyLevelSelector", () => $77aaf5a68eaa155c$export$2bcfec06e5c80ef6);
$parcel$export(module.exports, "issueTypeIdSelector", () => $77aaf5a68eaa155c$export$22410768c09b3a82);
$parcel$export(module.exports, "issueTypeIconUrlSelector", () => $77aaf5a68eaa155c$export$4cf7e4622f7b8aee);
$parcel$export(module.exports, "isIssueTypeFieldEditableSelector", () => $77aaf5a68eaa155c$export$580b385a93b77724);
$parcel$export(module.exports, "getParentIssuesSelector", () => $77aaf5a68eaa155c$export$1e6d1c8ba22c2162);

var $df4Sl = parcelRequire("df4Sl");

var $f9RL0 = parcelRequire("f9RL0");

var $5JqpU = parcelRequire("5JqpU");

var $fokFV = parcelRequire("fokFV");

var $jZDJX = parcelRequire("jZDJX");
// @ts-expect-error - TS2304 - Cannot find name 'BaseUrl'. | TS7006 - Parameter 'issueKey' implicitly has an 'any' type.
const $77aaf5a68eaa155c$var$createRelativeIssueUrl = (baseUrl, issueKey)=>`${baseUrl ? baseUrl.replace(/\/?$/, '/') : '/'}browse/${issueKey}`;
const $77aaf5a68eaa155c$export$f107e3172d0c8a79 = (baseUrl, issueKey)=>`${window.location.protocol}//${window.location.host}${$77aaf5a68eaa155c$var$createRelativeIssueUrl(baseUrl, issueKey)}`;
const $77aaf5a68eaa155c$var$issueTypeFieldSelector = (0, $fokFV.fieldSelector)((0, $f9RL0.ISSUE_TYPE));
const $77aaf5a68eaa155c$var$subtaskIssueFieldSelector = (0, $fokFV.fieldSelector)((0, $f9RL0.SUBTASK_PARENT));
const $77aaf5a68eaa155c$var$portfolioParentFieldSelector = (0, $fokFV.fieldSelector)((0, $f9RL0.PARENT));
const $77aaf5a68eaa155c$export$c5a236f192993436 = (0, $df4Sl.createSelector)($77aaf5a68eaa155c$var$issueTypeFieldSelector, (issueType)=>issueType && issueType.value);
const $77aaf5a68eaa155c$export$7855e152de23b9ca = (0, $df4Sl.createSelector)((0, $5JqpU.baseUrlSelector), (0, $5JqpU.issueKeySelector), $77aaf5a68eaa155c$var$createRelativeIssueUrl);
const $77aaf5a68eaa155c$export$14eeb219bfe6649b = (0, $df4Sl.createSelector)((0, $5JqpU.baseUrlSelector), (0, $5JqpU.issueKeySelector), $77aaf5a68eaa155c$export$f107e3172d0c8a79);
const $77aaf5a68eaa155c$export$477df8db13e4dac3 = (0, $df4Sl.createSelector)($77aaf5a68eaa155c$export$c5a236f192993436, (issueType)=>issueType && issueType.name);
const $77aaf5a68eaa155c$export$2bcfec06e5c80ef6 = (0, $df4Sl.createSelector)($77aaf5a68eaa155c$export$c5a236f192993436, (issueType)=>{
    if (!issueType) return null;
    return issueType && issueType.hierarchyLevel;
});
const $77aaf5a68eaa155c$export$22410768c09b3a82 = (0, $df4Sl.createSelector)($77aaf5a68eaa155c$export$c5a236f192993436, (issueType)=>issueType && issueType.id);
const $77aaf5a68eaa155c$export$4cf7e4622f7b8aee = (0, $df4Sl.createSelector)($77aaf5a68eaa155c$export$c5a236f192993436, (issueType)=>issueType && issueType.iconUrl);
const $77aaf5a68eaa155c$export$580b385a93b77724 = (0, $df4Sl.createSelector)($77aaf5a68eaa155c$var$issueTypeFieldSelector, (issueType)=>issueType && Boolean(issueType.editable));
const $77aaf5a68eaa155c$var$transformParentIssue = (issue, baseUrl)=>issue ? {
        summary: issue.summary,
        key: issue.key,
        url: $77aaf5a68eaa155c$var$createRelativeIssueUrl(baseUrl, issue.key),
        issueTypeName: issue.issueTypeName || '',
        issueTypeIconUrl: issue.issueTypeIconUrl || ''
    } : null;
// @ts-expect-error - TS7006 - Parameter 'issue' implicitly has an 'any' type.
const $77aaf5a68eaa155c$var$transformSubtaskParentIssue = (issue, baseUrl)=>issue ? {
        summary: issue.fields.summary,
        key: issue.key,
        url: $77aaf5a68eaa155c$var$createRelativeIssueUrl(baseUrl, issue.key),
        issueTypeName: issue.issueTypeName || '',
        issueTypeIconUrl: issue.issueTypeIconUrl || ''
    } : null;
// eslint-disable-next-line @typescript-eslint/no-explicit-any
const $77aaf5a68eaa155c$var$transformPortfolioParentIssue = (value, baseUrl)=>value && value.data ? {
        summary: value.data.summary,
        key: value.data.key,
        url: $77aaf5a68eaa155c$var$createRelativeIssueUrl(baseUrl, value.data.key),
        issueTypeName: value.data.issueTypeName || '',
        issueTypeIconUrl: value.data.issueTypeIconUrl || ''
    } : null;
const $77aaf5a68eaa155c$export$77f9f02e63a0906f = (0, $df4Sl.createSelector)($77aaf5a68eaa155c$var$portfolioParentFieldSelector, (0, $5JqpU.baseUrlSelector), (portfolioParentIssue, baseUrl)=>$77aaf5a68eaa155c$var$transformPortfolioParentIssue(portfolioParentIssue && portfolioParentIssue.value, baseUrl));
const $77aaf5a68eaa155c$var$subtaskIssueParentSelector = (0, $df4Sl.createSelector)($77aaf5a68eaa155c$var$subtaskIssueFieldSelector, (0, $5JqpU.baseUrlSelector), (subtaskIssue, baseUrl)=>$77aaf5a68eaa155c$var$transformSubtaskParentIssue(subtaskIssue && subtaskIssue.value, baseUrl));
const $77aaf5a68eaa155c$var$parentIssueSelector = (0, $df4Sl.createSelector)((0, $jZDJX.parentIssueEntitySelector), (0, $5JqpU.baseUrlSelector), (parentIssue, baseUrl)=>$77aaf5a68eaa155c$var$transformParentIssue(parentIssue, baseUrl));
const $77aaf5a68eaa155c$export$dfeb83ef40558422 = (0, $df4Sl.createSelector)($77aaf5a68eaa155c$var$parentIssueSelector, $77aaf5a68eaa155c$var$subtaskIssueParentSelector, $77aaf5a68eaa155c$export$77f9f02e63a0906f, (parentIssue, subtaskIssue, portfolioParentIssue)=>parentIssue || subtaskIssue || portfolioParentIssue);
const $77aaf5a68eaa155c$export$1e6d1c8ba22c2162 = (0, $df4Sl.createSelector)($77aaf5a68eaa155c$var$parentIssueSelector, (parentIssue)=>[
        parentIssue
    ].filter(Boolean));

});



parcelRegister("1b2Vj", function(module, exports) {

$parcel$export(module.exports, "supportedChildIssueTypesEntitiesSelector", () => $6915515a9b677dd8$export$1e8043fccfcba3b9);
$parcel$export(module.exports, "supportsChildCreationSelector", () => $6915515a9b677dd8$export$1af32b549149f3d9);
$parcel$export(module.exports, "parentLevelIssueTypeIdsSelector", () => $6915515a9b677dd8$export$be50776e2ae27cf6);
$parcel$export(module.exports, "parentLevelIssueTypeNamesSelector", () => $6915515a9b677dd8$export$57b3549670d3627b);
$parcel$export(module.exports, "sameLevelIssueTypesIdsSelector", () => $6915515a9b677dd8$export$a81bfe971074142b);
$parcel$export(module.exports, "hierarchyLevelSelector", () => $6915515a9b677dd8$export$4f7eb1d272a8015);
$parcel$export(module.exports, "isIssueBaseLevel", () => $6915515a9b677dd8$export$d9c73da87a448c4);
$parcel$export(module.exports, "canLinkToParentSelector", () => $6915515a9b677dd8$export$5530450eb840ecb2);

var $df4Sl = parcelRequire("df4Sl");

var $3l6tm = parcelRequire("3l6tm");

var $lO4Or = parcelRequire("lO4Or");

var $fokFV = parcelRequire("fokFV");

var $jZDJX = parcelRequire("jZDJX");

var $9F6MO = parcelRequire("9F6MO");

var $7FqHc = parcelRequire("7FqHc");
// @ts-expect-error - TS2322 - Type '(arg1: Readonly<{ agile: Agile; context: ContextState; entities: Readonly<{ applicationRoles?: ApplicationRole[] | undefined; cardCover: CardCover; childrenIssues: ChildrenIssuesState; ... 29 more ...; myPreferences?: Partial<...> | undefined; }>; ... 5 more ...; validators: Validators; }>) => any' is not assignable to type 'OutputSelector<Readonly<{ agile: Agile; context: ContextState; entities: Readonly<{ applicationRoles?: ApplicationRole[] | undefined; cardCover: CardCover; childrenIssues: ChildrenIssuesState; ... 29 more ...; myPreferences?: Partial<...> | undefined; }>; ... 5 more ...; validators: Validators; }>, undefined, IssueT...'.
const $6915515a9b677dd8$var$childLevelValueSelector = (0, $fokFV.fieldPersistedValueSelector)((0, $lO4Or.HIERARCHY_LEVEL_BELOW)) || null;
const $6915515a9b677dd8$var$isChildLevelSubtaskLevelSelector = (0, $df4Sl.createSelector)(// @ts-expect-error - TS2769 - No overload matches this call.
$6915515a9b677dd8$var$childLevelValueSelector, (childLevelFieldValue)=>{
    if (!childLevelFieldValue) return false;
    return (0, $3l6tm.isSubtaskHierarchyLevel)(childLevelFieldValue.level);
});
const $6915515a9b677dd8$export$7a45e255c239753 = (0, $df4Sl.createSelector)(// @ts-expect-error - TS2769 - No overload matches this call.
$6915515a9b677dd8$var$childLevelValueSelector, (childLevelValue)=>childLevelValue && childLevelValue.issueTypes || []);
const $6915515a9b677dd8$export$1e8043fccfcba3b9 = (0, $df4Sl.createSelector)((0, $jZDJX.entitiesSelector), $6915515a9b677dd8$export$7a45e255c239753, (entities, supportedIssueTypes)=>{
    const allIssueTypes = entities.issueTypes;
    const supportedIssueTypeIds = supportedIssueTypes.map((issueType)=>issueType.id);
    return allIssueTypes.filter(// @ts-expect-error - TS2345 - Argument of type 'number' is not assignable to parameter of type 'string'.
    (issueType)=>supportedIssueTypeIds.indexOf(issueType.id) !== -1);
});
const $6915515a9b677dd8$export$1af32b549149f3d9 = (0, $df4Sl.createSelector)((0, $9F6MO.permissionsSelector), $6915515a9b677dd8$export$7a45e255c239753, $6915515a9b677dd8$var$isChildLevelSubtaskLevelSelector, (0, $jZDJX.isSimplifiedProjectSelector), (permissions, supportedChildIssueTypes, isChildLevelSubtask, isSimplifiedProject)=>permissions.canCreateChildren && !!supportedChildIssueTypes.length && (isSimplifiedProject ? true : !isChildLevelSubtask));
// @ts-expect-error - TS2322 - Type '(arg1: Readonly<{ agile: Agile; context: ContextState; entities: Readonly<{ applicationRoles?: ApplicationRole[] | undefined; cardCover: CardCover; childrenIssues: ChildrenIssuesState; ... 29 more ...; myPreferences?: Partial<...> | undefined; }>; ... 5 more ...; validators: Validators; }>) => any' is not assignable to type 'OutputSelector<Readonly<{ agile: Agile; context: ContextState; entities: Readonly<{ applicationRoles?: ApplicationRole[] | undefined; cardCover: CardCover; childrenIssues: ChildrenIssuesState; ... 29 more ...; myPreferences?: Partial<...> | undefined; }>; ... 5 more ...; validators: Validators; }>, undefined, IssueT...'.
const $6915515a9b677dd8$var$parentLevelValueSelector = (0, $fokFV.fieldPersistedValueSelector)((0, $lO4Or.HIERARCHY_LEVEL_ABOVE)) || null;
const $6915515a9b677dd8$export$55a6507420d37093 = (0, $df4Sl.createSelector)(// @ts-expect-error - TS2769 - No overload matches this call.
$6915515a9b677dd8$var$parentLevelValueSelector, (parentLevelValue)=>parentLevelValue && (parentLevelValue.name || null));
const $6915515a9b677dd8$export$be50776e2ae27cf6 = (0, $df4Sl.createSelector)(// @ts-expect-error - TS2769 - No overload matches this call.
$6915515a9b677dd8$var$parentLevelValueSelector, (parentLevelValue)=>parentLevelValue && parentLevelValue.issueTypeIds.map(String) || []);
const $6915515a9b677dd8$export$57b3549670d3627b = (0, $df4Sl.createSelector)(// @ts-expect-error - TS2769 - No overload matches this call.
$6915515a9b677dd8$var$parentLevelValueSelector, (parentLevelValue)=>parentLevelValue && parentLevelValue.issueTypes.map((type)=>type.name).filter((name)=>name) || []);
const $6915515a9b677dd8$export$121e4a84c99db916 = (0, $df4Sl.createSelector)($6915515a9b677dd8$export$be50776e2ae27cf6, (parentLevelValue)=>parentLevelValue.length > 0);
// @ts-expect-error - TS2322 - Type '(arg1: Readonly<{ agile: Agile; context: ContextState; entities: Readonly<{ applicationRoles?: ApplicationRole[] | undefined; cardCover: CardCover; childrenIssues: ChildrenIssuesState; ... 29 more ...; myPreferences?: Partial<...> | undefined; }>; ... 5 more ...; validators: Validators; }>) => any' is not assignable to type 'OutputSelector<Readonly<{ agile: Agile; context: ContextState; entities: Readonly<{ applicationRoles?: ApplicationRole[] | undefined; cardCover: CardCover; childrenIssues: ChildrenIssuesState; ... 29 more ...; myPreferences?: Partial<...> | undefined; }>; ... 5 more ...; validators: Validators; }>, undefined, IssueT...'.
const $6915515a9b677dd8$var$sameLevelValueSelector = (0, $fokFV.fieldPersistedValueSelector)((0, $lO4Or.HIERARCHY_LEVEL_SAME_LEVEL)) || null;
const $6915515a9b677dd8$export$26996c7f0f08c0d8 = (0, $df4Sl.createSelector)(// @ts-expect-error - TS2769 - No overload matches this call.
$6915515a9b677dd8$var$sameLevelValueSelector, (sameLevelFieldValue)=>{
    if (!sameLevelFieldValue) return false;
    return (0, $3l6tm.isSubtaskHierarchyLevel)(sameLevelFieldValue.level);
});
const $6915515a9b677dd8$export$a81bfe971074142b = (0, $df4Sl.createSelector)(// @ts-expect-error - TS2769 - No overload matches this call.
$6915515a9b677dd8$var$sameLevelValueSelector, (sameLevelFieldValue)=>sameLevelFieldValue ? sameLevelFieldValue.issueTypeIds.map(String) : []);
const $6915515a9b677dd8$export$4f7eb1d272a8015 = (0, $df4Sl.createSelector)(// @ts-expect-error - TS2769 - No overload matches this call.
$6915515a9b677dd8$var$sameLevelValueSelector, (sameLevelFieldValue)=>sameLevelFieldValue ? (0, $3l6tm.toHierarchyLevel)(sameLevelFieldValue.level) : null);
const $6915515a9b677dd8$export$d9c73da87a448c4 = (0, $df4Sl.createSelector)($6915515a9b677dd8$export$4f7eb1d272a8015, (level)=>{
    if (level == null) // Some product types (JSM, Core, ...) do not support hierarchies at all and will not return this field.
    // For these, all issues are considered to be "Base" level.
    return true;
    return (0, $3l6tm.isBaseHierarchyLevel)(level);
});
const $6915515a9b677dd8$export$5530450eb840ecb2 = (0, $df4Sl.createSelector)($6915515a9b677dd8$export$55a6507420d37093, (0, $7FqHc.canEditIssuesSelector), $6915515a9b677dd8$export$121e4a84c99db916, (parentLevelName, shouldShowAddParent, hasParentIssueTypeId)=>Boolean(parentLevelName) && shouldShowAddParent && hasParentIssueTypeId);

});
parcelRegister("3l6tm", function(module, exports) {

$parcel$export(module.exports, "ISSUE_HIERARCHY_LEVEL_GOAL", () => $493876d3567385f4$export$2294cfc7730248df);
$parcel$export(module.exports, "ISSUE_HIERARCHY_LEVEL_STRATEGY", () => $493876d3567385f4$export$961a1d6da881600c);
$parcel$export(module.exports, "ISSUE_HIERARCHY_LEVEL_INITIATIVE", () => $493876d3567385f4$export$e11dea67b88ee556);
$parcel$export(module.exports, "ISSUE_HIERARCHY_LEVEL_EPIC", () => $493876d3567385f4$export$9ad20e435294162a);
$parcel$export(module.exports, "ISSUE_HIERARCHY_LEVEL_BASE", () => $493876d3567385f4$export$a454b3474c5ee5f5);
$parcel$export(module.exports, "ISSUE_HIERARCHY_LEVEL_SUBTASK", () => $493876d3567385f4$export$b69c1b48ce8f83de);
$parcel$export(module.exports, "BASE_HIERARCHY_TYPE", () => $493876d3567385f4$export$ba7c785763a2a58f);
$parcel$export(module.exports, "CHILD_HIERARCHY_TYPE", () => $493876d3567385f4$export$e09d07f2dcff2603);
$parcel$export(module.exports, "PARENT_HIERARCHY_TYPE", () => $493876d3567385f4$export$1165245f61159842);
$parcel$export(module.exports, "EPIC_PARENT_HIERARCHY_TYPE", () => $493876d3567385f4$export$8a96a83b3f957e58);
$parcel$export(module.exports, "toHierarchyLevel", () => $493876d3567385f4$export$c0c893ca5ccae9dd);
$parcel$export(module.exports, "isBaseHierarchyLevel", () => $493876d3567385f4$export$bcf91a9d8c5b0f58);
$parcel$export(module.exports, "isEpicHierarchyLevel", () => $493876d3567385f4$export$e415cf60723c7aae);
$parcel$export(module.exports, "isSubtaskHierarchyLevel", () => $493876d3567385f4$export$41f00a40e2ebd6e8);
$parcel$export(module.exports, "getHierarchyLevelType", () => $493876d3567385f4$export$556b686fea6fb229);
$parcel$export(module.exports, "getHierarchyLevelTypeSplitEpicFromCustom", () => $493876d3567385f4$export$638ac52227e67c8);
const $493876d3567385f4$export$2294cfc7730248df = 4;
const $493876d3567385f4$export$961a1d6da881600c = 3;
const $493876d3567385f4$export$e11dea67b88ee556 = 2;
const $493876d3567385f4$export$9ad20e435294162a = 1;
const $493876d3567385f4$export$a454b3474c5ee5f5 = 0;
const $493876d3567385f4$export$b69c1b48ce8f83de = -1;
const $493876d3567385f4$export$ba7c785763a2a58f = 'BASE';
const $493876d3567385f4$export$e09d07f2dcff2603 = 'CHILD';
const $493876d3567385f4$export$1165245f61159842 = 'PARENT';
const $493876d3567385f4$export$8a96a83b3f957e58 = 'EPIC';
const $493876d3567385f4$export$c0c893ca5ccae9dd = (level)=>level;
const $493876d3567385f4$export$bcf91a9d8c5b0f58 = (level)=>{
    const numericLevel = Number(level);
    if (Number.isNaN(numericLevel)) return true;
    return numericLevel === $493876d3567385f4$export$a454b3474c5ee5f5;
};
const $493876d3567385f4$export$e415cf60723c7aae = (level)=>{
    const numericLevel = Number(level);
    if (Number.isNaN(numericLevel)) return false;
    return numericLevel === $493876d3567385f4$export$9ad20e435294162a;
};
const $493876d3567385f4$export$41f00a40e2ebd6e8 = (level)=>{
    const numericLevel = Number(level);
    if (Number.isNaN(numericLevel)) return false;
    return numericLevel === $493876d3567385f4$export$b69c1b48ce8f83de;
};
const $493876d3567385f4$export$556b686fea6fb229 = (hierarchyLevel)=>{
    if (Number(hierarchyLevel) > 0) return $493876d3567385f4$export$1165245f61159842;
    if (Number(hierarchyLevel) < 0) return $493876d3567385f4$export$e09d07f2dcff2603;
    return $493876d3567385f4$export$ba7c785763a2a58f;
};
const $493876d3567385f4$export$638ac52227e67c8 = (hierarchyLevel)=>{
    if (Number(hierarchyLevel) === 1) return $493876d3567385f4$export$8a96a83b3f957e58;
    if (Number(hierarchyLevel) > 1) return $493876d3567385f4$export$1165245f61159842;
    if (Number(hierarchyLevel) < 0) return $493876d3567385f4$export$e09d07f2dcff2603;
    return $493876d3567385f4$export$ba7c785763a2a58f;
};

});

parcelRegister("7FqHc", function(module, exports) {

$parcel$export(module.exports, "canEditIssuesSelector", () => $82be12fe73ce8456$export$cdd6892c8add3e54);
$parcel$export(module.exports, "canLinkIssuesSelector", () => $82be12fe73ce8456$export$50487d0d29271836);

var $df4Sl = parcelRequire("df4Sl");

var $9F6MO = parcelRequire("9F6MO");
const $82be12fe73ce8456$export$a7a483ca0afc4ab3 = (0, $df4Sl.createSelector)((0, $9F6MO.permissionsSelector), (permissions)=>permissions.canCloneIssue);
const $82be12fe73ce8456$export$c1f4ef01259b4eb = (0, $df4Sl.createSelector)((0, $9F6MO.permissionsSelector), (permissions)=>permissions.canDeleteIssue);
const $82be12fe73ce8456$export$2f9dd165cbf0c5ea = (0, $df4Sl.createSelector)((0, $9F6MO.permissionsSelector), (permissions)=>permissions.canMoveIssue);
const $82be12fe73ce8456$export$cdd6892c8add3e54 = (0, $df4Sl.createSelector)((0, $9F6MO.permissionsSelector), (permissions)=>permissions.canEditIssues);
const $82be12fe73ce8456$export$f48030c6644c0c4d = (0, $df4Sl.createSelector)((0, $9F6MO.permissionsSelector), (permissions)=>permissions.canAdministerJira || permissions.canAdministerProject);
const $82be12fe73ce8456$export$4e8dac873f71d13e = (0, $df4Sl.createSelector)((0, $9F6MO.permissionsSelector), (permissions)=>permissions.canAssignIssues);
const $82be12fe73ce8456$export$50487d0d29271836 = (0, $df4Sl.createSelector)((0, $9F6MO.permissionsSelector), (permissions)=>permissions.canLinkIssues);

});


parcelRegister("cj1Xt", function(module, exports) {

$parcel$export(module.exports, "ecosystemCustomFieldIdsSelector", () => $c6007774372d78ef$export$c16e6010c2ccc7b2);

var $df4Sl = parcelRequire("df4Sl");

var $btjMs = parcelRequire("btjMs");

var $f9RL0 = parcelRequire("f9RL0");

var $fokFV = parcelRequire("fokFV");
const $c6007774372d78ef$export$1caf4359a6680b64 = (0, $df4Sl.createSelector)((0, $fokFV.fieldsSelector), (fields)=>Object.keys(fields).filter((id)=>{
        const type = (0, $btjMs.getFieldType)(fields[id]);
        return type && (0, $f9RL0.customFieldsToDisplay)().includes(type);
    }));
const $c6007774372d78ef$export$c16e6010c2ccc7b2 = (0, $df4Sl.createSelector)((0, $fokFV.fieldsSelector), (fields)=>Object.keys(fields).filter((id)=>{
        const type = (0, $btjMs.getFieldType)(fields[id]);
        return type && (0, $f9RL0.ecosystemCustomFields).includes(type);
    }));

});

parcelRegister("dmojD", function(module, exports) {

$parcel$export(module.exports, "entitiesCommentsSelector", () => $2fc412f4c8af7d4e$export$2bcb958351592bb9);
$parcel$export(module.exports, "totalCommentsSelector", () => $2fc412f4c8af7d4e$export$3873a5701cda7746);
$parcel$export(module.exports, "startIndexCommentsSelector", () => $2fc412f4c8af7d4e$export$10621129a0e171e5);
$parcel$export(module.exports, "loadedCommentsSelector", () => $2fc412f4c8af7d4e$export$c3802eebab78988b);
$parcel$export(module.exports, "isLoadingMoreCommentsSelector", () => $2fc412f4c8af7d4e$export$5d4ebbdab84a3a1);
$parcel$export(module.exports, "hasScrolledPermalinkCommentSelector", () => $2fc412f4c8af7d4e$export$3190c124f9d4af8a);
$parcel$export(module.exports, "loadingStageSelector", () => $2fc412f4c8af7d4e$export$18bc980d36bf93d);
$parcel$export(module.exports, "commentAuthorSelector", () => $2fc412f4c8af7d4e$export$6f6ac03c75ab3545);
$parcel$export(module.exports, "commentUpdateAuthorSelector", () => $2fc412f4c8af7d4e$export$7190d6fab16715b8);
$parcel$export(module.exports, "commentEditingBodySelector", () => $2fc412f4c8af7d4e$export$3e2634438f2a9b1a);
$parcel$export(module.exports, "commentEditingVisibilitySelector", () => $2fc412f4c8af7d4e$export$3c2f8c0a34054ef7);
$parcel$export(module.exports, "commentEditingOrViewBodyAdfSelector", () => $2fc412f4c8af7d4e$export$b0e0bc0c48cf00e6);
$parcel$export(module.exports, "commentOutsiderCommentSelector", () => $2fc412f4c8af7d4e$export$e7022c391905c53f);
$parcel$export(module.exports, "commentBodyHtmlSelector", () => $2fc412f4c8af7d4e$export$b9c6e85825c49cba);
$parcel$export(module.exports, "commentCreatedDateSelector", () => $2fc412f4c8af7d4e$export$b580f3d971b4e6fb);
$parcel$export(module.exports, "commentUpdatedDateSelector", () => $2fc412f4c8af7d4e$export$8b9935e49715b2d6);
$parcel$export(module.exports, "commentEditedSelector", () => $2fc412f4c8af7d4e$export$eff4fd551b2f55a1);
$parcel$export(module.exports, "pendingCommentSelector", () => $2fc412f4c8af7d4e$export$d63578bef1057cae);
$parcel$export(module.exports, "commentIsOptimisticSelector", () => $2fc412f4c8af7d4e$export$be047268481f07d8);
$parcel$export(module.exports, "commentSaveFailedSelector", () => $2fc412f4c8af7d4e$export$72075ae8ef4d6f6a);
$parcel$export(module.exports, "commentHasDeleteModalSelector", () => $2fc412f4c8af7d4e$export$c756ab72f25508bb);
$parcel$export(module.exports, "commentVisibilitySelector", () => $2fc412f4c8af7d4e$export$2cf9d22f626e5db0);
$parcel$export(module.exports, "commentEditingOrViewVisibilitySelector", () => $2fc412f4c8af7d4e$export$82fbf902093fe491);
$parcel$export(module.exports, "commentEditingEventOccurredAtSelector", () => $2fc412f4c8af7d4e$export$d820e1c3ac105e35);
$parcel$export(module.exports, "commentEventOccurredAtSelector", () => $2fc412f4c8af7d4e$export$9c8937d1bd8cf4a);
$parcel$export(module.exports, "commentJsdIncidentActivityViewHiddenSelector", () => $2fc412f4c8af7d4e$export$8c7be677b9a2cbf3);
$parcel$export(module.exports, "isInternalCommentSelector", () => $2fc412f4c8af7d4e$export$b99aa78c1374f9fe);
$parcel$export(module.exports, "isEditingInternalCommentSelector", () => $2fc412f4c8af7d4e$export$54205c8c886a2b43);
$parcel$export(module.exports, "canAddCommentsSelector", () => $2fc412f4c8af7d4e$export$a34c155854eb296b);
$parcel$export(module.exports, "canDeleteCommentSelector", () => $2fc412f4c8af7d4e$export$8cc876bb72dc09b7);
$parcel$export(module.exports, "canEditCommentSelector", () => $2fc412f4c8af7d4e$export$eb110f3a00a8432);
$parcel$export(module.exports, "visibleCommentIdsSelector", () => $2fc412f4c8af7d4e$export$3b3d01d442cb684a);
$parcel$export(module.exports, "sortedVisibleCommentIdsSelector", () => $2fc412f4c8af7d4e$export$81c523e14f04df2d);
$parcel$export(module.exports, "isEditingCommentSelector", () => $2fc412f4c8af7d4e$export$6eba3f548a7f384e);
$parcel$export(module.exports, "getEditingCommentIdsSelector", () => $2fc412f4c8af7d4e$export$3a00787e516c672c);
$parcel$export(module.exports, "commentIdsSelector", () => $2fc412f4c8af7d4e$export$4c04cd370caea884);
$parcel$export(module.exports, "isEditingAnyCommentSelector", () => $2fc412f4c8af7d4e$export$2e24e984817b4c7b);
$parcel$export(module.exports, "isAddCommentEditorExpandedSelector", () => $2fc412f4c8af7d4e$export$5373a6bfd674797c);
$parcel$export(module.exports, "addCommentEditorForceFocusSelector", () => $2fc412f4c8af7d4e$export$37aee7d1ec9d42d3);
$parcel$export(module.exports, "isCommentEditorOpenSelector", () => $2fc412f4c8af7d4e$export$6df0ef2ac2b35c13);
$parcel$export(module.exports, "isCommentAttachmentInProgressSelector", () => $2fc412f4c8af7d4e$export$f140c5c89826efc6);
$parcel$export(module.exports, "isCommentVisibilityRestrictionSupportedSelector", () => $2fc412f4c8af7d4e$export$2ce513eb85289331);

var $df4Sl = parcelRequire("df4Sl");

var $hvbu2 = parcelRequire("hvbu2");

var $78IOp = parcelRequire("78IOp");

var $kirCf = parcelRequire("kirCf");

var $7ZZxN = parcelRequire("7ZZxN");

var $1ybV0 = parcelRequire("1ybV0");


var $f6MOn = parcelRequire("f6MOn");

var $8aR1q = parcelRequire("8aR1q");

var $5JqpU = parcelRequire("5JqpU");

var $jZDJX = parcelRequire("jZDJX");

var $9F6MO = parcelRequire("9F6MO");

var $gIyTt = parcelRequire("gIyTt");

var $gzLYm = parcelRequire("gzLYm");
const $2fc412f4c8af7d4e$export$9832028921909a8f = (0, $df4Sl.createSelector)((0, $jZDJX.uiSelector), (ui)=>ui.comments.pendingDeletedIds);
const $2fc412f4c8af7d4e$export$2bcb958351592bb9 = (0, $df4Sl.createSelector)((0, $jZDJX.entitiesSelector), (entities)=>entities.comments);
const $2fc412f4c8af7d4e$export$3873a5701cda7746 = (0, $df4Sl.createSelector)((0, $jZDJX.entitiesSelector), (entities)=>entities.totalComments);
const $2fc412f4c8af7d4e$export$10621129a0e171e5 = (0, $df4Sl.createSelector)((0, $jZDJX.entitiesSelector), (entities)=>entities.commentsStartIndex);
const $2fc412f4c8af7d4e$export$c3802eebab78988b = (0, $df4Sl.createSelector)((0, $jZDJX.entitiesSelector), (entities)=>entities.loadedComments);
const $2fc412f4c8af7d4e$export$5d4ebbdab84a3a1 = (0, $df4Sl.createSelector)((0, $jZDJX.uiSelector), (ui)=>ui.comments.isLoadingMoreComments);
const $2fc412f4c8af7d4e$export$3190c124f9d4af8a = (0, $df4Sl.createSelector)((0, $jZDJX.uiSelector), (ui)=>ui.comments.hasScrolledPermalinkComment);
const $2fc412f4c8af7d4e$export$cb15fb58f04e4339 = (0, $df4Sl.createSelector)((0, $jZDJX.uiSelector), (ui)=>ui.comments.pendingSavedValues);
const $2fc412f4c8af7d4e$var$deleteModalCommentIdSelector = (0, $df4Sl.createSelector)((0, $jZDJX.uiSelector), (ui)=>ui.comments.deleteModalCommentId);
const $2fc412f4c8af7d4e$export$18bc980d36bf93d = (0, $df4Sl.createSelector)((0, $jZDJX.uiSelector), (ui)=>ui.comments.loadingStage);
const $2fc412f4c8af7d4e$export$f82d111da9150583 = (0, $df4Sl.createSelector)($2fc412f4c8af7d4e$export$2bcb958351592bb9, $2fc412f4c8af7d4e$export$cb15fb58f04e4339, (comments, optimisticComments)=>({
        ...comments,
        ...optimisticComments
    }));
const $2fc412f4c8af7d4e$var$commentSelector = (commentId)=>(0, $df4Sl.createSelector)($2fc412f4c8af7d4e$export$f82d111da9150583, (comments)=>comments[commentId]);
// If the user is anonymous, then they are not considered comment author
const $2fc412f4c8af7d4e$var$isUserCommentAuthorSelector = (commentId)=>(0, $df4Sl.createSelector)($2fc412f4c8af7d4e$var$commentSelector(commentId), (0, $5JqpU.accountIdloggedInUserSelector), (comment, loggedInUserId)=>loggedInUserId !== null && loggedInUserId === (comment && comment.authorId));
const $2fc412f4c8af7d4e$var$authorSelector = (commentId, authorIdPropertyName)=>(0, $df4Sl.createSelector)($2fc412f4c8af7d4e$var$commentSelector(commentId), (0, $jZDJX.getUserByIdSelector), (comment, userByIdSelector)=>// @ts-expect-error - TS7053 - Element implicitly has an 'any' type because expression of type 'string' can't be used to index type 'OptimisticComment | PersistedComment'.
        comment && comment[authorIdPropertyName] ? userByIdSelector(comment[authorIdPropertyName]) : null);
const $2fc412f4c8af7d4e$var$uiAllCommentsSelector = (0, $df4Sl.createSelector)((0, $jZDJX.uiSelector), (ui)=>ui && ui.comments || null);
const $2fc412f4c8af7d4e$var$uiAllCommentEditorsSelector = (0, $df4Sl.createSelector)($2fc412f4c8af7d4e$var$uiAllCommentsSelector, (uiComments)=>uiComments && uiComments.commentEditors || null);
const $2fc412f4c8af7d4e$var$uiCommentEditorSelector = (commentId)=>(0, $df4Sl.createSelector)($2fc412f4c8af7d4e$var$uiAllCommentEditorsSelector, (uiCommentEditors)=>uiCommentEditors && uiCommentEditors[commentId] || null);
const $2fc412f4c8af7d4e$export$6f6ac03c75ab3545 = (commentId)=>$2fc412f4c8af7d4e$var$authorSelector(commentId, 'authorId');
const $2fc412f4c8af7d4e$export$7190d6fab16715b8 = (commentId)=>$2fc412f4c8af7d4e$var$authorSelector(commentId, 'updateAuthorId');
const $2fc412f4c8af7d4e$export$3e2634438f2a9b1a = (commentId)=>(0, $df4Sl.createSelector)($2fc412f4c8af7d4e$var$uiCommentEditorSelector(commentId), (comment)=>comment && comment.editingValue || null);
const $2fc412f4c8af7d4e$export$3c2f8c0a34054ef7 = (commentId)=>(0, $df4Sl.createSelector)($2fc412f4c8af7d4e$var$uiCommentEditorSelector(commentId), (comment)=>comment && comment.visibility || null);
const $2fc412f4c8af7d4e$export$b0e0bc0c48cf00e6 = (commentId)=>(0, $df4Sl.createSelector)($2fc412f4c8af7d4e$export$3e2634438f2a9b1a(commentId), $2fc412f4c8af7d4e$var$commentSelector(commentId), (editingComment, comment)=>editingComment || comment && comment.bodyAdf || null);
const $2fc412f4c8af7d4e$export$e7022c391905c53f = (commentId)=>(0, $df4Sl.createSelector)($2fc412f4c8af7d4e$var$commentSelector(commentId), (comment)=>comment ? comment.jsdAuthorCanSeeRequest : null);
const $2fc412f4c8af7d4e$export$b9c6e85825c49cba = (commentId)=>(0, $df4Sl.createSelector)($2fc412f4c8af7d4e$var$commentSelector(commentId), (comment)=>comment ? comment.bodyHtml : null);
const $2fc412f4c8af7d4e$export$b580f3d971b4e6fb = (commentId)=>(0, $df4Sl.createSelector)($2fc412f4c8af7d4e$var$commentSelector(commentId), (comment)=>comment ? comment.createdDate : null);
const $2fc412f4c8af7d4e$export$8b9935e49715b2d6 = (commentId)=>(0, $df4Sl.createSelector)($2fc412f4c8af7d4e$var$commentSelector(commentId), (comment)=>comment ? comment.updatedDate : null);
const $2fc412f4c8af7d4e$export$eff4fd551b2f55a1 = (commentId)=>(0, $df4Sl.createSelector)($2fc412f4c8af7d4e$var$commentSelector(commentId), (comment)=>comment ? comment.edited : null);
const $2fc412f4c8af7d4e$export$d63578bef1057cae = (commentId)=>(0, $df4Sl.createSelector)($2fc412f4c8af7d4e$export$cb15fb58f04e4339, (pendingComments)=>pendingComments[commentId]);
const $2fc412f4c8af7d4e$export$be047268481f07d8 = (commentId)=>(0, $df4Sl.createSelector)($2fc412f4c8af7d4e$export$d63578bef1057cae(commentId), (pendingComment)=>!!pendingComment);
const $2fc412f4c8af7d4e$export$72075ae8ef4d6f6a = (commentId)=>(0, $df4Sl.createSelector)($2fc412f4c8af7d4e$export$d63578bef1057cae(commentId), (pendingComment)=>!!(pendingComment && pendingComment.hasSaveFailed));
const $2fc412f4c8af7d4e$export$c756ab72f25508bb = (commentId)=>(0, $df4Sl.createSelector)($2fc412f4c8af7d4e$var$deleteModalCommentIdSelector, (deleteModalCommentId)=>deleteModalCommentId === commentId);
const $2fc412f4c8af7d4e$export$2cf9d22f626e5db0 = (commentId)=>(0, $df4Sl.createSelector)($2fc412f4c8af7d4e$var$commentSelector(commentId), (comment)=>comment ? comment.visibility : (0, $f6MOn.COMMENT_VISIBILITY_PUBLIC));
const $2fc412f4c8af7d4e$var$commentIsInternalSelector = (commentId)=>(0, $df4Sl.createSelector)($2fc412f4c8af7d4e$var$commentSelector(commentId), (comment)=>comment ? comment.isInternal : false);
const $2fc412f4c8af7d4e$export$82fbf902093fe491 = (commentId)=>(0, $df4Sl.createSelector)($2fc412f4c8af7d4e$export$3c2f8c0a34054ef7(commentId), $2fc412f4c8af7d4e$export$2cf9d22f626e5db0(commentId), (editingVisibility, visibility)=>editingVisibility || visibility);
const $2fc412f4c8af7d4e$export$d820e1c3ac105e35 = (commentId)=>(0, $df4Sl.createSelector)($2fc412f4c8af7d4e$var$uiCommentEditorSelector(commentId), (comment)=>comment && comment.eventOccurredAt || null);
const $2fc412f4c8af7d4e$export$9c8937d1bd8cf4a = (commentId)=>(0, $df4Sl.createSelector)($2fc412f4c8af7d4e$var$commentSelector(commentId), (comment)=>comment && comment.eventOccurredAt ? comment.eventOccurredAt : null);
const $2fc412f4c8af7d4e$export$9b5c22d8443e21d6 = (commentId)=>(0, $df4Sl.createSelector)($2fc412f4c8af7d4e$export$d820e1c3ac105e35(commentId), $2fc412f4c8af7d4e$export$9c8937d1bd8cf4a(commentId), (editingEventOccurredAt, eventOccurredAt)=>editingEventOccurredAt || eventOccurredAt);
const $2fc412f4c8af7d4e$export$8c7be677b9a2cbf3 = (commentId)=>(0, $df4Sl.createSelector)($2fc412f4c8af7d4e$var$commentSelector(commentId), (comment)=>comment && typeof comment.jsdIncidentActivityViewHidden === 'boolean' ? comment.jsdIncidentActivityViewHidden : null);
const $2fc412f4c8af7d4e$export$b99aa78c1374f9fe = (commentId)=>(0, $df4Sl.createSelector)((0, $5JqpU.isServiceDeskSelector), $2fc412f4c8af7d4e$var$commentIsInternalSelector(commentId), (isServiceDeskComment, isInternal)=>isServiceDeskComment && isInternal);
const $2fc412f4c8af7d4e$export$54205c8c886a2b43 = (commentId)=>(0, $df4Sl.createSelector)($2fc412f4c8af7d4e$var$uiCommentEditorSelector(commentId), (commentEditor)=>commentEditor?.isInternal ?? true);
const $2fc412f4c8af7d4e$export$a34c155854eb296b = (0, $df4Sl.createSelector)((0, $9F6MO.permissionsSelector), (permissions)=>permissions.canAddComments);
const $2fc412f4c8af7d4e$export$8cc876bb72dc09b7 = (commentId)=>(0, $df4Sl.createSelector)((0, $9F6MO.permissionsSelector), $2fc412f4c8af7d4e$var$isUserCommentAuthorSelector(commentId), (permissions, isUserCommentAuthor)=>permissions.canDeleteAllComments || permissions.canDeleteOwnComments && isUserCommentAuthor);
const $2fc412f4c8af7d4e$export$eb110f3a00a8432 = (commentId)=>(0, $df4Sl.createSelector)((0, $9F6MO.permissionsSelector), $2fc412f4c8af7d4e$var$isUserCommentAuthorSelector(commentId), (permissions, isUserCommentAuthor)=>permissions.canEditAllComments || permissions.canEditOwnComments && isUserCommentAuthor);
const $2fc412f4c8af7d4e$var$mapIdToCommentSortInfo = (comments)=>(id)=>{
        const comment = comments[id];
        return {
            id: id,
            createdDate: new Date(comment.createdDate),
            eventOccurredAt: comment.eventOccurredAt ? new Date(comment.eventOccurredAt) : null
        };
    };
const $2fc412f4c8af7d4e$var$compareComments = (a, b)=>{
    if (a.eventOccurredAt && b.eventOccurredAt && (0, $78IOp.default)(a.eventOccurredAt, b.eventOccurredAt) === 0) return (0, $78IOp.default)(a.createdDate, b.createdDate);
    const dateForA = a.eventOccurredAt ? a.eventOccurredAt : a.createdDate;
    const dateForB = b.eventOccurredAt ? b.eventOccurredAt : b.createdDate;
    return (0, $78IOp.default)(dateForA, dateForB);
};
const $2fc412f4c8af7d4e$var$visibleCommentIdsSelectorOld = (0, $df4Sl.createSelector)($2fc412f4c8af7d4e$export$f82d111da9150583, $2fc412f4c8af7d4e$export$9832028921909a8f, (comments, deletedIds)=>{
    // filter out any comments currently pending deletion
    const nonDeletedCommentIds = Object.keys(comments).filter((id)=>!deletedIds.includes(id));
    // sort the remaining comment ids by their created date
    const sortedIds = nonDeletedCommentIds.map((id)=>({
            id: id,
            createdDate: new Date(comments[id].createdDate)
        })).sort((a, b)=>(0, $78IOp.default)(a.createdDate, b.createdDate)).map((comment)=>comment.id);
    return sortedIds;
});
const $2fc412f4c8af7d4e$var$visibleCommentIdsSelectorNew = (0, $df4Sl.createSelector)($2fc412f4c8af7d4e$export$f82d111da9150583, $2fc412f4c8af7d4e$export$9832028921909a8f, (comments, deletedIds)=>{
    // filter out any comments currently pending deletion
    const nonDeletedCommentIds = Object.keys(comments).filter((id)=>!deletedIds.includes(id));
    // sort the remaining comment ids by their created date
    const sortedIds = nonDeletedCommentIds.map($2fc412f4c8af7d4e$var$mapIdToCommentSortInfo(comments)).sort($2fc412f4c8af7d4e$var$compareComments).map((comment)=>comment.id);
    return sortedIds;
});
const $2fc412f4c8af7d4e$export$3b3d01d442cb684a = (0, $8aR1q.selectorWithCondition)((0, $gIyTt.isJsmTimelineEnabled), $2fc412f4c8af7d4e$var$visibleCommentIdsSelectorNew, $2fc412f4c8af7d4e$var$visibleCommentIdsSelectorOld);
const $2fc412f4c8af7d4e$var$compareCommentsInclSortOrderType = (sortOrderType)=>(a, b)=>{
        if (a.eventOccurredAt && b.eventOccurredAt && (0, $78IOp.default)(a.eventOccurredAt, b.eventOccurredAt) === 0) return sortOrderType === (0, $25476979aca7c7e0$export$e86669f498228fff) ? (0, $78IOp.default)(a.createdDate, b.createdDate) : (0, $kirCf.default)(a.createdDate, b.createdDate);
        const dateForA = a.eventOccurredAt ? a.eventOccurredAt : a.createdDate;
        const dateForB = b.eventOccurredAt ? b.eventOccurredAt : b.createdDate;
        return sortOrderType === (0, $25476979aca7c7e0$export$e86669f498228fff) ? (0, $78IOp.default)(dateForA, dateForB) : (0, $kirCf.default)(dateForA, dateForB);
    };
const $2fc412f4c8af7d4e$var$sortedVisibleCommentIdsSelectorOld = (0, $df4Sl.createSelector)((0, $gzLYm.getSelectedActivitySortOrder), $2fc412f4c8af7d4e$export$f82d111da9150583, $2fc412f4c8af7d4e$export$9832028921909a8f, (sortOrderType, comments, deletedIds)=>{
    // filter out any comments currently pending deletion
    const nonDeletedCommentIds = Object.keys(comments).filter((id)=>!deletedIds.includes(id));
    // sort the remaining comment ids by their created date
    const sortedIds = nonDeletedCommentIds.map((id)=>{
        const comment = comments[id];
        return {
            id: id,
            createdDate: new Date(comment.createdDate)
        };
    }).sort((a, b)=>sortOrderType === (0, $25476979aca7c7e0$export$e86669f498228fff) ? (0, $78IOp.default)(a.createdDate, b.createdDate) : (0, $kirCf.default)(a.createdDate, b.createdDate)).map((comment)=>comment.id);
    return sortedIds;
});
const $2fc412f4c8af7d4e$var$sortedVisibleCommentIdsSelectorNew = (0, $df4Sl.createSelector)((0, $gzLYm.getSelectedActivitySortOrder), $2fc412f4c8af7d4e$export$f82d111da9150583, $2fc412f4c8af7d4e$export$9832028921909a8f, (sortOrderType, comments, deletedIds)=>{
    // filter out any comments currently pending deletion
    const nonDeletedCommentIds = Object.keys(comments).filter((id)=>!deletedIds.includes(id));
    // sort the remaining comment ids by their created date
    const sortedIds = nonDeletedCommentIds.map($2fc412f4c8af7d4e$var$mapIdToCommentSortInfo(comments)).sort($2fc412f4c8af7d4e$var$compareCommentsInclSortOrderType(sortOrderType)).map((comment)=>comment.id);
    return sortedIds;
});
const $2fc412f4c8af7d4e$export$81c523e14f04df2d = (0, $8aR1q.selectorWithCondition)((0, $gIyTt.isJsmTimelineEnabled), $2fc412f4c8af7d4e$var$sortedVisibleCommentIdsSelectorNew, $2fc412f4c8af7d4e$var$sortedVisibleCommentIdsSelectorOld);
const $2fc412f4c8af7d4e$export$6eba3f548a7f384e = (commentId)=>(0, $df4Sl.createSelector)($2fc412f4c8af7d4e$var$uiCommentEditorSelector(commentId), (commentEditor)=>!!commentEditor && commentEditor.isEditing);
const $2fc412f4c8af7d4e$export$3a00787e516c672c = (0, $df4Sl.createSelector)($2fc412f4c8af7d4e$export$3b3d01d442cb684a, (state)=>state, (visibleCommentIds, state)=>visibleCommentIds.filter((commentId)=>$2fc412f4c8af7d4e$export$6eba3f548a7f384e(commentId)(state)));
const $2fc412f4c8af7d4e$export$4c04cd370caea884 = (0, $df4Sl.createSelector)($2fc412f4c8af7d4e$export$2bcb958351592bb9, (comments)=>comments ? Object.keys(comments).filter((key)=>typeof comments[key] === 'object') : []);
const $2fc412f4c8af7d4e$export$2e24e984817b4c7b = (0, $df4Sl.createSelector)($2fc412f4c8af7d4e$export$4c04cd370caea884, (state)=>state, (commentIds, state)=>commentIds.some((id)=>$2fc412f4c8af7d4e$export$6eba3f548a7f384e(id)(state)));
const $2fc412f4c8af7d4e$export$5373a6bfd674797c = (0, $df4Sl.createSelector)((0, $jZDJX.uiSelector), (ui)=>ui.comments.addCommentEditorExpand || false);
const $2fc412f4c8af7d4e$export$37aee7d1ec9d42d3 = (0, $df4Sl.createSelector)((0, $jZDJX.uiSelector), (ui)=>ui.comments.addCommentEditorForceFocus || 0);
const $2fc412f4c8af7d4e$export$6df0ef2ac2b35c13 = (0, $df4Sl.createSelector)($2fc412f4c8af7d4e$export$5373a6bfd674797c, $2fc412f4c8af7d4e$var$uiAllCommentEditorsSelector, (isAddCommentEditorExpanded, commentEditors)=>isAddCommentEditorExpanded || (commentEditors ? (0, (/*@__PURE__*/$parcel$interopDefault($hvbu2)))(commentEditors).some((editor)=>editor.isEditing) : false));
const $2fc412f4c8af7d4e$export$f140c5c89826efc6 = (0, $df4Sl.createSelector)((0, $jZDJX.uiSelector), (ui)=>ui.comments.isCommentAttachmentInProgress);
const $2fc412f4c8af7d4e$export$82d184f5a79c6a3d = (0, $df4Sl.createSelector)((0, $jZDJX.isSimplifiedProjectSelector), (0, $jZDJX.projectTypeSelector), (isSimplified, projectType)=>!isSimplified && (projectType === (0, $7ZZxN.CORE_PROJECT) || projectType === (0, $7ZZxN.SOFTWARE_PROJECT)));
const $2fc412f4c8af7d4e$export$e17f2dbd8456d708 = (0, $df4Sl.createSelector)((0, $jZDJX.isSimplifiedProjectSelector), (0, $jZDJX.projectTypeSelector), (isSimplified, projectType)=>!isSimplified && (projectType === (0, $7ZZxN.CORE_PROJECT) || projectType === (0, $7ZZxN.SOFTWARE_PROJECT) || projectType === (0, $7ZZxN.SERVICE_DESK_PROJECT)));
const $2fc412f4c8af7d4e$export$2ce513eb85289331 = (0, $8aR1q.selectorWithCondition)(()=>(0, $1ybV0.ff)('jsm-restrict-internal-comment-visibility'), $2fc412f4c8af7d4e$export$e17f2dbd8456d708, $2fc412f4c8af7d4e$export$82d184f5a79c6a3d);

});
// Activity sort order
const $25476979aca7c7e0$export$eda5fe8da1abb04c = 'NEWEST_FIRST';
const $25476979aca7c7e0$export$e86669f498228fff = 'OLDEST_FIRST';

parcelRegister("f6MOn", function(module, exports) {

$parcel$export(module.exports, "SAVE_COMMENT_LOADING", () => $125592c68d6a8334$export$ea56f55e95ac48c4);
$parcel$export(module.exports, "LOADING", () => $125592c68d6a8334$export$26d55645375ca9a);
$parcel$export(module.exports, "COMPLETE", () => $125592c68d6a8334$export$1660a2d7c2fff354);
$parcel$export(module.exports, "COMMENT_VISIBILITY_PUBLIC", () => $125592c68d6a8334$export$5dd24cf16d0bbf18);
$parcel$export(module.exports, "COMMENT_VISIBILITY_TYPE_PUBLIC", () => $b9bd3ab49fd3c4c9$export$a3863626f98a38c2);

const $125592c68d6a8334$export$34e5759f24cbaeac = (value)=>value;
const $125592c68d6a8334$export$ea56f55e95ac48c4 = 'SAVE_COMMENT_LOADING';
const $125592c68d6a8334$export$26d55645375ca9a = 'LOADING';
const $125592c68d6a8334$export$1660a2d7c2fff354 = 'COMPLETE';
const $125592c68d6a8334$export$5dd24cf16d0bbf18 = {
    type: (0, $b9bd3ab49fd3c4c9$export$a3863626f98a38c2),
    value: ''
};

});
const $b9bd3ab49fd3c4c9$export$537a061b2f9c8800 = 'group';
const $b9bd3ab49fd3c4c9$export$28a8bb936dce2def = 'role';
const $b9bd3ab49fd3c4c9$export$a3863626f98a38c2 = 'public';


parcelRegister("8aR1q", function(module, exports) {

$parcel$export(module.exports, "selectorWithCondition", () => $af2d2bdf884c8cd1$export$6be2ebff06b95055);
const $af2d2bdf884c8cd1$export$6be2ebff06b95055 = (condition, selectorTrue, selectorFalse)=>{
    const selector = (...args)=>{
        if (condition()) return selectorTrue(...args);
        return selectorFalse(...args);
    };
    return selector;
};

});

parcelRegister("gIyTt", function(module, exports) {

$parcel$export(module.exports, "isJsmTimelineEnabled", () => $b83585f211a8f289$export$575e1bf822db15b5);

var $1ybV0 = parcelRequire("1ybV0");
const $b83585f211a8f289$export$575e1bf822db15b5 = ()=>(0, $1ybV0.ff)('jsm-timelines-phase-2_70gja', false);

});

parcelRegister("gzLYm", function(module, exports) {

$parcel$export(module.exports, "getSelectedActivityItem", () => $297516f6b6fa6295$export$49b8848afae8c381);
$parcel$export(module.exports, "getSelectedActivitySortOrder", () => $297516f6b6fa6295$export$7091381d8f3bc5cc);

var $df4Sl = parcelRequire("df4Sl");

var $jZDJX = parcelRequire("jZDJX");
const $297516f6b6fa6295$var$getUiActivityFeed = (0, $df4Sl.createSelector)((0, $jZDJX.uiSelector), (ui)=>ui.activityFeed);
const $297516f6b6fa6295$export$49b8848afae8c381 = (0, $df4Sl.createSelector)($297516f6b6fa6295$var$getUiActivityFeed, (activityFeed)=>activityFeed.selectedActivityItem);
const $297516f6b6fa6295$export$7091381d8f3bc5cc = (0, $df4Sl.createSelector)($297516f6b6fa6295$var$getUiActivityFeed, (activityFeed)=>activityFeed.selectedActivitySortOrder);

});


parcelRegister("cFY86", function(module, exports) {

$parcel$export(module.exports, "isIssueLinksEnabledSelector", () => $a8031e8c92164db2$export$a8cf8910b8314c1a);
$parcel$export(module.exports, "remoteIssuesSelector", () => $a8031e8c92164db2$export$13978ee723866c4d);
$parcel$export(module.exports, "optimisticLinksDataSelector", () => $a8031e8c92164db2$export$819781ef7e99d6c7);
$parcel$export(module.exports, "hasCombinedIssueLinksSelector", () => $a8031e8c92164db2$export$8b1b2dfb6701d22c);
$parcel$export(module.exports, "combinedLinkedIssueCountSelector", () => $a8031e8c92164db2$export$7e10bfdc67ac9362);
$parcel$export(module.exports, "combinedLinksSelector", () => $a8031e8c92164db2$export$a101eb6fc884a8a0);
$parcel$export(module.exports, "issueLinkSelector", () => $a8031e8c92164db2$export$b82f4900195f5854);
$parcel$export(module.exports, "linkedIssueSelector", () => $a8031e8c92164db2$export$f5f26ceb5c86ee0);
$parcel$export(module.exports, "quickAddClickedCountSelector", () => $a8031e8c92164db2$export$d545d81c8e208408);
$parcel$export(module.exports, "isOpenedFromJsmSimilarIssuesSelector", () => $a8031e8c92164db2$export$3bf48255064c85d5);
$parcel$export(module.exports, "quickAddClickedIssueSelector", () => $a8031e8c92164db2$export$2c43c6abed5983de);
$parcel$export(module.exports, "shouldDisplayAddLinksSelector", () => $a8031e8c92164db2$export$5757979a0baa9c47);
$parcel$export(module.exports, "canCreateLinkedIssueSelector", () => $a8031e8c92164db2$export$99914e520087b170);

var $df4Sl = parcelRequire("df4Sl");

var $8blac = parcelRequire("8blac");

var $3LiTJ = parcelRequire("3LiTJ");

var $3cdA4 = parcelRequire("3cdA4");

var $1ybV0 = parcelRequire("1ybV0");

var $03XEB = parcelRequire("03XEB");

var $jZDJX = parcelRequire("jZDJX");

var $9HtxD = parcelRequire("9HtxD");
/**
 * selectors for issue links
 *
 * issue links state looks like
 * issueLinks: {
 *  issueLinks: [
 *      link1,
 *      link2
 *  ],
 *  linkedIssueKeys: ['KEY-1', 'KEY-2'],
 *  linkedIssues: {
 *      'KEY-1': issue1,
 *      'KEY-2': issue2
 *  }
 * }
 */ const $a8031e8c92164db2$var$issueLinksRootSelector = (0, $df4Sl.createSelector)((0, $jZDJX.entitiesSelector), (entities)=>entities.issueLinks);
const $a8031e8c92164db2$export$a8cf8910b8314c1a = (0, $df4Sl.createSelector)($a8031e8c92164db2$var$issueLinksRootSelector, (root)=>!!root);
const $a8031e8c92164db2$var$linksDataSelector = (0, $df4Sl.createSelector)($a8031e8c92164db2$var$issueLinksRootSelector, (issueLinks)=>issueLinks && issueLinks.issueLinks);
const $a8031e8c92164db2$export$13978ee723866c4d = (state)=>state.entities.remoteIssueLinks.remoteIssues;
const $a8031e8c92164db2$export$819781ef7e99d6c7 = (0, $df4Sl.createSelector)($a8031e8c92164db2$var$linksDataSelector, (issueLinks)=>issueLinks && (0, (/*@__PURE__*/$parcel$interopDefault($3LiTJ)))(issueLinks, (link)=>link.isOptimistic));
const $a8031e8c92164db2$var$linkedIssuesSelector = (0, $df4Sl.createSelector)($a8031e8c92164db2$var$issueLinksRootSelector, (issueLinks)=>issueLinks && issueLinks.linkedIssues);
const $a8031e8c92164db2$export$701dc165268e44de = (0, $df4Sl.createSelector)($a8031e8c92164db2$var$issueLinksRootSelector, (issueLinks)=>issueLinks?.linkedIssueKeys || []);
const $a8031e8c92164db2$export$3c65f67962ca81cc = (0, $df4Sl.createSelector)($a8031e8c92164db2$var$linksDataSelector, (links)=>!(0, (/*@__PURE__*/$parcel$interopDefault($8blac)))(links));
const $a8031e8c92164db2$export$8b1b2dfb6701d22c = (0, $df4Sl.createSelector)($a8031e8c92164db2$var$linksDataSelector, $a8031e8c92164db2$export$13978ee723866c4d, (links, remoteLinks)=>!(0, (/*@__PURE__*/$parcel$interopDefault($8blac)))(links) || !(0, (/*@__PURE__*/$parcel$interopDefault($8blac)))(remoteLinks));
const $a8031e8c92164db2$export$7e10bfdc67ac9362 = (0, $df4Sl.createSelector)($a8031e8c92164db2$export$701dc165268e44de, $a8031e8c92164db2$export$13978ee723866c4d, (links, remoteLinks)=>links.length + remoteLinks.length);
const $a8031e8c92164db2$export$f9c1778e36ca60f9 = (0, $df4Sl.createSelector)($a8031e8c92164db2$var$linksDataSelector, $a8031e8c92164db2$var$linkedIssuesSelector, (0, $9HtxD.jpdDeliverLinkTypeIdSelector), (links, issues, jpdDeliverLinkTypeId)=>{
    if (!(0, (/*@__PURE__*/$parcel$interopDefault($8blac)))(links)) return (0, (/*@__PURE__*/$parcel$interopDefault($3cdA4)))(links).filter((link)=>!link.isDeleted && !!link.linkedIssueKey)// Filter out links with jpd delivery link typeId and direction === "OUTWARD" and they are displayed in separate Ideas section
    .filter((link)=>(0, $1ybV0.ff)('polaris.jpd-panel-filter-by-delivery-link-type') ? !(jpdDeliverLinkTypeId && link.typeId === jpdDeliverLinkTypeId && link.direction === (0, $03XEB.OUTWARD_LINK_DIRECTION)) : true).map((link)=>({
            ...link,
            linkedIssue: issues[link.linkedIssueKey]
        })) // eslint-disable-next-line @typescript-eslint/no-explicit-any
    .reduce((linksMap, link)=>Object.assign(linksMap, {
            [link.typeName]: [
                ...linksMap[link.typeName] || [],
                link
            ]
        }), {});
    return null;
});
const $a8031e8c92164db2$export$a101eb6fc884a8a0 = (0, $df4Sl.createSelector)($a8031e8c92164db2$export$f9c1778e36ca60f9, $a8031e8c92164db2$export$13978ee723866c4d, (links, remoteIssues)=>{
    if (links == null && remoteIssues.length === 0) return null;
    const extractBasicIssueDetails = (remoteIssueLinkEntity)=>({
            id: remoteIssueLinkEntity.remoteIssueId,
            issueKey: remoteIssueLinkEntity.issueKey,
            issueLink: remoteIssueLinkEntity.issueLinkUrl,
            issueSummary: remoteIssueLinkEntity.summary,
            issueTypeIconUrl: remoteIssueLinkEntity.iconUrl
        });
    // FIXME: JIV-15410 - expected to return IssueLink[]
    return remoteIssues.reduce((combinedLinks, remoteIssue)=>{
        const { issueDetails: issueDetails, relationship: relationship, id: id, issueKey: issueKey, issueLinkUrl: issueLinkUrl, remoteIssueLinkError: remoteIssueLinkError, globalId: globalId, isSaved: isSaved, isLoading: isLoading, isOptimistic: isOptimistic, hasError: hasError, isDeleted: isDeleted } = remoteIssue;
        if (relationship != null && isDeleted !== true) return {
            // eslint-disable-next-line jira/js/no-reduce-accumulator-spread
            ...combinedLinks,
            [relationship]: [
                ...combinedLinks[relationship] || [],
                {
                    id: id.toString(),
                    direction: (0, $03XEB.OUTWARD_LINK_DIRECTION),
                    typeName: relationship,
                    linkedIssueKey: issueKey,
                    linkedIssue: issueDetails || extractBasicIssueDetails(remoteIssue),
                    isRemote: true,
                    globalId: globalId,
                    remoteServerHostname: new URL(issueLinkUrl).hostname,
                    remoteIssueLinkError: remoteIssueLinkError,
                    isSaved: isSaved,
                    isLoading: isLoading,
                    isOptimistic: isOptimistic,
                    hasError: hasError
                }
            ]
        };
        return combinedLinks;
    }, {
        ...links
    });
});
const $a8031e8c92164db2$export$b82f4900195f5854 = (issueLinkId)=>(0, $df4Sl.createSelector)($a8031e8c92164db2$var$linksDataSelector, (links)=>links && links[issueLinkId] || null);
const $a8031e8c92164db2$export$f5f26ceb5c86ee0 = (issueKey)=>(0, $df4Sl.createSelector)($a8031e8c92164db2$var$linkedIssuesSelector, (linkedIssues)=>linkedIssues && linkedIssues[issueKey] || null);
const $a8031e8c92164db2$export$d545d81c8e208408 = (0, $df4Sl.createSelector)($a8031e8c92164db2$var$issueLinksRootSelector, (issueLinks)=>issueLinks && issueLinks.quickAddClicked);
const $a8031e8c92164db2$export$3bf48255064c85d5 = (0, $df4Sl.createSelector)($a8031e8c92164db2$var$issueLinksRootSelector, (issueLinks)=>!!issueLinks?.isOpenedFromJsmSimilarIssues);
const $a8031e8c92164db2$export$2c43c6abed5983de = (0, $df4Sl.createSelector)($a8031e8c92164db2$var$issueLinksRootSelector, (issueLinks)=>issueLinks && issueLinks.quickAddClickedIssue);
const $a8031e8c92164db2$export$5757979a0baa9c47 = (0, $df4Sl.createSelector)($a8031e8c92164db2$export$d545d81c8e208408, (count)=>!!count);
const $a8031e8c92164db2$export$99914e520087b170 = (0, $df4Sl.createSelector)($a8031e8c92164db2$var$issueLinksRootSelector, (issueLinks)=>issueLinks && issueLinks.canCreateLinkedIssue);

});
parcelRegister("3cdA4", function(module, exports) {

var $bQoXG = parcelRequire("bQoXG");

var $b69Sx = parcelRequire("b69Sx");

var $fjnSB = parcelRequire("fjnSB");

var $jxg5X = parcelRequire("jxg5X");

var $4ZYEI = parcelRequire("4ZYEI");

var $hQ6NY = parcelRequire("hQ6NY");

var $c1eMI = parcelRequire("c1eMI");

var $bAWWz = parcelRequire("bAWWz");

var $aSldm = parcelRequire("aSldm");

var $hvbu2 = parcelRequire("hvbu2");
/** `Object#toString` result references. */ var $253d06f861bc4c67$var$mapTag = '[object Map]', $253d06f861bc4c67$var$setTag = '[object Set]';
/** Built-in value references. */ var $253d06f861bc4c67$var$symIterator = $bQoXG ? $bQoXG.iterator : undefined;
/**
 * Converts `value` to an array.
 *
 * @static
 * @since 0.1.0
 * @memberOf _
 * @category Lang
 * @param {*} value The value to convert.
 * @returns {Array} Returns the converted array.
 * @example
 *
 * _.toArray({ 'a': 1, 'b': 2 });
 * // => [1, 2]
 *
 * _.toArray('abc');
 * // => ['a', 'b', 'c']
 *
 * _.toArray(1);
 * // => []
 *
 * _.toArray(null);
 * // => []
 */ function $253d06f861bc4c67$var$toArray(value) {
    if (!value) return [];
    if ($jxg5X(value)) return $4ZYEI(value) ? $aSldm(value) : $b69Sx(value);
    if ($253d06f861bc4c67$var$symIterator && value[$253d06f861bc4c67$var$symIterator]) return $hQ6NY(value[$253d06f861bc4c67$var$symIterator]());
    var tag = $fjnSB(value), func = tag == $253d06f861bc4c67$var$mapTag ? $c1eMI : tag == $253d06f861bc4c67$var$setTag ? $bAWWz : $hvbu2;
    return func(value);
}
module.exports = $253d06f861bc4c67$var$toArray;

});
parcelRegister("4ZYEI", function(module, exports) {

var $2OY5s = parcelRequire("2OY5s");

var $1c8hB = parcelRequire("1c8hB");

var $hYEMs = parcelRequire("hYEMs");
/** `Object#toString` result references. */ var $3a3be8dd1917bddc$var$stringTag = '[object String]';
/**
 * Checks if `value` is classified as a `String` primitive or object.
 *
 * @static
 * @since 0.1.0
 * @memberOf _
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a string, else `false`.
 * @example
 *
 * _.isString('abc');
 * // => true
 *
 * _.isString(1);
 * // => false
 */ function $3a3be8dd1917bddc$var$isString(value) {
    return typeof value == 'string' || !$1c8hB(value) && $hYEMs(value) && $2OY5s(value) == $3a3be8dd1917bddc$var$stringTag;
}
module.exports = $3a3be8dd1917bddc$var$isString;

});

parcelRegister("hQ6NY", function(module, exports) {
/**
 * Converts `iterator` to an array.
 *
 * @private
 * @param {Object} iterator The iterator to convert.
 * @returns {Array} Returns the converted array.
 */ function $cfcc92505e25a5f1$var$iteratorToArray(iterator) {
    var data, result = [];
    while(!(data = iterator.next()).done)result.push(data.value);
    return result;
}
module.exports = $cfcc92505e25a5f1$var$iteratorToArray;

});


parcelRegister("03XEB", function(module, exports) {

$parcel$export(module.exports, "INWARD_LINK_DIRECTION", () => $dc38a98d5f20359c$export$b5e2b68b0fa7f1c8);
$parcel$export(module.exports, "OUTWARD_LINK_DIRECTION", () => $dc38a98d5f20359c$export$5dec99d71ec794ba);
$parcel$export(module.exports, "BOTH_LINK_DIRECTION", () => $dc38a98d5f20359c$export$6cdcf74878b11d34);
$parcel$export(module.exports, "IssueLinkDirectionTypes", () => $dc38a98d5f20359c$export$4b7bcc27238c61b9);
const $dc38a98d5f20359c$export$b5e2b68b0fa7f1c8 = 'INWARD';
const $dc38a98d5f20359c$export$5dec99d71ec794ba = 'OUTWARD';
const $dc38a98d5f20359c$export$6cdcf74878b11d34 = 'BOTH';
const $dc38a98d5f20359c$export$4b7bcc27238c61b9 = {
    [$dc38a98d5f20359c$export$b5e2b68b0fa7f1c8]: $dc38a98d5f20359c$export$b5e2b68b0fa7f1c8,
    [$dc38a98d5f20359c$export$5dec99d71ec794ba]: $dc38a98d5f20359c$export$5dec99d71ec794ba,
    [$dc38a98d5f20359c$export$6cdcf74878b11d34]: $dc38a98d5f20359c$export$6cdcf74878b11d34
};

});

parcelRegister("9HtxD", function(module, exports) {

$parcel$export(module.exports, "jpdDeliverLinkTypeIdSelector", () => $bfa856540e4e60df$export$c25a0be5d19458d3);

var $df4Sl = parcelRequire("df4Sl");

var $jZDJX = parcelRequire("jZDJX");
const $bfa856540e4e60df$export$c25a0be5d19458d3 = (0, $df4Sl.createSelector)((0, $jZDJX.entitiesSelector), (entities)=>entities.jpdDeliveryIssueLinkTypeId);

});


parcelRegister("ke6cX", function(module, exports) {

$parcel$export(module.exports, "issueTypesSelector", () => $4a7e93d9a88b268c$export$f5378064bf877b95);
$parcel$export(module.exports, "hasUnsupportedType", () => $4a7e93d9a88b268c$export$1f59505fa2d77635);
$parcel$export(module.exports, "issueTypesForClassicProjectEpicSelector", () => $4a7e93d9a88b268c$export$a0efcb09d3e23dc1);
$parcel$export(module.exports, "fetchIssueTypesStatusSelector", () => $4a7e93d9a88b268c$export$bfbb65ccb13a16eb);

var $df4Sl = parcelRequire("df4Sl");

var $8blac = parcelRequire("8blac");

var $jZDJX = parcelRequire("jZDJX");

var $9D3Vo = parcelRequire("9D3Vo");
const $4a7e93d9a88b268c$export$f5378064bf877b95 = (0, $df4Sl.createSelector)((0, $jZDJX.entitiesSelector), (entities)=>entities.issueTypes);
// A collection of issue fields which are marked as `required`
// for the creation of an issue, but are considered as 'provided' since
// the data for these fields is supplied by JIRA.
const $4a7e93d9a88b268c$var$providedRequiredFields = [
    'summary',
    'issuetype',
    'parent',
    'project'
];
const $4a7e93d9a88b268c$var$isRequiredFieldProvided = (fieldName)=>$4a7e93d9a88b268c$var$providedRequiredFields.find((providedFieldName)=>fieldName === providedFieldName);
// A field is considered 'unsupported' if not provided by JIRA,
// has no default value, and is a `required` field.
const $4a7e93d9a88b268c$var$hasUnsupportedRequiredField = (fields)=>// @ts-expect-error - TS2769 - No overload matches this call.
    !!Object.keys(fields).find((fieldName)=>!$4a7e93d9a88b268c$var$isRequiredFieldProvided(fieldName) && // @ts-expect-error - TS2532 - Object is possibly 'undefined'.
        !fields[fieldName].hasDefaultValue && // @ts-expect-error - TS2532 - Object is possibly 'undefined'.
        fields[fieldName].required);
const $4a7e93d9a88b268c$export$1f59505fa2d77635 = (issueType)=>(0, (/*@__PURE__*/$parcel$interopDefault($8blac)))(issueType.fields) || $4a7e93d9a88b268c$var$hasUnsupportedRequiredField(issueType.fields);
const $4a7e93d9a88b268c$export$a0efcb09d3e23dc1 = (0, $df4Sl.createSelector)($4a7e93d9a88b268c$export$f5378064bf877b95, (0, $9D3Vo.issueTypeSelector), (0, $jZDJX.isEpicSelector), (issueTypes, currentIssueType, // @ts-expect-error - TS1016 - A required parameter cannot follow an optional parameter.
isCurrentIssueAnEpic)=>{
    const epicIssueTypeId = isCurrentIssueAnEpic && currentIssueType && currentIssueType.id;
    return issueTypes.filter(// @ts-expect-error - TS2367 - This condition will always return 'true' since the types 'number' and 'string | boolean | undefined' have no overlap.
    (issueType)=>!issueType.subtask && issueType.id !== epicIssueTypeId);
});
const $4a7e93d9a88b268c$export$bfbb65ccb13a16eb = (0, $df4Sl.createSelector)((0, $jZDJX.uiSelector), (ui)=>ui.fetchIssueTypesStatus);

});

parcelRegister("6Fp9G", function(module, exports) {

$parcel$export(module.exports, "subtaskTypesSelector", () => $d7237d4b8f5dc461$export$86a4f97fc27a0c44);
$parcel$export(module.exports, "isSubtaskTypesPresentSelector", () => $d7237d4b8f5dc461$export$9a147dcac364dd81);
$parcel$export(module.exports, "hasUnsupportedTypeSelector", () => $d7237d4b8f5dc461$export$3fbfbdcf57f34c2);

var $df4Sl = parcelRequire("df4Sl");

var $ke6cX = parcelRequire("ke6cX");
const $d7237d4b8f5dc461$export$86a4f97fc27a0c44 = (0, $df4Sl.createSelector)((0, $ke6cX.issueTypesSelector), (issueTypes)=>issueTypes.filter((type)=>type.subtask));
const $d7237d4b8f5dc461$export$9a147dcac364dd81 = (0, $df4Sl.createSelector)($d7237d4b8f5dc461$export$86a4f97fc27a0c44, (subtaskTypes)=>subtaskTypes.length >= 1);
const $d7237d4b8f5dc461$export$3fbfbdcf57f34c2 = (0, $df4Sl.createSelector)($d7237d4b8f5dc461$export$86a4f97fc27a0c44, (subtaskTypes)=>!!subtaskTypes.find((0, $ke6cX.hasUnsupportedType)));

});

parcelRegister("dv9do", function(module, exports) {

$parcel$export(module.exports, "isSubtaskSelector", () => $ebb19174331d951e$export$15fea4741156936);
$parcel$export(module.exports, "subtaskEntitiesSelector", () => $ebb19174331d951e$export$17e529874841c746);
$parcel$export(module.exports, "hasSubtasksSelector", () => $ebb19174331d951e$export$f363078714850fd9);
$parcel$export(module.exports, "canCreateSubtaskSelector", () => $ebb19174331d951e$export$151aaebeef1cfe63);

var $df4Sl = parcelRequire("df4Sl");

var $f9RL0 = parcelRequire("f9RL0");


var $5JqpU = parcelRequire("5JqpU");

var $fokFV = parcelRequire("fokFV");

var $jZDJX = parcelRequire("jZDJX");

var $9F6MO = parcelRequire("9F6MO");

var $eeyEP = parcelRequire("eeyEP");

var $1b2Vj = parcelRequire("1b2Vj");

var $9D3Vo = parcelRequire("9D3Vo");

var $kndnY = parcelRequire("kndnY");

var $6Fp9G = parcelRequire("6Fp9G");
const $ebb19174331d951e$export$15fea4741156936 = (0, $df4Sl.createSelector)((0, $9D3Vo.issueTypeSelector), (issueType)=>!!(issueType && issueType.subtask));
const $ebb19174331d951e$export$17e529874841c746 = (0, $df4Sl.createSelector)((0, $jZDJX.entitiesSelector), (entities)=>entities.subtasks);
const $ebb19174331d951e$export$f363078714850fd9 = (0, $df4Sl.createSelector)($ebb19174331d951e$export$17e529874841c746, (0, $fokFV.childIssuesLimitUrlSelector), (subtasks, getChildIssuesLimitUrl)=>subtasks.length > 0 || Boolean(getChildIssuesLimitUrl((0, $f9RL0.SUBTASKS))));
const $ebb19174331d951e$export$899afcd59181acbb = (0, $df4Sl.createSelector)((0, $jZDJX.isSimplifiedProjectSelector), (0, $1b2Vj.isIssueBaseLevel), (0, $eeyEP.hasChildrenIssuesSelector), $ebb19174331d951e$export$f363078714850fd9, (isSimplifiedProject, issueBaseLevel, hasChildrenIssues, hasSubtasks)=>isSimplifiedProject ? issueBaseLevel && hasChildrenIssues : hasSubtasks);
const $ebb19174331d951e$export$58b46fbc7ab224f6 = (0, $df4Sl.createSelector)((0, $6Fp9G.hasUnsupportedTypeSelector), (0, $kndnY.projectHasSubtaskValidatorsSelector), (hasRequiredFields, hasSubtaskValidators)=>hasRequiredFields || hasSubtaskValidators);
const $ebb19174331d951e$export$94f22e5d109e9b04 = (0, $df4Sl.createSelector)((0, $jZDJX.entitiesSelector), ({ jiraSettings: jiraSettings })=>jiraSettings.subtasksConfiguration.enabled);
const $ebb19174331d951e$export$151aaebeef1cfe63 = (0, $df4Sl.createSelector)((0, $9F6MO.permissionsSelector), $ebb19174331d951e$export$15fea4741156936, (0, $6Fp9G.isSubtaskTypesPresentSelector), $ebb19174331d951e$export$58b46fbc7ab224f6, (0, $5JqpU.isMobileSelector), (0, $5JqpU.isBitbucketSelector), (0, $5JqpU.isServiceDeskSelector), (0, $jZDJX.isSimplifiedProjectSelector), $ebb19174331d951e$export$94f22e5d109e9b04, (0, $jZDJX.projectSelector), ({ canCreateSubtask: canCreateSubtask }, isSubtask, typesPresent, shouldUseFallbackDialog, isMobile, isBitbucket, isServicedesk, isSimplified, subtasksEnabled, project)=>{
    const shouldHideForMobileOrBitbucket = shouldUseFallbackDialog ? isMobile || isBitbucket : false;
    const isProjectActive = (project?.projectStatus ?? (0, $5bd9e96e4d7e8aee$export$62113557945f790a)) === (0, $5bd9e96e4d7e8aee$export$62113557945f790a);
    const shouldShowSubtask = isServicedesk ? !isSimplified : true;
    return !!(canCreateSubtask && !isSubtask && typesPresent && !shouldHideForMobileOrBitbucket && shouldShowSubtask && subtasksEnabled && isProjectActive);
});

});
const $5bd9e96e4d7e8aee$export$62113557945f790a = 'PROJECT_ACTIVE';
const $5bd9e96e4d7e8aee$export$4ccc35479ba9ad1 = 'PROJECT_ARCHIVED';
const $5bd9e96e4d7e8aee$export$a95d71e582b8bc0 = 'PROJECT_TRASHED';

parcelRegister("eeyEP", function(module, exports) {

$parcel$export(module.exports, "hasChildrenIssuesSelector", () => $2579e5337c5b7c8d$export$29f34d4d7c528e9c);

var $df4Sl = parcelRequire("df4Sl");

var $8blac = parcelRequire("8blac");

var $lO4Or = parcelRequire("lO4Or");

var $fokFV = parcelRequire("fokFV");
const $2579e5337c5b7c8d$var$childrenIssueSelector = (0, $fokFV.fieldSelector)((0, $lO4Or.CHILDREN_ISSUES));
const $2579e5337c5b7c8d$export$29f34d4d7c528e9c = (0, $df4Sl.createSelector)($2579e5337c5b7c8d$var$childrenIssueSelector, (0, $fokFV.childIssuesLimitUrlSelector), (childrenIssues, getChildIssuesLimitUrl)=>childrenIssues ? !(0, (/*@__PURE__*/$parcel$interopDefault($8blac)))(childrenIssues.value) || Boolean(getChildIssuesLimitUrl((0, $lO4Or.CHILDREN_ISSUES))) : false);

});

parcelRegister("kndnY", function(module, exports) {

$parcel$export(module.exports, "projectHasSubtaskValidatorsSelector", () => $d92659ac5d07e0a6$export$ecfed315b19a7565);

var $df4Sl = parcelRequire("df4Sl");

const $d92659ac5d07e0a6$var$hasSubtaskValidators = (hasValidators)=>hasValidators.status === (0, $97086cfe7b0ec751$export$4c02edeb1b5e410a) && hasValidators.value;
const $d92659ac5d07e0a6$var$unknown = (hasValidators)=>hasValidators.status === (0, $97086cfe7b0ec751$export$26d55645375ca9a) || hasValidators.status === (0, $97086cfe7b0ec751$export$d71930f7f5807a72);
const $d92659ac5d07e0a6$export$ecfed315b19a7565 = (0, $df4Sl.createSelector)(// @ts-expect-error - TS2571 - Object is of type 'unknown'.
(state)=>state.validators, (validators)=>{
    const val = validators.projectHasSubtaskValidators;
    return $d92659ac5d07e0a6$var$hasSubtaskValidators(val) || $d92659ac5d07e0a6$var$unknown(val);
});

});
const $97086cfe7b0ec751$export$26d55645375ca9a = 'LOADING';
const $97086cfe7b0ec751$export$d71930f7f5807a72 = 'FAILED';
const $97086cfe7b0ec751$export$4c02edeb1b5e410a = 'LOADED';



parcelRegister("9s86T", function(module, exports) {

$parcel$export(module.exports, "getPermalinkTypeAndId", () => $6e310a2be6a89df8$export$f72cac1fa8a03e80);
$parcel$export(module.exports, "getPermalinkStatus", () => $6e310a2be6a89df8$export$f79ae8c396759c89);
$parcel$export(module.exports, "getUrlPermalinkParameter", () => $6e310a2be6a89df8$export$b66f3e03c722c21c);
$parcel$export(module.exports, "WORKLOG", () => (parcelRequire("6VKiL")).WORKLOG);
$parcel$export(module.exports, "COMMENTS", () => (parcelRequire("6VKiL")).COMMENTS);
$parcel$export(module.exports, "PermalinkType", () => (parcelRequire("6VKiL")).PermalinkType);

var $5iWql = parcelRequire("5iWql");

var $53ciZ = parcelRequire("53ciZ");

var $6VKiL = parcelRequire("6VKiL");
const $6e310a2be6a89df8$export$58d3deae755361f = (0, $5iWql.default)((searchString)=>{
    const params = (0, (/*@__PURE__*/$parcel$interopDefault($53ciZ))).parseUrl(searchString).query;
    if (params[(0, $6VKiL.PermalinkType).COMMENTS]) return {
        permalinkType: (0, $6VKiL.COMMENTS),
        permalinkId: params[(0, $6VKiL.PermalinkType).COMMENTS]
    };
    if (params[(0, $6VKiL.PermalinkType).WORKLOG]) return {
        permalinkType: (0, $6VKiL.WORKLOG),
        permalinkId: params[(0, $6VKiL.PermalinkType).WORKLOG]
    };
    return null;
});
const $6e310a2be6a89df8$export$f72cac1fa8a03e80 = ()=>$6e310a2be6a89df8$export$58d3deae755361f(window.location.search);
const $6e310a2be6a89df8$export$f79ae8c396759c89 = (targetPermalinkType)=>{
    const { permalinkId: permalinkId, permalinkType: permalinkType } = $6e310a2be6a89df8$export$f72cac1fa8a03e80() || {};
    const hasPermalink = permalinkType === targetPermalinkType && permalinkId != null;
    return {
        hasPermalink: hasPermalink,
        permalinkId: hasPermalink ? permalinkId : ''
    };
};
const $6e310a2be6a89df8$export$b66f3e03c722c21c = (id, permalinkType)=>{
    const pathName = window.location.pathname;
    let urlQueryParam = `?${permalinkType}=${id}`;
    // in backlogs/modal view, next-gen board view, or jsd queues view
    if (/\/jira\/software\/c\/projects\/[^/]*\/boards\/.*/.test(pathName) || /\/jira\/people\/.*\/boards\/.*/.test(pathName) || pathName === '/secure/RapidBoard.jspa' || pathName.startsWith('/jira/software/projects/') && pathName.split('/')[5] === 'boards' || pathName.startsWith('/jira/servicedesk/projects/') && pathName.split('/')[5] === 'queues') {
        const url = new URL(window.location.href);
        // delete the opposite to avoid doubling up param in url
        url.searchParams.delete(permalinkType === (0, $6VKiL.PermalinkType).WORKLOG ? (0, $6VKiL.PermalinkType).COMMENTS : (0, $6VKiL.PermalinkType).WORKLOG);
        url.searchParams.set(permalinkType, id);
        urlQueryParam = url.search;
    }
    return urlQueryParam;
};

});
parcelRegister("6VKiL", function(module, exports) {

$parcel$export(module.exports, "COMMENTS", () => $5c63d4511ab79db4$export$4cab9dfa8fc858f4);
$parcel$export(module.exports, "WORKLOG", () => $5c63d4511ab79db4$export$df36fc05622c402);
$parcel$export(module.exports, "PermalinkType", () => $5c63d4511ab79db4$export$b18d061fc042df1a);
const $5c63d4511ab79db4$export$4cab9dfa8fc858f4 = 'Comments';
const $5c63d4511ab79db4$export$df36fc05622c402 = 'Worklog';
const $5c63d4511ab79db4$export$b18d061fc042df1a = {
    COMMENTS: 'focusedCommentId',
    WORKLOG: 'focusedWorklogId'
};

});



parcelRegister("gU59E", function(module, exports) {

$parcel$export(module.exports, "default", () => $f78fb3da3b537c5c$export$2e2bcd8739ae039);
class $f78fb3da3b537c5c$export$2e2bcd8739ae039 {
    constructor(state){
        this.hasLoadedEditor = false;
        this.startTime = Math.floor(performance.now()) // start time in origin relative  millis
        ;
        this.immutableState = state;
        this.isLoadedWithPage = state.isLoadedWithPage;
    }
    lazyMetricsProps() {
        return this.immutableState.lazyMetricsProps;
    }
    getDataProvider() {
        return this.immutableState.dataProvider;
    }
    getIsFullIssue() {
        return this.immutableState.analyticsSource === 'full-issue';
    }
    getIsLoadedWithPage() {
        return this.immutableState.isLoadedWithPage;
    }
    setIsLoadedWithPage(newValue) {
        this.isLoadedWithPage = newValue;
    }
    getIsSPA() {
        return this.immutableState.isSPA;
    }
    getIsRecentIssue() {
        return this.immutableState.isRecentIssue;
    }
    getRecentIssuesCount() {
        return this.immutableState.recentIssuesCount;
    }
    getAnalyticsSource() {
        return this.immutableState.analyticsSource;
    }
    getCorrelationId() {
        return this.immutableState.correlationId;
    }
    getIssueScaleabilityReporter() {
        return this.immutableState.issueScaleabilityReporter;
    }
    getStartTime() {
        return this.startTime;
    }
    setPreviewEnd(end) {
        this.previewEnd = end === null ? 0 : Math.floor(end);
    }
    getPreviewEnd() {
        return this.previewEnd;
    }
    setFMP(end) {
        this.fmp = end === null ? 0 : Math.floor(end);
    }
    getFMP() {
        return this.fmp;
    }
    setInteractiveEnd(millisSinceEpoch) {
        this.interactiveEnd = millisSinceEpoch;
    }
    getInteractiveEnd() {
        return this.interactiveEnd;
    }
    setTrueInteractiveEnd(millisSinceEpoch) {
        this.trueInteractiveEnd = Math.floor(millisSinceEpoch);
    }
    getTrueInteractiveEnd() {
        return Math.floor(this.trueInteractiveEnd);
    }
    getHasLoadedEditor() {
        return this.hasLoadedEditor;
    }
    getIsInitial() {
        return this.getIsFullIssue() && !this.getIsSPA();
    }
    getLocation() {
        const { route: route } = this.immutableState;
        const routeName = route?.name;
        return routeName || '';
    }
}

});

parcelRegister("7YIVI", function(module, exports) {

$parcel$export(module.exports, "metricsStateSelector", () => $fe3be24289bfe219$export$8cfb2e5f509cb762);

var $df4Sl = parcelRequire("df4Sl");

var $01hTQ = parcelRequire("01hTQ");

var $5JqpU = parcelRequire("5JqpU");
const $fe3be24289bfe219$export$8cfb2e5f509cb762 = (0, $df4Sl.createSelector)((0, $5JqpU.applicationKeySelector), (0, $5JqpU.viewModeSelector), (0, $5JqpU.issueIdSelector), (analyticsKey, viewMode, issueId)=>({
        analyticsKey: analyticsKey,
        viewMode: (0, $01hTQ.getSafeViewMode)(viewMode),
        issueId: issueId
    }));

});
parcelRegister("01hTQ", function(module, exports) {

$parcel$export(module.exports, "getSafeViewMode", () => $36ca2814f036e464$export$abc152b4d639d329);
const $36ca2814f036e464$var$getViewMode = ()=>window.localStorage && window.localStorage.getItem('gh.ghx-issue-fragment-view-mode') || 'default';
const $36ca2814f036e464$var$mapPredefinedViewMode = (predefinedViewMode)=>{
    switch(predefinedViewMode){
        case 'MODAL':
            return 'modal';
        case 'SIDEBAR':
            return 'sidebar';
        default:
            return null;
    }
};
const $36ca2814f036e464$export$abc152b4d639d329 = (predefinedViewMode = null)=>$36ca2814f036e464$var$mapPredefinedViewMode(predefinedViewMode) || $36ca2814f036e464$var$getViewMode().replace(/"/g, '');

});



parcelRegister("asM86", function(module, exports) {

$parcel$export(module.exports, "default", () => $80b3f33d2d36e8da$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $jG2Eu = parcelRequire("jG2Eu");

var $7rh0R = parcelRequire("7rh0R");

var $hFmdR = parcelRequire("hFmdR");

var $gUUjF = parcelRequire("gUUjF");

var $1ybV0 = parcelRequire("1ybV0");

var $fE3Ua = parcelRequire("fE3Ua");

var $gJYxu = parcelRequire("gJYxu");

var $9mxRp = parcelRequire("9mxRp");

var $48mPv = parcelRequire("48mPv");
var $d7Wfe = parcelRequire("d7Wfe");
var $bsdZ2 = parcelRequire("bsdZ2");

var $bFzGY = parcelRequire("bFzGY");

var $lB25E = parcelRequire("lB25E");

var $iVSJI = parcelRequire("iVSJI");

var $6HEK3 = parcelRequire("6HEK3");

var $6WAxo = parcelRequire("6WAxo");

var $6vrw7 = parcelRequire("6vrw7");

var $90ZS3 = parcelRequire("90ZS3");
const $80b3f33d2d36e8da$var$isEcClientEnabled = ()=>{
    const experiences = (0, $1ybV0.getFeatureFlagValue)('hela.ec.client.integration.jsm', '').split(',');
    return Array.isArray(experiences) && experiences.includes('jsm-issue-view');
};

const $80b3f33d2d36e8da$export$8c70dcc4643464f8 = (0, $7rh0R.lazyForPaint)(()=>(parcelRequire("geiGJ")), {
    ssr: false,
    moduleId: "./src/packages/issue/issue-view/src/views/issue-details/issue-app.tsx"
});
const $80b3f33d2d36e8da$export$5aebed4b5cba826a = ({ backButtonUrl: backButtonUrl, issueNavigatorData: issueNavigatorData, issueKey: issueKey, onDispatchExternalActionRef: onDispatchExternalActionRef, onIssueDeleteSuccess: onIssueDeleteSuccess, analyticsSource: analyticsSource, ServiceDeskAnalyticsContext: ServiceDeskAnalyticsContext = (0, $iVSJI.ServiceDeskAnalyticsContext) })=>{
    const routerActions = (0, $lB25E.useRouterActions)();
    const [selectedIssueKey, setIssueKey] = (0, $90ZS3.useQueryParam)('selectedIssue');
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $bFzGY.useAnalyticsEvents)();
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    let saveIssueMutationToCache;
    if ($80b3f33d2d36e8da$var$isEcClientEnabled()) // eslint-disable-next-line react-hooks/rules-of-hooks
    saveIssueMutationToCache = (0, $bsdZ2.useEcClient)().saveIssueMutationToCache;
    const onIssueKeyChange = (data)=>{
        setIssueKey(data.toIssueKey);
        if ((0, $1ybV0.ff)('jsm-redirecting-issue-to-browse-url-when-old-key-is-invalid')) {
            (0, $gUUjF.default).safeInfoWithoutCustomerData('jsm.issue.view.issue-key-change', 'Invalid issue key, redirecting to correct issue key');
            routerActions.push(`/browse/${data.toIssueKey}`);
        }
    };
    const onChangeHandler = (event)=>{
        if ((0, $1ybV0.ff)('jsm-saveissuemutationtocache-refactor_oyhki', false)) (0, $6HEK3.saveIssueMutationAnalyticsToCache)(event, createAnalyticsEvent, saveIssueMutationToCache);
        else onChangeHandlerOld(event);
    };
    const onChangeHandlerOld = (event)=>{
        if ($80b3f33d2d36e8da$var$isEcClientEnabled() && event?.type === (0, $fE3Ua.ChangeEventTypes).FIELD_CHANGED) {
            const mutationFailedAnalyticsPayload = {
                errorMsg: 'FAILED_JSM_ISSUEVIEW',
                error: true
            };
            const analyticsEventObj = createAnalyticsEvent({});
            const analyticsDataKey = {
                analyticsEventObj: analyticsEventObj,
                analyticsMetadata: {
                    scenario: 'jsm-issue-view',
                    type: event.type
                }
            };
            saveIssueMutationToCache(new (0, $48mPv.default)(event?.issueId, (0, $d7Wfe.MutationSource).UPDATE), analyticsDataKey, mutationFailedAnalyticsPayload);
        }
    };
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $6WAxo.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(ServiceDeskAnalyticsContext, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $gJYxu.IssueBoundary), {
        packageName: "servicedesk-issue-view"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($80b3f33d2d36e8da$export$8c70dcc4643464f8, {
        onClose: (0, (/*@__PURE__*/$parcel$interopDefault($jG2Eu))),
        analyticsSource: analyticsSource,
        backButtonUrl: backButtonUrl,
        dispatchExternalActionRef: onDispatchExternalActionRef,
        shouldSetInitialFocus: true,
        isLoadedWithPage: true,
        issueKey: (0, $6vrw7.toIssueKey)(selectedIssueKey) || issueKey,
        onIssueDeleteSuccess: onIssueDeleteSuccess,
        onIssueKeyChange: onIssueKeyChange,
        issueMaxWidth: (0, $9mxRp.getIssueContainerMaxWidth)(),
        onChange: onChangeHandler,
        issueNavigatorData: issueNavigatorData
    }))));
};
const $80b3f33d2d36e8da$var$getAnalyticsSourceFromUrl = ()=>{
    const { pathname: pathname } = window.location;
    if (pathname.includes('reports')) return 'viewReportIssue';
    return 'viewQueueIssue';
};
const $80b3f33d2d36e8da$var$WrappedIssueView = (0, $hFmdR.AnalyticsSource)($80b3f33d2d36e8da$var$getAnalyticsSourceFromUrl(), (0, $41ea3621645e2acc$export$f636b5b56f1d624a))($80b3f33d2d36e8da$export$5aebed4b5cba826a);
const $80b3f33d2d36e8da$var$IssueViewContainer = (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($80b3f33d2d36e8da$var$WrappedIssueView, props);
var $80b3f33d2d36e8da$export$2e2bcd8739ae039 = $80b3f33d2d36e8da$var$IssueViewContainer;

});
parcelRegister("fE3Ua", function(module, exports) {

$parcel$export(module.exports, "ChangeEventTypes", () => $407ab16d43881e85$export$8db21fc94823e1cc);
const $407ab16d43881e85$var$FIELD_CHANGE_REQUESTED = 'FIELD_CHANGE_REQUESTED';
const $407ab16d43881e85$var$FIELD_CHANGED = 'FIELD_CHANGED';
const $407ab16d43881e85$var$FIELD_CHANGE_FAILED = 'FIELD_CHANGE_FAILED';
const $407ab16d43881e85$var$ISSUE_TYPE_CHANGED = 'ISSUE_TYPE_CHANGED';
const $407ab16d43881e85$var$ISSUE_RELATIONSHIP_UPDATED = 'ISSUE_RELATIONSHIP_UPDATED';
const $407ab16d43881e85$var$ISSUE_LINKS_CREATED = 'ISSUE_LINKS_CREATED';
const $407ab16d43881e85$var$ISSUE_LINK_DELETED = 'ISSUE_LINK_DELETED';
const $407ab16d43881e85$var$CHILD_ISSUE_ADDED = 'CHILD_ISSUE_ADDED';
const $407ab16d43881e85$var$SUBTASK_ADDED = 'SUBTASK_ADDED';
const $407ab16d43881e85$var$ISSUE_CHILDREN_ORDER_CHANGED = 'ISSUE_CHILDREN_ORDER_CHANGED';
const $407ab16d43881e85$var$CHILD_ISSUE_FIELD_UPDATED = 'CHILD_ISSUE_FIELD_UPDATED';
const $407ab16d43881e85$var$CREATE_CONFLUENCE_PAGE_LINK_SUCCESS = 'CREATE_CONFLUENCE_PAGE_LINK_SUCCESS';
const $407ab16d43881e85$var$DELETE_CONFLUENCE_PAGE_LINK_SUCCESS = 'DELETE_CONFLUENCE_PAGE_LINK_SUCCESS';
const $407ab16d43881e85$export$8db21fc94823e1cc = {
    [$407ab16d43881e85$var$FIELD_CHANGE_REQUESTED]: $407ab16d43881e85$var$FIELD_CHANGE_REQUESTED,
    [$407ab16d43881e85$var$FIELD_CHANGE_FAILED]: $407ab16d43881e85$var$FIELD_CHANGE_FAILED,
    [$407ab16d43881e85$var$FIELD_CHANGED]: $407ab16d43881e85$var$FIELD_CHANGED,
    [$407ab16d43881e85$var$ISSUE_TYPE_CHANGED]: $407ab16d43881e85$var$ISSUE_TYPE_CHANGED,
    [$407ab16d43881e85$var$ISSUE_RELATIONSHIP_UPDATED]: $407ab16d43881e85$var$ISSUE_RELATIONSHIP_UPDATED,
    [$407ab16d43881e85$var$ISSUE_LINKS_CREATED]: $407ab16d43881e85$var$ISSUE_LINKS_CREATED,
    [$407ab16d43881e85$var$ISSUE_LINK_DELETED]: $407ab16d43881e85$var$ISSUE_LINK_DELETED,
    [$407ab16d43881e85$var$CHILD_ISSUE_ADDED]: $407ab16d43881e85$var$CHILD_ISSUE_ADDED,
    [$407ab16d43881e85$var$SUBTASK_ADDED]: $407ab16d43881e85$var$SUBTASK_ADDED,
    [$407ab16d43881e85$var$ISSUE_CHILDREN_ORDER_CHANGED]: $407ab16d43881e85$var$ISSUE_CHILDREN_ORDER_CHANGED,
    [$407ab16d43881e85$var$CHILD_ISSUE_FIELD_UPDATED]: $407ab16d43881e85$var$CHILD_ISSUE_FIELD_UPDATED,
    [$407ab16d43881e85$var$CREATE_CONFLUENCE_PAGE_LINK_SUCCESS]: $407ab16d43881e85$var$CREATE_CONFLUENCE_PAGE_LINK_SUCCESS,
    [$407ab16d43881e85$var$DELETE_CONFLUENCE_PAGE_LINK_SUCCESS]: $407ab16d43881e85$var$DELETE_CONFLUENCE_PAGE_LINK_SUCCESS
};

});

parcelRegister("gJYxu", function(module, exports) {

$parcel$export(module.exports, "IssueBoundary", () => $47dde6f657625382$export$fbf48ede0cf52b5a);
$parcel$export(module.exports, "IssueModalBoundary", () => $47dde6f657625382$export$74d408982642a541);
// eslint-disable-next-line jira/restricted/react-component-props

var $eUqFw = parcelRequire("eUqFw");

var $ciZ8Y = parcelRequire("ciZ8Y");

var $cyVXS = parcelRequire("cyVXS");

var $gGtKh = parcelRequire("gGtKh");

var $c4qEZ = parcelRequire("c4qEZ");
const $47dde6f657625382$export$fbf48ede0cf52b5a = ({ children: children, isEmbedView: isEmbedView = true, ...props })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $ciZ8Y.ErrorBoundary), {
        id: "issue",
        ...props
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $gGtKh.default), {
        name: "issue-boundary",
        fallback: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $c4qEZ.IssueViewSkeleton), {
            isEmbedView: isEmbedView
        })
    }, children));
const $47dde6f657625382$export$74d408982642a541 = ({ children: children, ...props })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $cyVXS.ModalBoundary), {
        id: "issue-modal",
        ...props
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $gGtKh.default), {
        name: "issue-modal-boundary",
        fallback: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $c4qEZ.IssueViewSkeleton), {
            isModalView: true
        })
    }, children));

});
parcelRegister("cyVXS", function(module, exports) {

$parcel$export(module.exports, "ModalBoundary", () => $f96d169c5da11246$export$c3f500e812fb1bb3);

var $eUqFw = parcelRequire("eUqFw");

var $h97Af = parcelRequire("h97Af");

var $ciZ8Y = parcelRequire("ciZ8Y");

var $fee69 = parcelRequire("fee69");

var $gGtKh = parcelRequire("gGtKh");
const $f96d169c5da11246$export$c3f500e812fb1bb3 = ({ children: children, id: id, metricKey: metricKey, packageName: packageName, onError: onError })=>{
    const ErrorState = (0, $eUqFw.useCallback)((args)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $fee69.ErrorFlagRenderer), {
            id: id,
            error: args.error
        }), [
        id
    ]);
    const fallback = typeof metricKey === 'string' && metricKey.length > 0 ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $h97Af.default), {
        metricKey: metricKey
    }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).Fragment, null);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $ciZ8Y.ErrorBoundary), {
        id: id,
        packageName: packageName,
        render: ErrorState,
        onError: onError
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $gGtKh.default), {
        name: id,
        fallback: fallback
    }, children));
};

});

parcelRegister("c4qEZ", function(module, exports) {

$parcel$export(module.exports, "IssueViewSkeleton", () => $d58942287640a101$export$49addbcdecb6e6ff);
/* index.tsx generated by @compiled/babel-plugin v0.29.1 */ 
var $7JEyt = parcelRequire("7JEyt");

var $eUqFw = parcelRequire("eUqFw");

var $kB5wN = parcelRequire("kB5wN");

var $8ICxF = parcelRequire("8ICxF");

var $haxva = parcelRequire("haxva");
const $d58942287640a101$var$fullpageStyles = null;
const $d58942287640a101$var$modalStyles = null;
const $d58942287640a101$var$customSpacingStyles = null;
const $d58942287640a101$export$49addbcdecb6e6ff = ({ isEmbedView: isEmbedView, isModalView: isModalView })=>{
    // same as getIssueContainerMaxWidth
    const customCss = [
        $d58942287640a101$var$customSpacingStyles,
        isEmbedView !== true && isModalView !== true ? $d58942287640a101$var$fullpageStyles : null,
        isModalView === true ? $d58942287640a101$var$modalStyles : null
    ];
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $kB5wN.CompactModeProvider), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $8ICxF.AppSkeletonImage), {
        src: (0, (/*@__PURE__*/$parcel$interopDefault($haxva))),
        className: (0, $7JEyt.default)([
            "_p12f1ypn _18s85ogf _t6vdxy5q _hr4jxy5q _11y7uu9g _l82tpxbi _j7o0pxbi",
            isEmbedView !== true && isModalView !== true && "_uwhk1ejb",
            isModalView === true && "_19pk10j7"
        ])
    }));
};

});
parcelRegister("kB5wN", function(module, exports) {

$parcel$export(module.exports, "CompactModeContext", () => $628d22027b8eaf89$export$37eeac5cc5245b18);
$parcel$export(module.exports, "CompactModeProvider", () => $628d22027b8eaf89$export$10cf42790e523b8e);
$parcel$export(module.exports, "CompactModeConsumer", () => $628d22027b8eaf89$export$20feb77b5b617e44);
/* index.tsx generated by @compiled/babel-plugin v0.29.1 */ 
var $eUqFw = parcelRequire("eUqFw");

var $7JEyt = parcelRequire("7JEyt");

var $6mgGK = parcelRequire("6mgGK");

var $lB25E = parcelRequire("lB25E");

var $fruGB = parcelRequire("fruGB");
const $628d22027b8eaf89$export$37eeac5cc5245b18 = /*#__PURE__*/ (0, $eUqFw.createContext)(false);
const { Provider: $628d22027b8eaf89$var$Provider, Consumer: $628d22027b8eaf89$var$Consumer } = $628d22027b8eaf89$export$37eeac5cc5245b18;
const $628d22027b8eaf89$export$55a90a8e865a39b5 = 700;
const $628d22027b8eaf89$var$COMPACT_LAYOUT_MAX_WIDTH_QUERY = `(max-width: ${$628d22027b8eaf89$export$55a90a8e865a39b5}px)`;
/**
 * A utility hook which returns a key based on the route
 */ function $628d22027b8eaf89$var$useRouteKey() {
    const [routeState] = (0, $lB25E.useRouter)();
    const { match: { path: path, params: params } } = routeState;
    // handle case where JSM doesn't have an issueKey on their route
    const hasIssueKey = params?.issueKey !== undefined;
    return `${path}${hasIssueKey ? '/hasIssueKey' : ''}`;
}
const $628d22027b8eaf89$export$10cf42790e523b8e = ({ children: children })=>{
    const key = $628d22027b8eaf89$var$useRouteKey();
    (0, $fruGB.invalidateCacheIfRouteChanged)(key);
    let defaultState = (0, $fruGB.getCachedIsCompactValue)(key);
    // in case there is no state change triggered
    if (defaultState === undefined) {
        defaultState = (0, $ebe79147dfe00ff9$export$ee15e0cd1efafcb4);
        (0, $fruGB.setCachedIsCompactValue)(defaultState, key);
    }
    const [isCompact, setIsCompact] = (0, $eUqFw.useState)(defaultState);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($628d22027b8eaf89$var$StyledWrapper, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $6mgGK.ContainerQueryObserver), {
        query: $628d22027b8eaf89$var$COMPACT_LAYOUT_MAX_WIDTH_QUERY,
        onChange: (state)=>{
            (0, $fruGB.setCachedIsCompactValue)(state, key);
            setIsCompact(state);
        },
        defaultState: defaultState
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($628d22027b8eaf89$var$Provider, {
        value: isCompact
    }, children));
};
const $628d22027b8eaf89$export$20feb77b5b617e44 = $628d22027b8eaf89$var$Consumer;
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $628d22027b8eaf89$var$StyledWrapper = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_4t3i1osq _1e0c1txw _2lx21bp4",
            __cmplp.className
        ])
    });
});

});
parcelRegister("6mgGK", function(module, exports) {

$parcel$export(module.exports, "ContainerQueryObserver", () => $2f0f372a50da62d9$export$e9574287678b8467);
/* index.tsx generated by @compiled/babel-plugin v0.29.1 */ 
var $eUqFw = parcelRequire("eUqFw");

var $7JEyt = parcelRequire("7JEyt");

const $2f0f372a50da62d9$var$QueryContext = /*#__PURE__*/ (0, $eUqFw.createContext)(undefined);
let $2f0f372a50da62d9$var$currentIdSeed = 0;
function $2f0f372a50da62d9$var$generateAttributeValue() {
    return `indicator-span-${$2f0f372a50da62d9$var$currentIdSeed++}`;
}
function $2f0f372a50da62d9$export$e9574287678b8467({ children: children, query: query, onChange: onChange, defaultState: defaultState = (0, $ebe79147dfe00ff9$export$ee15e0cd1efafcb4) }) {
    const [active, setActive] = (0, $eUqFw.useState)(defaultState);
    const handleQueryStatusChange = (0, $eUqFw.useCallback)((isContainerQueryActive)=>{
        onChange?.(isContainerQueryActive);
        setActive(isContainerQueryActive);
    }, [
        onChange
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($2f0f372a50da62d9$var$QueryContext.Provider, {
        value: active
    }, !false && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($2f0f372a50da62d9$var$IntersectionIndicator, {
        query: query,
        notifyIntersectionStatusChanged: handleQueryStatusChange
    }), children);
}
function $2f0f372a50da62d9$export$b66a67697973e01() {
    const currentState = (0, $eUqFw.useContext)($2f0f372a50da62d9$var$QueryContext);
    if (currentState === undefined) throw new Error('The component must be wrapped in a ContainerQueryObserver to use useContainerQueryState');
    return currentState;
}
function $2f0f372a50da62d9$var$IntersectionIndicator({ notifyIntersectionStatusChanged: handleChange, query: query }) {
    const attributeValue = (0, $eUqFw.useMemo)(()=>$2f0f372a50da62d9$var$generateAttributeValue(), []);
    const spanRef = (0, $eUqFw.useRef)(null);
    const containerRef = (0, $eUqFw.useRef)(null);
    const currentState = $2f0f372a50da62d9$export$b66a67697973e01();
    (0, $eUqFw.useLayoutEffect)(()=>{
        const queryStatusChangedCallback = (entries)=>{
            // This means that the parent container is either empty or loading, we should not notify of any change in this case.
            if (!containerRef.current || containerRef.current.clientWidth === 0) return;
            if (entries.length > 0) {
                // only ever going to be one entry max
                const isContainerQueryActive = entries[0].isIntersecting;
                if (isContainerQueryActive !== currentState) handleChange(isContainerQueryActive);
            }
        };
        const intersectionObserver = new IntersectionObserver(queryStatusChangedCallback);
        const spanElement = spanRef.current;
        spanElement && intersectionObserver.observe(spanElement);
        return ()=>{
            spanElement && intersectionObserver.unobserve(spanElement);
            intersectionObserver.disconnect();
        };
    }, [
        currentState,
        handleChange
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($2f0f372a50da62d9$var$ContainerToBeQueried, {
        ref: containerRef
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("style", {
        type: "text/css"
    }, `
                    [data-container-query-indicator-id="${attributeValue}"] {
                        display: none;
                        position: fixed;
                        top: 0;
                        left: 0;
                        width: 100%;
                        height: 100vh; 
                        pointer-events: none;
                    }
                    @container ${query} {
                        [data-container-query-indicator-id="${attributeValue}"] {
                            display: inherit;
                        }
                    }`), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("span", {
        ref: spanRef,
        "data-container-query-indicator-id": attributeValue
    }));
}
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $2f0f372a50da62d9$var$ContainerToBeQueried = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_kqsw1if8 _lcxvglyw _154iidpf _7ccakre2",
            __cmplp.className
        ])
    });
});

});
const $ebe79147dfe00ff9$export$ee15e0cd1efafcb4 = false;


parcelRegister("fruGB", function(module, exports) {

$parcel$export(module.exports, "getCachedIsCompactValue", () => $592157d792cf61e1$export$c47621d55d10906c);
$parcel$export(module.exports, "setCachedIsCompactValue", () => $592157d792cf61e1$export$568b2dd75c2027b4);
$parcel$export(module.exports, "invalidateCacheIfRouteChanged", () => $592157d792cf61e1$export$a81477a3594bcaab);
// Cleared on window refresh, unique to each window
const $592157d792cf61e1$var$cachedIsCompactValues = {};
let $592157d792cf61e1$var$previousRouteKey;
function $592157d792cf61e1$export$c47621d55d10906c(key) {
    return $592157d792cf61e1$var$cachedIsCompactValues[key];
}
function $592157d792cf61e1$export$568b2dd75c2027b4(isCompactValue, key) {
    $592157d792cf61e1$var$cachedIsCompactValues[key] = isCompactValue;
}
function $592157d792cf61e1$export$a81477a3594bcaab(currentRouteKey) {
    // If we navigate away from the route we can't assume that the cached value will stay valid when we come back
    if (currentRouteKey !== $592157d792cf61e1$var$previousRouteKey) {
        $592157d792cf61e1$var$previousRouteKey = currentRouteKey;
        delete $592157d792cf61e1$var$cachedIsCompactValues[$592157d792cf61e1$var$previousRouteKey];
    }
}

});


parcelRegister("8ICxF", function(module, exports) {

$parcel$export(module.exports, "AppSkeletonImage", () => $f467e6485d9792e8$export$45b107c5dc7b51a5);
/* index.tsx generated by @compiled/babel-plugin v0.29.1 */ 
var $eUqFw = parcelRequire("eUqFw");

var $7JEyt = parcelRequire("7JEyt");


var $5JgJ2 = parcelRequire("5JgJ2");

var $84CBi = parcelRequire("84CBi");

var $h1hCM = parcelRequire("h1hCM");
const $f467e6485d9792e8$var$skeletonImageStyles = null;
const $f467e6485d9792e8$export$45b107c5dc7b51a5 = ({ src: src, className: className, containerStyles: containerStyles })=>{
    const { formatMessage: formatMessage } = (0, $5JgJ2.default)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $84CBi.default), {
        name: "app-skeleton"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($f467e6485d9792e8$var$SkeletonWrapper // eslint-disable-next-line jira/react/no-style-attribute, @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
    , {
        style: containerStyles
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("img", {
        src: src,
        alt: `${formatMessage((0, $h1hCM.default).loading)}...`,
        className: (0, $7JEyt.default)([
            "_1e0c1ule _vchhusvi _1bsb1osq _1dqonqa1 _1h6d3acm _t6vd1ylp _hr4j1ylp _l82tgktf _j7o0gktf",
            className
        ])
    })));
};
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $f467e6485d9792e8$var$SkeletonWrapper = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_1reo15vq _18m915vq _1bsb1osq _4t3i1osq _yksp1ssb _1b421ssb _s8ks18ws _u1wz1nty",
            __cmplp.className
        ])
    });
});

});
parcelRegister("h1hCM", function(module, exports) {

$parcel$export(module.exports, "default", () => $0b5b2a6284984f9f$export$2e2bcd8739ae039);

var $90IgZ = parcelRequire("90IgZ");
var $0b5b2a6284984f9f$export$2e2bcd8739ae039 = (0, $90IgZ.defineMessages)({
    loading: {
        "id": "skeletons.common.loading",
        "defaultMessage": "Loading"
    }
});

});


parcelRegister("haxva", function(module, exports) {
module.exports = new URL("issue-app-skeleton.tpl.31d538db.svg", import.meta.url).toString();

});



parcelRegister("9mxRp", function(module, exports) {

$parcel$export(module.exports, "HEADER_BREADCRUMBS_BEGIN_MARK_KEY", () => $3849cfed910e9285$export$eb0ef5297b0cdc23);
$parcel$export(module.exports, "HEADER_BREADCRUMBS_END_MARK_KEY", () => $3849cfed910e9285$export$9c0a7052eb43d49c);
$parcel$export(module.exports, "HEADER_ACTIONS_BEGIN_MARK_KEY", () => $3849cfed910e9285$export$ff64d9f93169b1f0);
$parcel$export(module.exports, "HEADER_ACTIONS_END_MARK_KEY", () => $3849cfed910e9285$export$e696e07345d019c7);
$parcel$export(module.exports, "ISSUE_NAME_BEGIN_MARK_KEY", () => $3849cfed910e9285$export$39f2c7a88d6952c7);
$parcel$export(module.exports, "ISSUE_NAME_END_MARK_KEY", () => $3849cfed910e9285$export$6b38db117e6a59c3);
$parcel$export(module.exports, "QUICK_ADD_ITEMS_BEGIN_MARK_KEY", () => $3849cfed910e9285$export$e4ec603cd2ae64c3);
$parcel$export(module.exports, "QUICK_ADD_ITEMS_END_MARK_KEY", () => $3849cfed910e9285$export$485e8138df2fade3);
$parcel$export(module.exports, "CONTENT_ITEMS_BEGIN_MARK_KEY", () => $3849cfed910e9285$export$37c39403f63dfe50);
$parcel$export(module.exports, "CONTENT_ITEMS_END_MARK_KEY", () => $3849cfed910e9285$export$bcac34901554ce05);
$parcel$export(module.exports, "ACTIVITY_FEED_BEGIN_MARK_KEY", () => $3849cfed910e9285$export$cfd354167a2170f3);
$parcel$export(module.exports, "ACTIVITY_FEED_END_MARK_KEY", () => $3849cfed910e9285$export$e20857c483438d46);
$parcel$export(module.exports, "FOOTNOTE_BEGIN_MARK_KEY", () => $3849cfed910e9285$export$2f7e8d259a68175d);
$parcel$export(module.exports, "FOOTNOTE_END_MARK_KEY", () => $3849cfed910e9285$export$8c4857e697bb9a6b);
$parcel$export(module.exports, "ISSUE_STATUS_BEGIN_MARK_KEY", () => $3849cfed910e9285$export$6669013ba0004c0);
$parcel$export(module.exports, "ISSUE_STATUS_END_MARK_KEY", () => $3849cfed910e9285$export$ff2ebe781d7bd44e);
$parcel$export(module.exports, "defaultRatioRightColumn", () => $3849cfed910e9285$export$7fec582ac43ca9da);
$parcel$export(module.exports, "getIssueContainerMaxWidth", () => $3849cfed910e9285$export$c76181843186885);
const $3849cfed910e9285$export$eb0ef5297b0cdc23 = 'HEADER_BREADCRUMBS_BEGIN_MARK';
const $3849cfed910e9285$export$9c0a7052eb43d49c = 'HEADER_BREADCRUMBS_END_MARK';
const $3849cfed910e9285$export$ff64d9f93169b1f0 = 'HEADER_ACTIONS_BEGIN_MARK';
const $3849cfed910e9285$export$e696e07345d019c7 = 'HEADER_ACTIONS_END_MARK';
const $3849cfed910e9285$export$39f2c7a88d6952c7 = 'ISSUE_NAME_BEGIN_MARK';
const $3849cfed910e9285$export$6b38db117e6a59c3 = 'ISSUE_NAME_END_MARK';
const $3849cfed910e9285$export$e4ec603cd2ae64c3 = 'QUICK_ADD_ITEMS_BEGIN_MARK';
const $3849cfed910e9285$export$485e8138df2fade3 = 'QUICK_ADD_ITEMS_END_MARK';
const $3849cfed910e9285$export$37c39403f63dfe50 = 'CONTENT_ITEMS_BEGIN_MARK';
const $3849cfed910e9285$export$bcac34901554ce05 = 'CONTENT_ITEMS_END_MARK';
const $3849cfed910e9285$export$cfd354167a2170f3 = 'ACTIVITY_FEED_BEGIN_MARK';
const $3849cfed910e9285$export$e20857c483438d46 = 'ACTIVITY_FEED_END_MARK';
const $3849cfed910e9285$export$2f7e8d259a68175d = 'FOOTNOTE_BEGIN_MARK';
const $3849cfed910e9285$export$8c4857e697bb9a6b = 'FOOTNOTE_END_MARK';
const $3849cfed910e9285$export$6669013ba0004c0 = 'ISSUE_STATUS_BEGIN_MARK';
const $3849cfed910e9285$export$ff2ebe781d7bd44e = 'ISSUE_STATUS_END_MARK';
const $3849cfed910e9285$export$7fec582ac43ca9da = 0.35;
const $3849cfed910e9285$export$c76181843186885 = ()=>1680;

});

parcelRegister("48mPv", function(module, exports) {

$parcel$export(module.exports, "default", () => $ce578c493ad96d9e$export$2e2bcd8739ae039);
class $ce578c493ad96d9e$export$2e2bcd8739ae039 {
    constructor(issueId, mutationType, version = '1', matchStatus = [], // eslint-disable-next-line @typescript-eslint/no-unused-vars
    lastModified){
        this.issueId = issueId;
        this.mutationType = mutationType;
        this.version = version;
        this.matchStatus = matchStatus;
        // create a new timeStamp whenever an object is initialized
        this.lastModified = new Date().toISOString();
    }
}

});

parcelRegister("d7Wfe", function(module, exports) {

$parcel$export(module.exports, "MutationSource", () => $598bd411eca1df87$export$17f28c4c94a74282);
$parcel$export(module.exports, "CacheType", () => $598bd411eca1df87$export$ba193b555633db78);
const $598bd411eca1df87$export$17f28c4c94a74282 = {
    CREATE: 0,
    UPDATE: 1,
    DELETE: 2
};
const $598bd411eca1df87$export$ba193b555633db78 = {
    LOCAL: 'local',
    SESSION: 'session'
};

});

parcelRegister("bsdZ2", function(module, exports) {

$parcel$export(module.exports, "useEcClient", () => $b40c4387cd757cd5$export$9da409beb25e67da);

var $eUqFw = parcelRequire("eUqFw");

var $gUUjF = parcelRequire("gUUjF");

var $gd0Sp = parcelRequire("gd0Sp");

var $65uQX = parcelRequire("65uQX");
const $b40c4387cd757cd5$export$9da409beb25e67da = ()=>{
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    let tenantContext;
    try {
        // eslint-disable-next-line react-hooks/rules-of-hooks
        tenantContext = (0, $gd0Sp.useTenantContext)();
    } catch (e) {
        (0, $gUUjF.default).safeErrorWithoutCustomerData('jsis-ec-client', `tenant context : ${e?.toString() || ''}`);
    }
    (0, $eUqFw.useEffect)(()=>{
        (0, $65uQX.EcClient).setTenantDetails(tenantContext?.activationId, tenantContext?.cloudId, tenantContext?.atlassianAccountId);
    }, [
        tenantContext
    ]);
    const saveIssueMutationToCache = (0, $eUqFw.useCallback)((issueMutation, key = {
        analyticsMetadata: {
            scenario: 'unknown'
        }
    }, analyticsFailureEventObj = {})=>(0, $65uQX.default).saveIssueMutationToCache(issueMutation, key, analyticsFailureEventObj), []);
    const saveIssueMutationsToCache = (0, $eUqFw.useCallback)((issueMutations, key = {
        analyticsMetadata: {
            scenario: 'unknown'
        }
    }, analyticsFailureEventObj = {})=>(0, $65uQX.default).saveIssueMutationsToCache(issueMutations, key, analyticsFailureEventObj), []);
    const searchAndReconcile = (0, $eUqFw.useCallback)((matchApiUrl, jqlMatchingKey, search, // eslint-disable-next-line @typescript-eslint/no-explicit-any
    parseIssueData, capability)=>(0, $65uQX.default).searchAndReconcile(matchApiUrl, jqlMatchingKey, search, parseIssueData, capability), []);
    const getIssueMutationFromCache = (key)=>(0, $65uQX.default).getIssueMutationFromCache(key);
    return {
        saveIssueMutationToCache: saveIssueMutationToCache,
        saveIssueMutationsToCache: saveIssueMutationsToCache,
        searchAndReconcile: searchAndReconcile,
        getIssueMutationFromCache: getIssueMutationFromCache
    };
};

});
parcelRegister("65uQX", function(module, exports) {

$parcel$export(module.exports, "EcClient", () => $9d182d4720e39d79$export$a736992aaac2307a);
$parcel$export(module.exports, "getEcClient", () => $9d182d4720e39d79$export$c9342bd32f51406b);
$parcel$export(module.exports, "default", () => $9d182d4720e39d79$export$2e2bcd8739ae039);

var $gUUjF = parcelRequire("gUUjF");

var $1ybV0 = parcelRequire("1ybV0");

var $2OdyW = parcelRequire("2OdyW");

var $jMP2a = parcelRequire("jMP2a");

var $3FyZ4 = parcelRequire("3FyZ4");

var $fqqil = parcelRequire("fqqil");

var $7S3WE = parcelRequire("7S3WE");

var $d7Wfe = parcelRequire("d7Wfe");

var $4qvSX = parcelRequire("4qvSX");
class $9d182d4720e39d79$export$a736992aaac2307a {
    #issueCache;
    #config;
    constructor(){
        this.#issueCache = new (0, $7S3WE.default)('issue-cache-v1');
        this.#config = {};
    }
    /**
	 * A method to set tenant level details.
	 * These details include activation id, cloud id and user id
	 */ static setTenantDetails(activationID, cloudID, atlassianAccountId) {
        (0, $7S3WE.default).setTenantDetails(activationID, cloudID, atlassianAccountId);
    }
    /**
	 * A method to fire analytics events for both success and failure
	 */ static fireAnalyticsEvents(issueMutations, key = {
        analyticsMetadata: {
            scenario: 'unknown'
        }
    }, isSaved, analyticsFailureEventObj = {}) {
        try {
            // let mutationAnalyticsObj: any = [];
            let trackingId = '-1';
            if (Array.isArray(issueMutations)) //   mutationAnalyticsObj = issueMutations.map((item: IssueMutation) => item.issueId);
            trackingId = String(new Date(issueMutations[0]?.lastModified).valueOf()) + (0, $7S3WE.default).userID;
            else trackingId = String(new Date(issueMutations.lastModified).valueOf()) + (0, $7S3WE.default).userID;
            const payload = {
                action: 'mutated',
                actionSubject: 'issue',
                source: key?.analyticsMetadata?.scenario || 'unknown',
                attributes: {
                    ...key.analyticsMetadata,
                    trackingId: // issueMutationDetails: mutationAnalyticsObj,
                    trackingId
                }
            };
            // Error condition
            if (!isSaved) {
                if (!analyticsFailureEventObj) // eslint-disable-next-line no-param-reassign
                analyticsFailureEventObj = {
                    error: true,
                    errorMsg: payload.source
                };
                payload.attributes = {
                    ...payload.attributes,
                    ...analyticsFailureEventObj
                };
            }
            if (Object.prototype.hasOwnProperty.call(key, 'analyticsEventObj')) (0, $jMP2a.fireTrackAnalytics)(// @ts-expect-error - Argument of type 'Object' is not assignable to parameter of type 'UIAnalyticsEvent'.
            // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
            key.analyticsEventObj, `${payload.actionSubject} ${payload.action}`, payload.attributes);
            else // if there is no UI component that triggers the event then we manually fire the event
            (0, $3FyZ4.getAnalyticsWebClientPromise)().then((client)=>{
                client.getInstance().sendTrackEvent(payload);
            });
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        } catch (e) {
            (0, $gUUjF.default).safeErrorWithoutCustomerData('jsis-ec-client', e);
        }
    }
    /**
	 * A method to save a single issue mutations in cache
	 */ async saveIssueMutationToCache(issueMutation, key = {
        analyticsMetadata: {
            scenario: 'unknown'
        }
    }, analyticsFailureEventObj = {}) {
        if ((0, $1ybV0.ff)('odin.enable.backend.cache.ec.client')) {
            const isSaved = (0, $7S3WE.default).setBackendCache(issueMutation);
            $9d182d4720e39d79$export$a736992aaac2307a.fireAnalyticsEvents(issueMutation, key, isSaved, analyticsFailureEventObj);
            return isSaved;
        }
        return this.#issueCache.isPresent(issueMutation.issueId).then(async (result)=>{
            let isSaved = false;
            if (issueMutation.mutationType === (0, $d7Wfe.MutationSource).DELETE) isSaved = await this.#issueCache.delete(issueMutation.issueId);
            else if (result || issueMutation.mutationType === (0, $d7Wfe.MutationSource).UPDATE) isSaved = await this.#issueCache.update(issueMutation.issueId);
            else isSaved = await this.#issueCache.create(issueMutation.issueId);
            $9d182d4720e39d79$export$a736992aaac2307a.fireAnalyticsEvents(issueMutation, key, isSaved, analyticsFailureEventObj);
            return new Promise((resolve)=>resolve(isSaved));
        });
    }
    /**
	 * A method to save multiple issue mutations in cache
	 */ async saveIssueMutationsToCache(issueMutations, key = {
        analyticsMetadata: {
            scenario: 'unknown'
        }
    }, analyticsFailureEventObj = {}) {
        const data = [];
        if ((0, $1ybV0.ff)('odin.enable.backend.cache.ec.client')) {
            const isSaved = (0, $7S3WE.default).setBackendCache(issueMutations);
            $9d182d4720e39d79$export$a736992aaac2307a.fireAnalyticsEvents(issueMutations, key, isSaved, analyticsFailureEventObj);
            return [
                isSaved
            ];
        }
        issueMutations.forEach(async (issueMutation)=>{
            this.#issueCache.isPresent(issueMutation.issueId).then(async (result)=>{
                let isSaved = false;
                if (issueMutation.mutationType === (0, $d7Wfe.MutationSource).DELETE) isSaved = await this.#issueCache.delete(issueMutation.issueId);
                else if (result || issueMutation.mutationType === (0, $d7Wfe.MutationSource).UPDATE) isSaved = await this.#issueCache.update(issueMutation.issueId);
                else isSaved = await this.#issueCache.create(issueMutation.issueId);
                data.push(isSaved);
                $9d182d4720e39d79$export$a736992aaac2307a.fireAnalyticsEvents(issueMutations, key, isSaved, analyticsFailureEventObj);
            });
        });
        return new Promise((resolve)=>resolve(data));
    }
    /**
	 * A method to get issue mutations in saved in cache
	 */ getIssueMutationFromCache(key) {
        return this.#issueCache.get(key);
    }
    /**
	 * A method to remove the deleted issues from the search API
	 */ // eslint-disable-next-line @typescript-eslint/no-explicit-any
    async filterData(data) {
        const localStorageData = await this.getIssueMutationFromCache(null);
        const deletedData = new Set();
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        Object.values(localStorageData).forEach((element)=>{
            if (element.mutationType === (0, $d7Wfe.MutationSource).DELETE) deletedData.add(element.issueId);
        });
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        const filteredData = [];
        let success = true;
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        Object.values(data).forEach((element)=>{
            if (!element.id || typeof element.id !== 'number') success = false;
            else if (!deletedData.has(element.id.toString())) filteredData.push(element);
        });
        return new Promise((// eslint-disable-next-line @typescript-eslint/no-explicit-any
        resolve, // eslint-disable-next-line @typescript-eslint/no-explicit-any
        reject)=>{
            if (success) resolve(filteredData);
            else reject(new Error());
        });
    }
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    async constructMatchRequest() {
        const issueData = {
            issues: [],
            hydrationMode: 0
        };
        const data = await this.getIssueMutationFromCache(null);
        Object.values(data).forEach((issueMutation)=>{
            const element = {
                issueId: issueMutation.issueId,
                version: issueMutation.version
            };
            issueData.issues.push(element);
        });
        const options = {
            method: 'POST',
            headers: {
                content_type: 'application/json',
                // @ts-expect-error - TS2339 - Property 'capability' does not exist on type 'object'.
                'x-atlassian-capability': (0, $fqqil.getEnhancedCapabilityHeader)(this.#config.capability)
            },
            body: JSON.stringify(issueData)
        };
        return new Promise((resolve)=>resolve(options));
    }
    /**
	 * A method to get the relevant search data from the parsing function that the user has provided
	 */ static getIssueDataFromSearch(data, // eslint-disable-next-line @typescript-eslint/no-explicit-any
    parseIssueData) {
        const result = parseIssueData(data);
        if (result == null) return [];
        return result;
    }
    /**
	 * A method to get the search data and reconcile it with the data present in cache
	 */ async searchAndReconcile(matchApiUrl, jqlMatchingKey, search, // eslint-disable-next-line @typescript-eslint/no-explicit-any
    parseIssueData, capability) {
        // @ts-expect-error - TS2339 - Property 'capability' does not exist on type 'object'.
        this.#config.capability = capability;
        const matchRequest = await this.constructMatchRequest();
        if (matchRequest && matchRequest.body && matchRequest.body.issues && matchRequest.body.issues.length === 0) return search.then((data)=>new Promise((resolve)=>resolve({
                    reconciledIssues: $9d182d4720e39d79$export$a736992aaac2307a.getIssueDataFromSearch(data, parseIssueData),
                    matchAPIResponse: {
                        response: {
                            resultsByIssueId: {}
                        },
                        issue: {
                            issuesResponse: {}
                        }
                    }
                })));
        const matchPromise = (0, $2OdyW.default)(matchApiUrl, matchRequest);
        return Promise.all([
            search,
            matchPromise
        ]).then(([data, response])=>{
            // eslint-disable-next-line @typescript-eslint/no-explicit-any
            const structuredData = $9d182d4720e39d79$export$a736992aaac2307a.getIssueDataFromSearch(data, parseIssueData);
            return this.filterData(structuredData) // eslint-disable-next-line @typescript-eslint/no-explicit-any
            .then((filteredSearchData)=>{
                if (response == null || response.response == null || response.response.resultsByIssueId == null) throw new Error('Match response is invalid!');
                const matchedIssueIds = response.response.resultsByIssueId;
                // eslint-disable-next-line @typescript-eslint/no-explicit-any
                const filteredMatchedIssueIdsData = [];
                Object.entries(matchedIssueIds).forEach(([key, value])=>{
                    if (value === 'RESULT_MATCH') filteredMatchedIssueIdsData.push({
                        id: parseInt(key, 10)
                    });
                });
                return new Promise((resolve)=>{
                    resolve({
                        reconciledIssues: (0, $4qvSX.mergeResponseData)(filteredSearchData, filteredMatchedIssueIdsData),
                        matchAPIResponse: response
                    });
                });
            }).catch(()=>new Promise((resolve)=>resolve({
                        reconciledIssues: structuredData,
                        matchAPIResponse: response
                    })));
        });
    }
}
const $9d182d4720e39d79$var$ecClient = new $9d182d4720e39d79$export$a736992aaac2307a();
function $9d182d4720e39d79$export$c9342bd32f51406b(tenantContext = {}) {
    $9d182d4720e39d79$export$a736992aaac2307a.setTenantDetails(tenantContext?.activationId, tenantContext?.cloudId, tenantContext?.atlassianAccountId);
    return $9d182d4720e39d79$var$ecClient;
}
var $9d182d4720e39d79$export$2e2bcd8739ae039 = $9d182d4720e39d79$var$ecClient;

});
parcelRegister("7S3WE", function(module, exports) {

$parcel$export(module.exports, "default", () => $ed861ad8bfcfb81a$export$2e2bcd8739ae039);
// Issue Cache API is an internal tool and this file should not be edited. Please contact Odin team for any modifications.

var $kBiqn = parcelRequire("kBiqn");

var $gUUjF = parcelRequire("gUUjF");

var $1ybV0 = parcelRequire("1ybV0");

var $2OdyW = parcelRequire("2OdyW");

var $48mPv = parcelRequire("48mPv");

var $d7Wfe = parcelRequire("d7Wfe");

var $4qvSX = parcelRequire("4qvSX");
const $ed861ad8bfcfb81a$var$MAX_AGE_MIN = 5;
const $ed861ad8bfcfb81a$var$MAX_AGE = $ed861ad8bfcfb81a$var$MAX_AGE_MIN * 60000;
const $ed861ad8bfcfb81a$var$CACHE_SIZE = 100;
const $ed861ad8bfcfb81a$var$CACHE_KEY_PREFIX = '__storejs';
const $ed861ad8bfcfb81a$var$BE_CACHE_SAVE_ISSUE_MUTATION = '/gateway/api/jira-jql-service/api/v1/issue-mutation';
class $ed861ad8bfcfb81a$export$2e2bcd8739ae039 {
    #localCache;
    #sessionCache;
    constructor(namespace, maxAge = $ed861ad8bfcfb81a$var$MAX_AGE){
        this.maxAge = maxAge;
        this.namespace = namespace;
        // @ts-expect-error - TS7009 - 'new' expression, whose target lacks a construct signature, implicitly has an 'any' type.
        this.#localCache = new (0, $kBiqn.Cache)({
            size: $ed861ad8bfcfb81a$var$CACHE_SIZE,
            storageType: (0, $d7Wfe.CacheType).LOCAL,
            cacheKey: namespace
        });
        // @ts-expect-error - TS7009 - 'new' expression, whose target lacks a construct signature, implicitly has an 'any' type.
        this.#sessionCache = new (0, $kBiqn.Cache)({
            size: $ed861ad8bfcfb81a$var$CACHE_SIZE,
            storageType: (0, $d7Wfe.CacheType).SESSION,
            cacheKey: namespace
        });
    }
    /**
	 * A method to set tenant level details.
	 * These details include activation id, cloud id and user id
	 */ static setTenantDetails(activationID, cloudID, userID) {
        if (activationID && activationID !== $ed861ad8bfcfb81a$export$2e2bcd8739ae039.activationID) $ed861ad8bfcfb81a$export$2e2bcd8739ae039.activationID = activationID;
        if (cloudID && cloudID !== $ed861ad8bfcfb81a$export$2e2bcd8739ae039.cloudID) $ed861ad8bfcfb81a$export$2e2bcd8739ae039.cloudID = cloudID;
        if (userID && userID !== $ed861ad8bfcfb81a$export$2e2bcd8739ae039.userID) $ed861ad8bfcfb81a$export$2e2bcd8739ae039.userID = userID;
    }
    /**
	 * A util method to decide whether an issue mutation in cache is stale or not
	 */ static isIssueMutationStale(issueMutation) {
        const lastModified = new Date(issueMutation.lastModified).getTime();
        return Date.now() - lastModified < $ed861ad8bfcfb81a$var$MAX_AGE;
    }
    /**
	 * A util method to generate partial key containing username for storing in cache
	 */ static generateKey() {
        let anonymousId = window.localStorage.getItem('ajs_anonymous_id');
        anonymousId = anonymousId ? `.${anonymousId}` : '';
        anonymousId = anonymousId.replace(/["]+/g, '');
        // TODO : Replace this with something more generic
        return `jsis.ecCache.data${anonymousId}.newIssuesMutationList`;
    }
    /**
	 * A method to generate key containing username as well as namespace for storing in cache
	 */ generateReadKey() {
        return `${$ed861ad8bfcfb81a$var$CACHE_KEY_PREFIX}_${this.namespace}_${$ed861ad8bfcfb81a$export$2e2bcd8739ae039.generateKey()}`;
    }
    /**
	 * A method to get the issue mutations stored in the cache
	 * Accepts issueIds or array of issuesIds and returns corresponding issue mutations
	 * Returns all the issue mutations when provided with null argument in form of an array
	 * Cleans the cache before accessing issue mutations in order to avoid stale data
	 */ async get(key) {
        return this.cleanCache().then(()=>this.getWithoutClean(key));
    }
    /**
	 * A method to get the issue mutations stored in the cache
	 * Accepts issueIds or array of issuesIds to return selective issue mutations
	 * Returns all the issue mutations when provided with null argument
	 */ async getWithoutClean(key) {
        if (key == null) return new Promise((resolve)=>{
            this.#localCache.get(this.generateReadKey()).then((data)=>data ? resolve(data) : resolve({}));
        });
        return new Promise(// eslint-disable-next-line @typescript-eslint/no-explicit-any
        (resolve)=>{
            this.#localCache.get(this.generateReadKey()).then((data)=>{
                if (!data) resolve({});
                else {
                    const iterableData = data;
                    // eslint-disable-next-line @typescript-eslint/no-explicit-any
                    const newData = {};
                    if (typeof key === 'string') newData[key] = iterableData[key];
                    else if (Array.isArray(key)) key.forEach((issueId)=>{
                        newData[issueId] = iterableData[issueId];
                    });
                    resolve(newData);
                }
            });
        });
    }
    /**
	 * A method to construct object to be stored in backend cache
	 * Can receive an issue mutation or an array of issue mutations to be saved in cache
	 */ static constructBackendCacheObject(value) {
        if (value instanceof (0, $48mPv.default)) return {
            issueId: value.issueId,
            mutationType: value.mutationType,
            mutationTimestamp: value.lastModified
        };
        const result = [];
        value.forEach((data)=>{
            result.push($ed861ad8bfcfb81a$export$2e2bcd8739ae039.constructBackendCacheObject(data));
        });
        return result;
    }
    /**
	 * A method to save the issue mutations in the backend cache
	 * Can receive an issue mutation or an array of issue mutations to be saved in cache
	 */ static setBackendCache(data) {
        try {
            let issueBody = $ed861ad8bfcfb81a$export$2e2bcd8739ae039.constructBackendCacheObject(data);
            let trackingId = '-1';
            if (data instanceof (0, $48mPv.default)) {
                trackingId = String(new Date(data.lastModified).valueOf()) + ($ed861ad8bfcfb81a$export$2e2bcd8739ae039.userID || '');
                issueBody = [
                    issueBody
                ];
            } else trackingId = String(new Date(data[0].lastModified).valueOf()) + ($ed861ad8bfcfb81a$export$2e2bcd8739ae039.userID || '');
            (0, $2OdyW.default)($ed861ad8bfcfb81a$var$BE_CACHE_SAVE_ISSUE_MUTATION, {
                method: 'PUT',
                headers: {
                    'Content-Type': 'application/json',
                    'ATL-activationId': $ed861ad8bfcfb81a$export$2e2bcd8739ae039.activationID || '',
                    'atl-CloudId': $ed861ad8bfcfb81a$export$2e2bcd8739ae039.cloudID || '',
                    trackingId: trackingId
                },
                body: JSON.stringify({
                    issueMutations: issueBody
                })
            });
            return true;
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        } catch (e) {
            (0, $gUUjF.default).safeErrorWithoutCustomerData('jsis-ec-client', `${e?.toString() || ''}mutationObj: ${data}`);
            return false;
        }
    }
    /**
	 * A method to save the issue mutations in the cache
	 * Can receive an issue mutation or an array of issue mutations to be saved in cache
	 */ async set(value) {
        return this.getWithoutClean().then(async (cacheData)=>{
            if (value instanceof (0, $48mPv.default)) {
                const storeValue = {
                    [value.issueId]: value
                };
                return new Promise((resolve)=>{
                    try {
                        this.#localCache.set(this.generateReadKey(), (0, $4qvSX.mergeData)(cacheData, storeValue));
                        resolve(true);
                    // eslint-disable-next-line @typescript-eslint/no-explicit-any
                    } catch (e) {
                        resolve(false);
                    }
                });
            }
            // eslint-disable-next-line @typescript-eslint/no-explicit-any
            const storeData = {};
            value.forEach((data)=>{
                storeData[data.issueId] = data;
            });
            return new Promise((resolve)=>{
                try {
                    this.#localCache.set(this.generateReadKey(), (0, $4qvSX.mergeData)(cacheData, storeData));
                    resolve(true);
                // eslint-disable-next-line @typescript-eslint/no-explicit-any
                } catch (e) {
                    resolve(false);
                }
            });
        });
    }
    /**
	 * A method to create a new issue mutation in cache
	 * Can receive an issue ids or an array of issue ids to be created in cache
	 */ async create(value) {
        return this.cleanCache().then(()=>{
            if (!Array.isArray(value)) return this.set(new (0, $48mPv.default)(value, (0, $d7Wfe.MutationSource).CREATE, '1', [], new Date().toISOString()));
            const storeData = value.map((data)=>new (0, $48mPv.default)(data, (0, $d7Wfe.MutationSource).CREATE, '1', [], new Date().toISOString()));
            return this.set(storeData);
        });
    }
    /**
	 * A method to update an already existing issue mutation in cache
	 * Can receive an issue ids or an array of issue ids to be updated in cache
	 */ async update(value) {
        if ((0, $1ybV0.ff)('odin.enable.backend.cache.ec.client')) {
            if (typeof value === 'string') return this.set(new (0, $48mPv.default)(value, (0, $d7Wfe.MutationSource).UPDATE, '1', []));
            return this.set(value.map((issueId)=>new (0, $48mPv.default)(issueId, (0, $d7Wfe.MutationSource).UPDATE, '1', [])));
        }
        return this.getWithoutClean(value).then((data)=>{
            const valueToUpdate = [];
            Object.entries(data).forEach(([issueId, issueMutationObj])=>{
                if (issueMutationObj instanceof (0, $48mPv.default)) {
                    if ($ed861ad8bfcfb81a$export$2e2bcd8739ae039.isIssueMutationStale(issueMutationObj)) valueToUpdate.push(new (0, $48mPv.default)(String(issueId), (0, $d7Wfe.MutationSource).UPDATE, issueMutationObj.version, issueMutationObj.matchStatus, new Date().toISOString()));
                    else valueToUpdate.push(new (0, $48mPv.default)(String(issueId), (0, $d7Wfe.MutationSource).CREATE, '1', issueMutationObj.matchStatus, new Date().toISOString()));
                } else valueToUpdate.push(new (0, $48mPv.default)(String(issueId), (0, $d7Wfe.MutationSource).UPDATE, // TODO: Incorporate the version and match status and change the update method signature
                '1', [], new Date().toISOString()));
            });
            return this.set(valueToUpdate);
        });
    }
    /**
	 * A method to delete an issue mutation in cache
	 */ async delete(key) {
        if (typeof key === 'string') return this.set(new (0, $48mPv.default)(key, (0, $d7Wfe.MutationSource).DELETE, '', [], new Date().toISOString()));
        const storeData = key.map((data)=>new (0, $48mPv.default)(data, (0, $d7Wfe.MutationSource).DELETE, '', [], new Date().toISOString()));
        return this.set(storeData);
    }
    /**
	 * A method to clear the cache
	 */ async clear() {
        return this.#localCache.clear();
    }
    /**
	 * A method that selectively deletes the stale cache entries
	 */ async cleanCache() {
        // We don't clean the backend cache
        if ((0, $1ybV0.ff)('odin.enable.backend.cache.ec.client')) return Promise.resolve(true);
        return this.getWithoutClean(null).then((data)=>{
            const issuesToKeep = [];
            if (data && Object.keys(data).length !== 0 && Object.getPrototypeOf(data) === Object.prototype) Object.keys(data).forEach((issueId)=>{
                const issueMutationObj = data[issueId];
                if ($ed861ad8bfcfb81a$export$2e2bcd8739ae039.isIssueMutationStale(issueMutationObj)) issuesToKeep.push(issueMutationObj);
            });
            return this.clear().then(()=>this.set(issuesToKeep));
        });
    }
    /**
	 * A method to check if an issue id is present in the cache
	 */ isPresent(issueId) {
        return this.get(issueId).then((data)=>!!data && !!Object.values(data)[0]);
    }
    /**
	 * A method to check if any mutation is present in the cache
	 */ isEmpty() {
        return this.get(null).then((data)=>Object.keys(data).length === 0);
    }
    /**
	 * A method to find the size of the local storage for any given key
	 */ static getLocalStorageSizeForGivenKey(key) {
        const value = localStorage.getItem(key);
        if (value != null) {
            const keySize = value.length;
            return keySize;
        }
        return 0;
    }
    /**
	 * A method to find the size of the local storage for any given key
	 * It returns size of all the keys when provided with no key
	 */ static getLocalStorageSize(key) {
        if (key != null) return $ed861ad8bfcfb81a$export$2e2bcd8739ae039.getLocalStorageSizeForGivenKey(key);
        let totalSize = 0;
        Object.keys(localStorage).forEach((keys)=>{
            totalSize += $ed861ad8bfcfb81a$export$2e2bcd8739ae039.getLocalStorageSizeForGivenKey(keys);
        });
        return totalSize;
    }
}

});
parcelRegister("kBiqn", function(module, exports) {

$parcel$export(module.exports, "Cache", () => $32f02625ea3a7ccc$export$94affb487e701bf2);
$parcel$export(module.exports, "default", () => $32f02625ea3a7ccc$export$2e2bcd8739ae039);

var $aZaPn = parcelRequire("aZaPn");
var $89bO2 = parcelRequire("89bO2");

var $gUUjF = parcelRequire("gUUjF");


var $48k9t = parcelRequire("48k9t");
const $32f02625ea3a7ccc$var$calculateEntryAge = (timestamp)=>Date.now() - timestamp;
function $32f02625ea3a7ccc$export$94affb487e701bf2(props) {
    const cache = new Map();
    const { size: size } = props;
    let storage;
    let hasSyncedFromStorage = false;
    const devTools = window && window.__REDUX_DEVTOOLS_EXTENSION__ ? window.__REDUX_DEVTOOLS_EXTENSION__.connect({
        name: `Cache ${props.cacheKey}`,
        serialize: true
    }) : null;
    const syncWithDevTools = (type, payload)=>{
        if ((0, $48k9t.default).devTools) devTools && devTools.send({
            type: type,
            payload: payload
        }, cache, {}, props.cacheKey);
    };
    const removeExpiredKeysFromStorage = async (store)=>{
        const updatedStore = {
            ...store
        };
        if (props.storageType === (0, $834cc2f16be60bc5$export$bf340b99118a1511)) return {};
        const { cacheKey: cacheKey, maxAge: maxAge } = props;
        if (maxAge !== undefined) {
            Object.keys(store).forEach((key)=>{
                // @ts-expect-error - TS7053 - Element implicitly has an 'any' type because expression of type 'string' can't be used to index type 'Partial<Record<K, Entry<V>>>'.
                const keyAge = $32f02625ea3a7ccc$var$calculateEntryAge(store[key].timestamp);
                if (keyAge > maxAge) {
                    // @ts-expect-error - TS2345 - Argument of type '{ [x: string]: any; }' is not assignable to parameter of type 'K | Entry<V> | Partial<Record<K, Entry<V>>> | [K, Entry<V>][]'. | TS7053 - Element implicitly has an 'any' type because expression of type 'string' can't be used to index type 'Partial<Record<K, Entry<V>>>'.
                    syncWithDevTools((0, $834cc2f16be60bc5$export$26d12233004a7a60), {
                        [String(key)]: updatedStore[key]
                    });
                    // @ts-expect-error - TS7053 - Element implicitly has an 'any' type because expression of type 'string' can't be used to index type 'Partial<Record<K, Entry<V>>>'.
                    delete updatedStore[key];
                    // @ts-expect-error - TS2345 - Argument of type 'string' is not assignable to parameter of type 'K'.
                    cache.delete(key);
                }
            });
            storage.set(cacheKey, updatedStore);
        }
        return updatedStore;
    };
    const removeExpiredEntry = (key, val)=>{
        if (props.storageType !== (0, $834cc2f16be60bc5$export$bf340b99118a1511)) {
            const { maxAge: maxAge } = props;
            if (maxAge !== undefined && $32f02625ea3a7ccc$var$calculateEntryAge(val.timestamp) > maxAge) {
                // @ts-expect-error - TS2345 - Argument of type '{ [x: string]: Entry<V>; }' is not assignable to parameter of type 'K | Entry<V> | Partial<Record<K, Entry<V>>> | [K, Entry<V>][]'.
                syncWithDevTools((0, $834cc2f16be60bc5$export$26d12233004a7a60), {
                    [String(key)]: val
                });
                cache.delete(key);
                return true;
            }
        }
        return false;
    };
    const createStore = ()=>{
        if (props.storageType === (0, $834cc2f16be60bc5$export$2670cb7d5d4f7184)) storage = (0, $aZaPn.createLocalStorageProvider)((0, $48k9t.CACHE_PREFIX));
        else storage = (0, $89bO2.createSessionStorageProvider)((0, $48k9t.CACHE_PREFIX));
        return storage;
    };
    const set = async (key, value)=>{
        await load();
        // @ts-expect-error - TS2345 - Argument of type 'string | K' is not assignable to parameter of type 'K'.
        cache.delete(key);
        const entry = {
            value: value,
            timestamp: Date.now()
        };
        let storedContent = {};
        if (props.storageType !== (0, $834cc2f16be60bc5$export$bf340b99118a1511)) {
            storedContent = storage.get(props.cacheKey) || {};
            // @ts-expect-error - TS2536 - Type 'string | K' cannot be used to index type 'Partial<Record<K, Entry<V>>>'.
            storedContent[key] = entry;
        }
        // @ts-expect-error - TS2345 - Argument of type 'string | K' is not assignable to parameter of type 'K'.
        cache.set(key, entry);
        // @ts-expect-error - TS2345 - Argument of type '{ [x: string]: Entry<V>; }' is not assignable to parameter of type 'K | Entry<V> | Partial<Record<K, Entry<V>>> | [K, Entry<V>][]'.
        syncWithDevTools((0, $834cc2f16be60bc5$export$5e8f180ef0142226), {
            [String(key)]: entry
        });
        if (cache.size > size) {
            const keys = cache.keys();
            const firstEntry = keys.next().value;
            if (firstEntry !== undefined) {
                cache.delete(firstEntry);
                syncWithDevTools((0, $834cc2f16be60bc5$export$a61768fefd33fcb1), firstEntry);
                if (props.storageType !== (0, $834cc2f16be60bc5$export$bf340b99118a1511)) // @ts-expect-error - TS7053 - Element implicitly has an 'any' type because expression of type 'any' can't be used to index type 'Partial<Record<K, Entry<V>>>'.
                delete storedContent[firstEntry];
            }
        }
        props.storageType !== (0, $834cc2f16be60bc5$export$bf340b99118a1511) && storage.set(props.cacheKey, storedContent);
    };
    const load = async ()=>{
        if (false || hasSyncedFromStorage) return;
        hasSyncedFromStorage = true;
        if (props.storageType === (0, $834cc2f16be60bc5$export$bf340b99118a1511)) return;
        const { cacheKey: cacheKey } = props;
        storage = createStore();
        try {
            let data = storage.get(cacheKey) || {};
            data = await removeExpiredKeysFromStorage(data);
            syncWithDevTools((0, $834cc2f16be60bc5$export$61f74127e2b53cbe), data);
            const orderedKeys = Object.keys(data).sort(// @ts-expect-error - TS7053 - Element implicitly has an 'any' type because expression of type 'string' can't be used to index type 'Partial<Record<K, Entry<V>>>'. | TS7053 - Element implicitly has an 'any' type because expression of type 'string' can't be used to index type 'Partial<Record<K, Entry<V>>>'.
            (key1, key2)=>data[key1].timestamp - data[key2].timestamp);
            await Promise.all(orderedKeys.map(async (key)=>{
                // @ts-expect-error - TS7053 - Element implicitly has an 'any' type because expression of type 'string' can't be used to index type 'Partial<Record<K, Entry<V>>>'.
                await set(key, data[key].value);
            }));
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        } catch (err) {
            (0, $gUUjF.default).safeWarnWithoutCustomerData((0, $834cc2f16be60bc5$export$7271276960377470), `There was an error syncing with storage - ${cacheKey}`, err);
            throw err;
        }
    };
    const clear = async ()=>{
        await load();
        cache.clear();
        if (props.storageType !== (0, $834cc2f16be60bc5$export$bf340b99118a1511)) {
            const { cacheKey: cacheKey } = props;
            storage.remove(cacheKey);
        }
        syncWithDevTools((0, $834cc2f16be60bc5$export$6c4d37c7f376a1de), {});
    };
    const get = async (key)=>{
        await load();
        let val = cache.get(key);
        if (val) {
            if (removeExpiredEntry(key, val)) val = undefined;
        }
        // @ts-expect-error - TS2345 - Argument of type '{ [x: string]: Entry<V> | undefined; }' is not assignable to parameter of type 'K | Entry<V> | Partial<Record<K, Entry<V>>> | [K, Entry<V>][]'.
        syncWithDevTools((0, $834cc2f16be60bc5$export$1bb358554aac31c1), {
            [String(key)]: val
        });
        return val && val.value;
    };
    const update = async (key, value)=>{
        await load();
        const previousValue = cache.get(key);
        if (!previousValue) return;
        const entry = {
            value: value,
            timestamp: previousValue.timestamp
        };
        let storedContent = {};
        if (props.storageType !== (0, $834cc2f16be60bc5$export$bf340b99118a1511)) {
            storedContent = storage.get(props.cacheKey) || {};
            storedContent[key] = entry;
        }
        cache.set(key, entry);
        // @ts-expect-error - TS2345 - Argument of type '{ [x: string]: Entry<V>; }' is not assignable to parameter of type 'K | Entry<V> | Partial<Record<K, Entry<V>>> | [K, Entry<V>][]'.
        syncWithDevTools((0, $834cc2f16be60bc5$export$e271b26eefe41db8), {
            [String(key)]: entry
        });
        props.storageType !== (0, $834cc2f16be60bc5$export$bf340b99118a1511) && storage.set(props.cacheKey, storedContent);
    };
    const getEntries = async ()=>{
        await load();
        const entries = Array.from(cache.entries()).filter(// eslint-disable-next-line @typescript-eslint/no-explicit-any
        ([key, value])=>!removeExpiredEntry(key, value));
        syncWithDevTools((0, $834cc2f16be60bc5$export$9eb68924983e00fb), entries);
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        return entries.map(([key, { value: value }])=>[
                key,
                value
            ]);
    };
    const deleteEntry = async (key)=>{
        await load();
        if (props.storageType !== (0, $834cc2f16be60bc5$export$bf340b99118a1511)) {
            const storedContent = storage.get(props.cacheKey) || {};
            delete storedContent[key];
            storage.set(props.cacheKey, storedContent);
        }
        cache.delete(key);
        // @ts-expect-error - TS2345 - Argument of type '{ [x: string]: Entry<V> | undefined; }' is not assignable to parameter of type 'K | Entry<V> | Partial<Record<K, Entry<V>>> | [K, Entry<V>][]'.
        syncWithDevTools((0, $834cc2f16be60bc5$export$4bd2facc4a3e6aa1), {
            [String(key)]: cache.get(key)
        });
    };
    const refresh = async ()=>{
        if (props.storageType === (0, $834cc2f16be60bc5$export$bf340b99118a1511)) return;
        cache.clear();
        hasSyncedFromStorage = false;
        await load();
    };
    if ((0, $48k9t.default).scopes.current !== (0, $48k9t.default).scopes.prev) clear();
    return {
        cache: cache,
        get: get,
        set: set,
        delete: deleteEntry,
        clear: clear,
        load: load,
        update: update,
        getEntries: // @ts-expect-error - TS2322 - Type '() => Promise<any[][]>' is not assignable to type '() => Promise<[K, V][]>'.
        getEntries,
        refresh: refresh
    };
}
// eslint-disable-next-line @typescript-eslint/no-explicit-any
const $32f02625ea3a7ccc$var$cacheMap = {};
const $32f02625ea3a7ccc$var$getCache = async (props)=>{
    await (0, $48k9t.scopeGuard)().catch((error)=>{
        (0, $gUUjF.default).safeErrorWithoutCustomerData('common.cache.scope', 'There was a failure within cache scopeGuard', error);
    });
    const { cacheKey: cacheKey } = props;
    // @ts-expect-error - TS7009 - 'new' expression, whose target lacks a construct signature, implicitly has an 'any' type.
    $32f02625ea3a7ccc$var$cacheMap[cacheKey] = $32f02625ea3a7ccc$var$cacheMap[cacheKey] || new $32f02625ea3a7ccc$export$94affb487e701bf2(props);
    return $32f02625ea3a7ccc$var$cacheMap[cacheKey];
};
const $32f02625ea3a7ccc$export$710d301bf26d9700 = ()=>{
    Object.values($32f02625ea3a7ccc$var$cacheMap).forEach((cache)=>cache.clear());
};
var $32f02625ea3a7ccc$export$2e2bcd8739ae039 = $32f02625ea3a7ccc$var$getCache;

});
parcelRegister("89bO2", function(module, exports) {

$parcel$export(module.exports, "createSessionStorageProvider", () => $eaaf8012779da3f6$export$a922b987e648d2fa);
$parcel$export(module.exports, "createSessionExpirableStorageProvider", () => $eaaf8012779da3f6$export$e0a2e9a062c6a695);

var $jqvCZ = parcelRequire("jqvCZ");

var $avHyR = parcelRequire("avHyR");

var $8zsxt = parcelRequire("8zsxt");
const $eaaf8012779da3f6$export$a922b987e648d2fa = (0, (/*@__PURE__*/$parcel$interopDefault($jqvCZ)))((appPrefix)=>(0, $avHyR.createStorageProvider)(appPrefix, (0, $8zsxt.makeSessionStore)()));
const $eaaf8012779da3f6$export$e0a2e9a062c6a695 = (0, (/*@__PURE__*/$parcel$interopDefault($jqvCZ)))((appPrefix)=>{
    if (!appPrefix) throw Error("appPrefix can not be empty. It's used to separate apps");
    const store = (0, $8zsxt.makeSessionExpirableStore)();
    return store.namespace(appPrefix);
});

});
parcelRegister("8zsxt", function(module, exports) {

$parcel$export(module.exports, "makeSessionStore", () => $dffa4c0ba19d0eb7$export$fb690882d627b3b5);
$parcel$export(module.exports, "makeSessionExpirableStore", () => $dffa4c0ba19d0eb7$export$a8f626c8ded9a06c);

var $2y3XF = parcelRequire("2y3XF");

var $gleLd = parcelRequire("gleLd");

var $ZGlKn = parcelRequire("ZGlKn");

var $gpWeB = parcelRequire("gpWeB");

var $lyUHD = parcelRequire("lyUHD");

var $avHyR = parcelRequire("avHyR");
const $dffa4c0ba19d0eb7$export$fb690882d627b3b5 = ()=>(0, (/*@__PURE__*/$parcel$interopDefault($ZGlKn))).createStore([
        (0, (/*@__PURE__*/$parcel$interopDefault($lyUHD))),
        (0, (/*@__PURE__*/$parcel$interopDefault($gpWeB)))
    ], (0, $avHyR.plugins));
const $dffa4c0ba19d0eb7$export$a8f626c8ded9a06c = ()=>(0, (/*@__PURE__*/$parcel$interopDefault($ZGlKn))).createStore([
        (0, (/*@__PURE__*/$parcel$interopDefault($lyUHD))),
        (0, (/*@__PURE__*/$parcel$interopDefault($gpWeB)))
    ], [
        (0, (/*@__PURE__*/$parcel$interopDefault($2y3XF))),
        (0, (/*@__PURE__*/$parcel$interopDefault($gleLd)))
    ]);

});


const $834cc2f16be60bc5$export$7271276960377470 = 'common-cache';
const $834cc2f16be60bc5$export$a61768fefd33fcb1 = 'capacity exceeded';
const $834cc2f16be60bc5$export$6c4d37c7f376a1de = 'clear';
const $834cc2f16be60bc5$export$e271b26eefe41db8 = 'update';
const $834cc2f16be60bc5$export$4bd2facc4a3e6aa1 = 'delete';
const $834cc2f16be60bc5$export$26d12233004a7a60 = 'delete stale entry';
const $834cc2f16be60bc5$export$1bb358554aac31c1 = 'get';
const $834cc2f16be60bc5$export$61f74127e2b53cbe = 'hydrate';
const $834cc2f16be60bc5$export$5e8f180ef0142226 = 'set';
const $834cc2f16be60bc5$export$9eb68924983e00fb = 'get entries';
const $834cc2f16be60bc5$export$bf340b99118a1511 = 'memory';
const $834cc2f16be60bc5$export$2670cb7d5d4f7184 = 'local';
const $834cc2f16be60bc5$export$b796061ff0c82e1a = 'session';

parcelRegister("48k9t", function(module, exports) {

$parcel$export(module.exports, "CACHE_PREFIX", () => $619b603377692131$export$69ca515e4489d790);
$parcel$export(module.exports, "scopeGuard", () => $619b603377692131$export$653cd03438bb0386);
$parcel$export(module.exports, "default", () => $619b603377692131$export$2e2bcd8739ae039);

var $aZaPn = parcelRequire("aZaPn");
let $619b603377692131$var$resolveCachePromise;
const $619b603377692131$var$cachePromise = new Promise((resolve)=>{
    $619b603377692131$var$resolveCachePromise = resolve;
});
const $619b603377692131$export$27be962d708928a = '__scope_key__';
const $619b603377692131$export$69ca515e4489d790 = 'cache_prefix';
const $619b603377692131$var$TIMEOUT = 10000;
const $619b603377692131$var$promiseWithMaxExecutionTime = (ms, promise)=>{
    let id;
    const timeout = new Promise(// eslint-disable-next-line @typescript-eslint/no-explicit-any
    (resolve, reject)=>{
        id = setTimeout(()=>{
            const storage = (0, $aZaPn.createLocalStorageProvider)($619b603377692131$export$69ca515e4489d790);
            storage.clearAll();
            reject(new Error(`Cache scope was not set within ${$619b603377692131$var$TIMEOUT}ms`));
        }, ms);
    });
    return Promise.race([
        promise,
        timeout
    ]).then((result)=>{
        clearTimeout(id);
        return result;
    });
};
const $619b603377692131$export$653cd03438bb0386 = ()=>$619b603377692131$var$promiseWithMaxExecutionTime($619b603377692131$var$TIMEOUT, $619b603377692131$var$cachePromise);
const $619b603377692131$var$config = {
    devTools: false,
    scopes: {
        prev: null,
        current: null
    },
    set (scopeKey) {
        const storage = (0, $aZaPn.createLocalStorageProvider)($619b603377692131$export$69ca515e4489d790);
        const scopeKeyInStorage = storage.get($619b603377692131$export$27be962d708928a);
        // init value
        if (this.scopes.prev === null && this.scopes.current === null) {
            if (scopeKeyInStorage) {
                // @ts-expect-error - TS2540 - Cannot assign to 'prev' because it is a read-only property.
                this.scopes.prev = scopeKeyInStorage;
                // @ts-expect-error - TS2540 - Cannot assign to 'current' because it is a read-only property.
                this.scopes.current = scopeKeyInStorage;
            }
        }
        // same account id
        if (this.scopes.current !== scopeKey) {
            // diffrent account id
            if (this.scopes.current !== null) // scope has changed during session
            storage.clearAll();
            // @ts-expect-error - TS2540 - Cannot assign to 'prev' because it is a read-only property.
            this.scopes.prev = this.scopes.current;
            // @ts-expect-error - TS2540 - Cannot assign to 'current' because it is a read-only property.
            this.scopes.current = scopeKey;
            storage.set($619b603377692131$export$27be962d708928a, scopeKey);
        }
        // @ts-expect-error - TS7005 - Variable 'resolveCachePromise' implicitly has an 'any' type.
        $619b603377692131$var$resolveCachePromise();
    },
    get () {
        return this.scopes.current;
    }
};
var $619b603377692131$export$2e2bcd8739ae039 = $619b603377692131$var$config;

});


parcelRegister("4qvSX", function(module, exports) {

$parcel$export(module.exports, "mergeData", () => $1b463beed4d472c8$export$696bf4df45a0ddde);
$parcel$export(module.exports, "mergeResponseData", () => $1b463beed4d472c8$export$71923bad28063cb1);
$parcel$export(module.exports, "createAnalyticsMetadata", () => $1b463beed4d472c8$export$eeaad9fa1f02ef4a);

var $6rW04 = parcelRequire("6rW04");
function $1b463beed4d472c8$export$696bf4df45a0ddde(oldData, newData) {
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    const result = {};
    Object.keys(oldData).forEach((issueId)=>{
        result[issueId] = oldData[issueId];
    });
    Object.keys(newData).forEach((issueId)=>{
        result[issueId] = newData[issueId];
    });
    return result;
}
function $1b463beed4d472c8$export$71923bad28063cb1(searchData, matchData) {
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    const mergedData = [];
    const issueData = new Map();
    if (matchData.length) // eslint-disable-next-line @typescript-eslint/no-explicit-any
    matchData.forEach((element)=>{
        issueData.set(element.id, element);
    });
    if (searchData.length) // eslint-disable-next-line @typescript-eslint/no-explicit-any
    searchData.forEach((element)=>{
        // TODO: if issueVersion in Match is less than Search, we should not be overwriting that issueID.
        if (issueData.has(element.id)) {
            mergedData.push(issueData.get(element.id));
            issueData.delete(element.id);
        } else mergedData.push(element);
    });
    if (issueData.size) issueData.forEach((value)=>{
        mergedData.push(value);
    });
    return mergedData;
}
function $1b463beed4d472c8$export$eeaad9fa1f02ef4a(customKeys) {
    return {
        shard: (0, $6rW04.default)('ajs-shard') || '',
        userId: (0, $6rW04.default)('ajs-atlassian-account-id') || '',
        projectId: (0, $6rW04.default)('ajs-project-key') || '',
        ...customKeys
    };
}

});




// SCREENS
const $41ea3621645e2acc$export$f636b5b56f1d624a = 'Screen';
const $41ea3621645e2acc$export$9d2de6eebf7462b5 = 'Drawer';
const $41ea3621645e2acc$export$1171103ea9083ffa = 'Modal';
const $41ea3621645e2acc$export$cae2783c9279926 = 'InlineDialog';
const $41ea3621645e2acc$export$d1123261ca8831d2 = 'Dropdown';
const $41ea3621645e2acc$export$238d30785c4bca84 = 'Banner';
const $41ea3621645e2acc$export$a1562d08625f5d7e = 'UI';
const $41ea3621645e2acc$export$947dac6c72b26f81 = 'TRACK';
const $41ea3621645e2acc$export$f1d537d508d2945a = 'SCREEN';
const $41ea3621645e2acc$export$12346a674644c156 = 'OPERATIONAL';

parcelRegister("iVSJI", function(module, exports) {

$parcel$export(module.exports, "ServiceDeskAnalyticsContext", () => $98f32c00711ff158$export$ac31f8f3368d6881);

var $eUqFw = parcelRequire("eUqFw");

var $8WuJm = parcelRequire("8WuJm");

var $SEaoU = parcelRequire("SEaoU");

var $kJ81T = parcelRequire("kJ81T");
const $98f32c00711ff158$export$ac31f8f3368d6881 = ({ useContainerContext: useContainerContext, useServiceDeskAnalyticsContext: useServiceDeskAnalyticsContext, children: children, forceRenderWhileLoading: forceRenderWhileLoading })=>{
    const [{ data: containerContextData, loading: containerContextLoading }] = useContainerContext();
    const { data: analyticsContextAttributes, error: analyticsContextError, loading: analyticsContextLoading } = useServiceDeskAnalyticsContext();
    if ((0, $eUqFw.Children).count(children) > 0) {
        const loading = containerContextLoading || analyticsContextLoading;
        const shouldRenderChildren = !loading || loading && forceRenderWhileLoading || !!analyticsContextError;
        if (!shouldRenderChildren) return null;
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        const context = {};
        // @ts-expect-error - TS2339 - Property 'project' does not exist on type 'ContainerContext'.
        if (containerContextData && containerContextData.project) {
            // @ts-expect-error - TS2339 - Property 'project' does not exist on type 'ContainerContext'.
            const { id: id, type: type } = containerContextData.project;
            // containerType and containerId are obsolete - See https://developer.atlassian.com/platform/analytics-pipeline/getting-started/event-types/#glossary-of-terms
            // Also these dont work with screen events. See sendScreenEvent in: https://bitbucket.org/atlassian/analytics-web-client/src/master/src/analyticsWebClient.js
            // However they are kept here to not break any existing usages.
            context.containerType = 'project';
            context.containerId = `${id}`;
            // This is the preferred way to send container data for analytics
            context.containers = {
                project: {
                    id: `${id}`,
                    type: type
                }
            };
            if (analyticsContextAttributes && !analyticsContextError) context.attributes = analyticsContextAttributes;
        }
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $8WuJm.ContextualAnalyticsData), context, children);
    }
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).Fragment, null, children);
};
$98f32c00711ff158$export$ac31f8f3368d6881.defaultProps = {
    forceRenderWhileLoading: false,
    useServiceDeskAnalyticsContext: (0, $kJ81T.useServiceDeskAnalyticsContext),
    useContainerContext: (0, $SEaoU.useContainerContext)
};

});
parcelRegister("SEaoU", function(module, exports) {

$parcel$export(module.exports, "useContainerContext", () => $753bd1908e635680$export$c7066c2d215990cf);
$parcel$export(module.exports, "ContainerContextSubscriber", () => $753bd1908e635680$export$5b87a78c45d5dd17);
// eslint-disable-next-line jira/restricted/react-component-props

var $eUqFw = parcelRequire("eUqFw");

var $4MmfV = parcelRequire("4MmfV");
var $kXWpU = parcelRequire("kXWpU");

var $h5RgW = parcelRequire("h5RgW");

var $e8UKN = parcelRequire("e8UKN");
const $753bd1908e635680$var$useProjectContext = ()=>{
    const { data: data, loading: loading, error: error, refresh: refresh } = (0, $h5RgW.useResource)((0, $kXWpU.staticProjectSidebarNavigationResource));
    const projectContext = (0, $eUqFw.useMemo)(()=>data && (0, $e8UKN.getProjectContext)(data), [
        data
    ]);
    return [
        {
            data: projectContext,
            error: error,
            loading: loading
        },
        {
            fetch: refresh,
            refetch: refresh
        }
    ];
};
const $753bd1908e635680$var$useUserBoardContext = ()=>{
    const { data: data, loading: loading, error: error, refresh: refresh } = (0, $h5RgW.useResource)((0, $4MmfV.staticJSWUserBoardSidebarNavigationResource));
    const userContext = (0, $eUqFw.useMemo)(()=>data && (0, $e8UKN.getUserContext)(data), [
        data
    ]);
    return [
        {
            data: userContext,
            error: error,
            loading: loading
        },
        {
            fetch: refresh,
            refetch: refresh
        }
    ];
};
const $753bd1908e635680$export$c7066c2d215990cf = ()=>{
    const projectContext = $753bd1908e635680$var$useProjectContext();
    const userBoardContext = $753bd1908e635680$var$useUserBoardContext();
    if (userBoardContext && userBoardContext[0] && userBoardContext[0].data != null) return userBoardContext;
    return projectContext;
};
const $753bd1908e635680$export$5b87a78c45d5dd17 = (props)=>{
    const [data, actions] = $753bd1908e635680$export$c7066c2d215990cf();
    // @ts-expect-error - TS2345 - Argument of type '{ readonly data: ContainerContext | null; readonly error: Error | Record<string, any> | (Error & Record<string, any>) | (Record<string, any> & Error) | null; readonly loading: boolean; }' is not assignable to parameter of type 'ContainerContextData'.
    return props.children(data, actions);
};
$753bd1908e635680$export$5b87a78c45d5dd17.displayName = 'ContainerContextSubscriber';

});
parcelRegister("e8UKN", function(module, exports) {

$parcel$export(module.exports, "getUserContext", () => $4c7bf04e2602d89a$export$114c35c2c23732ab);
$parcel$export(module.exports, "getProjectContext", () => $4c7bf04e2602d89a$export$d17fffd59c7b3c60);

var $7ZZxN = parcelRequire("7ZZxN");

var $eWsAG = parcelRequire("eWsAG");
const $4c7bf04e2602d89a$export$114c35c2c23732ab = (userBoardNavData)=>{
    const { boardInfo: boardInfo, owner: owner } = userBoardNavData;
    return {
        contextType: 'user',
        user: {
            id: owner.id,
            name: owner.name,
            avatarUrl: owner.avatarUrl,
            profileUrl: owner.profileUrl,
            accountId: owner.accountId
        },
        scope: {
            id: boardInfo.id,
            type: boardInfo.type,
            name: boardInfo.name
        }
    };
};
const $4c7bf04e2602d89a$var$getScope = (projectNavInfo)=>{
    if (projectNavInfo.projectType === 'jira_software' && projectNavInfo?.jiraSoftwareNavData?.boardInfo) {
        const { boardInfo: boardInfo } = projectNavInfo.jiraSoftwareNavData;
        return {
            id: boardInfo.id,
            type: boardInfo.type,
            name: boardInfo.name
        };
    }
    return undefined;
};
const $4c7bf04e2602d89a$var$getProjectType = (projectType)=>{
    switch(projectType){
        case 'business':
            return 0, $7ZZxN.CORE_PROJECT;
        case 'software':
            return 0, $7ZZxN.SOFTWARE_PROJECT;
        case 'service_desk':
            return 0, $7ZZxN.SERVICE_DESK_PROJECT;
        case 'product_discovery':
            return 0, $7ZZxN.PRODUCT_DISCOVERY_PROJECT;
        default:
            return null;
    }
};
const $4c7bf04e2602d89a$export$d17fffd59c7b3c60 = (projectNavInfo)=>{
    const project = (0, $eWsAG.extractData)(projectNavInfo);
    const scope = $4c7bf04e2602d89a$var$getScope(projectNavInfo);
    if (project) {
        const projectType = $4c7bf04e2602d89a$var$getProjectType(project.type);
        if (projectType) return {
            contextType: 'project',
            project: {
                key: project.key,
                // @ts-expect-error TS2322: Type 'number' is not assignable to type 'string'
                id: project.id,
                name: project.name,
                type: projectType,
                isSimplified: project.isSimplified,
                avatarUrl: project.avatarUrl,
                style: (0, $eWsAG.getStyle)(project.isSimplified)
            },
            scope: scope
        };
    }
    return null;
};

});



parcelRegister("6HEK3", function(module, exports) {

$parcel$export(module.exports, "saveIssueMutationAnalyticsToCache", () => $b55abc31e99ca421$export$75fba429fd9a065f);

var $1ybV0 = parcelRequire("1ybV0");

var $fE3Ua = parcelRequire("fE3Ua");

var $48mPv = parcelRequire("48mPv");
var $d7Wfe = parcelRequire("d7Wfe");
const $b55abc31e99ca421$var$isEcClientEnabled = ()=>{
    const experiences = (0, $1ybV0.getFeatureFlagValue)('hela.ec.client.integration.jsm', '').split(',');
    return Array.isArray(experiences) && experiences.includes('jsm-issue-view');
};
const $b55abc31e99ca421$export$75fba429fd9a065f = (event, createAnalyticsEvent, /* saveIssueMutationToCache from useEcClient() */ saveIssueMutationToCache)=>{
    if ($b55abc31e99ca421$var$isEcClientEnabled() && event?.type === (0, $fE3Ua.ChangeEventTypes).FIELD_CHANGED) {
        const mutationFailedAnalyticsPayload = {
            errorMsg: 'FAILED_JSM_ISSUEVIEW',
            error: true
        };
        const analyticsEventObj = createAnalyticsEvent({});
        const analyticsDataKey = {
            analyticsEventObj: analyticsEventObj,
            analyticsMetadata: {
                scenario: 'jsm-issue-view',
                type: event.type
            }
        };
        saveIssueMutationToCache(new (0, $48mPv.default)(event?.issueId, (0, $d7Wfe.MutationSource).UPDATE), analyticsDataKey, mutationFailedAnalyticsPayload);
    }
};

});

parcelRegister("6WAxo", function(module, exports) {

$parcel$export(module.exports, "default", () => $97cff08cca774849$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $1rx5k = parcelRequire("1rx5k");
const $97cff08cca774849$export$e809a659e11e6855 = (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $1rx5k.FullPageIssueContainer), null, props.children);
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$97cff08cca774849$export$2e2bcd8739ae039 = ({ ...rest })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($97cff08cca774849$export$e809a659e11e6855, rest);

});
parcelRegister("1rx5k", function(module, exports) {

$parcel$export(module.exports, "FullPageIssueContainer", () => $e6a16efa52554d80$export$f4550b4a355415eb);
/* index.tsx generated by @compiled/babel-plugin v0.29.1 */ // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled, @atlaskit/ui-styling-standard/no-exported-styles -- Ignored via go/DSP-18766

var $eUqFw = parcelRequire("eUqFw");

var $7JEyt = parcelRequire("7JEyt");
const $e6a16efa52554d80$export$f4550b4a355415eb = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ $eUqFw.createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_4t3i1osq",
            __cmplp.className
        ])
    });
});

});


parcelRegister("90ZS3", function(module, exports) {

$parcel$export(module.exports, "useQueryParam", () => $531b22dea21c6f31$export$ae316f0eeb712a36);

var $eUqFw = parcelRequire("eUqFw");

var $ldoFd = parcelRequire("ldoFd");

var $i7Fym = parcelRequire("i7Fym");

var $53ciZ = parcelRequire("53ciZ");

var $lB25E = parcelRequire("lB25E");
const $531b22dea21c6f31$export$ae316f0eeb712a36 = (queryParam)=>{
    const [{ location: { pathname: pathname }, query: query }, { push: push }] = (0, $lB25E.useRouter)();
    const queryParamValue = query[queryParam];
    const setQueryParam = (0, $eUqFw.useCallback)((newValue)=>{
        const parsedSearch = (0, (/*@__PURE__*/$parcel$interopDefault($i7Fym)))({
            ...query,
            [queryParam]: newValue
        }, (value)=>(0, (/*@__PURE__*/$parcel$interopDefault($ldoFd)))(value));
        const strSearch = (0, (/*@__PURE__*/$parcel$interopDefault($53ciZ))).stringify(parsedSearch);
        push(pathname + (strSearch !== '' ? `?${strSearch}` : ''));
    }, [
        pathname,
        push,
        query,
        queryParam
    ]);
    return [
        queryParamValue,
        setQueryParam
    ];
};

});

parcelRegister("geiGJ", function(module, exports) {

var $d1Cng = parcelRequire("d1Cng");
module.exports = Promise.all([
    $d1Cng("kWrFZ"),
    $d1Cng("92sUi"),
    $d1Cng("i5RRW"),
    $d1Cng("dsiAd"),
    $d1Cng("eNmuD"),
    $d1Cng("2hmUs"),
    $d1Cng("bCeK4"),
    $d1Cng("hPzOn"),
    $d1Cng("h2MrD"),
    $d1Cng("bYT2S"),
    $d1Cng("kMAKK")
]).then(()=>parcelRequire('9zAkH'));

});



parcelRegister("fJAmy", function(module, exports) {

$parcel$export(module.exports, "Page", () => $2526d70ca07ebb02$export$6955bcca4cd3539f);
/* index.tsx generated by @compiled/babel-plugin v0.29.1 */ 
var $eUqFw = parcelRequire("eUqFw");

var $7JEyt = parcelRequire("7JEyt");

var $ae4LH = parcelRequire("ae4LH");

var $guiFP = parcelRequire("guiFP");

var $5zSUY = parcelRequire("5zSUY");

var $8WuJm = parcelRequire("8WuJm");
var $d6f6c = parcelRequire("d6f6c");

var $hqj5v = parcelRequire("hqj5v");

var $5yh8X = parcelRequire("5yh8X");

var $8A37l = parcelRequire("8A37l");
var $77u8i = parcelRequire("77u8i");
var $3GAHU = parcelRequire("3GAHU");
var $7F257 = parcelRequire("7F257");
var $9ihe5 = parcelRequire("9ihe5");
var $kyfix = parcelRequire("kyfix");
var $bibmI = parcelRequire("bibmI");

var $54i0g = parcelRequire("54i0g");

var $7Rqgg = parcelRequire("7Rqgg");

var $51Ia6 = parcelRequire("51Ia6");

var $78d1w = parcelRequire("78d1w");

var $bpOk7 = parcelRequire("bpOk7");
var $2a1Mo = parcelRequire("2a1Mo");

var $jNZWQ = parcelRequire("jNZWQ");
const $2526d70ca07ebb02$var$getResources = (locale)=>[
        ...(0, $kyfix.getMomentResources)(locale),
        (0, $9ihe5.getCalendarResources)(locale)
    ];
const $2526d70ca07ebb02$export$6955bcca4cd3539f = (props)=>{
    const { onNavigation: onNavigation, entity: entity, issueKey: issueKey, locale: locale, wrmDataForPage: wrmDataForPage, pathname: pathname } = props;
    const outerElement = (0, $eUqFw.useRef)(null);
    const [{ data: pageContext }] = (0, $51Ia6.usePageContext)();
    const { projectContext: projectContext } = pageContext || {};
    const { projectKey: projectKey } = projectContext || {};
    const metricKey = typeof entity === 'string' ? 'servicedesk.queues.issue' : 'servicedesk.reports.custom.issue';
    const metric = typeof entity === 'string' ? (0, $jNZWQ.JSMIssueViewLoad) : (0, $jNZWQ.JSMReportsIssueViewLoad);
    (0, $eUqFw.useEffect)(()=>{
        (0, $8A37l.addLinkInterceptor)(outerElement.current, onNavigation);
        // @ts-expect-error - TS2345 - Argument of type 'string | undefined' is not assignable to parameter of type 'string'.
        (0, $3GAHU.addNavigationListener)(projectKey, outerElement.current, onNavigation, false);
        (0, $77u8i.addMetaTags)({
            'atlassian-token': (0, $5zSUY.default)()
        }, {
            shouldIncludeAjsPrefix: false
        });
    }, [
        onNavigation,
        projectKey
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $7F257.AttachmentDropzoneContainer), null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $bibmI.LegacyIssueShortcuts), {
        ref: outerElement
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($2526d70ca07ebb02$var$LegacyStyles, {
        ref: outerElement
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $bpOk7.default), {
        wrmData: wrmDataForPage
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $78d1w.default), null, ({ isInitialRender: isInitialRender })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $2a1Mo.WRMModuleLoader), {
            modules: $2526d70ca07ebb02$var$getResources(locale)
        }, ({ loading: loading, error: error })=>{
            if (error) {
                // If the WRM fails to load here something has gone horribly wrong
                // In this case we want to throw to the JS error boundary to catch and log the error
                (0, $guiFP.default)({
                    error: error,
                    meta: {
                        id: 'ServiceDeskLegacyIssuePage',
                        packageName: 'jiraServicedeskLegacyBridges'
                    }
                });
                throw error;
            }
            if (loading) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $ae4LH.default), null);
            return(// @ts-expect-error - TS2769 - No overload matches this call.
            /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $hqj5v.default), {
                metricKey: metricKey,
                withMarks: [
                    (0, $5yh8X.appBundleReadyMark)
                ],
                isExpectedToHaveSsr: false,
                metric: metric
            }, ({ submit: submit })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $8WuJm.ContextualAnalyticsData), {
                    sourceName: "serviceDeskLegacyIssuePage",
                    sourceType: (0, $41ea3621645e2acc$export$f636b5b56f1d624a),
                    attributes: {
                        pageKey: metricKey
                    }
                }, !loading && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $d6f6c.FireScreenAnalytics), null), typeof entity === 'string' ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $54i0g.default), {
                    queueId: entity,
                    issueKey: issueKey,
                    onSubmitApdex: submit,
                    isInitialRender: isInitialRender,
                    pathname: pathname
                }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $7Rqgg.default), {
                    report: entity,
                    issueKey: issueKey,
                    onSubmitApdex: submit,
                    isInitialRender: isInitialRender,
                    pathname: pathname
                }))));
        }))));
};
var $2526d70ca07ebb02$export$2e2bcd8739ae039 = $2526d70ca07ebb02$export$6955bcca4cd3539f;
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $2526d70ca07ebb02$var$LegacyStyles = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_vwz4gktf _colwidpf _vbyaglyw",
            __cmplp.className
        ])
    });
});

});
parcelRegister("hqj5v", function(module, exports) {

$parcel$export(module.exports, "default", () => $dd515edca209afee$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $0S0fK = parcelRequire("0S0fK");

var $7vf5z = parcelRequire("7vf5z");
// eslint-disable-next-line jira/react/no-class-components
class $dd515edca209afee$var$ApdexActions extends (0, $eUqFw.Component) {
    static{
        this.defaultProps = (0, $7vf5z.baseDefaultProps);
    }
    render() {
        const { appName: appName, metricKey: metricKey, extra: extra, children: children, metric: metric } = this.props;
        (0, $7vf5z.checkAndEmitApdexSignal)(appName, metricKey);
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $0S0fK.default).Consumer, null, ({ onReady: onReady })=>children({
                submit: ()=>onReady(metricKey || `jira.fe.spa.initial-render.${String(appName)}`, metricKey || `jira.fe.spa.transition.${String(appName)}`, extra, metric)
            }));
    }
}
var $dd515edca209afee$export$2e2bcd8739ae039 = $dd515edca209afee$var$ApdexActions;

});
parcelRegister("7vf5z", function(module, exports) {

$parcel$export(module.exports, "checkAndEmitApdexSignal", () => $074ba9858fda469d$export$3082c88b693a5230);
$parcel$export(module.exports, "default", () => $074ba9858fda469d$export$2e2bcd8739ae039);
$parcel$export(module.exports, "baseDefaultProps", () => $074ba9858fda469d$export$9b3029ee6188a41f);

var $eUqFw = parcelRequire("eUqFw");

var $1ybV0 = parcelRequire("1ybV0");

var $4nnPJ = parcelRequire("4nnPJ");

var $1QVWH = parcelRequire("1QVWH");

var $eJ3kO = parcelRequire("eJ3kO");

var $51JrV = parcelRequire("51JrV");

var $22iQy = parcelRequire("22iQy");

var $brm1D = parcelRequire("brm1D");

var $ifyPR = parcelRequire("ifyPR");

var $aS0xb = parcelRequire("aS0xb");

var $45wsB = parcelRequire("45wsB");
const $074ba9858fda469d$export$3082c88b693a5230 = (appName, metricKey)=>{
    var emitSignal;
};
class $074ba9858fda469d$export$2e2bcd8739ae039 extends (0, $eUqFw.Component) {
    static{
        this.defaultProps = {
            isExpectedToHaveSsr: false,
            withMarks: [],
            extra: {},
            emitOnAnimationFrame: false
        };
    }
    render() {
        const { appName: appName, metricKey: metricKey, extra: extra, metric: metric, emitOnAnimationFrame: emitOnAnimationFrame, waitForLongTaskIdleTTI: waitForLongTaskIdleTTI } = this.props;
        $074ba9858fda469d$export$3082c88b693a5230(appName, metricKey);
        const isUFODefined = (0, $1ybV0.ff)('uip.ufo') && (0, $4nnPJ.GlobalPageLoadExperience).loadingPageLoadId !== 'UNKNOWN';
        if (isUFODefined) (0, $aS0xb.addUFOSSRDoneAsFMPToInteraction)();
        if (metric) {
            // https://product-fabric.atlassian.net/browse/UFO-323
            (0, $ifyPR.addBM3SSRDoneAsFMPToInteraction)(metric);
            (0, $45wsB.trackBM3FeatureFlagsAccessed)(metric);
        }
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $1QVWH.default), {
            data: extra
        }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $eJ3kO.UFOBM3TimingsToUFO), {
            marks: metric?.getData()?.marks,
            // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
            timings: metric?.getData()?.config?.timings
        }), isUFODefined ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $brm1D.StopUfo), {
            appName: appName,
            customData: extra,
            key: (0, $51JrV.getInteractionId)().current
        }) : metric && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $22iQy.StopBrowserMetrics3), {
            metric: metric,
            customData: extra,
            emitOnAnimationFrame: emitOnAnimationFrame,
            waitForLongTaskIdleTTI: waitForLongTaskIdleTTI
        }));
    }
}
const $074ba9858fda469d$export$9b3029ee6188a41f = $074ba9858fda469d$export$2e2bcd8739ae039.defaultProps;

});
parcelRegister("22iQy", function(module, exports) {

$parcel$export(module.exports, "StopBrowserMetrics3", () => $c48b51f586335ad5$export$575e93c0f9905999);

var $eUqFw = parcelRequire("eUqFw");

var $acbV3 = parcelRequire("acbV3");

var $6iz4v = parcelRequire("6iz4v");

var $6xYPC = parcelRequire("6xYPC");

var $1ybV0 = parcelRequire("1ybV0");

var $cNlZD = parcelRequire("cNlZD");

var $cNlZD = parcelRequire("cNlZD");

var $6M8Uw = parcelRequire("6M8Uw");
var $2B87Z = parcelRequire("2B87Z");

var $87isp = parcelRequire("87isp");

var $5iuyH = parcelRequire("5iuyH");

const $c48b51f586335ad5$var$emitMetrics = (metric, customData, stopTime)=>{
    !(0, $1ybV0.ff)('bm3.emit-on-raf.top-experiences') && (0, $2B87Z.stopInitialPageLoadTimingFromPerformanceMarkStart)('product', (0, $6M8Uw.PRODUCT_START_MARK), true);
    (0, $2B87Z.setInitialPageLoadTimingFromPerformanceMarks)('batch-js-heritage.eval', 'jira.heritage_batch_file_eval:start', 'jira.heritage_batch_file_eval:end');
    if (stopTime !== undefined) {
        if (!(0, $1ybV0.ff)('bm3.wait-for-long-task')) {
            metric.mark((0, $37f655a4e4d5690e$export$99c08ec92759c71c));
            (0, $6iz4v.setMark)((0, $37f655a4e4d5690e$export$99c08ec92759c71c));
            (0, $6iz4v.setMeasure)('BROWSER_METRICS_TTI_RAF', 'BROWSER_METRICS_TTI_START', (0, $37f655a4e4d5690e$export$99c08ec92759c71c));
        }
        metric.stop({
            customData: customData,
            stopTime: stopTime
        });
    } else metric.stop({
        customData: customData
    });
    if ((0, $87isp.isAutomaticExposureCollectionEnabled)()) (0, $6xYPC.stopLowPriorityEventDelay)();
};
class $c48b51f586335ad5$export$575e93c0f9905999 extends (0, $eUqFw.Component) {
    componentDidMount() {
        const { metric: metric, customData: customData, emitOnAnimationFrame: emitOnAnimationFrame } = this.props;
        if (!metric) return;
        const start = (0, $1ybV0.ff)('bm3.wait-for-long-task') ? (0, $acbV3.browserMetrics).getPageLoadMetric().getData()?.start || 0 : 0;
        (0, $6iz4v.setMark)('BROWSER_METRICS_TTI_START', {
            startTime: start
        });
        (0, $6iz4v.setMark)('BROWSER_METRICS_TTI_END');
        (0, $6iz4v.setMeasure)('BROWSER_METRICS_TTI', 'BROWSER_METRICS_TTI_START', 'BROWSER_METRICS_TTI_END');
        const bm3Data = metric.getData();
        if (this.props.waitForLongTaskIdleTTI) {
            const stopTime = performance.now();
            (0, $1ybV0.ff)('bm3.emit-on-raf.top-experiences') && (0, $2B87Z.stopInitialPageLoadTimingFromPerformanceMarkStart)('product', (0, $6M8Uw.PRODUCT_START_MARK), true);
            (0, $cNlZD.getTTIValue)().then((tti)=>{
                (0, $cNlZD.resetTTIObserver)();
                (0, $6iz4v.setMark)('BROWSER_METRICS_LONG_TASK_TTI_END', {
                    startTime: tti
                });
                (0, $6iz4v.setMeasure)('BROWSER_METRICS_LONG_TASK_TTI', 'BROWSER_METRICS_TTI_START', 'BROWSER_METRICS_LONG_TASK_TTI_END');
                $c48b51f586335ad5$var$emitMetrics(metric, customData, stopTime);
            });
            if (bm3Data) this.context?.addApdex({
                key: bm3Data.key,
                startTime: bm3Data.start,
                stopTime: stopTime
            });
        } else if (emitOnAnimationFrame) {
            const stopTime = performance.now();
            (0, $1ybV0.ff)('bm3.emit-on-raf.top-experiences') && (0, $2B87Z.stopInitialPageLoadTimingFromPerformanceMarkStart)('product', (0, $6M8Uw.PRODUCT_START_MARK), true);
            if (bm3Data) this.context?.addApdex({
                key: bm3Data.key,
                startTime: bm3Data.start,
                stopTime: stopTime
            });
            if (typeof queueMicrotask !== 'undefined') queueMicrotask(()=>{
                (0, $6iz4v.setMark)('BROWSER_METRICS_TTI_TASK_END');
                (0, $6iz4v.setMeasure)('BROWSER_METRICS_TTI_TASK', 'BROWSER_METRICS_TTI_START', 'BROWSER_METRICS_TTI_TASK_END');
            });
            requestAnimationFrame(()=>{
                if ((0, $1ybV0.ff)('bm3.wait-for-long-task')) {
                    metric.mark((0, $37f655a4e4d5690e$export$99c08ec92759c71c));
                    (0, $6iz4v.setMark)((0, $37f655a4e4d5690e$export$99c08ec92759c71c));
                    (0, $6iz4v.setMeasure)('BROWSER_METRICS_TTI_RAF', 'BROWSER_METRICS_TTI_START', (0, $37f655a4e4d5690e$export$99c08ec92759c71c));
                }
                if ((0, $1ybV0.ff)('bm3.wait-for-long-task')) setTimeout(()=>{
                    $c48b51f586335ad5$var$emitMetrics(metric, customData, stopTime);
                }, 500);
                else $c48b51f586335ad5$var$emitMetrics(metric, customData, stopTime);
            });
        } else {
            if (bm3Data) this.context?.addApdex({
                key: bm3Data.key,
                startTime: bm3Data.start,
                stopTime: performance.now()
            });
            (0, $1ybV0.ff)('bm3.emit-on-raf.top-experiences') && (0, $2B87Z.stopInitialPageLoadTimingFromPerformanceMarkStart)('product', (0, $6M8Uw.PRODUCT_START_MARK), true);
            $c48b51f586335ad5$var$emitMetrics(metric, customData);
        }
    }
    static{
        this.contextType = (0, $5iuyH.default);
    }
    render() {
        return null;
    }
}

});
parcelRegister("cNlZD", function(module, exports) {

$parcel$export(module.exports, "resetTTIObserver", () => $2134fd1f8b4ec9b6$export$1250c0c41b64ee5c);
$parcel$export(module.exports, "startTTIObserver", () => $2134fd1f8b4ec9b6$export$d2209a9a3184ff99);
$parcel$export(module.exports, "getTTIValue", () => $2134fd1f8b4ec9b6$export$e67176cf000b0a2e);

var $ba8ih = parcelRequire("ba8ih");
// Replace with lodash/noop
// eslint-disable-next-line @typescript-eslint/no-empty-function
let $2134fd1f8b4ec9b6$var$resolveTti = (_v)=>{};
let $2134fd1f8b4ec9b6$var$observerStarted = false;
/**
 * Initialize module state and return the promise a consumer can use to wait
 * for the TTI event.
 */ function $2134fd1f8b4ec9b6$var$initTtiPromise() {
    return new Promise((resolve)=>{
        let hasResolved = false;
        const callback = (ttiResult)=>{
            if (hasResolved) return;
            hasResolved = true;
            resolve(ttiResult);
        };
        $2134fd1f8b4ec9b6$var$resolveTti = callback;
    });
}
let $2134fd1f8b4ec9b6$var$ttiPromise = $2134fd1f8b4ec9b6$var$initTtiPromise();
function $2134fd1f8b4ec9b6$export$1250c0c41b64ee5c() {
    $2134fd1f8b4ec9b6$var$ttiPromise = $2134fd1f8b4ec9b6$var$initTtiPromise();
    $2134fd1f8b4ec9b6$var$observerStarted = false;
}
function $2134fd1f8b4ec9b6$export$d2209a9a3184ff99() {
    $2134fd1f8b4ec9b6$var$observerStarted = true;
    let cleanupObserver = null;
    let lastSeenEventTime = performance.now();
    const callback = ()=>{
        cleanupObserver?.();
        $2134fd1f8b4ec9b6$var$resolveTti(lastSeenEventTime);
    };
    let timeoutId = setTimeout(callback, 5000);
    cleanupObserver = (0, $ba8ih.startLongTaskObserver)(()=>{
        lastSeenEventTime = performance.now();
        clearTimeout(timeoutId);
        timeoutId = setTimeout(callback, 5000);
    });
}
function $2134fd1f8b4ec9b6$export$e67176cf000b0a2e() {
    const promise = $2134fd1f8b4ec9b6$var$ttiPromise ?? $2134fd1f8b4ec9b6$var$initTtiPromise();
    if (!$2134fd1f8b4ec9b6$var$observerStarted) $2134fd1f8b4ec9b6$export$d2209a9a3184ff99();
    return promise;
}

});
parcelRegister("ba8ih", function(module, exports) {

$parcel$export(module.exports, "startLongTaskObserver", () => $c3f66a1c0c2d8c9c$export$af412d3da3bf848a);
/**
 * Starts a long-task observer that will call `cb` on each observation.
 * Returns a disposal function
 */ function $c3f66a1c0c2d8c9c$export$af412d3da3bf848a(cb) {
    const observer = new PerformanceObserver(()=>{
        cb();
    });
    observer.observe({
        type: 'longtask'
    });
    return ()=>{
        observer.disconnect();
    };
}

});



parcelRegister("brm1D", function(module, exports) {

$parcel$export(module.exports, "StopUfo", () => $aa08c3eb931d9705$export$d91154f099475c5);

var $eUqFw = parcelRequire("eUqFw");

var $4nnPJ = parcelRequire("4nnPJ");

var $5iuyH = parcelRequire("5iuyH");
class $aa08c3eb931d9705$export$d91154f099475c5 extends (0, $eUqFw.Component) {
    componentDidMount() {
        const { customData: customData, appName: appName } = this.props;
        (0, $4nnPJ.GlobalPageLoadExperience).success({
            force: true,
            metadata: customData
        });
        const name = appName || (0, $4nnPJ.GlobalPageLoadExperience).loadingPageLoadId;
        if (name) this.context?.addApdex({
            key: name,
            stopTime: performance.now()
        });
    }
    static{
        this.contextType = (0, $5iuyH.default);
    }
    render() {
        return null;
    }
}

});

parcelRegister("ifyPR", function(module, exports) {

$parcel$export(module.exports, "addBM3SSRDoneAsFMPToInteraction", () => $d6714c8d166fb68b$export$bf239ac2bfb04967);

var $51JrV = parcelRequire("51JrV");

var $fYqUr = parcelRequire("fYqUr");
function $d6714c8d166fb68b$export$bf239ac2bfb04967(metric) {
    const interactionId = (0, $51JrV.getInteractionId)();
    const currentInteractionId = interactionId.current;
    if (!currentInteractionId) return;
    const data = metric.getData();
    // Use BM3 SSR mark as FMP config for UFO if it exists, temporarily.
    // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
    const config = data?.config;
    if (config && data?.isInitial) (0, $fYqUr.addMetadata)(currentInteractionId, {
        __legacy__bm3ConfigSSRDoneAsFmp: config.ssr?.doneAsFmp || false
    });
}

});

parcelRegister("aS0xb", function(module, exports) {

$parcel$export(module.exports, "addUFOSSRDoneAsFMPToInteraction", () => $714e33db0dc77e43$export$e63862cd888fe05a);

var $4nnPJ = parcelRequire("4nnPJ");
var $aPkDp = parcelRequire("aPkDp");

var $51JrV = parcelRequire("51JrV");

var $fYqUr = parcelRequire("fYqUr");
async function $714e33db0dc77e43$export$e63862cd888fe05a() {
    const interactionId = (0, $51JrV.getInteractionId)();
    const currentInteractionId = interactionId.current;
    if (!currentInteractionId) return;
    // Use UFO SSR mark as FMP config for rUFO if it exists, temporarily.
    const data = await (0, $4nnPJ.GlobalPageLoadExperience).exportData();
    const fmpMark = data.metrics.marks.find((mark)=>mark.name === 'fmp') || (0, $aPkDp.payloadPublisher).ssr?.getDoneMark();
    if (data.initial && fmpMark) (0, $fYqUr.addMetadata)(currentInteractionId, {
        __legacy__ufoConfigSSRDoneAsFmp: true
    });
}

});

parcelRegister("45wsB", function(module, exports) {

$parcel$export(module.exports, "trackBM3FeatureFlagsAccessed", () => $58cb476ec3ec20ed$export$f00f1e874ce869e9);

var $aWbzA = parcelRequire("aWbzA");

var $51JrV = parcelRequire("51JrV");
// eslint-disable-next-line @typescript-eslint/no-explicit-any
const $58cb476ec3ec20ed$var$startsAsObject = (value)=>{
    try {
        if (value.charAt(0) === '{') return true;
    } catch (e) {
        return false;
    }
    return false;
};
// eslint-disable-next-line @typescript-eslint/no-explicit-any
const $58cb476ec3ec20ed$var$isObject = (value)=>value && typeof value === 'object' && value.constructor === Object;
// eslint-disable-next-line @typescript-eslint/no-explicit-any
const $58cb476ec3ec20ed$var$isString = (input)=>{
    let result;
    try {
        result = typeof input === 'string' || input instanceof String;
    } catch (err) {
        // swallow any errors
        result = false;
    }
    return result;
};
const $58cb476ec3ec20ed$export$7b4abba432e57989 = (value)=>$58cb476ec3ec20ed$var$isString(value) && $58cb476ec3ec20ed$var$startsAsObject(value) || $58cb476ec3ec20ed$var$isObject(value);
const $58cb476ec3ec20ed$export$fcc03ee4c944962f = (featureFlagValue)=>$58cb476ec3ec20ed$export$7b4abba432e57989(featureFlagValue) ? 'non_boolean' : featureFlagValue;
const $58cb476ec3ec20ed$export$d2818866b4acbea4 = new Map();
const $58cb476ec3ec20ed$export$f00f1e874ce869e9 = (metric)=>{
    const interactionId = (0, $51JrV.getInteractionId)();
    const currentInteractionId = interactionId.current;
    if (!currentInteractionId) return;
    const data = metric.getData();
    // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
    const config = data?.config;
    if (config && config?.featureFlags?.length) {
        const allFeatureFlags = (0, $aWbzA.default)();
        config.featureFlags.forEach((featureFlagName)=>{
            const value = allFeatureFlags[featureFlagName];
            if (value === undefined) return;
            const featureFlagValue = $58cb476ec3ec20ed$export$fcc03ee4c944962f(value);
            $58cb476ec3ec20ed$export$d2818866b4acbea4.set(featureFlagName, featureFlagValue);
        });
    }
};

});



parcelRegister("8A37l", function(module, exports) {

$parcel$export(module.exports, "addLinkInterceptor", () => $87efcf9371ebfbdc$export$1ce34b3859880107);
const $87efcf9371ebfbdc$var$spaUrlRegex = '(/jira/servicedesk/projects/.*)';
const $87efcf9371ebfbdc$var$assetsPageRegex = '(/jira/servicedesk/assets/.*)';
const $87efcf9371ebfbdc$var$insightPageRegex = '(/jira/servicedesk/insight/.*)';
const $87efcf9371ebfbdc$export$1ce34b3859880107 = (element, onNavigateClicked)=>{
    if (!element) return;
    element.addEventListener('click', (e)=>{
        // @ts-expect-error - TS2339 - Property 'closest' does not exist on type 'EventTarget'.
        const anchor = e.target && e.target.closest('a');
        if (anchor) {
            const { href: href } = anchor;
            // We only want to target links, so that we can do the navigation ourselves.
            if (href != null) {
                // @ts-expect-error - TS2339 - Property 'getAttribute' does not exist on type 'EventTarget'.
                const isAuiTab = e.target.getAttribute('role') === 'tab';
                // We don't want to target links that open in a new tab
                // @ts-expect-error - TS2339 - Property 'target' does not exist on type 'EventTarget'.
                const opensInNewTab = e.target.target === '_blank';
                // We only want to target links that navigate somewhere else in this SPA
                const isPartOfSpa = href && href.match && href.match($87efcf9371ebfbdc$var$spaUrlRegex) !== null;
                // Insight legacy pages are special because they are rendered outside of a servicedesk project context
                const isInsightPage = href && href.match && (href.match($87efcf9371ebfbdc$var$assetsPageRegex) !== null || href.match($87efcf9371ebfbdc$var$insightPageRegex) !== null);
                // Don't do it for '#' hrefs - these act like buttons
                const hrefWithoutPath = // @ts-expect-error - TS2339 - Property 'getAttribute' does not exist on type 'EventTarget'.
                e.target.getAttribute('href') || anchor.getAttribute('href');
                const actsAsButton = hrefWithoutPath && hrefWithoutPath.startsWith && hrefWithoutPath.startsWith('#');
                if (!isAuiTab && !opensInNewTab && isPartOfSpa && !actsAsButton) {
                    e.preventDefault();
                    onNavigateClicked(href.match($87efcf9371ebfbdc$var$spaUrlRegex)[0]);
                } else if (!isAuiTab && !opensInNewTab && !actsAsButton && isInsightPage) {
                    e.preventDefault();
                    let matchUrl = href.match($87efcf9371ebfbdc$var$insightPageRegex);
                    if (matchUrl == null) matchUrl = href.match($87efcf9371ebfbdc$var$assetsPageRegex);
                    onNavigateClicked(matchUrl[0]);
                }
            }
        }
    });
};

});

parcelRegister("77u8i", function(module, exports) {

$parcel$export(module.exports, "addMetaTags", () => $933ed534dc13f409$export$8db8627a2f899700);
const $933ed534dc13f409$var$getTagKey = (key, shouldIncludeAjsPrefix)=>`${shouldIncludeAjsPrefix ? 'ajs-' : ''}${key}`;
const $933ed534dc13f409$var$deleteMetaTag = (key, shouldIncludeAjsPrefix)=>{
    const existingMetaTag = document.querySelector(`meta[name='${$933ed534dc13f409$var$getTagKey(key, shouldIncludeAjsPrefix)}']`);
    existingMetaTag && existingMetaTag.parentNode && existingMetaTag.parentNode.removeChild(existingMetaTag);
};
const $933ed534dc13f409$var$createMetaTag = (key, content, shouldIncludeAjsPrefix)=>{
    const existingMetaTag = document.querySelector(`meta[name='${$933ed534dc13f409$var$getTagKey(key, shouldIncludeAjsPrefix)}']`);
    if (!existingMetaTag) {
        const meta = document.createElement('meta');
        meta.setAttribute('name', $933ed534dc13f409$var$getTagKey(key, shouldIncludeAjsPrefix));
        meta.setAttribute('content', content);
        return {
            meta: meta,
            previousValue: undefined
        };
    }
    const previousValue = existingMetaTag.getAttribute('content');
    existingMetaTag.setAttribute('content', content);
    return {
        meta: existingMetaTag,
        previousValue: previousValue
    };
};
const $933ed534dc13f409$export$8db8627a2f899700 = (metaDataForPage, { shouldIncludeAjsPrefix: shouldIncludeAjsPrefix } = {
    shouldIncludeAjsPrefix: true
})=>{
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    const previousValues = {};
    Object.keys(metaDataForPage).forEach((key)=>{
        if (!metaDataForPage[key]) $933ed534dc13f409$var$deleteMetaTag(key, shouldIncludeAjsPrefix);
        else {
            const { meta: meta, previousValue: previousValue } = $933ed534dc13f409$var$createMetaTag(key, // @ts-expect-error - TS2345 - Argument of type 'string | null | undefined' is not assignable to parameter of type 'string'.
            metaDataForPage[key], shouldIncludeAjsPrefix);
            if (meta && !previousValue) document.head.appendChild(meta);
            previousValues[key] = previousValue;
        }
    });
    return ()=>{
        $933ed534dc13f409$export$8db8627a2f899700(previousValues);
    };
};

});

parcelRegister("3GAHU", function(module, exports) {

$parcel$export(module.exports, "addNavigationListener", () => $6ec9094474d8655b$export$50694ac99c31244c);

var $eUqFw = parcelRequire("eUqFw");

var $7ZZxN = parcelRequire("7ZZxN");

var $cqJw8 = parcelRequire("cqJw8");

var $lFVIh = parcelRequire("lFVIh");
// This event fires on navigation events in JSD's legacy SPA, BUT
// (unexpected) does not fire when navigating backwards and forward in the browser
// (expected) It does not fire when a page has a dirty form warning that delays navigation
const $6ec9094474d8655b$var$JSD_LEGACY_NAVIGATE_EVENT = 'jsdLegacyNavigate';
const $6ec9094474d8655b$export$50694ac99c31244c = (projectKey, element, onNavigation, isSettings)=>{
    // Detach all event listeners for this event in case we already have one
    (0, $lFVIh.Events).off($6ec9094474d8655b$var$JSD_LEGACY_NAVIGATE_EVENT);
    (0, $lFVIh.Events).on($6ec9094474d8655b$var$JSD_LEGACY_NAVIGATE_EVENT, (fragment)=>{
        if (isSettings) return onNavigation(`${(0, $cqJw8.getNextgenSettingsUrl)((0, $7ZZxN.SERVICE_DESK_PROJECT), projectKey)}/${fragment}`);
        return onNavigation(`/jira/servicedesk/projects/${projectKey}/${fragment}`);
    });
};
const $6ec9094474d8655b$export$1661a729db6303de = (onNavigation)=>{
    (0, $eUqFw.useEffect)(()=>{
        (0, $lFVIh.Events).on($6ec9094474d8655b$var$JSD_LEGACY_NAVIGATE_EVENT, onNavigation);
        return ()=>{
            (0, $lFVIh.Events).off($6ec9094474d8655b$var$JSD_LEGACY_NAVIGATE_EVENT, onNavigation);
        };
    }, [
        onNavigation
    ]);
};

});
parcelRegister("lFVIh", function(module, exports) {
!function(e, t) {
    module.exports = t();
}(module.exports, function() {
    return function(e) {
        function t(r) {
            if (n[r]) return n[r].exports;
            var o = n[r] = {
                i: r,
                l: !1,
                exports: {}
            };
            return e[r].call(o.exports, o, o.exports, t), o.l = !0, o.exports;
        }
        var n = {};
        return t.m = e, t.c = n, t.d = function(e, n, r) {
            t.o(e, n) || Object.defineProperty(e, n, {
                configurable: !1,
                enumerable: !0,
                get: r
            });
        }, t.n = function(e) {
            var n = e && e.__esModule ? function() {
                return e.default;
            } : function() {
                return e;
            };
            return t.d(n, "a", n), n;
        }, t.o = function(e, t) {
            return Object.prototype.hasOwnProperty.call(e, t);
        }, t.p = "", t(t.s = 3);
    }([
        function(e, t) {
            var n;
            n = function() {
                return this;
            }();
            try {
                n = n || Function("return this")() || (0, eval)("this");
            } catch (e) {
                "object" == typeof window && (n = window);
            }
            e.exports = n;
        },
        function(e, t, n) {
            "use strict";
            (function(e) {
                function n() {
                    return e.window._jsdFeRouting = e.window._jsdFeRouting || {}, e.window._jsdFeRouting;
                }
                function r() {
                    var t = n();
                    !t || t.feRouteFn || t.beforeNavigateListener || t.willNavigateListener || delete e.window._jsdFeRouting;
                }
                function o() {
                    return n().feRouteFn;
                }
                function i() {
                    delete n().feRouteFn, r();
                }
                function u(e) {
                    o() && console.error("Warning: [Service Desk Frontend routing] FeRouteFunction already exists. This function should be set only once per app."), n().feRouteFn = e;
                }
                function a() {
                    return n().beforeNavigateListener;
                }
                function s(e) {
                    a() && console.error("[Service Desk Frontend routing] beforeNavigateListener already exists. Listener should be set only once per app. Make sure you don't set it twice, or forget to unset it when your app unmounts"), n().beforeNavigateListener = e;
                }
                function c() {
                    delete n().beforeNavigateListener, r();
                }
                function l(e) {
                    var t = a();
                    return t ? t(e) : Promise.resolve();
                }
                function g() {
                    delete n().willNavigateListener, r();
                }
                function f() {
                    return n().willNavigateListener;
                }
                function d(e) {
                    f() && console.error("[Service Desk Frontend routing] willNavigateListener already exists. Listener should be set only once per app. Make sure you don't set it twice, or forget to unset it when your app unmounts"), n().willNavigateListener = e;
                }
                function y() {
                    var e = f();
                    if (!e) return void console.warn("[Service Desk Frontend routing] willNavigateListener is not defined. You should unmountComponentAtNode within a willNavigateListener. This is probably a memory leak.");
                    e();
                }
                Object.defineProperty(t, "__esModule", {
                    value: !0
                }), t.getFeRouteFunction = o, t.deleteFeRouteFunction = i, t.setFeRouteFunction = u, t.setBeforeNavigateListener = s, t.deleteBeforeNavigateListener = c, t.onBeforeNavigate = l, t.deleteWillNavigateListener = g, t.setWillNavigateListener = d, t.onWillNavigate = y;
            }).call(t, n(0));
        },
        function(e, t, n) {
            "use strict";
            (function(e) {
                function n() {
                    return e.window._jsdFeComponentRegistry = e.window._jsdFeComponentRegistry || {}, e.window._jsdFeComponentRegistry;
                }
                function r(e, t) {
                    n()[e] = t;
                }
                function o(e, t, n) {
                    return new Promise(function(r, o) {
                        a(e, t, n, i, r, o);
                    });
                }
                Object.defineProperty(t, "__esModule", {
                    value: !0
                }), t.registerFeComponent = r, t.renderFeComponentAsync = o;
                var i = 20, u = t.renderFeComponent = function(e, t, r) {
                    var o = n()[e];
                    if (o) return o(t, r);
                    throw new Error("FE component not found: '" + String(e) + "'");
                }, a = function e(t, n, r, o, i, a) {
                    try {
                        var s = u(t, n, r);
                        i(s);
                    } catch (u) {
                        o <= 0 ? a(u) : setTimeout(function() {
                            return e(t, n, r, o - 1, i, a);
                        }, 500);
                    }
                };
            }).call(t, n(0));
        },
        function(e, t, n) {
            "use strict";
            function r(e) {
                if (e && e.__esModule) return e;
                var t = {};
                if (null != e) for(var n in e)Object.prototype.hasOwnProperty.call(e, n) && (t[n] = e[n]);
                return t.default = e, t;
            }
            Object.defineProperty(t, "__esModule", {
                value: !0
            }), t.Events = t.LegacyModuleRegistry = t.LegacyPageRegistry = t.ComponentRegistry = t.PageEnabler = t.RouterManager = void 0;
            var o = n(1), i = r(o), u = n(2), a = r(u), s = n(4), c = r(s), l = n(5), g = r(l), f = n(6), d = r(f), y = n(7), v = function(e) {
                return e && e.__esModule ? e : {
                    default: e
                };
            }(y);
            t.RouterManager = i, t.PageEnabler = v.default, t.ComponentRegistry = a, t.LegacyPageRegistry = c, t.LegacyModuleRegistry = d, t.Events = g;
        },
        function(e, t, n) {
            "use strict";
            (function(e) {
                function n(e, t) {
                    var n = e && e.getPage && e.getPage(t);
                    return n ? n.controllerForJiraFrontend ? n && n.controllerForJiraFrontend() : Promise.reject("Page doesn't have a suitable controller method '" + t + "'") : Promise.reject("Trying to access a page that doesn't exist: '" + t + "'");
                }
                function r() {
                    return e._jsdLegacyAgentPageRegistry;
                }
                function o(t) {
                    e._jsdLegacyAgentPageRegistry = t;
                }
                function i(e) {
                    return n(r(), e);
                }
                function u() {
                    return e._jsdLegacySettingsPageRegistry;
                }
                function a(t) {
                    e._jsdLegacySettingsPageRegistry = t;
                }
                function s(e) {
                    var t = u();
                    return t ? n(t, e) : Promise.reject("Registry does not exist");
                }
                function c() {
                    e._jsdLegacyAgentPageRegistry = {}, e._jsdLegacySettingsPageRegistry = {};
                }
                Object.defineProperty(t, "__esModule", {
                    value: !0
                }), t.getGlobalLegacyAgentPageRegistry = r, t.registerLegacyAgentPageRegistry = o, t.runLegacyAgentPageController = i, t.getGlobalLegacySettingsPageRegistry = u, t.registerLegacySettingsPageRegistry = a, t.runLegacySettingsPageController = s, t.clearLegacyPageRegistries = c;
            }).call(t, n(0));
        },
        function(e, t, n) {
            "use strict";
            (function(e) {
                function n() {
                    return e.__jsdLegacyEventBus = e.__jsdLegacyEventBus || {}, e.__jsdLegacyEventBus;
                }
                function r(e) {
                    return n()[e] || [];
                }
                function o(e, t) {
                    var o = n(), i = r(e);
                    i.push(t), o[e] = i;
                }
                function i(e, t) {
                    if (t) {
                        var o = n(), i = r(e);
                        o[e] = i.filter(function(e) {
                            return e !== t;
                        });
                    } else n()[e] = [];
                }
                function u(e, t) {
                    r(e).forEach(function(e) {
                        return e(t);
                    });
                }
                Object.defineProperty(t, "__esModule", {
                    value: !0
                }), t.on = o, t.off = i, t.trigger = u;
            }).call(t, n(0));
        },
        function(e, t, n) {
            "use strict";
            (function(e) {
                Object.defineProperty(t, "__esModule", {
                    value: !0
                });
                var n = t.getLegacyModuleRegistry = function() {
                    return e._jsdLegacyModuleRegistry = e._jsdLegacyModuleRegistry || {}, e._jsdLegacyModuleRegistry;
                };
                t.registerLegacyModule = function(e, t) {
                    n()[e] = t;
                };
            }).call(t, n(0));
        },
        function(e, t, n) {
            "use strict";
            (function(e) {
                function r(e, t) {
                    if (!(e instanceof t)) throw new TypeError("Cannot call a class as a function");
                }
                function o(t) {
                    var n = new URL(e.window.location.href), r = n.href.slice(n.origin.length), o = new URL(t), i = o.href.slice(o.origin.length), u = n.hostname === o.hostname && r.startsWith(i) ? r.slice(i.length) : r;
                    return "/" === u[0] ? u : "/" + u;
                }
                Object.defineProperty(t, "__esModule", {
                    value: !0
                });
                var i = function() {
                    function e(e, t) {
                        for(var n = 0; n < t.length; n++){
                            var r = t[n];
                            r.enumerable = r.enumerable || !1, r.configurable = !0, "value" in r && (r.writable = !0), Object.defineProperty(e, r.key, r);
                        }
                    }
                    return function(t, n, r) {
                        return n && e(t.prototype, n), r && e(t, r), t;
                    };
                }(), u = n(1), a = n(2), s = function() {
                    function e() {
                        r(this, e);
                    }
                    return i(e, [
                        {
                            key: "enablePage",
                            value: function(e, t) {
                                (0, u.deleteFeRouteFunction)();
                                try {
                                    return (0, a.renderFeComponent)(e.feComponentId, t[0], {});
                                } catch (e) {
                                    return Promise.reject(e);
                                }
                            }
                        },
                        {
                            key: "updatePage",
                            value: function(e, t) {
                                var n = (0, u.getFeRouteFunction)();
                                if (t.feComponentId && n) n(o(e));
                                return Promise.resolve();
                            }
                        },
                        {
                            key: "disablePage",
                            value: function() {
                                (0, u.deleteFeRouteFunction)(), (0, u.deleteBeforeNavigateListener)(), (0, u.onWillNavigate)(), (0, u.deleteWillNavigateListener)();
                            }
                        },
                        {
                            key: "beforeNavigate",
                            value: function(e) {
                                return (0, u.onBeforeNavigate)(e);
                            }
                        }
                    ]), e;
                }();
                t.default = s;
            }).call(t, n(0));
        }
    ]);
});

});


parcelRegister("7F257", function(module, exports) {

$parcel$export(module.exports, "AttachmentDropzoneContainer", () => $4dbfcfbfca18ea70$export$91f929d3b164c89f);
/* index.tsx generated by @compiled/babel-plugin v0.29.1 */ 
var $eUqFw = parcelRequire("eUqFw");

var $7JEyt = parcelRequire("7JEyt");
const $4dbfcfbfca18ea70$export$91f929d3b164c89f = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($4dbfcfbfca18ea70$var$Container, {
        id: "attachment-dropzone-mask-container"
    });
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $4dbfcfbfca18ea70$var$Container = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_1e0cglyw",
            __cmplp.className
        ])
    });
});

});

parcelRegister("9ihe5", function(module, exports) {

$parcel$export(module.exports, "getCalendarResources", () => $c74ed5aa09407ffd$export$7fb1869917da484d);

var $drNtW = parcelRequire("drNtW");
const $c74ed5aa09407ffd$export$7fb1869917da484d = (locale)=>(0, $drNtW.default)(locale);

});
parcelRegister("drNtW", function(module, exports) {

$parcel$export(module.exports, "default", () => $bcc2e3f79d8a74bd$export$2e2bcd8739ae039);
/*
 * There are components in Issue and Service Desk that invoke legacy UI components. Some of these
 * components require Jira Calendar resources, but only two of the three required resources are
 * loaded implicitly. The third resource must be loaded dynamically because it depends on the
 * current user's locale.
 *
 * Here we generate the resource name for that calendar locale dependency, for loading through WRM.
 *
 * For more context in Jira, see:
 * - com.atlassian.jira.web.action.util.CalendarResourceIncluder
 * - jira-components/jira-webapp-resources/src/main/webapp/includes/lib/calendar
 * - system-webresources-plugin.xml
 */ const $bcc2e3f79d8a74bd$var$calendarLocaleMap = {
    cs_CZ: 'calendar-cs',
    da_DK: 'calendar-da',
    de_DE: 'calendar-de',
    en_GB: 'calendar-en',
    en_UK: 'calendar-en',
    en_ZZ: 'calendar-en',
    en_US: 'calendar-en',
    es_ES: 'calendar-es',
    et_EE: 'calendar-en',
    fi_FI: 'calendar-fi',
    fr_FR: 'calendar-fr',
    hu_HU: 'calendar-hu',
    is_IS: 'calendar-en',
    it_IT: 'calendar-it',
    ja_JP: 'calendar-jp',
    ko_KR: 'calendar-ko',
    nb_NO: 'calendar-no',
    nl_NL: 'calendar-nl',
    pl_PL: 'calendar-pl',
    pt_BR: 'calendar-pt',
    pt_PT: 'calendar-pt',
    ro_RO: 'calendar-ro',
    ru_RU: 'calendar-ru',
    sk_SK: 'calendar-sk',
    sv_SE: 'calendar-sv',
    tr_TR: 'calendar-tr',
    zh_CN: 'calendar-zh',
    zh_TW: 'calendar-zh'
};
const $bcc2e3f79d8a74bd$var$getCalendarResource = (locale)=>$bcc2e3f79d8a74bd$var$calendarLocaleMap[locale] || $bcc2e3f79d8a74bd$var$calendarLocaleMap.en_US;
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$bcc2e3f79d8a74bd$export$2e2bcd8739ae039 = (locale)=>`wrc!jira.webresources:${$bcc2e3f79d8a74bd$var$getCalendarResource(locale)}`;

});


parcelRegister("kyfix", function(module, exports) {

$parcel$export(module.exports, "getMomentResources", () => $f57104be77810364$export$4c97d1314fac2e0c);
/**
 * This copies the logic that currently exists in the backend monolith
 * in PageLanguageTools.java into the Jira frontend so that it can be used
 * by pages in the SPA.
 *
 * (https://stash.atlassian.com/projects/JIRACLOUD/repos/jira/browse/jira-components/jira-plugins/jira-servicedesk/sd-components/project-ui/src/main/java/com/atlassian/servicedesk/project/internal/web/action/PageLanguageTools.java)
 */ 
var $3OXzs = parcelRequire("3OXzs");
const $f57104be77810364$var$SUPPORTED_LANGUAGES = [
    'af',
    'ar-ma',
    'ar-sa',
    'ar-tn',
    'ar',
    'az',
    'be',
    'bg',
    'bn',
    'bo',
    'br',
    'bs',
    'ca',
    'cs',
    'cv',
    'cy',
    'da',
    'de-at',
    'de',
    'el',
    'en-au',
    'en-ca',
    'en-gb',
    'eo',
    'es',
    'et',
    'eu',
    'fa',
    'fi',
    'fo',
    'fr-ca',
    'fr',
    'fy',
    'gl',
    'he',
    'hi',
    'hr',
    'hu',
    'hy-am',
    'id',
    'is',
    'it',
    'ja',
    'jv',
    'ka',
    'km',
    'ko',
    'lb',
    'lt',
    'lv',
    'me',
    'mk',
    'ml',
    'mr',
    'ms-my',
    'my',
    'nb',
    'ne',
    'nl',
    'nn',
    'pl',
    'pt-br',
    'pt',
    'ro',
    'ru',
    'si',
    'sk',
    'sl',
    'sq',
    'sr-cyrl',
    'sr',
    'sv',
    'ta',
    'th',
    'tl-ph',
    'tr',
    'tzm-latn',
    'tzm',
    'uk',
    'uz',
    'vi',
    'zh-cn',
    'zh-tw'
];
const $f57104be77810364$var$isSupportedLanguage = (language)=>(0, (/*@__PURE__*/$parcel$interopDefault($3OXzs)))($f57104be77810364$var$SUPPORTED_LANGUAGES, language);
const $f57104be77810364$var$getLanguage = (locale)=>{
    const localeStr = locale.replace('_', '-');
    if ($f57104be77810364$var$isSupportedLanguage(localeStr)) return localeStr;
    return localeStr.split('-')[0];
};
const $f57104be77810364$var$addMomentLanguage = (resources, locale)=>{
    const language = $f57104be77810364$var$getLanguage(locale);
    if (language !== 'en' && $f57104be77810364$var$isSupportedLanguage(language)) return resources.concat([
        `com.atlassian.servicedesk.core-ui:momentjs-sd-${language}`
    ]);
    return resources;
};
const $f57104be77810364$export$4c97d1314fac2e0c = (locale)=>$f57104be77810364$var$addMomentLanguage([
        'com.atlassian.servicedesk.core-ui:lib-moment'
    ], locale);

});

parcelRegister("bibmI", function(module, exports) {

$parcel$export(module.exports, "LegacyIssueShortcuts", () => $e5d7be7830086b17$export$db79c283a92e239b);
/* global JIRA */ 
var $eUqFw = parcelRequire("eUqFw");

var $9aFSa = parcelRequire("9aFSa");
const $e5d7be7830086b17$export$db79c283a92e239b = /*#__PURE__*/ (0, $eUqFw.forwardRef)((_, ref)=>{
    // Provides a callback to click on the element found via
    // the given query selector.
    const clickElementCallback = (querySelector)=>()=>{
            const element = ref && 'current' in ref ? ref.current : null;
            if (element) {
                const elementToClick = element.querySelector(querySelector);
                if (elementToClick) // @ts-expect-error - Property 'click' does not exist on type 'Element'
                elementToClick.click();
            }
        };
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $9aFSa.default), {
        keyMap: {
            e: {
                callback: clickElementCallback('.issueaction-edit-issue')
            },
            a: {
                callback: clickElementCallback('.issueaction-assign-issue')
            },
            i: {
                callback: clickElementCallback('.issueaction-assign-to-me')
            },
            l: {
                callback: clickElementCallback('#edit-labels')
            },
            s: {
                callback: clickElementCallback('.viewissue-share')
            },
            m: {
                callback: ()=>{
                    // :bow: PLEASE DON'T JUDGE :bow:
                    // Shortcuts doesn't pass through the event so we can't
                    // preventDefault(). This prevents 'm' being typed into
                    // the comment box after you activate the shortcut.
                    setTimeout(()=>JIRA.Issue.invokeCommentTrigger(), 0);
                }
            }
        }
    });
});

});
parcelRegister("9aFSa", function(module, exports) {

$parcel$export(module.exports, "default", () => $80173688b586a9b5$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $7Q1yP = parcelRequire("7Q1yP");

var $cIhGE = parcelRequire("cIhGE");

var $haeC1 = parcelRequire("haeC1");

var $fVFUy = parcelRequire("fVFUy");

var $kGQen = parcelRequire("kGQen");

var $h80SI = parcelRequire("h80SI");
let $80173688b586a9b5$var$shortcutsCount = 0;
let $80173688b586a9b5$var$subscription = null;
const $80173688b586a9b5$var$ShortcutsSubscriber = false ? ()=>null : ({ keyMap: keyMap, label: label, location: location })=>{
    const parentRegistry = (0, $eUqFw.useContext)((0, $kGQen.ShortcutRegistryContext)) || (0, $fVFUy.rootRegistry);
    const addKeyMap = (0, $eUqFw.useCallback)(()=>parentRegistry.addKeyMap(()=>({
                keyMap: (0, $h80SI.bindKeyMapWithErrorHandling)(keyMap, location),
                label: label
            })), [
        label,
        parentRegistry,
        keyMap,
        location
    ]);
    (0, $eUqFw.useEffect)(()=>{
        $80173688b586a9b5$var$shortcutsCount += 1;
        const removeKeyMap = addKeyMap();
        return ()=>{
            removeKeyMap();
            $80173688b586a9b5$var$shortcutsCount -= 1;
            if ($80173688b586a9b5$var$subscription && $80173688b586a9b5$var$shortcutsCount === 0) {
                $80173688b586a9b5$var$subscription.unsubscribe();
                $80173688b586a9b5$var$subscription = null;
            }
        };
    }, [
        addKeyMap
    ]);
    (0, $eUqFw.useEffect)(()=>{
        $80173688b586a9b5$var$subscription = $80173688b586a9b5$var$subscription || // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
        (0, $cIhGE.default)().subscribe((0, $haeC1.default));
    }, [
        parentRegistry,
        keyMap
    ]);
    return null;
};
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$80173688b586a9b5$export$2e2bcd8739ae039 = ({ useKeyboardShortcutsToggle: useKeyboardShortcutsToggle = (0, $7Q1yP.useKeyboardShortcutsToggle), ...props })=>{
    const [{ isEnabled: isEnabled }] = useKeyboardShortcutsToggle();
    return isEnabled && !false ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($80173688b586a9b5$var$ShortcutsSubscriber, props) : null;
};

});
parcelRegister("7Q1yP", function(module, exports) {

$parcel$export(module.exports, "useKeyboardShortcutsToggle", () => $e8e091cfd61e9197$export$a33a81f1fc5458ad);

var $guiFP = parcelRequire("guiFP");

var $lRmyA = parcelRequire("lRmyA");

var $6rW04 = parcelRequire("6rW04");

var $jMP2a = parcelRequire("jMP2a");

var $1yZQx = parcelRequire("1yZQx");
var $kEDjj = parcelRequire("kEDjj");
const $e8e091cfd61e9197$var$URL_FRAGMENT = '/rest/internal/latest/user/preferences/keyboardShortcuts?turn=';
const $e8e091cfd61e9197$export$b62f67be35e65859 = (analyticsEvent)=>async ({ setState: setState, getState: getState })=>{
        const currentState = getState().isEnabled;
        const status = currentState ? 'off' : 'on';
        const url = `${$e8e091cfd61e9197$var$URL_FRAGMENT}${status}`;
        try {
            await (0, $lRmyA.performPutRequest)(url);
            setState({
                isEnabled: !currentState,
                error: null
            });
            (0, $jMP2a.fireUIAnalytics)(analyticsEvent, 'keyboardShortcutsToggle', {
                isEnabled: !currentState
            });
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        } catch (err) {
            setState({
                error: err
            });
            (0, $guiFP.default)({
                meta: {
                    id: 'keyboardShortcutToggleFailure',
                    // eslint-disable-next-line jira/js/package-name-enforcer-for-error-analytics
                    packageName: 'jiraCommonLegacyDoNotAddAnythingNew'
                },
                error: err
            });
        }
    };
const $e8e091cfd61e9197$var$Store = (0, $kEDjj.createStore)({
    initialState: {
        isEnabled: false ? false : !((0, $6rW04.default)('ajs-keyboard-shortcuts-enabled') === 'false'),
        error: null
    },
    actions: {
        // @ts-expect-error - TS2322 - Type '( analyticsEvent: UIAnalyticsEventInterface) => ({ setState, getState }: StoreActionApi<State>) => Promise<void>' is not assignable to type 'ActionThunk<{ isEnabled: boolean; error: null; }, { toggle: ( analyticsEvent: UIAnalyticsEventInterface) => ({ setState, getState }: StoreActionApi<State>) => Promise<void>; }>'.
        toggle: $e8e091cfd61e9197$export$b62f67be35e65859
    }
});
const $e8e091cfd61e9197$export$a33a81f1fc5458ad = (0, $1yZQx.createHook)($e8e091cfd61e9197$var$Store);

});

parcelRegister("cIhGE", function(module, exports) {

$parcel$export(module.exports, "default", () => $61e80b5974f2eb64$export$2e2bcd8739ae039);
$parcel$export(module.exports, "flush", () => $61e80b5974f2eb64$export$4909b86c8034bf73);
/**
 * An observable that emits key sequences as a string representation
 *
 * Examples:
 *
 * g i
 * shift+enter
 */ 
var $3JafE = parcelRequire("3JafE");

var $70s4u = parcelRequire("70s4u");
parcelRequire("fRdoC");
parcelRequire("5dKXv");
parcelRequire("8OtG5");
parcelRequire("fWv6o");
parcelRequire("flmol");
parcelRequire("7Rus6");
parcelRequire("azOPD");
parcelRequire("1d9Hc");

var $1YqdI = parcelRequire("1YqdI");
const $61e80b5974f2eb64$var$ignoredKeys = {
    Control: true,
    Meta: true,
    Shift: true,
    Alt: true,
    AltGraph: true,
    CapsLock: true,
    Fn: true,
    FnLock: true,
    Hyper: true,
    NumLock: true,
    OS: true,
    ScrollLock: true,
    Super: true,
    Symbol: true,
    SymbolLock: true
};
/**
 * Skipping few input types to allow keydown event propagation to it's parent element
 * inputMode - react-select or select or combo
 * type - skipping these inputtypes (checkbox, radio) to support shortcuts like
 *        e(EPIC panel) or v(VERSION panel) or n(board card selection) in board and backlog
 * This condition added as a part of https://a11y.atlassian.net/browse/JCA11Y-1317
 */ const $61e80b5974f2eb64$var$isNonTextInput = ({ inputMode: inputMode = '', type: type })=>inputMode === 'none' || type === 'checkbox';
// eslint-disable-next-line @typescript-eslint/no-explicit-any
const $61e80b5974f2eb64$var$isEditable = (node)=>node.nodeName === 'INPUT' && !$61e80b5974f2eb64$var$isNonTextInput(node) || node.nodeName === 'TEXTAREA' || node.isContentEditable === true;
// eslint-disable-next-line @typescript-eslint/no-explicit-any
const $61e80b5974f2eb64$var$isRelevantKeyEvent = (e)=>typeof e.key === 'string' && // @ts-expect-error - TS7053 - Element implicitly has an 'any' type because expression of type 'any' can't be used to index type '{ readonly Control: true; readonly Meta: true; readonly Shift: true; readonly Alt: true; readonly AltGraph: true; readonly CapsLock: true; readonly Fn: true; readonly FnLock: true; readonly Hyper: true; ... 5 more ...; readonly SymbolLock: true; }'.
    (e.key === 'Escape' || !$61e80b5974f2eb64$var$isEditable(e.target) && !$61e80b5974f2eb64$var$ignoredKeys[e.key]);
const $61e80b5974f2eb64$export$25d1b8252b4c49b7 = ()=>{
    const elBlankets = document.querySelectorAll('.aui-blanket');
    if (elBlankets.length === 0) // no aui-blanket in DOM, so it means it's closed
    return true;
    const isAllHidden = Array.from(elBlankets || []).every((el)=>{
        if (el.getAttribute('aria-hidden') === 'true' || // when `el.getAttribute('hidden')` returns an empty string, it means the element has the `hidden` attribute and it's invisible.
        el.getAttribute('hidden') !== null) return true;
        return false;
    });
    return isAllHidden;
};
let $61e80b5974f2eb64$var$key$;
const $61e80b5974f2eb64$var$flush$ = new (0, $70s4u.Subject)();
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$61e80b5974f2eb64$export$2e2bcd8739ae039 = ()=>{
    if (!$61e80b5974f2eb64$var$key$) {
        $61e80b5974f2eb64$var$key$ = false ? new (0, $70s4u.Subject)() : (0, $3JafE.Observable).fromEvent(document, 'keydown').filter($61e80b5974f2eb64$var$isRelevantKeyEvent).filter($61e80b5974f2eb64$export$25d1b8252b4c49b7).map((0, $1YqdI.toKeyWithModifiers));
        const sequence$ = $61e80b5974f2eb64$var$key$.scan((seq, key)=>{
            if (!key || !seq) return undefined;
            return {
                sequence: `${String(seq.sequence)} ${String(key.sequence)}`,
                e: key.e
            };
        });
        $61e80b5974f2eb64$var$key$ = $61e80b5974f2eb64$var$key$.debounceTime(1000).startWith(null).merge($61e80b5974f2eb64$var$flush$).switchMapTo(sequence$);
    }
    return $61e80b5974f2eb64$var$key$;
};
const $61e80b5974f2eb64$export$4909b86c8034bf73 = ()=>{
    $61e80b5974f2eb64$var$flush$.next();
};

});
parcelRegister("1YqdI", function(module, exports) {

$parcel$export(module.exports, "toKeyWithModifiers", () => $1b99fa3356e664b3$export$8cf0d2c3d060a0c2);
$parcel$export(module.exports, "isValidShortcut", () => $1b99fa3356e664b3$export$8e231506c5580162);
$parcel$export(module.exports, "isShortcutCollision", () => $1b99fa3356e664b3$export$4add9e50cb49d130);
/**
 * Converts a KeyboardEvent to a normalised string representation of
 * modifiers and key.
 *
 * Ordering of modifier keys is taken from Apple's guidelines:
 * https://developer.apple.com/macos/human-interface-guidelines/input-and-output/keyboard/
 *
 * Example representation of ArrowUp key with all modifiers present:
 * ctrl+shift+meta+arrowup
 *
 * Character keys never include the 'shift' modifier,.
 * as it changes the character itself.
 * Examples:
 *  - instead of 'shift+a' the normal form is 'A'
 *  - instead of 'shift+/' the normal form is '?'
 *
 * The 'alt' modifier is NOT supported at all due to inconsistent behaviour
 * across platforms. On Mac, it changes the character input, e.g.
 * 'alt+z' is 'Ω' - which becomes the `event.key`. To properly support
 * this, a reverse-mapping of all these characters needs to be added.
 * Alternatively, `String.fromCharCode(event.which)` can be used, but
 * 1. This is a deprecated property
 * 2. The char code is still for the modified character for some keys on Mac
 *    (e.g. The char code for 'alt+/' is '¿')
 */ // Special keys such as 'Escape', 'ArrowUp' or ' '
const $1b99fa3356e664b3$var$isNonCharacterKey = (e)=>e.key.length > 1 || e.key === ' ';
const $1b99fa3356e664b3$var$modifiers = [
    {
        name: 'ctrl',
        // @ts-expect-error - TS7006 - Parameter 'e' implicitly has an 'any' type.
        test: (e)=>e.ctrlKey
    },
    {
        name: 'shift',
        // @ts-expect-error - TS7006 - Parameter 'e' implicitly has an 'any' type.
        test: (e)=>e.shiftKey && $1b99fa3356e664b3$var$isNonCharacterKey(e)
    },
    {
        // Command key on MacOS, Windows key on Windows
        name: 'meta',
        // @ts-expect-error - TS7006 - Parameter 'e' implicitly has an 'any' type.
        test: (e)=>e.metaKey || e.getModifierState && e.getModifierState('OS')
    }
];
const $1b99fa3356e664b3$var$toKey = (e)=>{
    if ($1b99fa3356e664b3$var$isNonCharacterKey(e)) return e.key.toLowerCase();
    // Ignore accidental CapsLock
    return e.shiftKey ? e.key.toUpperCase() : e.key.toLowerCase();
};
const $1b99fa3356e664b3$export$8cf0d2c3d060a0c2 = (e)=>{
    if (!e || !e.key) // There are still browsers out there that do not support e.key;
    // Just today (Oct 2018) I have observed Chrome 47 in Sentry, but it started supporting e.key since 51.
    // So instead of crashing the page with TypeError let's not detect keyboard shortcuts.
    return {
        sequence: '',
        e: e
    };
    return {
        sequence: $1b99fa3356e664b3$var$modifiers.filter((modifier)=>modifier.test(e)).map((modifier)=>modifier.name).concat($1b99fa3356e664b3$var$toKey(e)).join('+'),
        e: e
    };
};
/*
 *  Selected special key values disjunction for regex. All lowercase, ordered alphabethically.
 *  See https://developer.mozilla.org/en-US/docs/Web/API/KeyboardEvent/key/Key_Values.
 */ const $1b99fa3356e664b3$var$orSpecialChars = ' |arrowdown|arrowleft|arrowright|arrowup|backspace|clear|delete|end|enter|escape|home|insert|pagedown|pageup|pause|printscreen|tab';
/*
 * This string when used as a regular expression:
 * 1. Allows lowercase only with a single exception (see 3)
 * 2. Allows optional ctrl, shift, meta followed by "+" in that specific order in the beginning
 * 3. Allows any printable character (may be uppercase letter) or a special key value
 * 4. If shift modifier is used it can only be followed by a special char
 * 5. Is based on toKeyWithModifiers, uses orSpecialChars whitelist for shift chars
 * 6. Does not capture redundant groups
 */ const $1b99fa3356e664b3$var$singleShortcutEntry = `(ctrl\\+)?(shift\\+(?=(?:(?:meta\\+)?(?:${$1b99fa3356e664b3$var$orSpecialChars}))))?(meta\\+)?(${$1b99fa3356e664b3$var$orSpecialChars}|[!-~])`;
/*
 * Any number of singleShortcutEntry separated by a single space
 * We are not specifying "g" flag, so it's fine to reuse the same regex object.
 */ const $1b99fa3356e664b3$var$shortcutRegex = RegExp(`^${$1b99fa3356e664b3$var$singleShortcutEntry}( ${$1b99fa3356e664b3$var$singleShortcutEntry})*$`);
const $1b99fa3356e664b3$export$8e231506c5580162 = (shortcut)=>$1b99fa3356e664b3$var$shortcutRegex.test(shortcut);
const $1b99fa3356e664b3$export$4add9e50cb49d130 = (leftShortcut, rightShortcut)=>{
    if (!leftShortcut || !rightShortcut) return leftShortcut === rightShortcut;
    if (rightShortcut === leftShortcut) return true;
    if (leftShortcut.indexOf(rightShortcut) === 0) return leftShortcut[rightShortcut.length] === ' ';
    if (rightShortcut.indexOf(leftShortcut) === 0) return rightShortcut[leftShortcut.length] === ' ';
    return false;
};

});


parcelRegister("haeC1", function(module, exports) {

$parcel$export(module.exports, "default", () => $44bf9c8ab51bd76c$export$2e2bcd8739ae039);

var $cIhGE = parcelRequire("cIhGE");

var $fVFUy = parcelRequire("fVFUy");
const $44bf9c8ab51bd76c$var$matches = (prefix)=>(definedSequence)=>definedSequence.startsWith(`${prefix} `);
var /**
 * Manages key sequence inputs to execute predefined actions or clear unmatched sequences. This function ensures efficient handling of user inputs by checking against existing sequences and preparing for potential future matches.
 */ // eslint-disable-next-line jira/import/no-anonymous-default-export
$44bf9c8ab51bd76c$export$2e2bcd8739ae039 = (keySequence)=>{
    const { sequence: sequence, e: e } = keySequence || {};
    const activeKeyMap = (0, $fVFUy.rootRegistry).getActiveKeyMap();
    if (sequence !== undefined && activeKeyMap[sequence]) {
        activeKeyMap[sequence].callback(e);
        (0, $cIhGE.flush)();
    } else {
        // Are there any sequences that might be activated with more key presses?
        const isFutureMatchPossible = sequence !== undefined && Object.keys(activeKeyMap).some($44bf9c8ab51bd76c$var$matches(sequence));
        if (!isFutureMatchPossible) (0, $cIhGE.flush)();
    }
};

});
parcelRegister("fVFUy", function(module, exports) {

$parcel$export(module.exports, "ShortcutRegistry", () => $3843ad0413ec519e$export$ca1c75b575abf5ff);
$parcel$export(module.exports, "rootRegistry", () => $3843ad0413ec519e$export$1dd4c61d1ce1fa15);
/* eslint-disable jira/js/no-reduce-accumulator-spread */ /**
 * A tree-like registry of shortcuts, with a default, root registry.
 */ 
var $fUTZC = parcelRequire("fUTZC");

var $6G5mG = parcelRequire("6G5mG");

var $ldoFd = parcelRequire("ldoFd");

var $bFXjh = parcelRequire("bFXjh");

var $1YqdI = parcelRequire("1YqdI");
const $3843ad0413ec519e$var$validateKeyMaps = (keyMaps)=>{
    (0, (/*@__PURE__*/$parcel$interopDefault($fUTZC)))(keyMaps, (keyMap, keyMapIndex)=>{
        const shortcuts = Object.keys(keyMap);
        (0, (/*@__PURE__*/$parcel$interopDefault($fUTZC)))(shortcuts, (shortcut, shortcutIndex)=>{
            if (!(0, $1YqdI.isValidShortcut)(shortcut)) // eslint-disable-next-line no-console
            console.error(`"${shortcut}" is an incorrect shortcut. Please, update it according to a playbook entry on shortcuts.`);
            for(let indexForOtherKeymaps = keyMapIndex + 1; indexForOtherKeymaps < keyMaps.length; indexForOtherKeymaps += 1){
                const anotherKeyMap = keyMaps[indexForOtherKeymaps];
                (0, (/*@__PURE__*/$parcel$interopDefault($fUTZC)))(anotherKeyMap, (anotherAction, anotherShortcut)=>{
                    if ((0, $1YqdI.isShortcutCollision)(anotherShortcut, shortcut)) // If neither shortcut has a priority we have a conflict.. You should ideally
                    // put a priority on one of these conflicting shortcut configs so you definitively
                    // know which one should be active when there is a conflict.
                    {
                        if ((0, (/*@__PURE__*/$parcel$interopDefault($ldoFd)))(keyMap[shortcut].priority) && (0, (/*@__PURE__*/$parcel$interopDefault($ldoFd)))(anotherKeyMap[anotherShortcut].priority) || keyMap[shortcut].priority === anotherKeyMap[anotherShortcut].priority) // DO NOT LET THIS HAPPEN. ADD A PRIORITY!!!
                        // eslint-disable-next-line no-console
                        console.error(`"${shortcut}" has a collision with "${anotherShortcut}" shortcut from another keyMap.`);
                    }
                });
            }
            for(let indexToCompareSelf = shortcutIndex + 1; indexToCompareSelf < shortcuts.length; indexToCompareSelf += 1)if ((0, $1YqdI.isShortcutCollision)(shortcut, shortcuts[indexToCompareSelf])) // eslint-disable-next-line no-console
            console.error(`"${shortcut}" has a collision with "${shortcuts[indexToCompareSelf]}" shortcut from the same keyMap.`);
        });
    });
};
const $3843ad0413ec519e$var$mergeKeyMaps = (keyMapsToMerge)=>// Instead of doing the standard Object.assign({}, ...keyMapsToMerge)
    // we want to have a bit more control over what we can and can't override
    // through the use of the priority
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    keyMapsToMerge.reduce((prev, keyMap)=>({
            ...prev,
            // Add the keys that can be overridden
            // eslint-disable-next-line @typescript-eslint/no-explicit-any
            ...Object.keys(keyMap).reduce((newAccumulator, newKey)=>{
                if (!(0, (/*@__PURE__*/$parcel$interopDefault($6G5mG)))(prev, newKey) || (prev[newKey].priority ?? 0) < (keyMap[newKey].priority ?? 1 // Default behaviour is override
                )) return {
                    ...newAccumulator,
                    [newKey]: keyMap[newKey]
                };
                return newAccumulator;
            }, {})
        }), {});
class $3843ad0413ec519e$export$ca1c75b575abf5ff {
    addChildRegistry(child) {
        this.children.push(child);
        return ()=>{
            (0, (/*@__PURE__*/$parcel$interopDefault($bFXjh)))(this.children, child);
        };
    }
    addKeyMap(getKeyMap) {
        this.keyMapRetrievers.push(getKeyMap);
        return ()=>{
            (0, (/*@__PURE__*/$parcel$interopDefault($bFXjh)))(this.keyMapRetrievers, getKeyMap);
        };
    }
    getActiveKeyMap() {
        const keyMaps = this.children.length ? this.children.map((child)=>child.getActiveKeyMap()) : this.keyMapRetrievers.map((getKeyMap)=>getKeyMap().keyMap);
        return {
            ...$3843ad0413ec519e$var$mergeKeyMaps(keyMaps)
        };
    }
    getKeyMapInfo() {
        const info = this.children.length ? this.children.map((child)=>child.getKeyMapInfo()) : this.keyMapRetrievers.map((getInfo)=>getInfo());
        // @ts-expect-error - TS2769 - No overload matches this call.
        const flattenedInfo = [].concat(...info);
        return flattenedInfo;
    }
    constructor(){
        // go/jfe-eslint
        this.children = [];
        this.keyMapRetrievers = [];
    }
}
const $3843ad0413ec519e$export$1dd4c61d1ce1fa15 = new $3843ad0413ec519e$export$ca1c75b575abf5ff();

});


parcelRegister("kGQen", function(module, exports) {

$parcel$export(module.exports, "ShortcutRegistryContext", () => $082205e2100625d8$export$ebbb59327adb551a);
$parcel$export(module.exports, "default", () => $082205e2100625d8$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $fVFUy = parcelRequire("fVFUy");
const $082205e2100625d8$export$ebbb59327adb551a = /*#__PURE__*/ (0, $eUqFw.createContext)((0, $fVFUy.rootRegistry));
const $082205e2100625d8$var$ShortcutScope = ({ children: children = null })=>{
    const registry = (0, $eUqFw.useMemo)(()=>new (0, $fVFUy.ShortcutRegistry)(), []);
    const parentRegistry = (0, $eUqFw.useContext)($082205e2100625d8$export$ebbb59327adb551a) || (0, $fVFUy.rootRegistry);
    (0, $eUqFw.useEffect)(()=>{
        // "This only happens ONCE.  But it happens AFTER the initial render."
        const removeRegistry = parentRegistry.addChildRegistry(registry);
        return removeRegistry;
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($082205e2100625d8$export$ebbb59327adb551a.Provider, {
        value: registry
    }, children);
};
var $082205e2100625d8$export$2e2bcd8739ae039 = false ? ({ children: children = null })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).Fragment, null, children) : $082205e2100625d8$var$ShortcutScope;

});

parcelRegister("h80SI", function(module, exports) {

$parcel$export(module.exports, "bindKeyMapWithErrorHandling", () => $2297a6a3d8ab933d$export$77477772a9b904da);

var $gUUjF = parcelRequire("gUUjF");
const $2297a6a3d8ab933d$var$wrapCallbackWithErrorHandling = (key, callback, location = 'keyboard-shortcuts.common')=>(e)=>{
        try {
            callback(e);
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        } catch (error) {
            (0, $gUUjF.default).safeErrorWithoutCustomerData(location, `Error firing shortcut '${key}': ${error.message} (commandPaletteBlockNativeShortcutFF=true)`, error);
        }
    };
const $2297a6a3d8ab933d$export$77477772a9b904da = (keyMap, location)=>// eslint-disable-next-line @typescript-eslint/no-explicit-any
    Object.keys(keyMap).reduce((map, key)=>({
            // eslint-disable-next-line jira/js/no-reduce-accumulator-spread
            ...map,
            [key]: {
                ...keyMap[key],
                callback: $2297a6a3d8ab933d$var$wrapCallbackWithErrorHandling(key, keyMap[key].callback, location)
            }
        }), {});

});



parcelRegister("54i0g", function(module, exports) {

$parcel$export(module.exports, "default", () => $d284dd528f4f5938$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $3JafE = parcelRequire("3JafE");
parcelRequire("cpH8E");

var $ae4LH = parcelRequire("ae4LH");

var $gUUjF = parcelRequire("gUUjF");

var $guiFP = parcelRequire("guiFP");

var $cGWC4 = parcelRequire("cGWC4");

var $b3V2m = parcelRequire("b3V2m");

var $cZWuN = parcelRequire("cZWuN");
class $d284dd528f4f5938$export$2e2bcd8739ae039 extends (0, $eUqFw.Component) {
    static{
        this.defaultProps = {
            // Replace with lodash/noop
            // eslint-disable-next-line @typescript-eslint/no-empty-function
            onSubmitApdex: ()=>{}
        };
    }
    componentDidMount() {
        this.requestForBridgedView();
    }
    shouldComponentUpdate({ issueKey: nextKey, queueId: nextQueueId }, { loading: nextLoading }) {
        const { issueKey: issueKey, queueId: queueId } = this.props;
        const { issueView: issueView } = this;
        const { loading: loading } = this.state;
        if (nextQueueId !== queueId && issueView) // no visual changes, just update back link to
        // return to correct queue
        issueView.updateQueueId(nextQueueId);
        return nextKey !== issueKey || nextLoading !== loading;
    }
    componentDidUpdate({ issueKey: prevIssueKey }) {
        const { issueView: issueView } = this;
        const { issueKey: key, queueId: queueId } = this.props;
        const hasIssueKeyChanged = prevIssueKey !== key;
        // guard in case of a force update
        if (hasIssueKeyChanged) {
            if (issueView) issueView.render({
                key: key,
                queueId: queueId
            });
            else {
                this.bridgeSubscription.unsubscribe();
                this.requestForBridgedView();
            }
        }
    }
    componentWillUnmount() {
        const { bridgeSubscription: bridgeSubscription, issueView: issueView } = this;
        if (bridgeSubscription) bridgeSubscription.unsubscribe();
        if (issueView) issueView.dismiss();
    }
    requestForBridgedView() {
        const { onSubmitApdex: onSubmitApdex, pathname: pathname, isInitialRender: isInitialRender } = this.props;
        this.bridgeSubscription = (0, $3JafE.Observable).fromPromise((0, $cZWuN.getLegacyIssueView)()).subscribe((IssueView)=>{
            let generatedPageState;
            if (!onSubmitApdex && pathname) {
                const jsdApdexSanitizedPathname = pathname.replace('/jira/servicedesk', '');
                generatedPageState = (0, $cGWC4.generatePageState)({
                    newRoute: jsdApdexSanitizedPathname,
                    isSettings: false
                });
                (0, $b3V2m.start)(generatedPageState, isInitialRender);
            }
            this.setState({
                loading: false
            });
            const { queueId: queueId, issueKey: key } = this.props;
            const { current: el } = this.wrapperRef;
            if (el) {
                // @ts-expect-error - TS7009 - 'new' expression, whose target lacks a construct signature, implicitly has an 'any' type.
                this.issueView = new IssueView();
                this.issueView.setElement(el).render({
                    key: key,
                    queueId: queueId
                }).then(()=>{
                    if (onSubmitApdex) onSubmitApdex();
                    else generatedPageState && (0, $b3V2m.end)(generatedPageState);
                });
            }
        }, (error)=>{
            const errMessage = `Queues Legacy issue view has failed to load: ${error}`;
            (0, $guiFP.default)({
                meta: {
                    id: 'legacyIssueViewLoad',
                    packageName: 'jiraServicedeskQueuesLegacyIssueView',
                    teamName: 'jsd-shield'
                },
                error: new Error(errMessage)
            });
            (0, $gUUjF.default).safeErrorWithoutCustomerData('servicedesk.queues.legacy-issue-view.view', errMessage);
        });
    }
    render() {
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).Fragment, null, this.state.loading && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $ae4LH.default), null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("div", {
            ref: this.wrapperRef
        }));
    }
    constructor(...args){
        super(...args);
        this.state = {
            loading: true
        };
        this.wrapperRef = /*#__PURE__*/ (0, $eUqFw.createRef)();
    }
}

});
parcelRegister("cGWC4", function(module, exports) {

$parcel$export(module.exports, "generatePageState", () => $9bc7317f0cb0e58c$export$f2c04cc57e85bfe1);
const $9bc7317f0cb0e58c$export$f2c04cc57e85bfe1 = ({ newRoute: newRoute, isSettings: isSettings })=>{
    const processedSubRoute = newRoute.match(`/projects/[^/]+${isSettings ? '/settings' : ''}/(.*)`);
    const subRoute = processedSubRoute && processedSubRoute.length >= 2 ? processedSubRoute[1] : '';
    const splitUrl = subRoute.split('/');
    return {
        module: splitUrl[0],
        item: splitUrl[1],
        secondaryItem: splitUrl[2],
        tertiaryItem: splitUrl[3],
        quaternaryItem: splitUrl[4],
        quinternaryItem: splitUrl[5]
    };
};

});

parcelRegister("b3V2m", function(module, exports) {
!function(t, e) {
    module.exports = e();
}(module.exports, function() {
    return function(t) {
        function e(n) {
            if (r[n]) return r[n].exports;
            var o = r[n] = {
                i: n,
                l: !1,
                exports: {}
            };
            return t[n].call(o.exports, o, o.exports, e), o.l = !0, o.exports;
        }
        var r = {};
        return e.m = t, e.c = r, e.d = function(t, r, n) {
            e.o(t, r) || Object.defineProperty(t, r, {
                configurable: !1,
                enumerable: !0,
                get: n
            });
        }, e.n = function(t) {
            var r = t && t.__esModule ? function() {
                return t.default;
            } : function() {
                return t;
            };
            return e.d(r, "a", r), r;
        }, e.o = function(t, e) {
            return Object.prototype.hasOwnProperty.call(t, e);
        }, e.p = "", e(e.s = 43);
    }([
        function(t, e) {
            var r = Array.isArray;
            t.exports = r;
        },
        function(t, e, r) {
            var n = r(22), o = "object" == typeof self && self && self.Object === Object && self, u = n || o || Function("return this")();
            t.exports = u;
        },
        function(t, e, r) {
            function n(t, e) {
                var r = u(t, e);
                return o(r) ? r : void 0;
            }
            var o = r(75), u = r(78);
            t.exports = n;
        },
        function(t, e, r) {
            function n(t) {
                return null == t ? void 0 === t ? a : c : f && f in Object(t) ? u(t) : i(t);
            }
            var o = r(5), u = r(52), i = r(53), c = "[object Null]", a = "[object Undefined]", f = o ? o.toStringTag : void 0;
            t.exports = n;
        },
        function(t, e) {
            function r(t) {
                return null != t && "object" == typeof t;
            }
            t.exports = r;
        },
        function(t, e, r) {
            var n = r(1), o = n.Symbol;
            t.exports = o;
        },
        function(t, e, r) {
            function n(t) {
                var e = -1, r = null == t ? 0 : t.length;
                for(this.clear(); ++e < r;){
                    var n = t[e];
                    this.set(n[0], n[1]);
                }
            }
            var o = r(65), u = r(66), i = r(67), c = r(68), a = r(69);
            n.prototype.clear = o, n.prototype.delete = u, n.prototype.get = i, n.prototype.has = c, n.prototype.set = a, t.exports = n;
        },
        function(t, e, r) {
            function n(t, e) {
                for(var r = t.length; r--;)if (o(t[r][0], e)) return r;
                return -1;
            }
            var o = r(31);
            t.exports = n;
        },
        function(t, e, r) {
            var n = r(2), o = n(Object, "create");
            t.exports = o;
        },
        function(t, e, r) {
            function n(t, e) {
                var r = t.__data__;
                return o(e) ? r["string" == typeof e ? "string" : "hash"] : r.map;
            }
            var o = r(87);
            t.exports = n;
        },
        function(t, e, r) {
            function n(t) {
                if ("string" == typeof t || o(t)) return t;
                var e = t + "";
                return "0" == e && 1 / t == -u ? "-0" : e;
            }
            var o = r(18), u = 1 / 0;
            t.exports = n;
        },
        function(t, e, r) {
            function n(t) {
                return i(t) ? o(t) : u(t);
            }
            var o = r(49), u = r(58), i = r(13);
            t.exports = n;
        },
        function(t, e) {
            function r(t) {
                return "number" == typeof t && t > -1 && t % 1 == 0 && t <= n;
            }
            var n = 9007199254740991;
            t.exports = r;
        },
        function(t, e, r) {
            function n(t) {
                return null != t && u(t.length) && !o(t);
            }
            var o = r(28), u = r(12);
            t.exports = n;
        },
        function(t, e) {
            function r(t) {
                var e = typeof t;
                return null != t && ("object" == e || "function" == e);
            }
            t.exports = r;
        },
        function(t, e, r) {
            var n = r(2), o = r(1), u = n(o, "Map");
            t.exports = u;
        },
        function(t, e, r) {
            function n(t) {
                var e = -1, r = null == t ? 0 : t.length;
                for(this.clear(); ++e < r;){
                    var n = t[e];
                    this.set(n[0], n[1]);
                }
            }
            var o = r(79), u = r(86), i = r(88), c = r(89), a = r(90);
            n.prototype.clear = o, n.prototype.delete = u, n.prototype.get = i, n.prototype.has = c, n.prototype.set = a, t.exports = n;
        },
        function(t, e, r) {
            function n(t, e) {
                if (o(t)) return !1;
                var r = typeof t;
                return !("number" != r && "symbol" != r && "boolean" != r && null != t && !u(t)) || c.test(t) || !i.test(t) || null != e && t in Object(e);
            }
            var o = r(0), u = r(18), i = /\.|\[(?:[^[\]]*|(["'])(?:(?!\1)[^\\]|\\.)*?\1)\]/, c = /^\w*$/;
            t.exports = n;
        },
        function(t, e, r) {
            function n(t) {
                return "symbol" == typeof t || u(t) && o(t) == i;
            }
            var o = r(3), u = r(4), i = "[object Symbol]";
            t.exports = n;
        },
        function(t, e, r) {
            "use strict";
            function n(t) {
                return t && t.__esModule ? t : {
                    default: t
                };
            }
            function o(t) {
                return !isNaN(parseInt(t, 10));
            }
            function u(t) {
                return new RegExp("[A-Z0-9]+-\\d+").test(t);
            }
            Object.defineProperty(e, "__esModule", {
                value: !0
            });
            var i = r(44), c = n(i), a = r(127), f = n(a), s = r(129), p = n(s), l = r(42);
            e.default = function(t) {
                var e = (0, p.default)([
                    t.module,
                    t.item,
                    t.secondaryItem,
                    t.tertiaryItem,
                    t.quaternaryItem,
                    t.quinternaryItem
                ]), r = (0, f.default)(e, function(t) {
                    return o(t) ? "ENTITY_ID" : u(t) ? "ISSUE_KEY" : t;
                }).join(".");
                return (0, c.default)((0, l.getKeyTransformers)(), function(t, e) {
                    return e(t);
                }, r);
            };
        },
        function(t, e, r) {
            var n = r(46), o = r(62), u = o(n);
            t.exports = u;
        },
        function(t, e, r) {
            var n = r(51), o = r(4), u = Object.prototype, i = u.hasOwnProperty, c = u.propertyIsEnumerable, a = n(function() {
                return arguments;
            }()) ? n : function(t) {
                return o(t) && i.call(t, "callee") && !c.call(t, "callee");
            };
            t.exports = a;
        },
        function(t, e, r) {
            (function(e) {
                var r = "object" == typeof e && e && e.Object === Object && e;
                t.exports = r;
            }).call(e, r(23));
        },
        function(t, e) {
            var r;
            r = function() {
                return this;
            }();
            try {
                r = r || Function("return this")() || (0, eval)("this");
            } catch (t) {
                "object" == typeof window && (r = window);
            }
            t.exports = r;
        },
        function(t, e, r) {
            (function(t) {
                var n = r(1), o = r(54), u = "object" == typeof e && e && !e.nodeType && e, i = u && "object" == typeof t && t && !t.nodeType && t, c = i && i.exports === u, a = c ? n.Buffer : void 0, f = a ? a.isBuffer : void 0, s = f || o;
                t.exports = s;
            }).call(e, r(25)(t));
        },
        function(t, e) {
            t.exports = function(t) {
                return t.webpackPolyfill || (t.deprecate = function() {}, t.paths = [], t.children || (t.children = []), Object.defineProperty(t, "loaded", {
                    enumerable: !0,
                    get: function() {
                        return t.l;
                    }
                }), Object.defineProperty(t, "id", {
                    enumerable: !0,
                    get: function() {
                        return t.i;
                    }
                }), t.webpackPolyfill = 1), t;
            };
        },
        function(t, e) {
            function r(t, e) {
                var r = typeof t;
                return !!(e = null == e ? n : e) && ("number" == r || "symbol" != r && o.test(t)) && t > -1 && t % 1 == 0 && t < e;
            }
            var n = 9007199254740991, o = /^(?:0|[1-9]\d*)$/;
            t.exports = r;
        },
        function(t, e, r) {
            var n = r(55), o = r(56), u = r(57), i = u && u.isTypedArray, c = i ? o(i) : n;
            t.exports = c;
        },
        function(t, e, r) {
            function n(t) {
                if (!u(t)) return !1;
                var e = o(t);
                return e == c || e == a || e == i || e == f;
            }
            var o = r(3), u = r(14), i = "[object AsyncFunction]", c = "[object Function]", a = "[object GeneratorFunction]", f = "[object Proxy]";
            t.exports = n;
        },
        function(t, e, r) {
            function n(t) {
                return "function" == typeof t ? t : null == t ? i : "object" == typeof t ? c(t) ? u(t[0], t[1]) : o(t) : a(t);
            }
            var o = r(63), u = r(114), i = r(41), c = r(0), a = r(123);
            t.exports = n;
        },
        function(t, e, r) {
            function n(t) {
                var e = this.__data__ = new o(t);
                this.size = e.size;
            }
            var o = r(6), u = r(70), i = r(71), c = r(72), a = r(73), f = r(74);
            n.prototype.clear = u, n.prototype.delete = i, n.prototype.get = c, n.prototype.has = a, n.prototype.set = f, t.exports = n;
        },
        function(t, e) {
            function r(t, e) {
                return t === e || t !== t && e !== e;
            }
            t.exports = r;
        },
        function(t, e) {
            function r(t) {
                if (null != t) {
                    try {
                        return o.call(t);
                    } catch (t) {}
                    try {
                        return t + "";
                    } catch (t) {}
                }
                return "";
            }
            var n = Function.prototype, o = n.toString;
            t.exports = r;
        },
        function(t, e, r) {
            function n(t, e, r, i, c) {
                return t === e || (null == t || null == e || !u(t) && !u(e) ? t !== t && e !== e : o(t, e, r, i, n, c));
            }
            var o = r(91), u = r(4);
            t.exports = n;
        },
        function(t, e, r) {
            function n(t, e, r, n, f, s) {
                var p = r & c, l = t.length, v = e.length;
                if (l != v && !(p && v > l)) return !1;
                var d = s.get(t);
                if (d && s.get(e)) return d == e;
                var y = -1, h = !0, b = r & a ? new o : void 0;
                for(s.set(t, e), s.set(e, t); ++y < l;){
                    var x = t[y], _ = e[y];
                    if (n) var j = p ? n(_, x, y, e, t, s) : n(x, _, y, t, e, s);
                    if (void 0 !== j) {
                        if (j) continue;
                        h = !1;
                        break;
                    }
                    if (b) {
                        if (!u(e, function(t, e) {
                            if (!i(b, e) && (x === t || f(x, t, r, n, s))) return b.push(e);
                        })) {
                            h = !1;
                            break;
                        }
                    } else if (x !== _ && !f(x, _, r, n, s)) {
                        h = !1;
                        break;
                    }
                }
                return s.delete(t), s.delete(e), h;
            }
            var o = r(92), u = r(95), i = r(96), c = 1, a = 2;
            t.exports = n;
        },
        function(t, e, r) {
            function n(t) {
                return t === t && !o(t);
            }
            var o = r(14);
            t.exports = n;
        },
        function(t, e) {
            function r(t, e) {
                return function(r) {
                    return null != r && r[t] === e && (void 0 !== e || t in Object(r));
                };
            }
            t.exports = r;
        },
        function(t, e, r) {
            function n(t, e) {
                e = o(e, t);
                for(var r = 0, n = e.length; null != t && r < n;)t = t[u(e[r++])];
                return r && r == n ? t : void 0;
            }
            var o = r(38), u = r(10);
            t.exports = n;
        },
        function(t, e, r) {
            function n(t, e) {
                return o(t) ? t : u(t, e) ? [
                    t
                ] : i(c(t));
            }
            var o = r(0), u = r(17), i = r(116), c = r(119);
            t.exports = n;
        },
        function(t, e) {
            function r(t, e) {
                for(var r = -1, n = null == t ? 0 : t.length, o = Array(n); ++r < n;)o[r] = e(t[r], r, t);
                return o;
            }
            t.exports = r;
        },
        function(t, e, r) {
            function n(t, e, r) {
                e = o(e, t);
                for(var n = -1, s = e.length, p = !1; ++n < s;){
                    var l = f(e[n]);
                    if (!(p = null != t && r(t, l))) break;
                    t = t[l];
                }
                return p || ++n != s ? p : !!(s = null == t ? 0 : t.length) && a(s) && c(l, s) && (i(t) || u(t));
            }
            var o = r(38), u = r(21), i = r(0), c = r(26), a = r(12), f = r(10);
            t.exports = n;
        },
        function(t, e) {
            function r(t) {
                return t;
            }
            t.exports = r;
        },
        function(t, e, r) {
            "use strict";
            (function(t) {
                function n(t) {
                    return t && t.__esModule ? t : {
                        default: t
                    };
                }
                function o(t, e, r) {
                    return e in t ? Object.defineProperty(t, e, {
                        value: r,
                        enumerable: !0,
                        configurable: !0,
                        writable: !0
                    }) : t[e] = r, t;
                }
                function u(e, r) {
                    t.window._jsdApdex ? (0, d.default)(t.window._jsdApdex, e) || (t.window._jsdApdex[e] = r) : t.window._jsdApdex = o({}, e, r);
                }
                function i() {
                    return t.window._jsdApdex || {};
                }
                function c(t) {
                    u("metricsRecorder", t);
                }
                function a() {
                    return i().metricsRecorder ? i().metricsRecorder : (console.error("APDEX metrics recorder not initialized. Not recording APDEX."), {
                        start: l.default,
                        end: l.default
                    });
                }
                function f(t) {
                    u("keyTransformers", t);
                }
                function s() {
                    return i().keyTransformers || [];
                }
                Object.defineProperty(e, "__esModule", {
                    value: !0
                });
                var p = r(41), l = n(p), v = r(130), d = n(v);
                e.installMetricsRecorder = c, e.getMetricsRecorder = a, e.installKeyTransformers = f, e.getKeyTransformers = s;
            }).call(e, r(23));
        },
        function(t, e, r) {
            "use strict";
            function n(t) {
                return t && t.__esModule ? t : {
                    default: t
                };
            }
            function o(t) {
                return "object" === (void 0 === t ? "undefined" : f(t)) ? (0, p.default)(t) : "string" == typeof t ? (0, v.default)(t) : "";
            }
            function u(t, e) {
                (0, y.installMetricsRecorder)(t), (0, y.installKeyTransformers)(e);
            }
            function i(t, e) {
                var r = o(t);
                return (0, d.withStartEventFiltering)(r, function(t) {
                    (0, y.getMetricsRecorder)().start(t, e);
                });
            }
            function c(t) {
                var e = o(t);
                return (0, d.withEndEventFiltering)(e, function(t) {
                    (0, y.getMetricsRecorder)().end(t);
                });
            }
            function a(t) {
                return c(t);
            }
            Object.defineProperty(e, "__esModule", {
                value: !0
            }), e.getExpectedRedirect = e.hasExpectedRedirect = e.hasExpectedRedirectOf = void 0;
            var f = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(t) {
                return typeof t;
            } : function(t) {
                return t && "function" == typeof Symbol && t.constructor === Symbol && t !== Symbol.prototype ? "symbol" : typeof t;
            };
            e.install = u, e.start = i, e.end = c, e.readyForUser = a;
            var s = r(19), p = n(s), l = r(132), v = n(l), d = r(133), y = r(42);
            e.hasExpectedRedirectOf = d.hasExpectedRedirectOf, e.hasExpectedRedirect = d.hasExpectedRedirect, e.getExpectedRedirect = d.getExpectedRedirect;
        },
        function(t, e, r) {
            function n(t, e, r) {
                var n = a(t) ? o : c, f = arguments.length < 3;
                return n(t, i(e, 4), r, f, u);
            }
            var o = r(45), u = r(20), i = r(29), c = r(126), a = r(0);
            t.exports = n;
        },
        function(t, e) {
            function r(t, e, r, n) {
                var o = -1, u = null == t ? 0 : t.length;
                for(n && u && (r = t[++o]); ++o < u;)r = e(r, t[o], o, t);
                return r;
            }
            t.exports = r;
        },
        function(t, e, r) {
            function n(t, e) {
                return t && o(t, e, u);
            }
            var o = r(47), u = r(11);
            t.exports = n;
        },
        function(t, e, r) {
            var n = r(48), o = n();
            t.exports = o;
        },
        function(t, e) {
            function r(t) {
                return function(e, r, n) {
                    for(var o = -1, u = Object(e), i = n(e), c = i.length; c--;){
                        var a = i[t ? c : ++o];
                        if (!1 === r(u[a], a, u)) break;
                    }
                    return e;
                };
            }
            t.exports = r;
        },
        function(t, e, r) {
            function n(t, e) {
                var r = i(t), n = !r && u(t), s = !r && !n && c(t), l = !r && !n && !s && f(t), v = r || n || s || l, d = v ? o(t.length, String) : [], y = d.length;
                for(var h in t)!e && !p.call(t, h) || v && ("length" == h || s && ("offset" == h || "parent" == h) || l && ("buffer" == h || "byteLength" == h || "byteOffset" == h) || a(h, y)) || d.push(h);
                return d;
            }
            var o = r(50), u = r(21), i = r(0), c = r(24), a = r(26), f = r(27), s = Object.prototype, p = s.hasOwnProperty;
            t.exports = n;
        },
        function(t, e) {
            function r(t, e) {
                for(var r = -1, n = Array(t); ++r < t;)n[r] = e(r);
                return n;
            }
            t.exports = r;
        },
        function(t, e, r) {
            function n(t) {
                return u(t) && o(t) == i;
            }
            var o = r(3), u = r(4), i = "[object Arguments]";
            t.exports = n;
        },
        function(t, e, r) {
            function n(t) {
                var e = i.call(t, a), r = t[a];
                try {
                    t[a] = void 0;
                    var n = !0;
                } catch (t) {}
                var o = c.call(t);
                return n && (e ? t[a] = r : delete t[a]), o;
            }
            var o = r(5), u = Object.prototype, i = u.hasOwnProperty, c = u.toString, a = o ? o.toStringTag : void 0;
            t.exports = n;
        },
        function(t, e) {
            function r(t) {
                return o.call(t);
            }
            var n = Object.prototype, o = n.toString;
            t.exports = r;
        },
        function(t, e) {
            function r() {
                return !1;
            }
            t.exports = r;
        },
        function(t, e, r) {
            function n(t) {
                return i(t) && u(t.length) && !!c[o(t)];
            }
            var o = r(3), u = r(12), i = r(4), c = {};
            c["[object Float32Array]"] = c["[object Float64Array]"] = c["[object Int8Array]"] = c["[object Int16Array]"] = c["[object Int32Array]"] = c["[object Uint8Array]"] = c["[object Uint8ClampedArray]"] = c["[object Uint16Array]"] = c["[object Uint32Array]"] = !0, c["[object Arguments]"] = c["[object Array]"] = c["[object ArrayBuffer]"] = c["[object Boolean]"] = c["[object DataView]"] = c["[object Date]"] = c["[object Error]"] = c["[object Function]"] = c["[object Map]"] = c["[object Number]"] = c["[object Object]"] = c["[object RegExp]"] = c["[object Set]"] = c["[object String]"] = c["[object WeakMap]"] = !1, t.exports = n;
        },
        function(t, e) {
            function r(t) {
                return function(e) {
                    return t(e);
                };
            }
            t.exports = r;
        },
        function(t, e, r) {
            (function(t) {
                var n = r(22), o = "object" == typeof e && e && !e.nodeType && e, u = o && "object" == typeof t && t && !t.nodeType && t, i = u && u.exports === o, c = i && n.process, a = function() {
                    try {
                        var t = u && u.require && u.require("util").types;
                        return t || c && c.binding && c.binding("util");
                    } catch (t) {}
                }();
                t.exports = a;
            }).call(e, r(25)(t));
        },
        function(t, e, r) {
            function n(t) {
                if (!o(t)) return u(t);
                var e = [];
                for(var r in Object(t))c.call(t, r) && "constructor" != r && e.push(r);
                return e;
            }
            var o = r(59), u = r(60), i = Object.prototype, c = i.hasOwnProperty;
            t.exports = n;
        },
        function(t, e) {
            function r(t) {
                var e = t && t.constructor;
                return t === ("function" == typeof e && e.prototype || n);
            }
            var n = Object.prototype;
            t.exports = r;
        },
        function(t, e, r) {
            var n = r(61), o = n(Object.keys, Object);
            t.exports = o;
        },
        function(t, e) {
            function r(t, e) {
                return function(r) {
                    return t(e(r));
                };
            }
            t.exports = r;
        },
        function(t, e, r) {
            function n(t, e) {
                return function(r, n) {
                    if (null == r) return r;
                    if (!o(r)) return t(r, n);
                    for(var u = r.length, i = e ? u : -1, c = Object(r); (e ? i-- : ++i < u) && !1 !== n(c[i], i, c););
                    return r;
                };
            }
            var o = r(13);
            t.exports = n;
        },
        function(t, e, r) {
            function n(t) {
                var e = u(t);
                return 1 == e.length && e[0][2] ? i(e[0][0], e[0][1]) : function(r) {
                    return r === t || o(r, t, e);
                };
            }
            var o = r(64), u = r(113), i = r(36);
            t.exports = n;
        },
        function(t, e, r) {
            function n(t, e, r, n) {
                var a = r.length, f = a, s = !n;
                if (null == t) return !f;
                for(t = Object(t); a--;){
                    var p = r[a];
                    if (s && p[2] ? p[1] !== t[p[0]] : !(p[0] in t)) return !1;
                }
                for(; ++a < f;){
                    p = r[a];
                    var l = p[0], v = t[l], d = p[1];
                    if (s && p[2]) {
                        if (void 0 === v && !(l in t)) return !1;
                    } else {
                        var y = new o;
                        if (n) var h = n(v, d, l, t, e, y);
                        if (!(void 0 === h ? u(d, v, i | c, n, y) : h)) return !1;
                    }
                }
                return !0;
            }
            var o = r(30), u = r(33), i = 1, c = 2;
            t.exports = n;
        },
        function(t, e) {
            function r() {
                this.__data__ = [], this.size = 0;
            }
            t.exports = r;
        },
        function(t, e, r) {
            function n(t) {
                var e = this.__data__, r = o(e, t);
                return !(r < 0) && (r == e.length - 1 ? e.pop() : i.call(e, r, 1), --this.size, !0);
            }
            var o = r(7), u = Array.prototype, i = u.splice;
            t.exports = n;
        },
        function(t, e, r) {
            function n(t) {
                var e = this.__data__, r = o(e, t);
                return r < 0 ? void 0 : e[r][1];
            }
            var o = r(7);
            t.exports = n;
        },
        function(t, e, r) {
            function n(t) {
                return o(this.__data__, t) > -1;
            }
            var o = r(7);
            t.exports = n;
        },
        function(t, e, r) {
            function n(t, e) {
                var r = this.__data__, n = o(r, t);
                return n < 0 ? (++this.size, r.push([
                    t,
                    e
                ])) : r[n][1] = e, this;
            }
            var o = r(7);
            t.exports = n;
        },
        function(t, e, r) {
            function n() {
                this.__data__ = new o, this.size = 0;
            }
            var o = r(6);
            t.exports = n;
        },
        function(t, e) {
            function r(t) {
                var e = this.__data__, r = e.delete(t);
                return this.size = e.size, r;
            }
            t.exports = r;
        },
        function(t, e) {
            function r(t) {
                return this.__data__.get(t);
            }
            t.exports = r;
        },
        function(t, e) {
            function r(t) {
                return this.__data__.has(t);
            }
            t.exports = r;
        },
        function(t, e, r) {
            function n(t, e) {
                var r = this.__data__;
                if (r instanceof o) {
                    var n = r.__data__;
                    if (!u || n.length < c - 1) return n.push([
                        t,
                        e
                    ]), this.size = ++r.size, this;
                    r = this.__data__ = new i(n);
                }
                return r.set(t, e), this.size = r.size, this;
            }
            var o = r(6), u = r(15), i = r(16), c = 200;
            t.exports = n;
        },
        function(t, e, r) {
            function n(t) {
                return !(!i(t) || u(t)) && (o(t) ? d : f).test(c(t));
            }
            var o = r(28), u = r(76), i = r(14), c = r(32), a = /[\\^$.*+?()[\]{}|]/g, f = /^\[object .+?Constructor\]$/, s = Function.prototype, p = Object.prototype, l = s.toString, v = p.hasOwnProperty, d = RegExp("^" + l.call(v).replace(a, "\\$&").replace(/hasOwnProperty|(function).*?(?=\\\()| for .+?(?=\\\])/g, "$1.*?") + "$");
            t.exports = n;
        },
        function(t, e, r) {
            function n(t) {
                return !!u && u in t;
            }
            var o = r(77), u = function() {
                var t = /[^.]+$/.exec(o && o.keys && o.keys.IE_PROTO || "");
                return t ? "Symbol(src)_1." + t : "";
            }();
            t.exports = n;
        },
        function(t, e, r) {
            var n = r(1), o = n["__core-js_shared__"];
            t.exports = o;
        },
        function(t, e) {
            function r(t, e) {
                return null == t ? void 0 : t[e];
            }
            t.exports = r;
        },
        function(t, e, r) {
            function n() {
                this.size = 0, this.__data__ = {
                    hash: new o,
                    map: new (i || u),
                    string: new o
                };
            }
            var o = r(80), u = r(6), i = r(15);
            t.exports = n;
        },
        function(t, e, r) {
            function n(t) {
                var e = -1, r = null == t ? 0 : t.length;
                for(this.clear(); ++e < r;){
                    var n = t[e];
                    this.set(n[0], n[1]);
                }
            }
            var o = r(81), u = r(82), i = r(83), c = r(84), a = r(85);
            n.prototype.clear = o, n.prototype.delete = u, n.prototype.get = i, n.prototype.has = c, n.prototype.set = a, t.exports = n;
        },
        function(t, e, r) {
            function n() {
                this.__data__ = o ? o(null) : {}, this.size = 0;
            }
            var o = r(8);
            t.exports = n;
        },
        function(t, e) {
            function r(t) {
                var e = this.has(t) && delete this.__data__[t];
                return this.size -= e ? 1 : 0, e;
            }
            t.exports = r;
        },
        function(t, e, r) {
            function n(t) {
                var e = this.__data__;
                if (o) {
                    var r = e[t];
                    return r === u ? void 0 : r;
                }
                return c.call(e, t) ? e[t] : void 0;
            }
            var o = r(8), u = "__lodash_hash_undefined__", i = Object.prototype, c = i.hasOwnProperty;
            t.exports = n;
        },
        function(t, e, r) {
            function n(t) {
                var e = this.__data__;
                return o ? void 0 !== e[t] : i.call(e, t);
            }
            var o = r(8), u = Object.prototype, i = u.hasOwnProperty;
            t.exports = n;
        },
        function(t, e, r) {
            function n(t, e) {
                var r = this.__data__;
                return this.size += this.has(t) ? 0 : 1, r[t] = o && void 0 === e ? u : e, this;
            }
            var o = r(8), u = "__lodash_hash_undefined__";
            t.exports = n;
        },
        function(t, e, r) {
            function n(t) {
                var e = o(this, t).delete(t);
                return this.size -= e ? 1 : 0, e;
            }
            var o = r(9);
            t.exports = n;
        },
        function(t, e) {
            function r(t) {
                var e = typeof t;
                return "string" == e || "number" == e || "symbol" == e || "boolean" == e ? "__proto__" !== t : null === t;
            }
            t.exports = r;
        },
        function(t, e, r) {
            function n(t) {
                return o(this, t).get(t);
            }
            var o = r(9);
            t.exports = n;
        },
        function(t, e, r) {
            function n(t) {
                return o(this, t).has(t);
            }
            var o = r(9);
            t.exports = n;
        },
        function(t, e, r) {
            function n(t, e) {
                var r = o(this, t), n = r.size;
                return r.set(t, e), this.size += r.size == n ? 0 : 1, this;
            }
            var o = r(9);
            t.exports = n;
        },
        function(t, e, r) {
            function n(t, e, r, n, h, x) {
                var _ = f(t), j = f(e), g = _ ? d : a(t), m = j ? d : a(e);
                g = g == v ? y : g, m = m == v ? y : m;
                var w = g == y, O = m == y, A = g == m;
                if (A && s(t)) {
                    if (!s(e)) return !1;
                    _ = !0, w = !1;
                }
                if (A && !w) return x || (x = new o), _ || p(t) ? u(t, e, r, n, h, x) : i(t, e, g, r, n, h, x);
                if (!(r & l)) {
                    var E = w && b.call(t, "__wrapped__"), P = O && b.call(e, "__wrapped__");
                    if (E || P) {
                        var R = E ? t.value() : t, S = P ? e.value() : e;
                        return x || (x = new o), h(R, S, r, n, x);
                    }
                }
                return !!A && (x || (x = new o), c(t, e, r, n, h, x));
            }
            var o = r(30), u = r(34), i = r(97), c = r(101), a = r(108), f = r(0), s = r(24), p = r(27), l = 1, v = "[object Arguments]", d = "[object Array]", y = "[object Object]", h = Object.prototype, b = h.hasOwnProperty;
            t.exports = n;
        },
        function(t, e, r) {
            function n(t) {
                var e = -1, r = null == t ? 0 : t.length;
                for(this.__data__ = new o; ++e < r;)this.add(t[e]);
            }
            var o = r(16), u = r(93), i = r(94);
            n.prototype.add = n.prototype.push = u, n.prototype.has = i, t.exports = n;
        },
        function(t, e) {
            function r(t) {
                return this.__data__.set(t, n), this;
            }
            var n = "__lodash_hash_undefined__";
            t.exports = r;
        },
        function(t, e) {
            function r(t) {
                return this.__data__.has(t);
            }
            t.exports = r;
        },
        function(t, e) {
            function r(t, e) {
                for(var r = -1, n = null == t ? 0 : t.length; ++r < n;)if (e(t[r], r, t)) return !0;
                return !1;
            }
            t.exports = r;
        },
        function(t, e) {
            function r(t, e) {
                return t.has(e);
            }
            t.exports = r;
        },
        function(t, e, r) {
            function n(t, e, r, n, o, w, A) {
                switch(r){
                    case m:
                        if (t.byteLength != e.byteLength || t.byteOffset != e.byteOffset) return !1;
                        t = t.buffer, e = e.buffer;
                    case g:
                        return !(t.byteLength != e.byteLength || !w(new u(t), new u(e)));
                    case l:
                    case v:
                    case h:
                        return i(+t, +e);
                    case d:
                        return t.name == e.name && t.message == e.message;
                    case b:
                    case _:
                        return t == e + "";
                    case y:
                        var E = a;
                    case x:
                        var P = n & s;
                        if (E || (E = f), t.size != e.size && !P) return !1;
                        var R = A.get(t);
                        if (R) return R == e;
                        n |= p, A.set(t, e);
                        var S = c(E(t), E(e), n, o, w, A);
                        return A.delete(t), S;
                    case j:
                        if (O) return O.call(t) == O.call(e);
                }
                return !1;
            }
            var o = r(5), u = r(98), i = r(31), c = r(34), a = r(99), f = r(100), s = 1, p = 2, l = "[object Boolean]", v = "[object Date]", d = "[object Error]", y = "[object Map]", h = "[object Number]", b = "[object RegExp]", x = "[object Set]", _ = "[object String]", j = "[object Symbol]", g = "[object ArrayBuffer]", m = "[object DataView]", w = o ? o.prototype : void 0, O = w ? w.valueOf : void 0;
            t.exports = n;
        },
        function(t, e, r) {
            var n = r(1), o = n.Uint8Array;
            t.exports = o;
        },
        function(t, e) {
            function r(t) {
                var e = -1, r = Array(t.size);
                return t.forEach(function(t, n) {
                    r[++e] = [
                        n,
                        t
                    ];
                }), r;
            }
            t.exports = r;
        },
        function(t, e) {
            function r(t) {
                var e = -1, r = Array(t.size);
                return t.forEach(function(t) {
                    r[++e] = t;
                }), r;
            }
            t.exports = r;
        },
        function(t, e, r) {
            function n(t, e, r, n, i, a) {
                var f = r & u, s = o(t), p = s.length;
                if (p != o(e).length && !f) return !1;
                for(var l = p; l--;){
                    var v = s[l];
                    if (!(f ? v in e : c.call(e, v))) return !1;
                }
                var d = a.get(t);
                if (d && a.get(e)) return d == e;
                var y = !0;
                a.set(t, e), a.set(e, t);
                for(var h = f; ++l < p;){
                    v = s[l];
                    var b = t[v], x = e[v];
                    if (n) var _ = f ? n(x, b, v, e, t, a) : n(b, x, v, t, e, a);
                    if (!(void 0 === _ ? b === x || i(b, x, r, n, a) : _)) {
                        y = !1;
                        break;
                    }
                    h || (h = "constructor" == v);
                }
                if (y && !h) {
                    var j = t.constructor, g = e.constructor;
                    j != g && "constructor" in t && "constructor" in e && !("function" == typeof j && j instanceof j && "function" == typeof g && g instanceof g) && (y = !1);
                }
                return a.delete(t), a.delete(e), y;
            }
            var o = r(102), u = 1, i = Object.prototype, c = i.hasOwnProperty;
            t.exports = n;
        },
        function(t, e, r) {
            function n(t) {
                return o(t, i, u);
            }
            var o = r(103), u = r(105), i = r(11);
            t.exports = n;
        },
        function(t, e, r) {
            function n(t, e, r) {
                var n = e(t);
                return u(t) ? n : o(n, r(t));
            }
            var o = r(104), u = r(0);
            t.exports = n;
        },
        function(t, e) {
            function r(t, e) {
                for(var r = -1, n = e.length, o = t.length; ++r < n;)t[o + r] = e[r];
                return t;
            }
            t.exports = r;
        },
        function(t, e, r) {
            var n = r(106), o = r(107), u = Object.prototype, i = u.propertyIsEnumerable, c = Object.getOwnPropertySymbols, a = c ? function(t) {
                return null == t ? [] : (t = Object(t), n(c(t), function(e) {
                    return i.call(t, e);
                }));
            } : o;
            t.exports = a;
        },
        function(t, e) {
            function r(t, e) {
                for(var r = -1, n = null == t ? 0 : t.length, o = 0, u = []; ++r < n;){
                    var i = t[r];
                    e(i, r, t) && (u[o++] = i);
                }
                return u;
            }
            t.exports = r;
        },
        function(t, e) {
            function r() {
                return [];
            }
            t.exports = r;
        },
        function(t, e, r) {
            var n = r(109), o = r(15), u = r(110), i = r(111), c = r(112), a = r(3), f = r(32), s = f(n), p = f(o), l = f(u), v = f(i), d = f(c), y = a;
            (n && "[object DataView]" != y(new n(new ArrayBuffer(1))) || o && "[object Map]" != y(new o) || u && "[object Promise]" != y(u.resolve()) || i && "[object Set]" != y(new i) || c && "[object WeakMap]" != y(new c)) && (y = function(t) {
                var e = a(t), r = "[object Object]" == e ? t.constructor : void 0, n = r ? f(r) : "";
                if (n) switch(n){
                    case s:
                        return "[object DataView]";
                    case p:
                        return "[object Map]";
                    case l:
                        return "[object Promise]";
                    case v:
                        return "[object Set]";
                    case d:
                        return "[object WeakMap]";
                }
                return e;
            }), t.exports = y;
        },
        function(t, e, r) {
            var n = r(2), o = r(1), u = n(o, "DataView");
            t.exports = u;
        },
        function(t, e, r) {
            var n = r(2), o = r(1), u = n(o, "Promise");
            t.exports = u;
        },
        function(t, e, r) {
            var n = r(2), o = r(1), u = n(o, "Set");
            t.exports = u;
        },
        function(t, e, r) {
            var n = r(2), o = r(1), u = n(o, "WeakMap");
            t.exports = u;
        },
        function(t, e, r) {
            function n(t) {
                for(var e = u(t), r = e.length; r--;){
                    var n = e[r], i = t[n];
                    e[r] = [
                        n,
                        i,
                        o(i)
                    ];
                }
                return e;
            }
            var o = r(35), u = r(11);
            t.exports = n;
        },
        function(t, e, r) {
            function n(t, e) {
                return c(t) && a(e) ? f(s(t), e) : function(r) {
                    var n = u(r, t);
                    return void 0 === n && n === e ? i(r, t) : o(e, n, p | l);
                };
            }
            var o = r(33), u = r(115), i = r(121), c = r(17), a = r(35), f = r(36), s = r(10), p = 1, l = 2;
            t.exports = n;
        },
        function(t, e, r) {
            function n(t, e, r) {
                var n = null == t ? void 0 : o(t, e);
                return void 0 === n ? r : n;
            }
            var o = r(37);
            t.exports = n;
        },
        function(t, e, r) {
            var n = r(117), o = /[^.[\]]+|\[(?:(-?\d+(?:\.\d+)?)|(["'])((?:(?!\2)[^\\]|\\.)*?)\2)\]|(?=(?:\.|\[\])(?:\.|\[\]|$))/g, u = /\\(\\)?/g, i = n(function(t) {
                var e = [];
                return 46 === t.charCodeAt(0) && e.push(""), t.replace(o, function(t, r, n, o) {
                    e.push(n ? o.replace(u, "$1") : r || t);
                }), e;
            });
            t.exports = i;
        },
        function(t, e, r) {
            function n(t) {
                var e = o(t, function(t) {
                    return r.size === u && r.clear(), t;
                }), r = e.cache;
                return e;
            }
            var o = r(118), u = 500;
            t.exports = n;
        },
        function(t, e, r) {
            function n(t, e) {
                if ("function" != typeof t || null != e && "function" != typeof e) throw new TypeError(u);
                var r = function() {
                    var n = arguments, o = e ? e.apply(this, n) : n[0], u = r.cache;
                    if (u.has(o)) return u.get(o);
                    var i = t.apply(this, n);
                    return r.cache = u.set(o, i) || u, i;
                };
                return r.cache = new (n.Cache || o), r;
            }
            var o = r(16), u = "Expected a function";
            n.Cache = o, t.exports = n;
        },
        function(t, e, r) {
            function n(t) {
                return null == t ? "" : o(t);
            }
            var o = r(120);
            t.exports = n;
        },
        function(t, e, r) {
            function n(t) {
                if ("string" == typeof t) return t;
                if (i(t)) return u(t, n) + "";
                if (c(t)) return s ? s.call(t) : "";
                var e = t + "";
                return "0" == e && 1 / t == -a ? "-0" : e;
            }
            var o = r(5), u = r(39), i = r(0), c = r(18), a = 1 / 0, f = o ? o.prototype : void 0, s = f ? f.toString : void 0;
            t.exports = n;
        },
        function(t, e, r) {
            function n(t, e) {
                return null != t && u(t, e, o);
            }
            var o = r(122), u = r(40);
            t.exports = n;
        },
        function(t, e) {
            function r(t, e) {
                return null != t && e in Object(t);
            }
            t.exports = r;
        },
        function(t, e, r) {
            function n(t) {
                return i(t) ? o(c(t)) : u(t);
            }
            var o = r(124), u = r(125), i = r(17), c = r(10);
            t.exports = n;
        },
        function(t, e) {
            function r(t) {
                return function(e) {
                    return null == e ? void 0 : e[t];
                };
            }
            t.exports = r;
        },
        function(t, e, r) {
            function n(t) {
                return function(e) {
                    return o(e, t);
                };
            }
            var o = r(37);
            t.exports = n;
        },
        function(t, e) {
            function r(t, e, r, n, o) {
                return o(t, function(t, o, u) {
                    r = n ? (n = !1, t) : e(r, t, o, u);
                }), r;
            }
            t.exports = r;
        },
        function(t, e, r) {
            function n(t, e) {
                return (c(t) ? o : i)(t, u(e, 3));
            }
            var o = r(39), u = r(29), i = r(128), c = r(0);
            t.exports = n;
        },
        function(t, e, r) {
            function n(t, e) {
                var r = -1, n = u(t) ? Array(t.length) : [];
                return o(t, function(t, o, u) {
                    n[++r] = e(t, o, u);
                }), n;
            }
            var o = r(20), u = r(13);
            t.exports = n;
        },
        function(t, e) {
            function r(t) {
                for(var e = -1, r = null == t ? 0 : t.length, n = 0, o = []; ++e < r;){
                    var u = t[e];
                    u && (o[n++] = u);
                }
                return o;
            }
            t.exports = r;
        },
        function(t, e, r) {
            function n(t, e) {
                return null != t && u(t, e, o);
            }
            var o = r(131), u = r(40);
            t.exports = n;
        },
        function(t, e) {
            function r(t, e) {
                return null != t && o.call(t, e);
            }
            var n = Object.prototype, o = n.hasOwnProperty;
            t.exports = r;
        },
        function(t, e, r) {
            "use strict";
            function n(t) {
                if (Array.isArray(t)) {
                    for(var e = 0, r = Array(t.length); e < t.length; e++)r[e] = t[e];
                    return r;
                }
                return Array.from(t);
            }
            function o(t) {
                return f.test(t) ? t.replace(f, "") : s.test(t) ? t.replace(s, "") : p.test(t) ? t.replace(p, "") : t.substr(1);
            }
            function u(t, e, r, n, o, u) {
                return {
                    module: t,
                    item: e,
                    secondaryItem: r,
                    tertiaryItem: n,
                    quaternaryItem: o,
                    quinternaryItem: u
                };
            }
            function i(t) {
                var e = o(t);
                return u.apply(void 0, n(e.split("/")));
            }
            Object.defineProperty(e, "__esModule", {
                value: !0
            }), e.stateFromRoute = i;
            var c = r(19), a = function(t) {
                return t && t.__esModule ? t : {
                    default: t
                };
            }(c), f = /^\/servicedesk\/admin\/[A-Z][A-Z0-9]{1,9}\//, s = /^\/projects\/[A-Z][A-Z0-9]{1,9}\//, p = /^\/jira\/servicedesk\/projects\/[A-Z][A-Z0-9]{1,9}\//;
            e.default = function(t) {
                return (0, a.default)(i(t));
            };
        },
        function(t, e, r) {
            "use strict";
            Object.defineProperty(e, "__esModule", {
                value: !0
            });
            var n = RegExp("\\.REDIRECT$"), o = void 0, u = e.getExpectedRedirect = function(t) {
                return t.replace(n, "");
            }, i = e.hasExpectedRedirect = function(t) {
                return n.test(t);
            }, c = (e.hasExpectedRedirectOf = function(t) {
                return t + ".REDIRECT";
            }, function(t) {
                return i(t) ? o = u(t) : (o = void 0, t);
            });
            e.resetSuppressedEvent = function() {
                o = void 0;
            }, e.withStartEventFiltering = function(t, e) {
                if (u(t) === o) return c(t);
                var r = c(t);
                return e(r), r;
            }, e.withEndEventFiltering = function(t, e) {
                return i(t) ? u(t) : (e(t), t);
            };
        }
    ]);
});

});

parcelRegister("cZWuN", function(module, exports) {

$parcel$export(module.exports, "getLegacyIssueView", () => $4c316ee6bc010170$export$31910960cc695581);

var $16kIm = parcelRequire("16kIm");
const $4c316ee6bc010170$export$31910960cc695581 = ()=>(0, $16kIm.asyncWrmRequire)([
        'wrc!jira.view.issue',
        'wrc!sd.project.legacy.issue.view',
        'wrc!sd.project.queues.legacy.issue.view.bridge'
    ]).then(()=>__jsdQueues.LegacyIssueView);

});


parcelRegister("7Rqgg", function(module, exports) {

$parcel$export(module.exports, "default", () => $4ce1e4f6297182b3$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $3JafE = parcelRequire("3JafE");
parcelRequire("cpH8E");

var $ae4LH = parcelRequire("ae4LH");

var $gUUjF = parcelRequire("gUUjF");

var $0cdA8 = parcelRequire("0cdA8");

var $guiFP = parcelRequire("guiFP");

var $cGWC4 = parcelRequire("cGWC4");

var $b3V2m = parcelRequire("b3V2m");

var $f0TrZ = parcelRequire("f0TrZ");
class $4ce1e4f6297182b3$export$2e2bcd8739ae039 extends (0, $eUqFw.Component) {
    static{
        this.defaultProps = {
            // Replace with lodash/noop
            // eslint-disable-next-line @typescript-eslint/no-empty-function
            onSubmitApdex: ()=>{}
        };
    }
    componentDidMount() {
        this.requestForBridgedView();
    }
    shouldComponentUpdate({ issueKey: nextKey }, { loading: nextLoading }) {
        const { issueKey: issueKey } = this.props;
        const { loading: loading } = this.state;
        return nextKey !== issueKey || nextLoading !== loading;
    }
    componentDidUpdate({ issueKey: prevIssueKey }) {
        const { issueView: issueView } = this;
        const { issueKey: key, report: report } = this.props;
        const hasIssueKeyChanged = prevIssueKey !== key;
        // guard in case of a force update
        if (hasIssueKeyChanged) {
            if (issueView) issueView.render({
                key: key,
                report: report
            });
            else {
                this.bridgeSubscription.unsubscribe();
                this.requestForBridgedView();
            }
        }
    }
    componentWillUnmount() {
        const { bridgeSubscription: bridgeSubscription, issueView: issueView } = this;
        if (bridgeSubscription) bridgeSubscription.unsubscribe();
        if (issueView) issueView.dismiss();
    }
    requestForBridgedView() {
        const { onSubmitApdex: onSubmitApdex, pathname: pathname, isInitialRender: isInitialRender } = this.props;
        this.bridgeSubscription = (0, $3JafE.Observable).fromPromise((0, $f0TrZ.getLegacyIssueView)()).subscribe((IssueView)=>{
            let generatedPageState;
            if (!onSubmitApdex && pathname) {
                const jsdApdexSanitizedPathname = pathname.replace('/jira/servicedesk', '');
                generatedPageState = (0, $cGWC4.generatePageState)({
                    newRoute: jsdApdexSanitizedPathname,
                    isSettings: false
                });
                (0, $b3V2m.start)(generatedPageState, isInitialRender);
            }
            this.setState({
                loading: false
            });
            const { report: report, issueKey: key } = this.props;
            const { current: el } = this.wrapperRef;
            if (el) {
                // @ts-expect-error - TS7009 - 'new' expression, whose target lacks a construct signature, implicitly has an 'any' type.
                this.issueView = new IssueView();
                this.issueView.setElement(el).render({
                    key: key,
                    report: report
                }).then(()=>{
                    if (onSubmitApdex) onSubmitApdex();
                    else generatedPageState && (0, $b3V2m.end)(generatedPageState);
                });
            }
        }, (error)=>{
            const errMessage = `Reports Legacy issue view has failed to load: ${error}`;
            (0, $guiFP.default)({
                meta: {
                    id: 'legacyIssueViewLoad',
                    packageName: 'jiraServicedeskReportsLegacyIssueView'
                },
                error: new Error(errMessage)
            });
            (0, $gUUjF.default).safeErrorWithoutCustomerData('servicedesk.reports.legacy-issue-view.view', errMessage);
        });
    }
    render() {
        const ReportsLegacyIssueView = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).Fragment, null, this.state.loading && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $ae4LH.default), null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("div", {
            ref: this.wrapperRef
        }));
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $0cdA8.JSErrorBoundary), {
            id: "reportsLegacyIssueViewApp",
            packageName: "jiraServicedeskReportsLegacyIssueView",
            fallback: "flag"
        }, ReportsLegacyIssueView);
    }
    constructor(...args){
        super(...args);
        this.state = {
            loading: true
        };
        this.wrapperRef = /*#__PURE__*/ (0, $eUqFw.createRef)();
    }
}

});
parcelRegister("f0TrZ", function(module, exports) {

$parcel$export(module.exports, "getLegacyIssueView", () => $36ca7eda7d8a5c6a$export$31910960cc695581);

var $16kIm = parcelRequire("16kIm");
const $36ca7eda7d8a5c6a$export$31910960cc695581 = ()=>(0, $16kIm.asyncWrmRequire)([
        'wrc!jira.view.issue',
        'wrc!sd.project.legacy.issue.view',
        'wrc!sd.project.report.legacy.issue.view.bridge'
    ]).then(()=>__jsdReport.LegacyIssueView);

});


parcelRegister("bpOk7", function(module, exports) {

$parcel$export(module.exports, "default", () => $1668c2c75a2a4f99$export$2e2bcd8739ae039);
/* wrm-data-container.tsx generated by @compiled/babel-plugin v0.29.1 */ 
var $eUqFw = parcelRequire("eUqFw");

var $7JEyt = parcelRequire("7JEyt");
const $1668c2c75a2a4f99$export$eabf00abaa2cb4bf = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "span", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_1e0cagmp _4t3iidpf _tzy4idpf",
            __cmplp.className
        ])
    });
});
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$1668c2c75a2a4f99$export$2e2bcd8739ae039 = ({ wrmData: wrmData })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($1668c2c75a2a4f99$export$eabf00abaa2cb4bf, {
        id: "jsd-spa-page-wrm-data-container"
    }, JSON.stringify(wrmData));

});

parcelRegister("2a1Mo", function(module, exports) {

$parcel$export(module.exports, "WRMModuleLoader", () => $c3f2f0b2bf813513$export$7b7998ab5dc5666b);

var $eUqFw = parcelRequire("eUqFw");

var $gUUjF = parcelRequire("gUUjF");

var $16kIm = parcelRequire("16kIm");
class $c3f2f0b2bf813513$export$7b7998ab5dc5666b extends (0, $eUqFw.Component) {
    static{
        this.defaultProps = {
            // Replace with lodash/noop
            // eslint-disable-next-line @typescript-eslint/no-empty-function
            onLoad: ()=>{}
        };
    }
    componentDidMount() {
        this.getModules();
    }
    componentDidUpdate(prevProps, prevState) {
        if (prevProps.modules !== this.props.modules) this.getModules();
        if (prevState.loading && !this.state.loading) {
            if (!this.state.error) this.props.onLoad();
        }
    }
    getModules() {
        (0, $16kIm.asyncWrmRequire)(this.props.modules).then(()=>{
            this.setState({
                loading: false,
                error: null
            });
        }).catch((error)=>{
            (0, $gUUjF.default).safeErrorWithoutCustomerData('wrm-module-loader.getModules', 'asyncWrmRequire error', error);
            this.setState({
                loading: false,
                error: error
            });
        });
    }
    render() {
        const { loading: loading, error: error } = this.state;
        return this.props.children({
            loading: loading,
            error: error
        });
    }
    constructor(...args){
        super(...args);
        this.state = {
            loading: true,
            error: null
        };
    }
}

});

parcelRegister("jNZWQ", function(module, exports) {

$parcel$export(module.exports, "JSMIssueViewLoad", () => $7175273f07dae875$export$1e32b6c8e1e31a3d);
$parcel$export(module.exports, "JSMReportsIssueViewLoad", () => $7175273f07dae875$export$30ebd3f479793fc1);

var $lNfG4 = parcelRequire("lNfG4");
const $7175273f07dae875$export$1e32b6c8e1e31a3d = (0, $lNfG4.metrics).pageLoad({
    key: 'service-management.queues.issue'
});
const $7175273f07dae875$export$30ebd3f479793fc1 = (0, $lNfG4.metrics).pageLoad({
    key: 'service-management.reports.issue'
});

});


parcelRegister("4YkVK", function(module, exports) {

$parcel$export(module.exports, "useKbConfluenceContext", () => $cb72f3010d1f4c73$export$a8450b4f39918e6d);

var $eUqFw = parcelRequire("eUqFw");

var $h5RgW = parcelRequire("h5RgW");

var $bbvOQ = parcelRequire("bbvOQ");
const $cb72f3010d1f4c73$var$getKbConfluenceContextResource = ()=>(0, $bbvOQ.kbConfluenceContextResource);
const $cb72f3010d1f4c73$export$a8450b4f39918e6d = (projectKey)=>{
    const { data: data, loading: loading, error: error, refresh: refreshCache } = (0, $h5RgW.useResource)($cb72f3010d1f4c73$var$getKbConfluenceContextResource());
    (0, $eUqFw.useEffect)(()=>{
        if (!false) refreshCache();
    }, [
        projectKey,
        refreshCache
    ]);
    return [
        {
            data: data,
            loading: loading,
            error: error
        }
    ];
};
var $cb72f3010d1f4c73$export$2e2bcd8739ae039 = $cb72f3010d1f4c73$export$a8450b4f39918e6d;

});

parcelRegister("cVYSD", function(module, exports) {

$parcel$export(module.exports, "useShouldShowLegacyIssueView", () => $495e21ac5e72f6a7$export$ebe5701b3a084631);

var $53ciZ = parcelRequire("53ciZ");

var $gUUjF = parcelRequire("gUUjF");

var $7JKBZ = parcelRequire("7JKBZ");
const $495e21ac5e72f6a7$var$OLD_ISSUE_VIEW_QUERY_PARAM = 'oldIssueView';
const $495e21ac5e72f6a7$var$hasOldIssueViewQueryParam = (search)=>{
    if (false) {
        const query = (0, (/*@__PURE__*/$parcel$interopDefault($53ciZ))).parse(search);
        return Object.keys(query).includes($495e21ac5e72f6a7$var$OLD_ISSUE_VIEW_QUERY_PARAM);
    }
    const query = new URLSearchParams(search);
    return query.get('oldIssueView') === 'true';
};
const $495e21ac5e72f6a7$var$useNewIssueViewLockedIn = ()=>{
    const { error: error, newIssueViewLockedIn: newIssueViewLockedIn } = (0, $7JKBZ.useNewIssueViewLockInStatus)();
    if (newIssueViewLockedIn !== null) return newIssueViewLockedIn;
    if (error) (0, $gUUjF.default).safeErrorWithoutCustomerData('spa-commons.utils.should-show-legacy-issue-view-provider', 'Error getting new issue view lock in status, default to false');
    return false;
};
const $495e21ac5e72f6a7$export$ebe5701b3a084631 = (isProjectSimplified, canSeeNewIssueView, search)=>{
    const isNewIssueViewLockedIn = $495e21ac5e72f6a7$var$useNewIssueViewLockedIn();
    if (isNewIssueViewLockedIn) return {
        showLegacyIssueView: false
    };
    if (canSeeNewIssueView) return {
        showLegacyIssueView: $495e21ac5e72f6a7$var$hasOldIssueViewQueryParam(search)
    };
    return {
        showLegacyIssueView: true
    };
};

});




//# sourceMappingURL=async-servicedesk-queues-issue-view.99db56a8.js.map
